(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":17}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":18}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };
},{"core-js/library/fn/object/define-properties":19}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":20}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-descriptor":21}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-names"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-names":22}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-own-property-symbols"), __esModule: true };
},{"core-js/library/fn/object/get-own-property-symbols":23}],8:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":24}],9:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/is-extensible"), __esModule: true };
},{"core-js/library/fn/object/is-extensible":25}],10:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":26}],11:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/prevent-extensions"), __esModule: true };
},{"core-js/library/fn/object/prevent-extensions":27}],12:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":28}],13:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":29}],14:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":30}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
},{"../core-js/object/define-property":4}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":13,"../core-js/symbol/iterator":14}],17:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":38}],18:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":38,"../../modules/es6.object.create":105}],19:[function(require,module,exports){
require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};

},{"../../modules/_core":38,"../../modules/es6.object.define-properties":106}],20:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":38,"../../modules/es6.object.define-property":107}],21:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};

},{"../../modules/_core":38,"../../modules/es6.object.get-own-property-descriptor":108}],22:[function(require,module,exports){
require('../../modules/es6.object.get-own-property-names');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};

},{"../../modules/_core":38,"../../modules/es6.object.get-own-property-names":109}],23:[function(require,module,exports){
require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Object.getOwnPropertySymbols;

},{"../../modules/_core":38,"../../modules/es6.symbol":117}],24:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;

},{"../../modules/_core":38,"../../modules/es6.object.get-prototype-of":110}],25:[function(require,module,exports){
require('../../modules/es6.object.is-extensible');
module.exports = require('../../modules/_core').Object.isExtensible;

},{"../../modules/_core":38,"../../modules/es6.object.is-extensible":111}],26:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":38,"../../modules/es6.object.keys":112}],27:[function(require,module,exports){
require('../../modules/es6.object.prevent-extensions');
module.exports = require('../../modules/_core').Object.preventExtensions;

},{"../../modules/_core":38,"../../modules/es6.object.prevent-extensions":113}],28:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":38,"../modules/es6.object.to-string":114,"../modules/es6.promise":115,"../modules/es6.string.iterator":116,"../modules/es7.promise.finally":118,"../modules/es7.promise.try":119,"../modules/web.dom.iterable":122}],29:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":38,"../../modules/es6.object.to-string":114,"../../modules/es6.symbol":117,"../../modules/es7.symbol.async-iterator":120,"../../modules/es7.symbol.observable":121}],30:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":101,"../../modules/es6.string.iterator":116,"../../modules/web.dom.iterable":122}],31:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],32:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],33:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],34:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":57}],35:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":92,"./_to-iobject":94,"./_to-length":95}],36:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":37,"./_wks":102}],37:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],38:[function(require,module,exports){
var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],39:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":31}],40:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],41:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":46}],42:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":48,"./_is-object":57}],43:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],44:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":74,"./_object-keys":77,"./_object-pie":78}],45:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":38,"./_ctx":39,"./_global":48,"./_has":49,"./_hide":50}],46:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],47:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":34,"./_ctx":39,"./_is-array-iter":55,"./_iter-call":58,"./_to-length":95,"./core.get-iterator-method":103}],48:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],49:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],50:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":41,"./_object-dp":69,"./_property-desc":82}],51:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":48}],52:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":41,"./_dom-create":42,"./_fails":46}],53:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],54:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":37}],55:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":63,"./_wks":102}],56:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":37}],57:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],58:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":34}],59:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":50,"./_object-create":68,"./_property-desc":82,"./_set-to-string-tag":86,"./_wks":102}],60:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":45,"./_hide":50,"./_iter-create":59,"./_iterators":63,"./_library":64,"./_object-gpo":75,"./_redefine":84,"./_set-to-string-tag":86,"./_wks":102}],61:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":102}],62:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],63:[function(require,module,exports){
module.exports = {};

},{}],64:[function(require,module,exports){
module.exports = true;

},{}],65:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":46,"./_has":49,"./_is-object":57,"./_object-dp":69,"./_uid":98}],66:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":37,"./_global":48,"./_task":91}],67:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":31}],68:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":34,"./_dom-create":42,"./_enum-bug-keys":43,"./_html":51,"./_object-dps":70,"./_shared-key":87}],69:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":34,"./_descriptors":41,"./_ie8-dom-define":52,"./_to-primitive":97}],70:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":34,"./_descriptors":41,"./_object-dp":69,"./_object-keys":77}],71:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":41,"./_has":49,"./_ie8-dom-define":52,"./_object-pie":78,"./_property-desc":82,"./_to-iobject":94,"./_to-primitive":97}],72:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":73,"./_to-iobject":94}],73:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":43,"./_object-keys-internal":76}],74:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],75:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":49,"./_shared-key":87,"./_to-object":96}],76:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":35,"./_has":49,"./_shared-key":87,"./_to-iobject":94}],77:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":43,"./_object-keys-internal":76}],78:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],79:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":38,"./_export":45,"./_fails":46}],80:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],81:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":34,"./_is-object":57,"./_new-promise-capability":67}],82:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],83:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":50}],84:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":50}],85:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":38,"./_descriptors":41,"./_global":48,"./_object-dp":69,"./_wks":102}],86:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":49,"./_object-dp":69,"./_wks":102}],87:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":88,"./_uid":98}],88:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":38,"./_global":48,"./_library":64}],89:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":31,"./_an-object":34,"./_wks":102}],90:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":40,"./_to-integer":93}],91:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":37,"./_ctx":39,"./_dom-create":42,"./_global":48,"./_html":51,"./_invoke":53}],92:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":93}],93:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],94:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":40,"./_iobject":54}],95:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":93}],96:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":40}],97:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":57}],98:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],99:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":48}],100:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":38,"./_global":48,"./_library":64,"./_object-dp":69,"./_wks-ext":101}],101:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":102}],102:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":48,"./_shared":88,"./_uid":98}],103:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":36,"./_core":38,"./_iterators":63,"./_wks":102}],104:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":32,"./_iter-define":60,"./_iter-step":62,"./_iterators":63,"./_to-iobject":94}],105:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":45,"./_object-create":68}],106:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":41,"./_export":45,"./_object-dps":70}],107:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":41,"./_export":45,"./_object-dp":69}],108:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":71,"./_object-sap":79,"./_to-iobject":94}],109:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":72,"./_object-sap":79}],110:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":75,"./_object-sap":79,"./_to-object":96}],111:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":57,"./_object-sap":79}],112:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":77,"./_object-sap":79,"./_to-object":96}],113:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":57,"./_meta":65,"./_object-sap":79}],114:[function(require,module,exports){

},{}],115:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":31,"./_an-instance":33,"./_classof":36,"./_core":38,"./_ctx":39,"./_export":45,"./_for-of":47,"./_global":48,"./_is-object":57,"./_iter-detect":61,"./_library":64,"./_microtask":66,"./_new-promise-capability":67,"./_perform":80,"./_promise-resolve":81,"./_redefine-all":83,"./_set-species":85,"./_set-to-string-tag":86,"./_species-constructor":89,"./_task":91,"./_user-agent":99,"./_wks":102}],116:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":60,"./_string-at":90}],117:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":34,"./_descriptors":41,"./_enum-keys":44,"./_export":45,"./_fails":46,"./_global":48,"./_has":49,"./_hide":50,"./_is-array":56,"./_is-object":57,"./_library":64,"./_meta":65,"./_object-create":68,"./_object-dp":69,"./_object-gopd":71,"./_object-gopn":73,"./_object-gopn-ext":72,"./_object-gops":74,"./_object-keys":77,"./_object-pie":78,"./_property-desc":82,"./_redefine":84,"./_set-to-string-tag":86,"./_shared":88,"./_to-iobject":94,"./_to-object":96,"./_to-primitive":97,"./_uid":98,"./_wks":102,"./_wks-define":100,"./_wks-ext":101}],118:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":38,"./_export":45,"./_global":48,"./_promise-resolve":81,"./_species-constructor":89}],119:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":45,"./_new-promise-capability":67,"./_perform":80}],120:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":100}],121:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":100}],122:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":48,"./_hide":50,"./_iterators":63,"./_wks":102,"./es6.array.iterator":104}],123:[function(require,module,exports){
'use strict';
var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

},{}],124:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],125:[function(require,module,exports){
'use strict';
var strictUriEncode = require('strict-uri-encode');
var objectAssign = require('object-assign');
var decodeComponent = require('decode-uri-component');

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};

},{"decode-uri-component":123,"object-assign":126,"strict-uri-encode":127}],126:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],127:[function(require,module,exports){
'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

},{}],128:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueChartJs=t():e.VueChartJs=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return e[r].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="/",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var i=n(207),a=r(i),o=n(209),s=r(o),u=n(210),d=r(u),l=n(211),c=r(l),h=n(212),_=r(h),f=n(213),m=r(f),p=n(208),g=r(p),v=n(214),y=r(v),M={Bar:a.default,Doughnut:s.default,Line:d.default,Pie:c.default,PolarArea:_.default,Radar:m.default,Bubble:g.default,Scatter:y.default};e.exports=M},function(e,t,n){(function(e){!function(t,n){e.exports=n()}(this,function(){"use strict";function t(){return gr.apply(null,arguments)}function r(e){gr=e}function i(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function a(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function o(e){var t;for(t in e)return!1;return!0}function s(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function u(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function d(e,t){var n,r=[];for(n=0;n<e.length;++n)r.push(t(e[n],n));return r}function l(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function c(e,t){for(var n in t)l(t,n)&&(e[n]=t[n]);return l(t,"toString")&&(e.toString=t.toString),l(t,"valueOf")&&(e.valueOf=t.valueOf),e}function h(e,t,n,r){return yt(e,t,n,r,!0).utc()}function _(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null}}function f(e){return null==e._pf&&(e._pf=_()),e._pf}function m(e){if(null==e._isValid){var t=f(e),n=yr.call(t.parsedDateParts,function(e){return null!=e}),r=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidMonth&&!t.invalidWeekday&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n);if(e._strict&&(r=r&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return r;e._isValid=r}return e._isValid}function p(e){var t=h(NaN);return null!=e?c(f(t),e):f(t).userInvalidated=!0,t}function g(e){return void 0===e}function v(e,t){var n,r,i;if(g(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),g(t._i)||(e._i=t._i),g(t._f)||(e._f=t._f),g(t._l)||(e._l=t._l),g(t._strict)||(e._strict=t._strict),g(t._tzm)||(e._tzm=t._tzm),g(t._isUTC)||(e._isUTC=t._isUTC),g(t._offset)||(e._offset=t._offset),g(t._pf)||(e._pf=f(t)),g(t._locale)||(e._locale=t._locale),Mr.length>0)for(n in Mr)r=Mr[n],i=t[r],g(i)||(e[r]=i);return e}function y(e){v(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),br===!1&&(br=!0,t.updateOffset(this),br=!1)}function M(e){return e instanceof y||null!=e&&null!=e._isAMomentObject}function b(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function L(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=b(t)),n}function k(e,t,n){var r,i=Math.min(e.length,t.length),a=Math.abs(e.length-t.length),o=0;for(r=0;r<i;r++)(n&&e[r]!==t[r]||!n&&L(e[r])!==L(t[r]))&&o++;return o+a}function Y(e){t.suppressDeprecationWarnings===!1&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function x(e,n){var r=!0;return c(function(){if(null!=t.deprecationHandler&&t.deprecationHandler(null,e),r){for(var i,a=[],o=0;o<arguments.length;o++){if(i="","object"==typeof arguments[o]){i+="\n["+o+"] ";for(var s in arguments[0])i+=s+": "+arguments[0][s]+", ";i=i.slice(0,-2)}else i=arguments[o];a.push(i)}Y(e+"\nArguments: "+Array.prototype.slice.call(a).join("")+"\n"+(new Error).stack),r=!1}return n.apply(this,arguments)},n)}function w(e,n){null!=t.deprecationHandler&&t.deprecationHandler(e,n),Lr[e]||(Y(n),Lr[e]=!0)}function D(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function T(e){var t,n;for(n in e)t=e[n],D(t)?this[n]=t:this["_"+n]=t;this._config=e,this._ordinalParseLenient=new RegExp(this._ordinalParse.source+"|"+/\d{1,2}/.source)}function S(e,t){var n,r=c({},e);for(n in t)l(t,n)&&(a(e[n])&&a(t[n])?(r[n]={},c(r[n],e[n]),c(r[n],t[n])):null!=t[n]?r[n]=t[n]:delete r[n]);for(n in e)l(e,n)&&!l(t,n)&&a(e[n])&&(r[n]=c({},r[n]));return r}function j(e){null!=e&&this.set(e)}function H(e,t,n){var r=this._calendar[e]||this._calendar.sameElse;return D(r)?r.call(t,n):r}function A(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])}function P(){return this._invalidDate}function C(e){return this._ordinal.replace("%d",e)}function O(e,t,n,r){var i=this._relativeTime[n];return D(i)?i(e,t,n,r):i.replace(/%d/i,e)}function F(e,t){var n=this._relativeTime[e>0?"future":"past"];return D(n)?n(t):n.replace(/%s/i,t)}function W(e,t){var n=e.toLowerCase();Ar[n]=Ar[n+"s"]=Ar[t]=e}function I(e){return"string"==typeof e?Ar[e]||Ar[e.toLowerCase()]:void 0}function E(e){var t,n,r={};for(n in e)l(e,n)&&(t=I(n),t&&(r[t]=e[n]));return r}function z(e,t){Pr[e]=t}function R(e){var t=[];for(var n in e)t.push({unit:n,priority:Pr[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}function N(e,n){return function(r){return null!=r?(B(this,e,r),t.updateOffset(this,n),this):V(this,e)}}function V(e,t){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+t]():NaN}function B(e,t,n){e.isValid()&&e._d["set"+(e._isUTC?"UTC":"")+t](n)}function $(e){return e=I(e),D(this[e])?this[e]():this}function J(e,t){if("object"==typeof e){e=E(e);for(var n=R(e),r=0;r<n.length;r++)this[n[r].unit](e[n[r].unit])}else if(e=I(e),D(this[e]))return this[e](t);return this}function U(e,t,n){var r=""+Math.abs(e),i=t-r.length,a=e>=0;return(a?n?"+":"":"-")+Math.pow(10,Math.max(0,i)).toString().substr(1)+r}function q(e,t,n,r){var i=r;"string"==typeof r&&(i=function(){return this[r]()}),e&&(Wr[e]=i),t&&(Wr[t[0]]=function(){return U(i.apply(this,arguments),t[1],t[2])}),n&&(Wr[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function G(e){return e.match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"")}function K(e){var t,n,r=e.match(Cr);for(t=0,n=r.length;t<n;t++)Wr[r[t]]?r[t]=Wr[r[t]]:r[t]=G(r[t]);return function(t){var i,a="";for(i=0;i<n;i++)a+=r[i]instanceof Function?r[i].call(t,e):r[i];return a}}function Z(e,t){return e.isValid()?(t=Q(t,e.localeData()),Fr[t]=Fr[t]||K(t),Fr[t](e)):e.localeData().invalidDate()}function Q(e,t){function n(e){return t.longDateFormat(e)||e}var r=5;for(Or.lastIndex=0;r>=0&&Or.test(e);)e=e.replace(Or,n),Or.lastIndex=0,r-=1;return e}function X(e,t,n){ti[e]=D(t)?t:function(e,r){return e&&n?n:t}}function ee(e,t){return l(ti,e)?ti[e](t._strict,t._locale):new RegExp(te(e))}function te(e){return ne(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,r,i){return t||n||r||i}))}function ne(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function re(e,t){var n,r=t;for("string"==typeof e&&(e=[e]),s(t)&&(r=function(e,n){n[t]=L(e)}),n=0;n<e.length;n++)ni[e[n]]=r}function ie(e,t){re(e,function(e,n,r,i){r._w=r._w||{},t(e,r._w,r,i)})}function ae(e,t,n){null!=t&&l(ni,e)&&ni[e](t,n._a,n,e)}function oe(e,t){return new Date(Date.UTC(e,t+1,0)).getUTCDate()}function se(e,t){return e?i(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||_i).test(t)?"format":"standalone"][e.month()]:this._months}function ue(e,t){return e?i(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[_i.test(t)?"format":"standalone"][e.month()]:this._monthsShort}function de(e,t,n){var r,i,a,o=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],r=0;r<12;++r)a=h([2e3,r]),this._shortMonthsParse[r]=this.monthsShort(a,"").toLocaleLowerCase(),this._longMonthsParse[r]=this.months(a,"").toLocaleLowerCase();return n?"MMM"===t?(i=hi.call(this._shortMonthsParse,o),i!==-1?i:null):(i=hi.call(this._longMonthsParse,o),i!==-1?i:null):"MMM"===t?(i=hi.call(this._shortMonthsParse,o),i!==-1?i:(i=hi.call(this._longMonthsParse,o),i!==-1?i:null)):(i=hi.call(this._longMonthsParse,o),i!==-1?i:(i=hi.call(this._shortMonthsParse,o),i!==-1?i:null))}function le(e,t,n){var r,i,a;if(this._monthsParseExact)return de.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),r=0;r<12;r++){if(i=h([2e3,r]),n&&!this._longMonthsParse[r]&&(this._longMonthsParse[r]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[r]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[r]||(a="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[r]=new RegExp(a.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[r].test(e))return r;if(n&&"MMM"===t&&this._shortMonthsParse[r].test(e))return r;if(!n&&this._monthsParse[r].test(e))return r}}function ce(e,t){var n;if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=L(t);else if(t=e.localeData().monthsParse(t),!s(t))return e;return n=Math.min(e.date(),oe(e.year(),t)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](t,n),e}function he(e){return null!=e?(ce(this,e),t.updateOffset(this,!0),this):V(this,"Month")}function _e(){return oe(this.year(),this.month())}function fe(e){return this._monthsParseExact?(l(this,"_monthsRegex")||pe.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,"_monthsShortRegex")||(this._monthsShortRegex=pi),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)}function me(e){return this._monthsParseExact?(l(this,"_monthsRegex")||pe.call(this),e?this._monthsStrictRegex:this._monthsRegex):(l(this,"_monthsRegex")||(this._monthsRegex=gi),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)}function pe(){function e(e,t){return t.length-e.length}var t,n,r=[],i=[],a=[];for(t=0;t<12;t++)n=h([2e3,t]),r.push(this.monthsShort(n,"")),i.push(this.months(n,"")),a.push(this.months(n,"")),a.push(this.monthsShort(n,""));for(r.sort(e),i.sort(e),a.sort(e),t=0;t<12;t++)r[t]=ne(r[t]),i[t]=ne(i[t]);for(t=0;t<24;t++)a[t]=ne(a[t]);this._monthsRegex=new RegExp("^("+a.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+r.join("|")+")","i")}function ge(e){return ve(e)?366:365}function ve(e){return e%4===0&&e%100!==0||e%400===0}function ye(){return ve(this.year())}function Me(e,t,n,r,i,a,o){var s=new Date(e,t,n,r,i,a,o);return e<100&&e>=0&&isFinite(s.getFullYear())&&s.setFullYear(e),s}function be(e){var t=new Date(Date.UTC.apply(null,arguments));return e<100&&e>=0&&isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e),t}function Le(e,t,n){var r=7+t-n,i=(7+be(e,0,r).getUTCDay()-t)%7;return-i+r-1}function ke(e,t,n,r,i){var a,o,s=(7+n-r)%7,u=Le(e,r,i),d=1+7*(t-1)+s+u;return d<=0?(a=e-1,o=ge(a)+d):d>ge(e)?(a=e+1,o=d-ge(e)):(a=e,o=d),{year:a,dayOfYear:o}}function Ye(e,t,n){var r,i,a=Le(e.year(),t,n),o=Math.floor((e.dayOfYear()-a-1)/7)+1;return o<1?(i=e.year()-1,r=o+xe(i,t,n)):o>xe(e.year(),t,n)?(r=o-xe(e.year(),t,n),i=e.year()+1):(i=e.year(),r=o),{week:r,year:i}}function xe(e,t,n){var r=Le(e,t,n),i=Le(e+1,t,n);return(ge(e)-r+i)/7}function we(e){return Ye(e,this._week.dow,this._week.doy).week}function De(){return this._week.dow}function Te(){return this._week.doy}function Se(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")}function je(e){var t=Ye(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")}function He(e,t){return"string"!=typeof e?e:isNaN(e)?(e=t.weekdaysParse(e),"number"==typeof e?e:null):parseInt(e,10)}function Ae(e,t){return"string"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}function Pe(e,t){return e?i(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(t)?"format":"standalone"][e.day()]:this._weekdays}function Ce(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort}function Oe(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin}function Fe(e,t,n){var r,i,a,o=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],r=0;r<7;++r)a=h([2e3,1]).day(r),this._minWeekdaysParse[r]=this.weekdaysMin(a,"").toLocaleLowerCase(),this._shortWeekdaysParse[r]=this.weekdaysShort(a,"").toLocaleLowerCase(),this._weekdaysParse[r]=this.weekdays(a,"").toLocaleLowerCase();return n?"dddd"===t?(i=hi.call(this._weekdaysParse,o),i!==-1?i:null):"ddd"===t?(i=hi.call(this._shortWeekdaysParse,o),i!==-1?i:null):(i=hi.call(this._minWeekdaysParse,o),i!==-1?i:null):"dddd"===t?(i=hi.call(this._weekdaysParse,o),i!==-1?i:(i=hi.call(this._shortWeekdaysParse,o),i!==-1?i:(i=hi.call(this._minWeekdaysParse,o),i!==-1?i:null))):"ddd"===t?(i=hi.call(this._shortWeekdaysParse,o),i!==-1?i:(i=hi.call(this._weekdaysParse,o),i!==-1?i:(i=hi.call(this._minWeekdaysParse,o),i!==-1?i:null))):(i=hi.call(this._minWeekdaysParse,o),i!==-1?i:(i=hi.call(this._weekdaysParse,o),i!==-1?i:(i=hi.call(this._shortWeekdaysParse,o),i!==-1?i:null)))}function We(e,t,n){var r,i,a;if(this._weekdaysParseExact)return Fe.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),r=0;r<7;r++){if(i=h([2e3,1]).day(r),n&&!this._fullWeekdaysParse[r]&&(this._fullWeekdaysParse[r]=new RegExp("^"+this.weekdays(i,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[r]=new RegExp("^"+this.weekdaysShort(i,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[r]=new RegExp("^"+this.weekdaysMin(i,"").replace(".",".?")+"$","i")),this._weekdaysParse[r]||(a="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[r]=new RegExp(a.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[r].test(e))return r;if(n&&"ddd"===t&&this._shortWeekdaysParse[r].test(e))return r;if(n&&"dd"===t&&this._minWeekdaysParse[r].test(e))return r;if(!n&&this._weekdaysParse[r].test(e))return r}}function Ie(e){if(!this.isValid())return null!=e?this:NaN;var t=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=He(e,this.localeData()),this.add(e-t,"d")):t}function Ee(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")}function ze(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=Ae(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7}function Re(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,"_weekdaysRegex")||(this._weekdaysRegex=ki),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)}function Ne(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=Yi),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Ve(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=xi),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Be(){function e(e,t){return t.length-e.length}var t,n,r,i,a,o=[],s=[],u=[],d=[];for(t=0;t<7;t++)n=h([2e3,1]).day(t),r=this.weekdaysMin(n,""),i=this.weekdaysShort(n,""),a=this.weekdays(n,""),o.push(r),s.push(i),u.push(a),d.push(r),d.push(i),d.push(a);for(o.sort(e),s.sort(e),u.sort(e),d.sort(e),t=0;t<7;t++)s[t]=ne(s[t]),u[t]=ne(u[t]),d[t]=ne(d[t]);this._weekdaysRegex=new RegExp("^("+d.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+u.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+s.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+o.join("|")+")","i")}function $e(){return this.hours()%12||12}function Je(){return this.hours()||24}function Ue(e,t){q(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function qe(e,t){return t._meridiemParse}function Ge(e){return"p"===(e+"").toLowerCase().charAt(0)}function Ke(e,t,n){return e>11?n?"pm":"PM":n?"am":"AM"}function Ze(e){return e?e.toLowerCase().replace("_","-"):e}function Qe(e){for(var t,n,r,i,a=0;a<e.length;){for(i=Ze(e[a]).split("-"),t=i.length,n=Ze(e[a+1]),n=n?n.split("-"):null;t>0;){if(r=Xe(i.slice(0,t).join("-")))return r;if(n&&n.length>=t&&k(i,n,!0)>=t-1)break;t--}a++}return null}function Xe(t){var r=null;if(!ji[t]&&"undefined"!=typeof e&&e&&e.exports)try{r=wi._abbr,n(388)("./"+t),et(r)}catch(e){}return ji[t]}function et(e,t){var n;return e&&(n=g(t)?rt(e):tt(e,t),n&&(wi=n)),wi._abbr}function tt(e,t){if(null!==t){var n=Si;if(t.abbr=e,null!=ji[e])w("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),n=ji[e]._config;else if(null!=t.parentLocale){if(null==ji[t.parentLocale])return Hi[t.parentLocale]||(Hi[t.parentLocale]=[]),Hi[t.parentLocale].push({name:e,config:t}),null;n=ji[t.parentLocale]._config}return ji[e]=new j(S(n,t)),Hi[e]&&Hi[e].forEach(function(e){tt(e.name,e.config)}),et(e),ji[e]}return delete ji[e],null}function nt(e,t){if(null!=t){var n,r=Si;null!=ji[e]&&(r=ji[e]._config),t=S(r,t),n=new j(t),n.parentLocale=ji[e],ji[e]=n,et(e)}else null!=ji[e]&&(null!=ji[e].parentLocale?ji[e]=ji[e].parentLocale:null!=ji[e]&&delete ji[e]);return ji[e]}function rt(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return wi;if(!i(e)){if(t=Xe(e))return t;e=[e]}return Qe(e)}function it(){return xr(ji)}function at(e){var t,n=e._a;return n&&f(e).overflow===-2&&(t=n[ii]<0||n[ii]>11?ii:n[ai]<1||n[ai]>oe(n[ri],n[ii])?ai:n[oi]<0||n[oi]>24||24===n[oi]&&(0!==n[si]||0!==n[ui]||0!==n[di])?oi:n[si]<0||n[si]>59?si:n[ui]<0||n[ui]>59?ui:n[di]<0||n[di]>999?di:-1,f(e)._overflowDayOfYear&&(t<ri||t>ai)&&(t=ai),f(e)._overflowWeeks&&t===-1&&(t=li),f(e)._overflowWeekday&&t===-1&&(t=ci),f(e).overflow=t),e}function ot(e){var t,n,r,i,a,o,s=e._i,u=Ai.exec(s)||Pi.exec(s);if(u){for(f(e).iso=!0,t=0,n=Oi.length;t<n;t++)if(Oi[t][1].exec(u[1])){i=Oi[t][0],r=Oi[t][2]!==!1;break}if(null==i)return void(e._isValid=!1);if(u[3]){for(t=0,n=Fi.length;t<n;t++)if(Fi[t][1].exec(u[3])){a=(u[2]||" ")+Fi[t][0];break}if(null==a)return void(e._isValid=!1)}if(!r&&null!=a)return void(e._isValid=!1);if(u[4]){if(!Ci.exec(u[4]))return void(e._isValid=!1);o="Z"}e._f=i+(a||"")+(o||""),ht(e)}else e._isValid=!1}function st(e){var n=Wi.exec(e._i);return null!==n?void(e._d=new Date(+n[1])):(ot(e),void(e._isValid===!1&&(delete e._isValid,t.createFromInputFallback(e))))}function ut(e,t,n){return null!=e?e:null!=t?t:n}function dt(e){var n=new Date(t.now());return e._useUTC?[n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()]:[n.getFullYear(),n.getMonth(),n.getDate()]}function lt(e){var t,n,r,i,a=[];if(!e._d){for(r=dt(e),e._w&&null==e._a[ai]&&null==e._a[ii]&&ct(e),e._dayOfYear&&(i=ut(e._a[ri],r[ri]),e._dayOfYear>ge(i)&&(f(e)._overflowDayOfYear=!0),n=be(i,0,e._dayOfYear),e._a[ii]=n.getUTCMonth(),e._a[ai]=n.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=a[t]=r[t];for(;t<7;t++)e._a[t]=a[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[oi]&&0===e._a[si]&&0===e._a[ui]&&0===e._a[di]&&(e._nextDay=!0,e._a[oi]=0),e._d=(e._useUTC?be:Me).apply(null,a),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[oi]=24)}}function ct(e){var t,n,r,i,a,o,s,u;if(t=e._w,null!=t.GG||null!=t.W||null!=t.E)a=1,o=4,n=ut(t.GG,e._a[ri],Ye(Mt(),1,4).year),r=ut(t.W,1),i=ut(t.E,1),(i<1||i>7)&&(u=!0);else{a=e._locale._week.dow,o=e._locale._week.doy;var d=Ye(Mt(),a,o);n=ut(t.gg,e._a[ri],d.year),r=ut(t.w,d.week),null!=t.d?(i=t.d,(i<0||i>6)&&(u=!0)):null!=t.e?(i=t.e+a,(t.e<0||t.e>6)&&(u=!0)):i=a}r<1||r>xe(n,a,o)?f(e)._overflowWeeks=!0:null!=u?f(e)._overflowWeekday=!0:(s=ke(n,r,i,a,o),e._a[ri]=s.year,e._dayOfYear=s.dayOfYear)}function ht(e){if(e._f===t.ISO_8601)return void ot(e);e._a=[],f(e).empty=!0;var n,r,i,a,o,s=""+e._i,u=s.length,d=0;for(i=Q(e._f,e._locale).match(Cr)||[],n=0;n<i.length;n++)a=i[n],r=(s.match(ee(a,e))||[])[0],r&&(o=s.substr(0,s.indexOf(r)),o.length>0&&f(e).unusedInput.push(o),s=s.slice(s.indexOf(r)+r.length),d+=r.length),Wr[a]?(r?f(e).empty=!1:f(e).unusedTokens.push(a),ae(a,r,e)):e._strict&&!r&&f(e).unusedTokens.push(a);f(e).charsLeftOver=u-d,s.length>0&&f(e).unusedInput.push(s),e._a[oi]<=12&&f(e).bigHour===!0&&e._a[oi]>0&&(f(e).bigHour=void 0),f(e).parsedDateParts=e._a.slice(0),f(e).meridiem=e._meridiem,e._a[oi]=_t(e._locale,e._a[oi],e._meridiem),lt(e),at(e)}function _t(e,t,n){var r;return null==n?t:null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?(r=e.isPM(n),r&&t<12&&(t+=12),r||12!==t||(t=0),t):t}function ft(e){var t,n,r,i,a;if(0===e._f.length)return f(e).invalidFormat=!0,void(e._d=new Date(NaN));for(i=0;i<e._f.length;i++)a=0,t=v({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[i],ht(t),m(t)&&(a+=f(t).charsLeftOver,a+=10*f(t).unusedTokens.length,f(t).score=a,(null==r||a<r)&&(r=a,n=t));c(e,n||t)}function mt(e){if(!e._d){var t=E(e._i);e._a=d([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),lt(e)}}function pt(e){var t=new y(at(gt(e)));return t._nextDay&&(t.add(1,"d"),t._nextDay=void 0),t}function gt(e){var t=e._i,n=e._f;return e._locale=e._locale||rt(e._l),null===t||void 0===n&&""===t?p({nullInput:!0}):("string"==typeof t&&(e._i=t=e._locale.preparse(t)),M(t)?new y(at(t)):(u(t)?e._d=t:i(n)?ft(e):n?ht(e):vt(e),m(e)||(e._d=null),e))}function vt(e){var n=e._i;void 0===n?e._d=new Date(t.now()):u(n)?e._d=new Date(n.valueOf()):"string"==typeof n?st(e):i(n)?(e._a=d(n.slice(0),function(e){return parseInt(e,10)}),lt(e)):"object"==typeof n?mt(e):s(n)?e._d=new Date(n):t.createFromInputFallback(e)}function yt(e,t,n,r,s){var u={};return n!==!0&&n!==!1||(r=n,n=void 0),(a(e)&&o(e)||i(e)&&0===e.length)&&(e=void 0),u._isAMomentObject=!0,u._useUTC=u._isUTC=s,u._l=n,u._i=e,u._f=t,u._strict=r,pt(u)}function Mt(e,t,n,r){return yt(e,t,n,r,!1)}function bt(e,t){var n,r;if(1===t.length&&i(t[0])&&(t=t[0]),!t.length)return Mt();for(n=t[0],r=1;r<t.length;++r)t[r].isValid()&&!t[r][e](n)||(n=t[r]);return n}function Lt(){var e=[].slice.call(arguments,0);return bt("isBefore",e)}function kt(){var e=[].slice.call(arguments,0);return bt("isAfter",e)}function Yt(e){var t=E(e),n=t.year||0,r=t.quarter||0,i=t.month||0,a=t.week||0,o=t.day||0,s=t.hour||0,u=t.minute||0,d=t.second||0,l=t.millisecond||0;this._milliseconds=+l+1e3*d+6e4*u+1e3*s*60*60,this._days=+o+7*a,this._months=+i+3*r+12*n,this._data={},this._locale=rt(),this._bubble()}function xt(e){return e instanceof Yt}function wt(e){return e<0?Math.round(-1*e)*-1:Math.round(e)}function Dt(e,t){q(e,0,0,function(){var e=this.utcOffset(),n="+";return e<0&&(e=-e,n="-"),n+U(~~(e/60),2)+t+U(~~e%60,2)})}function Tt(e,t){var n=(t||"").match(e);if(null===n)return null;var r=n[n.length-1]||[],i=(r+"").match(Ri)||["-",0,0],a=+(60*i[1])+L(i[2]);return 0===a?0:"+"===i[0]?a:-a}function St(e,n){var r,i;return n._isUTC?(r=n.clone(),i=(M(e)||u(e)?e.valueOf():Mt(e).valueOf())-r.valueOf(),r._d.setTime(r._d.valueOf()+i),t.updateOffset(r,!1),r):Mt(e).local()}function jt(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Ht(e,n){var r,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if("string"==typeof e){if(e=Tt(Qr,e),null===e)return this}else Math.abs(e)<16&&(e*=60);return!this._isUTC&&n&&(r=jt(this)),this._offset=e,this._isUTC=!0,null!=r&&this.add(r,"m"),i!==e&&(!n||this._changeInProgress?Ut(this,Nt(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,t.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?i:jt(this)}function At(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}function Pt(e){return this.utcOffset(0,e)}function Ct(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(jt(this),"m")),this}function Ot(){if(null!=this._tzm)this.utcOffset(this._tzm);else if("string"==typeof this._i){var e=Tt(Zr,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this}function Ft(e){return!!this.isValid()&&(e=e?Mt(e).utcOffset():0,(this.utcOffset()-e)%60===0)}function Wt(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function It(){if(!g(this._isDSTShifted))return this._isDSTShifted;var e={};if(v(e,this),e=gt(e),e._a){var t=e._isUTC?h(e._a):Mt(e._a);this._isDSTShifted=this.isValid()&&k(e._a,t.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Et(){return!!this.isValid()&&!this._isUTC}function zt(){return!!this.isValid()&&this._isUTC}function Rt(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}function Nt(e,t){var n,r,i,a=e,o=null;return xt(e)?a={ms:e._milliseconds,d:e._days,M:e._months}:s(e)?(a={},t?a[t]=e:a.milliseconds=e):(o=Ni.exec(e))?(n="-"===o[1]?-1:1,a={y:0,d:L(o[ai])*n,h:L(o[oi])*n,m:L(o[si])*n,s:L(o[ui])*n,ms:L(wt(1e3*o[di]))*n}):(o=Vi.exec(e))?(n="-"===o[1]?-1:1,a={y:Vt(o[2],n),M:Vt(o[3],n),w:Vt(o[4],n),d:Vt(o[5],n),h:Vt(o[6],n),m:Vt(o[7],n),s:Vt(o[8],n)}):null==a?a={}:"object"==typeof a&&("from"in a||"to"in a)&&(i=$t(Mt(a.from),Mt(a.to)),a={},a.ms=i.milliseconds,a.M=i.months),r=new Yt(a),xt(e)&&l(e,"_locale")&&(r._locale=e._locale),r}function Vt(e,t){var n=e&&parseFloat(e.replace(",","."));return(isNaN(n)?0:n)*t}function Bt(e,t){var n={milliseconds:0,months:0};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function $t(e,t){var n;return e.isValid()&&t.isValid()?(t=St(t,e),e.isBefore(t)?n=Bt(e,t):(n=Bt(t,e),n.milliseconds=-n.milliseconds,n.months=-n.months),n):{milliseconds:0,months:0}}function Jt(e,t){return function(n,r){var i,a;return null===r||isNaN(+r)||(w(t,"moment()."+t+"(period, number) is deprecated. Please use moment()."+t+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),a=n,n=r,r=a),n="string"==typeof n?+n:n,i=Nt(n,r),Ut(this,i,e),this}}function Ut(e,n,r,i){var a=n._milliseconds,o=wt(n._days),s=wt(n._months);e.isValid()&&(i=null==i||i,a&&e._d.setTime(e._d.valueOf()+a*r),o&&B(e,"Date",V(e,"Date")+o*r),s&&ce(e,V(e,"Month")+s*r),i&&t.updateOffset(e,o||s))}function qt(e,t){var n=e.diff(t,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"}function Gt(e,n){var r=e||Mt(),i=St(r,this).startOf("day"),a=t.calendarFormat(this,i)||"sameElse",o=n&&(D(n[a])?n[a].call(this,r):n[a]);return this.format(o||this.localeData().calendar(a,this,Mt(r)))}function Kt(){return new y(this)}function Zt(e,t){var n=M(e)?e:Mt(e);return!(!this.isValid()||!n.isValid())&&(t=I(g(t)?"millisecond":t),"millisecond"===t?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())}function Qt(e,t){var n=M(e)?e:Mt(e);return!(!this.isValid()||!n.isValid())&&(t=I(g(t)?"millisecond":t),"millisecond"===t?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())}function Xt(e,t,n,r){return r=r||"()",("("===r[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===r[1]?this.isBefore(t,n):!this.isAfter(t,n))}function en(e,t){var n,r=M(e)?e:Mt(e);return!(!this.isValid()||!r.isValid())&&(t=I(t||"millisecond"),"millisecond"===t?this.valueOf()===r.valueOf():(n=r.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))}function tn(e,t){return this.isSame(e,t)||this.isAfter(e,t)}function nn(e,t){return this.isSame(e,t)||this.isBefore(e,t)}function rn(e,t,n){var r,i,a,o;return this.isValid()?(r=St(e,this),r.isValid()?(i=6e4*(r.utcOffset()-this.utcOffset()),t=I(t),"year"===t||"month"===t||"quarter"===t?(o=an(this,r),"quarter"===t?o/=3:"year"===t&&(o/=12)):(a=this-r,o="second"===t?a/1e3:"minute"===t?a/6e4:"hour"===t?a/36e5:"day"===t?(a-i)/864e5:"week"===t?(a-i)/6048e5:a),n?o:b(o)):NaN):NaN}function an(e,t){var n,r,i=12*(t.year()-e.year())+(t.month()-e.month()),a=e.clone().add(i,"months");return t-a<0?(n=e.clone().add(i-1,"months"),r=(t-a)/(a-n)):(n=e.clone().add(i+1,"months"),r=(t-a)/(n-a)),-(i+r)||0}function on(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function sn(){var e=this.clone().utc();return 0<e.year()&&e.year()<=9999?D(Date.prototype.toISOString)?this.toDate().toISOString():Z(e,"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"):Z(e,"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}function un(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e="moment",t="";this.isLocal()||(e=0===this.utcOffset()?"moment.utc":"moment.parseZone",t="Z");var n="["+e+'("]',r=0<this.year()&&this.year()<=9999?"YYYY":"YYYYYY",i="-MM-DD[T]HH:mm:ss.SSS",a=t+'[")]';return this.format(n+r+i+a)}function dn(e){e||(e=this.isUtc()?t.defaultFormatUtc:t.defaultFormat);var n=Z(this,e);return this.localeData().postformat(n)}function ln(e,t){return this.isValid()&&(M(e)&&e.isValid()||Mt(e).isValid())?Nt({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function cn(e){return this.from(Mt(),e)}function hn(e,t){return this.isValid()&&(M(e)&&e.isValid()||Mt(e).isValid())?Nt({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function _n(e){return this.to(Mt(),e)}function fn(e){var t;return void 0===e?this._locale._abbr:(t=rt(e),null!=t&&(this._locale=t),this)}function mn(){return this._locale}function pn(e){switch(e=I(e)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":case"date":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===e&&this.weekday(0),"isoWeek"===e&&this.isoWeekday(1),"quarter"===e&&this.month(3*Math.floor(this.month()/3)),this}function gn(e){return e=I(e),void 0===e||"millisecond"===e?this:("date"===e&&(e="day"),this.startOf(e).add(1,"isoWeek"===e?"week":e).subtract(1,"ms"))}function vn(){return this._d.valueOf()-6e4*(this._offset||0)}function yn(){return Math.floor(this.valueOf()/1e3)}function Mn(){return new Date(this.valueOf())}function bn(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]}function Ln(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}}function kn(){return this.isValid()?this.toISOString():null}function Yn(){return m(this)}function xn(){return c({},f(this))}function wn(){return f(this).overflow}function Dn(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function Tn(e,t){q(0,[e,e.length],0,t)}function Sn(e){return Pn.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function jn(e){return Pn.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)}function Hn(){return xe(this.year(),1,4)}function An(){var e=this.localeData()._week;return xe(this.year(),e.dow,e.doy)}function Pn(e,t,n,r,i){var a;return null==e?Ye(this,r,i).year:(a=xe(e,r,i),t>a&&(t=a),Cn.call(this,e,t,n,r,i))}function Cn(e,t,n,r,i){var a=ke(e,t,n,r,i),o=be(a.year,0,a.dayOfYear);return this.year(o.getUTCFullYear()),this.month(o.getUTCMonth()),this.date(o.getUTCDate()),this}function On(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3);
}function Fn(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")}function Wn(e,t){t[di]=L(1e3*("0."+e))}function In(){return this._isUTC?"UTC":""}function En(){return this._isUTC?"Coordinated Universal Time":""}function zn(e){return Mt(1e3*e)}function Rn(){return Mt.apply(null,arguments).parseZone()}function Nn(e){return e}function Vn(e,t,n,r){var i=rt(),a=h().set(r,t);return i[n](a,e)}function Bn(e,t,n){if(s(e)&&(t=e,e=void 0),e=e||"",null!=t)return Vn(e,t,n,"month");var r,i=[];for(r=0;r<12;r++)i[r]=Vn(e,r,n,"month");return i}function $n(e,t,n,r){"boolean"==typeof e?(s(t)&&(n=t,t=void 0),t=t||""):(t=e,n=t,e=!1,s(t)&&(n=t,t=void 0),t=t||"");var i=rt(),a=e?i._week.dow:0;if(null!=n)return Vn(t,(n+a)%7,r,"day");var o,u=[];for(o=0;o<7;o++)u[o]=Vn(t,(o+a)%7,r,"day");return u}function Jn(e,t){return Bn(e,t,"months")}function Un(e,t){return Bn(e,t,"monthsShort")}function qn(e,t,n){return $n(e,t,n,"weekdays")}function Gn(e,t,n){return $n(e,t,n,"weekdaysShort")}function Kn(e,t,n){return $n(e,t,n,"weekdaysMin")}function Zn(){var e=this._data;return this._milliseconds=ea(this._milliseconds),this._days=ea(this._days),this._months=ea(this._months),e.milliseconds=ea(e.milliseconds),e.seconds=ea(e.seconds),e.minutes=ea(e.minutes),e.hours=ea(e.hours),e.months=ea(e.months),e.years=ea(e.years),this}function Qn(e,t,n,r){var i=Nt(t,n);return e._milliseconds+=r*i._milliseconds,e._days+=r*i._days,e._months+=r*i._months,e._bubble()}function Xn(e,t){return Qn(this,e,t,1)}function er(e,t){return Qn(this,e,t,-1)}function tr(e){return e<0?Math.floor(e):Math.ceil(e)}function nr(){var e,t,n,r,i,a=this._milliseconds,o=this._days,s=this._months,u=this._data;return a>=0&&o>=0&&s>=0||a<=0&&o<=0&&s<=0||(a+=864e5*tr(ir(s)+o),o=0,s=0),u.milliseconds=a%1e3,e=b(a/1e3),u.seconds=e%60,t=b(e/60),u.minutes=t%60,n=b(t/60),u.hours=n%24,o+=b(n/24),i=b(rr(o)),s+=i,o-=tr(ir(i)),r=b(s/12),s%=12,u.days=o,u.months=s,u.years=r,this}function rr(e){return 4800*e/146097}function ir(e){return 146097*e/4800}function ar(e){var t,n,r=this._milliseconds;if(e=I(e),"month"===e||"year"===e)return t=this._days+r/864e5,n=this._months+rr(t),"month"===e?n:n/12;switch(t=this._days+Math.round(ir(this._months)),e){case"week":return t/7+r/6048e5;case"day":return t+r/864e5;case"hour":return 24*t+r/36e5;case"minute":return 1440*t+r/6e4;case"second":return 86400*t+r/1e3;case"millisecond":return Math.floor(864e5*t)+r;default:throw new Error("Unknown unit "+e)}}function or(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*L(this._months/12)}function sr(e){return function(){return this.as(e)}}function ur(e){return e=I(e),this[e+"s"]()}function dr(e){return function(){return this._data[e]}}function lr(){return b(this.days()/7)}function cr(e,t,n,r,i){return i.relativeTime(t||1,!!n,e,r)}function hr(e,t,n){var r=Nt(e).abs(),i=pa(r.as("s")),a=pa(r.as("m")),o=pa(r.as("h")),s=pa(r.as("d")),u=pa(r.as("M")),d=pa(r.as("y")),l=i<ga.s&&["s",i]||a<=1&&["m"]||a<ga.m&&["mm",a]||o<=1&&["h"]||o<ga.h&&["hh",o]||s<=1&&["d"]||s<ga.d&&["dd",s]||u<=1&&["M"]||u<ga.M&&["MM",u]||d<=1&&["y"]||["yy",d];return l[2]=t,l[3]=+e>0,l[4]=n,cr.apply(null,l)}function _r(e){return void 0===e?pa:"function"==typeof e&&(pa=e,!0)}function fr(e,t){return void 0!==ga[e]&&(void 0===t?ga[e]:(ga[e]=t,!0))}function mr(e){var t=this.localeData(),n=hr(this,!e,t);return e&&(n=t.pastFuture(+this,n)),t.postformat(n)}function pr(){var e,t,n,r=va(this._milliseconds)/1e3,i=va(this._days),a=va(this._months);e=b(r/60),t=b(e/60),r%=60,e%=60,n=b(a/12),a%=12;var o=n,s=a,u=i,d=t,l=e,c=r,h=this.asSeconds();return h?(h<0?"-":"")+"P"+(o?o+"Y":"")+(s?s+"M":"")+(u?u+"D":"")+(d||l||c?"T":"")+(d?d+"H":"")+(l?l+"M":"")+(c?c+"S":""):"P0D"}var gr,vr;vr=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,r=0;r<n;r++)if(r in t&&e.call(this,t[r],r,t))return!0;return!1};var yr=vr,Mr=t.momentProperties=[],br=!1,Lr={};t.suppressDeprecationWarnings=!1,t.deprecationHandler=null;var kr;kr=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)l(e,t)&&n.push(t);return n};var Yr,xr=kr,wr={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},Dr={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},Tr="Invalid date",Sr="%d",jr=/\d{1,2}/,Hr={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},Ar={},Pr={},Cr=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Or=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Fr={},Wr={},Ir=/\d/,Er=/\d\d/,zr=/\d{3}/,Rr=/\d{4}/,Nr=/[+-]?\d{6}/,Vr=/\d\d?/,Br=/\d\d\d\d?/,$r=/\d\d\d\d\d\d?/,Jr=/\d{1,3}/,Ur=/\d{1,4}/,qr=/[+-]?\d{1,6}/,Gr=/\d+/,Kr=/[+-]?\d+/,Zr=/Z|[+-]\d\d:?\d\d/gi,Qr=/Z|[+-]\d\d(?::?\d\d)?/gi,Xr=/[+-]?\d+(\.\d{1,3})?/,ei=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,ti={},ni={},ri=0,ii=1,ai=2,oi=3,si=4,ui=5,di=6,li=7,ci=8;Yr=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1};var hi=Yr;q("M",["MM",2],"Mo",function(){return this.month()+1}),q("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),q("MMMM",0,0,function(e){return this.localeData().months(this,e)}),W("month","M"),z("month",8),X("M",Vr),X("MM",Vr,Er),X("MMM",function(e,t){return t.monthsShortRegex(e)}),X("MMMM",function(e,t){return t.monthsRegex(e)}),re(["M","MM"],function(e,t){t[ii]=L(e)-1}),re(["MMM","MMMM"],function(e,t,n,r){var i=n._locale.monthsParse(e,r,n._strict);null!=i?t[ii]=i:f(n).invalidMonth=e});var _i=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,fi="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),mi="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),pi=ei,gi=ei;q("Y",0,0,function(){var e=this.year();return e<=9999?""+e:"+"+e}),q(0,["YY",2],0,function(){return this.year()%100}),q(0,["YYYY",4],0,"year"),q(0,["YYYYY",5],0,"year"),q(0,["YYYYYY",6,!0],0,"year"),W("year","y"),z("year",1),X("Y",Kr),X("YY",Vr,Er),X("YYYY",Ur,Rr),X("YYYYY",qr,Nr),X("YYYYYY",qr,Nr),re(["YYYYY","YYYYYY"],ri),re("YYYY",function(e,n){n[ri]=2===e.length?t.parseTwoDigitYear(e):L(e)}),re("YY",function(e,n){n[ri]=t.parseTwoDigitYear(e)}),re("Y",function(e,t){t[ri]=parseInt(e,10)}),t.parseTwoDigitYear=function(e){return L(e)+(L(e)>68?1900:2e3)};var vi=N("FullYear",!0);q("w",["ww",2],"wo","week"),q("W",["WW",2],"Wo","isoWeek"),W("week","w"),W("isoWeek","W"),z("week",5),z("isoWeek",5),X("w",Vr),X("ww",Vr,Er),X("W",Vr),X("WW",Vr,Er),ie(["w","ww","W","WW"],function(e,t,n,r){t[r.substr(0,1)]=L(e)});var yi={dow:0,doy:6};q("d",0,"do","day"),q("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),q("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),q("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),q("e",0,0,"weekday"),q("E",0,0,"isoWeekday"),W("day","d"),W("weekday","e"),W("isoWeekday","E"),z("day",11),z("weekday",11),z("isoWeekday",11),X("d",Vr),X("e",Vr),X("E",Vr),X("dd",function(e,t){return t.weekdaysMinRegex(e)}),X("ddd",function(e,t){return t.weekdaysShortRegex(e)}),X("dddd",function(e,t){return t.weekdaysRegex(e)}),ie(["dd","ddd","dddd"],function(e,t,n,r){var i=n._locale.weekdaysParse(e,r,n._strict);null!=i?t.d=i:f(n).invalidWeekday=e}),ie(["d","e","E"],function(e,t,n,r){t[r]=L(e)});var Mi="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),bi="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Li="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),ki=ei,Yi=ei,xi=ei;q("H",["HH",2],0,"hour"),q("h",["hh",2],0,$e),q("k",["kk",2],0,Je),q("hmm",0,0,function(){return""+$e.apply(this)+U(this.minutes(),2)}),q("hmmss",0,0,function(){return""+$e.apply(this)+U(this.minutes(),2)+U(this.seconds(),2)}),q("Hmm",0,0,function(){return""+this.hours()+U(this.minutes(),2)}),q("Hmmss",0,0,function(){return""+this.hours()+U(this.minutes(),2)+U(this.seconds(),2)}),Ue("a",!0),Ue("A",!1),W("hour","h"),z("hour",13),X("a",qe),X("A",qe),X("H",Vr),X("h",Vr),X("HH",Vr,Er),X("hh",Vr,Er),X("hmm",Br),X("hmmss",$r),X("Hmm",Br),X("Hmmss",$r),re(["H","HH"],oi),re(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),re(["h","hh"],function(e,t,n){t[oi]=L(e),f(n).bigHour=!0}),re("hmm",function(e,t,n){var r=e.length-2;t[oi]=L(e.substr(0,r)),t[si]=L(e.substr(r)),f(n).bigHour=!0}),re("hmmss",function(e,t,n){var r=e.length-4,i=e.length-2;t[oi]=L(e.substr(0,r)),t[si]=L(e.substr(r,2)),t[ui]=L(e.substr(i)),f(n).bigHour=!0}),re("Hmm",function(e,t,n){var r=e.length-2;t[oi]=L(e.substr(0,r)),t[si]=L(e.substr(r))}),re("Hmmss",function(e,t,n){var r=e.length-4,i=e.length-2;t[oi]=L(e.substr(0,r)),t[si]=L(e.substr(r,2)),t[ui]=L(e.substr(i))});var wi,Di=/[ap]\.?m?\.?/i,Ti=N("Hours",!0),Si={calendar:wr,longDateFormat:Dr,invalidDate:Tr,ordinal:Sr,ordinalParse:jr,relativeTime:Hr,months:fi,monthsShort:mi,week:yi,weekdays:Mi,weekdaysMin:Li,weekdaysShort:bi,meridiemParse:Di},ji={},Hi={},Ai=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Pi=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Ci=/Z|[+-]\d\d(?::?\d\d)?/,Oi=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],Fi=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Wi=/^\/?Date\((\-?\d+)/i;t.createFromInputFallback=x("value provided is not in a recognized ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),t.ISO_8601=function(){};var Ii=x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=Mt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:p()}),Ei=x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=Mt.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:p()}),zi=function(){return Date.now?Date.now():+new Date};Dt("Z",":"),Dt("ZZ",""),X("Z",Qr),X("ZZ",Qr),re(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Tt(Qr,e)});var Ri=/([\+\-]|\d\d)/gi;t.updateOffset=function(){};var Ni=/^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,Vi=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;Nt.fn=Yt.prototype;var Bi=Jt(1,"add"),$i=Jt(-1,"subtract");t.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",t.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var Ji=x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});q(0,["gg",2],0,function(){return this.weekYear()%100}),q(0,["GG",2],0,function(){return this.isoWeekYear()%100}),Tn("gggg","weekYear"),Tn("ggggg","weekYear"),Tn("GGGG","isoWeekYear"),Tn("GGGGG","isoWeekYear"),W("weekYear","gg"),W("isoWeekYear","GG"),z("weekYear",1),z("isoWeekYear",1),X("G",Kr),X("g",Kr),X("GG",Vr,Er),X("gg",Vr,Er),X("GGGG",Ur,Rr),X("gggg",Ur,Rr),X("GGGGG",qr,Nr),X("ggggg",qr,Nr),ie(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,r){t[r.substr(0,2)]=L(e)}),ie(["gg","GG"],function(e,n,r,i){n[i]=t.parseTwoDigitYear(e)}),q("Q",0,"Qo","quarter"),W("quarter","Q"),z("quarter",7),X("Q",Ir),re("Q",function(e,t){t[ii]=3*(L(e)-1)}),q("D",["DD",2],"Do","date"),W("date","D"),z("date",9),X("D",Vr),X("DD",Vr,Er),X("Do",function(e,t){return e?t._ordinalParse:t._ordinalParseLenient}),re(["D","DD"],ai),re("Do",function(e,t){t[ai]=L(e.match(Vr)[0],10)});var Ui=N("Date",!0);q("DDD",["DDDD",3],"DDDo","dayOfYear"),W("dayOfYear","DDD"),z("dayOfYear",4),X("DDD",Jr),X("DDDD",zr),re(["DDD","DDDD"],function(e,t,n){n._dayOfYear=L(e)}),q("m",["mm",2],0,"minute"),W("minute","m"),z("minute",14),X("m",Vr),X("mm",Vr,Er),re(["m","mm"],si);var qi=N("Minutes",!1);q("s",["ss",2],0,"second"),W("second","s"),z("second",15),X("s",Vr),X("ss",Vr,Er),re(["s","ss"],ui);var Gi=N("Seconds",!1);q("S",0,0,function(){return~~(this.millisecond()/100)}),q(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),q(0,["SSS",3],0,"millisecond"),q(0,["SSSS",4],0,function(){return 10*this.millisecond()}),q(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),q(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),q(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),q(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),q(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),W("millisecond","ms"),z("millisecond",16),X("S",Jr,Ir),X("SS",Jr,Er),X("SSS",Jr,zr);var Ki;for(Ki="SSSS";Ki.length<=9;Ki+="S")X(Ki,Gr);for(Ki="S";Ki.length<=9;Ki+="S")re(Ki,Wn);var Zi=N("Milliseconds",!1);q("z",0,0,"zoneAbbr"),q("zz",0,0,"zoneName");var Qi=y.prototype;Qi.add=Bi,Qi.calendar=Gt,Qi.clone=Kt,Qi.diff=rn,Qi.endOf=gn,Qi.format=dn,Qi.from=ln,Qi.fromNow=cn,Qi.to=hn,Qi.toNow=_n,Qi.get=$,Qi.invalidAt=wn,Qi.isAfter=Zt,Qi.isBefore=Qt,Qi.isBetween=Xt,Qi.isSame=en,Qi.isSameOrAfter=tn,Qi.isSameOrBefore=nn,Qi.isValid=Yn,Qi.lang=Ji,Qi.locale=fn,Qi.localeData=mn,Qi.max=Ei,Qi.min=Ii,Qi.parsingFlags=xn,Qi.set=J,Qi.startOf=pn,Qi.subtract=$i,Qi.toArray=bn,Qi.toObject=Ln,Qi.toDate=Mn,Qi.toISOString=sn,Qi.inspect=un,Qi.toJSON=kn,Qi.toString=on,Qi.unix=yn,Qi.valueOf=vn,Qi.creationData=Dn,Qi.year=vi,Qi.isLeapYear=ye,Qi.weekYear=Sn,Qi.isoWeekYear=jn,Qi.quarter=Qi.quarters=On,Qi.month=he,Qi.daysInMonth=_e,Qi.week=Qi.weeks=Se,Qi.isoWeek=Qi.isoWeeks=je,Qi.weeksInYear=An,Qi.isoWeeksInYear=Hn,Qi.date=Ui,Qi.day=Qi.days=Ie,Qi.weekday=Ee,Qi.isoWeekday=ze,Qi.dayOfYear=Fn,Qi.hour=Qi.hours=Ti,Qi.minute=Qi.minutes=qi,Qi.second=Qi.seconds=Gi,Qi.millisecond=Qi.milliseconds=Zi,Qi.utcOffset=Ht,Qi.utc=Pt,Qi.local=Ct,Qi.parseZone=Ot,Qi.hasAlignedHourOffset=Ft,Qi.isDST=Wt,Qi.isLocal=Et,Qi.isUtcOffset=zt,Qi.isUtc=Rt,Qi.isUTC=Rt,Qi.zoneAbbr=In,Qi.zoneName=En,Qi.dates=x("dates accessor is deprecated. Use date instead.",Ui),Qi.months=x("months accessor is deprecated. Use month instead",he),Qi.years=x("years accessor is deprecated. Use year instead",vi),Qi.zone=x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",At),Qi.isDSTShifted=x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",It);var Xi=j.prototype;Xi.calendar=H,Xi.longDateFormat=A,Xi.invalidDate=P,Xi.ordinal=C,Xi.preparse=Nn,Xi.postformat=Nn,Xi.relativeTime=O,Xi.pastFuture=F,Xi.set=T,Xi.months=se,Xi.monthsShort=ue,Xi.monthsParse=le,Xi.monthsRegex=me,Xi.monthsShortRegex=fe,Xi.week=we,Xi.firstDayOfYear=Te,Xi.firstDayOfWeek=De,Xi.weekdays=Pe,Xi.weekdaysMin=Oe,Xi.weekdaysShort=Ce,Xi.weekdaysParse=We,Xi.weekdaysRegex=Re,Xi.weekdaysShortRegex=Ne,Xi.weekdaysMinRegex=Ve,Xi.isPM=Ge,Xi.meridiem=Ke,et("en",{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10,n=1===L(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n}}),t.lang=x("moment.lang is deprecated. Use moment.locale instead.",et),t.langData=x("moment.langData is deprecated. Use moment.localeData instead.",rt);var ea=Math.abs,ta=sr("ms"),na=sr("s"),ra=sr("m"),ia=sr("h"),aa=sr("d"),oa=sr("w"),sa=sr("M"),ua=sr("y"),da=dr("milliseconds"),la=dr("seconds"),ca=dr("minutes"),ha=dr("hours"),_a=dr("days"),fa=dr("months"),ma=dr("years"),pa=Math.round,ga={s:45,m:45,h:22,d:26,M:11},va=Math.abs,ya=Yt.prototype;return ya.abs=Zn,ya.add=Xn,ya.subtract=er,ya.as=ar,ya.asMilliseconds=ta,ya.asSeconds=na,ya.asMinutes=ra,ya.asHours=ia,ya.asDays=aa,ya.asWeeks=oa,ya.asMonths=sa,ya.asYears=ua,ya.valueOf=or,ya._bubble=nr,ya.get=ur,ya.milliseconds=da,ya.seconds=la,ya.minutes=ca,ya.hours=ha,ya.days=_a,ya.weeks=lr,ya.months=fa,ya.years=ma,ya.humanize=mr,ya.toISOString=pr,ya.toString=pr,ya.toJSON=pr,ya.locale=fn,ya.localeData=mn,ya.toIsoString=x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",pr),ya.lang=Ji,q("X",0,0,"unix"),q("x",0,0,"valueOf"),X("x",Kr),X("X",Xr),re("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),re("x",function(e,t,n){n._d=new Date(L(e))}),t.version="2.17.1",r(Mt),t.fn=Qi,t.min=Lt,t.max=kt,t.now=zi,t.utc=h,t.unix=zn,t.months=Jn,t.isDate=u,t.locale=et,t.invalid=p,t.duration=Nt,t.isMoment=M,t.weekdays=qn,t.parseZone=Rn,t.localeData=rt,t.isDuration=xt,t.monthsShort=Un,t.weekdaysMin=Kn,t.defineLocale=tt,t.updateLocale=nt,t.locales=it,t.weekdaysShort=Gn,t.normalizeUnits=I,t.relativeTimeRounding=_r,t.relativeTimeThreshold=fr,t.calendarFormat=qt,t.prototype=Qi,t})}).call(t,n(32)(e))},function(e,t,n){var r=n(76),i="object"==typeof self&&self&&self.Object===Object&&self,a=r||i||Function("return this")();e.exports=a},function(e,t){var n=Array.isArray;e.exports=n},function(e,t){function n(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){return(0,o.default)(e,t)}Object.defineProperty(t,"__esModule",{value:!0}),t.mergeOptions=i;var a=n(371),o=r(a)},function(e,t,n){var r=n(235)();n(233)(r),n(247)(r),n(229)(r),n(232)(r),n(237)(r),n(228)(r),n(230)(r),n(231)(r),n(236)(r),n(239)(r),n(240)(r),n(238)(r),n(234)(r),n(241)(r),n(242)(r),n(243)(r),n(244)(r),n(245)(r),n(253)(r),n(251)(r),n(252)(r),n(254)(r),n(255)(r),n(256)(r),n(222)(r),n(223)(r),n(224)(r),n(225)(r),n(226)(r),n(227)(r),n(215)(r),n(216)(r),n(217)(r),n(218)(r),n(219)(r),n(220)(r),n(221)(r);var i=[];i.push(n(248)(r),n(249)(r),n(250)(r)),r.plugins.register(i),e.exports=r,"undefined"!=typeof window&&(window.Chart=r)},function(e,t){function n(e){return null!=e&&"object"==typeof e}e.exports=n},function(e,t,n){/*!
	 * Vue.js v1.0.28
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
"use strict";function r(e,t,n){if(a(e,t))return void(e[t]=n);if(e._isVue)return void r(e._data,t,n);var i=e.__ob__;if(!i)return void(e[t]=n);if(i.convert(t,n),i.dep.notify(),i.vms)for(var o=i.vms.length;o--;){var s=i.vms[o];s._proxy(t),s._digest()}return n}function i(e,t){if(a(e,t)){delete e[t];var n=e.__ob__;if(!n)return void(e._isVue&&(delete e._data[t],e._digest()));if(n.dep.notify(),n.vms)for(var r=n.vms.length;r--;){var i=n.vms[r];i._unproxy(t),i._digest()}}}function a(e,t){return Bn.call(e,t)}function o(e){return $n.test(e)}function s(e){var t=(e+"").charCodeAt(0);return 36===t||95===t}function u(e){return null==e?"":e.toString()}function d(e){if("string"!=typeof e)return e;var t=Number(e);return isNaN(t)?e:t}function l(e){return"true"===e||"false"!==e&&e}function c(e){var t=e.charCodeAt(0),n=e.charCodeAt(e.length-1);return t!==n||34!==t&&39!==t?e:e.slice(1,-1)}function h(e){return e.replace(Jn,_)}function _(e,t){return t?t.toUpperCase():""}function f(e){return e.replace(Un,"$1-$2").replace(Un,"$1-$2").toLowerCase()}function m(e){return e.replace(qn,_)}function p(e,t){return function(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}}function g(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function v(e,t){for(var n=Object.keys(t),r=n.length;r--;)e[n[r]]=t[n[r]];return e}function y(e){return null!==e&&"object"==typeof e}function M(e){return Gn.call(e)===Kn}function b(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}function L(e,t){var n,r,i,a,o,s=function s(){var u=Date.now()-a;u<t&&u>=0?n=setTimeout(s,t-u):(n=null,o=e.apply(i,r),n||(i=r=null))};return function(){return i=this,r=arguments,a=Date.now(),n||(n=setTimeout(s,t)),o}}function k(e,t){for(var n=e.length;n--;)if(e[n]===t)return n;return-1}function Y(e){var t=function t(){if(!t.cancelled)return e.apply(this,arguments)};return t.cancel=function(){t.cancelled=!0},t}function x(e,t){return e==t||!(!y(e)||!y(t))&&JSON.stringify(e)===JSON.stringify(t)}function w(e){return/native code/.test(e.toString())}function D(e){this.size=0,this.limit=e,this.head=this.tail=void 0,this._keymap=Object.create(null)}function T(){return mr.charCodeAt(vr+1)}function S(){return mr.charCodeAt(++vr)}function j(){return vr>=gr}function H(){for(;T()===Hr;)S()}function A(e){return e===Dr||e===Tr}function P(e){return Ar[e]}function C(e,t){return Pr[e]===t}function O(){for(var e,t=S();!j();)if(e=S(),e===jr)S();else if(e===t)break}function F(e){for(var t=0,n=e;!j();)if(e=T(),A(e))O();else if(n===e&&t++,C(n,e)&&t--,S(),0===t)break}function W(){for(var e=vr;!j();)if(yr=T(),A(yr))O();else if(P(yr))F(yr);else if(yr===Sr){if(S(),yr=T(),yr!==Sr){Mr!==kr&&Mr!==wr||(Mr=Yr);break}S()}else{if(yr===Hr&&(Mr===xr||Mr===wr)){H();break}Mr===Yr&&(Mr=xr),S()}return mr.slice(e+1,vr)||null}function I(){for(var e=[];!j();)e.push(E());return e}function E(){var e,t={};return Mr=Yr,t.name=W().trim(),Mr=wr,e=z(),e.length&&(t.args=e),t}function z(){for(var e=[];!j()&&Mr!==Yr;){var t=W();if(!t)break;e.push(R(t))}return e}function R(e){if(Lr.test(e))return{value:d(e),dynamic:!1};var t=c(e),n=t===e;return{value:n?e:t,dynamic:n}}function N(e){var t=br.get(e);if(t)return t;mr=e,pr={},gr=mr.length,vr=-1,yr="",Mr=kr;var n;return mr.indexOf("|")<0?pr.expression=mr.trim():(pr.expression=W().trim(),n=I(),n.length&&(pr.filters=n)),br.put(e,pr),pr}function V(e){return e.replace(Or,"\\$&")}function B(){var e=V(Vr.delimiters[0]),t=V(Vr.delimiters[1]),n=V(Vr.unsafeDelimiters[0]),r=V(Vr.unsafeDelimiters[1]);Wr=new RegExp(n+"((?:.|\\n)+?)"+r+"|"+e+"((?:.|\\n)+?)"+t,"g"),Ir=new RegExp("^"+n+"((?:.|\\n)+?)"+r+"$"),Fr=new D(1e3)}function $(e){Fr||B();var t=Fr.get(e);if(t)return t;if(!Wr.test(e))return null;for(var n,r,i,a,o,s,u=[],d=Wr.lastIndex=0;n=Wr.exec(e);)r=n.index,r>d&&u.push({value:e.slice(d,r)}),i=Ir.test(n[0]),a=i?n[1]:n[2],o=a.charCodeAt(0),s=42===o,a=s?a.slice(1):a,u.push({tag:!0,value:a.trim(),html:i,oneTime:s}),d=r+n[0].length;return d<e.length&&u.push({value:e.slice(d)}),Fr.put(e,u),u}function J(e,t){return e.length>1?e.map(function(e){return U(e,t)}).join("+"):U(e[0],t,!0)}function U(e,t,n){return e.tag?e.oneTime&&t?'"'+t.$eval(e.value)+'"':q(e.value,n):'"'+e.value+'"'}function q(e,t){if(Er.test(e)){var n=N(e);return n.filters?"this._applyFilters("+n.expression+",null,"+JSON.stringify(n.filters)+",false)":"("+e+")"}return t?e:"("+e+")"}function G(e,t,n,r){Q(e,1,function(){t.appendChild(e)},n,r)}function K(e,t,n,r){Q(e,1,function(){ie(e,t)},n,r)}function Z(e,t,n){Q(e,-1,function(){oe(e)},t,n)}function Q(e,t,n,r,i){var a=e.__v_trans;if(!a||!a.hooks&&!sr||!r._isCompiled||r.$parent&&!r.$parent._isCompiled)return n(),void(i&&i());var o=t>0?"enter":"leave";a[o](n,i)}function X(e){if("string"==typeof e){e=document.querySelector(e)}return e}function ee(e){if(!e)return!1;var t=e.ownerDocument.documentElement,n=e.parentNode;return t===e||t===n||!(!n||1!==n.nodeType||!t.contains(n))}function te(e,t){var n=e.getAttribute(t);return null!==n&&e.removeAttribute(t),n}function ne(e,t){var n=te(e,":"+t);return null===n&&(n=te(e,"v-bind:"+t)),n}function re(e,t){return e.hasAttribute(t)||e.hasAttribute(":"+t)||e.hasAttribute("v-bind:"+t)}function ie(e,t){t.parentNode.insertBefore(e,t)}function ae(e,t){t.nextSibling?ie(e,t.nextSibling):t.parentNode.appendChild(e)}function oe(e){e.parentNode.removeChild(e)}function se(e,t){t.firstChild?ie(e,t.firstChild):t.appendChild(e)}function ue(e,t){var n=e.parentNode;n&&n.replaceChild(t,e)}function de(e,t,n,r){e.addEventListener(t,n,r)}function le(e,t,n){e.removeEventListener(t,n)}function ce(e){var t=e.className;return"object"==typeof t&&(t=t.baseVal||""),t}function he(e,t){rr&&!/svg$/.test(e.namespaceURI)?e.className=t:e.setAttribute("class",t)}function _e(e,t){if(e.classList)e.classList.add(t);else{var n=" "+ce(e)+" ";n.indexOf(" "+t+" ")<0&&he(e,(n+t).trim())}}function fe(e,t){if(e.classList)e.classList.remove(t);else{for(var n=" "+ce(e)+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");he(e,n.trim())}e.className||e.removeAttribute("class")}function me(e,t){var n,r;if(ve(e)&&ke(e.content)&&(e=e.content),e.hasChildNodes())for(pe(e),r=t?document.createDocumentFragment():document.createElement("div");n=e.firstChild;)r.appendChild(n);return r}function pe(e){for(var t;t=e.firstChild,ge(t);)e.removeChild(t);for(;t=e.lastChild,ge(t);)e.removeChild(t)}function ge(e){return e&&(3===e.nodeType&&!e.data.trim()||8===e.nodeType)}function ve(e){return e.tagName&&"template"===e.tagName.toLowerCase()}function ye(e,t){var n=Vr.debug?document.createComment(e):document.createTextNode(t?" ":"");return n.__v_anchor=!0,n}function Me(e){if(e.hasAttributes())for(var t=e.attributes,n=0,r=t.length;n<r;n++){var i=t[n].name;if(Jr.test(i))return h(i.replace(Jr,""))}}function be(e,t,n){for(var r;e!==t;)r=e.nextSibling,n(e),e=r;n(t)}function Le(e,t,n,r,i){function a(){if(s++,o&&s>=u.length){for(var e=0;e<u.length;e++)r.appendChild(u[e]);i&&i()}}var o=!1,s=0,u=[];be(e,t,function(e){e===t&&(o=!0),u.push(e),Z(e,n,a)})}function ke(e){return e&&11===e.nodeType}function Ye(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}function xe(e,t){var n=e.tagName.toLowerCase(),r=e.hasAttributes();if(Ur.test(n)||qr.test(n)){if(r)return we(e,t)}else{if(Pe(t,"components",n))return{id:n};var i=r&&we(e,t);if(i)return i}}function we(e,t){var n=e.getAttribute("is");if(null!=n){if(Pe(t,"components",n))return e.removeAttribute("is"),{id:n}}else if(n=ne(e,"is"),null!=n)return{id:n,dynamic:!0}}function De(e,t){var n,i,o;for(n in t)i=e[n],o=t[n],a(e,n)?y(i)&&y(o)&&De(i,o):r(e,n,o);return e}function Te(e,t){var n=Object.create(e||null);return t?v(n,He(t)):n}function Se(e){if(e.components)for(var t,n=e.components=He(e.components),r=Object.keys(n),i=0,a=r.length;i<a;i++){var o=r[i];Ur.test(o)||qr.test(o)||(t=n[o],M(t)&&(n[o]=In.extend(t)))}}function je(e){var t,n,r=e.props;if(Zn(r))for(e.props={},t=r.length;t--;)n=r[t],"string"==typeof n?e.props[n]=null:n.name&&(e.props[n.name]=n);else if(M(r)){var i=Object.keys(r);for(t=i.length;t--;)n=r[i[t]],"function"==typeof n&&(r[i[t]]={type:n})}}function He(e){if(Zn(e)){for(var t,n={},r=e.length;r--;){t=e[r];var i="function"==typeof t?t.options&&t.options.name||t.id:t.name||t.id;i&&(n[i]=t)}return n}return e}function Ae(e,t,n){function r(r){var i=Gr[r]||Kr;o[r]=i(e[r],t[r],n,r)}Se(t),je(t);var i,o={};if(t.extends&&(e="function"==typeof t.extends?Ae(e,t.extends.options,n):Ae(e,t.extends,n)),t.mixins)for(var s=0,u=t.mixins.length;s<u;s++){var d=t.mixins[s],l=d.prototype instanceof In?d.options:d;e=Ae(e,l,n)}for(i in e)r(i);for(i in t)a(e,i)||r(i);return o}function Pe(e,t,n,r){if("string"==typeof n){var i,a=e[t],o=a[n]||a[i=h(n)]||a[i.charAt(0).toUpperCase()+i.slice(1)];return o}}function Ce(){this.id=Zr++,this.subs=[]}function Oe(e){ti=!1,e(),ti=!0}function Fe(e){if(this.value=e,this.dep=new Ce,b(e,"__ob__",this),Zn(e)){var t=Qn?We:Ie;t(e,Xr,ei),this.observeArray(e)}else this.walk(e)}function We(e,t){e.__proto__=t}function Ie(e,t,n){for(var r=0,i=n.length;r<i;r++){var a=n[r];b(e,a,t[a])}}function Ee(e,t){if(e&&"object"==typeof e){var n;return a(e,"__ob__")&&e.__ob__ instanceof Fe?n=e.__ob__:ti&&(Zn(e)||M(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new Fe(e)),n&&t&&n.addVm(t),n}}function ze(e,t,n){var r=new Ce,i=Object.getOwnPropertyDescriptor(e,t);if(!i||i.configurable!==!1){var a=i&&i.get,o=i&&i.set,s=Ee(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=a?a.call(e):n;if(Ce.target&&(r.depend(),s&&s.dep.depend(),Zn(t)))for(var i,o=0,u=t.length;o<u;o++)i=t[o],i&&i.__ob__&&i.__ob__.dep.depend();return t},set:function(t){var i=a?a.call(e):n;t!==i&&(o?o.call(e,t):n=t,s=Ee(t),r.notify())}})}}function Re(e){e.prototype._init=function(e){e=e||{},this.$el=null,this.$parent=e.parent,this.$root=this.$parent?this.$parent.$root:this,this.$children=[],this.$refs={},this.$els={},this._watchers=[],this._directives=[],this._uid=ri++,this._isVue=!0,this._events={},this._eventsCount={},this._isFragment=!1,this._fragment=this._fragmentStart=this._fragmentEnd=null,this._isCompiled=this._isDestroyed=this._isReady=this._isAttached=this._isBeingDestroyed=this._vForRemoving=!1,this._unlinkFn=null,this._context=e._context||this.$parent,this._scope=e._scope,this._frag=e._frag,this._frag&&this._frag.children.push(this),this.$parent&&this.$parent.$children.push(this),e=this.$options=Ae(this.constructor.options,e,this),this._updateRef(),this._data={},this._callHook("init"),this._initState(),this._initEvents(),this._callHook("created"),e.el&&this.$mount(e.el)}}function Ne(e){if(void 0===e)return"eof";var t=e.charCodeAt(0);switch(t){case 91:case 93:case 46:case 34:case 39:case 48:return e;case 95:case 36:return"ident";case 32:case 9:case 10:case 13:case 160:case 65279:case 8232:case 8233:return"ws"}return t>=97&&t<=122||t>=65&&t<=90?"ident":t>=49&&t<=57?"number":"else"}function Ve(e){var t=e.trim();return("0"!==e.charAt(0)||!isNaN(e))&&(o(t)?c(t):"*"+t)}function Be(e){function t(){var t=e[l+1];if(c===fi&&"'"===t||c===mi&&'"'===t)return l++,r="\\"+t,_[ai](),!0}var n,r,i,a,o,s,u,d=[],l=-1,c=di,h=0,_=[];for(_[oi]=function(){void 0!==i&&(d.push(i),i=void 0)},_[ai]=function(){void 0===i?i=r:i+=r},_[si]=function(){_[ai](),h++},_[ui]=function(){if(h>0)h--,c=_i,_[ai]();else{if(h=0,i=Ve(i),i===!1)return!1;_[oi]()}};null!=c;)if(l++,n=e[l],"\\"!==n||!t()){if(a=Ne(n),u=vi[c],o=u[a]||u.else||gi,o===gi)return;if(c=o[0],s=_[o[1]],s&&(r=o[2],r=void 0===r?n:r,s()===!1))return;if(c===pi)return d.raw=e,d}}function $e(e){var t=ii.get(e);return t||(t=Be(e),t&&ii.put(e,t)),t}function Je(e,t){return tt(t).get(e)}function Ue(e,t,n){var i=e;if("string"==typeof t&&(t=Be(t)),!t||!y(e))return!1;for(var a,o,s=0,u=t.length;s<u;s++)a=e,o=t[s],"*"===o.charAt(0)&&(o=tt(o.slice(1)).get.call(i,i)),s<u-1?(e=e[o],y(e)||(e={},r(a,o,e))):Zn(e)?e.$set(o,n):o in e?e[o]=n:r(e,o,n);return!0}function qe(){}function Ge(e,t){var n=Ai.length;return Ai[n]=t?e.replace(wi,"\\n"):e,'"'+n+'"'}function Ke(e){var t=e.charAt(0),n=e.slice(1);return Li.test(n)?e:(n=n.indexOf('"')>-1?n.replace(Ti,Ze):n,t+"scope."+n)}function Ze(e,t){return Ai[t]}function Qe(e){Yi.test(e),Ai.length=0;var t=e.replace(Di,Ge).replace(xi,"");return t=(" "+t).replace(ji,Ke).replace(Ti,Ze),Xe(t)}function Xe(e){try{return new Function("scope","return "+e+";")}catch(e){return qe}}function et(e){var t=$e(e);if(t)return function(e,n){Ue(e,t,n)}}function tt(e,t){e=e.trim();var n=Mi.get(e);if(n)return t&&!n.set&&(n.set=et(n.exp)),n;var r={exp:e};return r.get=nt(e)&&e.indexOf("[")<0?Xe("scope."+e):Qe(e),t&&(r.set=et(e)),Mi.put(e,r),r}function nt(e){return Si.test(e)&&!Hi.test(e)&&"Math."!==e.slice(0,5)}function rt(){Ci.length=0,Oi.length=0,Fi={},Wi={},Ii=!1}function it(){for(var e=!0;e;)e=!1,at(Ci),at(Oi),Ci.length?e=!0:(er&&Vr.devtools&&er.emit("flush"),rt())}function at(e){for(var t=0;t<e.length;t++){var n=e[t],r=n.id;Fi[r]=null,n.run()}e.length=0}function ot(e){var t=e.id;if(null==Fi[t]){var n=e.user?Oi:Ci;Fi[t]=n.length,n.push(e),Ii||(Ii=!0,hr(it))}}function st(e,t,n,r){r&&v(this,r);var i="function"==typeof t;if(this.vm=e,e._watchers.push(this),this.expression=t,this.cb=n,this.id=++Ei,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new _r,this.newDepIds=new _r,this.prevError=null,i)this.getter=t,this.setter=void 0;else{var a=tt(t,this.twoWay);this.getter=a.get,this.setter=a.set}this.value=this.lazy?void 0:this.get(),this.queued=this.shallow=!1}function ut(e,t){var n=void 0,r=void 0;t||(t=zi,t.clear());var i=Zn(e),a=y(e);if((i||a)&&Object.isExtensible(e)){if(e.__ob__){var o=e.__ob__.dep.id;if(t.has(o))return;t.add(o)}if(i)for(n=e.length;n--;)ut(e[n],t);else if(a)for(r=Object.keys(e),n=r.length;n--;)ut(e[r[n]],t)}}function dt(e){return ve(e)&&ke(e.content)}function lt(e,t){var n=t?e:e.trim(),r=Ni.get(n);if(r)return r;var i=document.createDocumentFragment(),a=e.match($i),o=Ji.test(e),s=Ui.test(e);if(a||o||s){var u=a&&a[1],d=Bi[u]||Bi.efault,l=d[0],c=d[1],h=d[2],_=document.createElement("div");for(_.innerHTML=c+e+h;l--;)_=_.lastChild;for(var f;f=_.firstChild;)i.appendChild(f)}else i.appendChild(document.createTextNode(e));return t||pe(i),Ni.put(n,i),i}function ct(e){if(dt(e))return lt(e.innerHTML);if("SCRIPT"===e.tagName)return lt(e.textContent);for(var t,n=ht(e),r=document.createDocumentFragment();t=n.firstChild;)r.appendChild(t);return pe(r),r}function ht(e){if(!e.querySelectorAll)return e.cloneNode();var t,n,r,i=e.cloneNode(!0);if(qi){var a=i;if(dt(e)&&(e=e.content,a=i.content),n=e.querySelectorAll("template"),n.length)for(r=a.querySelectorAll("template"),t=r.length;t--;)r[t].parentNode.replaceChild(ht(n[t]),r[t])}if(Gi)if("TEXTAREA"===e.tagName)i.value=e.value;else if(n=e.querySelectorAll("textarea"),n.length)for(r=i.querySelectorAll("textarea"),t=r.length;t--;)r[t].value=n[t].value;return i}function _t(e,t,n){var r,i;return ke(e)?(pe(e),t?ht(e):e):("string"==typeof e?n||"#"!==e.charAt(0)?i=lt(e,n):(i=Vi.get(e),i||(r=document.getElementById(e.slice(1)),r&&(i=ct(r),Vi.put(e,i)))):e.nodeType&&(i=ct(e)),i&&t?ht(i):i)}function ft(e,t,n,r,i,a){this.children=[],this.childFrags=[],this.vm=t,this.scope=i,this.inserted=!1,this.parentFrag=a,a&&a.childFrags.push(this),this.unlink=e(t,n,r,i,this);var o=this.single=1===n.childNodes.length&&!n.childNodes[0].__v_anchor;o?(this.node=n.childNodes[0],this.before=mt,this.remove=pt):(this.node=ye("fragment-start"),this.end=ye("fragment-end"),this.frag=n,se(this.node,n),n.appendChild(this.end),this.before=gt,this.remove=vt),this.node.__v_frag=this}function mt(e,t){this.inserted=!0;var n=t!==!1?K:ie;n(this.node,e,this.vm),ee(this.node)&&this.callHook(yt)}function pt(){this.inserted=!1;var e=ee(this.node),t=this;this.beforeRemove(),Z(this.node,this.vm,function(){e&&t.callHook(Mt),t.destroy()})}function gt(e,t){this.inserted=!0;var n=this.vm,r=t!==!1?K:ie;be(this.node,this.end,function(t){r(t,e,n)}),ee(this.node)&&this.callHook(yt)}function vt(){this.inserted=!1;var e=this,t=ee(this.node);this.beforeRemove(),Le(this.node,this.end,this.vm,this.frag,function(){t&&e.callHook(Mt),e.destroy()})}function yt(e){!e._isAttached&&ee(e.$el)&&e._callHook("attached")}function Mt(e){e._isAttached&&!ee(e.$el)&&e._callHook("detached")}function bt(e,t){this.vm=e;var n,r="string"==typeof t;r||ve(t)&&!t.hasAttribute("v-if")?n=_t(t,!0):(n=document.createDocumentFragment(),n.appendChild(t)),this.template=n;var i,a=e.constructor.cid;if(a>0){var o=a+(r?t:Ye(t));i=Qi.get(o),i||(i=Kt(n,e.$options,!0),Qi.put(o,i))}else i=Kt(n,e.$options,!0);this.linker=i}function Lt(e,t,n){var r=e.node.previousSibling;if(r){for(e=r.__v_frag;!(e&&e.forId===n&&e.inserted||r===t);){if(r=r.previousSibling,!r)return;e=r.__v_frag}return e}}function kt(e){for(var t=-1,n=new Array(Math.floor(e));++t<e;)n[t]=t;return n}function Yt(e,t,n,r){return r?"$index"===r?e:r.charAt(0).match(/\w/)?Je(n,r):n[r]:t||n}function xt(e){var t=e.node;if(e.end)for(;!t.__vue__&&t!==e.end&&t.nextSibling;)t=t.nextSibling;return t.__vue__}function wt(e,t,n){for(var r,i,a,o=t?[]:null,s=0,u=e.options.length;s<u;s++)if(r=e.options[s],a=n?r.hasAttribute("selected"):r.selected){if(i=r.hasOwnProperty("_value")?r._value:r.value,!t)return i;o.push(i)}return o}function Dt(e,t){for(var n=e.length;n--;)if(x(e[n],t))return n;return-1}function Tt(e,t){var n=t.map(function(e){var t=e.charCodeAt(0);return t>47&&t<58?parseInt(e,10):1===e.length&&(t=e.toUpperCase().charCodeAt(0),t>64&&t<91)?t:ya[e]});return n=[].concat.apply([],n),function(t){if(n.indexOf(t.keyCode)>-1)return e.call(this,t)}}function St(e){return function(t){return t.stopPropagation(),e.call(this,t)}}function jt(e){return function(t){return t.preventDefault(),e.call(this,t)}}function Ht(e){return function(t){if(t.target===t.currentTarget)return e.call(this,t)}}function At(e){if(Ya[e])return Ya[e];var t=Pt(e);return Ya[e]=Ya[t]=t,t}function Pt(e){e=f(e);var t=h(e),n=t.charAt(0).toUpperCase()+t.slice(1);xa||(xa=document.createElement("div"));var r,i=ba.length;if("filter"!==t&&t in xa.style)return{kebab:e,camel:t};for(;i--;)if(r=La[i]+n,r in xa.style)return{kebab:ba[i]+e,camel:r}}function Ct(e){var t=[];if(Zn(e))for(var n=0,r=e.length;n<r;n++){var i=e[n];if(i)if("string"==typeof i)t.push(i);else for(var a in i)i[a]&&t.push(a)}else if(y(e))for(var o in e)e[o]&&t.push(o);return t}function Ot(e,t,n){if(t=t.trim(),t.indexOf(" ")===-1)return void n(e,t);for(var r=t.split(/\s+/),i=0,a=r.length;i<a;i++)n(e,r[i])}function Ft(e,t,n){function r(){++a>=i?n():e[a].call(t,r)}var i=e.length,a=0;e[0].call(t,r)}function Wt(e,t,n){for(var r,i,a,s,u,d,l,c=[],_=n.$options.propsData,m=Object.keys(t),p=m.length;p--;)if(i=m[p],r=t[i]||Ra,u=h(i),Na.test(u)){if(l={name:i,path:u,options:r,mode:za.ONE_WAY,raw:null},a=f(i),null===(s=ne(e,a))&&(null!==(s=ne(e,a+".sync"))?l.mode=za.TWO_WAY:null!==(s=ne(e,a+".once"))&&(l.mode=za.ONE_TIME)),null!==s)l.raw=s,d=N(s),s=d.expression,l.filters=d.filters,o(s)&&!d.filters?l.optimizedLiteral=!0:l.dynamic=!0,l.parentPath=s;else if(null!==(s=te(e,a)))l.raw=s;else if(_&&null!==(s=_[i]||_[u]))l.raw=s;else;c.push(l)}return It(c)}function It(e){return function(t,n){t._props={};for(var r,i,o,s,u,h=t.$options.propsData,_=e.length;_--;)if(r=e[_],u=r.raw,i=r.path,o=r.options,t._props[i]=r,h&&a(h,i)&&zt(t,r,h[i]),null===u)zt(t,r,void 0);else if(r.dynamic)r.mode===za.ONE_TIME?(s=(n||t._context||t).$get(r.parentPath),zt(t,r,s)):t._context?t._bindDir({name:"prop",def:Ba,prop:r},null,null,n):zt(t,r,t.$get(r.parentPath));else if(r.optimizedLiteral){var m=c(u);s=m===u?l(d(u)):m,zt(t,r,s)}else s=o.type===Boolean&&(""===u||u===f(r.name))||u,zt(t,r,s)}}function Et(e,t,n,r){var i=t.dynamic&&nt(t.parentPath),a=n;void 0===a&&(a=Nt(e,t)),a=Bt(t,a,e);var o=a!==n;Vt(t,a,e)||(a=void 0),i&&!o?Oe(function(){r(a)}):r(a)}function zt(e,t,n){Et(e,t,n,function(n){ze(e,t.path,n)})}function Rt(e,t,n){Et(e,t,n,function(n){e[t.path]=n})}function Nt(e,t){var n=t.options;if(!a(n,"default"))return n.type!==Boolean&&void 0;var r=n.default;return y(r),"function"==typeof r&&n.type!==Function?r.call(e):r}function Vt(e,t,n){if(!e.options.required&&(null===e.raw||null==t))return!0;var r=e.options,i=r.type,a=!i,o=[];if(i){Zn(i)||(i=[i]);for(var s=0;s<i.length&&!a;s++){var u=$t(t,i[s]);o.push(u.expectedType),a=u.valid}}if(!a)return!1;var d=r.validator;return!(d&&!d(t))}function Bt(e,t,n){var r=e.options.coerce;return r&&"function"==typeof r?r(t):t}function $t(e,t){var n,r;return t===String?(r="string",n=typeof e===r):t===Number?(r="number",n=typeof e===r):t===Boolean?(r="boolean",n=typeof e===r):t===Function?(r="function",n=typeof e===r):t===Object?(r="object",n=M(e)):t===Array?(r="array",n=Zn(e)):n=e instanceof t,{valid:n,expectedType:r}}function Jt(e){$a.push(e),Ja||(Ja=!0,hr(Ut))}function Ut(){for(var e=document.documentElement.offsetHeight,t=0;t<$a.length;t++)$a[t]();return $a=[],Ja=!1,e}function qt(e,t,n,r){this.id=t,this.el=e,this.enterClass=n&&n.enterClass||t+"-enter",this.leaveClass=n&&n.leaveClass||t+"-leave",this.hooks=n,this.vm=r,this.pendingCssEvent=this.pendingCssCb=this.cancel=this.pendingJsCb=this.op=this.cb=null,this.justEntered=!1,this.entered=this.left=!1,this.typeCache={},this.type=n&&n.type;var i=this;["enterNextTick","enterDone","leaveNextTick","leaveDone"].forEach(function(e){i[e]=p(i[e],i)})}function Gt(e){if(/svg$/.test(e.namespaceURI)){var t=e.getBoundingClientRect();return!(t.width||t.height)}return!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)}function Kt(e,t,n){var r=n||!t._asComponent?rn(e,t):null,i=r&&r.terminal||bn(e)||!e.hasChildNodes()?null:ln(e.childNodes,t);return function(e,t,n,a,o){var s=g(t.childNodes),u=Zt(function(){r&&r(e,t,n,a,o),i&&i(e,s,n,a,o)},e);return Xt(e,u)}}function Zt(e,t){t._directives=[];var n=t._directives.length;e();var r=t._directives.slice(n);Qt(r);for(var i=0,a=r.length;i<a;i++)r[i]._bind();return r}function Qt(e){if(0!==e.length){var t,n,r,i,a={},o=0,s=[];for(t=0,n=e.length;t<n;t++){var u=e[t],d=u.descriptor.def.priority||so,l=a[d];l||(l=a[d]=[],s.push(d)),l.push(u)}for(s.sort(function(e,t){return e>t?-1:e===t?0:1}),t=0,n=s.length;t<n;t++){var c=a[s[t]];for(r=0,i=c.length;r<i;r++)e[o++]=c[r]}}}function Xt(e,t,n,r){function i(i){en(e,t,i),n&&r&&en(n,r)}return i.dirs=t,i}function en(e,t,n){for(var r=t.length;r--;)t[r]._teardown()}function tn(e,t,n,r){var i=Wt(t,n,e),a=Zt(function(){i(e,r)},e);return Xt(e,a)}function nn(e,t,n){var r,i,a=t._containerAttrs,o=t._replacerAttrs;if(11!==e.nodeType)t._asComponent?(a&&n&&(r=gn(a,n)),o&&(i=gn(o,t))):i=gn(e.attributes,t);else;return t._containerAttrs=t._replacerAttrs=null,function(e,t,n){var a,o=e._context;o&&r&&(a=Zt(function(){r(o,t,null,n)},o));var s=Zt(function(){i&&i(e,t)},e);return Xt(e,s,o,a)}}function rn(e,t){var n=e.nodeType;return 1!==n||bn(e)?3===n&&e.data.trim()?on(e,t):null:an(e,t)}function an(e,t){if("TEXTAREA"===e.tagName){if(null!==te(e,"v-pre"))return mn;var n=$(e.value);n&&(e.setAttribute(":value",J(n)),e.value="")}var r,i=e.hasAttributes(),a=i&&g(e.attributes);return i&&(r=fn(e,a,t)),r||(r=hn(e,t)),r||(r=_n(e,t)),!r&&i&&(r=gn(a,t)),r}function on(e,t){if(e._skip)return sn;var n=$(e.wholeText);if(!n)return null;for(var r=e.nextSibling;r&&3===r.nodeType;)r._skip=!0,r=r.nextSibling;for(var i,a,o=document.createDocumentFragment(),s=0,u=n.length;s<u;s++)a=n[s],i=a.tag?un(a,t):document.createTextNode(a.value),o.appendChild(i);return dn(n,o,t)}function sn(e,t){oe(t)}function un(e,t){function n(t){if(!e.descriptor){var n=N(e.value);e.descriptor={name:t,def:Wa[t],expression:n.expression,filters:n.filters}}}var r;return e.oneTime?r=document.createTextNode(e.value):e.html?(r=document.createComment("v-html"),n("html")):(r=document.createTextNode(" "),n("text")),r}function dn(e,t){return function(n,r,i,a){for(var o,s,d,l=t.cloneNode(!0),c=g(l.childNodes),h=0,_=e.length;h<_;h++)o=e[h],s=o.value,o.tag&&(d=c[h],o.oneTime?(s=(a||n).$eval(s),o.html?ue(d,_t(s,!0)):d.data=u(s)):n._bindDir(o.descriptor,d,i,a));ue(r,l)}}function ln(e,t){for(var n,r,i,a=[],o=0,s=e.length;o<s;o++)i=e[o],n=rn(i,t),r=n&&n.terminal||"SCRIPT"===i.tagName||!i.hasChildNodes()?null:ln(i.childNodes,t),a.push(n,r);return a.length?cn(a):null}function cn(e){return function(t,n,r,i,a){for(var o,s,u,d=0,l=0,c=e.length;d<c;l++){o=n[l],s=e[d++],u=e[d++];var h=g(o.childNodes);s&&s(t,o,r,i,a),u&&u(t,h,r,i,a)}}}function hn(e,t){var n=e.tagName.toLowerCase();if(!Ur.test(n)){var r=Pe(t,"elementDirectives",n);return r?pn(e,n,"",t,r):void 0}}function _n(e,t){var n=xe(e,t);if(n){var r=Me(e),i={name:"component",ref:r,expression:n.id,def:to.component,modifiers:{literal:!n.dynamic}},a=function(e,t,n,a,o){r&&ze((a||e).$refs,r,null),e._bindDir(i,t,n,a,o)};return a.terminal=!0,a}}function fn(e,t,n){if(null!==te(e,"v-pre"))return mn;if(e.hasAttribute("v-else")){var r=e.previousElementSibling;if(r&&r.hasAttribute("v-if"))return mn}for(var i,a,o,s,u,d,l,c,h,_,f=0,m=t.length;f<m;f++)i=t[f],a=i.name.replace(ao,""),(u=a.match(io))&&(h=Pe(n,"directives",u[1]),h&&h.terminal&&(!_||(h.priority||uo)>_.priority)&&(_=h,l=i.name,s=vn(i.name),o=i.value,d=u[1],c=u[2]));return _?pn(e,d,o,n,_,l,c,s):void 0}function mn(){}function pn(e,t,n,r,i,a,o,s){var u=N(n),d={name:t,arg:o,expression:u.expression,filters:u.filters,raw:n,attr:a,modifiers:s,def:i};"for"!==t&&"router-view"!==t||(d.ref=Me(e));var l=function(e,t,n,r,i){d.ref&&ze((r||e).$refs,d.ref,null),e._bindDir(d,t,n,r,i)};return l.terminal=!0,l}function gn(e,t){function n(e,t,n){var r=n&&Mn(n),i=!r&&N(a);m.push({name:e,attr:o,raw:s,def:t,arg:d,modifiers:l,expression:i&&i.expression,filters:i&&i.filters,interp:n,hasOneTime:r})}for(var r,i,a,o,s,u,d,l,c,h,_,f=e.length,m=[];f--;)if(r=e[f],i=o=r.name,a=s=r.value,h=$(a),d=null,l=vn(i),i=i.replace(ao,""),h)a=J(h),d=i,n("bind",Wa.bind,h);else if(oo.test(i))l.literal=!no.test(i),n("transition",to.transition);else if(ro.test(i))d=i.replace(ro,""),n("on",Wa.on);else if(no.test(i))u=i.replace(no,""),"style"===u||"class"===u?n(u,to[u]):(d=u,n("bind",Wa.bind));else if(_=i.match(io)){if(u=_[1],d=_[2],"else"===u)continue;c=Pe(t,"directives",u,!0),c&&n(u,c)}if(m.length)return yn(m)}function vn(e){var t=Object.create(null),n=e.match(ao);if(n)for(var r=n.length;r--;)t[n[r].slice(1)]=!0;return t}function yn(e){return function(t,n,r,i,a){for(var o=e.length;o--;)t._bindDir(e[o],n,r,i,a)}}function Mn(e){for(var t=e.length;t--;)if(e[t].oneTime)return!0}function bn(e){return"SCRIPT"===e.tagName&&(!e.hasAttribute("type")||"text/javascript"===e.getAttribute("type"))}function Ln(e,t){return t&&(t._containerAttrs=Yn(e)),ve(e)&&(e=_t(e)),t&&(t._asComponent&&!t.template&&(t.template="<slot></slot>"),t.template&&(t._content=me(e),e=kn(e,t))),ke(e)&&(se(ye("v-start",!0),e),e.appendChild(ye("v-end",!0))),e}function kn(e,t){var n=t.template,r=_t(n,!0);if(r){var i=r.firstChild;if(!i)return r;var a=i.tagName&&i.tagName.toLowerCase();return t.replace?(e===document.body,r.childNodes.length>1||1!==i.nodeType||"component"===a||Pe(t,"components",a)||re(i,"is")||Pe(t,"elementDirectives",a)||i.hasAttribute("v-for")||i.hasAttribute("v-if")?r:(t._replacerAttrs=Yn(i),xn(e,i),i)):(e.appendChild(r),e)}}function Yn(e){if(1===e.nodeType&&e.hasAttributes())return g(e.attributes)}function xn(e,t){for(var n,r,i=e.attributes,a=i.length;a--;)n=i[a].name,r=i[a].value,t.hasAttribute(n)||lo.test(n)?"class"===n&&!$(r)&&(r=r.trim())&&r.split(/\s+/).forEach(function(e){_e(t,e)}):t.setAttribute(n,r)}function wn(e,t){if(t){for(var n,r,i=e._slotContents=Object.create(null),a=0,o=t.children.length;a<o;a++)n=t.children[a],(r=n.getAttribute("slot"))&&(i[r]||(i[r]=[])).push(n);for(r in i)i[r]=Dn(i[r],t);if(t.hasChildNodes()){var s=t.childNodes;if(1===s.length&&3===s[0].nodeType&&!s[0].data.trim())return;i.default=Dn(t.childNodes,t)}}}function Dn(e,t){var n=document.createDocumentFragment();e=g(e);for(var r=0,i=e.length;r<i;r++){var a=e[r];!ve(a)||a.hasAttribute("v-if")||a.hasAttribute("v-for")||(t.removeChild(a),a=_t(a,!0)),n.appendChild(a)}return n}function Tn(e){function t(){}function n(e,t){var n=new st(t,e,null,{lazy:!0});return function(){return n.dirty&&n.evaluate(),Ce.target&&n.depend(),n.value}}Object.defineProperty(e.prototype,"$data",{get:function(){return this._data},set:function(e){e!==this._data&&this._setData(e)}}),e.prototype._initState=function(){this._initProps(),this._initMeta(),this._initMethods(),this._initData(),this._initComputed()},e.prototype._initProps=function(){var e=this.$options,t=e.el,n=e.props;t=e.el=X(t),this._propsUnlinkFn=t&&1===t.nodeType&&n?tn(this,t,n,this._scope):null},e.prototype._initData=function(){var e=this.$options.data,t=this._data=e?e():{};M(t)||(t={});var n,r,i=this._props,o=Object.keys(t);for(n=o.length;n--;)r=o[n],i&&a(i,r)||this._proxy(r);Ee(t,this)},e.prototype._setData=function(e){e=e||{};var t=this._data;this._data=e;var n,r,i;for(n=Object.keys(t),i=n.length;i--;)r=n[i],r in e||this._unproxy(r);for(n=Object.keys(e),i=n.length;i--;)r=n[i],a(this,r)||this._proxy(r);t.__ob__.removeVm(this),Ee(e,this),this._digest()},e.prototype._proxy=function(e){if(!s(e)){var t=this;Object.defineProperty(t,e,{configurable:!0,enumerable:!0,get:function(){return t._data[e]},set:function(n){t._data[e]=n}})}},e.prototype._unproxy=function(e){s(e)||delete this[e]},e.prototype._digest=function(){for(var e=0,t=this._watchers.length;e<t;e++)this._watchers[e].update(!0)},e.prototype._initComputed=function(){var e=this.$options.computed;if(e)for(var r in e){var i=e[r],a={enumerable:!0,configurable:!0};"function"==typeof i?(a.get=n(i,this),a.set=t):(a.get=i.get?i.cache!==!1?n(i.get,this):p(i.get,this):t,a.set=i.set?p(i.set,this):t),Object.defineProperty(this,r,a)}},e.prototype._initMethods=function(){var e=this.$options.methods;if(e)for(var t in e)this[t]=p(e[t],this)},e.prototype._initMeta=function(){var e=this.$options._meta;if(e)for(var t in e)ze(this,t,e[t])}}function Sn(e){function t(e,t){for(var n,r,i,a=t.attributes,o=0,s=a.length;o<s;o++)n=a[o].name,ho.test(n)&&(n=n.replace(ho,""),r=a[o].value,nt(r)&&(r+=".apply(this, $arguments)"),i=(e._scope||e._context).$eval(r,!0),i._fromParent=!0,e.$on(n.replace(ho),i))}function n(e,t,n){if(n){var i,a,o,s;for(a in n)if(i=n[a],Zn(i))for(o=0,s=i.length;o<s;o++)r(e,t,a,i[o]);else r(e,t,a,i)}}function r(e,t,n,i,a){var o=typeof i;if("function"===o)e[t](n,i,a);else if("string"===o){var s=e.$options.methods,u=s&&s[i];u&&e[t](n,u,a)}else i&&"object"===o&&r(e,t,n,i.handler,i)}function i(){this._isAttached||(this._isAttached=!0,this.$children.forEach(a))}function a(e){!e._isAttached&&ee(e.$el)&&e._callHook("attached")}function o(){this._isAttached&&(this._isAttached=!1,this.$children.forEach(s))}function s(e){e._isAttached&&!ee(e.$el)&&e._callHook("detached")}e.prototype._initEvents=function(){var e=this.$options;e._asComponent&&t(this,e.el),n(this,"$on",e.events),n(this,"$watch",e.watch)},e.prototype._initDOMHooks=function(){this.$on("hook:attached",i),this.$on("hook:detached",o)},e.prototype._callHook=function(e){this.$emit("pre-hook:"+e);var t=this.$options[e];if(t)for(var n=0,r=t.length;n<r;n++)t[n].call(this);this.$emit("hook:"+e)}}function jn(){}function Hn(e,t,n,r,i,a){this.vm=t,this.el=n,this.descriptor=e,this.name=e.name,this.expression=e.expression,this.arg=e.arg,this.modifiers=e.modifiers,this.filters=e.filters,this.literal=this.modifiers&&this.modifiers.literal,this._locked=!1,this._bound=!1,this._listeners=null,this._host=r,this._scope=i,this._frag=a}function An(e){e.prototype._updateRef=function(e){var t=this.$options._ref;if(t){var n=(this._scope||this._context).$refs;e?n[t]===this&&(n[t]=null):n[t]=this}},e.prototype._compile=function(e){var t=this.$options,n=e;if(e=Ln(e,t),this._initElement(e),1!==e.nodeType||null===te(e,"v-pre")){var r=this._context&&this._context.$options,i=nn(e,t,r);wn(this,t._content);var a,o=this.constructor;t._linkerCachable&&(a=o.linker,a||(a=o.linker=Kt(e,t)));var s=i(this,e,this._scope),u=a?a(this,e):Kt(e,t)(this,e);this._unlinkFn=function(){s(),u(!0)},t.replace&&ue(n,e),this._isCompiled=!0,this._callHook("compiled")}},e.prototype._initElement=function(e){
ke(e)?(this._isFragment=!0,this.$el=this._fragmentStart=e.firstChild,this._fragmentEnd=e.lastChild,3===this._fragmentStart.nodeType&&(this._fragmentStart.data=this._fragmentEnd.data=""),this._fragment=e):this.$el=e,this.$el.__vue__=this,this._callHook("beforeCompile")},e.prototype._bindDir=function(e,t,n,r,i){this._directives.push(new Hn(e,this,t,n,r,i))},e.prototype._destroy=function(e,t){if(this._isBeingDestroyed)return void(t||this._cleanup());var n,r,i=this,a=function(){!n||r||t||i._cleanup()};e&&this.$el&&(r=!0,this.$remove(function(){r=!1,a()})),this._callHook("beforeDestroy"),this._isBeingDestroyed=!0;var o,s=this.$parent;for(s&&!s._isBeingDestroyed&&(s.$children.$remove(this),this._updateRef(!0)),o=this.$children.length;o--;)this.$children[o].$destroy();for(this._propsUnlinkFn&&this._propsUnlinkFn(),this._unlinkFn&&this._unlinkFn(),o=this._watchers.length;o--;)this._watchers[o].teardown();this.$el&&(this.$el.__vue__=null),n=!0,a()},e.prototype._cleanup=function(){this._isDestroyed||(this._frag&&this._frag.children.$remove(this),this._data&&this._data.__ob__&&this._data.__ob__.removeVm(this),this.$el=this.$parent=this.$root=this.$children=this._watchers=this._context=this._scope=this._directives=null,this._isDestroyed=!0,this._callHook("destroyed"),this.$off())}}function Pn(e){e.prototype._applyFilters=function(e,t,n,r){var i,a,o,s,u,d,l,c,h;for(d=0,l=n.length;d<l;d++)if(i=n[r?l-d-1:d],a=Pe(this.$options,"filters",i.name,!0),a&&(a=r?a.write:a.read||a,"function"==typeof a)){if(o=r?[e,t]:[e],u=r?2:1,i.args)for(c=0,h=i.args.length;c<h;c++)s=i.args[c],o[c+u]=s.dynamic?this.$get(s.value):s.value;e=a.apply(this,o)}return e},e.prototype._resolveComponent=function(t,n){var r;if(r="function"==typeof t?t:Pe(this.$options,"components",t,!0))if(r.options)n(r);else if(r.resolved)n(r.resolved);else if(r.requested)r.pendingCallbacks.push(n);else{r.requested=!0;var i=r.pendingCallbacks=[n];r.call(this,function(t){M(t)&&(t=e.extend(t)),r.resolved=t;for(var n=0,a=i.length;n<a;n++)i[n](t)},function(e){})}}}function Cn(e){function t(e){return JSON.parse(JSON.stringify(e))}e.prototype.$get=function(e,t){var n=tt(e);if(n){if(t){var r=this;return function(){r.$arguments=g(arguments);var e=n.get.call(r,r);return r.$arguments=null,e}}try{return n.get.call(this,this)}catch(e){}}},e.prototype.$set=function(e,t){var n=tt(e,!0);n&&n.set&&n.set.call(this,this,t)},e.prototype.$delete=function(e){i(this._data,e)},e.prototype.$watch=function(e,t,n){var r,i=this;"string"==typeof e&&(r=N(e),e=r.expression);var a=new st(i,e,t,{deep:n&&n.deep,sync:n&&n.sync,filters:r&&r.filters,user:!n||n.user!==!1});return n&&n.immediate&&t.call(i,a.value),function(){a.teardown()}},e.prototype.$eval=function(e,t){if(_o.test(e)){var n=N(e),r=this.$get(n.expression,t);return n.filters?this._applyFilters(r,null,n.filters):r}return this.$get(e,t)},e.prototype.$interpolate=function(e){var t=$(e),n=this;return t?1===t.length?n.$eval(t[0].value)+"":t.map(function(e){return e.tag?n.$eval(e.value):e.value}).join(""):e},e.prototype.$log=function(e){var n=e?Je(this._data,e):this._data;if(n&&(n=t(n)),!e){var r;for(r in this.$options.computed)n[r]=t(this[r]);if(this._props)for(r in this._props)n[r]=t(this[r])}console.log(n)}}function On(e){function t(e,t,r,i,a,o){t=n(t);var s=!ee(t),u=i===!1||s?a:o,d=!s&&!e._isAttached&&!ee(e.$el);return e._isFragment?(be(e._fragmentStart,e._fragmentEnd,function(n){u(n,t,e)}),r&&r()):u(e.$el,t,e,r),d&&e._callHook("attached"),e}function n(e){return"string"==typeof e?document.querySelector(e):e}function r(e,t,n,r){t.appendChild(e),r&&r()}function i(e,t,n,r){ie(e,t),r&&r()}function a(e,t,n){oe(e),n&&n()}e.prototype.$nextTick=function(e){hr(e,this)},e.prototype.$appendTo=function(e,n,i){return t(this,e,n,i,r,G)},e.prototype.$prependTo=function(e,t,r){return e=n(e),e.hasChildNodes()?this.$before(e.firstChild,t,r):this.$appendTo(e,t,r),this},e.prototype.$before=function(e,n,r){return t(this,e,n,r,i,K)},e.prototype.$after=function(e,t,r){return e=n(e),e.nextSibling?this.$before(e.nextSibling,t,r):this.$appendTo(e.parentNode,t,r),this},e.prototype.$remove=function(e,t){if(!this.$el.parentNode)return e&&e();var n=this._isAttached&&ee(this.$el);n||(t=!1);var r=this,i=function(){n&&r._callHook("detached"),e&&e()};if(this._isFragment)Le(this._fragmentStart,this._fragmentEnd,this,this._fragment,i);else{var o=t===!1?a:Z;o(this.$el,this,i)}return this}}function Fn(e){function t(e,t,r){var i=e.$parent;if(i&&r&&!n.test(t))for(;i;)i._eventsCount[t]=(i._eventsCount[t]||0)+r,i=i.$parent}e.prototype.$on=function(e,n){return(this._events[e]||(this._events[e]=[])).push(n),t(this,e,1),this},e.prototype.$once=function(e,t){function n(){r.$off(e,n),t.apply(this,arguments)}var r=this;return n.fn=t,this.$on(e,n),this},e.prototype.$off=function(e,n){var r;if(!arguments.length){if(this.$parent)for(e in this._events)r=this._events[e],r&&t(this,e,-r.length);return this._events={},this}if(r=this._events[e],!r)return this;if(1===arguments.length)return t(this,e,-r.length),this._events[e]=null,this;for(var i,a=r.length;a--;)if(i=r[a],i===n||i.fn===n){t(this,e,-1),r.splice(a,1);break}return this},e.prototype.$emit=function(e){var t="string"==typeof e;e=t?e:e.name;var n=this._events[e],r=t||!n;if(n){n=n.length>1?g(n):n;var i=t&&n.some(function(e){return e._fromParent});i&&(r=!1);for(var a=g(arguments,1),o=0,s=n.length;o<s;o++){var u=n[o],d=u.apply(this,a);d!==!0||i&&!u._fromParent||(r=!0)}}return r},e.prototype.$broadcast=function(e){var t="string"==typeof e;if(e=t?e:e.name,this._eventsCount[e]){var n=this.$children,r=g(arguments);t&&(r[0]={name:e,source:this});for(var i=0,a=n.length;i<a;i++){var o=n[i],s=o.$emit.apply(o,r);s&&o.$broadcast.apply(o,r)}return this}},e.prototype.$dispatch=function(e){var t=this.$emit.apply(this,arguments);if(t){var n=this.$parent,r=g(arguments);for(r[0]={name:e,source:this};n;)t=n.$emit.apply(n,r),n=t?n.$parent:null;return this}};var n=/^hook:/}function Wn(e){function t(){this._isAttached=!0,this._isReady=!0,this._callHook("ready")}e.prototype.$mount=function(e){if(!this._isCompiled)return e=X(e),e||(e=document.createElement("div")),this._compile(e),this._initDOMHooks(),ee(this.$el)?(this._callHook("attached"),t.call(this)):this.$once("hook:attached",t),this},e.prototype.$destroy=function(e,t){this._destroy(e,t)},e.prototype.$compile=function(e,t,n,r){return Kt(e,this.$options,!0)(this,e,t,n,r)}}function In(e){this._init(e)}function En(e,t,n){return n=n?parseInt(n,10):0,t=d(t),"number"==typeof t?e.slice(n,n+t):e}function zn(e,t,n){if(e=go(e),null==t)return e;if("function"==typeof t)return e.filter(t);t=(""+t).toLowerCase();for(var r,i,a,o,s="in"===n?3:2,u=Array.prototype.concat.apply([],g(arguments,s)),d=[],l=0,c=e.length;l<c;l++)if(r=e[l],a=r&&r.$value||r,o=u.length){for(;o--;)if(i=u[o],"$key"===i&&Nn(r.$key,t)||Nn(Je(a,i),t)){d.push(r);break}}else Nn(r,t)&&d.push(r);return d}function Rn(e){function t(e,t,n){var i=r[n];return i&&("$key"!==i&&(y(e)&&"$value"in e&&(e=e.$value),y(t)&&"$value"in t&&(t=t.$value)),e=y(e)?Je(e,i):e,t=y(t)?Je(t,i):t),e===t?0:e>t?a:-a}var n=null,r=void 0;e=go(e);var i=g(arguments,1),a=i[i.length-1];"number"==typeof a?(a=a<0?-1:1,i=i.length>1?i.slice(0,-1):i):a=1;var o=i[0];return o?("function"==typeof o?n=function(e,t){return o(e,t)*a}:(r=Array.prototype.concat.apply([],i),n=function(e,i,a){return a=a||0,a>=r.length-1?t(e,i,a):t(e,i,a)||n(e,i,a+1)}),e.slice().sort(n)):e}function Nn(e,t){var n;if(M(e)){var r=Object.keys(e);for(n=r.length;n--;)if(Nn(e[r[n]],t))return!0}else if(Zn(e)){for(n=e.length;n--;)if(Nn(e[n],t))return!0}else if(null!=e)return e.toString().toLowerCase().indexOf(t)>-1}function Vn(e){function t(e){return new Function("return function "+m(e)+" (options) { this._init(options) }")()}e.options={directives:Wa,elementDirectives:po,filters:yo,transitions:{},components:{},partials:{},replace:!0},e.util=ni,e.config=Vr,e.set=r,e.delete=i,e.nextTick=hr,e.compiler=co,e.FragmentFactory=bt,e.internalDirectives=to,e.parsers={path:yi,text:zr,template:Ki,directive:Cr,expression:Pi},e.cid=0;var n=1;e.extend=function(e){e=e||{};var r=this,i=0===r.cid;if(i&&e._Ctor)return e._Ctor;var a=e.name||r.options.name,o=t(a||"VueComponent");return o.prototype=Object.create(r.prototype),o.prototype.constructor=o,o.cid=n++,o.options=Ae(r.options,e),o.super=r,o.extend=r.extend,Vr._assetTypes.forEach(function(e){o[e]=r[e]}),a&&(o.options.components[a]=o),i&&(e._Ctor=o),o},e.use=function(e){if(!e.installed){var t=g(arguments,1);return t.unshift(this),"function"==typeof e.install?e.install.apply(e,t):e.apply(null,t),e.installed=!0,this}},e.mixin=function(t){e.options=Ae(e.options,t)},Vr._assetTypes.forEach(function(t){e[t]=function(n,r){return r?("component"===t&&M(r)&&(r.name||(r.name=n),r=e.extend(r)),this.options[t+"s"][n]=r,r):this.options[t+"s"][n]}}),v(e.transition,$r)}var Bn=Object.prototype.hasOwnProperty,$n=/^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/,Jn=/-(\w)/g,Un=/([^-])([A-Z])/g,qn=/(?:^|[-_\/])(\w)/g,Gn=Object.prototype.toString,Kn="[object Object]",Zn=Array.isArray,Qn="__proto__"in{},Xn="undefined"!=typeof window&&"[object Object]"!==Object.prototype.toString.call(window),er=Xn&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__,tr=Xn&&window.navigator.userAgent.toLowerCase(),nr=tr&&tr.indexOf("trident")>0,rr=tr&&tr.indexOf("msie 9.0")>0,ir=tr&&tr.indexOf("android")>0,ar=tr&&/iphone|ipad|ipod|ios/.test(tr),or=void 0,sr=void 0,ur=void 0,dr=void 0;if(Xn&&!rr){var lr=void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend,cr=void 0===window.onanimationend&&void 0!==window.onwebkitanimationend;or=lr?"WebkitTransition":"transition",sr=lr?"webkitTransitionEnd":"transitionend",ur=cr?"WebkitAnimation":"animation",dr=cr?"webkitAnimationEnd":"animationend"}var hr=function(){function e(){n=!1;var e=t.slice(0);t.length=0;for(var r=0;r<e.length;r++)e[r]()}var t=[],n=!1,r=void 0;if("undefined"!=typeof Promise&&w(Promise)){var i=Promise.resolve(),a=function(){};r=function(){i.then(e),ar&&setTimeout(a)}}else if("undefined"!=typeof MutationObserver){var o=1,s=new MutationObserver(e),u=document.createTextNode(String(o));s.observe(u,{characterData:!0}),r=function(){o=(o+1)%2,u.data=String(o)}}else r=setTimeout;return function(i,a){var o=a?function(){i.call(a)}:i;t.push(o),n||(n=!0,r(e,0))}}(),_r=void 0;"undefined"!=typeof Set&&w(Set)?_r=Set:(_r=function(){this.set=Object.create(null)},_r.prototype.has=function(e){return void 0!==this.set[e]},_r.prototype.add=function(e){this.set[e]=1},_r.prototype.clear=function(){this.set=Object.create(null)});var fr=D.prototype;fr.put=function(e,t){var n,r=this.get(e,!0);return r||(this.size===this.limit&&(n=this.shift()),r={key:e},this._keymap[e]=r,this.tail?(this.tail.newer=r,r.older=this.tail):this.head=r,this.tail=r,this.size++),r.value=t,n},fr.shift=function(){var e=this.head;return e&&(this.head=this.head.newer,this.head.older=void 0,e.newer=e.older=void 0,this._keymap[e.key]=void 0,this.size--),e},fr.get=function(e,t){var n=this._keymap[e];if(void 0!==n)return n===this.tail?t?n:n.value:(n.newer&&(n===this.head&&(this.head=n.newer),n.newer.older=n.older),n.older&&(n.older.newer=n.newer),n.newer=void 0,n.older=this.tail,this.tail&&(this.tail.newer=n),this.tail=n,t?n:n.value)};var mr,pr,gr,vr,yr,Mr,br=new D(1e3),Lr=/^in$|^-?\d+/,kr=0,Yr=1,xr=2,wr=3,Dr=34,Tr=39,Sr=124,jr=92,Hr=32,Ar={91:1,123:1,40:1},Pr={91:93,123:125,40:41},Cr=Object.freeze({parseDirective:N}),Or=/[-.*+?^${}()|[\]\/\\]/g,Fr=void 0,Wr=void 0,Ir=void 0,Er=/[^|]\|[^|]/,zr=Object.freeze({compileRegex:B,parseText:$,tokensToExp:J}),Rr=["{{","}}"],Nr=["{{{","}}}"],Vr=Object.defineProperties({debug:!1,silent:!1,async:!0,warnExpressionErrors:!0,devtools:!1,_delimitersChanged:!0,_assetTypes:["component","directive","elementDirective","filter","transition","partial"],_propBindingModes:{ONE_WAY:0,TWO_WAY:1,ONE_TIME:2},_maxUpdateCount:100},{delimiters:{get:function(){return Rr},set:function(e){Rr=e,B()},configurable:!0,enumerable:!0},unsafeDelimiters:{get:function(){return Nr},set:function(e){Nr=e,B()},configurable:!0,enumerable:!0}}),Br=void 0,$r=Object.freeze({appendWithTransition:G,beforeWithTransition:K,removeWithTransition:Z,applyTransition:Q}),Jr=/^v-ref:/,Ur=/^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i,qr=/^(slot|partial|component)$/i,Gr=Vr.optionMergeStrategies=Object.create(null);Gr.data=function(e,t,n){return n?e||t?function(){var r="function"==typeof t?t.call(n):t,i="function"==typeof e?e.call(n):void 0;return r?De(r,i):i}:void 0:t?"function"!=typeof t?e:e?function(){return De(t.call(this),e.call(this))}:t:e},Gr.el=function(e,t,n){if(n||!t||"function"==typeof t){var r=t||e;return n&&"function"==typeof r?r.call(n):r}},Gr.init=Gr.created=Gr.ready=Gr.attached=Gr.detached=Gr.beforeCompile=Gr.compiled=Gr.beforeDestroy=Gr.destroyed=Gr.activate=function(e,t){return t?e?e.concat(t):Zn(t)?t:[t]:e},Vr._assetTypes.forEach(function(e){Gr[e+"s"]=Te}),Gr.watch=Gr.events=function(e,t){if(!t)return e;if(!e)return t;var n={};v(n,e);for(var r in t){var i=n[r],a=t[r];i&&!Zn(i)&&(i=[i]),n[r]=i?i.concat(a):[a]}return n},Gr.props=Gr.methods=Gr.computed=function(e,t){if(!t)return e;if(!e)return t;var n=Object.create(null);return v(n,e),v(n,t),n};var Kr=function(e,t){return void 0===t?e:t},Zr=0;Ce.target=null,Ce.prototype.addSub=function(e){this.subs.push(e)},Ce.prototype.removeSub=function(e){this.subs.$remove(e)},Ce.prototype.depend=function(){Ce.target.addDep(this)},Ce.prototype.notify=function(){for(var e=g(this.subs),t=0,n=e.length;t<n;t++)e[t].update()};var Qr=Array.prototype,Xr=Object.create(Qr);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=Qr[e];b(Xr,e,function(){for(var n=arguments.length,r=new Array(n);n--;)r[n]=arguments[n];var i,a=t.apply(this,r),o=this.__ob__;switch(e){case"push":i=r;break;case"unshift":i=r;break;case"splice":i=r.slice(2)}return i&&o.observeArray(i),o.dep.notify(),a})}),b(Qr,"$set",function(e,t){return e>=this.length&&(this.length=Number(e)+1),this.splice(e,1,t)[0]}),b(Qr,"$remove",function(e){if(this.length){var t=k(this,e);return t>-1?this.splice(t,1):void 0}});var ei=Object.getOwnPropertyNames(Xr),ti=!0;Fe.prototype.walk=function(e){for(var t=Object.keys(e),n=0,r=t.length;n<r;n++)this.convert(t[n],e[t[n]])},Fe.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ee(e[t])},Fe.prototype.convert=function(e,t){ze(this.value,e,t)},Fe.prototype.addVm=function(e){(this.vms||(this.vms=[])).push(e)},Fe.prototype.removeVm=function(e){this.vms.$remove(e)};var ni=Object.freeze({defineReactive:ze,set:r,del:i,hasOwn:a,isLiteral:o,isReserved:s,_toString:u,toNumber:d,toBoolean:l,stripQuotes:c,camelize:h,hyphenate:f,classify:m,bind:p,toArray:g,extend:v,isObject:y,isPlainObject:M,def:b,debounce:L,indexOf:k,cancellable:Y,looseEqual:x,isArray:Zn,hasProto:Qn,inBrowser:Xn,devtools:er,isIE:nr,isIE9:rr,isAndroid:ir,isIOS:ar,get transitionProp(){return or},get transitionEndEvent(){return sr},get animationProp(){return ur},get animationEndEvent(){return dr},nextTick:hr,get _Set(){return _r},query:X,inDoc:ee,getAttr:te,getBindAttr:ne,hasBindAttr:re,before:ie,after:ae,remove:oe,prepend:se,replace:ue,on:de,off:le,setClass:he,addClass:_e,removeClass:fe,extractContent:me,trimNode:pe,isTemplate:ve,createAnchor:ye,findRef:Me,mapNodeRange:be,removeNodeRange:Le,isFragment:ke,getOuterHTML:Ye,mergeOptions:Ae,resolveAsset:Pe,checkComponentAttr:xe,commonTagRE:Ur,reservedTagRE:qr,get warn(){return Br}}),ri=0,ii=new D(1e3),ai=0,oi=1,si=2,ui=3,di=0,li=1,ci=2,hi=3,_i=4,fi=5,mi=6,pi=7,gi=8,vi=[];vi[di]={ws:[di],ident:[hi,ai],"[":[_i],eof:[pi]},vi[li]={ws:[li],".":[ci],"[":[_i],eof:[pi]},vi[ci]={ws:[ci],ident:[hi,ai]},vi[hi]={ident:[hi,ai],0:[hi,ai],number:[hi,ai],ws:[li,oi],".":[ci,oi],"[":[_i,oi],eof:[pi,oi]},vi[_i]={"'":[fi,ai],'"':[mi,ai],"[":[_i,si],"]":[li,ui],eof:gi,else:[_i,ai]},vi[fi]={"'":[_i,ai],eof:gi,else:[fi,ai]},vi[mi]={'"':[_i,ai],eof:gi,else:[mi,ai]};var yi=Object.freeze({parsePath:$e,getPath:Je,setPath:Ue}),Mi=new D(1e3),bi="Math,Date,this,true,false,null,undefined,Infinity,NaN,isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,parseInt,parseFloat",Li=new RegExp("^("+bi.replace(/,/g,"\\b|")+"\\b)"),ki="break,case,class,catch,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,let,return,super,switch,throw,try,var,while,with,yield,enum,await,implements,package,protected,static,interface,private,public",Yi=new RegExp("^("+ki.replace(/,/g,"\\b|")+"\\b)"),xi=/\s/g,wi=/\n/g,Di=/[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g,Ti=/"(\d+)"/g,Si=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/,ji=/[^\w$\.](?:[A-Za-z_$][\w$]*)/g,Hi=/^(?:true|false|null|undefined|Infinity|NaN)$/,Ai=[],Pi=Object.freeze({parseExpression:tt,isSimplePath:nt}),Ci=[],Oi=[],Fi={},Wi={},Ii=!1,Ei=0;st.prototype.get=function(){this.beforeGet();var e,t=this.scope||this.vm;try{e=this.getter.call(t,t)}catch(e){}return this.deep&&ut(e),this.preProcess&&(e=this.preProcess(e)),this.filters&&(e=t._applyFilters(e,null,this.filters,!1)),this.postProcess&&(e=this.postProcess(e)),this.afterGet(),e},st.prototype.set=function(e){var t=this.scope||this.vm;this.filters&&(e=t._applyFilters(e,this.value,this.filters,!0));try{this.setter.call(t,t,e)}catch(e){}var n=t.$forContext;if(n&&n.alias===this.expression){if(n.filters)return;n._withLock(function(){t.$key?n.rawValue[t.$key]=e:n.rawValue.$set(t.$index,e)})}},st.prototype.beforeGet=function(){Ce.target=this},st.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},st.prototype.afterGet=function(){Ce.target=null;for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},st.prototype.update=function(e){this.lazy?this.dirty=!0:this.sync||!Vr.async?this.run():(this.shallow=this.queued?!!e&&this.shallow:!!e,this.queued=!0,ot(this))},st.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||(y(e)||this.deep)&&!this.shallow){var t=this.value;this.value=e;this.prevError;this.cb.call(this.vm,e,t)}this.queued=this.shallow=!1}},st.prototype.evaluate=function(){var e=Ce.target;this.value=this.get(),this.dirty=!1,Ce.target=e},st.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},st.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||this.vm._vForRemoving||this.vm._watchers.$remove(this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1,this.vm=this.cb=this.value=null}};var zi=new _r,Ri={bind:function(){this.attr=3===this.el.nodeType?"data":"textContent"},update:function(e){this.el[this.attr]=u(e)}},Ni=new D(1e3),Vi=new D(1e3),Bi={efault:[0,"",""],legend:[1,"<fieldset>","</fieldset>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"]};Bi.td=Bi.th=[3,"<table><tbody><tr>","</tr></tbody></table>"],Bi.option=Bi.optgroup=[1,'<select multiple="multiple">',"</select>"],Bi.thead=Bi.tbody=Bi.colgroup=Bi.caption=Bi.tfoot=[1,"<table>","</table>"],Bi.g=Bi.defs=Bi.symbol=Bi.use=Bi.image=Bi.text=Bi.circle=Bi.ellipse=Bi.line=Bi.path=Bi.polygon=Bi.polyline=Bi.rect=[1,'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:ev="http://www.w3.org/2001/xml-events"version="1.1">',"</svg>"];var $i=/<([\w:-]+)/,Ji=/&#?\w+?;/,Ui=/<!--/,qi=function(){if(Xn){var e=document.createElement("div");return e.innerHTML="<template>1</template>",!e.cloneNode(!0).firstChild.innerHTML}return!1}(),Gi=function(){if(Xn){var e=document.createElement("textarea");return e.placeholder="t","t"===e.cloneNode(!0).value}return!1}(),Ki=Object.freeze({cloneNode:ht,parseTemplate:_t}),Zi={bind:function(){8===this.el.nodeType&&(this.nodes=[],this.anchor=ye("v-html"),ue(this.el,this.anchor))},update:function(e){e=u(e),this.nodes?this.swap(e):this.el.innerHTML=e},swap:function(e){for(var t=this.nodes.length;t--;)oe(this.nodes[t]);var n=_t(e,!0,!0);this.nodes=g(n.childNodes),ie(n,this.anchor)}};ft.prototype.callHook=function(e){var t,n;for(t=0,n=this.childFrags.length;t<n;t++)this.childFrags[t].callHook(e);for(t=0,n=this.children.length;t<n;t++)e(this.children[t])},ft.prototype.beforeRemove=function(){var e,t;for(e=0,t=this.childFrags.length;e<t;e++)this.childFrags[e].beforeRemove(!1);for(e=0,t=this.children.length;e<t;e++)this.children[e].$destroy(!1,!0);var n=this.unlink.dirs;for(e=0,t=n.length;e<t;e++)n[e]._watcher&&n[e]._watcher.teardown()},ft.prototype.destroy=function(){this.parentFrag&&this.parentFrag.childFrags.$remove(this),this.node.__v_frag=null,this.unlink()};var Qi=new D(5e3);bt.prototype.create=function(e,t,n){var r=ht(this.template);return new ft(this.linker,this.vm,r,e,t,n)};var Xi=700,ea=800,ta=850,na=1100,ra=1500,ia=1500,aa=1750,oa=2100,sa=2200,ua=2300,da=0,la={priority:sa,terminal:!0,params:["track-by","stagger","enter-stagger","leave-stagger"],bind:function(){var e=this.expression.match(/(.*) (?:in|of) (.*)/);if(e){var t=e[1].match(/\((.*),(.*)\)/);t?(this.iterator=t[1].trim(),this.alias=t[2].trim()):this.alias=e[1].trim(),this.expression=e[2]}if(this.alias){this.id="__v-for__"+ ++da;var n=this.el.tagName;this.isOption=("OPTION"===n||"OPTGROUP"===n)&&"SELECT"===this.el.parentNode.tagName,this.start=ye("v-for-start"),this.end=ye("v-for-end"),ue(this.el,this.end),ie(this.start,this.end),this.cache=Object.create(null),this.factory=new bt(this.vm,this.el)}},update:function(e){this.diff(e),this.updateRef(),this.updateModel()},diff:function(e){var t,n,r,i,o,s,u=e[0],d=this.fromObject=y(u)&&a(u,"$key")&&a(u,"$value"),l=this.params.trackBy,c=this.frags,h=this.frags=new Array(e.length),_=this.alias,f=this.iterator,m=this.start,p=this.end,g=ee(m),v=!c;for(t=0,n=e.length;t<n;t++)u=e[t],i=d?u.$key:null,o=d?u.$value:u,s=!y(o),r=!v&&this.getCachedFrag(o,t,i),r?(r.reused=!0,r.scope.$index=t,i&&(r.scope.$key=i),f&&(r.scope[f]=null!==i?i:t),(l||d||s)&&Oe(function(){r.scope[_]=o})):(r=this.create(o,_,t,i),r.fresh=!v),h[t]=r,v&&r.before(p);if(!v){var M=0,b=c.length-h.length;for(this.vm._vForRemoving=!0,t=0,n=c.length;t<n;t++)r=c[t],r.reused||(this.deleteCachedFrag(r),this.remove(r,M++,b,g));this.vm._vForRemoving=!1,M&&(this.vm._watchers=this.vm._watchers.filter(function(e){return e.active}));var L,k,Y,x=0;for(t=0,n=h.length;t<n;t++)r=h[t],L=h[t-1],k=L?L.staggerCb?L.staggerAnchor:L.end||L.node:m,r.reused&&!r.staggerCb?(Y=Lt(r,m,this.id),Y===L||Y&&Lt(Y,m,this.id)===L||this.move(r,k)):this.insert(r,x++,k,g),r.reused=r.fresh=!1}},create:function(e,t,n,r){var i=this._host,a=this._scope||this.vm,o=Object.create(a);o.$refs=Object.create(a.$refs),o.$els=Object.create(a.$els),o.$parent=a,o.$forContext=this,Oe(function(){ze(o,t,e)}),ze(o,"$index",n),r?ze(o,"$key",r):o.$key&&b(o,"$key",null),this.iterator&&ze(o,this.iterator,null!==r?r:n);var s=this.factory.create(i,o,this._frag);return s.forId=this.id,this.cacheFrag(e,s,n,r),s},updateRef:function(){var e=this.descriptor.ref;if(e){var t,n=(this._scope||this.vm).$refs;this.fromObject?(t={},this.frags.forEach(function(e){t[e.scope.$key]=xt(e)})):t=this.frags.map(xt),n[e]=t}},updateModel:function(){if(this.isOption){var e=this.start.parentNode,t=e&&e.__v_model;t&&t.forceUpdate()}},insert:function(e,t,n,r){e.staggerCb&&(e.staggerCb.cancel(),e.staggerCb=null);var i=this.getStagger(e,t,null,"enter");if(r&&i){var a=e.staggerAnchor;a||(a=e.staggerAnchor=ye("stagger-anchor"),a.__v_frag=e),ae(a,n);var o=e.staggerCb=Y(function(){e.staggerCb=null,e.before(a),oe(a)});setTimeout(o,i)}else{var s=n.nextSibling;s||(ae(this.end,n),s=this.end),e.before(s)}},remove:function(e,t,n,r){if(e.staggerCb)return e.staggerCb.cancel(),void(e.staggerCb=null);var i=this.getStagger(e,t,n,"leave");if(r&&i){var a=e.staggerCb=Y(function(){e.staggerCb=null,e.remove()});setTimeout(a,i)}else e.remove()},move:function(e,t){t.nextSibling||this.end.parentNode.appendChild(this.end),e.before(t.nextSibling,!1)},cacheFrag:function(e,t,n,r){var i,o=this.params.trackBy,s=this.cache,u=!y(e);r||o||u?(i=Yt(n,r,e,o),s[i]||(s[i]=t)):(i=this.id,a(e,i)?null===e[i]&&(e[i]=t):Object.isExtensible(e)&&b(e,i,t)),t.raw=e},getCachedFrag:function(e,t,n){var r,i=this.params.trackBy,a=!y(e);if(n||i||a){var o=Yt(t,n,e,i);r=this.cache[o]}else r=e[this.id];return r&&(r.reused||r.fresh),r},deleteCachedFrag:function(e){var t=e.raw,n=this.params.trackBy,r=e.scope,i=r.$index,o=a(r,"$key")&&r.$key,s=!y(t);if(n||o||s){var u=Yt(i,o,t,n);this.cache[u]=null}else t[this.id]=null,e.raw=null},getStagger:function(e,t,n,r){r+="Stagger";var i=e.node.__v_trans,a=i&&i.hooks,o=a&&(a[r]||a.stagger);return o?o.call(e,t,n):t*parseInt(this.params[r]||this.params.stagger,10)},_preProcess:function(e){return this.rawValue=e,e},_postProcess:function(e){if(Zn(e))return e;if(M(e)){for(var t,n=Object.keys(e),r=n.length,i=new Array(r);r--;)t=n[r],i[r]={$key:t,$value:e[t]};return i}return"number"!=typeof e||isNaN(e)||(e=kt(e)),e||[]},unbind:function(){if(this.descriptor.ref&&((this._scope||this.vm).$refs[this.descriptor.ref]=null),this.frags)for(var e,t=this.frags.length;t--;)e=this.frags[t],this.deleteCachedFrag(e),e.destroy()}},ca={priority:oa,terminal:!0,bind:function(){var e=this.el;if(e.__vue__)this.invalid=!0;else{var t=e.nextElementSibling;t&&null!==te(t,"v-else")&&(oe(t),this.elseEl=t),this.anchor=ye("v-if"),ue(e,this.anchor)}},update:function(e){this.invalid||(e?this.frag||this.insert():this.remove())},insert:function(){this.elseFrag&&(this.elseFrag.remove(),this.elseFrag=null),this.factory||(this.factory=new bt(this.vm,this.el)),this.frag=this.factory.create(this._host,this._scope,this._frag),this.frag.before(this.anchor)},remove:function(){this.frag&&(this.frag.remove(),this.frag=null),this.elseEl&&!this.elseFrag&&(this.elseFactory||(this.elseFactory=new bt(this.elseEl._context||this.vm,this.elseEl)),this.elseFrag=this.elseFactory.create(this._host,this._scope,this._frag),this.elseFrag.before(this.anchor))},unbind:function(){this.frag&&this.frag.destroy(),this.elseFrag&&this.elseFrag.destroy()}},ha={bind:function(){var e=this.el.nextElementSibling;e&&null!==te(e,"v-else")&&(this.elseEl=e)},update:function(e){this.apply(this.el,e),this.elseEl&&this.apply(this.elseEl,!e)},apply:function(e,t){function n(){e.style.display=t?"":"none"}ee(e)?Q(e,t?1:-1,n,this.vm):n()}},_a={bind:function(){var e=this,t=this.el,n="range"===t.type,r=this.params.lazy,i=this.params.number,a=this.params.debounce,o=!1;if(ir||n||(this.on("compositionstart",function(){o=!0}),this.on("compositionend",function(){o=!1,r||e.listener()})),this.focused=!1,n||r||(this.on("focus",function(){e.focused=!0}),this.on("blur",function(){e.focused=!1,e._frag&&!e._frag.inserted||e.rawListener()})),this.listener=this.rawListener=function(){if(!o&&e._bound){var r=i||n?d(t.value):t.value;e.set(r),hr(function(){e._bound&&!e.focused&&e.update(e._watcher.value)})}},a&&(this.listener=L(this.listener,a)),this.hasjQuery="function"==typeof jQuery,this.hasjQuery){var s=jQuery.fn.on?"on":"bind";jQuery(t)[s]("change",this.rawListener),r||jQuery(t)[s]("input",this.listener)}else this.on("change",this.rawListener),r||this.on("input",this.listener);!r&&rr&&(this.on("cut",function(){hr(e.listener)}),this.on("keyup",function(t){46!==t.keyCode&&8!==t.keyCode||e.listener()})),(t.hasAttribute("value")||"TEXTAREA"===t.tagName&&t.value.trim())&&(this.afterBind=this.listener)},update:function(e){e=u(e),e!==this.el.value&&(this.el.value=e)},unbind:function(){var e=this.el;if(this.hasjQuery){var t=jQuery.fn.off?"off":"unbind";jQuery(e)[t]("change",this.listener),jQuery(e)[t]("input",this.listener)}}},fa={bind:function(){var e=this,t=this.el;this.getValue=function(){if(t.hasOwnProperty("_value"))return t._value;var n=t.value;return e.params.number&&(n=d(n)),n},this.listener=function(){e.set(e.getValue())},this.on("change",this.listener),t.hasAttribute("checked")&&(this.afterBind=this.listener)},update:function(e){this.el.checked=x(e,this.getValue())}},ma={bind:function(){var e=this,t=this,n=this.el;this.forceUpdate=function(){t._watcher&&t.update(t._watcher.get())};var r=this.multiple=n.hasAttribute("multiple");this.listener=function(){var e=wt(n,r);e=t.params.number?Zn(e)?e.map(d):d(e):e,t.set(e)},this.on("change",this.listener);var i=wt(n,r,!0);(r&&i.length||!r&&null!==i)&&(this.afterBind=this.listener),this.vm.$on("hook:attached",function(){hr(e.forceUpdate)}),ee(n)||hr(this.forceUpdate)},update:function(e){var t=this.el;t.selectedIndex=-1;for(var n,r,i=this.multiple&&Zn(e),a=t.options,o=a.length;o--;)n=a[o],r=n.hasOwnProperty("_value")?n._value:n.value,n.selected=i?Dt(e,r)>-1:x(e,r)},unbind:function(){this.vm.$off("hook:attached",this.forceUpdate)}},pa={bind:function(){function e(){var e=n.checked;return e&&n.hasOwnProperty("_trueValue")?n._trueValue:!e&&n.hasOwnProperty("_falseValue")?n._falseValue:e}var t=this,n=this.el;this.getValue=function(){return n.hasOwnProperty("_value")?n._value:t.params.number?d(n.value):n.value},this.listener=function(){var r=t._watcher.get();if(Zn(r)){var i=t.getValue(),a=k(r,i);n.checked?a<0&&t.set(r.concat(i)):a>-1&&t.set(r.slice(0,a).concat(r.slice(a+1)))}else t.set(e())},this.on("change",this.listener),n.hasAttribute("checked")&&(this.afterBind=this.listener)},update:function(e){var t=this.el;Zn(e)?t.checked=k(e,this.getValue())>-1:t.hasOwnProperty("_trueValue")?t.checked=x(e,t._trueValue):t.checked=!!e}},ga={text:_a,radio:fa,select:ma,checkbox:pa},va={priority:ea,twoWay:!0,handlers:ga,params:["lazy","number","debounce"],bind:function(){this.checkFilters(),this.hasRead&&!this.hasWrite;var e,t=this.el,n=t.tagName;if("INPUT"===n)e=ga[t.type]||ga.text;else if("SELECT"===n)e=ga.select;else{if("TEXTAREA"!==n)return;e=ga.text}t.__v_model=this,e.bind.call(this),this.update=e.update,this._unbind=e.unbind},checkFilters:function(){var e=this.filters;if(e)for(var t=e.length;t--;){var n=Pe(this.vm.$options,"filters",e[t].name);("function"==typeof n||n.read)&&(this.hasRead=!0),n.write&&(this.hasWrite=!0)}},unbind:function(){this.el.__v_model=null,this._unbind&&this._unbind()}},ya={esc:27,tab:9,enter:13,space:32,delete:[8,46],up:38,left:37,right:39,down:40},Ma={priority:Xi,acceptStatement:!0,keyCodes:ya,bind:function(){if("IFRAME"===this.el.tagName&&"load"!==this.arg){var e=this;this.iframeBind=function(){de(e.el.contentWindow,e.arg,e.handler,e.modifiers.capture)},this.on("load",this.iframeBind)}},update:function(e){if(this.descriptor.raw||(e=function(){}),"function"==typeof e){this.modifiers.stop&&(e=St(e)),this.modifiers.prevent&&(e=jt(e)),this.modifiers.self&&(e=Ht(e));var t=Object.keys(this.modifiers).filter(function(e){return"stop"!==e&&"prevent"!==e&&"self"!==e&&"capture"!==e});t.length&&(e=Tt(e,t)),this.reset(),this.handler=e,this.iframeBind?this.iframeBind():de(this.el,this.arg,this.handler,this.modifiers.capture)}},reset:function(){var e=this.iframeBind?this.el.contentWindow:this.el;this.handler&&le(e,this.arg,this.handler)},unbind:function(){this.reset()}},ba=["-webkit-","-moz-","-ms-"],La=["Webkit","Moz","ms"],ka=/!important;?$/,Ya=Object.create(null),xa=null,wa={deep:!0,update:function(e){"string"==typeof e?this.el.style.cssText=e:Zn(e)?this.handleObject(e.reduce(v,{})):this.handleObject(e||{})},handleObject:function(e){var t,n,r=this.cache||(this.cache={});for(t in r)t in e||(this.handleSingle(t,null),delete r[t]);for(t in e)n=e[t],n!==r[t]&&(r[t]=n,this.handleSingle(t,n))},handleSingle:function(e,t){if(e=At(e))if(null!=t&&(t+=""),t){var n=ka.test(t)?"important":"";n?(t=t.replace(ka,"").trim(),this.el.style.setProperty(e.kebab,t,n)):this.el.style[e.camel]=t}else this.el.style[e.camel]=""}},Da="http://www.w3.org/1999/xlink",Ta=/^xlink:/,Sa=/^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/,ja=/^(?:value|checked|selected|muted)$/,Ha=/^(?:draggable|contenteditable|spellcheck)$/,Aa={
value:"_value","true-value":"_trueValue","false-value":"_falseValue"},Pa={priority:ta,bind:function(){var e=this.arg,t=this.el.tagName;e||(this.deep=!0);var n=this.descriptor,r=n.interp;if(r){n.hasOneTime&&(this.expression=J(r,this._scope||this.vm)),(Sa.test(e)||"name"===e&&("PARTIAL"===t||"SLOT"===t))&&(this.el.removeAttribute(e),this.invalid=!0)}},update:function(e){if(!this.invalid){var t=this.arg;this.arg?this.handleSingle(t,e):this.handleObject(e||{})}},handleObject:wa.handleObject,handleSingle:function(e,t){var n=this.el,r=this.descriptor.interp;if(this.modifiers.camel&&(e=h(e)),!r&&ja.test(e)&&e in n){var i="value"===e&&null==t?"":t;n[e]!==i&&(n[e]=i)}var a=Aa[e];if(!r&&a){n[a]=t;var o=n.__v_model;o&&o.listener()}return"value"===e&&"TEXTAREA"===n.tagName?void n.removeAttribute(e):void(Ha.test(e)?n.setAttribute(e,t?"true":"false"):null!=t&&t!==!1?"class"===e?(n.__v_trans&&(t+=" "+n.__v_trans.id+"-transition"),he(n,t)):Ta.test(e)?n.setAttributeNS(Da,e,t===!0?"":t):n.setAttribute(e,t===!0?"":t):n.removeAttribute(e))}},Ca={priority:ra,bind:function(){if(this.arg){var e=this.id=h(this.arg),t=(this._scope||this.vm).$els;a(t,e)?t[e]=this.el:ze(t,e,this.el)}},unbind:function(){var e=(this._scope||this.vm).$els;e[this.id]===this.el&&(e[this.id]=null)}},Oa={bind:function(){}},Fa={bind:function(){var e=this.el;this.vm.$once("pre-hook:compiled",function(){e.removeAttribute("v-cloak")})}},Wa={text:Ri,html:Zi,for:la,if:ca,show:ha,model:va,on:Ma,bind:Pa,el:Ca,ref:Oa,cloak:Fa},Ia={deep:!0,update:function(e){e?"string"==typeof e?this.setClass(e.trim().split(/\s+/)):this.setClass(Ct(e)):this.cleanup()},setClass:function(e){this.cleanup(e);for(var t=0,n=e.length;t<n;t++){var r=e[t];r&&Ot(this.el,r,_e)}this.prevKeys=e},cleanup:function(e){var t=this.prevKeys;if(t)for(var n=t.length;n--;){var r=t[n];(!e||e.indexOf(r)<0)&&Ot(this.el,r,fe)}}},Ea={priority:ia,params:["keep-alive","transition-mode","inline-template"],bind:function(){this.el.__vue__||(this.keepAlive=this.params.keepAlive,this.keepAlive&&(this.cache={}),this.params.inlineTemplate&&(this.inlineTemplate=me(this.el,!0)),this.pendingComponentCb=this.Component=null,this.pendingRemovals=0,this.pendingRemovalCb=null,this.anchor=ye("v-component"),ue(this.el,this.anchor),this.el.removeAttribute("is"),this.el.removeAttribute(":is"),this.descriptor.ref&&this.el.removeAttribute("v-ref:"+f(this.descriptor.ref)),this.literal&&this.setComponent(this.expression))},update:function(e){this.literal||this.setComponent(e)},setComponent:function(e,t){if(this.invalidatePending(),e){var n=this;this.resolveComponent(e,function(){n.mountComponent(t)})}else this.unbuild(!0),this.remove(this.childVM,t),this.childVM=null},resolveComponent:function(e,t){var n=this;this.pendingComponentCb=Y(function(r){n.ComponentName=r.options.name||("string"==typeof e?e:null),n.Component=r,t()}),this.vm._resolveComponent(e,this.pendingComponentCb)},mountComponent:function(e){this.unbuild(!0);var t=this,n=this.Component.options.activate,r=this.getCached(),i=this.build();n&&!r?(this.waitingFor=i,Ft(n,i,function(){t.waitingFor===i&&(t.waitingFor=null,t.transition(i,e))})):(r&&i._updateRef(),this.transition(i,e))},invalidatePending:function(){this.pendingComponentCb&&(this.pendingComponentCb.cancel(),this.pendingComponentCb=null)},build:function(e){var t=this.getCached();if(t)return t;if(this.Component){var n={name:this.ComponentName,el:ht(this.el),template:this.inlineTemplate,parent:this._host||this.vm,_linkerCachable:!this.inlineTemplate,_ref:this.descriptor.ref,_asComponent:!0,_isRouterView:this._isRouterView,_context:this.vm,_scope:this._scope,_frag:this._frag};e&&v(n,e);var r=new this.Component(n);return this.keepAlive&&(this.cache[this.Component.cid]=r),r}},getCached:function(){return this.keepAlive&&this.cache[this.Component.cid]},unbuild:function(e){this.waitingFor&&(this.keepAlive||this.waitingFor.$destroy(),this.waitingFor=null);var t=this.childVM;return!t||this.keepAlive?void(t&&(t._inactive=!0,t._updateRef(!0))):void t.$destroy(!1,e)},remove:function(e,t){var n=this.keepAlive;if(e){this.pendingRemovals++,this.pendingRemovalCb=t;var r=this;e.$remove(function(){r.pendingRemovals--,n||e._cleanup(),!r.pendingRemovals&&r.pendingRemovalCb&&(r.pendingRemovalCb(),r.pendingRemovalCb=null)})}else t&&t()},transition:function(e,t){var n=this,r=this.childVM;switch(r&&(r._inactive=!0),e._inactive=!1,this.childVM=e,n.params.transitionMode){case"in-out":e.$before(n.anchor,function(){n.remove(r,t)});break;case"out-in":n.remove(r,function(){e.$before(n.anchor,t)});break;default:n.remove(r),e.$before(n.anchor,t)}},unbind:function(){if(this.invalidatePending(),this.unbuild(),this.cache){for(var e in this.cache)this.cache[e].$destroy();this.cache=null}}},za=Vr._propBindingModes,Ra={},Na=/^[$_a-zA-Z]+[\w$]*$/,Va=Vr._propBindingModes,Ba={bind:function(){var e=this.vm,t=e._context,n=this.descriptor.prop,r=n.path,i=n.parentPath,a=n.mode===Va.TWO_WAY,o=this.parentWatcher=new st(t,i,function(t){Rt(e,n,t)},{twoWay:a,filters:n.filters,scope:this._scope});if(zt(e,n,o.value),a){var s=this;e.$once("pre-hook:created",function(){s.childWatcher=new st(e,r,function(e){o.set(e)},{sync:!0})})}},unbind:function(){this.parentWatcher.teardown(),this.childWatcher&&this.childWatcher.teardown()}},$a=[],Ja=!1,Ua="transition",qa="animation",Ga=or+"Duration",Ka=ur+"Duration",Za=Xn&&window.requestAnimationFrame,Qa=Za?function(e){Za(function(){Za(e)})}:function(e){setTimeout(e,50)},Xa=qt.prototype;Xa.enter=function(e,t){this.cancelPending(),this.callHook("beforeEnter"),this.cb=t,_e(this.el,this.enterClass),e(),this.entered=!1,this.callHookWithCb("enter"),this.entered||(this.cancel=this.hooks&&this.hooks.enterCancelled,Jt(this.enterNextTick))},Xa.enterNextTick=function(){var e=this;this.justEntered=!0,Qa(function(){e.justEntered=!1});var t=this.enterDone,n=this.getCssTransitionType(this.enterClass);this.pendingJsCb?n===Ua&&fe(this.el,this.enterClass):n===Ua?(fe(this.el,this.enterClass),this.setupCssCb(sr,t)):n===qa?this.setupCssCb(dr,t):t()},Xa.enterDone=function(){this.entered=!0,this.cancel=this.pendingJsCb=null,fe(this.el,this.enterClass),this.callHook("afterEnter"),this.cb&&this.cb()},Xa.leave=function(e,t){this.cancelPending(),this.callHook("beforeLeave"),this.op=e,this.cb=t,_e(this.el,this.leaveClass),this.left=!1,this.callHookWithCb("leave"),this.left||(this.cancel=this.hooks&&this.hooks.leaveCancelled,this.op&&!this.pendingJsCb&&(this.justEntered?this.leaveDone():Jt(this.leaveNextTick)))},Xa.leaveNextTick=function(){var e=this.getCssTransitionType(this.leaveClass);if(e){var t=e===Ua?sr:dr;this.setupCssCb(t,this.leaveDone)}else this.leaveDone()},Xa.leaveDone=function(){this.left=!0,this.cancel=this.pendingJsCb=null,this.op(),fe(this.el,this.leaveClass),this.callHook("afterLeave"),this.cb&&this.cb(),this.op=null},Xa.cancelPending=function(){this.op=this.cb=null;var e=!1;this.pendingCssCb&&(e=!0,le(this.el,this.pendingCssEvent,this.pendingCssCb),this.pendingCssEvent=this.pendingCssCb=null),this.pendingJsCb&&(e=!0,this.pendingJsCb.cancel(),this.pendingJsCb=null),e&&(fe(this.el,this.enterClass),fe(this.el,this.leaveClass)),this.cancel&&(this.cancel.call(this.vm,this.el),this.cancel=null)},Xa.callHook=function(e){this.hooks&&this.hooks[e]&&this.hooks[e].call(this.vm,this.el)},Xa.callHookWithCb=function(e){var t=this.hooks&&this.hooks[e];t&&(t.length>1&&(this.pendingJsCb=Y(this[e+"Done"])),t.call(this.vm,this.el,this.pendingJsCb))},Xa.getCssTransitionType=function(e){if(!(!sr||document.hidden||this.hooks&&this.hooks.css===!1||Gt(this.el))){var t=this.type||this.typeCache[e];if(t)return t;var n=this.el.style,r=window.getComputedStyle(this.el),i=n[Ga]||r[Ga];if(i&&"0s"!==i)t=Ua;else{var a=n[Ka]||r[Ka];a&&"0s"!==a&&(t=qa)}return t&&(this.typeCache[e]=t),t}},Xa.setupCssCb=function(e,t){this.pendingCssEvent=e;var n=this,r=this.el,i=this.pendingCssCb=function(a){a.target===r&&(le(r,e,i),n.pendingCssEvent=n.pendingCssCb=null,!n.pendingJsCb&&t&&t())};de(r,e,i)};var eo={priority:na,update:function(e,t){var n=this.el,r=Pe(this.vm.$options,"transitions",e);e=e||"v",t=t||"v",n.__v_trans=new qt(n,e,r,this.vm),fe(n,t+"-transition"),_e(n,e+"-transition")}},to={style:wa,class:Ia,component:Ea,prop:Ba,transition:eo},no=/^v-bind:|^:/,ro=/^v-on:|^@/,io=/^v-([^:]+)(?:$|:(.*)$)/,ao=/\.[^\.]+/g,oo=/^(v-bind:|:)?transition$/,so=1e3,uo=2e3;mn.terminal=!0;var lo=/[^\w\-:\.]/,co=Object.freeze({compile:Kt,compileAndLinkProps:tn,compileRoot:nn,transclude:Ln,resolveSlots:wn}),ho=/^v-on:|^@/;Hn.prototype._bind=function(){var e=this.name,t=this.descriptor;if(("cloak"!==e||this.vm._isCompiled)&&this.el&&this.el.removeAttribute){var n=t.attr||"v-"+e;this.el.removeAttribute(n)}var r=t.def;if("function"==typeof r?this.update=r:v(this,r),this._setupParams(),this.bind&&this.bind(),this._bound=!0,this.literal)this.update&&this.update(t.raw);else if((this.expression||this.modifiers)&&(this.update||this.twoWay)&&!this._checkStatement()){var i=this;this.update?this._update=function(e,t){i._locked||i.update(e,t)}:this._update=jn;var a=this._preProcess?p(this._preProcess,this):null,o=this._postProcess?p(this._postProcess,this):null,s=this._watcher=new st(this.vm,this.expression,this._update,{filters:this.filters,twoWay:this.twoWay,deep:this.deep,preProcess:a,postProcess:o,scope:this._scope});this.afterBind?this.afterBind():this.update&&this.update(s.value)}},Hn.prototype._setupParams=function(){if(this.params){var e=this.params;this.params=Object.create(null);for(var t,n,r,i=e.length;i--;)t=f(e[i]),r=h(t),n=ne(this.el,t),null!=n?this._setupParamWatcher(r,n):(n=te(this.el,t),null!=n&&(this.params[r]=""===n||n))}},Hn.prototype._setupParamWatcher=function(e,t){var n=this,r=!1,i=(this._scope||this.vm).$watch(t,function(t,i){if(n.params[e]=t,r){var a=n.paramWatchers&&n.paramWatchers[e];a&&a.call(n,t,i)}else r=!0},{immediate:!0,user:!1});(this._paramUnwatchFns||(this._paramUnwatchFns=[])).push(i)},Hn.prototype._checkStatement=function(){var e=this.expression;if(e&&this.acceptStatement&&!nt(e)){var t=tt(e).get,n=this._scope||this.vm,r=function(e){n.$event=e,t.call(n,n),n.$event=null};return this.filters&&(r=n._applyFilters(r,null,this.filters)),this.update(r),!0}},Hn.prototype.set=function(e){this.twoWay&&this._withLock(function(){this._watcher.set(e)})},Hn.prototype._withLock=function(e){var t=this;t._locked=!0,e.call(t),hr(function(){t._locked=!1})},Hn.prototype.on=function(e,t,n){de(this.el,e,t,n),(this._listeners||(this._listeners=[])).push([e,t])},Hn.prototype._teardown=function(){if(this._bound){this._bound=!1,this.unbind&&this.unbind(),this._watcher&&this._watcher.teardown();var e,t=this._listeners;if(t)for(e=t.length;e--;)le(this.el,t[e][0],t[e][1]);var n=this._paramUnwatchFns;if(n)for(e=n.length;e--;)n[e]();this.vm=this.el=this._watcher=this._listeners=null}};var _o=/[^|]\|[^|]/;Re(In),Tn(In),Sn(In),An(In),Pn(In),Cn(In),On(In),Fn(In),Wn(In);var fo={priority:ua,params:["name"],bind:function(){var e=this.params.name||"default",t=this.vm._slotContents&&this.vm._slotContents[e];t&&t.hasChildNodes()?this.compile(t.cloneNode(!0),this.vm._context,this.vm):this.fallback()},compile:function(e,t,n){if(e&&t){if(this.el.hasChildNodes()&&1===e.childNodes.length&&1===e.childNodes[0].nodeType&&e.childNodes[0].hasAttribute("v-if")){var r=document.createElement("template");r.setAttribute("v-else",""),r.innerHTML=this.el.innerHTML,r._context=this.vm,e.appendChild(r)}var i=n?n._scope:this._scope;this.unlink=t.$compile(e,n,i,this._frag)}e?ue(this.el,e):oe(this.el)},fallback:function(){this.compile(me(this.el,!0),this.vm)},unbind:function(){this.unlink&&this.unlink()}},mo={priority:aa,params:["name"],paramWatchers:{name:function(e){ca.remove.call(this),e&&this.insert(e)}},bind:function(){this.anchor=ye("v-partial"),ue(this.el,this.anchor),this.insert(this.params.name)},insert:function(e){var t=Pe(this.vm.$options,"partials",e,!0);t&&(this.factory=new bt(this.vm,t),ca.insert.call(this))},unbind:function(){this.frag&&this.frag.destroy()}},po={slot:fo,partial:mo},go=la._postProcess,vo=/(\d{3})(?=\d)/g,yo={orderBy:Rn,filterBy:zn,limitBy:En,json:{read:function(e,t){return"string"==typeof e?e:JSON.stringify(e,null,arguments.length>1?t:2)},write:function(e){try{return JSON.parse(e)}catch(t){return e}}},capitalize:function(e){return e||0===e?(e=e.toString(),e.charAt(0).toUpperCase()+e.slice(1)):""},uppercase:function(e){return e||0===e?e.toString().toUpperCase():""},lowercase:function(e){return e||0===e?e.toString().toLowerCase():""},currency:function(e,t,n){if(e=parseFloat(e),!isFinite(e)||!e&&0!==e)return"";t=null!=t?t:"$",n=null!=n?n:2;var r=Math.abs(e).toFixed(n),i=n?r.slice(0,-1-n):r,a=i.length%3,o=a>0?i.slice(0,a)+(i.length>3?",":""):"",s=n?r.slice(-1-n):"",u=e<0?"-":"";return u+t+o+i.slice(a).replace(vo,"$1,")+s},pluralize:function(e){var t=g(arguments,1),n=t.length;if(n>1){var r=e%10-1;return r in t?t[r]:t[n-1]}return t[0]+(1===e?"":"s")},debounce:function(e,t){if(e)return t||(t=300),L(e,t)}};Vn(In),In.version="1.0.28",setTimeout(function(){Vr.devtools&&er&&er.emit("init",In)},0),e.exports=In},function(e,t,n){function r(e,t){var n=a(e,t);return i(n)?n:void 0}var i=n(281),a=n(318);e.exports=r},function(e,t,n){var r=n(2),i=r.Symbol;e.exports=i},function(e,t,n){function r(e){return null==e?void 0===e?u:s:d&&d in Object(e)?a(e):o(e)}var i=n(10),a=n(317),o=n(349),s="[object Null]",u="[object Undefined]",d=i?i.toStringTag:void 0;e.exports=r},function(e,t){function n(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}e.exports=n},function(e,t,n){function r(e,t,n,r){var o=!n;n||(n={});for(var s=-1,u=t.length;++s<u;){var d=t[s],l=r?r(n[d],e[d],d,n,e):void 0;void 0===l&&(l=e[d]),o?a(n,d,l):i(n,d,l)}return n}var i=n(59),a=n(39);e.exports=r},function(e,t,n){function r(e){if("string"==typeof e||i(e))return e;var t=e+"";return"0"==t&&1/e==-a?"-0":t}var i=n(16),a=1/0;e.exports=r},function(e,t){function n(e,t){return e===t||e!==e&&t!==t}e.exports=n},function(e,t,n){function r(e){return"symbol"==typeof e||a(e)&&i(e)==o}var i=n(11),a=n(7),o="[object Symbol]";e.exports=r},function(e,t,n){function r(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var i=n(334),a=n(335),o=n(336),s=n(337),u=n(338);r.prototype.clear=i,r.prototype.delete=a,r.prototype.get=o,r.prototype.has=s,r.prototype.set=u,e.exports=r},function(e,t,n){function r(e){var t=this.__data__=new i(e);this.size=t.size}var i=n(17),a=n(354),o=n(355),s=n(356),u=n(357),d=n(358);r.prototype.clear=a,r.prototype.delete=o,r.prototype.get=s,r.prototype.has=u,r.prototype.set=d,e.exports=r},function(e,t,n){function r(e,t){for(var n=e.length;n--;)if(i(e[n][0],t))return n;return-1}var i=n(15);e.exports=r},function(e,t,n){var r=n(4),i=Object.create,a=function(){function e(){}return function(t){if(!r(t))return{};if(i)return i(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();e.exports=a},function(e,t,n){function r(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=i(e.prototype),r=e.apply(n,t);return a(r)?r:n}}var i=n(20),a=n(4);e.exports=r},function(e,t,n){function r(e,t){var n=e.__data__;return i(t)?n["string"==typeof t?"string":"hash"]:n.map}var i=n(331);e.exports=r},function(e,t){function n(e,t){return t=null==t?r:t,!!t&&("number"==typeof e||i.test(e))&&e>-1&&e%1==0&&e<t}var r=9007199254740991,i=/^(?:0|[1-9]\d*)$/;e.exports=n},function(e,t,n){var r=n(9),i=r(Object,"create");e.exports=i},function(e,t){function n(e){return e}e.exports=n},function(e,t,n){var r=n(277),i=n(7),a=Object.prototype,o=a.hasOwnProperty,s=a.propertyIsEnumerable,u=r(function(){return arguments}())?r:function(e){return i(e)&&o.call(e,"callee")&&!s.call(e,"callee")};e.exports=u},function(e,t,n){function r(e){return null!=e&&a(e.length)&&!i(e)}var i=n(29),a=n(49);e.exports=r},function(e,t,n){(function(e){var r=n(2),i=n(382),a="object"==typeof t&&t&&!t.nodeType&&t,o=a&&"object"==typeof e&&e&&!e.nodeType&&e,s=o&&o.exports===a,u=s?r.Buffer:void 0,d=u?u.isBuffer:void 0,l=d||i;e.exports=l}).call(t,n(32)(e))},function(e,t,n){function r(e){if(!a(e))return!1;var t=i(e);return t==s||t==u||t==o||t==d}var i=n(11),a=n(4),o="[object AsyncFunction]",s="[object Function]",u="[object GeneratorFunction]",d="[object Proxy]";e.exports=r},function(e,t,n){function r(e){return o(e)?i(e):a(e)}var i=n(55),a=n(65),o=n(27);e.exports=r},function(e,t,n){function r(e){return o(e)?i(e,!0):a(e)}var i=n(55),a=n(284),o=n(27);e.exports=r},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}},function(e,t,n){function r(e){this.__wrapped__=e,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=o,this.__views__=[]}var i=n(20),a=n(40),o=4294967295;r.prototype=i(a.prototype),r.prototype.constructor=r,e.exports=r},function(e,t,n){var r=n(9),i=n(2),a=r(i,"Map");e.exports=a},function(e,t,n){function r(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var i=n(339),a=n(340),o=n(341),s=n(342),u=n(343);r.prototype.clear=i,r.prototype.delete=a,r.prototype.get=o,r.prototype.has=s,r.prototype.set=u,e.exports=r},function(e,t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}e.exports=n},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&t(e[n],n,e)!==!1;);return e}e.exports=n},function(e,t){function n(e,t){for(var n=-1,r=t.length,i=e.length;++n<r;)e[i+n]=t[n];return e}e.exports=n},function(e,t,n){function r(e,t,n){"__proto__"==t&&i?i(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}var i=n(74);e.exports=r},function(e,t){function n(){}e.exports=n},function(e,t,n){function r(e){var t=new e.constructor(e.byteLength);return new i(t).set(new i(e)),t}var i=n(53);e.exports=r},function(e,t,n){function r(e,t,n,r,L,k,Y,x){var w=t&p;if(!w&&"function"!=typeof e)throw new TypeError(f);var D=r?r.length:0;if(D||(t&=~(y|M),r=L=void 0),Y=void 0===Y?Y:b(_(Y),0),x=void 0===x?x:_(x),D-=L?L.length:0,t&M){var T=r,S=L;r=L=void 0}var j=w?void 0:d(e),H=[e,t,n,r,L,T,S,k,Y,x];if(j&&l(H,j),e=H[0],t=H[1],n=H[2],r=H[3],L=H[4],x=H[9]=void 0===H[9]?w?0:e.length:b(H[9]-D,0),!x&&t&(g|v)&&(t&=~(g|v)),t&&t!=m)A=t==g||t==v?o(e,t,x):t!=y&&t!=(m|y)||L.length?s.apply(void 0,H):u(e,t,n,r);else var A=a(e,t,n);var P=j?i:c;return h(P(A,H),e,t)}var i=n(66),a=n(308),o=n(309),s=n(72),u=n(310),d=n(78),l=n(345),c=n(89),h=n(91),_=n(97),f="Expected a function",m=1,p=2,g=8,v=16,y=32,M=64,b=Math.max;e.exports=r},function(e,t,n){var r=n(87),i=r(Object.getPrototypeOf,Object);e.exports=i},function(e,t,n){var r=n(268),i=n(96),a=Object.prototype,o=a.propertyIsEnumerable,s=Object.getOwnPropertySymbols,u=s?function(e){return null==e?[]:(e=Object(e),r(s(e),function(t){return o.call(e,t)}))}:i;e.exports=u},function(e,t,n){function r(e,t){if(i(e))return!1;var n=typeof e;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=e&&!a(e))||(s.test(e)||!o.test(e)||null!=t&&e in Object(t))}var i=n(3),a=n(16),o=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,s=/^\w*$/;e.exports=r},function(e,t){function n(e){var t=e&&e.constructor,n="function"==typeof t&&t.prototype||r;return e===n}var r=Object.prototype;e.exports=n},function(e,t){function n(e,t){for(var n=-1,i=e.length,a=0,o=[];++n<i;){var s=e[n];s!==t&&s!==r||(e[n]=r,o[a++]=n)}return o}var r="__lodash_placeholder__";e.exports=n},function(e,t,n){var r=n(292),i=n(92),a=i(r);e.exports=a},function(e,t){function n(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=r}var r=9007199254740991;e.exports=n},function(e,t,n){var r=n(282),i=n(295),a=n(348),o=a&&a.isTypedArray,s=o?i(o):r;e.exports=s},function(e,t,n){var r=n(259),i=n(257),a=function(e){if(e instanceof a)return e;if(!(this instanceof a))return new a(e);this.valid=!1,this.values={rgb:[0,0,0],hsl:[0,0,0],hsv:[0,0,0],hwb:[0,0,0],cmyk:[0,0,0,0],alpha:1};var t;"string"==typeof e?(t=i.getRgba(e),t?this.setValues("rgb",t):(t=i.getHsla(e))?this.setValues("hsl",t):(t=i.getHwb(e))&&this.setValues("hwb",t)):"object"==typeof e&&(t=e,void 0!==t.r||void 0!==t.red?this.setValues("rgb",t):void 0!==t.l||void 0!==t.lightness?this.setValues("hsl",t):void 0!==t.v||void 0!==t.value?this.setValues("hsv",t):void 0!==t.w||void 0!==t.whiteness?this.setValues("hwb",t):void 0===t.c&&void 0===t.cyan||this.setValues("cmyk",t))};a.prototype={isValid:function(){return this.valid},rgb:function(){return this.setSpace("rgb",arguments)},hsl:function(){return this.setSpace("hsl",arguments)},hsv:function(){return this.setSpace("hsv",arguments)},hwb:function(){return this.setSpace("hwb",arguments)},cmyk:function(){return this.setSpace("cmyk",arguments)},rgbArray:function(){return this.values.rgb},hslArray:function(){return this.values.hsl},hsvArray:function(){return this.values.hsv},hwbArray:function(){var e=this.values;return 1!==e.alpha?e.hwb.concat([e.alpha]):e.hwb},cmykArray:function(){return this.values.cmyk},rgbaArray:function(){var e=this.values;return e.rgb.concat([e.alpha])},hslaArray:function(){var e=this.values;return e.hsl.concat([e.alpha])},alpha:function(e){return void 0===e?this.values.alpha:(this.setValues("alpha",e),this)},red:function(e){return this.setChannel("rgb",0,e)},green:function(e){return this.setChannel("rgb",1,e)},blue:function(e){return this.setChannel("rgb",2,e)},hue:function(e){return e&&(e%=360,e=e<0?360+e:e),this.setChannel("hsl",0,e)},saturation:function(e){return this.setChannel("hsl",1,e)},lightness:function(e){return this.setChannel("hsl",2,e)},saturationv:function(e){return this.setChannel("hsv",1,e)},whiteness:function(e){return this.setChannel("hwb",1,e)},blackness:function(e){return this.setChannel("hwb",2,e)},value:function(e){return this.setChannel("hsv",2,e)},cyan:function(e){return this.setChannel("cmyk",0,e)},magenta:function(e){return this.setChannel("cmyk",1,e)},yellow:function(e){return this.setChannel("cmyk",2,e)},black:function(e){return this.setChannel("cmyk",3,e)},hexString:function(){return i.hexString(this.values.rgb)},rgbString:function(){return i.rgbString(this.values.rgb,this.values.alpha)},rgbaString:function(){return i.rgbaString(this.values.rgb,this.values.alpha)},percentString:function(){return i.percentString(this.values.rgb,this.values.alpha)},hslString:function(){return i.hslString(this.values.hsl,this.values.alpha)},hslaString:function(){return i.hslaString(this.values.hsl,this.values.alpha)},hwbString:function(){return i.hwbString(this.values.hwb,this.values.alpha)},keyword:function(){return i.keyword(this.values.rgb,this.values.alpha)},rgbNumber:function(){var e=this.values.rgb;return e[0]<<16|e[1]<<8|e[2]},luminosity:function(){for(var e=this.values.rgb,t=[],n=0;n<e.length;n++){var r=e[n]/255;t[n]=r<=.03928?r/12.92:Math.pow((r+.055)/1.055,2.4)}return.2126*t[0]+.7152*t[1]+.0722*t[2]},contrast:function(e){var t=this.luminosity(),n=e.luminosity();return t>n?(t+.05)/(n+.05):(n+.05)/(t+.05)},level:function(e){var t=this.contrast(e);return t>=7.1?"AAA":t>=4.5?"AA":""},dark:function(){var e=this.values.rgb,t=(299*e[0]+587*e[1]+114*e[2])/1e3;return t<128},light:function(){return!this.dark()},negate:function(){for(var e=[],t=0;t<3;t++)e[t]=255-this.values.rgb[t];return this.setValues("rgb",e),this},lighten:function(e){var t=this.values.hsl;return t[2]+=t[2]*e,this.setValues("hsl",t),this},darken:function(e){var t=this.values.hsl;return t[2]-=t[2]*e,this.setValues("hsl",t),this},saturate:function(e){var t=this.values.hsl;return t[1]+=t[1]*e,this.setValues("hsl",t),this},desaturate:function(e){var t=this.values.hsl;return t[1]-=t[1]*e,this.setValues("hsl",t),this},whiten:function(e){var t=this.values.hwb;return t[1]+=t[1]*e,this.setValues("hwb",t),this},blacken:function(e){var t=this.values.hwb;return t[2]+=t[2]*e,this.setValues("hwb",t),this},greyscale:function(){var e=this.values.rgb,t=.3*e[0]+.59*e[1]+.11*e[2];return this.setValues("rgb",[t,t,t]),this},clearer:function(e){var t=this.values.alpha;return this.setValues("alpha",t-t*e),this},opaquer:function(e){var t=this.values.alpha;return this.setValues("alpha",t+t*e),this},rotate:function(e){var t=this.values.hsl,n=(t[0]+e)%360;return t[0]=n<0?360+n:n,this.setValues("hsl",t),this},mix:function(e,t){var n=this,r=e,i=void 0===t?.5:t,a=2*i-1,o=n.alpha()-r.alpha(),s=((a*o===-1?a:(a+o)/(1+a*o))+1)/2,u=1-s;return this.rgb(s*n.red()+u*r.red(),s*n.green()+u*r.green(),s*n.blue()+u*r.blue()).alpha(n.alpha()*i+r.alpha()*(1-i))},toJSON:function(){return this.rgb()},clone:function(){var e,t,n=new a,r=this.values,i=n.values;for(var o in r)r.hasOwnProperty(o)&&(e=r[o],t={}.toString.call(e),"[object Array]"===t?i[o]=e.slice(0):"[object Number]"===t?i[o]=e:console.error("unexpected color value:",e));return n}},a.prototype.spaces={rgb:["red","green","blue"],hsl:["hue","saturation","lightness"],hsv:["hue","saturation","value"],hwb:["hue","whiteness","blackness"],cmyk:["cyan","magenta","yellow","black"]},a.prototype.maxes={rgb:[255,255,255],hsl:[360,100,100],hsv:[360,100,100],hwb:[360,100,100],cmyk:[100,100,100,100]},a.prototype.getValues=function(e){for(var t=this.values,n={},r=0;r<e.length;r++)n[e.charAt(r)]=t[e][r];return 1!==t.alpha&&(n.a=t.alpha),n},a.prototype.setValues=function(e,t){var n,i=this.values,a=this.spaces,o=this.maxes,s=1;if(this.valid=!0,"alpha"===e)s=t;else if(t.length)i[e]=t.slice(0,e.length),s=t[e.length];else if(void 0!==t[e.charAt(0)]){for(n=0;n<e.length;n++)i[e][n]=t[e.charAt(n)];s=t.a}else if(void 0!==t[a[e][0]]){var u=a[e];for(n=0;n<e.length;n++)i[e][n]=t[u[n]];s=t.alpha}if(i.alpha=Math.max(0,Math.min(1,void 0===s?i.alpha:s)),"alpha"===e)return!1;var d;for(n=0;n<e.length;n++)d=Math.max(0,Math.min(o[e][n],i[e][n])),i[e][n]=Math.round(d);for(var l in a)l!==e&&(i[l]=r[e][l](i[e]));return!0},a.prototype.setSpace=function(e,t){var n=t[0];return void 0===n?this.getValues(e):("number"==typeof n&&(n=Array.prototype.slice.call(t)),this.setValues(e,n),this)},a.prototype.setChannel=function(e,t,n){var r=this.values[e];return void 0===n?r[t]:n===r[t]?this:(r[t]=n,this.setValues(e,r),this)},"undefined"!=typeof window&&(window.Color=a),e.exports=a},function(e,t,n){function r(e,t){this.__wrapped__=e,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=void 0}var i=n(20),a=n(40);r.prototype=i(a.prototype),r.prototype.constructor=r,e.exports=r},function(e,t,n){var r=n(2),i=r.Uint8Array;e.exports=i},function(e,t,n){var r=n(9),i=n(2),a=r(i,"WeakMap");e.exports=a},function(e,t,n){function r(e,t){var n=o(e),r=!n&&a(e),l=!n&&!r&&s(e),h=!n&&!r&&!l&&d(e),_=n||r||l||h,f=_?i(e.length,String):[],m=f.length;for(var p in e)!t&&!c.call(e,p)||_&&("length"==p||l&&("offset"==p||"parent"==p)||h&&("buffer"==p||"byteLength"==p||"byteOffset"==p)||u(p,m))||f.push(p);return f}var i=n(293),a=n(26),o=n(3),s=n(28),u=n(23),d=n(50),l=Object.prototype,c=l.hasOwnProperty;e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length,i=Array(r);++n<r;)i[n]=t(e[n],n,e);return i}e.exports=n},function(e,t){function n(e,t,n,r){var i=-1,a=null==e?0:e.length;for(r&&a&&(n=e[++i]);++i<a;)n=t(n,e[i],i,e);return n}e.exports=n},function(e,t,n){function r(e,t,n){(void 0===n||a(e[t],n))&&(void 0!==n||t in e)||i(e,t,n)}var i=n(39),a=n(15);e.exports=r},function(e,t,n){function r(e,t,n){var r=e[t];s.call(e,t)&&a(r,n)&&(void 0!==n||t in e)||i(e,t,n)}var i=n(39),a=n(15),o=Object.prototype,s=o.hasOwnProperty;e.exports=r},function(e,t,n){function r(e,t){return e&&i(t,a(t),e)}var i=n(13),a=n(30);e.exports=r},function(e,t,n){function r(e,t,n,D,T,S){var j,P=t&k,C=t&Y,F=t&x;if(n&&(j=T?n(e,D,T,S):n(e)),void 0!==j)return j;if(!b(e))return e;var W=y(e);if(W){if(j=p(e),!P)return l(e,j)}else{var I=m(e),E=I==H||I==A;if(M(e))return d(e,P);if(I==O||I==w||E&&!T){if(j=C||E?{}:v(e),!P)return C?h(e,u(j,e)):c(e,s(j,e))}else{if(!Q[I])return T?e:{};j=g(e,I,r,P)}}S||(S=new i);var z=S.get(e);if(z)return z;S.set(e,j);var R=F?C?f:_:C?keysIn:L,N=W?void 0:R(e);return a(N||e,function(i,a){N&&(a=i,i=e[a]),o(j,a,r(i,t,n,a,e,S))}),j}var i=n(18),a=n(37),o=n(59),s=n(60),u=n(271),d=n(68),l=n(12),c=n(302),h=n(303),_=n(77),f=n(314),m=n(81),p=n(326),g=n(327),v=n(82),y=n(3),M=n(28),b=n(4),L=n(30),k=1,Y=2,x=4,w="[object Arguments]",D="[object Array]",T="[object Boolean]",S="[object Date]",j="[object Error]",H="[object Function]",A="[object GeneratorFunction]",P="[object Map]",C="[object Number]",O="[object Object]",F="[object RegExp]",W="[object Set]",I="[object String]",E="[object Symbol]",z="[object WeakMap]",R="[object ArrayBuffer]",N="[object DataView]",V="[object Float32Array]",B="[object Float64Array]",$="[object Int8Array]",J="[object Int16Array]",U="[object Int32Array]",q="[object Uint8Array]",G="[object Uint8ClampedArray]",K="[object Uint16Array]",Z="[object Uint32Array]",Q={};Q[w]=Q[D]=Q[R]=Q[N]=Q[T]=Q[S]=Q[V]=Q[B]=Q[$]=Q[J]=Q[U]=Q[P]=Q[C]=Q[O]=Q[F]=Q[W]=Q[I]=Q[E]=Q[q]=Q[G]=Q[K]=Q[Z]=!0,Q[j]=Q[H]=Q[z]=!1,e.exports=r},function(e,t,n){function r(e,t){t=i(t,e);for(var n=0,r=t.length;null!=e&&n<r;)e=e[a(t[n++])];return n&&n==r?e:void 0}var i=n(67),a=n(14);e.exports=r},function(e,t,n){function r(e,t,n){var r=t(e);return a(e)?r:i(r,n(e))}var i=n(38),a=n(3);e.exports=r},function(e,t,n){function r(e,t,n,o,s){return e===t||(null==e||null==t||!a(e)&&!a(t)?e!==e&&t!==t:i(e,t,n,o,r,s))}var i=n(278),a=n(7);e.exports=r},function(e,t,n){function r(e){if(!i(e))return a(e);var t=[];for(var n in Object(e))s.call(e,n)&&"constructor"!=n&&t.push(n);return t}var i=n(46),a=n(346),o=Object.prototype,s=o.hasOwnProperty;e.exports=r},function(e,t,n){var r=n(25),i=n(86),a=i?function(e,t){return i.set(e,t),e}:r;e.exports=a},function(e,t,n){function r(e,t){return i(e)?e:a(e,t)?[e]:o(s(e))}var i=n(3),a=n(45),o=n(93),s=n(98);e.exports=r},function(e,t,n){(function(e){function r(e,t){if(t)return e.slice();var n=e.length,r=d?d(n):new e.constructor(n);return e.copy(r),r}var i=n(2),a="object"==typeof t&&t&&!t.nodeType&&t,o=a&&"object"==typeof e&&e&&!e.nodeType&&e,s=o&&o.exports===a,u=s?i.Buffer:void 0,d=u?u.allocUnsafe:void 0;e.exports=r}).call(t,n(32)(e))},function(e,t,n){function r(e,t){var n=t?i(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}var i=n(41);e.exports=r},function(e,t){function n(e,t,n,i){for(var a=-1,o=e.length,s=n.length,u=-1,d=t.length,l=r(o-s,0),c=Array(d+l),h=!i;++u<d;)c[u]=t[u];for(;++a<s;)(h||a<o)&&(c[n[a]]=e[a]);for(;l--;)c[u++]=e[a++];return c}var r=Math.max;e.exports=n},function(e,t){function n(e,t,n,i){for(var a=-1,o=e.length,s=-1,u=n.length,d=-1,l=t.length,c=r(o-u,0),h=Array(c+l),_=!i;++a<c;)h[a]=e[a];for(var f=a;++d<l;)h[f+d]=t[d];for(;++s<u;)(_||a<o)&&(h[f+n[s]]=e[a++]);return h}var r=Math.max;e.exports=n},function(e,t,n){function r(e,t,n,y,M,b,L,k,Y,x){function w(){for(var _=arguments.length,f=Array(_),m=_;m--;)f[m]=arguments[m];if(j)var p=d(w),g=o(f,p);if(y&&(f=i(f,y,M,j)),b&&(f=a(f,b,L,j)),_-=g,j&&_<x){var v=c(f,p);return u(e,t,r,w.placeholder,n,f,v,k,Y,x-_)}var P=T?n:this,C=S?P[e]:e;return _=f.length,k?f=l(f,k):H&&_>1&&f.reverse(),D&&Y<_&&(f.length=Y),this&&this!==h&&this instanceof w&&(C=A||s(C)),C.apply(P,f)}var D=t&g,T=t&_,S=t&f,j=t&(m|p),H=t&v,A=S?void 0:s(e);return w}var i=n(70),a=n(71),o=n(305),s=n(21),u=n(73),d=n(79),l=n(351),c=n(47),h=n(2),_=1,f=2,m=8,p=16,g=128,v=512;e.exports=r},function(e,t,n){function r(e,t,n,r,_,f,m,p,g,v){var y=t&l,M=y?m:void 0,b=y?void 0:m,L=y?f:void 0,k=y?void 0:f;t|=y?c:h,t&=~(y?h:c),t&d||(t&=~(s|u));var Y=[e,t,_,L,M,k,b,p,g,v],x=n.apply(void 0,Y);return i(e)&&a(x,Y),x.placeholder=r,o(x,e,t)}var i=n(332),a=n(89),o=n(91),s=1,u=2,d=4,l=8,c=32,h=64;e.exports=r},function(e,t,n){var r=n(9),i=function(){try{var e=r(Object,"defineProperty");return e({},"",{}),e}catch(e){}}();e.exports=i},function(e,t,n){function r(e,t,n,r,d,l){var c=n&s,h=e.length,_=t.length;
if(h!=_&&!(c&&_>h))return!1;var f=l.get(e);if(f&&l.get(t))return f==t;var m=-1,p=!0,g=n&u?new i:void 0;for(l.set(e,t),l.set(t,e);++m<h;){var v=e[m],y=t[m];if(r)var M=c?r(y,v,m,t,e,l):r(v,y,m,e,t,l);if(void 0!==M){if(M)continue;p=!1;break}if(g){if(!a(t,function(e,t){if(!o(g,t)&&(v===e||d(v,e,n,r,l)))return g.push(t)})){p=!1;break}}else if(v!==y&&!d(v,y,n,r,l)){p=!1;break}}return l.delete(e),l.delete(t),p}var i=n(265),a=n(270),o=n(296),s=1,u=2;e.exports=r},function(e,t){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.exports=n}).call(t,function(){return this}())},function(e,t,n){function r(e){return i(e,o,a)}var i=n(63),a=n(44),o=n(30);e.exports=r},function(e,t,n){var r=n(86),i=n(379),a=r?function(e){return r.get(e)}:i;e.exports=a},function(e,t){function n(e){var t=e;return t.placeholder}e.exports=n},function(e,t,n){var r=n(38),i=n(43),a=n(44),o=n(96),s=Object.getOwnPropertySymbols,u=s?function(e){for(var t=[];e;)r(t,a(e)),e=i(e);return t}:o;e.exports=u},function(e,t,n){var r=n(261),i=n(34),a=n(263),o=n(264),s=n(54),u=n(11),d=n(94),l="[object Map]",c="[object Object]",h="[object Promise]",_="[object Set]",f="[object WeakMap]",m="[object DataView]",p=d(r),g=d(i),v=d(a),y=d(o),M=d(s),b=u;(r&&b(new r(new ArrayBuffer(1)))!=m||i&&b(new i)!=l||a&&b(a.resolve())!=h||o&&b(new o)!=_||s&&b(new s)!=f)&&(b=function(e){var t=u(e),n=t==c?e.constructor:void 0,r=n?d(n):"";if(r)switch(r){case p:return m;case g:return l;case v:return h;case y:return _;case M:return f}return t}),e.exports=b},function(e,t,n){function r(e){return"function"!=typeof e.constructor||o(e)?{}:i(a(e))}var i=n(20),a=n(43),o=n(46);e.exports=r},function(e,t,n){function r(e){return e===e&&!i(e)}var i=n(4);e.exports=r},function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach(function(e,r){n[++t]=[r,e]}),n}e.exports=n},function(e,t){function n(e,t){return function(n){return null!=n&&(n[e]===t&&(void 0!==t||e in Object(n)))}}e.exports=n},function(e,t,n){var r=n(54),i=r&&new r;e.exports=i},function(e,t){function n(e,t){return function(n){return e(t(n))}}e.exports=n},function(e,t,n){function r(e,t,n){return t=a(void 0===t?e.length-1:t,0),function(){for(var r=arguments,o=-1,s=a(r.length-t,0),u=Array(s);++o<s;)u[o]=r[t+o];o=-1;for(var d=Array(t+1);++o<t;)d[o]=r[o];return d[t]=n(u),i(e,this,d)}}var i=n(36),a=Math.max;e.exports=r},function(e,t,n){var r=n(66),i=n(92),a=i(r);e.exports=a},function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}e.exports=n},function(e,t,n){function r(e,t,n){var r=t+"";return o(e,a(r,s(i(r),n)))}var i=n(319),a=n(328),o=n(48),s=n(360);e.exports=r},function(e,t){function n(e){var t=0,n=0;return function(){var o=a(),s=i-(o-n);if(n=o,s>0){if(++t>=r)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}var r=800,i=16,a=Date.now;e.exports=n},function(e,t,n){var r=n(344),i=/^\./,a=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,o=/\\(\\)?/g,s=r(function(e){var t=[];return i.test(e)&&t.push(""),e.replace(a,function(e,n,r,i){t.push(r?i.replace(o,"$1"):n||e)}),t});e.exports=s},function(e,t){function n(e){if(null!=e){try{return i.call(e)}catch(e){}try{return e+""}catch(e){}}return""}var r=Function.prototype,i=r.toString;e.exports=n},function(e,t){e.exports={}},function(e,t){function n(){return[]}e.exports=n},function(e,t,n){function r(e){var t=i(e),n=t%1;return t===t?n?t-n:t:0}var i=n(383);e.exports=r},function(e,t,n){function r(e){return null==e?"":i(e)}var i=n(294);e.exports=r},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,t,n){return e<12?n?"vm":"VM":n?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[Môre om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ar-dz",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"أح_إث_ثلا_أر_خم_جم_سب".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},i=function(e){return function(t,i,a,o){var s=n(t),u=r[e][n(t)];return 2===s&&(u=u[i?0:1]),u.replace(/%d/i,t)}},a=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],o=e.defineLocale("ar-ly",{months:a,monthsShort:a,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:i("s"),m:i("m"),mm:i("m"),h:i("h"),hh:i("h"),d:i("d"),dd:i("d"),M:i("M"),MM:i("M"),y:i("y"),yy:i("y")},preparse:function(e){return e.replace(/\u200f/g,"").replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}});return o})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},r=e.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]}).replace(/,/g,"،")},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},r=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},i={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},a=function(e){return function(t,n,a,o){var s=r(t),u=i[e][r(t)];return 2===s&&(u=u[n?0:1]),u.replace(/%d/i,t)}},o=["كانون الثاني يناير","شباط فبراير","آذار مارس","نيسان أبريل","أيار مايو","حزيران يونيو","تموز يوليو","آب أغسطس","أيلول سبتمبر","تشرين الأول أكتوبر","تشرين الثاني نوفمبر","كانون الأول ديسمبر"],s=e.defineLocale("ar",{months:o,monthsShort:o,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:a("s"),m:a("m"),mm:a("m"),h:a("h"),hh:a("h"),d:a("d"),dd:a("d"),M:a("M"),MM:a("M"),y:a("y"),yy:a("y")},preparse:function(e){return e.replace(/\u200f/g,"").replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}});return s})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-üncü",4:"-üncü",100:"-üncü",6:"-ncı",9:"-uncu",10:"-uncu",30:"-uncu",60:"-ıncı",90:"-ıncı"},n=e.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),weekdaysShort:"Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),weekdaysMin:"Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[gələn həftə] dddd [saat] LT",lastDay:"[dünən] LT",lastWeek:"[keçən həftə] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s əvvəl",s:"birneçə saniyyə",m:"bir dəqiqə",mm:"%d dəqiqə",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gecə|səhər|gündüz|axşam/,isPM:function(e){return/^(gündüz|axşam)$/.test(e)},meridiem:function(e,t,n){return e<4?"gecə":e<12?"səhər":e<17?"gündüz":"axşam"},ordinalParse:/\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,ordinal:function(e){if(0===e)return e+"-ıncı";var n=e%10,r=e%100-n,i=e>=100?100:null;return e+(t[n]||t[r]||t[i])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t){var n=e.split("_");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var i={mm:n?"хвіліна_хвіліны_хвілін":"хвіліну_хвіліны_хвілін",hh:n?"гадзіна_гадзіны_гадзін":"гадзіну_гадзіны_гадзін",dd:"дзень_дні_дзён",MM:"месяц_месяцы_месяцаў",yy:"год_гады_гадоў"};return"m"===r?n?"хвіліна":"хвіліну":"h"===r?n?"гадзіна":"гадзіну":e+" "+t(i[r],+e)}var r=e.defineLocale("be",{months:{format:"студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),standalone:"студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")},monthsShort:"студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),weekdays:{format:"нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),standalone:"нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),isFormat:/\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/},weekdaysShort:"нд_пн_ат_ср_чц_пт_сб".split("_"),weekdaysMin:"нд_пн_ат_ср_чц_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., HH:mm",LLLL:"dddd, D MMMM YYYY г., HH:mm"},calendar:{sameDay:"[Сёння ў] LT",nextDay:"[Заўтра ў] LT",lastDay:"[Учора ў] LT",nextWeek:function(){return"[У] dddd [ў] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[У мінулую] dddd [ў] LT";case 1:case 2:case 4:return"[У мінулы] dddd [ў] LT"}},sameElse:"L"},relativeTime:{future:"праз %s",past:"%s таму",s:"некалькі секунд",m:n,mm:n,h:n,hh:n,d:"дзень",dd:n,M:"месяц",MM:n,y:"год",yy:n},meridiemParse:/ночы|раніцы|дня|вечара/,isPM:function(e){return/^(дня|вечара)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночы":e<12?"раніцы":e<17?"дня":"вечара"},ordinalParse:/\d{1,2}-(і|ы|га)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":case"w":case"W":return e%10!==2&&e%10!==3||e%100===12||e%100===13?e+"-ы":e+"-і";case"D":return e+"-га";default:return e}},week:{dow:1,doy:7}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[В изминалата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[В изминалия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дни",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},ordinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+"-ев":0===n?e+"-ен":n>10&&n<20?e+"-ти":1===t?e+"-ви":2===t?e+"-ри":7===t||8===t?e+"-ми":e+"-ти"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"১",2:"২",3:"৩",4:"৪",5:"৫",6:"৬",7:"৭",8:"৮",9:"৯",0:"০"},n={"১":"1","২":"2","৩":"3","৪":"4","৫":"5","৬":"6","৭":"7","৮":"8","৯":"9","০":"0"},r=e.defineLocale("bn",{months:"জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),monthsShort:"জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),weekdays:"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),weekdaysShort:"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),weekdaysMin:"রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি".split("_"),longDateFormat:{LT:"A h:mm সময়",LTS:"A h:mm:ss সময়",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm সময়",LLLL:"dddd, D MMMM YYYY, A h:mm সময়"},calendar:{sameDay:"[আজ] LT",nextDay:"[আগামীকাল] LT",nextWeek:"dddd, LT",lastDay:"[গতকাল] LT",lastWeek:"[গত] dddd, LT",sameElse:"L"},relativeTime:{future:"%s পরে",past:"%s আগে",s:"কয়েক সেকেন্ড",m:"এক মিনিট",mm:"%d মিনিট",h:"এক ঘন্টা",hh:"%d ঘন্টা",d:"এক দিন",dd:"%d দিন",M:"এক মাস",MM:"%d মাস",y:"এক বছর",yy:"%d বছর"},preparse:function(e){return e.replace(/[১২৩৪৫৬৭৮৯০]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/রাত|সকাল|দুপুর|বিকাল|রাত/,meridiemHour:function(e,t){return 12===e&&(e=0),"রাত"===t&&e>=4||"দুপুর"===t&&e<5||"বিকাল"===t?e+12:e},meridiem:function(e,t,n){return e<4?"রাত":e<10?"সকাল":e<17?"দুপুর":e<20?"বিকাল":"রাত"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"༡",2:"༢",3:"༣",4:"༤",5:"༥",6:"༦",7:"༧",8:"༨",9:"༩",0:"༠"},n={"༡":"1","༢":"2","༣":"3","༤":"4","༥":"5","༦":"6","༧":"7","༨":"8","༩":"9","༠":"0"},r=e.defineLocale("bo",{months:"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),monthsShort:"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),weekdays:"གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),weekdaysShort:"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),weekdaysMin:"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[དི་རིང] LT",nextDay:"[སང་ཉིན] LT",nextWeek:"[བདུན་ཕྲག་རྗེས་མ], LT",lastDay:"[ཁ་སང] LT",lastWeek:"[བདུན་ཕྲག་མཐའ་མ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ལ་",past:"%s སྔན་ལ",s:"ལམ་སང",m:"སྐར་མ་གཅིག",mm:"%d སྐར་མ",h:"ཆུ་ཚོད་གཅིག",hh:"%d ཆུ་ཚོད",d:"ཉིན་གཅིག",dd:"%d ཉིན་",M:"ཟླ་བ་གཅིག",MM:"%d ཟླ་བ",y:"ལོ་གཅིག",yy:"%d ལོ"},preparse:function(e){return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,meridiemHour:function(e,t){return 12===e&&(e=0),"མཚན་མོ"===t&&e>=4||"ཉིན་གུང"===t&&e<5||"དགོང་དག"===t?e+12:e},meridiem:function(e,t,n){return e<4?"མཚན་མོ":e<10?"ཞོགས་ཀས":e<17?"ཉིན་གུང":e<20?"དགོང་དག":"མཚན་མོ"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n){var r={mm:"munutenn",MM:"miz",dd:"devezh"};return e+" "+i(r[n],e)}function n(e){switch(r(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}function r(e){return e>9?r(e%10):e}function i(e,t){return 2===t?a(e):e}function a(e){var t={m:"v",b:"v",d:"z"};return void 0===t[e.charAt(0)]?e:t[e.charAt(0)]+e.substring(1)}var o=e.defineLocale("br",{months:"Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h[e]mm A",LTS:"h[e]mm:ss A",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY h[e]mm A",LLLL:"dddd, D [a viz] MMMM YYYY h[e]mm A"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warc'hoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Dec'h da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s 'zo",s:"un nebeud segondennoù",m:"ur vunutenn",mm:t,h:"un eur",hh:"%d eur",d:"un devezh",dd:t,M:"ur miz",MM:t,y:"ur bloaz",yy:n},ordinalParse:/\d{1,2}(añ|vet)/,ordinal:function(e){var t=1===e?"añ":"vet";return e+t},week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n){var r=e+" ";switch(n){case"m":return t?"jedna minuta":"jedne minute";case"mm":return r+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return t?"jedan sat":"jednog sata";case"hh":return r+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return r+=1===e?"dan":"dana";case"MM":return r+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return r+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}var n=e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",m:t,mm:t,h:t,hh:t,d:"dan",dd:t,M:"mjesec",MM:t,y:"godinu",yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ca",{months:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),monthsShort:"gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"Dg_Dl_Dt_Dc_Dj_Dv_Ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd D MMMM YYYY H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"uns segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},ordinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,t){var n=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==t&&"W"!==t||(n="a"),e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){return e>1&&e<5&&1!==~~(e/10)}function n(e,n,r,i){var a=e+" ";switch(r){case"s":return n||i?"pár sekund":"pár sekundami";case"m":return n?"minuta":i?"minutu":"minutou";case"mm":return n||i?a+(t(e)?"minuty":"minut"):a+"minutami";case"h":return n?"hodina":i?"hodinu":"hodinou";case"hh":return n||i?a+(t(e)?"hodiny":"hodin"):a+"hodinami";case"d":return n||i?"den":"dnem";case"dd":return n||i?a+(t(e)?"dny":"dní"):a+"dny";case"M":return n||i?"měsíc":"měsícem";case"MM":return n||i?a+(t(e)?"měsíce":"měsíců"):a+"měsíci";case"y":return n||i?"rok":"rokem";case"yy":return n||i?a+(t(e)?"roky":"let"):a+"lety"}}var r="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),i="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),a=e.defineLocale("cs",{months:r,monthsShort:i,monthsParse:function(e,t){var n,r=[];for(n=0;n<12;n++)r[n]=new RegExp("^"+e[n]+"$|^"+t[n]+"$","i");return r}(r,i),shortMonthsParse:function(e){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp("^"+e[t]+"$","i");return n}(i),longMonthsParse:function(e){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp("^"+e[t]+"$","i");return n}(r),weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("cv",{months:"кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),monthsShort:"кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),weekdays:"вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),weekdaysShort:"выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),weekdaysMin:"вр_тн_ыт_юн_кҫ_эр_шм".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",LLL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",LLLL:"dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"},calendar:{sameDay:"[Паян] LT [сехетре]",nextDay:"[Ыран] LT [сехетре]",lastDay:"[Ӗнер] LT [сехетре]",nextWeek:"[Ҫитес] dddd LT [сехетре]",lastWeek:"[Иртнӗ] dddd LT [сехетре]",sameElse:"L"},relativeTime:{future:function(e){var t=/сехет$/i.exec(e)?"рен":/ҫул$/i.exec(e)?"тан":"ран";return e+t},past:"%s каялла",s:"пӗр-ик ҫеккунт",m:"пӗр минут",mm:"%d минут",h:"пӗр сехет",hh:"%d сехет",d:"пӗр кун",dd:"%d кун",M:"пӗр уйӑх",MM:"%d уйӑх",y:"пӗр ҫул",yy:"%d ҫул"},ordinalParse:/\d{1,2}-мӗш/,ordinal:"%d-мӗш",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn ôl",s:"ychydig eiliadau",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},ordinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var t=e,n="",r=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"];return t>20?n=40===t||50===t||60===t||80===t||100===t?"fed":"ain":t>0&&(n=r[t]),e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY HH:mm"},calendar:{sameDay:"[I dag kl.] LT",nextDay:"[I morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[I går kl.] LT",lastWeek:"[sidste] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],
MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?i[n][0]:i[n][1]}var n=e.defineLocale("de-at",{months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:t,mm:"%d Minuten",h:t,hh:"%d Stunden",d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?i[n][0]:i[n][1]}var n=e.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:t,mm:"%d Minuten",h:t,hh:"%d Stunden",d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=["ޖެނުއަރީ","ފެބްރުއަރީ","މާރިޗު","އޭޕްރީލު","މޭ","ޖޫން","ޖުލައި","އޯގަސްޓު","ސެޕްޓެމްބަރު","އޮކްޓޯބަރު","ނޮވެމްބަރު","ޑިސެމްބަރު"],n=["އާދިއްތަ","ހޯމަ","އަންގާރަ","ބުދަ","ބުރާސްފަތި","ހުކުރު","ހޮނިހިރު"],r=e.defineLocale("dv",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:"އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/މކ|މފ/,isPM:function(e){return"މފ"===e},meridiem:function(e,t,n){return e<12?"މކ":"މފ"},calendar:{sameDay:"[މިއަދު] LT",nextDay:"[މާދަމާ] LT",nextWeek:"dddd LT",lastDay:"[އިއްޔެ] LT",lastWeek:"[ފާއިތުވި] dddd LT",sameElse:"L"},relativeTime:{future:"ތެރޭގައި %s",past:"ކުރިން %s",s:"ސިކުންތުކޮޅެއް",m:"މިނިޓެއް",mm:"މިނިޓު %d",h:"ގަޑިއިރެއް",hh:"ގަޑިއިރު %d",d:"ދުވަހެއް",dd:"ދުވަސް %d",M:"މަހެއް",MM:"މަސް %d",y:"އަހަރެއް",yy:"އަހަރު %d"},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:7,doy:12}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}var n=e.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,t){return/D/.test(t.substring(0,t.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,t,n){return e>11?n?"μμ":"ΜΜ":n?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,n){var r=this._calendarEl[e],i=n&&n.hours();return t(r)&&(r=r.apply(n)),r.replace("{}",i%12===1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},ordinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec".split("_"),weekdays:"Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato".split("_"),weekdaysShort:"Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Ĵa_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D[-an de] MMMM, YYYY",LLL:"D[-an de] MMMM, YYYY HH:mm",LLLL:"dddd, [la] D[-an de] MMMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,t,n){return e>11?n?"p.t.m.":"P.T.M.":n?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodiaŭ je] LT",nextDay:"[Morgaŭ je] LT",nextWeek:"dddd [je] LT",lastDay:"[Hieraŭ je] LT",lastWeek:"[pasinta] dddd [je] LT",sameElse:"L"},relativeTime:{future:"je %s",past:"antaŭ %s",s:"sekundoj",m:"minuto",mm:"%d minutoj",h:"horo",hh:"%d horoj",d:"tago",dd:"%d tagoj",M:"monato",MM:"%d monatoj",y:"jaro",yy:"%d jaroj"},ordinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return/-MMM-/.test(r)?n[e.month()]:t[e.month()]},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return/-MMM-/.test(r)?n[e.month()]:t[e.month()]},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i={s:["mõne sekundi","mõni sekund","paar sekundit"],m:["ühe minuti","üks minut"],mm:[e+" minuti",e+" minutit"],h:["ühe tunni","tund aega","üks tund"],hh:[e+" tunni",e+" tundi"],d:["ühe päeva","üks päev"],M:["kuu aja","kuu aega","üks kuu"],MM:[e+" kuu",e+" kuud"],y:["ühe aasta","aasta","üks aasta"],yy:[e+" aasta",e+" aastat"]};return t?i[n][2]?i[n][2]:i[n][1]:r?i[n][0]:i[n][1]}var n=e.defineLocale("et",{months:"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[Täna,] LT",nextDay:"[Homme,] LT",nextWeek:"[Järgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s pärast",past:"%s tagasi",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:"%d päeva",M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},n={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"},r=e.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,t,n){return e<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چندین ثانیه",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]}).replace(/,/g,"،")},ordinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,r,i){var a="";switch(r){case"s":return i?"muutaman sekunnin":"muutama sekunti";case"m":return i?"minuutin":"minuutti";case"mm":a=i?"minuutin":"minuuttia";break;case"h":return i?"tunnin":"tunti";case"hh":a=i?"tunnin":"tuntia";break;case"d":return i?"päivän":"päivä";case"dd":a=i?"päivän":"päivää";break;case"M":return i?"kuukauden":"kuukausi";case"MM":a=i?"kuukauden":"kuukautta";break;case"y":return i?"vuoden":"vuosi";case"yy":a=i?"vuoden":"vuotta"}return a=n(e,i)+" "+a}function n(e,t){return e<10?t?i[e]:r[e]:e}var r="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),i=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",r[7],r[8],r[9]],a=e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("fo",{months:"januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),weekdaysShort:"sun_mán_týs_mik_hós_frí_ley".split("_"),weekdaysMin:"su_má_tý_mi_hó_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[Í dag kl.] LT",nextDay:"[Í morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[Í gjár kl.] LT",lastWeek:"[síðstu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s síðani",s:"fá sekund",m:"ein minutt",mm:"%d minuttir",h:"ein tími",hh:"%d tímar",d:"ein dagur",dd:"%d dagar",M:"ein mánaði",MM:"%d mánaðir",y:"eitt ár",yy:"%d ár"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|e)/,ordinal:function(e){return e+(1===e?"er":"e")}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|e)/,ordinal:function(e){return e+(1===e?"er":"e")},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|)/,ordinal:function(e){return e+(1===e?"er":"")},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t="jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),n="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),r=e.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,r){return/-MMM-/.test(r)?n[e.month()]:t[e.month()]},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[ôfrûne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",m:"ien minút",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=["Am Faoilleach","An Gearran","Am Màrt","An Giblean","An Cèitean","An t-Ògmhios","An t-Iuchar","An Lùnastal","An t-Sultain","An Dàmhair","An t-Samhain","An Dùbhlachd"],n=["Faoi","Gear","Màrt","Gibl","Cèit","Ògmh","Iuch","Lùn","Sult","Dàmh","Samh","Dùbh"],r=["Didòmhnaich","Diluain","Dimàirt","Diciadain","Diardaoin","Dihaoine","Disathairne"],i=["Did","Dil","Dim","Dic","Dia","Dih","Dis"],a=["Dò","Lu","Mà","Ci","Ar","Ha","Sa"],o=e.defineLocale("gd",{months:t,monthsShort:n,monthsParseExact:!0,weekdays:r,weekdaysShort:i,weekdaysMin:a,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-màireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-dè aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"mìos",MM:"%d mìosan",y:"bliadhna",yy:"%d bliadhna"},ordinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){var t=1===e?"d":e%10===2?"na":"mh";return e+t},week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),weekdaysShort:"dom._lun._mar._mér._xov._ven._sáb.".split("_"),weekdaysMin:"do_lu_ma_mé_xo_ve_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":e%10===0&&10!==e?e+" שנה":e+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,t,n){return e<5?"לפנות בוקר":e<10?"בבוקר":e<12?n?'לפנה"צ':"לפני הצהריים":e<18?n?'אחה"צ':"אחרי הצהריים":"בערב"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},r=e.defineLocale("hi",{months:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,t){return 12===e&&(e=0),"रात"===t?e<4?e:e+12:"सुबह"===t?e:"दोपहर"===t?e>=10?e:e+12:"शाम"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"रात":e<10?"सुबह":e<17?"दोपहर":e<20?"शाम":"रात";
},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n){var r=e+" ";switch(n){case"m":return t?"jedna minuta":"jedne minute";case"mm":return r+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return t?"jedan sat":"jednog sata";case"hh":return r+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return r+=1===e?"dan":"dana";case"MM":return r+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return r+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}var n=e.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",m:t,mm:t,h:t,hh:t,d:"dan",dd:t,M:"mjesec",MM:t,y:"godinu",yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i=e;switch(n){case"s":return r||t?"néhány másodperc":"néhány másodperce";case"m":return"egy"+(r||t?" perc":" perce");case"mm":return i+(r||t?" perc":" perce");case"h":return"egy"+(r||t?" óra":" órája");case"hh":return i+(r||t?" óra":" órája");case"d":return"egy"+(r||t?" nap":" napja");case"dd":return i+(r||t?" nap":" napja");case"M":return"egy"+(r||t?" hónap":" hónapja");case"MM":return i+(r||t?" hónap":" hónapja");case"y":return"egy"+(r||t?" év":" éve");case"yy":return i+(r||t?" év":" éve")}return""}function n(e){return(e?"":"[múlt] ")+"["+r[this.day()]+"] LT[-kor]"}var r="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" "),i=e.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,t,n){return e<12?n===!0?"de":"DE":n===!0?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return n.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return n.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return i})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("hy-am",{months:{format:"հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),standalone:"հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")},monthsShort:"հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),weekdays:"կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),weekdaysShort:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),weekdaysMin:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY թ.",LLL:"D MMMM YYYY թ., HH:mm",LLLL:"dddd, D MMMM YYYY թ., HH:mm"},calendar:{sameDay:"[այսօր] LT",nextDay:"[վաղը] LT",lastDay:"[երեկ] LT",nextWeek:function(){return"dddd [օրը ժամը] LT"},lastWeek:function(){return"[անցած] dddd [օրը ժամը] LT"},sameElse:"L"},relativeTime:{future:"%s հետո",past:"%s առաջ",s:"մի քանի վայրկյան",m:"րոպե",mm:"%d րոպե",h:"ժամ",hh:"%d ժամ",d:"օր",dd:"%d օր",M:"ամիս",MM:"%d ամիս",y:"տարի",yy:"%d տարի"},meridiemParse:/գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,isPM:function(e){return/^(ցերեկվա|երեկոյան)$/.test(e)},meridiem:function(e){return e<4?"գիշերվա":e<12?"առավոտվա":e<17?"ցերեկվա":"երեկոյան"},ordinalParse:/\d{1,2}|\d{1,2}-(ին|րդ)/,ordinal:function(e,t){switch(t){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-ին":e+"-րդ";default:return e}},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"siang"===t?e>=11?e:e+12:"sore"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){return e%100===11||e%10!==1}function n(e,n,r,i){var a=e+" ";switch(r){case"s":return n||i?"nokkrar sekúndur":"nokkrum sekúndum";case"m":return n?"mínúta":"mínútu";case"mm":return t(e)?a+(n||i?"mínútur":"mínútum"):n?a+"mínúta":a+"mínútu";case"hh":return t(e)?a+(n||i?"klukkustundir":"klukkustundum"):a+"klukkustund";case"d":return n?"dagur":i?"dag":"degi";case"dd":return t(e)?n?a+"dagar":a+(i?"daga":"dögum"):n?a+"dagur":a+(i?"dag":"degi");case"M":return n?"mánuður":i?"mánuð":"mánuði";case"MM":return t(e)?n?a+"mánuðir":a+(i?"mánuði":"mánuðum"):n?a+"mánuður":a+(i?"mánuð":"mánuði");case"y":return n||i?"ár":"ári";case"yy":return t(e)?a+(n||i?"ár":"árum"):a+(n||i?"ár":"ári")}}var r=e.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:n,m:n,mm:n,h:"klukkustund",hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),weekdaysShort:"Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),weekdaysMin:"Do_Lu_Ma_Me_Gi_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ja",{months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"Ah時m分",LTS:"Ah時m分s秒",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah時m分",LLLL:"YYYY年M月D日Ah時m分 dddd"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e,t,n){return e<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:"[来週]dddd LT",lastDay:"[昨日] LT",lastWeek:"[前週]dddd LT",sameElse:"L"},ordinalParse:/\d{1,2}日/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,t){return 12===e&&(e=0),"enjing"===t?e:"siyang"===t?e>=11?e:e+12:"sonten"===t||"ndalu"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ka",{months:{standalone:"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),format:"იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს".split("_")},monthsShort:"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),weekdays:{standalone:"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),format:"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),weekdaysMin:"კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[დღეს] LT[-ზე]",nextDay:"[ხვალ] LT[-ზე]",lastDay:"[გუშინ] LT[-ზე]",nextWeek:"[შემდეგ] dddd LT[-ზე]",lastWeek:"[წინა] dddd LT-ზე",sameElse:"L"},relativeTime:{future:function(e){return/(წამი|წუთი|საათი|წელი)/.test(e)?e.replace(/ი$/,"ში"):e+"ში"},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,"ის წინ"):/წელი/.test(e)?e.replace(/წელი$/,"წლის წინ"):void 0},s:"რამდენიმე წამი",m:"წუთი",mm:"%d წუთი",h:"საათი",hh:"%d საათი",d:"დღე",dd:"%d დღე",M:"თვე",MM:"%d თვე",y:"წელი",yy:"%d წელი"},ordinalParse:/0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+"-ლი":e<20||e<=100&&e%20===0||e%100===0?"მე-"+e:e+"-ე"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={0:"-ші",1:"-ші",2:"-ші",3:"-ші",4:"-ші",5:"-ші",6:"-шы",7:"-ші",8:"-ші",9:"-шы",10:"-шы",20:"-шы",30:"-шы",40:"-шы",50:"-ші",60:"-шы",70:"-ші",80:"-ші",90:"-шы",100:"-ші"},n=e.defineLocale("kk",{months:"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),monthsShort:"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),weekdays:"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),weekdaysShort:"жек_дүй_сей_сәр_бей_жұм_сен".split("_"),weekdaysMin:"жк_дй_сй_ср_бй_жм_сн".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгін сағат] LT",nextDay:"[Ертең сағат] LT",nextWeek:"dddd [сағат] LT",lastDay:"[Кеше сағат] LT",lastWeek:"[Өткен аптаның] dddd [сағат] LT",sameElse:"L"},relativeTime:{future:"%s ішінде",past:"%s бұрын",s:"бірнеше секунд",m:"бір минут",mm:"%d минут",h:"бір сағат",hh:"%d сағат",d:"бір күн",dd:"%d күн",M:"бір ай",MM:"%d ай",y:"бір жыл",yy:"%d жыл"},ordinalParse:/\d{1,2}-(ші|шы)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("km",{months:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),monthsShort:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),weekdays:"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),weekdaysShort:"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),weekdaysMin:"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[ថ្ងៃនេះ ម៉ោង] LT",nextDay:"[ស្អែក ម៉ោង] LT",nextWeek:"dddd [ម៉ោង] LT",lastDay:"[ម្សិលមិញ ម៉ោង] LT",lastWeek:"dddd [សប្តាហ៍មុន] [ម៉ោង] LT",sameElse:"L"},relativeTime:{future:"%sទៀត",past:"%sមុន",s:"ប៉ុន្មានវិនាទី",m:"មួយនាទី",mm:"%d នាទី",h:"មួយម៉ោង",hh:"%d ម៉ោង",d:"មួយថ្ងៃ",dd:"%d ថ្ងៃ",M:"មួយខែ",MM:"%d ខែ",y:"មួយឆ្នាំ",yy:"%d ឆ្នាំ"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h시 m분",LTS:"A h시 m분 s초",L:"YYYY.MM.DD",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h시 m분",LLLL:"YYYY년 MMMM D일 dddd A h시 m분"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"일분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},ordinalParse:/\d{1,2}일/,ordinal:"%d일",meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e,t,n){return e<12?"오전":"오후"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={0:"-чү",1:"-чи",2:"-чи",3:"-чү",4:"-чү",5:"-чи",6:"-чы",7:"-чи",8:"-чи",9:"-чу",10:"-чу",20:"-чы",30:"-чу",40:"-чы",50:"-чү",60:"-чы",70:"-чи",80:"-чи",90:"-чу",100:"-чү"},n=e.defineLocale("ky",{months:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),monthsShort:"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),weekdays:"Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),weekdaysShort:"Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),weekdaysMin:"Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгүн саат] LT",nextDay:"[Эртең саат] LT",nextWeek:"dddd [саат] LT",lastDay:"[Кече саат] LT",lastWeek:"[Өткен аптанын] dddd [күнү] [саат] LT",sameElse:"L"},relativeTime:{future:"%s ичинде",past:"%s мурун",s:"бирнече секунд",m:"бир мүнөт",mm:"%d мүнөт",h:"бир саат",hh:"%d саат",d:"бир күн",dd:"%d күн",M:"бир ай",MM:"%d ай",y:"бир жыл",yy:"%d жыл"},ordinalParse:/\d{1,2}-(чи|чы|чү|чу)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return t?i[n][0]:i[n][1]}function n(e){var t=e.substr(0,e.indexOf(" "));return i(t)?"a "+e:"an "+e}function r(e){var t=e.substr(0,e.indexOf(" "));return i(t)?"viru "+e:"virun "+e}function i(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var t=e%10,n=e/10;return i(0===t?n:t)}if(e<1e4){for(;e>=10;)e/=10;return i(e)}return e/=1e3,i(e)}var a=e.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:n,past:r,s:"e puer Sekonnen",m:t,mm:"%d Minutten",h:t,hh:"%d Stonnen",d:t,dd:"%d Deeg",M:t,MM:"%d Méint",y:t,yy:"%d Joer"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("lo",{months:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),monthsShort:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),weekdays:"ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysShort:"ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysMin:"ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"ວັນdddd D MMMM YYYY HH:mm"},meridiemParse:/ຕອນເຊົ້າ|ຕອນແລງ/,isPM:function(e){return"ຕອນແລງ"===e},meridiem:function(e,t,n){return e<12?"ຕອນເຊົ້າ":"ຕອນແລງ"},calendar:{sameDay:"[ມື້ນີ້ເວລາ] LT",nextDay:"[ມື້ອື່ນເວລາ] LT",nextWeek:"[ວັນ]dddd[ໜ້າເວລາ] LT",lastDay:"[ມື້ວານນີ້ເວລາ] LT",lastWeek:"[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",sameElse:"L"},relativeTime:{future:"ອີກ %s",past:"%sຜ່ານມາ",s:"ບໍ່ເທົ່າໃດວິນາທີ",m:"1 ນາທີ",mm:"%d ນາທີ",h:"1 ຊົ່ວໂມງ",hh:"%d ຊົ່ວໂມງ",d:"1 ມື້",dd:"%d ມື້",M:"1 ເດືອນ",MM:"%d ເດືອນ",y:"1 ປີ",yy:"%d ປີ"},ordinalParse:/(ທີ່)\d{1,2}/,ordinal:function(e){return"ທີ່"+e}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){return t?"kelios sekundės":r?"kelių sekundžių":"kelias sekundes"}function n(e,t,n,r){return t?i(n)[0]:r?i(n)[1]:i(n)[2]}function r(e){return e%10===0||e>10&&e<20}function i(e){return o[e].split("_")}function a(e,t,a,o){var s=e+" ";return 1===e?s+n(e,t,a[0],o):t?s+(r(e)?i(a)[1]:i(a)[0]):o?s+i(a)[1]:s+(r(e)?i(a)[1]:i(a)[2])}var o={m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"},s=e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:t,m:n,mm:a,h:n,hh:a,d:n,dd:a,M:n,MM:a,y:n,yy:a},ordinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});return s})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n){return n?t%10===1&&t%100!==11?e[2]:e[3]:t%10===1&&t%100!==11?e[0]:e[1]}function n(e,n,r){return e+" "+t(a[r],e,n)}function r(e,n,r){return t(a[r],e,n)}function i(e,t){return t?"dažas sekundes":"dažām sekundēm"}var a={m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")},o=e.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:i,m:r,mm:n,h:r,hh:n,d:r,dd:n,M:r,MM:n,y:r,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={words:{m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var i=t.words[r];return 1===r.length?n?i[0]:i[1]:e+" "+t.correctGrammaticalCase(e,i)}},n=e.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){var e=["[prošle] [nedjelje] [u] LT","[prošlog] [ponedjeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srijede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:"dan",dd:t.translate,M:"mjesec",MM:t.translate,y:"godinu",yy:t.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("mi",{months:"Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),weekdaysShort:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),weekdaysMin:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te hēkona ruarua",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"после %s",past:"пред %s",s:"неколку секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",M:"месец",MM:"%d месеци",y:"година",yy:"%d години"},ordinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+"-ев":0===n?e+"-ен":n>10&&n<20?e+"-ти":1===t?e+"-ви":2===t?e+"-ри":7===t||8===t?e+"-ми":e+"-ти"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ml",{months:"ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),monthsShort:"ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),monthsParseExact:!0,weekdays:"ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),weekdaysShort:"ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),weekdaysMin:"ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),longDateFormat:{LT:"A h:mm -നു",LTS:"A h:mm:ss -നു",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -നു",LLLL:"dddd, D MMMM YYYY, A h:mm -നു"},calendar:{sameDay:"[ഇന്ന്] LT",nextDay:"[നാളെ] LT",nextWeek:"dddd, LT",lastDay:"[ഇന്നലെ] LT",lastWeek:"[കഴിഞ്ഞ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s കഴിഞ്ഞ്",past:"%s മുൻപ്",s:"അൽപ നിമിഷങ്ങൾ",m:"ഒരു മിനിറ്റ്",mm:"%d മിനിറ്റ്",h:"ഒരു മണിക്കൂർ",hh:"%d മണിക്കൂർ",d:"ഒരു ദിവസം",dd:"%d ദിവസം",M:"ഒരു മാസം",MM:"%d മാസം",y:"ഒരു വർഷം",yy:"%d വർഷം"},meridiemParse:/രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,meridiemHour:function(e,t){return 12===e&&(e=0),"രാത്രി"===t&&e>=4||"ഉച്ച കഴിഞ്ഞ്"===t||"വൈകുന്നേരം"===t?e+12:e},meridiem:function(e,t,n){return e<4?"രാത്രി":e<12?"രാവിലെ":e<17?"ഉച്ച കഴിഞ്ഞ്":e<20?"വൈകുന്നേരം":"രാത്രി"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i="";if(t)switch(n){case"s":i="काही सेकंद";break;case"m":i="एक मिनिट";break;case"mm":i="%d मिनिटे";break;case"h":i="एक तास";break;case"hh":i="%d तास";break;case"d":i="एक दिवस";break;case"dd":i="%d दिवस";break;case"M":i="एक महिना";break;case"MM":i="%d महिने";break;case"y":i="एक वर्ष";break;case"yy":i="%d वर्षे"}else switch(n){case"s":i="काही सेकंदां";break;case"m":i="एका मिनिटा";break;case"mm":i="%d मिनिटां";break;case"h":i="एका तासा";break;case"hh":i="%d तासां";break;case"d":i="एका दिवसा";break;case"dd":i="%d दिवसां";break;case"M":i="एका महिन्या";break;case"MM":i="%d महिन्यां";break;case"y":i="एका वर्षा";break;case"yy":i="%d वर्षां"}return i.replace(/%d/i,e)}var n={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},r={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},i=e.defineLocale("mr",{months:"जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),monthsShort:"जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm वाजता",LTS:"A h:mm:ss वाजता",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm वाजता",LLLL:"dddd, D MMMM YYYY, A h:mm वाजता"},calendar:{sameDay:"[आज] LT",nextDay:"[उद्या] LT",nextWeek:"dddd, LT",lastDay:"[काल] LT",lastWeek:"[मागील] dddd, LT",sameElse:"L"},relativeTime:{future:"%sमध्ये",past:"%sपूर्वी",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return r[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return n[e]})},meridiemParse:/रात्री|सकाळी|दुपारी|सायंकाळी/,meridiemHour:function(e,t){return 12===e&&(e=0),"रात्री"===t?e<4?e:e+12:"सकाळी"===t?e:"दुपारी"===t?e>=10?e:e+12:"सायंकाळी"===t?e+12:void 0;
},meridiem:function(e,t,n){return e<4?"रात्री":e<10?"सकाळी":e<17?"दुपारी":e<20?"सायंकाळी":"रात्री"},week:{dow:0,doy:6}});return i})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"tengahari"===t?e>=11?e:e+12:"petang"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"tengahari"===t?e>=11?e:e+12:"petang"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"၁",2:"၂",3:"၃",4:"၄",5:"၅",6:"၆",7:"၇",8:"၈",9:"၉",0:"၀"},n={"၁":"1","၂":"2","၃":"3","၄":"4","၅":"5","၆":"6","၇":"7","၈":"8","၉":"9","၀":"0"},r=e.defineLocale("my",{months:"ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),monthsShort:"ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),weekdays:"တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),weekdaysShort:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),weekdaysMin:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ယနေ.] LT [မှာ]",nextDay:"[မနက်ဖြန်] LT [မှာ]",nextWeek:"dddd LT [မှာ]",lastDay:"[မနေ.က] LT [မှာ]",lastWeek:"[ပြီးခဲ့သော] dddd LT [မှာ]",sameElse:"L"},relativeTime:{future:"လာမည့် %s မှာ",past:"လွန်ခဲ့သော %s က",s:"စက္ကန်.အနည်းငယ်",m:"တစ်မိနစ်",mm:"%d မိနစ်",h:"တစ်နာရီ",hh:"%d နာရီ",d:"တစ်ရက်",dd:"%d ရက်",M:"တစ်လ",MM:"%d လ",y:"တစ်နှစ်",yy:"%d နှစ်"},preparse:function(e){return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},week:{dow:1,doy:4}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},r=e.defineLocale("ne",{months:"जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),monthsShort:"जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),monthsParseExact:!0,weekdays:"आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),weekdaysShort:"आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),weekdaysMin:"आ._सो._मं._बु._बि._शु._श.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"Aको h:mm बजे",LTS:"Aको h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, Aको h:mm बजे",LLLL:"dddd, D MMMM YYYY, Aको h:mm बजे"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/राति|बिहान|दिउँसो|साँझ/,meridiemHour:function(e,t){return 12===e&&(e=0),"राति"===t?e<4?e:e+12:"बिहान"===t?e:"दिउँसो"===t?e>=10?e:e+12:"साँझ"===t?e+12:void 0},meridiem:function(e,t,n){return e<3?"राति":e<12?"बिहान":e<16?"दिउँसो":e<20?"साँझ":"राति"},calendar:{sameDay:"[आज] LT",nextDay:"[भोलि] LT",nextWeek:"[आउँदो] dddd[,] LT",lastDay:"[हिजो] LT",lastWeek:"[गएको] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%sमा",past:"%s अगाडि",s:"केही क्षण",m:"एक मिनेट",mm:"%d मिनेट",h:"एक घण्टा",hh:"%d घण्टा",d:"एक दिन",dd:"%d दिन",M:"एक महिना",MM:"%d महिना",y:"एक बर्ष",yy:"%d बर्ष"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),r=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],i=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,a=e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,r){return/-MMM-/.test(r)?n[e.month()]:t[e.month()]},monthsRegex:i,monthsShortRegex:i,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"Zo_Ma_Di_Wo_Do_Vr_Za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),r=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],i=/^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,a=e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,r){return/-MMM-/.test(r)?n[e.month()]:t[e.month()]},monthsRegex:i,monthsShortRegex:i,monthsStrictRegex:/^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"Zo_Ma_Di_Wo_Do_Vr_Za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_mån_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_må_ty_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"੧",2:"੨",3:"੩",4:"੪",5:"੫",6:"੬",7:"੭",8:"੮",9:"੯",0:"੦"},n={"੧":"1","੨":"2","੩":"3","੪":"4","੫":"5","੬":"6","੭":"7","੮":"8","੯":"9","੦":"0"},r=e.defineLocale("pa-in",{months:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),monthsShort:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),weekdays:"ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),weekdaysShort:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),weekdaysMin:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),longDateFormat:{LT:"A h:mm ਵਜੇ",LTS:"A h:mm:ss ਵਜੇ",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm ਵਜੇ",LLLL:"dddd, D MMMM YYYY, A h:mm ਵਜੇ"},calendar:{sameDay:"[ਅਜ] LT",nextDay:"[ਕਲ] LT",nextWeek:"dddd, LT",lastDay:"[ਕਲ] LT",lastWeek:"[ਪਿਛਲੇ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ਵਿੱਚ",past:"%s ਪਿਛਲੇ",s:"ਕੁਝ ਸਕਿੰਟ",m:"ਇਕ ਮਿੰਟ",mm:"%d ਮਿੰਟ",h:"ਇੱਕ ਘੰਟਾ",hh:"%d ਘੰਟੇ",d:"ਇੱਕ ਦਿਨ",dd:"%d ਦਿਨ",M:"ਇੱਕ ਮਹੀਨਾ",MM:"%d ਮਹੀਨੇ",y:"ਇੱਕ ਸਾਲ",yy:"%d ਸਾਲ"},preparse:function(e){return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,meridiemHour:function(e,t){return 12===e&&(e=0),"ਰਾਤ"===t?e<4?e:e+12:"ਸਵੇਰ"===t?e:"ਦੁਪਹਿਰ"===t?e>=10?e:e+12:"ਸ਼ਾਮ"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"ਰਾਤ":e<10?"ਸਵੇਰ":e<17?"ਦੁਪਹਿਰ":e<20?"ਸ਼ਾਮ":"ਰਾਤ"},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){return e%10<5&&e%10>1&&~~(e/10)%10!==1}function n(e,n,r){var i=e+" ";switch(r){case"m":return n?"minuta":"minutę";case"mm":return i+(t(e)?"minuty":"minut");case"h":return n?"godzina":"godzinę";case"hh":return i+(t(e)?"godziny":"godzin");case"MM":return i+(t(e)?"miesiące":"miesięcy");case"yy":return i+(t(e)?"lata":"lat")}}var r="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),i="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),a=e.defineLocale("pl",{months:function(e,t){return""===t?"("+i[e.month()]+"|"+r[e.month()]+")":/D MMMM/.test(t)?i[e.month()]:r[e.month()]},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:"[W] dddd [o] LT",lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",m:n,mm:n,h:n,hh:n,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:n,y:"rok",yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("pt-br",{months:"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Dom_2ª_3ª_4ª_5ª_6ª_Sáb".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"%s atrás",s:"poucos segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº"});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("pt",{months:"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Dom_2ª_3ª_4ª_5ª_6ª_Sáb".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n){var r={mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"},i=" ";return(e%100>=20||e>=100&&e%100===0)&&(i=" de "),e+i+r[n]}var n=e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",m:"un minut",mm:t,h:"o oră",hh:t,d:"o zi",dd:t,M:"o lună",MM:t,y:"un an",yy:t},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t){var n=e.split("_");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var i={mm:n?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"};return"m"===r?n?"минута":"минуту":e+" "+t(i[r],+e)}var r=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i],i=e.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:r,longMonthsParse:r,shortMonthsParse:r,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., HH:mm",LLLL:"dddd, D MMMM YYYY г., HH:mm"},calendar:{sameDay:"[Сегодня в] LT",nextDay:"[Завтра в] LT",lastDay:"[Вчера в] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В следующее] dddd [в] LT";case 1:case 2:case 4:return"[В следующий] dddd [в] LT";case 3:case 5:case 6:return"[В следующую] dddd [в] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",m:n,mm:n,h:"час",hh:n,d:"день",dd:n,M:"месяц",MM:n,y:"год",yy:n},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночи":e<12?"утра":e<17?"дня":"вечера"},ordinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:7}});return i})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("se",{months:"ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),monthsShort:"ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),weekdays:"sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),weekdaysShort:"sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s geažes",past:"maŋit %s",s:"moadde sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta mánnu",MM:"%d mánut",y:"okta jahki",yy:"%d jagit"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("si",{months:"ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),monthsShort:"ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),weekdays:"ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),weekdaysShort:"ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),weekdaysMin:"ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [වැනි] dddd, a h:mm:ss"},calendar:{sameDay:"[අද] LT[ට]",nextDay:"[හෙට] LT[ට]",nextWeek:"dddd LT[ට]",lastDay:"[ඊයේ] LT[ට]",lastWeek:"[පසුගිය] dddd LT[ට]",sameElse:"L"},relativeTime:{future:"%sකින්",past:"%sකට පෙර",s:"තත්පර කිහිපය",m:"මිනිත්තුව",mm:"මිනිත්තු %d",h:"පැය",hh:"පැය %d",d:"දිනය",dd:"දින %d",M:"මාසය",MM:"මාස %d",y:"වසර",yy:"වසර %d"},ordinalParse:/\d{1,2} වැනි/,ordinal:function(e){return e+" වැනි"},meridiemParse:/පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,isPM:function(e){return"ප.ව."===e||"පස් වරු"===e},meridiem:function(e,t,n){return e>11?n?"ප.ව.":"පස් වරු":n?"පෙ.ව.":"පෙර වරු"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){return e>1&&e<5}function n(e,n,r,i){var a=e+" ";switch(r){case"s":return n||i?"pár sekúnd":"pár sekundami";case"m":return n?"minúta":i?"minútu":"minútou";case"mm":return n||i?a+(t(e)?"minúty":"minút"):a+"minútami";case"h":return n?"hodina":i?"hodinu":"hodinou";case"hh":return n||i?a+(t(e)?"hodiny":"hodín"):a+"hodinami";case"d":return n||i?"deň":"dňom";case"dd":return n||i?a+(t(e)?"dni":"dní"):a+"dňami";case"M":return n||i?"mesiac":"mesiacom";case"MM":return n||i?a+(t(e)?"mesiace":"mesiacov"):a+"mesiacmi";case"y":return n||i?"rok":"rokom";case"yy":return n||i?a+(t(e)?"roky":"rokov"):a+"rokmi"}}var r="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),i="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_"),a=e.defineLocale("sk",{months:r,monthsShort:i,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i=e+" ";switch(n){case"s":return t||r?"nekaj sekund":"nekaj sekundami";case"m":return t?"ena minuta":"eno minuto";case"mm":return i+=1===e?t?"minuta":"minuto":2===e?t||r?"minuti":"minutama":e<5?t||r?"minute":"minutami":t||r?"minut":"minutami";case"h":return t?"ena ura":"eno uro";case"hh":return i+=1===e?t?"ura":"uro":2===e?t||r?"uri":"urama":e<5?t||r?"ure":"urami":t||r?"ur":"urami";case"d":return t||r?"en dan":"enim dnem";case"dd":return i+=1===e?t||r?"dan":"dnem":2===e?t||r?"dni":"dnevoma":t||r?"dni":"dnevi";case"M":return t||r?"en mesec":"enim mesecem";case"MM":return i+=1===e?t||r?"mesec":"mesecem":2===e?t||r?"meseca":"mesecema":e<5?t||r?"mesece":"meseci":t||r?"mesecev":"meseci";case"y":return t||r?"eno leto":"enim letom";case"yy":return i+=1===e?t||r?"leto":"letom":2===e?t||r?"leti":"letoma":e<5?t||r?"leta":"leti":t||r?"let":"leti"}}var n=e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),weekdays:"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),weekdaysShort:"Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_Më_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,t,n){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot në] LT",nextDay:"[Nesër në] LT",nextWeek:"dddd [në] LT",lastDay:"[Dje në] LT",lastWeek:"dddd [e kaluar në] LT",sameElse:"L"},relativeTime:{future:"në %s",past:"%s më parë",s:"disa sekonda",m:"një minutë",mm:"%d minuta",h:"një orë",hh:"%d orë",d:"një ditë",dd:"%d ditë",M:"një muaj",MM:"%d muaj",y:"një vit",yy:"%d vite"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={words:{m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var i=t.words[r];return 1===r.length?n?i[0]:i[1]:e+" "+t.correctGrammaticalCase(e,i)}},n=e.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){var e=["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:"дан",dd:t.translate,M:"месец",MM:t.translate,y:"годину",yy:t.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={words:{m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var i=t.words[r];return 1===r.length?n?i[0]:i[1]:e+" "+t.correctGrammaticalCase(e,i)}},n=e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",
lastWeek:function(){var e=["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:"dan",dd:t.translate,M:"mesec",MM:t.translate,y:"godinu",yy:t.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,t,n){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,t){return 12===e&&(e=0),"ekuseni"===t?e:"emini"===t?e>=11?e:e+12:"entsambama"===t||"ebusuku"===t?0===e?0:e+12:void 0},ordinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"e":1===t?"a":2===t?"a":"e";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"masiku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"௧",2:"௨",3:"௩",4:"௪",5:"௫",6:"௬",7:"௭",8:"௮",9:"௯",0:"௦"},n={"௧":"1","௨":"2","௩":"3","௪":"4","௫":"5","௬":"6","௭":"7","௮":"8","௯":"9","௦":"0"},r=e.defineLocale("ta",{months:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),monthsShort:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),weekdays:"ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),weekdaysShort:"ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),weekdaysMin:"ஞா_தி_செ_பு_வி_வெ_ச".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[இன்று] LT",nextDay:"[நாளை] LT",nextWeek:"dddd, LT",lastDay:"[நேற்று] LT",lastWeek:"[கடந்த வாரம்] dddd, LT",sameElse:"L"},relativeTime:{future:"%s இல்",past:"%s முன்",s:"ஒரு சில விநாடிகள்",m:"ஒரு நிமிடம்",mm:"%d நிமிடங்கள்",h:"ஒரு மணி நேரம்",hh:"%d மணி நேரம்",d:"ஒரு நாள்",dd:"%d நாட்கள்",M:"ஒரு மாதம்",MM:"%d மாதங்கள்",y:"ஒரு வருடம்",yy:"%d ஆண்டுகள்"},ordinalParse:/\d{1,2}வது/,ordinal:function(e){return e+"வது"},preparse:function(e){return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return t[e]})},meridiemParse:/யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,meridiem:function(e,t,n){return e<2?" யாமம்":e<6?" வைகறை":e<10?" காலை":e<14?" நண்பகல்":e<18?" எற்பாடு":e<22?" மாலை":" யாமம்"},meridiemHour:function(e,t){return 12===e&&(e=0),"யாமம்"===t?e<2?e:e+12:"வைகறை"===t||"காலை"===t?e:"நண்பகல்"===t&&e>=10?e:e+12},week:{dow:0,doy:6}});return r})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("te",{months:"జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),monthsShort:"జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),monthsParseExact:!0,weekdays:"ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),weekdaysShort:"ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),weekdaysMin:"ఆ_సో_మం_బు_గు_శు_శ".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[నేడు] LT",nextDay:"[రేపు] LT",nextWeek:"dddd, LT",lastDay:"[నిన్న] LT",lastWeek:"[గత] dddd, LT",sameElse:"L"},relativeTime:{future:"%s లో",past:"%s క్రితం",s:"కొన్ని క్షణాలు",m:"ఒక నిమిషం",mm:"%d నిమిషాలు",h:"ఒక గంట",hh:"%d గంటలు",d:"ఒక రోజు",dd:"%d రోజులు",M:"ఒక నెల",MM:"%d నెలలు",y:"ఒక సంవత్సరం",yy:"%d సంవత్సరాలు"},ordinalParse:/\d{1,2}వ/,ordinal:"%dవ",meridiemParse:/రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,meridiemHour:function(e,t){return 12===e&&(e=0),"రాత్రి"===t?e<4?e:e+12:"ఉదయం"===t?e:"మధ్యాహ్నం"===t?e>=10?e:e+12:"సాయంత్రం"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"రాత్రి":e<10?"ఉదయం":e<17?"మధ్యాహ్నం":e<20?"సాయంత్రం":"రాత్రి"},week:{dow:0,doy:6}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sext_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Sex_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"minutu balun",m:"minutu ida",mm:"minutus %d",h:"horas ida",hh:"horas %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY/MM/DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e,t,n){return e<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},ordinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e){var t=e;return t=e.indexOf("jaj")!==-1?t.slice(0,-3)+"leS":e.indexOf("jar")!==-1?t.slice(0,-3)+"waQ":e.indexOf("DIS")!==-1?t.slice(0,-3)+"nem":t+" pIq"}function n(e){var t=e;return t=e.indexOf("jaj")!==-1?t.slice(0,-3)+"Hu’":e.indexOf("jar")!==-1?t.slice(0,-3)+"wen":e.indexOf("DIS")!==-1?t.slice(0,-3)+"ben":t+" ret"}function r(e,t,n,r){var a=i(e);switch(n){case"mm":return a+" tup";case"hh":return a+" rep";case"dd":return a+" jaj";case"MM":return a+" jar";case"yy":return a+" DIS"}}function i(e){var t=Math.floor(e%1e3/100),n=Math.floor(e%100/10),r=e%10,i="";return t>0&&(i+=a[t]+"vatlh"),n>0&&(i+=(""!==i?" ":"")+a[n]+"maH"),r>0&&(i+=(""!==i?" ":"")+a[r]),""===i?"pagh":i}var a="pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_"),o=e.defineLocale("tlh",{months:"tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),monthsShort:"jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa’leS] LT",nextWeek:"LLL",lastDay:"[wa’Hu’] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:t,past:n,s:"puS lup",m:"wa’ tup",mm:r,h:"wa’ rep",hh:r,d:"wa’ jaj",dd:r,M:"wa’ jar",MM:r,y:"wa’ DIS",yy:r},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return o})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"},n=e.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[haftaya] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen hafta] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinalParse:/\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,ordinal:function(e){if(0===e)return e+"'ıncı";var n=e%10,r=e%100-n,i=e>=100?100:null;return e+(t[n]||t[r]||t[i])},week:{dow:1,doy:7}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t,n,r){var i={s:["viensas secunds","'iensas secunds"],m:["'n míut","'iens míut"],mm:[e+" míuts",""+e+" míuts"],h:["'n þora","'iensa þora"],hh:[e+" þoras",""+e+" þoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",""+e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",""+e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",""+e+" ars"]};return r?i[n][0]:t?i[n][0]:i[n][1]}var n=e.defineLocale("tzl",{months:"Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),weekdaysShort:"Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),weekdaysMin:"Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,t,n){return e>11?n?"d'o":"D'O":n?"d'a":"D'A"},calendar:{sameDay:"[oxhi à] LT",nextDay:"[demà à] LT",nextWeek:"dddd [à] LT",lastDay:"[ieiri à] LT",lastWeek:"[sür el] dddd [lasteu à] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return n})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("tzm-latn",{months:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",m:"minuḍ",mm:"%d minuḍ",h:"saɛa",hh:"%d tassaɛin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("tzm",{months:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),monthsShort:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),weekdays:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysShort:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysMin:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ⴰⵙⴷⵅ ⴴ] LT",nextDay:"[ⴰⵙⴽⴰ ⴴ] LT",nextWeek:"dddd [ⴴ] LT",lastDay:"[ⴰⵚⴰⵏⵜ ⴴ] LT",lastWeek:"dddd [ⴴ] LT",sameElse:"L"},relativeTime:{future:"ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",past:"ⵢⴰⵏ %s",s:"ⵉⵎⵉⴽ",m:"ⵎⵉⵏⵓⴺ",mm:"%d ⵎⵉⵏⵓⴺ",h:"ⵙⴰⵄⴰ",hh:"%d ⵜⴰⵙⵙⴰⵄⵉⵏ",d:"ⴰⵙⵙ",dd:"%d oⵙⵙⴰⵏ",M:"ⴰⵢoⵓⵔ",MM:"%d ⵉⵢⵢⵉⵔⵏ",y:"ⴰⵙⴳⴰⵙ",yy:"%d ⵉⵙⴳⴰⵙⵏ"},week:{dow:6,doy:12}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";function t(e,t){var n=e.split("_");return t%10===1&&t%100!==11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){var i={mm:n?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:n?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"};return"m"===r?n?"хвилина":"хвилину":"h"===r?n?"година":"годину":e+" "+t(i[r],+e)}function r(e,t){var n={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")},r=/(\[[ВвУу]\]) ?dddd/.test(t)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(t)?"genitive":"nominative";return n[r][e.day()]}function i(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}var a=e.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:r,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:i("[Сьогодні "),nextDay:i("[Завтра "),lastDay:i("[Вчора "),nextWeek:i("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return i("[Минулої] dddd [").call(this);case 1:case 2:case 4:return i("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",m:n,mm:n,h:"годину",hh:n,d:"день",dd:n,M:"місяць",MM:n,y:"рік",yy:n},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночі":e<12?"ранку":e<17?"дня":"вечора"},ordinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":case"w":case"W":return e+"-й";case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}});return a})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("uz",{months:"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),monthsShort:"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),weekdays:"Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),weekdaysShort:"Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),weekdaysMin:"Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Бугун соат] LT [да]",nextDay:"[Эртага] LT [да]",nextWeek:"dddd [куни соат] LT [да]",lastDay:"[Кеча соат] LT [да]",lastWeek:"[Утган] dddd [куни соат] LT [да]",sameElse:"L"},relativeTime:{future:"Якин %s ичида",past:"Бир неча %s олдин",s:"фурсат",m:"бир дакика",mm:"%d дакика",h:"бир соат",hh:"%d соат",d:"бир кун",dd:"%d кун",M:"бир ой",MM:"%d ой",y:"бир йил",yy:"%d йил"},week:{dow:1,doy:7}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,t,n){return e<12?n?"sa":"SA":n?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần rồi lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},ordinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("x-pseudo",{months:"J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),monthsShort:"J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),monthsParseExact:!0,weekdays:"S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),weekdaysShort:"S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),weekdaysMin:"S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~ódá~ý át] LT",nextDay:"[T~ómó~rró~w át] LT",nextWeek:"dddd [át] LT",lastDay:"[Ý~ést~érdá~ý át] LT",lastWeek:"[L~ást] dddd [át] LT",sameElse:"L"},relativeTime:{future:"í~ñ %s",past:"%s á~gó",s:"á ~féw ~sécó~ñds",m:"á ~míñ~úté",mm:"%d m~íñú~tés",h:"á~ñ hó~úr",hh:"%d h~óúrs",d:"á ~dáý",dd:"%d d~áýs",M:"á ~móñ~th",MM:"%d m~óñt~hs",y:"á ~ýéár",yy:"%d ý~éárs"},ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10,n=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+n},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("yo",{months:"Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),monthsShort:"Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),weekdays:"Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),weekdaysShort:"Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),weekdaysMin:"Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Ònì ni] LT",nextDay:"[Ọ̀la ni] LT",nextWeek:"dddd [Ọsẹ̀ tón'bọ] [ni] LT",lastDay:"[Àna ni] LT",lastWeek:"dddd [Ọsẹ̀ tólọ́] [ni] LT",sameElse:"L"},relativeTime:{future:"ní %s",past:"%s kọjá",s:"ìsẹjú aayá die",m:"ìsẹjú kan",mm:"ìsẹjú %d",h:"wákati kan",hh:"wákati %d",d:"ọjọ́ kan",dd:"ọjọ́ %d",M:"osù kan",MM:"osù %d",y:"ọdún kan",yy:"ọdún %d"},ordinalParse:/ọjọ́\s\d{1,2}/,ordinal:"ọjọ́ %d",week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah点mm分",LTS:"Ah点m分s秒",L:"YYYY-MM-DD",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日Ah点mm分",LLLL:"YYYY年MMMD日ddddAh点mm分",l:"YYYY-MM-DD",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日Ah点mm分",llll:"YYYY年MMMD日ddddAh点mm分"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"下午"===t||"晚上"===t?e+12:e>=11?e:e+12},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:function(){return 0===this.minutes()?"[今天]Ah[点整]":"[今天]LT"},nextDay:function(){return 0===this.minutes()?"[明天]Ah[点整]":"[明天]LT"},lastDay:function(){return 0===this.minutes()?"[昨天]Ah[点整]":"[昨天]LT"},nextWeek:function(){var t,n;return t=e().startOf("week"),n=this.diff(t,"days")>=7?"[下]":"[本]",0===this.minutes()?n+"dddAh点整":n+"dddAh点mm"},lastWeek:function(){var t,n;return t=e().startOf("week"),n=this.unix()<t.unix()?"[上]":"[本]",0===this.minutes()?n+"dddAh点整":n+"dddAh点mm"},sameElse:"LL"},ordinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s内",past:"%s前",s:"几秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("zh-hk",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah點mm分",LTS:"Ah點m分s秒",L:"YYYY年MMMD日",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日Ah點mm分",LLLL:"YYYY年MMMD日ddddAh點mm分",l:"YYYY年MMMD日",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日Ah點mm分",llll:"YYYY年MMMD日ddddAh點mm分"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},ordinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}});return t})},function(e,t,n){!function(e,t){t(n(1))}(this,function(e){"use strict";var t=e.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah點mm分",LTS:"Ah點m分s秒",L:"YYYY年MMMD日",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日Ah點mm分",LLLL:"YYYY年MMMD日ddddAh點mm分",l:"YYYY年MMMD日",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日Ah點mm分",llll:"YYYY年MMMD日ddddAh點mm分"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},ordinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}});return t})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width="{{width}}" height="{{height}}" v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"bar-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{scales:{yAxes:[{ticks:{beginAtZero:!0},gridLines:{display:!1}}],xAxes:[{gridLines:{display:!1},categoryPercentage:.5,barPercentage:.2}]}}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"bar",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"bubble-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"bubble",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"doughnut-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"doughnut",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"line-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{scales:{yAxes:[{ticks:{beginAtZero:!0},gridLines:{display:!1}}],xAxes:[{gridLines:{display:!1}}]}}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"line",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',
props:{chartId:{default:"pie-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"pie",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"polar-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"polarArea",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"radar-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"radar",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(8),a=r(i),o=n(6),s=r(o),u=n(5);t.default=a.default.extend({template:'\n    <div>\n      <canvas id="{{chartId}}" width={{width}} height={{height}} v-el:canvas></canvas>\n    </div>\n  ',props:{chartId:{default:"scatter-chart",type:String},width:{default:400,type:Number},height:{default:400,type:Number}},data:function(){return{defaultOptions:{scales:{xAxes:[{type:"linear",position:"bottom"}]}}}},methods:{render:function(e,t){var n=(0,u.mergeOptions)(this.defaultOptions,t);this._chart=new s.default(this.$els.canvas.getContext("2d"),{type:"scatter",data:e,options:n}),this._chart.generateLegend()}},beforeDestroy:function(){this._chart&&this._chart.destroy()}})},function(e,t){"use strict";e.exports=function(e){e.Bar=function(t,n){return n.type="bar",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){e.Bubble=function(t,n){return n.type="bubble",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){e.Doughnut=function(t,n){return n.type="doughnut",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){e.Line=function(t,n){return n.type="line",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){e.PolarArea=function(t,n){return n.type="polarArea",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){e.Radar=function(t,n){return n.type="radar",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){var t={hover:{mode:"single"},scales:{xAxes:[{type:"linear",position:"bottom",id:"x-axis-1"}],yAxes:[{type:"linear",position:"left",id:"y-axis-1"}]},tooltips:{callbacks:{title:function(){return""},label:function(e){return"("+e.xLabel+", "+e.yLabel+")"}}}};e.defaults.scatter=t,e.controllers.scatter=e.controllers.line,e.Scatter=function(t,n){return n.type="scatter",new e(t,n)}}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.bar={hover:{mode:"label"},scales:{xAxes:[{type:"category",categoryPercentage:.8,barPercentage:.9,gridLines:{offsetGridLines:!0}}],yAxes:[{type:"linear"}]}},e.controllers.bar=e.DatasetController.extend({dataElementType:e.elements.Rectangle,initialize:function(){var t,n=this;e.DatasetController.prototype.initialize.apply(n,arguments),t=n.getMeta(),t.stack=n.getDataset().stack,t.bar=!0},update:function(e){var t,n,r=this,i=r.getMeta().data;for(r._ruler=r.getRuler(),t=0,n=i.length;t<n;++t)r.updateElement(i[t],t,e)},updateElement:function(e,n,r){var i=this,a=i.chart,o=i.getMeta(),s=i.getDataset(),u=e.custom||{},d=a.options.elements.rectangle;e._xScale=i.getScaleForId(o.xAxisID),e._yScale=i.getScaleForId(o.yAxisID),e._datasetIndex=i.index,e._index=n,e._model={datasetLabel:s.label,label:a.data.labels[n],borderSkipped:u.borderSkipped?u.borderSkipped:d.borderSkipped,backgroundColor:u.backgroundColor?u.backgroundColor:t.getValueAtIndexOrDefault(s.backgroundColor,n,d.backgroundColor),borderColor:u.borderColor?u.borderColor:t.getValueAtIndexOrDefault(s.borderColor,n,d.borderColor),borderWidth:u.borderWidth?u.borderWidth:t.getValueAtIndexOrDefault(s.borderWidth,n,d.borderWidth)},i.updateElementGeometry(e,n,r),e.pivot()},updateElementGeometry:function(e,t,n){var r=this,i=e._model,a=r.getValueScale(),o=a.getBasePixel(),s=a.isHorizontal(),u=r._ruler||r.getRuler(),d=r.calculateBarValuePixels(r.index,t),l=r.calculateBarIndexPixels(r.index,t,u);i.horizontal=s,i.base=n?o:d.base,i.x=s?n?o:d.head:l.center,i.y=s?l.center:n?o:d.head,i.height=s?l.size:void 0,i.width=s?void 0:l.size},getValueScaleId:function(){return this.getMeta().yAxisID},getIndexScaleId:function(){return this.getMeta().xAxisID},getValueScale:function(){return this.getScaleForId(this.getValueScaleId())},getIndexScale:function(){return this.getScaleForId(this.getIndexScaleId())},getStackCount:function(e){var t,n,r=this,i=r.chart,a=r.getIndexScale(),o=a.options.stacked,s=void 0===e?i.data.datasets.length:e+1,u=[];for(t=0;t<s;++t)n=i.getDatasetMeta(t),n.bar&&i.isDatasetVisible(t)&&(o===!1||o===!0&&u.indexOf(n.stack)===-1||void 0===o&&(void 0===n.stack||u.indexOf(n.stack)===-1))&&u.push(n.stack);return u.length},getStackIndex:function(e){return this.getStackCount(e)-1},getRuler:function(){var e=this,n=e.getIndexScale(),r=n.options,i=e.getStackCount(),a=n.isHorizontal()?n.width:n.height,o=a/n.ticks.length,s=o*r.categoryPercentage,u=s/i,d=u*r.barPercentage;return d=Math.min(t.getValueOrDefault(r.barThickness,d),t.getValueOrDefault(r.maxBarThickness,1/0)),{stackCount:i,tickSize:o,categorySize:s,categorySpacing:o-s,fullBarSize:u,barSize:d,barSpacing:u-d,scale:n}},calculateBarValuePixels:function(e,t){var n,r,i,a,o,s,u=this,d=u.chart,l=u.getMeta(),c=u.getValueScale(),h=d.data.datasets,_=Number(h[e].data[t]),f=c.options.stacked,m=l.stack,p=0;if(f||void 0===f&&void 0!==m)for(n=0;n<e;++n)r=d.getDatasetMeta(n),r.bar&&r.stack===m&&r.controller.getValueScaleId()===c.id&&d.isDatasetVisible(n)&&(i=Number(h[n].data[t]),(_<0&&i<0||_>=0&&i>0)&&(p+=i));return a=c.getPixelForValue(p),o=c.getPixelForValue(p+_),s=(o-a)/2,{size:s,base:a,head:o,center:o+s/2}},calculateBarIndexPixels:function(e,t,n){var r=this,i=n.scale,a=r.chart.isCombo,o=r.getStackIndex(e),s=i.getPixelForValue(null,t,e,a),u=n.barSize;return s-=a?n.tickSize/2:0,s+=n.fullBarSize*o,s+=n.categorySpacing/2,s+=n.barSpacing/2,{size:u,base:s,head:s+u,center:s+u/2}},draw:function(){var e,n=this,r=n.chart,i=n.getMeta().data,a=n.getDataset(),o=i.length,s=0;for(t.canvas.clipArea(r.ctx,r.chartArea);s<o;++s)e=a.data[s],null===e||void 0===e||isNaN(e)||i[s].draw();t.canvas.unclipArea(r.ctx)},setHoverStyle:function(e){var n=this.chart.data.datasets[e._datasetIndex],r=e._index,i=e.custom||{},a=e._model;a.backgroundColor=i.hoverBackgroundColor?i.hoverBackgroundColor:t.getValueAtIndexOrDefault(n.hoverBackgroundColor,r,t.getHoverColor(a.backgroundColor)),a.borderColor=i.hoverBorderColor?i.hoverBorderColor:t.getValueAtIndexOrDefault(n.hoverBorderColor,r,t.getHoverColor(a.borderColor)),a.borderWidth=i.hoverBorderWidth?i.hoverBorderWidth:t.getValueAtIndexOrDefault(n.hoverBorderWidth,r,a.borderWidth)},removeHoverStyle:function(e){var n=this.chart.data.datasets[e._datasetIndex],r=e._index,i=e.custom||{},a=e._model,o=this.chart.options.elements.rectangle;a.backgroundColor=i.backgroundColor?i.backgroundColor:t.getValueAtIndexOrDefault(n.backgroundColor,r,o.backgroundColor),a.borderColor=i.borderColor?i.borderColor:t.getValueAtIndexOrDefault(n.borderColor,r,o.borderColor),a.borderWidth=i.borderWidth?i.borderWidth:t.getValueAtIndexOrDefault(n.borderWidth,r,o.borderWidth)}}),e.defaults.horizontalBar={hover:{mode:"label"},scales:{xAxes:[{type:"linear",position:"bottom"}],yAxes:[{position:"left",type:"category",categoryPercentage:.8,barPercentage:.9,gridLines:{offsetGridLines:!0}}]},elements:{rectangle:{borderSkipped:"left"}},tooltips:{callbacks:{title:function(e,t){var n="";return e.length>0&&(e[0].yLabel?n=e[0].yLabel:t.labels.length>0&&e[0].index<t.labels.length&&(n=t.labels[e[0].index])),n},label:function(e,t){var n=t.datasets[e.datasetIndex].label||"";return n+": "+e.xLabel}}}},e.controllers.horizontalBar=e.controllers.bar.extend({getValueScaleId:function(){return this.getMeta().xAxisID},getIndexScaleId:function(){return this.getMeta().yAxisID}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.bubble={hover:{mode:"single"},scales:{xAxes:[{type:"linear",position:"bottom",id:"x-axis-0"}],yAxes:[{type:"linear",position:"left",id:"y-axis-0"}]},tooltips:{callbacks:{title:function(){return""},label:function(e,t){var n=t.datasets[e.datasetIndex].label||"",r=t.datasets[e.datasetIndex].data[e.index];return n+": ("+e.xLabel+", "+e.yLabel+", "+r.r+")"}}}},e.controllers.bubble=e.DatasetController.extend({dataElementType:e.elements.Point,update:function(e){var n=this,r=n.getMeta(),i=r.data;t.each(i,function(t,r){n.updateElement(t,r,e)})},updateElement:function(n,r,i){var a=this,o=a.getMeta(),s=a.getScaleForId(o.xAxisID),u=a.getScaleForId(o.yAxisID),d=n.custom||{},l=a.getDataset(),c=l.data[r],h=a.chart.options.elements.point,_=a.index;t.extend(n,{_xScale:s,_yScale:u,_datasetIndex:_,_index:r,_model:{x:i?s.getPixelForDecimal(.5):s.getPixelForValue("object"==typeof c?c:NaN,r,_,a.chart.isCombo),y:i?u.getBasePixel():u.getPixelForValue(c,r,_),radius:i?0:d.radius?d.radius:a.getRadius(c),hitRadius:d.hitRadius?d.hitRadius:t.getValueAtIndexOrDefault(l.hitRadius,r,h.hitRadius)}}),e.DatasetController.prototype.removeHoverStyle.call(a,n,h);var f=n._model;f.skip=d.skip?d.skip:isNaN(f.x)||isNaN(f.y),n.pivot()},getRadius:function(e){return e.r||this.chart.options.elements.point.radius},setHoverStyle:function(n){var r=this;e.DatasetController.prototype.setHoverStyle.call(r,n);var i=r.chart.data.datasets[n._datasetIndex],a=n._index,o=n.custom||{},s=n._model;s.radius=o.hoverRadius?o.hoverRadius:t.getValueAtIndexOrDefault(i.hoverRadius,a,r.chart.options.elements.point.hoverRadius)+r.getRadius(i.data[a])},removeHoverStyle:function(t){var n=this;e.DatasetController.prototype.removeHoverStyle.call(n,t,n.chart.options.elements.point);var r=n.chart.data.datasets[t._datasetIndex].data[t._index],i=t.custom||{},a=t._model;a.radius=i.radius?i.radius:n.getRadius(r)}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n=e.defaults;n.doughnut={animation:{animateRotate:!0,animateScale:!1},aspectRatio:1,hover:{mode:"single"},legendCallback:function(e){var t=[];t.push('<ul class="'+e.id+'-legend">');var n=e.data,r=n.datasets,i=n.labels;if(r.length)for(var a=0;a<r[0].data.length;++a)t.push('<li><span style="background-color:'+r[0].backgroundColor[a]+'"></span>'),i[a]&&t.push(i[a]),t.push("</li>");return t.push("</ul>"),t.join("")},legend:{labels:{generateLabels:function(e){var n=e.data;return n.labels.length&&n.datasets.length?n.labels.map(function(r,i){var a=e.getDatasetMeta(0),o=n.datasets[0],s=a.data[i],u=s&&s.custom||{},d=t.getValueAtIndexOrDefault,l=e.options.elements.arc,c=u.backgroundColor?u.backgroundColor:d(o.backgroundColor,i,l.backgroundColor),h=u.borderColor?u.borderColor:d(o.borderColor,i,l.borderColor),_=u.borderWidth?u.borderWidth:d(o.borderWidth,i,l.borderWidth);return{text:r,fillStyle:c,strokeStyle:h,lineWidth:_,hidden:isNaN(o.data[i])||a.data[i].hidden,index:i}}):[]}},onClick:function(e,t){var n,r,i,a=t.index,o=this.chart;for(n=0,r=(o.data.datasets||[]).length;n<r;++n)i=o.getDatasetMeta(n),i.data[a]&&(i.data[a].hidden=!i.data[a].hidden);o.update()}},cutoutPercentage:50,rotation:Math.PI*-.5,circumference:2*Math.PI,tooltips:{callbacks:{title:function(){return""},label:function(e,n){var r=n.labels[e.index],i=": "+n.datasets[e.datasetIndex].data[e.index];return t.isArray(r)?(r=r.slice(),r[0]+=i):r+=i,r}}}},n.pie=t.clone(n.doughnut),t.extend(n.pie,{cutoutPercentage:0}),e.controllers.doughnut=e.controllers.pie=e.DatasetController.extend({dataElementType:e.elements.Arc,linkScales:t.noop,getRingIndex:function(e){for(var t=0,n=0;n<e;++n)this.chart.isDatasetVisible(n)&&++t;return t},update:function(e){var n=this,r=n.chart,i=r.chartArea,a=r.options,o=a.elements.arc,s=i.right-i.left-o.borderWidth,u=i.bottom-i.top-o.borderWidth,d=Math.min(s,u),l={x:0,y:0},c=n.getMeta(),h=a.cutoutPercentage,_=a.circumference;if(_<2*Math.PI){var f=a.rotation%(2*Math.PI);f+=2*Math.PI*(f>=Math.PI?-1:f<-Math.PI?1:0);var m=f+_,p={x:Math.cos(f),y:Math.sin(f)},g={x:Math.cos(m),y:Math.sin(m)},v=f<=0&&0<=m||f<=2*Math.PI&&2*Math.PI<=m,y=f<=.5*Math.PI&&.5*Math.PI<=m||f<=2.5*Math.PI&&2.5*Math.PI<=m,M=f<=-Math.PI&&-Math.PI<=m||f<=Math.PI&&Math.PI<=m,b=f<=.5*-Math.PI&&.5*-Math.PI<=m||f<=1.5*Math.PI&&1.5*Math.PI<=m,L=h/100,k={x:M?-1:Math.min(p.x*(p.x<0?1:L),g.x*(g.x<0?1:L)),y:b?-1:Math.min(p.y*(p.y<0?1:L),g.y*(g.y<0?1:L))},Y={x:v?1:Math.max(p.x*(p.x>0?1:L),g.x*(g.x>0?1:L)),y:y?1:Math.max(p.y*(p.y>0?1:L),g.y*(g.y>0?1:L))},x={width:.5*(Y.x-k.x),height:.5*(Y.y-k.y)};d=Math.min(s/x.width,u/x.height),l={x:(Y.x+k.x)*-.5,y:(Y.y+k.y)*-.5}}r.borderWidth=n.getMaxBorderWidth(c.data),r.outerRadius=Math.max((d-r.borderWidth)/2,0),r.innerRadius=Math.max(h?r.outerRadius/100*h:0,0),r.radiusLength=(r.outerRadius-r.innerRadius)/r.getVisibleDatasetCount(),r.offsetX=l.x*r.outerRadius,r.offsetY=l.y*r.outerRadius,c.total=n.calculateTotal(),n.outerRadius=r.outerRadius-r.radiusLength*n.getRingIndex(n.index),n.innerRadius=Math.max(n.outerRadius-r.radiusLength,0),t.each(c.data,function(t,r){n.updateElement(t,r,e)})},updateElement:function(e,n,r){var i=this,a=i.chart,o=a.chartArea,s=a.options,u=s.animation,d=(o.left+o.right)/2,l=(o.top+o.bottom)/2,c=s.rotation,h=s.rotation,_=i.getDataset(),f=r&&u.animateRotate?0:e.hidden?0:i.calculateCircumference(_.data[n])*(s.circumference/(2*Math.PI)),m=r&&u.animateScale?0:i.innerRadius,p=r&&u.animateScale?0:i.outerRadius,g=t.getValueAtIndexOrDefault;t.extend(e,{_datasetIndex:i.index,_index:n,_model:{x:d+a.offsetX,y:l+a.offsetY,startAngle:c,endAngle:h,circumference:f,outerRadius:p,innerRadius:m,label:g(_.label,n,a.data.labels[n])}});var v=e._model;this.removeHoverStyle(e),r&&u.animateRotate||(0===n?v.startAngle=s.rotation:v.startAngle=i.getMeta().data[n-1]._model.endAngle,v.endAngle=v.startAngle+v.circumference),e.pivot()},removeHoverStyle:function(t){e.DatasetController.prototype.removeHoverStyle.call(this,t,this.chart.options.elements.arc)},calculateTotal:function(){var e,n=this.getDataset(),r=this.getMeta(),i=0;return t.each(r.data,function(t,r){e=n.data[r],isNaN(e)||t.hidden||(i+=Math.abs(e))}),i},calculateCircumference:function(e){var t=this.getMeta().total;return t>0&&!isNaN(e)?2*Math.PI*(e/t):0},getMaxBorderWidth:function(e){for(var t,n,r=0,i=this.index,a=e.length,o=0;o<a;o++)t=e[o]._model?e[o]._model.borderWidth:0,n=e[o]._chart?e[o]._chart.config.data.datasets[i].hoverBorderWidth:0,r=t>r?t:r,r=n>r?n:r;return r}})}},function(e,t){"use strict";e.exports=function(e){function t(e,t){return n.getValueOrDefault(e.showLine,t.showLines)}var n=e.helpers;e.defaults.line={showLines:!0,spanGaps:!1,hover:{mode:"label"},scales:{xAxes:[{type:"category",id:"x-axis-0"}],yAxes:[{type:"linear",id:"y-axis-0"}]}},e.controllers.line=e.DatasetController.extend({datasetElementType:e.elements.Line,dataElementType:e.elements.Point,update:function(e){var r,i,a,o=this,s=o.getMeta(),u=s.dataset,d=s.data||[],l=o.chart.options,c=l.elements.line,h=o.getScaleForId(s.yAxisID),_=o.getDataset(),f=t(_,l);for(f&&(a=u.custom||{},void 0!==_.tension&&void 0===_.lineTension&&(_.lineTension=_.tension),u._scale=h,u._datasetIndex=o.index,u._children=d,u._model={spanGaps:_.spanGaps?_.spanGaps:l.spanGaps,tension:a.tension?a.tension:n.getValueOrDefault(_.lineTension,c.tension),backgroundColor:a.backgroundColor?a.backgroundColor:_.backgroundColor||c.backgroundColor,borderWidth:a.borderWidth?a.borderWidth:_.borderWidth||c.borderWidth,borderColor:a.borderColor?a.borderColor:_.borderColor||c.borderColor,borderCapStyle:a.borderCapStyle?a.borderCapStyle:_.borderCapStyle||c.borderCapStyle,borderDash:a.borderDash?a.borderDash:_.borderDash||c.borderDash,borderDashOffset:a.borderDashOffset?a.borderDashOffset:_.borderDashOffset||c.borderDashOffset,borderJoinStyle:a.borderJoinStyle?a.borderJoinStyle:_.borderJoinStyle||c.borderJoinStyle,fill:a.fill?a.fill:void 0!==_.fill?_.fill:c.fill,steppedLine:a.steppedLine?a.steppedLine:n.getValueOrDefault(_.steppedLine,c.stepped),cubicInterpolationMode:a.cubicInterpolationMode?a.cubicInterpolationMode:n.getValueOrDefault(_.cubicInterpolationMode,c.cubicInterpolationMode)},u.pivot()),r=0,i=d.length;r<i;++r)o.updateElement(d[r],r,e);for(f&&0!==u._model.tension&&o.updateBezierControlPoints(),r=0,i=d.length;r<i;++r)d[r].pivot()},getPointBackgroundColor:function(e,t){var r=this.chart.options.elements.point.backgroundColor,i=this.getDataset(),a=e.custom||{};return a.backgroundColor?r=a.backgroundColor:i.pointBackgroundColor?r=n.getValueAtIndexOrDefault(i.pointBackgroundColor,t,r):i.backgroundColor&&(r=i.backgroundColor),r},getPointBorderColor:function(e,t){var r=this.chart.options.elements.point.borderColor,i=this.getDataset(),a=e.custom||{};return a.borderColor?r=a.borderColor:i.pointBorderColor?r=n.getValueAtIndexOrDefault(i.pointBorderColor,t,r):i.borderColor&&(r=i.borderColor),r},getPointBorderWidth:function(e,t){var r=this.chart.options.elements.point.borderWidth,i=this.getDataset(),a=e.custom||{};return isNaN(a.borderWidth)?isNaN(i.pointBorderWidth)?isNaN(i.borderWidth)||(r=i.borderWidth):r=n.getValueAtIndexOrDefault(i.pointBorderWidth,t,r):r=a.borderWidth,r},updateElement:function(e,t,r){var i,a,o=this,s=o.getMeta(),u=e.custom||{},d=o.getDataset(),l=o.index,c=d.data[t],h=o.getScaleForId(s.yAxisID),_=o.getScaleForId(s.xAxisID),f=o.chart.options.elements.point,m=o.chart.data.labels||[],p=1===m.length||1===d.data.length||o.chart.isCombo;void 0!==d.radius&&void 0===d.pointRadius&&(d.pointRadius=d.radius),void 0!==d.hitRadius&&void 0===d.pointHitRadius&&(d.pointHitRadius=d.hitRadius),i=_.getPixelForValue("object"==typeof c?c:NaN,t,l,p),a=r?h.getBasePixel():o.calculatePointY(c,t,l),e._xScale=_,e._yScale=h,e._datasetIndex=l,e._index=t,e._model={x:i,y:a,skip:u.skip||isNaN(i)||isNaN(a),radius:u.radius||n.getValueAtIndexOrDefault(d.pointRadius,t,f.radius),pointStyle:u.pointStyle||n.getValueAtIndexOrDefault(d.pointStyle,t,f.pointStyle),backgroundColor:o.getPointBackgroundColor(e,t),borderColor:o.getPointBorderColor(e,t),borderWidth:o.getPointBorderWidth(e,t),tension:s.dataset._model?s.dataset._model.tension:0,steppedLine:!!s.dataset._model&&s.dataset._model.steppedLine,hitRadius:u.hitRadius||n.getValueAtIndexOrDefault(d.pointHitRadius,t,f.hitRadius)}},calculatePointY:function(e,t,n){var r,i,a,o=this,s=o.chart,u=o.getMeta(),d=o.getScaleForId(u.yAxisID),l=0,c=0;if(d.options.stacked){for(r=0;r<n;r++)if(i=s.data.datasets[r],a=s.getDatasetMeta(r),"line"===a.type&&a.yAxisID===d.id&&s.isDatasetVisible(r)){var h=Number(d.getRightValue(i.data[t]));h<0?c+=h||0:l+=h||0}var _=Number(d.getRightValue(e));return _<0?d.getPixelForValue(c+_):d.getPixelForValue(l+_)}return d.getPixelForValue(e)},updateBezierControlPoints:function(){function e(e,t,n){return Math.max(Math.min(e,n),t)}var t,r,i,a,o,s=this,u=s.getMeta(),d=s.chart.chartArea,l=u.data||[];if(u.dataset._model.spanGaps&&(l=l.filter(function(e){return!e._model.skip})),"monotone"===u.dataset._model.cubicInterpolationMode)n.splineCurveMonotone(l);else for(t=0,r=l.length;t<r;++t)i=l[t],a=i._model,o=n.splineCurve(n.previousItem(l,t)._model,a,n.nextItem(l,t)._model,u.dataset._model.tension),a.controlPointPreviousX=o.previous.x,a.controlPointPreviousY=o.previous.y,a.controlPointNextX=o.next.x,a.controlPointNextY=o.next.y;if(s.chart.options.elements.line.capBezierPoints)for(t=0,r=l.length;t<r;++t)a=l[t]._model,a.controlPointPreviousX=e(a.controlPointPreviousX,d.left,d.right),a.controlPointPreviousY=e(a.controlPointPreviousY,d.top,d.bottom),a.controlPointNextX=e(a.controlPointNextX,d.left,d.right),a.controlPointNextY=e(a.controlPointNextY,d.top,d.bottom)},draw:function(){var n=this,r=n.chart,i=n.getMeta(),a=i.data||[],o=r.chartArea,s=a.length,u=0;for(e.canvasHelpers.clipArea(r.ctx,o),t(n.getDataset(),r.options)&&i.dataset.draw(),e.canvasHelpers.unclipArea(r.ctx);u<s;++u)a[u].draw(o)},setHoverStyle:function(e){var t=this.chart.data.datasets[e._datasetIndex],r=e._index,i=e.custom||{},a=e._model;a.radius=i.hoverRadius||n.getValueAtIndexOrDefault(t.pointHoverRadius,r,this.chart.options.elements.point.hoverRadius),a.backgroundColor=i.hoverBackgroundColor||n.getValueAtIndexOrDefault(t.pointHoverBackgroundColor,r,n.getHoverColor(a.backgroundColor)),a.borderColor=i.hoverBorderColor||n.getValueAtIndexOrDefault(t.pointHoverBorderColor,r,n.getHoverColor(a.borderColor)),a.borderWidth=i.hoverBorderWidth||n.getValueAtIndexOrDefault(t.pointHoverBorderWidth,r,a.borderWidth)},removeHoverStyle:function(e){var t=this,r=t.chart.data.datasets[e._datasetIndex],i=e._index,a=e.custom||{},o=e._model;void 0!==r.radius&&void 0===r.pointRadius&&(r.pointRadius=r.radius),o.radius=a.radius||n.getValueAtIndexOrDefault(r.pointRadius,i,t.chart.options.elements.point.radius),o.backgroundColor=t.getPointBackgroundColor(e,i),o.borderColor=t.getPointBorderColor(e,i),o.borderWidth=t.getPointBorderWidth(e,i)}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.polarArea={scale:{type:"radialLinear",angleLines:{display:!1},gridLines:{circular:!0},pointLabels:{display:!1},ticks:{beginAtZero:!0}},animation:{animateRotate:!0,animateScale:!0},startAngle:-.5*Math.PI,aspectRatio:1,legendCallback:function(e){var t=[];t.push('<ul class="'+e.id+'-legend">');var n=e.data,r=n.datasets,i=n.labels;if(r.length)for(var a=0;a<r[0].data.length;++a)t.push('<li><span style="background-color:'+r[0].backgroundColor[a]+'"></span>'),i[a]&&t.push(i[a]),t.push("</li>");return t.push("</ul>"),t.join("")},legend:{labels:{generateLabels:function(e){var n=e.data;return n.labels.length&&n.datasets.length?n.labels.map(function(r,i){var a=e.getDatasetMeta(0),o=n.datasets[0],s=a.data[i],u=s.custom||{},d=t.getValueAtIndexOrDefault,l=e.options.elements.arc,c=u.backgroundColor?u.backgroundColor:d(o.backgroundColor,i,l.backgroundColor),h=u.borderColor?u.borderColor:d(o.borderColor,i,l.borderColor),_=u.borderWidth?u.borderWidth:d(o.borderWidth,i,l.borderWidth);return{text:r,fillStyle:c,strokeStyle:h,lineWidth:_,hidden:isNaN(o.data[i])||a.data[i].hidden,index:i}}):[]}},onClick:function(e,t){var n,r,i,a=t.index,o=this.chart;for(n=0,r=(o.data.datasets||[]).length;n<r;++n)i=o.getDatasetMeta(n),i.data[a].hidden=!i.data[a].hidden;o.update()}},tooltips:{callbacks:{title:function(){return""},label:function(e,t){return t.labels[e.index]+": "+e.yLabel}}}},e.controllers.polarArea=e.DatasetController.extend({dataElementType:e.elements.Arc,linkScales:t.noop,update:function(e){var n=this,r=n.chart,i=r.chartArea,a=n.getMeta(),o=r.options,s=o.elements.arc,u=Math.min(i.right-i.left,i.bottom-i.top);r.outerRadius=Math.max((u-s.borderWidth/2)/2,0),r.innerRadius=Math.max(o.cutoutPercentage?r.outerRadius/100*o.cutoutPercentage:1,0),r.radiusLength=(r.outerRadius-r.innerRadius)/r.getVisibleDatasetCount(),n.outerRadius=r.outerRadius-r.radiusLength*n.index,n.innerRadius=n.outerRadius-r.radiusLength,a.count=n.countVisibleElements(),t.each(a.data,function(t,r){n.updateElement(t,r,e)})},updateElement:function(e,n,r){for(var i=this,a=i.chart,o=i.getDataset(),s=a.options,u=s.animation,d=a.scale,l=t.getValueAtIndexOrDefault,c=a.data.labels,h=i.calculateCircumference(o.data[n]),_=d.xCenter,f=d.yCenter,m=0,p=i.getMeta(),g=0;g<n;++g)isNaN(o.data[g])||p.data[g].hidden||++m;var v=s.startAngle,y=e.hidden?0:d.getDistanceFromCenterForValue(o.data[n]),M=v+h*m,b=M+(e.hidden?0:h),L=u.animateScale?0:d.getDistanceFromCenterForValue(o.data[n]);t.extend(e,{_datasetIndex:i.index,_index:n,_scale:d,_model:{x:_,y:f,innerRadius:0,outerRadius:r?L:y,startAngle:r&&u.animateRotate?v:M,endAngle:r&&u.animateRotate?v:b,label:l(c,n,c[n])}}),i.removeHoverStyle(e),e.pivot()},removeHoverStyle:function(t){e.DatasetController.prototype.removeHoverStyle.call(this,t,this.chart.options.elements.arc)},countVisibleElements:function(){var e=this.getDataset(),n=this.getMeta(),r=0;return t.each(n.data,function(t,n){isNaN(e.data[n])||t.hidden||r++}),r},calculateCircumference:function(e){var t=this.getMeta().count;return t>0&&!isNaN(e)?2*Math.PI/t:0}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.radar={aspectRatio:1,scale:{type:"radialLinear"},elements:{line:{tension:0}}},e.controllers.radar=e.DatasetController.extend({datasetElementType:e.elements.Line,dataElementType:e.elements.Point,linkScales:t.noop,update:function(e){var n=this,r=n.getMeta(),i=r.dataset,a=r.data,o=i.custom||{},s=n.getDataset(),u=n.chart.options.elements.line,d=n.chart.scale;void 0!==s.tension&&void 0===s.lineTension&&(s.lineTension=s.tension),t.extend(r.dataset,{_datasetIndex:n.index,_scale:d,_children:a,_loop:!0,_model:{tension:o.tension?o.tension:t.getValueOrDefault(s.lineTension,u.tension),backgroundColor:o.backgroundColor?o.backgroundColor:s.backgroundColor||u.backgroundColor,borderWidth:o.borderWidth?o.borderWidth:s.borderWidth||u.borderWidth,borderColor:o.borderColor?o.borderColor:s.borderColor||u.borderColor,fill:o.fill?o.fill:void 0!==s.fill?s.fill:u.fill,borderCapStyle:o.borderCapStyle?o.borderCapStyle:s.borderCapStyle||u.borderCapStyle,borderDash:o.borderDash?o.borderDash:s.borderDash||u.borderDash,borderDashOffset:o.borderDashOffset?o.borderDashOffset:s.borderDashOffset||u.borderDashOffset,borderJoinStyle:o.borderJoinStyle?o.borderJoinStyle:s.borderJoinStyle||u.borderJoinStyle}}),r.dataset.pivot(),t.each(a,function(t,r){n.updateElement(t,r,e)},n),n.updateBezierControlPoints()},updateElement:function(e,n,r){var i=this,a=e.custom||{},o=i.getDataset(),s=i.chart.scale,u=i.chart.options.elements.point,d=s.getPointPositionForValue(n,o.data[n]);void 0!==o.radius&&void 0===o.pointRadius&&(o.pointRadius=o.radius),void 0!==o.hitRadius&&void 0===o.pointHitRadius&&(o.pointHitRadius=o.hitRadius),t.extend(e,{_datasetIndex:i.index,_index:n,_scale:s,_model:{x:r?s.xCenter:d.x,y:r?s.yCenter:d.y,tension:a.tension?a.tension:t.getValueOrDefault(o.lineTension,i.chart.options.elements.line.tension),radius:a.radius?a.radius:t.getValueAtIndexOrDefault(o.pointRadius,n,u.radius),backgroundColor:a.backgroundColor?a.backgroundColor:t.getValueAtIndexOrDefault(o.pointBackgroundColor,n,u.backgroundColor),borderColor:a.borderColor?a.borderColor:t.getValueAtIndexOrDefault(o.pointBorderColor,n,u.borderColor),borderWidth:a.borderWidth?a.borderWidth:t.getValueAtIndexOrDefault(o.pointBorderWidth,n,u.borderWidth),pointStyle:a.pointStyle?a.pointStyle:t.getValueAtIndexOrDefault(o.pointStyle,n,u.pointStyle),hitRadius:a.hitRadius?a.hitRadius:t.getValueAtIndexOrDefault(o.pointHitRadius,n,u.hitRadius)}}),e._model.skip=a.skip?a.skip:isNaN(e._model.x)||isNaN(e._model.y)},updateBezierControlPoints:function(){var e=this.chart.chartArea,n=this.getMeta();t.each(n.data,function(r,i){var a=r._model,o=t.splineCurve(t.previousItem(n.data,i,!0)._model,a,t.nextItem(n.data,i,!0)._model,a.tension);a.controlPointPreviousX=Math.max(Math.min(o.previous.x,e.right),e.left),a.controlPointPreviousY=Math.max(Math.min(o.previous.y,e.bottom),e.top),a.controlPointNextX=Math.max(Math.min(o.next.x,e.right),e.left),a.controlPointNextY=Math.max(Math.min(o.next.y,e.bottom),e.top),r.pivot()})},setHoverStyle:function(e){var n=this.chart.data.datasets[e._datasetIndex],r=e.custom||{},i=e._index,a=e._model;a.radius=r.hoverRadius?r.hoverRadius:t.getValueAtIndexOrDefault(n.pointHoverRadius,i,this.chart.options.elements.point.hoverRadius),a.backgroundColor=r.hoverBackgroundColor?r.hoverBackgroundColor:t.getValueAtIndexOrDefault(n.pointHoverBackgroundColor,i,t.getHoverColor(a.backgroundColor)),a.borderColor=r.hoverBorderColor?r.hoverBorderColor:t.getValueAtIndexOrDefault(n.pointHoverBorderColor,i,t.getHoverColor(a.borderColor)),a.borderWidth=r.hoverBorderWidth?r.hoverBorderWidth:t.getValueAtIndexOrDefault(n.pointHoverBorderWidth,i,a.borderWidth)},removeHoverStyle:function(e){var n=this.chart.data.datasets[e._datasetIndex],r=e.custom||{},i=e._index,a=e._model,o=this.chart.options.elements.point;a.radius=r.radius?r.radius:t.getValueAtIndexOrDefault(n.pointRadius,i,o.radius),a.backgroundColor=r.backgroundColor?r.backgroundColor:t.getValueAtIndexOrDefault(n.pointBackgroundColor,i,o.backgroundColor),a.borderColor=r.borderColor?r.borderColor:t.getValueAtIndexOrDefault(n.pointBorderColor,i,o.borderColor),a.borderWidth=r.borderWidth?r.borderWidth:t.getValueAtIndexOrDefault(n.pointBorderWidth,i,o.borderWidth)}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.global.animation={duration:1e3,easing:"easeOutQuart",onProgress:t.noop,onComplete:t.noop},e.Animation=e.Element.extend({chart:null,currentStep:0,numSteps:60,easing:"",render:null,onAnimationProgress:null,onAnimationComplete:null}),e.animationService={frameDuration:17,animations:[],dropFrames:0,request:null,addAnimation:function(e,t,n,r){var i,a,o=this.animations;for(t.chart=e,r||(e.animating=!0),i=0,a=o.length;i<a;++i)if(o[i].chart===e)return void(o[i]=t);o.push(t),1===o.length&&this.requestAnimationFrame()},cancelAnimation:function(e){var n=t.findIndex(this.animations,function(t){return t.chart===e});n!==-1&&(this.animations.splice(n,1),e.animating=!1)},requestAnimationFrame:function(){var e=this;null===e.request&&(e.request=t.requestAnimFrame.call(window,function(){e.request=null,e.startDigest()}))},startDigest:function(){var e=this,t=Date.now(),n=0;e.dropFrames>1&&(n=Math.floor(e.dropFrames),e.dropFrames=e.dropFrames%1),e.advance(1+n);var r=Date.now();e.dropFrames+=(r-t)/e.frameDuration,e.animations.length>0&&e.requestAnimationFrame()},advance:function(e){for(var n,r,i=this.animations,a=0;a<i.length;)n=i[a],r=n.chart,n.currentStep=(n.currentStep||0)+e,n.currentStep=Math.min(n.currentStep,n.numSteps),t.callback(n.render,[r,n],r),t.callback(n.onAnimationProgress,[n],r),n.currentStep>=n.numSteps?(t.callback(n.onAnimationComplete,[n],r),r.animating=!1,i.splice(a,1)):++a}},Object.defineProperty(e.Animation.prototype,"animationObject",{get:function(){return this}}),Object.defineProperty(e.Animation.prototype,"chartInstance",{get:function(){return this.chart},set:function(e){this.chart=e}})}},function(e,t){"use strict";e.exports=function(e){var t=e.canvasHelpers={};t.drawPoint=function(t,n,r,i,a){var o,s,u,d,l,c;if("object"==typeof n&&(o=n.toString(),"[object HTMLImageElement]"===o||"[object HTMLCanvasElement]"===o))return void t.drawImage(n,i-n.width/2,a-n.height/2,n.width,n.height);if(!(isNaN(r)||r<=0)){switch(n){default:t.beginPath(),t.arc(i,a,r,0,2*Math.PI),t.closePath(),t.fill();break;case"triangle":t.beginPath(),s=3*r/Math.sqrt(3),l=s*Math.sqrt(3)/2,t.moveTo(i-s/2,a+l/3),t.lineTo(i+s/2,a+l/3),t.lineTo(i,a-2*l/3),t.closePath(),t.fill();break;case"rect":c=1/Math.SQRT2*r,t.beginPath(),t.fillRect(i-c,a-c,2*c,2*c),t.strokeRect(i-c,a-c,2*c,2*c);break;case"rectRounded":var h=r/Math.SQRT2,_=i-h,f=a-h,m=Math.SQRT2*r;e.helpers.drawRoundedRectangle(t,_,f,m,m,r/2),t.fill();break;case"rectRot":c=1/Math.SQRT2*r,t.beginPath(),t.moveTo(i-c,a),t.lineTo(i,a+c),
t.lineTo(i+c,a),t.lineTo(i,a-c),t.closePath(),t.fill();break;case"cross":t.beginPath(),t.moveTo(i,a+r),t.lineTo(i,a-r),t.moveTo(i-r,a),t.lineTo(i+r,a),t.closePath();break;case"crossRot":t.beginPath(),u=Math.cos(Math.PI/4)*r,d=Math.sin(Math.PI/4)*r,t.moveTo(i-u,a-d),t.lineTo(i+u,a+d),t.moveTo(i-u,a+d),t.lineTo(i+u,a-d),t.closePath();break;case"star":t.beginPath(),t.moveTo(i,a+r),t.lineTo(i,a-r),t.moveTo(i-r,a),t.lineTo(i+r,a),u=Math.cos(Math.PI/4)*r,d=Math.sin(Math.PI/4)*r,t.moveTo(i-u,a-d),t.lineTo(i+u,a+d),t.moveTo(i-u,a+d),t.lineTo(i+u,a-d),t.closePath();break;case"line":t.beginPath(),t.moveTo(i-r,a),t.lineTo(i+r,a),t.closePath();break;case"dash":t.beginPath(),t.moveTo(i,a),t.lineTo(i+r,a),t.closePath()}t.stroke()}},t.clipArea=function(e,t){e.save(),e.beginPath(),e.rect(t.left,t.top,t.right-t.left,t.bottom-t.top),e.clip()},t.unclipArea=function(e){e.restore()},t.lineTo=function(e,t,n,r){return n.steppedLine?("after"===n.steppedLine?e.lineTo(t.x,n.y):e.lineTo(n.x,t.y),void e.lineTo(n.x,n.y)):n.tension?void e.bezierCurveTo(r?t.controlPointPreviousX:t.controlPointNextX,r?t.controlPointPreviousY:t.controlPointNextY,r?n.controlPointNextX:n.controlPointPreviousX,r?n.controlPointNextY:n.controlPointPreviousY,n.x,n.y):void e.lineTo(n.x,n.y)},e.helpers.canvas=t}},function(e,t){"use strict";e.exports=function(e){function t(t){t=t||{};var n=t.data=t.data||{};return n.datasets=n.datasets||[],n.labels=n.labels||[],t.options=i.configMerge(e.defaults.global,e.defaults[t.type],t.options||{}),t}function n(e){var t=e.options;t.scale?e.scale.options=t.scale:t.scales&&t.scales.xAxes.concat(t.scales.yAxes).forEach(function(t){e.scales[t.id].options=t}),e.tooltip._options=t.tooltips}function r(e){return"top"===e||"bottom"===e}var i=e.helpers,a=e.plugins,o=e.platform;e.types={},e.instances={},e.controllers={},i.extend(e.prototype,{construct:function(n,r){var a=this;r=t(r);var s=o.acquireContext(n,r),u=s&&s.canvas,d=u&&u.height,l=u&&u.width;return a.id=i.uid(),a.ctx=s,a.canvas=u,a.config=r,a.width=l,a.height=d,a.aspectRatio=d?l/d:null,a.options=r.options,a._bufferedRender=!1,a.chart=a,a.controller=a,e.instances[a.id]=a,Object.defineProperty(a,"data",{get:function(){return a.config.data},set:function(e){a.config.data=e}}),s&&u?(a.initialize(),void a.update()):void console.error("Failed to create chart: can't acquire context from the given item")},initialize:function(){var e=this;return a.notify(e,"beforeInit"),i.retinaScale(e),e.bindEvents(),e.options.responsive&&e.resize(!0),e.ensureScalesHaveIDs(),e.buildScales(),e.initToolTip(),a.notify(e,"afterInit"),e},clear:function(){return i.clear(this),this},stop:function(){return e.animationService.cancelAnimation(this),this},resize:function(e){var t=this,n=t.options,r=t.canvas,o=n.maintainAspectRatio&&t.aspectRatio||null,s=Math.floor(i.getMaximumWidth(r)),u=Math.floor(o?s/o:i.getMaximumHeight(r));if((t.width!==s||t.height!==u)&&(r.width=t.width=s,r.height=t.height=u,r.style.width=s+"px",r.style.height=u+"px",i.retinaScale(t),!e)){var d={width:s,height:u};a.notify(t,"resize",[d]),t.options.onResize&&t.options.onResize(t,d),t.stop(),t.update(t.options.responsiveAnimationDuration)}},ensureScalesHaveIDs:function(){var e=this.options,t=e.scales||{},n=e.scale;i.each(t.xAxes,function(e,t){e.id=e.id||"x-axis-"+t}),i.each(t.yAxes,function(e,t){e.id=e.id||"y-axis-"+t}),n&&(n.id=n.id||"scale")},buildScales:function(){var t=this,n=t.options,a=t.scales={},o=[];n.scales&&(o=o.concat((n.scales.xAxes||[]).map(function(e){return{options:e,dtype:"category",dposition:"bottom"}}),(n.scales.yAxes||[]).map(function(e){return{options:e,dtype:"linear",dposition:"left"}}))),n.scale&&o.push({options:n.scale,dtype:"radialLinear",isDefault:!0,dposition:"chartArea"}),i.each(o,function(n){var o=n.options,s=i.getValueOrDefault(o.type,n.dtype),u=e.scaleService.getScaleConstructor(s);if(u){r(o.position)!==r(n.dposition)&&(o.position=n.dposition);var d=new u({id:o.id,options:o,ctx:t.ctx,chart:t});a[d.id]=d,n.isDefault&&(t.scale=d)}}),e.scaleService.addScalesToLayout(this)},buildOrUpdateControllers:function(){var t=this,n=[],r=[];if(i.each(t.data.datasets,function(i,a){var o=t.getDatasetMeta(a);if(o.type||(o.type=i.type||t.config.type),n.push(o.type),o.controller)o.controller.updateIndex(a);else{var s=e.controllers[o.type];if(void 0===s)throw new Error('"'+o.type+'" is not a chart type.');o.controller=new s(t,a),r.push(o.controller)}},t),n.length>1)for(var a=1;a<n.length;a++)if(n[a]!==n[a-1]){t.isCombo=!0;break}return r},resetElements:function(){var e=this;i.each(e.data.datasets,function(t,n){e.getDatasetMeta(n).controller.reset()},e)},reset:function(){this.resetElements(),this.tooltip.initialize()},update:function(e,t){var r=this;if(n(r),a.notify(r,"beforeUpdate")!==!1){r.tooltip._data=r.data;var o=r.buildOrUpdateControllers();i.each(r.data.datasets,function(e,t){r.getDatasetMeta(t).controller.buildOrUpdateElements()},r),r.updateLayout(),i.each(o,function(e){e.reset()}),r.updateDatasets(),a.notify(r,"afterUpdate"),r._bufferedRender?r._bufferedRequest={lazy:t,duration:e}:r.render(e,t)}},updateLayout:function(){var t=this;a.notify(t,"beforeLayout")!==!1&&(e.layoutService.update(this,this.width,this.height),a.notify(t,"afterScaleUpdate"),a.notify(t,"afterLayout"))},updateDatasets:function(){var e=this;if(a.notify(e,"beforeDatasetsUpdate")!==!1){for(var t=0,n=e.data.datasets.length;t<n;++t)e.updateDataset(t);a.notify(e,"afterDatasetsUpdate")}},updateDataset:function(e){var t=this,n=t.getDatasetMeta(e),r={meta:n,index:e};a.notify(t,"beforeDatasetUpdate",[r])!==!1&&(n.controller.update(),a.notify(t,"afterDatasetUpdate",[r]))},render:function(t,n){var r=this;if(a.notify(r,"beforeRender")!==!1){var o=r.options.animation,s=function(e){a.notify(r,"afterRender"),i.callback(o&&o.onComplete,[e],r)};if(o&&("undefined"!=typeof t&&0!==t||"undefined"==typeof t&&0!==o.duration)){var u=new e.Animation({numSteps:(t||o.duration)/16.66,easing:o.easing,render:function(e,t){var n=i.easingEffects[t.easing],r=t.currentStep,a=r/t.numSteps;e.draw(n(a),a,r)},onAnimationProgress:o.onProgress,onAnimationComplete:s});e.animationService.addAnimation(r,u,t,n)}else r.draw(),s(new e.Animation({numSteps:0,chart:r}));return r}},draw:function(e){var t=this;t.clear(),void 0!==e&&null!==e||(e=1),t.transition(e),a.notify(t,"beforeDraw",[e])!==!1&&(i.each(t.boxes,function(e){e.draw(t.chartArea)},t),t.scale&&t.scale.draw(),t.drawDatasets(e),t.tooltip.draw(),a.notify(t,"afterDraw",[e]))},transition:function(e){for(var t=this,n=0,r=(t.data.datasets||[]).length;n<r;++n)t.isDatasetVisible(n)&&t.getDatasetMeta(n).controller.transition(e);t.tooltip.transition(e)},drawDatasets:function(e){var t=this;if(a.notify(t,"beforeDatasetsDraw",[e])!==!1){for(var n=(t.data.datasets||[]).length-1;n>=0;--n)t.isDatasetVisible(n)&&t.drawDataset(n,e);a.notify(t,"afterDatasetsDraw",[e])}},drawDataset:function(e,t){var n=this,r=n.getDatasetMeta(e),i={meta:r,index:e,easingValue:t};a.notify(n,"beforeDatasetDraw",[i])!==!1&&(r.controller.draw(t),a.notify(n,"afterDatasetDraw",[i]))},getElementAtEvent:function(t){return e.Interaction.modes.single(this,t)},getElementsAtEvent:function(t){return e.Interaction.modes.label(this,t,{intersect:!0})},getElementsAtXAxis:function(t){return e.Interaction.modes["x-axis"](this,t,{intersect:!0})},getElementsAtEventForMode:function(t,n,r){var i=e.Interaction.modes[n];return"function"==typeof i?i(this,t,r):[]},getDatasetAtEvent:function(t){return e.Interaction.modes.dataset(this,t,{intersect:!0})},getDatasetMeta:function(e){var t=this,n=t.data.datasets[e];n._meta||(n._meta={});var r=n._meta[t.id];return r||(r=n._meta[t.id]={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null}),r},getVisibleDatasetCount:function(){for(var e=0,t=0,n=this.data.datasets.length;t<n;++t)this.isDatasetVisible(t)&&e++;return e},isDatasetVisible:function(e){var t=this.getDatasetMeta(e);return"boolean"==typeof t.hidden?!t.hidden:!this.data.datasets[e].hidden},generateLegend:function(){return this.options.legendCallback(this)},destroy:function(){var t,n,r,s=this,u=s.canvas;for(s.stop(),n=0,r=s.data.datasets.length;n<r;++n)t=s.getDatasetMeta(n),t.controller&&(t.controller.destroy(),t.controller=null);u&&(s.unbindEvents(),i.clear(s),o.releaseContext(s.ctx),s.canvas=null,s.ctx=null),a.notify(s,"destroy"),delete e.instances[s.id]},toBase64Image:function(){return this.canvas.toDataURL.apply(this.canvas,arguments)},initToolTip:function(){var t=this;t.tooltip=new e.Tooltip({_chart:t,_chartInstance:t,_data:t.data,_options:t.options.tooltips},t),t.tooltip.initialize()},bindEvents:function(){var e=this,t=e._listeners={},n=function(){e.eventHandler.apply(e,arguments)};i.each(e.options.events,function(r){o.addEventListener(e,r,n),t[r]=n}),e.options.responsive&&(n=function(){e.resize()},o.addEventListener(e,"resize",n),t.resize=n)},unbindEvents:function(){var e=this,t=e._listeners;t&&(delete e._listeners,i.each(t,function(t,n){o.removeEventListener(e,n,t)}))},updateHoverStyle:function(e,t,n){var r,i,a,o=n?"setHoverStyle":"removeHoverStyle";for(i=0,a=e.length;i<a;++i)r=e[i],r&&this.getDatasetMeta(r._datasetIndex).controller[o](r)},eventHandler:function(e){var t=this,n=t.tooltip;if(a.notify(t,"beforeEvent",[e])!==!1){t._bufferedRender=!0,t._bufferedRequest=null;var r=t.handleEvent(e);r|=n&&n.handleEvent(e),a.notify(t,"afterEvent",[e]);var i=t._bufferedRequest;return i?t.render(i.duration,i.lazy):r&&!t.animating&&(t.stop(),t.render(t.options.hover.animationDuration,!0)),t._bufferedRender=!1,t._bufferedRequest=null,t}},handleEvent:function(e){var t=this,n=t.options||{},r=n.hover,a=!1;return t.lastActive=t.lastActive||[],"mouseout"===e.type?t.active=[]:t.active=t.getElementsAtEventForMode(e,r.mode,r),r.onHover&&r.onHover.call(t,e.native,t.active),"mouseup"!==e.type&&"click"!==e.type||n.onClick&&n.onClick.call(t,e.native,t.active),t.lastActive.length&&t.updateHoverStyle(t.lastActive,r.mode,!1),t.active.length&&r.mode&&t.updateHoverStyle(t.active,r.mode,!0),a=!i.arrayEquals(t.active,t.lastActive),t.lastActive=t.active,a}}),e.Controller=e}},function(e,t){"use strict";e.exports=function(e){function t(e,t){return e._chartjs?void e._chartjs.listeners.push(t):(Object.defineProperty(e,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[t]}}),void i.forEach(function(t){var n="onData"+t.charAt(0).toUpperCase()+t.slice(1),i=e[t];Object.defineProperty(e,t,{configurable:!0,enumerable:!1,value:function(){var t=Array.prototype.slice.call(arguments),a=i.apply(this,t);return r.each(e._chartjs.listeners,function(e){"function"==typeof e[n]&&e[n].apply(e,t)}),a}})}))}function n(e,t){var n=e._chartjs;if(n){var r=n.listeners,a=r.indexOf(t);a!==-1&&r.splice(a,1),r.length>0||(i.forEach(function(t){delete e[t]}),delete e._chartjs)}}var r=e.helpers,i=["push","pop","shift","splice","unshift"];e.DatasetController=function(e,t){this.initialize(e,t)},r.extend(e.DatasetController.prototype,{datasetElementType:null,dataElementType:null,initialize:function(e,t){var n=this;n.chart=e,n.index=t,n.linkScales(),n.addElements()},updateIndex:function(e){this.index=e},linkScales:function(){var e=this,t=e.getMeta(),n=e.getDataset();null===t.xAxisID&&(t.xAxisID=n.xAxisID||e.chart.options.scales.xAxes[0].id),null===t.yAxisID&&(t.yAxisID=n.yAxisID||e.chart.options.scales.yAxes[0].id)},getDataset:function(){return this.chart.data.datasets[this.index]},getMeta:function(){return this.chart.getDatasetMeta(this.index)},getScaleForId:function(e){return this.chart.scales[e]},reset:function(){this.update(!0)},destroy:function(){this._data&&n(this._data,this)},createMetaDataset:function(){var e=this,t=e.datasetElementType;return t&&new t({_chart:e.chart,_datasetIndex:e.index})},createMetaData:function(e){var t=this,n=t.dataElementType;return n&&new n({_chart:t.chart,_datasetIndex:t.index,_index:e})},addElements:function(){var e,t,n=this,r=n.getMeta(),i=n.getDataset().data||[],a=r.data;for(e=0,t=i.length;e<t;++e)a[e]=a[e]||n.createMetaData(e);r.dataset=r.dataset||n.createMetaDataset()},addElementAndReset:function(e){var t=this.createMetaData(e);this.getMeta().data.splice(e,0,t),this.updateElement(t,e,!0)},buildOrUpdateElements:function(){var e=this,r=e.getDataset(),i=r.data||(r.data=[]);e._data!==i&&(e._data&&n(e._data,e),t(i,e),e._data=i),e.resyncElements()},update:r.noop,transition:function(e){for(var t=this.getMeta(),n=t.data||[],r=n.length,i=0;i<r;++i)n[i].transition(e);t.dataset&&t.dataset.transition(e)},draw:function(){var e=this.getMeta(),t=e.data||[],n=t.length,r=0;for(e.dataset&&e.dataset.draw();r<n;++r)t[r].draw()},removeHoverStyle:function(e,t){var n=this.chart.data.datasets[e._datasetIndex],i=e._index,a=e.custom||{},o=r.getValueAtIndexOrDefault,s=e._model;s.backgroundColor=a.backgroundColor?a.backgroundColor:o(n.backgroundColor,i,t.backgroundColor),s.borderColor=a.borderColor?a.borderColor:o(n.borderColor,i,t.borderColor),s.borderWidth=a.borderWidth?a.borderWidth:o(n.borderWidth,i,t.borderWidth)},setHoverStyle:function(e){var t=this.chart.data.datasets[e._datasetIndex],n=e._index,i=e.custom||{},a=r.getValueAtIndexOrDefault,o=r.getHoverColor,s=e._model;s.backgroundColor=i.hoverBackgroundColor?i.hoverBackgroundColor:a(t.hoverBackgroundColor,n,o(s.backgroundColor)),s.borderColor=i.hoverBorderColor?i.hoverBorderColor:a(t.hoverBorderColor,n,o(s.borderColor)),s.borderWidth=i.hoverBorderWidth?i.hoverBorderWidth:a(t.hoverBorderWidth,n,s.borderWidth)},resyncElements:function(){var e=this,t=e.getMeta(),n=e.getDataset().data,r=t.data.length,i=n.length;i<r?t.data.splice(i,r-i):i>r&&e.insertElements(r,i-r)},insertElements:function(e,t){for(var n=0;n<t;++n)this.addElementAndReset(e+n)},onDataPush:function(){this.insertElements(this.getDataset().data.length-1,arguments.length)},onDataPop:function(){this.getMeta().data.pop()},onDataShift:function(){this.getMeta().data.shift()},onDataSplice:function(e,t){this.getMeta().data.splice(e,t),this.insertElements(e,arguments.length-2)},onDataUnshift:function(){this.insertElements(0,arguments.length)}}),e.DatasetController.extend=r.inherits}},function(e,t,n){"use strict";var r=n(51);e.exports=function(e){function t(e,t,n,i){var a,o,s,u,d,l,c,h,_,f=Object.keys(n);for(a=0,o=f.length;a<o;++a)if(s=f[a],l=n[s],t.hasOwnProperty(s)||(t[s]=l),u=t[s],u!==l&&"_"!==s[0]){if(e.hasOwnProperty(s)||(e[s]=u),d=e[s],c=typeof l,c===typeof d)if("string"===c){if(h=r(d),h.valid&&(_=r(l),_.valid)){t[s]=_.mix(h,i).rgbString();continue}}else if("number"===c&&isFinite(d)&&isFinite(l)){t[s]=d+(l-d)*i;continue}t[s]=l}}var n=e.helpers;e.elements={},e.Element=function(e){n.extend(this,e),this.initialize.apply(this,arguments)},n.extend(e.Element.prototype,{initialize:function(){this.hidden=!1},pivot:function(){var e=this;return e._view||(e._view=n.clone(e._model)),e._start={},e},transition:function(e){var n=this,r=n._model,i=n._start,a=n._view;return r&&1!==e?(a||(a=n._view={}),i||(i=n._start={}),t(i,a,r,e),n):(n._view=r,n._start=null,n)},tooltipPosition:function(){return{x:this._model.x,y:this._model.y}},hasValue:function(){return n.isNumber(this._model.x)&&n.isNumber(this._model.y)}}),e.Element.extend=n.inherits}},function(e,t,n){"use strict";var r=n(51);e.exports=function(e){function t(e,t,n){var r;return"string"==typeof e?(r=parseInt(e,10),e.indexOf("%")!==-1&&(r=r/100*t.parentNode[n])):r=e,r}function n(e){return void 0!==e&&null!==e&&"none"!==e}function i(e,r,i){var a=document.defaultView,o=e.parentNode,s=a.getComputedStyle(e)[r],u=a.getComputedStyle(o)[r],d=n(s),l=n(u),c=Number.POSITIVE_INFINITY;return d||l?Math.min(d?t(s,e,i):c,l?t(u,o,i):c):"none"}var a=e.helpers={};a.each=function(e,t,n,r){var i,o;if(a.isArray(e))if(o=e.length,r)for(i=o-1;i>=0;i--)t.call(n,e[i],i);else for(i=0;i<o;i++)t.call(n,e[i],i);else if("object"==typeof e){var s=Object.keys(e);for(o=s.length,i=0;i<o;i++)t.call(n,e[s[i]],s[i])}},a.clone=function(e){var t={};return a.each(e,function(e,n){a.isArray(e)?t[n]=e.slice(0):"object"==typeof e&&null!==e?t[n]=a.clone(e):t[n]=e}),t},a.extend=function(e){for(var t=function(t,n){e[n]=t},n=1,r=arguments.length;n<r;n++)a.each(arguments[n],t);return e},a.configMerge=function(t){var n=a.clone(t);return a.each(Array.prototype.slice.call(arguments,1),function(t){a.each(t,function(t,r){var i=n.hasOwnProperty(r),o=i?n[r]:{};"scales"===r?n[r]=a.scaleMerge(o,t):"scale"===r?n[r]=a.configMerge(o,e.scaleService.getScaleDefaults(t.type),t):!i||"object"!=typeof o||a.isArray(o)||null===o||"object"!=typeof t||a.isArray(t)?n[r]=t:n[r]=a.configMerge(o,t)})}),n},a.scaleMerge=function(t,n){var r=a.clone(t);return a.each(n,function(t,n){"xAxes"===n||"yAxes"===n?r.hasOwnProperty(n)?a.each(t,function(t,i){var o=a.getValueOrDefault(t.type,"xAxes"===n?"category":"linear"),s=e.scaleService.getScaleDefaults(o);i>=r[n].length||!r[n][i].type?r[n].push(a.configMerge(s,t)):t.type&&t.type!==r[n][i].type?r[n][i]=a.configMerge(r[n][i],s,t):r[n][i]=a.configMerge(r[n][i],t)}):(r[n]=[],a.each(t,function(t){var i=a.getValueOrDefault(t.type,"xAxes"===n?"category":"linear");r[n].push(a.configMerge(e.scaleService.getScaleDefaults(i),t))})):r.hasOwnProperty(n)&&"object"==typeof r[n]&&null!==r[n]&&"object"==typeof t?r[n]=a.configMerge(r[n],t):r[n]=t}),r},a.getValueAtIndexOrDefault=function(e,t,n){return void 0===e||null===e?n:a.isArray(e)?t<e.length?e[t]:n:e},a.getValueOrDefault=function(e,t){return void 0===e?t:e},a.indexOf=Array.prototype.indexOf?function(e,t){return e.indexOf(t)}:function(e,t){for(var n=0,r=e.length;n<r;++n)if(e[n]===t)return n;return-1},a.where=function(e,t){if(a.isArray(e)&&Array.prototype.filter)return e.filter(t);var n=[];return a.each(e,function(e){t(e)&&n.push(e)}),n},a.findIndex=Array.prototype.findIndex?function(e,t,n){return e.findIndex(t,n)}:function(e,t,n){n=void 0===n?e:n;for(var r=0,i=e.length;r<i;++r)if(t.call(n,e[r],r,e))return r;return-1},a.findNextWhere=function(e,t,n){void 0!==n&&null!==n||(n=-1);for(var r=n+1;r<e.length;r++){var i=e[r];if(t(i))return i}},a.findPreviousWhere=function(e,t,n){void 0!==n&&null!==n||(n=e.length);for(var r=n-1;r>=0;r--){var i=e[r];if(t(i))return i}},a.inherits=function(e){var t=this,n=e&&e.hasOwnProperty("constructor")?e.constructor:function(){return t.apply(this,arguments)},r=function(){this.constructor=n};return r.prototype=t.prototype,n.prototype=new r,n.extend=a.inherits,e&&a.extend(n.prototype,e),n.__super__=t.prototype,n},a.noop=function(){},a.uid=function(){var e=0;return function(){return e++}}(),a.isNumber=function(e){return!isNaN(parseFloat(e))&&isFinite(e)},a.almostEquals=function(e,t,n){return Math.abs(e-t)<n},a.almostWhole=function(e,t){var n=Math.round(e);return n-t<e&&n+t>e},a.max=function(e){return e.reduce(function(e,t){return isNaN(t)?e:Math.max(e,t)},Number.NEGATIVE_INFINITY)},a.min=function(e){return e.reduce(function(e,t){return isNaN(t)?e:Math.min(e,t)},Number.POSITIVE_INFINITY)},a.sign=Math.sign?function(e){return Math.sign(e)}:function(e){return e=+e,0===e||isNaN(e)?e:e>0?1:-1},a.log10=Math.log10?function(e){return Math.log10(e)}:function(e){return Math.log(e)/Math.LN10},a.toRadians=function(e){return e*(Math.PI/180)},a.toDegrees=function(e){return e*(180/Math.PI)},a.getAngleFromPoint=function(e,t){var n=t.x-e.x,r=t.y-e.y,i=Math.sqrt(n*n+r*r),a=Math.atan2(r,n);return a<-.5*Math.PI&&(a+=2*Math.PI),{angle:a,distance:i}},a.distanceBetweenPoints=function(e,t){return Math.sqrt(Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2))},a.aliasPixel=function(e){return e%2===0?0:.5},a.splineCurve=function(e,t,n,r){var i=e.skip?t:e,a=t,o=n.skip?t:n,s=Math.sqrt(Math.pow(a.x-i.x,2)+Math.pow(a.y-i.y,2)),u=Math.sqrt(Math.pow(o.x-a.x,2)+Math.pow(o.y-a.y,2)),d=s/(s+u),l=u/(s+u);d=isNaN(d)?0:d,l=isNaN(l)?0:l;var c=r*d,h=r*l;return{previous:{x:a.x-c*(o.x-i.x),y:a.y-c*(o.y-i.y)},next:{x:a.x+h*(o.x-i.x),y:a.y+h*(o.y-i.y)}}},a.EPSILON=Number.EPSILON||1e-14,a.splineCurveMonotone=function(e){var t,n,r,i,o=(e||[]).map(function(e){return{model:e._model,deltaK:0,mK:0}}),s=o.length;for(t=0;t<s;++t)if(r=o[t],!r.model.skip){if(n=t>0?o[t-1]:null,i=t<s-1?o[t+1]:null,i&&!i.model.skip){var u=i.model.x-r.model.x;r.deltaK=0!==u?(i.model.y-r.model.y)/u:0}!n||n.model.skip?r.mK=r.deltaK:!i||i.model.skip?r.mK=n.deltaK:this.sign(n.deltaK)!==this.sign(r.deltaK)?r.mK=0:r.mK=(n.deltaK+r.deltaK)/2}var d,l,c,h;for(t=0;t<s-1;++t)r=o[t],i=o[t+1],r.model.skip||i.model.skip||(a.almostEquals(r.deltaK,0,this.EPSILON)?r.mK=i.mK=0:(d=r.mK/r.deltaK,l=i.mK/r.deltaK,h=Math.pow(d,2)+Math.pow(l,2),h<=9||(c=3/Math.sqrt(h),r.mK=d*c*r.deltaK,i.mK=l*c*r.deltaK)));var _;for(t=0;t<s;++t)r=o[t],r.model.skip||(n=t>0?o[t-1]:null,i=t<s-1?o[t+1]:null,n&&!n.model.skip&&(_=(r.model.x-n.model.x)/3,r.model.controlPointPreviousX=r.model.x-_,r.model.controlPointPreviousY=r.model.y-_*r.mK),i&&!i.model.skip&&(_=(i.model.x-r.model.x)/3,r.model.controlPointNextX=r.model.x+_,r.model.controlPointNextY=r.model.y+_*r.mK))},a.nextItem=function(e,t,n){return n?t>=e.length-1?e[0]:e[t+1]:t>=e.length-1?e[e.length-1]:e[t+1]},a.previousItem=function(e,t,n){return n?t<=0?e[e.length-1]:e[t-1]:t<=0?e[0]:e[t-1]},a.niceNum=function(e,t){var n,r=Math.floor(a.log10(e)),i=e/Math.pow(10,r);return n=t?i<1.5?1:i<3?2:i<7?5:10:i<=1?1:i<=2?2:i<=5?5:10,n*Math.pow(10,r)};var o=a.easingEffects={linear:function(e){return e},easeInQuad:function(e){return e*e},easeOutQuad:function(e){return-1*e*(e-2)},easeInOutQuad:function(e){return(e/=.5)<1?.5*e*e:-.5*(--e*(e-2)-1)},easeInCubic:function(e){return e*e*e},easeOutCubic:function(e){return 1*((e=e/1-1)*e*e+1)},easeInOutCubic:function(e){return(e/=.5)<1?.5*e*e*e:.5*((e-=2)*e*e+2)},easeInQuart:function(e){return e*e*e*e},easeOutQuart:function(e){return-1*((e=e/1-1)*e*e*e-1)},easeInOutQuart:function(e){return(e/=.5)<1?.5*e*e*e*e:-.5*((e-=2)*e*e*e-2)},easeInQuint:function(e){return 1*(e/=1)*e*e*e*e},easeOutQuint:function(e){return 1*((e=e/1-1)*e*e*e*e+1)},easeInOutQuint:function(e){return(e/=.5)<1?.5*e*e*e*e*e:.5*((e-=2)*e*e*e*e+2)},easeInSine:function(e){return-1*Math.cos(e/1*(Math.PI/2))+1},easeOutSine:function(e){return 1*Math.sin(e/1*(Math.PI/2))},easeInOutSine:function(e){return-.5*(Math.cos(Math.PI*e/1)-1)},easeInExpo:function(e){return 0===e?1:1*Math.pow(2,10*(e/1-1))},easeOutExpo:function(e){return 1===e?1:1*(-Math.pow(2,-10*e/1)+1)},easeInOutExpo:function(e){return 0===e?0:1===e?1:(e/=.5)<1?.5*Math.pow(2,10*(e-1)):.5*(-Math.pow(2,-10*--e)+2)},easeInCirc:function(e){return e>=1?e:-1*(Math.sqrt(1-(e/=1)*e)-1)},easeOutCirc:function(e){return 1*Math.sqrt(1-(e=e/1-1)*e)},easeInOutCirc:function(e){return(e/=.5)<1?-.5*(Math.sqrt(1-e*e)-1):.5*(Math.sqrt(1-(e-=2)*e)+1)},easeInElastic:function(e){var t=1.70158,n=0,r=1;return 0===e?0:1===(e/=1)?1:(n||(n=.3),r<Math.abs(1)?(r=1,t=n/4):t=n/(2*Math.PI)*Math.asin(1/r),-(r*Math.pow(2,10*(e-=1))*Math.sin((1*e-t)*(2*Math.PI)/n)))},easeOutElastic:function(e){var t=1.70158,n=0,r=1;return 0===e?0:1===(e/=1)?1:(n||(n=.3),r<Math.abs(1)?(r=1,t=n/4):t=n/(2*Math.PI)*Math.asin(1/r),r*Math.pow(2,-10*e)*Math.sin((1*e-t)*(2*Math.PI)/n)+1)},easeInOutElastic:function(e){var t=1.70158,n=0,r=1;return 0===e?0:2===(e/=.5)?1:(n||(n=1*(.3*1.5)),r<Math.abs(1)?(r=1,t=n/4):t=n/(2*Math.PI)*Math.asin(1/r),e<1?-.5*(r*Math.pow(2,10*(e-=1))*Math.sin((1*e-t)*(2*Math.PI)/n)):r*Math.pow(2,-10*(e-=1))*Math.sin((1*e-t)*(2*Math.PI)/n)*.5+1)},easeInBack:function(e){var t=1.70158;return 1*(e/=1)*e*((t+1)*e-t)},easeOutBack:function(e){var t=1.70158;return 1*((e=e/1-1)*e*((t+1)*e+t)+1)},easeInOutBack:function(e){var t=1.70158;return(e/=.5)<1?.5*(e*e*(((t*=1.525)+1)*e-t)):.5*((e-=2)*e*(((t*=1.525)+1)*e+t)+2)},easeInBounce:function(e){return 1-o.easeOutBounce(1-e)},easeOutBounce:function(e){return(e/=1)<1/2.75?1*(7.5625*e*e):e<2/2.75?1*(7.5625*(e-=1.5/2.75)*e+.75):e<2.5/2.75?1*(7.5625*(e-=2.25/2.75)*e+.9375):1*(7.5625*(e-=2.625/2.75)*e+.984375)},easeInOutBounce:function(e){return e<.5?.5*o.easeInBounce(2*e):.5*o.easeOutBounce(2*e-1)+.5}};a.requestAnimFrame=function(){return"undefined"==typeof window?function(e){e()}:window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e){return window.setTimeout(e,1e3/60)}}(),a.getRelativePosition=function(e,t){var n,r,i=e.originalEvent||e,o=e.currentTarget||e.srcElement,s=o.getBoundingClientRect(),u=i.touches;u&&u.length>0?(n=u[0].clientX,r=u[0].clientY):(n=i.clientX,r=i.clientY);var d=parseFloat(a.getStyle(o,"padding-left")),l=parseFloat(a.getStyle(o,"padding-top")),c=parseFloat(a.getStyle(o,"padding-right")),h=parseFloat(a.getStyle(o,"padding-bottom")),_=s.right-s.left-d-c,f=s.bottom-s.top-l-h;return n=Math.round((n-s.left-d)/_*o.width/t.currentDevicePixelRatio),r=Math.round((r-s.top-l)/f*o.height/t.currentDevicePixelRatio),{x:n,y:r}},a.addEvent=function(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent?e.attachEvent("on"+t,n):e["on"+t]=n},a.removeEvent=function(e,t,n){e.removeEventListener?e.removeEventListener(t,n,!1):e.detachEvent?e.detachEvent("on"+t,n):e["on"+t]=a.noop},a.getConstraintWidth=function(e){return i(e,"max-width","clientWidth")},a.getConstraintHeight=function(e){return i(e,"max-height","clientHeight")},a.getMaximumWidth=function(e){var t=e.parentNode,n=parseInt(a.getStyle(t,"padding-left"),10),r=parseInt(a.getStyle(t,"padding-right"),10),i=t.clientWidth-n-r,o=a.getConstraintWidth(e);return isNaN(o)?i:Math.min(i,o)},a.getMaximumHeight=function(e){var t=e.parentNode,n=parseInt(a.getStyle(t,"padding-top"),10),r=parseInt(a.getStyle(t,"padding-bottom"),10),i=t.clientHeight-n-r,o=a.getConstraintHeight(e);return isNaN(o)?i:Math.min(i,o)},a.getStyle=function(e,t){return e.currentStyle?e.currentStyle[t]:document.defaultView.getComputedStyle(e,null).getPropertyValue(t)},a.retinaScale=function(e){var t=e.currentDevicePixelRatio=window.devicePixelRatio||1;if(1!==t){var n=e.canvas,r=e.height,i=e.width;n.height=r*t,n.width=i*t,e.ctx.scale(t,t),n.style.height=r+"px",n.style.width=i+"px"}},a.clear=function(e){e.ctx.clearRect(0,0,e.width,e.height)},a.fontString=function(e,t,n){return t+" "+e+"px "+n},a.longestText=function(e,t,n,r){r=r||{};var i=r.data=r.data||{},o=r.garbageCollect=r.garbageCollect||[];r.font!==t&&(i=r.data={},o=r.garbageCollect=[],r.font=t),e.font=t;var s=0;a.each(n,function(t){void 0!==t&&null!==t&&a.isArray(t)!==!0?s=a.measureText(e,i,o,s,t):a.isArray(t)&&a.each(t,function(t){void 0===t||null===t||a.isArray(t)||(s=a.measureText(e,i,o,s,t))})});var u=o.length/2;if(u>n.length){for(var d=0;d<u;d++)delete i[o[d]];o.splice(0,u)}return s},a.measureText=function(e,t,n,r,i){var a=t[i];return a||(a=t[i]=e.measureText(i).width,n.push(i)),a>r&&(r=a),r},a.numberOfLabelLines=function(e){var t=1;return a.each(e,function(e){a.isArray(e)&&e.length>t&&(t=e.length)}),t},a.drawRoundedRectangle=function(e,t,n,r,i,a){e.beginPath(),e.moveTo(t+a,n),e.lineTo(t+r-a,n),e.quadraticCurveTo(t+r,n,t+r,n+a),e.lineTo(t+r,n+i-a),e.quadraticCurveTo(t+r,n+i,t+r-a,n+i),e.lineTo(t+a,n+i),e.quadraticCurveTo(t,n+i,t,n+i-a),e.lineTo(t,n+a),e.quadraticCurveTo(t,n,t+a,n),e.closePath()},a.color=r?function(t){return t instanceof CanvasGradient&&(t=e.defaults.global.defaultColor),r(t)}:function(e){return console.error("Color.js not found!"),e},a.isArray=Array.isArray?function(e){return Array.isArray(e)}:function(e){return"[object Array]"===Object.prototype.toString.call(e)},a.arrayEquals=function(e,t){var n,r,i,o;if(!e||!t||e.length!==t.length)return!1;for(n=0,r=e.length;n<r;++n)if(i=e[n],o=t[n],i instanceof Array&&o instanceof Array){if(!a.arrayEquals(i,o))return!1}else if(i!==o)return!1;return!0},a.callback=function(e,t,n){e&&"function"==typeof e.call&&e.apply(n,t)},a.getHoverColor=function(e){return e instanceof CanvasPattern?e:a.color(e).saturate(.5).darken(.1).rgbString()},a.callCallback=a.callback}},function(e,t){"use strict";e.exports=function(e){function t(e,t){return e.native?{x:e.x,y:e.y}:o.getRelativePosition(e,t)}function n(e,t){var n,r,i,a,o,s=e.data.datasets;for(r=0,a=s.length;r<a;++r)if(e.isDatasetVisible(r))for(n=e.getDatasetMeta(r),i=0,o=n.data.length;i<o;++i){var u=n.data[i];u._view.skip||t(u)}}function r(e,t){var r=[];return n(e,function(e){e.inRange(t.x,t.y)&&r.push(e)}),r}function i(e,t,r,i){var a=Number.POSITIVE_INFINITY,s=[];return i||(i=o.distanceBetweenPoints),n(e,function(e){if(!r||e.inRange(t.x,t.y)){var n=e.getCenterPoint(),o=i(t,n);o<a?(s=[e],a=o):o===a&&s.push(e)}}),s}function a(e,n,a){var o=t(n,e),s=function(e,t){return Math.abs(e.x-t.x)},u=a.intersect?r(e,o):i(e,o,!1,s),d=[];return u.length?(e.data.datasets.forEach(function(t,n){if(e.isDatasetVisible(n)){var r=e.getDatasetMeta(n),i=r.data[u[0]._index];i&&!i._view.skip&&d.push(i)}}),d):[]}var o=e.helpers;e.Interaction={modes:{single:function(e,r){var i=t(r,e),a=[];return n(e,function(e){if(e.inRange(i.x,i.y))return a.push(e),a}),a.slice(0,1)},label:a,index:a,dataset:function(e,n,a){var o=t(n,e),s=a.intersect?r(e,o):i(e,o,!1);return s.length>0&&(s=e.getDatasetMeta(s[0]._datasetIndex).data),s},"x-axis":function(e,t){return a(e,t,!0)},point:function(e,n){var i=t(n,e);return r(e,i)},nearest:function(e,n,r){var a=t(n,e),o=i(e,a,r.intersect);return o.length>1&&o.sort(function(e,t){var n=e.getArea(),r=t.getArea(),i=n-r;return 0===i&&(i=e._datasetIndex-t._datasetIndex),i}),o.slice(0,1)},x:function(e,r,i){var a=t(r,e),o=[],s=!1;return n(e,function(e){e.inXRange(a.x)&&o.push(e),e.inRange(a.x,a.y)&&(s=!0)}),i.intersect&&!s&&(o=[]),o},y:function(e,r,i){var a=t(r,e),o=[],s=!1;return n(e,function(e){e.inYRange(a.y)&&o.push(e),e.inRange(a.x,a.y)&&(s=!0)}),i.intersect&&!s&&(o=[]),o}}}}},function(e,t){"use strict";e.exports=function(){var e=function(e,t){return this.construct(e,t),this};return e.defaults={global:{responsive:!0,responsiveAnimationDuration:0,maintainAspectRatio:!0,events:["mousemove","mouseout","click","touchstart","touchmove"],hover:{onHover:null,mode:"nearest",intersect:!0,animationDuration:400},onClick:null,defaultColor:"rgba(0,0,0,0.1)",defaultFontColor:"#666",defaultFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",defaultFontSize:12,defaultFontStyle:"normal",showLines:!0,elements:{},legendCallback:function(e){var t=[];t.push('<ul class="'+e.id+'-legend">');for(var n=0;n<e.data.datasets.length;n++)t.push('<li><span style="background-color:'+e.data.datasets[n].backgroundColor+'"></span>'),e.data.datasets[n].label&&t.push(e.data.datasets[n].label),t.push("</li>");return t.push("</ul>"),t.join("")}}},e.Chart=e,e}},function(e,t){"use strict";e.exports=function(e){function t(e,t){return r.where(e,function(e){return e.position===t})}function n(e,t){e.forEach(function(e,t){return e._tmpIndex_=t,e}),e.sort(function(e,n){var r=t?n:e,i=t?e:n;return r.weight===i.weight?r._tmpIndex_-i._tmpIndex_:r.weight-i.weight}),e.forEach(function(e){delete e._tmpIndex_})}var r=e.helpers;e.layoutService={defaults:{},addBox:function(e,t){e.boxes||(e.boxes=[]),t.fullWidth=t.fullWidth||!1,t.position=t.position||"top",t.weight=t.weight||0,e.boxes.push(t)},removeBox:function(e,t){var n=e.boxes?e.boxes.indexOf(t):-1;n!==-1&&e.boxes.splice(n,1)},configure:function(e,t,n){for(var r,i=["fullWidth","position","weight"],a=i.length,o=0;o<a;++o)r=i[o],n.hasOwnProperty(r)&&(t[r]=n[r])},update:function(e,i,a){function o(e){var t,n=e.isHorizontal();n?(t=e.update(e.fullWidth?b:D,w),T-=t.height):(t=e.update(x,Y),D-=t.width),S.push({horizontal:n,minSize:t,box:e})}function s(e){var t=r.findNextWhere(S,function(t){return t.box===e});if(t)if(e.isHorizontal()){var n={left:Math.max(C,j),right:Math.max(O,H),top:0,bottom:0};e.update(e.fullWidth?b:D,L/2,n)}else e.update(t.minSize.width,T)}function u(e){var t=r.findNextWhere(S,function(t){return t.box===e}),n={left:0,right:0,top:F,bottom:W};t&&e.update(t.minSize.width,T,n)}function d(e){e.isHorizontal()?(e.left=e.fullWidth?h:C,e.right=e.fullWidth?i-_:C+D,e.top=V,e.bottom=V+e.height,V=e.bottom):(e.left=N,e.right=N+e.width,e.top=F,e.bottom=F+T,N=e.right)}if(e){var l=e.options.layout,c=l?l.padding:null,h=0,_=0,f=0,m=0;isNaN(c)?(h=c.left||0,_=c.right||0,f=c.top||0,m=c.bottom||0):(h=c,_=c,f=c,m=c);var p=t(e.boxes,"left"),g=t(e.boxes,"right"),v=t(e.boxes,"top"),y=t(e.boxes,"bottom"),M=t(e.boxes,"chartArea");
n(p,!0),n(g,!1),n(v,!0),n(y,!1);var b=i-h-_,L=a-f-m,k=b/2,Y=L/2,x=(i-k)/(p.length+g.length),w=(a-Y)/(v.length+y.length),D=b,T=L,S=[];r.each(p.concat(g,v,y),o);var j=0,H=0,A=0,P=0;r.each(v.concat(y),function(e){if(e.getPadding){var t=e.getPadding();j=Math.max(j,t.left),H=Math.max(H,t.right)}}),r.each(p.concat(g),function(e){if(e.getPadding){var t=e.getPadding();A=Math.max(A,t.top),P=Math.max(P,t.bottom)}});var C=h,O=_,F=f,W=m;r.each(p.concat(g),s),r.each(p,function(e){C+=e.width}),r.each(g,function(e){O+=e.width}),r.each(v.concat(y),s),r.each(v,function(e){F+=e.height}),r.each(y,function(e){W+=e.height}),r.each(p.concat(g),u),C=h,O=_,F=f,W=m,r.each(p,function(e){C+=e.width}),r.each(g,function(e){O+=e.width}),r.each(v,function(e){F+=e.height}),r.each(y,function(e){W+=e.height});var I=Math.max(j-C,0);C+=I,O+=Math.max(H-O,0);var E=Math.max(A-F,0);F+=E,W+=Math.max(P-W,0);var z=a-F-W,R=i-C-O;R===D&&z===T||(r.each(p,function(e){e.height=z}),r.each(g,function(e){e.height=z}),r.each(v,function(e){e.fullWidth||(e.width=R)}),r.each(y,function(e){e.fullWidth||(e.width=R)}),T=z,D=R);var N=h+I,V=f+E;r.each(p.concat(v),d),N+=D,V+=T,r.each(g,d),r.each(y,d),e.chartArea={left:C,top:F,right:C+D,bottom:F+T},r.each(M,function(t){t.left=e.chartArea.left,t.top=e.chartArea.top,t.right=e.chartArea.right,t.bottom=e.chartArea.bottom,t.update(D,T)})}}}}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.defaults.global.plugins={},e.plugins={_plugins:[],_cacheId:0,register:function(e){var t=this._plugins;[].concat(e).forEach(function(e){t.indexOf(e)===-1&&t.push(e)}),this._cacheId++},unregister:function(e){var t=this._plugins;[].concat(e).forEach(function(e){var n=t.indexOf(e);n!==-1&&t.splice(n,1)}),this._cacheId++},clear:function(){this._plugins=[],this._cacheId++},count:function(){return this._plugins.length},getAll:function(){return this._plugins},notify:function(e,t,n){var r,i,a,o,s,u=this.descriptors(e),d=u.length;for(r=0;r<d;++r)if(i=u[r],a=i.plugin,s=a[t],"function"==typeof s&&(o=[e].concat(n||[]),o.push(i.options),s.apply(a,o)===!1))return!1;return!0},descriptors:function(n){var r=n._plugins||(n._plugins={});if(r.id===this._cacheId)return r.descriptors;var i=[],a=[],o=n&&n.config||{},s=e.defaults.global.plugins,u=o.options&&o.options.plugins||{};return this._plugins.concat(o.plugins||[]).forEach(function(e){var n=i.indexOf(e);if(n===-1){var r=e.id,o=u[r];o!==!1&&(o===!0&&(o=t.clone(s[r])),i.push(e),a.push({plugin:e,options:o||{}}))}}),r.descriptors=a,r.id=this._cacheId,a}},e.pluginService=e.plugins,e.PluginBase=e.Element.extend({})}},function(e,t){"use strict";e.exports=function(e){function t(e,t,n){return r.isArray(t)?r.longestText(e,n,t):e.measureText(t).width}function n(t){var n=r.getValueOrDefault,i=e.defaults.global,a=n(t.fontSize,i.defaultFontSize),o=n(t.fontStyle,i.defaultFontStyle),s=n(t.fontFamily,i.defaultFontFamily);return{size:a,style:o,family:s,font:r.fontString(a,o,s)}}var r=e.helpers;e.defaults.scale={display:!0,position:"left",gridLines:{display:!0,color:"rgba(0, 0, 0, 0.1)",lineWidth:1,drawBorder:!0,drawOnChartArea:!0,drawTicks:!0,tickMarkLength:10,zeroLineWidth:1,zeroLineColor:"rgba(0,0,0,0.25)",zeroLineBorderDash:[],zeroLineBorderDashOffset:0,offsetGridLines:!1,borderDash:[],borderDashOffset:0},scaleLabel:{labelString:"",display:!1},ticks:{beginAtZero:!1,minRotation:0,maxRotation:50,mirror:!1,padding:0,reverse:!1,display:!0,autoSkip:!0,autoSkipPadding:0,labelOffset:0,callback:e.Ticks.formatters.values}},e.Scale=e.Element.extend({getPadding:function(){var e=this;return{left:e.paddingLeft||0,top:e.paddingTop||0,right:e.paddingRight||0,bottom:e.paddingBottom||0}},beforeUpdate:function(){r.callback(this.options.beforeUpdate,[this])},update:function(e,t,n){var i=this;return i.beforeUpdate(),i.maxWidth=e,i.maxHeight=t,i.margins=r.extend({left:0,right:0,top:0,bottom:0},n),i.longestTextCache=i.longestTextCache||{},i.beforeSetDimensions(),i.setDimensions(),i.afterSetDimensions(),i.beforeDataLimits(),i.determineDataLimits(),i.afterDataLimits(),i.beforeBuildTicks(),i.buildTicks(),i.afterBuildTicks(),i.beforeTickToLabelConversion(),i.convertTicksToLabels(),i.afterTickToLabelConversion(),i.beforeCalculateTickRotation(),i.calculateTickRotation(),i.afterCalculateTickRotation(),i.beforeFit(),i.fit(),i.afterFit(),i.afterUpdate(),i.minSize},afterUpdate:function(){r.callback(this.options.afterUpdate,[this])},beforeSetDimensions:function(){r.callback(this.options.beforeSetDimensions,[this])},setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0},afterSetDimensions:function(){r.callback(this.options.afterSetDimensions,[this])},beforeDataLimits:function(){r.callback(this.options.beforeDataLimits,[this])},determineDataLimits:r.noop,afterDataLimits:function(){r.callback(this.options.afterDataLimits,[this])},beforeBuildTicks:function(){r.callback(this.options.beforeBuildTicks,[this])},buildTicks:r.noop,afterBuildTicks:function(){r.callback(this.options.afterBuildTicks,[this])},beforeTickToLabelConversion:function(){r.callback(this.options.beforeTickToLabelConversion,[this])},convertTicksToLabels:function(){var e=this,t=e.options.ticks;e.ticks=e.ticks.map(t.userCallback||t.callback)},afterTickToLabelConversion:function(){r.callback(this.options.afterTickToLabelConversion,[this])},beforeCalculateTickRotation:function(){r.callback(this.options.beforeCalculateTickRotation,[this])},calculateTickRotation:function(){var e=this,t=e.ctx,i=e.options.ticks,a=n(i);t.font=a.font;var o=i.minRotation||0;if(e.options.display&&e.isHorizontal())for(var s,u,d=r.longestText(t,a.font,e.ticks,e.longestTextCache),l=d,c=e.getPixelForTick(1)-e.getPixelForTick(0)-6;l>c&&o<i.maxRotation;){var h=r.toRadians(o);if(s=Math.cos(h),u=Math.sin(h),u*d>e.maxHeight){o--;break}o++,l=s*d}e.labelRotation=o},afterCalculateTickRotation:function(){r.callback(this.options.afterCalculateTickRotation,[this])},beforeFit:function(){r.callback(this.options.beforeFit,[this])},fit:function(){var e=this,i=e.minSize={width:0,height:0},a=e.options,o=a.ticks,s=a.scaleLabel,u=a.gridLines,d=a.display,l=e.isHorizontal(),c=n(o),h=1.5*n(s).size,_=a.gridLines.tickMarkLength;if(l?i.width=e.isFullWidth()?e.maxWidth-e.margins.left-e.margins.right:e.maxWidth:i.width=d&&u.drawTicks?_:0,l?i.height=d&&u.drawTicks?_:0:i.height=e.maxHeight,s.display&&d&&(l?i.height+=h:i.width+=h),o.display&&d){var f=r.longestText(e.ctx,c.font,e.ticks,e.longestTextCache),m=r.numberOfLabelLines(e.ticks),p=.5*c.size;if(l){e.longestLabelWidth=f;var g=r.toRadians(e.labelRotation),v=Math.cos(g),y=Math.sin(g),M=y*f+c.size*m+p*m;i.height=Math.min(e.maxHeight,i.height+M),e.ctx.font=c.font;var b=e.ticks[0],L=t(e.ctx,b,c.font),k=e.ticks[e.ticks.length-1],Y=t(e.ctx,k,c.font);0!==e.labelRotation?(e.paddingLeft="bottom"===a.position?v*L+3:v*p+3,e.paddingRight="bottom"===a.position?v*p+3:v*Y+3):(e.paddingLeft=L/2+3,e.paddingRight=Y/2+3)}else o.mirror?f=0:f+=e.options.ticks.padding,i.width=Math.min(e.maxWidth,i.width+f),e.paddingTop=c.size/2,e.paddingBottom=c.size/2}e.handleMargins(),e.width=i.width,e.height=i.height},handleMargins:function(){var e=this;e.margins&&(e.paddingLeft=Math.max(e.paddingLeft-e.margins.left,0),e.paddingTop=Math.max(e.paddingTop-e.margins.top,0),e.paddingRight=Math.max(e.paddingRight-e.margins.right,0),e.paddingBottom=Math.max(e.paddingBottom-e.margins.bottom,0))},afterFit:function(){r.callback(this.options.afterFit,[this])},isHorizontal:function(){return"top"===this.options.position||"bottom"===this.options.position},isFullWidth:function(){return this.options.fullWidth},getRightValue:function(e){return null===e||"undefined"==typeof e?NaN:"number"!=typeof e||isFinite(e)?"object"==typeof e?e instanceof Date||e.isValid?e:this.getRightValue(this.isHorizontal()?e.x:e.y):e:NaN},getLabelForIndex:r.noop,getPixelForValue:r.noop,getValueForPixel:r.noop,getPixelForTick:function(e,t){var n=this;if(n.isHorizontal()){var r=n.width-(n.paddingLeft+n.paddingRight),i=r/Math.max(n.ticks.length-(n.options.gridLines.offsetGridLines?0:1),1),a=i*e+n.paddingLeft;t&&(a+=i/2);var o=n.left+Math.round(a);return o+=n.isFullWidth()?n.margins.left:0}var s=n.height-(n.paddingTop+n.paddingBottom);return n.top+e*(s/(n.ticks.length-1))},getPixelForDecimal:function(e){var t=this;if(t.isHorizontal()){var n=t.width-(t.paddingLeft+t.paddingRight),r=n*e+t.paddingLeft,i=t.left+Math.round(r);return i+=t.isFullWidth()?t.margins.left:0}return t.top+e*t.height},getBasePixel:function(){return this.getPixelForValue(this.getBaseValue())},getBaseValue:function(){var e=this,t=e.min,n=e.max;return e.beginAtZero?0:t<0&&n<0?n:t>0&&n>0?t:0},draw:function(t){var i=this,a=i.options;if(a.display){var o,s,u=i.ctx,d=e.defaults.global,l=a.ticks,c=a.gridLines,h=a.scaleLabel,_=0!==i.labelRotation,f=l.autoSkip,m=i.isHorizontal();l.maxTicksLimit&&(s=l.maxTicksLimit);var p=r.getValueOrDefault(l.fontColor,d.defaultFontColor),g=n(l),v=c.drawTicks?c.tickMarkLength:0,y=r.getValueOrDefault(h.fontColor,d.defaultFontColor),M=n(h),b=r.toRadians(i.labelRotation),L=Math.cos(b),k=i.longestLabelWidth*L;u.fillStyle=p;var Y=[];if(m){if(o=!1,(k+l.autoSkipPadding)*i.ticks.length>i.width-(i.paddingLeft+i.paddingRight)&&(o=1+Math.floor((k+l.autoSkipPadding)*i.ticks.length/(i.width-(i.paddingLeft+i.paddingRight)))),s&&i.ticks.length>s)for(;!o||i.ticks.length/(o||1)>s;)o||(o=1),o+=1;f||(o=!1)}var x="right"===a.position?i.left:i.right-v,w="right"===a.position?i.left+v:i.right,D="bottom"===a.position?i.top:i.bottom-v,T="bottom"===a.position?i.top+v:i.bottom;if(r.each(i.ticks,function(e,n){if(void 0!==e&&null!==e){var s=i.ticks.length===n+1,u=o>1&&n%o>0||n%o===0&&n+o>=i.ticks.length;if((!u||s)&&void 0!==e&&null!==e){var h,f,p,g;n===("undefined"!=typeof i.zeroLineIndex?i.zeroLineIndex:0)?(h=c.zeroLineWidth,f=c.zeroLineColor,p=c.zeroLineBorderDash,g=c.zeroLineBorderDashOffset):(h=r.getValueAtIndexOrDefault(c.lineWidth,n),f=r.getValueAtIndexOrDefault(c.color,n),p=r.getValueOrDefault(c.borderDash,d.borderDash),g=r.getValueOrDefault(c.borderDashOffset,d.borderDashOffset));var y,M,L,k,S,j,H,A,P,C,O="middle",F="middle";if(m){"bottom"===a.position?(F=_?"middle":"top",O=_?"right":"center",C=i.top+v):(F=_?"middle":"bottom",O=_?"left":"center",C=i.bottom-v);var W=i.getPixelForTick(n)+r.aliasPixel(h);P=i.getPixelForTick(n,c.offsetGridLines)+l.labelOffset,y=L=S=H=W,M=D,k=T,j=t.top,A=t.bottom}else{var I,E="left"===a.position,z=l.padding;l.mirror?(O=E?"left":"right",I=z):(O=E?"right":"left",I=v+z),P=E?i.right-I:i.left+I;var R=i.getPixelForTick(n);R+=r.aliasPixel(h),C=i.getPixelForTick(n,c.offsetGridLines),y=x,L=w,S=t.left,H=t.right,M=k=j=A=R}Y.push({tx1:y,ty1:M,tx2:L,ty2:k,x1:S,y1:j,x2:H,y2:A,labelX:P,labelY:C,glWidth:h,glColor:f,glBorderDash:p,glBorderDashOffset:g,rotation:-1*b,label:e,textBaseline:F,textAlign:O})}}}),r.each(Y,function(e){if(c.display&&(u.save(),u.lineWidth=e.glWidth,u.strokeStyle=e.glColor,u.setLineDash&&(u.setLineDash(e.glBorderDash),u.lineDashOffset=e.glBorderDashOffset),u.beginPath(),c.drawTicks&&(u.moveTo(e.tx1,e.ty1),u.lineTo(e.tx2,e.ty2)),c.drawOnChartArea&&(u.moveTo(e.x1,e.y1),u.lineTo(e.x2,e.y2)),u.stroke(),u.restore()),l.display){u.save(),u.translate(e.labelX,e.labelY),u.rotate(e.rotation),u.font=g.font,u.textBaseline=e.textBaseline,u.textAlign=e.textAlign;var t=e.label;if(r.isArray(t))for(var n=0,i=0;n<t.length;++n)u.fillText(""+t[n],0,i),i+=1.5*g.size;else u.fillText(t,0,0);u.restore()}}),h.display){var S,j,H=0;if(m)S=i.left+(i.right-i.left)/2,j="bottom"===a.position?i.bottom-M.size/2:i.top+M.size/2;else{var A="left"===a.position;S=A?i.left+M.size/2:i.right-M.size/2,j=i.top+(i.bottom-i.top)/2,H=A?-.5*Math.PI:.5*Math.PI}u.save(),u.translate(S,j),u.rotate(H),u.textAlign="center",u.textBaseline="middle",u.fillStyle=y,u.font=M.font,u.fillText(h.labelString,0,0),u.restore()}if(c.drawBorder){u.lineWidth=r.getValueAtIndexOrDefault(c.lineWidth,0),u.strokeStyle=r.getValueAtIndexOrDefault(c.color,0);var P=i.left,C=i.right,O=i.top,F=i.bottom,W=r.aliasPixel(u.lineWidth);m?(O=F="top"===a.position?i.bottom:i.top,O+=W,F+=W):(P=C="left"===a.position?i.right:i.left,P+=W,C+=W),u.beginPath(),u.moveTo(P,O),u.lineTo(C,F),u.stroke()}}}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.scaleService={constructors:{},defaults:{},registerScaleType:function(e,n,r){this.constructors[e]=n,this.defaults[e]=t.clone(r)},getScaleConstructor:function(e){return this.constructors.hasOwnProperty(e)?this.constructors[e]:void 0},getScaleDefaults:function(n){return this.defaults.hasOwnProperty(n)?t.scaleMerge(e.defaults.scale,this.defaults[n]):{}},updateScaleDefaults:function(e,n){var r=this.defaults;r.hasOwnProperty(e)&&(r[e]=t.extend(r[e],n))},addScalesToLayout:function(n){t.each(n.scales,function(t){t.fullWidth=t.options.fullWidth,t.position=t.options.position,t.weight=t.options.weight,e.layoutService.addBox(n,t)})}}}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers;e.Ticks={generators:{linear:function(e,n){var r,i=[];if(e.stepSize&&e.stepSize>0)r=e.stepSize;else{var a=t.niceNum(n.max-n.min,!1);r=t.niceNum(a/(e.maxTicks-1),!0)}var o=Math.floor(n.min/r)*r,s=Math.ceil(n.max/r)*r;e.min&&e.max&&e.stepSize&&t.almostWhole((e.max-e.min)/e.stepSize,r/1e3)&&(o=e.min,s=e.max);var u=(s-o)/r;u=t.almostEquals(u,Math.round(u),r/1e3)?Math.round(u):Math.ceil(u),i.push(void 0!==e.min?e.min:o);for(var d=1;d<u;++d)i.push(o+d*r);return i.push(void 0!==e.max?e.max:s),i},logarithmic:function(e,n){var r,i,a=[],o=t.getValueOrDefault,s=o(e.min,Math.pow(10,Math.floor(t.log10(n.min)))),u=Math.floor(t.log10(n.max)),d=Math.ceil(n.max/Math.pow(10,u));0===s?(r=Math.floor(t.log10(n.minNotZero)),i=Math.floor(n.minNotZero/Math.pow(10,r)),a.push(s),s=i*Math.pow(10,r)):(r=Math.floor(t.log10(s)),i=Math.floor(s/Math.pow(10,r)));do a.push(s),++i,10===i&&(i=1,++r),s=i*Math.pow(10,r);while(r<u||r===u&&i<d);var l=o(e.max,s);return a.push(l),a}},formatters:{values:function(e){return t.isArray(e)?e:""+e},linear:function(e,n,r){var i=r.length>3?r[2]-r[1]:r[1]-r[0];Math.abs(i)>1&&e!==Math.floor(e)&&(i=e-Math.floor(e));var a=t.log10(Math.abs(i)),o="";if(0!==e){var s=-1*Math.floor(a);s=Math.max(Math.min(s,20),0),o=e.toFixed(s)}else o="0";return o},logarithmic:function(e,n,r){var i=e/Math.pow(10,Math.floor(t.log10(e)));return 0===e?"0":1===i||2===i||5===i||0===n||n===r.length-1?e.toExponential():""}}}}},function(e,t){"use strict";e.exports=function(e){function t(e,t){var n=u.color(e);return n.alpha(t*n.alpha()).rgbaString()}function n(e,t){return t&&(u.isArray(t)?Array.prototype.push.apply(e,t):e.push(t)),e}function r(e){var t=e._xScale,n=e._yScale||e._scale,r=e._index,i=e._datasetIndex;return{xLabel:t?t.getLabelForIndex(r,i):"",yLabel:n?n.getLabelForIndex(r,i):"",index:r,datasetIndex:i,x:e._model.x,y:e._model.y}}function i(t){var n=e.defaults.global,r=u.getValueOrDefault;return{xPadding:t.xPadding,yPadding:t.yPadding,xAlign:t.xAlign,yAlign:t.yAlign,bodyFontColor:t.bodyFontColor,_bodyFontFamily:r(t.bodyFontFamily,n.defaultFontFamily),_bodyFontStyle:r(t.bodyFontStyle,n.defaultFontStyle),_bodyAlign:t.bodyAlign,bodyFontSize:r(t.bodyFontSize,n.defaultFontSize),bodySpacing:t.bodySpacing,titleFontColor:t.titleFontColor,_titleFontFamily:r(t.titleFontFamily,n.defaultFontFamily),_titleFontStyle:r(t.titleFontStyle,n.defaultFontStyle),titleFontSize:r(t.titleFontSize,n.defaultFontSize),_titleAlign:t.titleAlign,titleSpacing:t.titleSpacing,titleMarginBottom:t.titleMarginBottom,footerFontColor:t.footerFontColor,_footerFontFamily:r(t.footerFontFamily,n.defaultFontFamily),_footerFontStyle:r(t.footerFontStyle,n.defaultFontStyle),footerFontSize:r(t.footerFontSize,n.defaultFontSize),_footerAlign:t.footerAlign,footerSpacing:t.footerSpacing,footerMarginTop:t.footerMarginTop,caretSize:t.caretSize,cornerRadius:t.cornerRadius,backgroundColor:t.backgroundColor,opacity:0,legendColorBackground:t.multiKeyBackground,displayColors:t.displayColors,borderColor:t.borderColor,borderWidth:t.borderWidth}}function a(e,t){var n=e._chart.ctx,r=2*t.yPadding,i=0,a=t.body,o=a.reduce(function(e,t){return e+t.before.length+t.lines.length+t.after.length},0);o+=t.beforeBody.length+t.afterBody.length;var s=t.title.length,d=t.footer.length,l=t.titleFontSize,c=t.bodyFontSize,h=t.footerFontSize;r+=s*l,r+=s?(s-1)*t.titleSpacing:0,r+=s?t.titleMarginBottom:0,r+=o*c,r+=o?(o-1)*t.bodySpacing:0,r+=d?t.footerMarginTop:0,r+=d*h,r+=d?(d-1)*t.footerSpacing:0;var _=0,f=function(e){i=Math.max(i,n.measureText(e).width+_)};return n.font=u.fontString(l,t._titleFontStyle,t._titleFontFamily),u.each(t.title,f),n.font=u.fontString(c,t._bodyFontStyle,t._bodyFontFamily),u.each(t.beforeBody.concat(t.afterBody),f),_=t.displayColors?c+2:0,u.each(a,function(e){u.each(e.before,f),u.each(e.lines,f),u.each(e.after,f)}),_=0,n.font=u.fontString(h,t._footerFontStyle,t._footerFontFamily),u.each(t.footer,f),i+=2*t.xPadding,{width:i,height:r}}function o(e,t){var n=e._model,r=e._chart,i=e._chart.chartArea,a="center",o="center";n.y<t.height?o="top":n.y>r.height-t.height&&(o="bottom");var s,u,d,l,c,h=(i.left+i.right)/2,_=(i.top+i.bottom)/2;"center"===o?(s=function(e){return e<=h},u=function(e){return e>h}):(s=function(e){return e<=t.width/2},u=function(e){return e>=r.width-t.width/2}),d=function(e){return e+t.width>r.width},l=function(e){return e-t.width<0},c=function(e){return e<=_?"top":"bottom"},s(n.x)?(a="left",d(n.x)&&(a="center",o=c(n.y))):u(n.x)&&(a="right",l(n.x)&&(a="center",o=c(n.y)));var f=e._options;return{xAlign:f.xAlign?f.xAlign:a,yAlign:f.yAlign?f.yAlign:o}}function s(e,t,n){var r=e.x,i=e.y,a=e.caretSize,o=e.caretPadding,s=e.cornerRadius,u=n.xAlign,d=n.yAlign,l=a+o,c=s+o;return"right"===u?r-=t.width:"center"===u&&(r-=t.width/2),"top"===d?i+=l:i-="bottom"===d?t.height+l:t.height/2,"center"===d?"left"===u?r+=l:"right"===u&&(r-=l):"left"===u?r-=c:"right"===u&&(r+=c),{x:r,y:i}}var u=e.helpers;e.defaults.global.tooltips={enabled:!0,custom:null,mode:"nearest",position:"average",intersect:!0,backgroundColor:"rgba(0,0,0,0.8)",titleFontStyle:"bold",titleSpacing:2,titleMarginBottom:6,titleFontColor:"#fff",titleAlign:"left",bodySpacing:2,bodyFontColor:"#fff",bodyAlign:"left",footerFontStyle:"bold",footerSpacing:2,footerMarginTop:6,footerFontColor:"#fff",footerAlign:"left",yPadding:6,xPadding:6,caretPadding:2,caretSize:5,cornerRadius:6,multiKeyBackground:"#fff",displayColors:!0,borderColor:"rgba(0,0,0,0)",borderWidth:0,callbacks:{beforeTitle:u.noop,title:function(e,t){var n="",r=t.labels,i=r?r.length:0;if(e.length>0){var a=e[0];a.xLabel?n=a.xLabel:i>0&&a.index<i&&(n=r[a.index])}return n},afterTitle:u.noop,beforeBody:u.noop,beforeLabel:u.noop,label:function(e,t){var n=t.datasets[e.datasetIndex].label||"";return n&&(n+=": "),n+=e.yLabel},labelColor:function(e,t){var n=t.getDatasetMeta(e.datasetIndex),r=n.data[e.index],i=r._view;return{borderColor:i.borderColor,backgroundColor:i.backgroundColor}},afterLabel:u.noop,afterBody:u.noop,beforeFooter:u.noop,footer:u.noop,afterFooter:u.noop}},e.Tooltip=e.Element.extend({initialize:function(){this._model=i(this._options)},getTitle:function(){var e=this,t=e._options,r=t.callbacks,i=r.beforeTitle.apply(e,arguments),a=r.title.apply(e,arguments),o=r.afterTitle.apply(e,arguments),s=[];return s=n(s,i),s=n(s,a),s=n(s,o)},getBeforeBody:function(){var e=this._options.callbacks.beforeBody.apply(this,arguments);return u.isArray(e)?e:void 0!==e?[e]:[]},getBody:function(e,t){var r=this,i=r._options.callbacks,a=[];return u.each(e,function(e){var o={before:[],lines:[],after:[]};n(o.before,i.beforeLabel.call(r,e,t)),n(o.lines,i.label.call(r,e,t)),n(o.after,i.afterLabel.call(r,e,t)),a.push(o)}),a},getAfterBody:function(){var e=this._options.callbacks.afterBody.apply(this,arguments);return u.isArray(e)?e:void 0!==e?[e]:[]},getFooter:function(){var e=this,t=e._options.callbacks,r=t.beforeFooter.apply(e,arguments),i=t.footer.apply(e,arguments),a=t.afterFooter.apply(e,arguments),o=[];return o=n(o,r),o=n(o,i),o=n(o,a)},update:function(t){var n,d,l=this,c=l._options,h=l._model,_=l._model=i(c),f=l._active,m=l._data,p={xAlign:h.xAlign,yAlign:h.yAlign},g={x:h.x,y:h.y},v={width:h.width,height:h.height},y={x:h.caretX,y:h.caretY};if(f.length){_.opacity=1;var M=[];y=e.Tooltip.positioners[c.position](f,l._eventPosition);var b=[];for(n=0,d=f.length;n<d;++n)b.push(r(f[n]));c.filter&&(b=b.filter(function(e){return c.filter(e,m)})),c.itemSort&&(b=b.sort(function(e,t){return c.itemSort(e,t,m)})),u.each(b,function(e){M.push(c.callbacks.labelColor.call(l,e,l._chart))}),_.title=l.getTitle(b,m),_.beforeBody=l.getBeforeBody(b,m),_.body=l.getBody(b,m),_.afterBody=l.getAfterBody(b,m),_.footer=l.getFooter(b,m),_.x=Math.round(y.x),_.y=Math.round(y.y),_.caretPadding=c.caretPadding,_.labelColors=M,_.dataPoints=b,v=a(this,_),p=o(this,v),g=s(_,v,p)}else _.opacity=0;return _.xAlign=p.xAlign,_.yAlign=p.yAlign,_.x=g.x,_.y=g.y,_.width=v.width,_.height=v.height,_.caretX=y.x,_.caretY=y.y,l._model=_,t&&c.custom&&c.custom.call(l,_),l},drawCaret:function(e,t){var n=this._chart.ctx,r=this._view,i=this.getCaretPosition(e,t,r);n.lineTo(i.x1,i.y1),n.lineTo(i.x2,i.y2),n.lineTo(i.x3,i.y3)},getCaretPosition:function(e,t,n){var r,i,a,o,s,u,d=n.caretSize,l=n.cornerRadius,c=n.xAlign,h=n.yAlign,_=e.x,f=e.y,m=t.width,p=t.height;if("center"===h)s=f+p/2,"left"===c?(r=_,i=r-d,a=r,o=s+d,u=s-d):(r=_+m,i=r+d,a=r,o=s-d,u=s+d);else if("left"===c?(i=_+l+d,r=i-d,a=i+d):"right"===c?(i=_+m-l-d,r=i-d,a=i+d):(i=_+m/2,r=i-d,a=i+d),"top"===h)o=f,s=o-d,u=o;else{o=f+p,s=o+d,u=o;var g=a;a=r,r=g}return{x1:r,x2:i,x3:a,y1:o,y2:s,y3:u}},drawTitle:function(e,n,r,i){var a=n.title;if(a.length){r.textAlign=n._titleAlign,r.textBaseline="top";var o=n.titleFontSize,s=n.titleSpacing;r.fillStyle=t(n.titleFontColor,i),r.font=u.fontString(o,n._titleFontStyle,n._titleFontFamily);var d,l;for(d=0,l=a.length;d<l;++d)r.fillText(a[d],e.x,e.y),e.y+=o+s,d+1===a.length&&(e.y+=n.titleMarginBottom-s)}},drawBody:function(e,n,r,i){var a=n.bodyFontSize,o=n.bodySpacing,s=n.body;r.textAlign=n._bodyAlign,r.textBaseline="top";var d=t(n.bodyFontColor,i);r.fillStyle=d,r.font=u.fontString(a,n._bodyFontStyle,n._bodyFontFamily);var l=0,c=function(t){r.fillText(t,e.x+l,e.y),e.y+=a+o};u.each(n.beforeBody,c);var h=n.displayColors;l=h?a+2:0,u.each(s,function(o,s){u.each(o.before,c),u.each(o.lines,function(o){h&&(r.fillStyle=t(n.legendColorBackground,i),r.fillRect(e.x,e.y,a,a),r.strokeStyle=t(n.labelColors[s].borderColor,i),r.strokeRect(e.x,e.y,a,a),r.fillStyle=t(n.labelColors[s].backgroundColor,i),r.fillRect(e.x+1,e.y+1,a-2,a-2),r.fillStyle=d),c(o)}),u.each(o.after,c)}),l=0,u.each(n.afterBody,c),e.y-=o},drawFooter:function(e,n,r,i){var a=n.footer;a.length&&(e.y+=n.footerMarginTop,r.textAlign=n._footerAlign,r.textBaseline="top",r.fillStyle=t(n.footerFontColor,i),r.font=u.fontString(n.footerFontSize,n._footerFontStyle,n._footerFontFamily),u.each(a,function(t){r.fillText(t,e.x,e.y),e.y+=n.footerFontSize+n.footerSpacing}))},drawBackground:function(e,n,r,i,a){r.fillStyle=t(n.backgroundColor,a),r.strokeStyle=t(n.borderColor,a),r.lineWidth=n.borderWidth;var o=n.xAlign,s=n.yAlign,u=e.x,d=e.y,l=i.width,c=i.height,h=n.cornerRadius;r.beginPath(),r.moveTo(u+h,d),"top"===s&&this.drawCaret(e,i),r.lineTo(u+l-h,d),r.quadraticCurveTo(u+l,d,u+l,d+h),"center"===s&&"right"===o&&this.drawCaret(e,i),r.lineTo(u+l,d+c-h),r.quadraticCurveTo(u+l,d+c,u+l-h,d+c),"bottom"===s&&this.drawCaret(e,i),r.lineTo(u+h,d+c),r.quadraticCurveTo(u,d+c,u,d+c-h),"center"===s&&"left"===o&&this.drawCaret(e,i),r.lineTo(u,d+h),r.quadraticCurveTo(u,d,u+h,d),r.closePath(),r.fill(),n.borderWidth>0&&r.stroke()},draw:function(){var e=this._chart.ctx,t=this._view;if(0!==t.opacity){var n={width:t.width,height:t.height},r={x:t.x,y:t.y},i=Math.abs(t.opacity<.001)?0:t.opacity,a=t.title.length||t.beforeBody.length||t.body.length||t.afterBody.length||t.footer.length;this._options.enabled&&a&&(this.drawBackground(r,t,e,n,i),r.x+=t.xPadding,r.y+=t.yPadding,this.drawTitle(r,t,e,i),this.drawBody(r,t,e,i),this.drawFooter(r,t,e,i))}},handleEvent:function(e){var t=this,n=t._options,r=!1;if(t._lastActive=t._lastActive||[],"mouseout"===e.type?t._active=[]:t._active=t._chart.getElementsAtEventForMode(e,n.mode,n),r=!u.arrayEquals(t._active,t._lastActive),!r)return!1;if(t._lastActive=t._active,n.enabled||n.custom){t._eventPosition={x:e.x,y:e.y};var i=t._model;t.update(!0),t.pivot(),r|=i.x!==t._model.x||i.y!==t._model.y}return r}}),e.Tooltip.positioners={average:function(e){if(!e.length)return!1;var t,n,r=0,i=0,a=0;for(t=0,n=e.length;t<n;++t){var o=e[t];if(o&&o.hasValue()){var s=o.tooltipPosition();r+=s.x,i+=s.y,++a}}return{x:Math.round(r/a),y:Math.round(i/a)}},nearest:function(e,t){var n,r,i,a=t.x,o=t.y,s=Number.POSITIVE_INFINITY;for(r=0,i=e.length;r<i;++r){var d=e[r];if(d&&d.hasValue()){var l=d.getCenterPoint(),c=u.distanceBetweenPoints(t,l);c<s&&(s=c,n=d)}}if(n){var h=n.tooltipPosition();a=h.x,o=h.y}return{x:a,y:o}}}}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n=e.defaults.global;n.elements.arc={backgroundColor:n.defaultColor,borderColor:"#fff",borderWidth:2},e.elements.Arc=e.Element.extend({inLabelRange:function(e){var t=this._view;return!!t&&Math.pow(e-t.x,2)<Math.pow(t.radius+t.hoverRadius,2)},inRange:function(e,n){var r=this._view;if(r){for(var i=t.getAngleFromPoint(r,{x:e,y:n}),a=i.angle,o=i.distance,s=r.startAngle,u=r.endAngle;u<s;)u+=2*Math.PI;for(;a>u;)a-=2*Math.PI;for(;a<s;)a+=2*Math.PI;var d=a>=s&&a<=u,l=o>=r.innerRadius&&o<=r.outerRadius;return d&&l}return!1},getCenterPoint:function(){var e=this._view,t=(e.startAngle+e.endAngle)/2,n=(e.innerRadius+e.outerRadius)/2;return{x:e.x+Math.cos(t)*n,y:e.y+Math.sin(t)*n}},getArea:function(){var e=this._view;return Math.PI*((e.endAngle-e.startAngle)/(2*Math.PI))*(Math.pow(e.outerRadius,2)-Math.pow(e.innerRadius,2))},tooltipPosition:function(){var e=this._view,t=e.startAngle+(e.endAngle-e.startAngle)/2,n=(e.outerRadius-e.innerRadius)/2+e.innerRadius;return{x:e.x+Math.cos(t)*n,y:e.y+Math.sin(t)*n}},draw:function(){var e=this._chart.ctx,t=this._view,n=t.startAngle,r=t.endAngle;e.beginPath(),e.arc(t.x,t.y,t.outerRadius,n,r),e.arc(t.x,t.y,t.innerRadius,r,n,!0),e.closePath(),e.strokeStyle=t.borderColor,e.lineWidth=t.borderWidth,e.fillStyle=t.backgroundColor,e.fill(),e.lineJoin="bevel",t.borderWidth&&e.stroke()}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n=e.defaults.global;e.defaults.global.elements.line={tension:.4,backgroundColor:n.defaultColor,borderWidth:3,borderColor:n.defaultColor,borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",capBezierPoints:!0,fill:!0},e.elements.Line=e.Element.extend({draw:function(){var e,r,i,a,o=this,s=o._view,u=o._chart.ctx,d=s.spanGaps,l=o._children.slice(),c=n.elements.line,h=-1;for(o._loop&&l.length&&l.push(l[0]),u.save(),u.lineCap=s.borderCapStyle||c.borderCapStyle,u.setLineDash&&u.setLineDash(s.borderDash||c.borderDash),u.lineDashOffset=s.borderDashOffset||c.borderDashOffset,u.lineJoin=s.borderJoinStyle||c.borderJoinStyle,u.lineWidth=s.borderWidth||c.borderWidth,u.strokeStyle=s.borderColor||n.defaultColor,u.beginPath(),h=-1,e=0;e<l.length;++e)r=l[e],i=t.previousItem(l,e),a=r._view,0===e?a.skip||(u.moveTo(a.x,a.y),h=e):(i=h===-1?i:l[h],a.skip||(h!==e-1&&!d||h===-1?u.moveTo(a.x,a.y):t.canvas.lineTo(u,i._view,r._view),h=e));u.stroke(),u.restore()}})}},function(e,t){"use strict";e.exports=function(e){function t(e){var t=this._view;return!!t&&Math.pow(e-t.x,2)<Math.pow(t.radius+t.hitRadius,2)}function n(e){var t=this._view;return!!t&&Math.pow(e-t.y,2)<Math.pow(t.radius+t.hitRadius,2)}var r=e.helpers,i=e.defaults.global,a=i.defaultColor;i.elements.point={radius:3,pointStyle:"circle",backgroundColor:a,borderWidth:1,borderColor:a,hitRadius:1,hoverRadius:4,hoverBorderWidth:1},e.elements.Point=e.Element.extend({inRange:function(e,t){var n=this._view;return!!n&&Math.pow(e-n.x,2)+Math.pow(t-n.y,2)<Math.pow(n.hitRadius+n.radius,2)},inLabelRange:t,inXRange:t,inYRange:n,getCenterPoint:function(){var e=this._view;return{x:e.x,y:e.y}},getArea:function(){return Math.PI*Math.pow(this._view.radius,2)},tooltipPosition:function(){var e=this._view;return{x:e.x,y:e.y,padding:e.radius+e.borderWidth}},draw:function(t){var n=this._view,o=this._model,s=this._chart.ctx,u=n.pointStyle,d=n.radius,l=n.x,c=n.y,h=e.helpers.color,_=1.01,f=0;n.skip||(s.strokeStyle=n.borderColor||a,s.lineWidth=r.getValueOrDefault(n.borderWidth,i.elements.point.borderWidth),s.fillStyle=n.backgroundColor||a,void 0!==t&&(o.x<t.left||t.right*_<o.x||o.y<t.top||t.bottom*_<o.y)&&(o.x<t.left?f=(l-o.x)/(t.left-o.x):t.right*_<o.x?f=(o.x-l)/(o.x-t.right):o.y<t.top?f=(c-o.y)/(t.top-o.y):t.bottom*_<o.y&&(f=(o.y-c)/(o.y-t.bottom)),f=Math.round(100*f)/100,s.strokeStyle=h(s.strokeStyle).alpha(f).rgbString(),s.fillStyle=h(s.fillStyle).alpha(f).rgbString()),e.canvasHelpers.drawPoint(s,u,d,l,c))}})}},function(e,t){"use strict";e.exports=function(e){function t(e){return void 0!==e._view.width}function n(e){var n,r,i,a,o=e._view;if(t(e)){var s=o.width/2;n=o.x-s,r=o.x+s,i=Math.min(o.y,o.base),a=Math.max(o.y,o.base)}else{var u=o.height/2;n=Math.min(o.x,o.base),r=Math.max(o.x,o.base),i=o.y-u,a=o.y+u}return{left:n,top:i,right:r,bottom:a}}var r=e.defaults.global;r.elements.rectangle={backgroundColor:r.defaultColor,borderWidth:0,borderColor:r.defaultColor,borderSkipped:"bottom"},e.elements.Rectangle=e.Element.extend({draw:function(){function e(e){return g[(y+e)%4]}var t,n,r,i,a,o,s,u=this._chart.ctx,d=this._view,l=d.borderWidth;if(d.horizontal?(t=d.base,n=d.x,r=d.y-d.height/2,i=d.y+d.height/2,a=n>t?1:-1,o=1,s=d.borderSkipped||"left"):(t=d.x-d.width/2,n=d.x+d.width/2,r=d.y,i=d.base,a=1,o=i>r?1:-1,s=d.borderSkipped||"bottom"),l){var c=Math.min(Math.abs(t-n),Math.abs(r-i));l=l>c?c:l;var h=l/2,_=t+("left"!==s?h*a:0),f=n+("right"!==s?-h*a:0),m=r+("top"!==s?h*o:0),p=i+("bottom"!==s?-h*o:0);_!==f&&(r=m,i=p),m!==p&&(t=_,n=f)}u.beginPath(),u.fillStyle=d.backgroundColor,u.strokeStyle=d.borderColor,u.lineWidth=l;var g=[[t,i],[t,r],[n,r],[n,i]],v=["bottom","left","top","right"],y=v.indexOf(s,0);y===-1&&(y=0);var M=e(0);u.moveTo(M[0],M[1]);for(var b=1;b<4;b++)M=e(b),u.lineTo(M[0],M[1]);u.fill(),l&&u.stroke()},height:function(){var e=this._view;return e.base-e.y},inRange:function(e,t){var r=!1;if(this._view){var i=n(this);r=e>=i.left&&e<=i.right&&t>=i.top&&t<=i.bottom}return r},inLabelRange:function(e,r){var i=this;if(!i._view)return!1;var a=!1,o=n(i);return a=t(i)?e>=o.left&&e<=o.right:r>=o.top&&r<=o.bottom},inXRange:function(e){var t=n(this);return e>=t.left&&e<=t.right},inYRange:function(e){var t=n(this);return e>=t.top&&e<=t.bottom},getCenterPoint:function(){var e,n,r=this._view;return t(this)?(e=r.x,n=(r.y+r.base)/2):(e=(r.x+r.base)/2,n=r.y),{x:e,y:n}},getArea:function(){var e=this._view;return e.width*Math.abs(e.y-e.base)},tooltipPosition:function(){var e=this._view;return{x:e.x,y:e.y}}})}},function(e,t){"use strict";e.exports=function(e){function t(e,t){var n=u.getStyle(e,t),r=n&&n.match(/^(\d+)(\.\d+)?px$/);return r?Number(r[1]):void 0}function n(e,n){var r=e.style,i=e.getAttribute("height"),a=e.getAttribute("width");if(e._chartjs={initial:{height:i,width:a,style:{display:r.display,height:r.height,width:r.width}}},r.display=r.display||"block",null===a||""===a){var o=t(e,"width");void 0!==o&&(e.width=o)}if(null===i||""===i)if(""===e.style.height)e.height=e.width/(n.options.aspectRatio||2);else{var s=t(e,"height");void 0!==o&&(e.height=s)}return e}function r(e,t,n,r,i){return{type:e,chart:t,native:i||null,x:void 0!==n?n:null,y:void 0!==r?r:null}}function i(e,t){var n=d[e.type]||e.type,i=u.getRelativePosition(e,t);return r(n,t,i.x,i.y,e)}function a(e){var t=document.createElement("iframe");return t.className="chartjs-hidden-iframe",t.style.cssText="display:block;overflow:hidden;border:0;margin:0;top:0;left:0;bottom:0;right:0;height:100%;width:100%;position:absolute;pointer-events:none;z-index:-1;",t.tabIndex=-1,u.addEvent(t,"load",function(){u.addEvent(t.contentWindow||t,"resize",e),e()}),t}function o(e,t,n){
var i=e._chartjs={ticking:!1},o=function(){i.ticking||(i.ticking=!0,u.requestAnimFrame.call(window,function(){if(i.resizer)return i.ticking=!1,t(r("resize",n))}))};i.resizer=a(o),e.insertBefore(i.resizer,e.firstChild)}function s(e){if(e&&e._chartjs){var t=e._chartjs.resizer;t&&(t.parentNode.removeChild(t),e._chartjs.resizer=null),delete e._chartjs}}var u=e.helpers,d={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"};return{acquireContext:function(e,t){"string"==typeof e?e=document.getElementById(e):e.length&&(e=e[0]),e&&e.canvas&&(e=e.canvas);var r=e&&e.getContext&&e.getContext("2d");return r&&r.canvas===e?(n(e,t),r):null},releaseContext:function(e){var t=e.canvas;if(t._chartjs){var n=t._chartjs.initial;["height","width"].forEach(function(e){var r=n[e];void 0===r||null===r?t.removeAttribute(e):t.setAttribute(e,r)}),u.each(n.style||{},function(e,n){t.style[n]=e}),t.width=t.width,delete t._chartjs}},addEventListener:function(e,t,n){var r=e.canvas;if("resize"===t)return void o(r.parentNode,n,e);var a=n._chartjs||(n._chartjs={}),s=a.proxies||(a.proxies={}),d=s[e.id+"_"+t]=function(t){n(i(t,e))};u.addEvent(r,t,d)},removeEventListener:function(e,t,n){var r=e.canvas;if("resize"===t)return void s(r.parentNode,n);var i=n._chartjs||{},a=i.proxies||{},o=a[e.id+"_"+t];o&&u.removeEvent(r,t,o)}}}},function(e,t,n){"use strict";var r=n(246);e.exports=function(e){e.platform={acquireContext:function(){},releaseContext:function(){},addEventListener:function(){},removeEventListener:function(){}},e.helpers.extend(e.platform,r(e))}},function(e,t){"use strict";e.exports=function(e){function t(e,t,n){var r,i=e._model||{},a=i.fill;if(void 0===a&&(a=!!i.backgroundColor),a===!1||null===a)return!1;if(a===!0)return"origin";if(r=parseFloat(a,10),isFinite(r)&&Math.floor(r)===r)return"-"!==a[0]&&"+"!==a[0]||(r=t+r),!(r===t||r<0||r>=n)&&r;switch(a){case"bottom":return"start";case"top":return"end";case"zero":return"origin";case"origin":case"start":case"end":return a;default:return!1}}function n(e){var t,n=e.el._model||{},r=e.el._scale||{},i=e.fill,a=null;if(isFinite(i))return null;if("start"===i?a=void 0===n.scaleBottom?r.bottom:n.scaleBottom:"end"===i?a=void 0===n.scaleTop?r.top:n.scaleTop:void 0!==n.scaleZero?a=n.scaleZero:r.getBasePosition?a=r.getBasePosition():r.getBasePixel&&(a=r.getBasePixel()),void 0!==a&&null!==a){if(void 0!==a.x&&void 0!==a.y)return a;if("number"==typeof a&&isFinite(a))return t=r.isHorizontal(),{x:t?a:null,y:t?null:a}}return null}function r(e,t,n){var r,i=e[t],a=i.fill,o=[t];if(!n)return a;for(;a!==!1&&o.indexOf(a)===-1;){if(!isFinite(a))return a;if(r=e[a],!r)return!1;if(r.visible)return a;o.push(a),a=r.fill}return!1}function i(e){var t=e.fill,n="dataset";return t===!1?null:(isFinite(t)||(n="boundary"),l[n](e))}function a(e){return e&&!e.skip}function o(e,t,n,r,i){var a;if(r&&i){for(e.moveTo(t[0].x,t[0].y),a=1;a<r;++a)d.canvas.lineTo(e,t[a-1],t[a]);for(e.lineTo(n[i-1].x,n[i-1].y),a=i-1;a>0;--a)d.canvas.lineTo(e,n[a],n[a-1],!0)}}function s(e,t,n,r,i,s){var u,d,l,c,h,_,f,m=t.length,p=r.spanGaps,g=[],v=[],y=0,M=0;for(e.beginPath(),u=0,d=m+!!s;u<d;++u)l=u%m,c=t[l]._view,h=n(c,l,r),_=a(c),f=a(h),_&&f?(y=g.push(c),M=v.push(h)):y&&M&&(p?(_&&g.push(c),f&&v.push(h)):(o(e,g,v,y,M),y=M=0,g=[],v=[]));o(e,g,v,y,M),e.closePath(),e.fillStyle=i,e.fill()}e.defaults.global.plugins.filler={propagate:!0};var u=e.defaults,d=e.helpers,l={dataset:function(e){var t=e.fill,n=e.chart,r=n.getDatasetMeta(t),i=r&&n.isDatasetVisible(t),a=i&&r.dataset._children||[];return a.length?function(e,t){return a[t]._view||null}:null},boundary:function(e){var t=e.boundary,n=t?t.x:null,r=t?t.y:null;return function(e){return{x:null===n?e.x:n,y:null===r?e.y:r}}}};return{id:"filler",afterDatasetsUpdate:function(a,o){var s,u,d,l,c=(a.data.datasets||[]).length,h=o.propagate,_=[];for(u=0;u<c;++u)s=a.getDatasetMeta(u),d=s.dataset,l=null,d&&d._model&&d instanceof e.elements.Line&&(l={visible:a.isDatasetVisible(u),fill:t(d,u,c),chart:a,el:d}),s.$filler=l,_.push(l);for(u=0;u<c;++u)l=_[u],l&&(l.fill=r(_,u,h),l.boundary=n(l),l.mapper=i(l))},beforeDatasetDraw:function(e,t){var n=t.meta.$filler;if(n){var r=n.el,i=r._view,a=r._children||[],o=n.mapper,d=i.backgroundColor||u.global.defaultColor;o&&d&&a.length&&s(e.ctx,a,o,i,d,r._loop)}}}}},function(e,t){"use strict";e.exports=function(e){function t(e,t){return e.usePointStyle?t*Math.SQRT2:e.boxWidth}function n(t,n){var r=new e.Legend({ctx:t.ctx,options:n,chart:t});i.configure(t,r,n),i.addBox(t,r),t.legend=r}var r=e.helpers,i=e.layoutService,a=r.noop;return e.defaults.global.legend={display:!0,position:"top",fullWidth:!0,reverse:!1,weight:1e3,onClick:function(e,t){var n=t.datasetIndex,r=this.chart,i=r.getDatasetMeta(n);i.hidden=null===i.hidden?!r.data.datasets[n].hidden:null,r.update()},onHover:null,labels:{boxWidth:40,padding:10,generateLabels:function(e){var t=e.data;return r.isArray(t.datasets)?t.datasets.map(function(t,n){return{text:t.label,fillStyle:r.isArray(t.backgroundColor)?t.backgroundColor[0]:t.backgroundColor,hidden:!e.isDatasetVisible(n),lineCap:t.borderCapStyle,lineDash:t.borderDash,lineDashOffset:t.borderDashOffset,lineJoin:t.borderJoinStyle,lineWidth:t.borderWidth,strokeStyle:t.borderColor,pointStyle:t.pointStyle,datasetIndex:n}},this):[]}}},e.Legend=e.Element.extend({initialize:function(e){r.extend(this,e),this.legendHitBoxes=[],this.doughnutMode=!1},beforeUpdate:a,update:function(e,t,n){var r=this;return r.beforeUpdate(),r.maxWidth=e,r.maxHeight=t,r.margins=n,r.beforeSetDimensions(),r.setDimensions(),r.afterSetDimensions(),r.beforeBuildLabels(),r.buildLabels(),r.afterBuildLabels(),r.beforeFit(),r.fit(),r.afterFit(),r.afterUpdate(),r.minSize},afterUpdate:a,beforeSetDimensions:a,setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0,e.minSize={width:0,height:0}},afterSetDimensions:a,beforeBuildLabels:a,buildLabels:function(){var e=this,t=e.options.labels,n=t.generateLabels.call(e,e.chart);t.filter&&(n=n.filter(function(n){return t.filter(n,e.chart.data)})),e.options.reverse&&n.reverse(),e.legendItems=n},afterBuildLabels:a,beforeFit:a,fit:function(){var n=this,i=n.options,a=i.labels,o=i.display,s=n.ctx,u=e.defaults.global,d=r.getValueOrDefault,l=d(a.fontSize,u.defaultFontSize),c=d(a.fontStyle,u.defaultFontStyle),h=d(a.fontFamily,u.defaultFontFamily),_=r.fontString(l,c,h),f=n.legendHitBoxes=[],m=n.minSize,p=n.isHorizontal();if(p?(m.width=n.maxWidth,m.height=o?10:0):(m.width=o?10:0,m.height=n.maxHeight),o)if(s.font=_,p){var g=n.lineWidths=[0],v=n.legendItems.length?l+a.padding:0;s.textAlign="left",s.textBaseline="top",r.each(n.legendItems,function(e,r){var i=t(a,l),o=i+l/2+s.measureText(e.text).width;g[g.length-1]+o+a.padding>=n.width&&(v+=l+a.padding,g[g.length]=n.left),f[r]={left:0,top:0,width:o,height:l},g[g.length-1]+=o+a.padding}),m.height+=v}else{var y=a.padding,M=n.columnWidths=[],b=a.padding,L=0,k=0,Y=l+y;r.each(n.legendItems,function(e,n){var r=t(a,l),i=r+l/2+s.measureText(e.text).width;k+Y>m.height&&(b+=L+a.padding,M.push(L),L=0,k=0),L=Math.max(L,i),k+=Y,f[n]={left:0,top:0,width:i,height:l}}),b+=L,M.push(L),m.width+=b}n.width=m.width,n.height=m.height},afterFit:a,isHorizontal:function(){return"top"===this.options.position||"bottom"===this.options.position},draw:function(){var n=this,i=n.options,a=i.labels,o=e.defaults.global,s=o.elements.line,u=n.width,d=n.lineWidths;if(i.display){var l,c=n.ctx,h=r.getValueOrDefault,_=h(a.fontColor,o.defaultFontColor),f=h(a.fontSize,o.defaultFontSize),m=h(a.fontStyle,o.defaultFontStyle),p=h(a.fontFamily,o.defaultFontFamily),g=r.fontString(f,m,p);c.textAlign="left",c.textBaseline="top",c.lineWidth=.5,c.strokeStyle=_,c.fillStyle=_,c.font=g;var v=t(a,f),y=n.legendHitBoxes,M=function(t,n,r){if(!(isNaN(v)||v<=0)){c.save(),c.fillStyle=h(r.fillStyle,o.defaultColor),c.lineCap=h(r.lineCap,s.borderCapStyle),c.lineDashOffset=h(r.lineDashOffset,s.borderDashOffset),c.lineJoin=h(r.lineJoin,s.borderJoinStyle),c.lineWidth=h(r.lineWidth,s.borderWidth),c.strokeStyle=h(r.strokeStyle,o.defaultColor);var a=0===h(r.lineWidth,s.borderWidth);if(c.setLineDash&&c.setLineDash(h(r.lineDash,s.borderDash)),i.labels&&i.labels.usePointStyle){var u=f*Math.SQRT2/2,d=u/Math.SQRT2,l=t+d,_=n+d;e.canvasHelpers.drawPoint(c,r.pointStyle,u,l,_)}else a||c.strokeRect(t,n,v,f),c.fillRect(t,n,v,f);c.restore()}},b=function(e,t,n,r){c.fillText(n.text,v+f/2+e,t),n.hidden&&(c.beginPath(),c.lineWidth=2,c.moveTo(v+f/2+e,t+f/2),c.lineTo(v+f/2+e+r,t+f/2),c.stroke())},L=n.isHorizontal();l=L?{x:n.left+(u-d[0])/2,y:n.top+a.padding,line:0}:{x:n.left+a.padding,y:n.top+a.padding,line:0};var k=f+a.padding;r.each(n.legendItems,function(e,t){var r=c.measureText(e.text).width,i=v+f/2+r,o=l.x,s=l.y;L?o+i>=u&&(s=l.y+=k,l.line++,o=l.x=n.left+(u-d[l.line])/2):s+k>n.bottom&&(o=l.x=o+n.columnWidths[l.line]+a.padding,s=l.y=n.top+a.padding,l.line++),M(o,s,e),y[t].left=o,y[t].top=s,b(o,s,e,r),L?l.x+=i+a.padding:l.y+=k})}},handleEvent:function(e){var t=this,n=t.options,r="mouseup"===e.type?"click":e.type,i=!1;if("mousemove"===r){if(!n.onHover)return}else{if("click"!==r)return;if(!n.onClick)return}var a=e.x,o=e.y;if(a>=t.left&&a<=t.right&&o>=t.top&&o<=t.bottom)for(var s=t.legendHitBoxes,u=0;u<s.length;++u){var d=s[u];if(a>=d.left&&a<=d.left+d.width&&o>=d.top&&o<=d.top+d.height){if("click"===r){n.onClick.call(t,e.native,t.legendItems[u]),i=!0;break}if("mousemove"===r){n.onHover.call(t,e.native,t.legendItems[u]),i=!0;break}}}return i}}),{id:"legend",beforeInit:function(e){var t=e.options.legend;t&&n(e,t)},beforeUpdate:function(t){var a=t.options.legend,o=t.legend;a?(a=r.configMerge(e.defaults.global.legend,a),o?(i.configure(t,o,a),o.options=a):n(t,a)):o&&(i.removeBox(t,o),delete t.legend)},afterEvent:function(e,t){var n=e.legend;n&&n.handleEvent(t)}}}},function(e,t){"use strict";e.exports=function(e){function t(t,n){var i=new e.Title({ctx:t.ctx,options:n,chart:t});r.configure(t,i,n),r.addBox(t,i),t.titleBlock=i}var n=e.helpers,r=e.layoutService,i=n.noop;return e.defaults.global.title={display:!1,position:"top",fullWidth:!0,weight:2e3,fontStyle:"bold",padding:10,text:""},e.Title=e.Element.extend({initialize:function(e){var t=this;n.extend(t,e),t.legendHitBoxes=[]},beforeUpdate:i,update:function(e,t,n){var r=this;return r.beforeUpdate(),r.maxWidth=e,r.maxHeight=t,r.margins=n,r.beforeSetDimensions(),r.setDimensions(),r.afterSetDimensions(),r.beforeBuildLabels(),r.buildLabels(),r.afterBuildLabels(),r.beforeFit(),r.fit(),r.afterFit(),r.afterUpdate(),r.minSize},afterUpdate:i,beforeSetDimensions:i,setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0,e.minSize={width:0,height:0}},afterSetDimensions:i,beforeBuildLabels:i,buildLabels:i,afterBuildLabels:i,beforeFit:i,fit:function(){var t=this,r=n.getValueOrDefault,i=t.options,a=e.defaults.global,o=i.display,s=r(i.fontSize,a.defaultFontSize),u=t.minSize;t.isHorizontal()?(u.width=t.maxWidth,u.height=o?s+2*i.padding:0):(u.width=o?s+2*i.padding:0,u.height=t.maxHeight),t.width=u.width,t.height=u.height},afterFit:i,isHorizontal:function(){var e=this.options.position;return"top"===e||"bottom"===e},draw:function(){var t=this,r=t.ctx,i=n.getValueOrDefault,a=t.options,o=e.defaults.global;if(a.display){var s,u,d,l=i(a.fontSize,o.defaultFontSize),c=i(a.fontStyle,o.defaultFontStyle),h=i(a.fontFamily,o.defaultFontFamily),_=n.fontString(l,c,h),f=0,m=t.top,p=t.left,g=t.bottom,v=t.right;r.fillStyle=i(a.fontColor,o.defaultFontColor),r.font=_,t.isHorizontal()?(s=p+(v-p)/2,u=m+(g-m)/2,d=v-p):(s="left"===a.position?p+l/2:v-l/2,u=m+(g-m)/2,d=g-m,f=Math.PI*("left"===a.position?-.5:.5)),r.save(),r.translate(s,u),r.rotate(f),r.textAlign="center",r.textBaseline="middle",r.fillText(a.text,0,0,d),r.restore()}}}),{id:"title",beforeInit:function(e){var n=e.options.title;n&&t(e,n)},beforeUpdate:function(i){var a=i.options.title,o=i.titleBlock;a?(a=n.configMerge(e.defaults.global.title,a),o?(r.configure(i,o,a),o.options=a):t(i,a)):o&&(e.layoutService.removeBox(i,o),delete i.titleBlock)}}}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n={position:"bottom"},r=e.Scale.extend({getLabels:function(){var e=this.chart.data;return(this.isHorizontal()?e.xLabels:e.yLabels)||e.labels},determineDataLimits:function(){var e=this,n=e.getLabels();e.minIndex=0,e.maxIndex=n.length-1;var r;void 0!==e.options.ticks.min&&(r=t.indexOf(n,e.options.ticks.min),e.minIndex=r!==-1?r:e.minIndex),void 0!==e.options.ticks.max&&(r=t.indexOf(n,e.options.ticks.max),e.maxIndex=r!==-1?r:e.maxIndex),e.min=n[e.minIndex],e.max=n[e.maxIndex]},buildTicks:function(){var e=this,t=e.getLabels();e.ticks=0===e.minIndex&&e.maxIndex===t.length-1?t:t.slice(e.minIndex,e.maxIndex+1)},getLabelForIndex:function(e,t){var n=this,r=n.chart.data,i=n.isHorizontal();return r.yLabels&&!i?n.getRightValue(r.datasets[t].data[e]):n.ticks[e-n.minIndex]},getPixelForValue:function(e,t,n,r){var i,a=this,o=Math.max(a.maxIndex+1-a.minIndex-(a.options.gridLines.offsetGridLines?0:1),1);if(void 0!==e&&null!==e&&(i=a.isHorizontal()?e.x:e.y),void 0!==i||void 0!==e&&isNaN(t)){var s=a.getLabels();e=i||e;var u=s.indexOf(e);t=u!==-1?u:t}if(a.isHorizontal()){var d=a.width/o,l=d*(t-a.minIndex);return(a.options.gridLines.offsetGridLines&&r||a.maxIndex===a.minIndex&&r)&&(l+=d/2),a.left+Math.round(l)}var c=a.height/o,h=c*(t-a.minIndex);return a.options.gridLines.offsetGridLines&&r&&(h+=c/2),a.top+Math.round(h)},getPixelForTick:function(e,t){return this.getPixelForValue(this.ticks[e],e+this.minIndex,null,t)},getValueForPixel:function(e){var t,n=this,r=Math.max(n.ticks.length-(n.options.gridLines.offsetGridLines?0:1),1),i=n.isHorizontal(),a=(i?n.width:n.height)/r;return e-=i?n.left:n.top,n.options.gridLines.offsetGridLines&&(e-=a/2),t=e<=0?0:Math.round(e/a)},getBasePixel:function(){return this.bottom}});e.scaleService.registerScaleType("category",r,n)}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n={position:"left",ticks:{callback:e.Ticks.formatters.linear}},r=e.LinearScaleBase.extend({determineDataLimits:function(){function e(e){return s?e.xAxisID===n.id:e.yAxisID===n.id}var n=this,r=n.options,i=n.chart,a=i.data,o=a.datasets,s=n.isHorizontal(),u=0,d=1;n.min=null,n.max=null;var l=r.stacked;if(void 0===l&&t.each(o,function(t,n){if(!l){var r=i.getDatasetMeta(n);i.isDatasetVisible(n)&&e(r)&&void 0!==r.stack&&(l=!0)}}),r.stacked||l){var c={};t.each(o,function(a,o){var s=i.getDatasetMeta(o),u=[s.type,void 0===r.stacked&&void 0===s.stack?o:"",s.stack].join(".");void 0===c[u]&&(c[u]={positiveValues:[],negativeValues:[]});var d=c[u].positiveValues,l=c[u].negativeValues;i.isDatasetVisible(o)&&e(s)&&t.each(a.data,function(e,t){var i=+n.getRightValue(e);isNaN(i)||s.data[t].hidden||(d[t]=d[t]||0,l[t]=l[t]||0,r.relativePoints?d[t]=100:i<0?l[t]+=i:d[t]+=i)})}),t.each(c,function(e){var r=e.positiveValues.concat(e.negativeValues),i=t.min(r),a=t.max(r);n.min=null===n.min?i:Math.min(n.min,i),n.max=null===n.max?a:Math.max(n.max,a)})}else t.each(o,function(r,a){var o=i.getDatasetMeta(a);i.isDatasetVisible(a)&&e(o)&&t.each(r.data,function(e,t){var r=+n.getRightValue(e);isNaN(r)||o.data[t].hidden||(null===n.min?n.min=r:r<n.min&&(n.min=r),null===n.max?n.max=r:r>n.max&&(n.max=r))})});n.min=isFinite(n.min)?n.min:u,n.max=isFinite(n.max)?n.max:d,this.handleTickRangeOptions()},getTickLimit:function(){var n,r=this,i=r.options.ticks;if(r.isHorizontal())n=Math.min(i.maxTicksLimit?i.maxTicksLimit:11,Math.ceil(r.width/50));else{var a=t.getValueOrDefault(i.fontSize,e.defaults.global.defaultFontSize);n=Math.min(i.maxTicksLimit?i.maxTicksLimit:11,Math.ceil(r.height/(2*a)))}return n},handleDirectionalChanges:function(){this.isHorizontal()||this.ticks.reverse()},getLabelForIndex:function(e,t){return+this.getRightValue(this.chart.data.datasets[t].data[e])},getPixelForValue:function(e){var t,n=this,r=n.start,i=+n.getRightValue(e),a=n.end-r;return n.isHorizontal()?(t=n.left+n.width/a*(i-r),Math.round(t)):(t=n.bottom-n.height/a*(i-r),Math.round(t))},getValueForPixel:function(e){var t=this,n=t.isHorizontal(),r=n?t.width:t.height,i=(n?e-t.left:t.bottom-e)/r;return t.start+(t.end-t.start)*i},getPixelForTick:function(e){return this.getPixelForValue(this.ticksAsNumbers[e])}});e.scaleService.registerScaleType("linear",r,n)}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n=t.noop;e.LinearScaleBase=e.Scale.extend({handleTickRangeOptions:function(){var e=this,n=e.options,r=n.ticks;if(r.beginAtZero){var i=t.sign(e.min),a=t.sign(e.max);i<0&&a<0?e.max=0:i>0&&a>0&&(e.min=0)}void 0!==r.min?e.min=r.min:void 0!==r.suggestedMin&&(null===e.min?e.min=r.suggestedMin:e.min=Math.min(e.min,r.suggestedMin)),void 0!==r.max?e.max=r.max:void 0!==r.suggestedMax&&(null===e.max?e.max=r.suggestedMax:e.max=Math.max(e.max,r.suggestedMax)),e.min===e.max&&(e.max++,r.beginAtZero||e.min--)},getTickLimit:n,handleDirectionalChanges:n,buildTicks:function(){var n=this,r=n.options,i=r.ticks,a=n.getTickLimit();a=Math.max(2,a);var o={maxTicks:a,min:i.min,max:i.max,stepSize:t.getValueOrDefault(i.fixedStepSize,i.stepSize)},s=n.ticks=e.Ticks.generators.linear(o,n);n.handleDirectionalChanges(),n.max=t.max(s),n.min=t.min(s),i.reverse?(s.reverse(),n.start=n.max,n.end=n.min):(n.start=n.min,n.end=n.max)},convertTicksToLabels:function(){var t=this;t.ticksAsNumbers=t.ticks.slice(),t.zeroLineIndex=t.ticks.indexOf(0),e.Scale.prototype.convertTicksToLabels.call(t)}})}},function(e,t){"use strict";e.exports=function(e){var t=e.helpers,n={position:"left",ticks:{callback:e.Ticks.formatters.logarithmic}},r=e.Scale.extend({determineDataLimits:function(){function e(e){return d?e.xAxisID===n.id:e.yAxisID===n.id}var n=this,r=n.options,i=r.ticks,a=n.chart,o=a.data,s=o.datasets,u=t.getValueOrDefault,d=n.isHorizontal();n.min=null,n.max=null,n.minNotZero=null;var l=r.stacked;if(void 0===l&&t.each(s,function(t,n){if(!l){var r=a.getDatasetMeta(n);a.isDatasetVisible(n)&&e(r)&&void 0!==r.stack&&(l=!0)}}),r.stacked||l){var c={};t.each(s,function(i,o){var s=a.getDatasetMeta(o),u=[s.type,void 0===r.stacked&&void 0===s.stack?o:"",s.stack].join(".");a.isDatasetVisible(o)&&e(s)&&(void 0===c[u]&&(c[u]=[]),t.each(i.data,function(e,t){var i=c[u],a=+n.getRightValue(e);isNaN(a)||s.data[t].hidden||(i[t]=i[t]||0,r.relativePoints?i[t]=100:i[t]+=a)}))}),t.each(c,function(e){var r=t.min(e),i=t.max(e);n.min=null===n.min?r:Math.min(n.min,r),n.max=null===n.max?i:Math.max(n.max,i)})}else t.each(s,function(r,i){var o=a.getDatasetMeta(i);a.isDatasetVisible(i)&&e(o)&&t.each(r.data,function(e,t){var r=+n.getRightValue(e);isNaN(r)||o.data[t].hidden||(null===n.min?n.min=r:r<n.min&&(n.min=r),null===n.max?n.max=r:r>n.max&&(n.max=r),0!==r&&(null===n.minNotZero||r<n.minNotZero)&&(n.minNotZero=r))})});n.min=u(i.min,n.min),n.max=u(i.max,n.max),n.min===n.max&&(0!==n.min&&null!==n.min?(n.min=Math.pow(10,Math.floor(t.log10(n.min))-1),n.max=Math.pow(10,Math.floor(t.log10(n.max))+1)):(n.min=1,n.max=10))},buildTicks:function(){var n=this,r=n.options,i=r.ticks,a={min:i.min,max:i.max},o=n.ticks=e.Ticks.generators.logarithmic(a,n);n.isHorizontal()||o.reverse(),n.max=t.max(o),n.min=t.min(o),i.reverse?(o.reverse(),n.start=n.max,n.end=n.min):(n.start=n.min,n.end=n.max)},convertTicksToLabels:function(){this.tickValues=this.ticks.slice(),e.Scale.prototype.convertTicksToLabels.call(this)},getLabelForIndex:function(e,t){return+this.getRightValue(this.chart.data.datasets[t].data[e])},getPixelForTick:function(e){return this.getPixelForValue(this.tickValues[e])},getPixelForValue:function(e){var n,r,i,a=this,o=a.start,s=+a.getRightValue(e),u=a.options,d=u.ticks;return a.isHorizontal()?(i=t.log10(a.end)-t.log10(o),0===s?r=a.left:(n=a.width,r=a.left+n/i*(t.log10(s)-t.log10(o)))):(n=a.height,0!==o||d.reverse?0===a.end&&d.reverse?(i=t.log10(a.start)-t.log10(a.minNotZero),r=s===a.end?a.top:s===a.minNotZero?a.top+.02*n:a.top+.02*n+.98*n/i*(t.log10(s)-t.log10(a.minNotZero))):0===s?r=d.reverse?a.top:a.bottom:(i=t.log10(a.end)-t.log10(o),n=a.height,r=a.bottom-n/i*(t.log10(s)-t.log10(o))):(i=t.log10(a.end)-t.log10(a.minNotZero),r=s===o?a.bottom:s===a.minNotZero?a.bottom-.02*n:a.bottom-.02*n-.98*n/i*(t.log10(s)-t.log10(a.minNotZero)))),r},getValueForPixel:function(e){var n,r,i=this,a=t.log10(i.end)-t.log10(i.start);return i.isHorizontal()?(r=i.width,n=i.start*Math.pow(10,(e-i.left)*a/r)):(r=i.height,n=Math.pow(10,(i.bottom-e)*a/r)/i.start),n}});e.scaleService.registerScaleType("logarithmic",r,n)}},function(e,t){"use strict";e.exports=function(e){function t(e){var t=e.options;return t.angleLines.display||t.pointLabels.display?e.chart.data.labels.length:0}function n(e){var t=e.options.pointLabels,n=_.getValueOrDefault(t.fontSize,f.defaultFontSize),r=_.getValueOrDefault(t.fontStyle,f.defaultFontStyle),i=_.getValueOrDefault(t.fontFamily,f.defaultFontFamily),a=_.fontString(n,r,i);return{size:n,style:r,family:i,font:a}}function r(e,t,n){return _.isArray(n)?{w:_.longestText(e,e.font,n),h:n.length*t+1.5*(n.length-1)*t}:{w:e.measureText(n).width,h:t}}function i(e,t,n,r,i){return e===r||e===i?{start:t-n/2,end:t+n/2}:e<r||e>i?{start:t-n-5,end:t}:{start:t,end:t+n+5}}function a(e){var a,o,s,u=n(e),d=Math.min(e.height/2,e.width/2),l={r:e.width,l:0,t:e.height,b:0},c={};e.ctx.font=u.font,e._pointLabelSizes=[];var h=t(e);for(a=0;a<h;a++){s=e.getPointPosition(a,d),o=r(e.ctx,u.size,e.pointLabels[a]||""),e._pointLabelSizes[a]=o;var f=e.getIndexAngle(a),m=_.toDegrees(f)%360,p=i(m,s.x,o.w,0,180),g=i(m,s.y,o.h,90,270);p.start<l.l&&(l.l=p.start,c.l=f),p.end>l.r&&(l.r=p.end,c.r=f),g.start<l.t&&(l.t=g.start,c.t=f),g.end>l.b&&(l.b=g.end,c.b=f)}e.setReductions(d,l,c)}function o(e){var t=Math.min(e.height/2,e.width/2);e.drawingArea=Math.round(t),e.setCenterPoint(0,0,0,0)}function s(e){return 0===e||180===e?"center":e<180?"left":"right"}function u(e,t,n,r){if(_.isArray(t))for(var i=n.y,a=1.5*r,o=0;o<t.length;++o)e.fillText(t[o],n.x,i),i+=a;else e.fillText(t,n.x,n.y)}function d(e,t,n){90===e||270===e?n.y-=t.h/2:(e>270||e<90)&&(n.y-=t.h)}function l(e){var r=e.ctx,i=_.getValueOrDefault,a=e.options,o=a.angleLines,l=a.pointLabels;r.lineWidth=o.lineWidth,r.strokeStyle=o.color;var c=e.getDistanceFromCenterForValue(a.reverse?e.min:e.max),h=n(e);r.textBaseline="top";for(var m=t(e)-1;m>=0;m--){if(o.display){var p=e.getPointPosition(m,c);r.beginPath(),r.moveTo(e.xCenter,e.yCenter),r.lineTo(p.x,p.y),r.stroke(),r.closePath()}if(l.display){var g=e.getPointPosition(m,c+5),v=i(l.fontColor,f.defaultFontColor);r.font=h.font,r.fillStyle=v;var y=e.getIndexAngle(m),M=_.toDegrees(y);r.textAlign=s(M),d(M,e._pointLabelSizes[m],g),u(r,e.pointLabels[m]||"",g,h.size)}}}function c(e,n,r,i){var a=e.ctx;if(a.strokeStyle=_.getValueAtIndexOrDefault(n.color,i-1),a.lineWidth=_.getValueAtIndexOrDefault(n.lineWidth,i-1),e.options.gridLines.circular)a.beginPath(),a.arc(e.xCenter,e.yCenter,r,0,2*Math.PI),a.closePath(),a.stroke();else{var o=t(e);if(0===o)return;a.beginPath();var s=e.getPointPosition(0,r);a.moveTo(s.x,s.y);for(var u=1;u<o;u++)s=e.getPointPosition(u,r),a.lineTo(s.x,s.y);a.closePath(),a.stroke()}}function h(e){return _.isNumber(e)?e:0}var _=e.helpers,f=e.defaults.global,m={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,color:"rgba(0, 0, 0, 0.1)",lineWidth:1},gridLines:{circular:!1},ticks:{showLabelBackdrop:!0,backdropColor:"rgba(255,255,255,0.75)",backdropPaddingY:2,backdropPaddingX:2,callback:e.Ticks.formatters.linear},pointLabels:{display:!0,fontSize:10,callback:function(e){return e}}},p=e.LinearScaleBase.extend({setDimensions:function(){var e=this,t=e.options,n=t.ticks;e.width=e.maxWidth,e.height=e.maxHeight,e.xCenter=Math.round(e.width/2),e.yCenter=Math.round(e.height/2);var r=_.min([e.height,e.width]),i=_.getValueOrDefault(n.fontSize,f.defaultFontSize);e.drawingArea=t.display?r/2-(i/2+n.backdropPaddingY):r/2},determineDataLimits:function(){var e=this,t=e.chart,n=Number.POSITIVE_INFINITY,r=Number.NEGATIVE_INFINITY;_.each(t.data.datasets,function(i,a){if(t.isDatasetVisible(a)){var o=t.getDatasetMeta(a);_.each(i.data,function(t,i){var a=+e.getRightValue(t);isNaN(a)||o.data[i].hidden||(n=Math.min(a,n),r=Math.max(a,r))})}}),e.min=n===Number.POSITIVE_INFINITY?0:n,e.max=r===Number.NEGATIVE_INFINITY?0:r,e.handleTickRangeOptions()},getTickLimit:function(){var e=this.options.ticks,t=_.getValueOrDefault(e.fontSize,f.defaultFontSize);return Math.min(e.maxTicksLimit?e.maxTicksLimit:11,Math.ceil(this.drawingArea/(1.5*t)))},convertTicksToLabels:function(){var t=this;e.LinearScaleBase.prototype.convertTicksToLabels.call(t),t.pointLabels=t.chart.data.labels.map(t.options.pointLabels.callback,t)},getLabelForIndex:function(e,t){return+this.getRightValue(this.chart.data.datasets[t].data[e])},fit:function(){this.options.pointLabels.display?a(this):o(this)},setReductions:function(e,t,n){var r=this,i=t.l/Math.sin(n.l),a=Math.max(t.r-r.width,0)/Math.sin(n.r),o=-t.t/Math.cos(n.t),s=-Math.max(t.b-r.height,0)/Math.cos(n.b);i=h(i),a=h(a),o=h(o),s=h(s),r.drawingArea=Math.min(Math.round(e-(i+a)/2),Math.round(e-(o+s)/2)),r.setCenterPoint(i,a,o,s)},setCenterPoint:function(e,t,n,r){var i=this,a=i.width-t-i.drawingArea,o=e+i.drawingArea,s=n+i.drawingArea,u=i.height-r-i.drawingArea;i.xCenter=Math.round((o+a)/2+i.left),i.yCenter=Math.round((s+u)/2+i.top)},getIndexAngle:function(e){var n=2*Math.PI/t(this),r=this.chart.options&&this.chart.options.startAngle?this.chart.options.startAngle:0,i=r*Math.PI*2/360;return e*n+i},getDistanceFromCenterForValue:function(e){var t=this;if(null===e)return 0;var n=t.drawingArea/(t.max-t.min);return t.options.reverse?(t.max-e)*n:(e-t.min)*n},getPointPosition:function(e,t){var n=this,r=n.getIndexAngle(e)-Math.PI/2;return{x:Math.round(Math.cos(r)*t)+n.xCenter,y:Math.round(Math.sin(r)*t)+n.yCenter}},getPointPositionForValue:function(e,t){return this.getPointPosition(e,this.getDistanceFromCenterForValue(t))},getBasePosition:function(){var e=this,t=e.min,n=e.max;return e.getPointPositionForValue(0,e.beginAtZero?0:t<0&&n<0?n:t>0&&n>0?t:0)},draw:function(){var e=this,t=e.options,n=t.gridLines,r=t.ticks,i=_.getValueOrDefault;if(t.display){var a=e.ctx,o=i(r.fontSize,f.defaultFontSize),s=i(r.fontStyle,f.defaultFontStyle),u=i(r.fontFamily,f.defaultFontFamily),d=_.fontString(o,s,u);_.each(e.ticks,function(s,u){if(u>0||t.reverse){var l=e.getDistanceFromCenterForValue(e.ticksAsNumbers[u]),h=e.yCenter-l;if(n.display&&0!==u&&c(e,n,l,u),r.display){var _=i(r.fontColor,f.defaultFontColor);if(a.font=d,r.showLabelBackdrop){var m=a.measureText(s).width;a.fillStyle=r.backdropColor,a.fillRect(e.xCenter-m/2-r.backdropPaddingX,h-o/2-r.backdropPaddingY,m+2*r.backdropPaddingX,o+2*r.backdropPaddingY)}a.textAlign="center",a.textBaseline="middle",a.fillStyle=_,a.fillText(s,e.xCenter,h)}}}),(t.angleLines.display||t.pointLabels.display)&&l(e)}}});e.scaleService.registerScaleType("radialLinear",p,m)}},function(e,t,n){"use strict";var r=n(1);r="function"==typeof r?r:window.moment,e.exports=function(e){function t(e,t){var n=e.options.time;if("string"==typeof n.parser)return r(t,n.parser);if("function"==typeof n.parser)return n.parser(t);if("function"==typeof t.getMonth||"number"==typeof t)return r(t);if(t.isValid&&t.isValid())return t;var i=n.format;return"string"!=typeof i&&i.call?(console.warn("options.time.format is deprecated and replaced by options.time.parser."),i(t)):r(t,i)}function n(e,t,n,r){for(var i,a=Object.keys(s),o=a.length,u=a.indexOf(e);u<o;u++){i=a[u];var d=s[i],l=d.steps&&d.steps[d.steps.length-1]||d.maxStep;if(void 0===l||Math.ceil((n-t)/(l*d.size))<=r)break}return i}function i(e,t,n,r){var i=s[n],a=i.size,o=Math.ceil((t-e)/a),u=1,d=t-e;if(i.steps)for(var l=i.steps.length,c=0;c<l&&o>r;c++)u=i.steps[c],o=Math.ceil(d/(a*u));else for(;o>r&&r>0;)++u,o=Math.ceil(d/(a*u));return u}function a(e,t,n){var i=[];if(e.maxTicks){var a=e.stepSize;i.push(void 0!==e.min?e.min:n.min);for(var o=r(n.min);o.add(a,e.unit).valueOf()<n.max;)i.push(o.valueOf());var s=e.max||n.max;i[i.length-1]!==s&&i.push(s)}return i}var o=e.helpers,s={millisecond:{size:1,steps:[1,2,5,10,20,50,100,250,500]},second:{size:1e3,steps:[1,2,5,10,30]},minute:{size:6e4,steps:[1,2,5,10,30]},hour:{size:36e5,steps:[1,2,3,6,12]},day:{size:864e5,steps:[1,2,5]},week:{size:6048e5,maxStep:4},month:{size:2628e6,maxStep:3},quarter:{size:7884e6,maxStep:4},year:{size:3154e7,maxStep:!1}},u={position:"bottom",time:{parser:!1,format:!1,unit:!1,round:!1,displayFormat:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{millisecond:"h:mm:ss.SSS a",second:"h:mm:ss a",minute:"h:mm:ss a",hour:"MMM D, hA",day:"ll",week:"ll",month:"MMM YYYY",quarter:"[Q]Q - YYYY",year:"YYYY"}},ticks:{autoSkip:!1}};e.Ticks.generators.time=function(e,t){var n,i,o=e.isoWeekday;return"week"===e.unit&&o!==!1?(n=r(t.min).startOf("isoWeek").isoWeekday(o).valueOf(),i=r(t.max).startOf("isoWeek").isoWeekday(o),t.max-i>0&&i.add(1,"week"),i=i.valueOf()):(n=r(t.min).startOf(e.unit).valueOf(),i=r(t.max).startOf(e.unit),t.max-i>0&&i.add(1,e.unit),i=i.valueOf()),a(e,t,{min:n,max:i})};var d=e.Scale.extend({initialize:function(){if(!r)throw new Error("Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com");e.Scale.prototype.initialize.call(this)},determineDataLimits:function(){var e,n=this,r=n.options.time,i=Number.MAX_SAFE_INTEGER,a=Number.MIN_SAFE_INTEGER,s=n.chart.data,u={labels:[],datasets:[]};o.each(s.labels,function(o,s){var d=t(n,o);d.isValid()&&(r.round&&d.startOf(r.round),e=d.valueOf(),i=Math.min(e,i),a=Math.max(e,a),u.labels[s]=e)}),o.each(s.datasets,function(s,d){var l=[];"object"==typeof s.data[0]&&null!==s.data[0]&&n.chart.isDatasetVisible(d)?o.each(s.data,function(o,s){var u=t(n,n.getRightValue(o));u.isValid()&&(r.round&&u.startOf(r.round),e=u.valueOf(),i=Math.min(e,i),a=Math.max(e,a),l[s]=e)}):l=u.labels.slice(),u.datasets[d]=l}),n.dataMin=i,n.dataMax=a,n._parsedData=u},buildTicks:function(){var r,a,s=this,u=s.options.time,d=s.dataMin,l=s.dataMax;if(u.min){var c=t(s,u.min);u.round&&c.round(u.round),r=c.valueOf()}u.max&&(a=t(s,u.max).valueOf());var h=s.getLabelCapacity(r||d),_=u.unit||n(u.minUnit,r||d,a||l,h);s.displayFormat=u.displayFormats[_];var f=u.stepSize||i(r||d,a||l,_,h);s.ticks=e.Ticks.generators.time({maxTicks:h,min:r,max:a,stepSize:f,unit:_,isoWeekday:u.isoWeekday},{min:d,max:l}),s.max=o.max(s.ticks),s.min=o.min(s.ticks)},getLabelForIndex:function(e,n){var r=this,i=r.chart.data.labels&&e<r.chart.data.labels.length?r.chart.data.labels[e]:"",a=r.chart.data.datasets[n].data[e];return null!==a&&"object"==typeof a&&(i=r.getRightValue(a)),r.options.time.tooltipFormat&&(i=t(r,i).format(r.options.time.tooltipFormat)),i},tickFormatFunction:function(e,t,n){var r=e.format(this.displayFormat),i=this.options.ticks,a=o.getValueOrDefault(i.callback,i.userCallback);return a?a(r,t,n):r},convertTicksToLabels:function(){var e=this;e.ticksAsTimestamps=e.ticks,e.ticks=e.ticks.map(function(e){return r(e)}).map(e.tickFormatFunction,e)},getPixelForOffset:function(e){var t=this,n=t.max-t.min,r=n?(e-t.min)/n:0;if(t.isHorizontal()){var i=t.width*r;return t.left+Math.round(i)}var a=t.height*r;return t.top+Math.round(a)},getPixelForValue:function(e,n,r){var i=this,a=null;if(void 0!==n&&void 0!==r&&(a=i._parsedData.datasets[r][n]),null===a&&(e&&e.isValid||(e=t(i,i.getRightValue(e))),e&&e.isValid&&e.isValid()&&(a=e.valueOf())),null!==a)return i.getPixelForOffset(a)},getPixelForTick:function(e){return this.getPixelForOffset(this.ticksAsTimestamps[e])},getValueForPixel:function(e){var t=this,n=t.isHorizontal()?t.width:t.height,i=(e-(t.isHorizontal()?t.left:t.top))/n;return r(t.min+i*(t.max-t.min))},getLabelWidth:function(t){var n=this,r=n.options.ticks,i=n.ctx.measureText(t).width,a=Math.cos(o.toRadians(r.maxRotation)),s=Math.sin(o.toRadians(r.maxRotation)),u=o.getValueOrDefault(r.fontSize,e.defaults.global.defaultFontSize);
return i*a+u*s},getLabelCapacity:function(e){var t=this;t.displayFormat=t.options.time.displayFormats.millisecond;var n=t.tickFormatFunction(r(e),0,[]),i=t.getLabelWidth(n),a=t.isHorizontal()?t.width:t.height,o=a/i;return o}});e.scaleService.registerScaleType("time",d,u)}},function(e,t,n){function r(e){if(e){var t=/^#([a-fA-F0-9]{3})$/,n=/^#([a-fA-F0-9]{6})$/,r=/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,i=/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,a=/(\w+)/,o=[0,0,0],s=1,u=e.match(t);if(u){u=u[1];for(var d=0;d<o.length;d++)o[d]=parseInt(u[d]+u[d],16)}else if(u=e.match(n)){u=u[1];for(var d=0;d<o.length;d++)o[d]=parseInt(u.slice(2*d,2*d+2),16)}else if(u=e.match(r)){for(var d=0;d<o.length;d++)o[d]=parseInt(u[d+1]);s=parseFloat(u[4])}else if(u=e.match(i)){for(var d=0;d<o.length;d++)o[d]=Math.round(2.55*parseFloat(u[d+1]));s=parseFloat(u[4])}else if(u=e.match(a)){if("transparent"==u[1])return[0,0,0,0];if(o=M[u[1]],!o)return}for(var d=0;d<o.length;d++)o[d]=v(o[d],0,255);return s=s||0==s?v(s,0,1):1,o[3]=s,o}}function i(e){if(e){var t=/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,n=e.match(t);if(n){var r=parseFloat(n[4]),i=v(parseInt(n[1]),0,360),a=v(parseFloat(n[2]),0,100),o=v(parseFloat(n[3]),0,100),s=v(isNaN(r)?1:r,0,1);return[i,a,o,s]}}}function a(e){if(e){var t=/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,n=e.match(t);if(n){var r=parseFloat(n[4]),i=v(parseInt(n[1]),0,360),a=v(parseFloat(n[2]),0,100),o=v(parseFloat(n[3]),0,100),s=v(isNaN(r)?1:r,0,1);return[i,a,o,s]}}}function o(e){var t=r(e);return t&&t.slice(0,3)}function s(e){var t=i(e);return t&&t.slice(0,3)}function u(e){var t=r(e);return t?t[3]:(t=i(e))?t[3]:(t=a(e))?t[3]:void 0}function d(e){return"#"+y(e[0])+y(e[1])+y(e[2])}function l(e,t){return t<1||e[3]&&e[3]<1?c(e,t):"rgb("+e[0]+", "+e[1]+", "+e[2]+")"}function c(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"rgba("+e[0]+", "+e[1]+", "+e[2]+", "+t+")"}function h(e,t){if(t<1||e[3]&&e[3]<1)return _(e,t);var n=Math.round(e[0]/255*100),r=Math.round(e[1]/255*100),i=Math.round(e[2]/255*100);return"rgb("+n+"%, "+r+"%, "+i+"%)"}function _(e,t){var n=Math.round(e[0]/255*100),r=Math.round(e[1]/255*100),i=Math.round(e[2]/255*100);return"rgba("+n+"%, "+r+"%, "+i+"%, "+(t||e[3]||1)+")"}function f(e,t){return t<1||e[3]&&e[3]<1?m(e,t):"hsl("+e[0]+", "+e[1]+"%, "+e[2]+"%)"}function m(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"hsla("+e[0]+", "+e[1]+"%, "+e[2]+"%, "+t+")"}function p(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"hwb("+e[0]+", "+e[1]+"%, "+e[2]+"%"+(void 0!==t&&1!==t?", "+t:"")+")"}function g(e){return b[e.slice(0,3)]}function v(e,t,n){return Math.min(Math.max(t,e),n)}function y(e){var t=e.toString(16).toUpperCase();return t.length<2?"0"+t:t}var M=n(260);e.exports={getRgba:r,getHsla:i,getRgb:o,getHsl:s,getHwb:a,getAlpha:u,hexString:d,rgbString:l,rgbaString:c,percentString:h,percentaString:_,hslString:f,hslaString:m,hwbString:p,keyword:g};var b={};for(var L in M)b[M[L]]=L},function(e,t){function n(e){var t,n,r,i=e[0]/255,a=e[1]/255,o=e[2]/255,s=Math.min(i,a,o),u=Math.max(i,a,o),d=u-s;return u==s?t=0:i==u?t=(a-o)/d:a==u?t=2+(o-i)/d:o==u&&(t=4+(i-a)/d),t=Math.min(60*t,360),t<0&&(t+=360),r=(s+u)/2,n=u==s?0:r<=.5?d/(u+s):d/(2-u-s),[t,100*n,100*r]}function i(e){var t,n,r,i=e[0],a=e[1],o=e[2],s=Math.min(i,a,o),u=Math.max(i,a,o),d=u-s;return n=0==u?0:d/u*1e3/10,u==s?t=0:i==u?t=(a-o)/d:a==u?t=2+(o-i)/d:o==u&&(t=4+(i-a)/d),t=Math.min(60*t,360),t<0&&(t+=360),r=u/255*1e3/10,[t,n,r]}function a(e){var t=e[0],r=e[1],i=e[2],a=n(e)[0],o=1/255*Math.min(t,Math.min(r,i)),i=1-1/255*Math.max(t,Math.max(r,i));return[a,100*o,100*i]}function o(e){var t,n,r,i,a=e[0]/255,o=e[1]/255,s=e[2]/255;return i=Math.min(1-a,1-o,1-s),t=(1-a-i)/(1-i)||0,n=(1-o-i)/(1-i)||0,r=(1-s-i)/(1-i)||0,[100*t,100*n,100*r,100*i]}function s(e){return K[JSON.stringify(e)]}function u(e){var t=e[0]/255,n=e[1]/255,r=e[2]/255;t=t>.04045?Math.pow((t+.055)/1.055,2.4):t/12.92,n=n>.04045?Math.pow((n+.055)/1.055,2.4):n/12.92,r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92;var i=.4124*t+.3576*n+.1805*r,a=.2126*t+.7152*n+.0722*r,o=.0193*t+.1192*n+.9505*r;return[100*i,100*a,100*o]}function d(e){var t,n,r,i=u(e),a=i[0],o=i[1],s=i[2];return a/=95.047,o/=100,s/=108.883,a=a>.008856?Math.pow(a,1/3):7.787*a+16/116,o=o>.008856?Math.pow(o,1/3):7.787*o+16/116,s=s>.008856?Math.pow(s,1/3):7.787*s+16/116,t=116*o-16,n=500*(a-o),r=200*(o-s),[t,n,r]}function l(e){return W(d(e))}function c(e){var t,n,r,i,a,o=e[0]/360,s=e[1]/100,u=e[2]/100;if(0==s)return a=255*u,[a,a,a];n=u<.5?u*(1+s):u+s-u*s,t=2*u-n,i=[0,0,0];for(var d=0;d<3;d++)r=o+1/3*-(d-1),r<0&&r++,r>1&&r--,a=6*r<1?t+6*(n-t)*r:2*r<1?n:3*r<2?t+(n-t)*(2/3-r)*6:t,i[d]=255*a;return i}function h(e){var t,n,r=e[0],i=e[1]/100,a=e[2]/100;return 0===a?[0,0,0]:(a*=2,i*=a<=1?a:2-a,n=(a+i)/2,t=2*i/(a+i),[r,100*t,100*n])}function _(e){return a(c(e))}function f(e){return o(c(e))}function m(e){return s(c(e))}function p(e){var t=e[0]/60,n=e[1]/100,r=e[2]/100,i=Math.floor(t)%6,a=t-Math.floor(t),o=255*r*(1-n),s=255*r*(1-n*a),u=255*r*(1-n*(1-a)),r=255*r;switch(i){case 0:return[r,u,o];case 1:return[s,r,o];case 2:return[o,r,u];case 3:return[o,s,r];case 4:return[u,o,r];case 5:return[r,o,s]}}function v(e){var t,n,r=e[0],i=e[1]/100,a=e[2]/100;return n=(2-i)*a,t=i*a,t/=n<=1?n:2-n,t=t||0,n/=2,[r,100*t,100*n]}function y(e){return a(p(e))}function M(e){return o(p(e))}function L(e){return s(p(e))}function k(e){var t,n,i,a,o=e[0]/360,s=e[1]/100,u=e[2]/100,d=s+u;switch(d>1&&(s/=d,u/=d),t=Math.floor(6*o),n=1-u,i=6*o-t,0!=(1&t)&&(i=1-i),a=s+i*(n-s),t){default:case 6:case 0:r=n,g=a,b=s;break;case 1:r=a,g=n,b=s;break;case 2:r=s,g=n,b=a;break;case 3:r=s,g=a,b=n;break;case 4:r=a,g=s,b=n;break;case 5:r=n,g=s,b=a}return[255*r,255*g,255*b]}function Y(e){return n(k(e))}function x(e){return i(k(e))}function w(e){return o(k(e))}function D(e){return s(k(e))}function T(e){var t,n,r,i=e[0]/100,a=e[1]/100,o=e[2]/100,s=e[3]/100;return t=1-Math.min(1,i*(1-s)+s),n=1-Math.min(1,a*(1-s)+s),r=1-Math.min(1,o*(1-s)+s),[255*t,255*n,255*r]}function S(e){return n(T(e))}function j(e){return i(T(e))}function H(e){return a(T(e))}function A(e){return s(T(e))}function P(e){var t,n,r,i=e[0]/100,a=e[1]/100,o=e[2]/100;return t=3.2406*i+a*-1.5372+o*-.4986,n=i*-.9689+1.8758*a+.0415*o,r=.0557*i+a*-.204+1.057*o,t=t>.0031308?1.055*Math.pow(t,1/2.4)-.055:t*=12.92,n=n>.0031308?1.055*Math.pow(n,1/2.4)-.055:n*=12.92,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:r*=12.92,t=Math.min(Math.max(0,t),1),n=Math.min(Math.max(0,n),1),r=Math.min(Math.max(0,r),1),[255*t,255*n,255*r]}function C(e){var t,n,r,i=e[0],a=e[1],o=e[2];return i/=95.047,a/=100,o/=108.883,i=i>.008856?Math.pow(i,1/3):7.787*i+16/116,a=a>.008856?Math.pow(a,1/3):7.787*a+16/116,o=o>.008856?Math.pow(o,1/3):7.787*o+16/116,t=116*a-16,n=500*(i-a),r=200*(a-o),[t,n,r]}function O(e){return W(C(e))}function F(e){var t,n,r,i,a=e[0],o=e[1],s=e[2];return a<=8?(n=100*a/903.3,i=7.787*(n/100)+16/116):(n=100*Math.pow((a+16)/116,3),i=Math.pow(n/100,1/3)),t=t/95.047<=.008856?t=95.047*(o/500+i-16/116)/7.787:95.047*Math.pow(o/500+i,3),r=r/108.883<=.008859?r=108.883*(i-s/200-16/116)/7.787:108.883*Math.pow(i-s/200,3),[t,n,r]}function W(e){var t,n,r,i=e[0],a=e[1],o=e[2];return t=Math.atan2(o,a),n=360*t/2/Math.PI,n<0&&(n+=360),r=Math.sqrt(a*a+o*o),[i,r,n]}function I(e){return P(F(e))}function E(e){var t,n,r,i=e[0],a=e[1],o=e[2];return r=o/360*2*Math.PI,t=a*Math.cos(r),n=a*Math.sin(r),[i,t,n]}function z(e){return F(E(e))}function R(e){return I(E(e))}function N(e){return G[e]}function V(e){return n(N(e))}function B(e){return i(N(e))}function $(e){return a(N(e))}function J(e){return o(N(e))}function U(e){return d(N(e))}function q(e){return u(N(e))}e.exports={rgb2hsl:n,rgb2hsv:i,rgb2hwb:a,rgb2cmyk:o,rgb2keyword:s,rgb2xyz:u,rgb2lab:d,rgb2lch:l,hsl2rgb:c,hsl2hsv:h,hsl2hwb:_,hsl2cmyk:f,hsl2keyword:m,hsv2rgb:p,hsv2hsl:v,hsv2hwb:y,hsv2cmyk:M,hsv2keyword:L,hwb2rgb:k,hwb2hsl:Y,hwb2hsv:x,hwb2cmyk:w,hwb2keyword:D,cmyk2rgb:T,cmyk2hsl:S,cmyk2hsv:j,cmyk2hwb:H,cmyk2keyword:A,keyword2rgb:N,keyword2hsl:V,keyword2hsv:B,keyword2hwb:$,keyword2cmyk:J,keyword2lab:U,keyword2xyz:q,xyz2rgb:P,xyz2lab:C,xyz2lch:O,lab2xyz:F,lab2rgb:I,lab2lch:W,lch2lab:E,lch2xyz:z,lch2rgb:R};var G={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},K={};for(var Z in G)K[JSON.stringify(G[Z])]=Z},function(e,t,n){var r=n(258),i=function(){return new d};for(var a in r){i[a+"Raw"]=function(e){return function(t){return"number"==typeof t&&(t=Array.prototype.slice.call(arguments)),r[e](t)}}(a);var o=/(\w+)2(\w+)/.exec(a),s=o[1],u=o[2];i[s]=i[s]||{},i[s][u]=i[a]=function(e){return function(t){"number"==typeof t&&(t=Array.prototype.slice.call(arguments));var n=r[e](t);if("string"==typeof n||void 0===n)return n;for(var i=0;i<n.length;i++)n[i]=Math.round(n[i]);return n}}(a)}var d=function(){this.convs={}};d.prototype.routeSpace=function(e,t){var n=t[0];return void 0===n?this.getValues(e):("number"==typeof n&&(n=Array.prototype.slice.call(t)),this.setValues(e,n))},d.prototype.setValues=function(e,t){return this.space=e,this.convs={},this.convs[e]=t,this},d.prototype.getValues=function(e){var t=this.convs[e];if(!t){var n=this.space,r=this.convs[n];t=i[n][e](r),this.convs[e]=t}return t},["rgb","hsl","hsv","cmyk","keyword"].forEach(function(e){d.prototype[e]=function(t){return this.routeSpace(e,arguments)}}),e.exports=i},function(e,t){e.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},function(e,t,n){var r=n(9),i=n(2),a=r(i,"DataView");e.exports=a},function(e,t,n){function r(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var i=n(321),a=n(322),o=n(323),s=n(324),u=n(325);r.prototype.clear=i,r.prototype.delete=a,r.prototype.get=o,r.prototype.has=s,r.prototype.set=u,e.exports=r},function(e,t,n){var r=n(9),i=n(2),a=r(i,"Promise");e.exports=a},function(e,t,n){var r=n(9),i=n(2),a=r(i,"Set");e.exports=a},function(e,t,n){function r(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new i;++t<n;)this.add(e[t])}var i=n(35),a=n(352),o=n(353);r.prototype.add=r.prototype.push=a,r.prototype.has=o,e.exports=r},function(e,t){function n(e,t){return e.set(t[0],t[1]),e}e.exports=n},function(e,t){function n(e,t){return e.add(t),e}e.exports=n},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length,i=0,a=[];++n<r;){var o=e[n];t(o,n,e)&&(a[i++]=o)}return a}e.exports=n},function(e,t,n){function r(e,t){var n=null==e?0:e.length;return!!n&&i(e,t,0)>-1}var i=n(276);e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=null==e?0:e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}e.exports=n},function(e,t,n){function r(e,t){return e&&i(t,a(t),e)}var i=n(13),a=n(31);e.exports=r},function(e,t){function n(e,t,n,r){for(var i=e.length,a=n+(r?1:-1);r?a--:++a<i;)if(t(e[a],a,e))return a;return-1}e.exports=n},function(e,t,n){function r(e,t,n,o,s){var u=-1,d=e.length;for(n||(n=a),s||(s=[]);++u<d;){var l=e[u];t>0&&n(l)?t>1?r(l,t-1,n,o,s):i(s,l):o||(s[s.length]=l)}return s}var i=n(38),a=n(329);e.exports=r},function(e,t,n){var r=n(307),i=r();e.exports=i},function(e,t){function n(e,t){return null!=e&&t in Object(e)}e.exports=n},function(e,t,n){function r(e,t,n){return t===t?o(e,t,n):i(e,a,n)}var i=n(272),a=n(280),o=n(359);e.exports=r},function(e,t,n){function r(e){return a(e)&&i(e)==o}var i=n(11),a=n(7),o="[object Arguments]";e.exports=r},function(e,t,n){function r(e,t,n,r,p,v){var y=d(e),M=d(t),b=y?f:u(e),L=M?f:u(t);b=b==_?m:b,L=L==_?m:L;var k=b==m,Y=L==m,x=b==L;if(x&&l(e)){if(!l(t))return!1;y=!0,k=!1}if(x&&!k)return v||(v=new i),y||c(e)?a(e,t,n,r,p,v):o(e,t,b,n,r,p,v);if(!(n&h)){var w=k&&g.call(e,"__wrapped__"),D=Y&&g.call(t,"__wrapped__");if(w||D){var T=w?e.value():e,S=D?t.value():t;return v||(v=new i),p(T,S,n,r,v)}}return!!x&&(v||(v=new i),s(e,t,n,r,p,v))}var i=n(18),a=n(75),o=n(311),s=n(312),u=n(81),d=n(3),l=n(28),c=n(50),h=1,_="[object Arguments]",f="[object Array]",m="[object Object]",p=Object.prototype,g=p.hasOwnProperty;e.exports=r},function(e,t,n){function r(e,t,n,r){var u=n.length,d=u,l=!r;if(null==e)return!d;for(e=Object(e);u--;){var c=n[u];if(l&&c[2]?c[1]!==e[c[0]]:!(c[0]in e))return!1}for(;++u<d;){c=n[u];var h=c[0],_=e[h],f=c[1];if(l&&c[2]){if(void 0===_&&!(h in e))return!1}else{var m=new i;if(r)var p=r(_,f,h,e,t,m);if(!(void 0===p?a(f,_,o|s,r,m):p))return!1}}return!0}var i=n(18),a=n(64),o=1,s=2;e.exports=r},function(e,t){function n(e){return e!==e}e.exports=n},function(e,t,n){function r(e){if(!o(e)||a(e))return!1;var t=i(e)?f:d;return t.test(s(e))}var i=n(29),a=n(333),o=n(4),s=n(94),u=/[\\^$.*+?()[\]{}|]/g,d=/^\[object .+?Constructor\]$/,l=Function.prototype,c=Object.prototype,h=l.toString,_=c.hasOwnProperty,f=RegExp("^"+h.call(_).replace(u,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=r},function(e,t,n){function r(e){return o(e)&&a(e.length)&&!!H[i(e)]}var i=n(11),a=n(49),o=n(7),s="[object Arguments]",u="[object Array]",d="[object Boolean]",l="[object Date]",c="[object Error]",h="[object Function]",_="[object Map]",f="[object Number]",m="[object Object]",p="[object RegExp]",g="[object Set]",v="[object String]",y="[object WeakMap]",M="[object ArrayBuffer]",b="[object DataView]",L="[object Float32Array]",k="[object Float64Array]",Y="[object Int8Array]",x="[object Int16Array]",w="[object Int32Array]",D="[object Uint8Array]",T="[object Uint8ClampedArray]",S="[object Uint16Array]",j="[object Uint32Array]",H={};H[L]=H[k]=H[Y]=H[x]=H[w]=H[D]=H[T]=H[S]=H[j]=!0,H[s]=H[u]=H[M]=H[d]=H[b]=H[l]=H[c]=H[h]=H[_]=H[f]=H[m]=H[p]=H[g]=H[v]=H[y]=!1,e.exports=r},function(e,t,n){function r(e){return"function"==typeof e?e:null==e?o:"object"==typeof e?s(e)?a(e[0],e[1]):i(e):u(e)}var i=n(285),a=n(286),o=n(25),s=n(3),u=n(380);e.exports=r},function(e,t,n){function r(e){if(!i(e))return o(e);var t=a(e),n=[];for(var r in e)("constructor"!=r||!t&&u.call(e,r))&&n.push(r);return n}var i=n(4),a=n(46),o=n(347),s=Object.prototype,u=s.hasOwnProperty;e.exports=r},function(e,t,n){function r(e){var t=a(e);return 1==t.length&&t[0][2]?o(t[0][0],t[0][1]):function(n){return n===e||i(n,e,t)}}var i=n(279),a=n(316),o=n(85);e.exports=r},function(e,t,n){function r(e,t){return s(e)&&u(t)?d(l(e),t):function(n){var r=a(n,e);return void 0===r&&r===t?o(n,e):i(t,r,c|h)}}var i=n(64),a=n(372),o=n(373),s=n(45),u=n(83),d=n(85),l=n(14),c=1,h=2;e.exports=r},function(e,t,n){function r(e,t,n,l,c){e!==t&&o(t,function(o,d){if(u(o))c||(c=new i),s(e,t,d,n,r,l,c);else{var h=l?l(e[d],o,d+"",e,t,c):void 0;void 0===h&&(h=o),a(e,d,h)}},d)}var i=n(18),a=n(58),o=n(274),s=n(288),u=n(4),d=n(31);e.exports=r},function(e,t,n){function r(e,t,n,r,v,y,M){var b=e[n],L=t[n],k=M.get(L);if(k)return void i(e,n,k);var Y=y?y(b,L,n+"",e,t,M):void 0,x=void 0===Y;if(x){var w=l(L),D=!w&&h(L),T=!w&&!D&&p(L);Y=L,w||D||T?l(b)?Y=b:c(b)?Y=s(b):D?(x=!1,Y=a(L,!0)):T?(x=!1,Y=o(L,!0)):Y=[]:m(L)||d(L)?(Y=b,d(b)?Y=g(b):(!f(b)||r&&_(b))&&(Y=u(L))):x=!1}x&&(M.set(L,Y),v(Y,L,r,y,M),M.delete(L)),i(e,n,Y)}var i=n(58),a=n(68),o=n(69),s=n(12),u=n(82),d=n(26),l=n(3),c=n(374),h=n(28),_=n(29),f=n(4),m=n(375),p=n(50),g=n(386);e.exports=r},function(e,t){function n(e){return function(t){return null==t?void 0:t[e]}}e.exports=n},function(e,t,n){function r(e){return function(t){return i(t,e)}}var i=n(62);e.exports=r},function(e,t,n){function r(e,t){return o(a(e,t,i),e+"")}var i=n(25),a=n(88),o=n(48);e.exports=r},function(e,t,n){var r=n(364),i=n(74),a=n(25),o=i?function(e,t){return i(e,"toString",{configurable:!0,enumerable:!1,value:r(t),writable:!0})}:a;e.exports=o},function(e,t){function n(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}e.exports=n},function(e,t,n){function r(e){if("string"==typeof e)return e;if(o(e))return a(e,r)+"";if(s(e))return l?l.call(e):"";var t=e+"";return"0"==t&&1/e==-u?"-0":t}var i=n(10),a=n(56),o=n(3),s=n(16),u=1/0,d=i?i.prototype:void 0,l=d?d.toString:void 0;e.exports=r},function(e,t){function n(e){return function(t){return e(t)}}e.exports=n},function(e,t){function n(e,t){return e.has(t)}e.exports=n},function(e,t,n){function r(e,t){var n=t?i(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}var i=n(41);e.exports=r},function(e,t,n){function r(e,t,n){var r=t?n(o(e),s):o(e);return a(r,i,new e.constructor)}var i=n(266),a=n(57),o=n(84),s=1;e.exports=r},function(e,t){function n(e){var t=new e.constructor(e.source,r.exec(e));return t.lastIndex=e.lastIndex,t}var r=/\w*$/;e.exports=n},function(e,t,n){function r(e,t,n){var r=t?n(o(e),s):o(e);return a(r,i,new e.constructor)}var i=n(267),a=n(57),o=n(90),s=1;e.exports=r},function(e,t,n){function r(e){return o?Object(o.call(e)):{}}var i=n(10),a=i?i.prototype:void 0,o=a?a.valueOf:void 0;e.exports=r},function(e,t,n){function r(e,t){return i(e,a(e),t)}var i=n(13),a=n(44);e.exports=r},function(e,t,n){function r(e,t){return i(e,a(e),t)}var i=n(13),a=n(80);e.exports=r},function(e,t,n){var r=n(2),i=r["__core-js_shared__"];e.exports=i},function(e,t){function n(e,t){for(var n=e.length,r=0;n--;)e[n]===t&&++r;return r}e.exports=n},function(e,t,n){function r(e){return i(function(t,n){var r=-1,i=n.length,o=i>1?n[i-1]:void 0,s=i>2?n[2]:void 0;for(o=e.length>3&&"function"==typeof o?(i--,o):void 0,s&&a(n[0],n[1],s)&&(o=i<3?void 0:o,i=1),t=Object(t);++r<i;){var u=n[r];u&&e(t,u,r,o)}return t})}var i=n(291),a=n(330);e.exports=r},function(e,t){function n(e){return function(t,n,r){for(var i=-1,a=Object(t),o=r(t),s=o.length;s--;){var u=o[e?s:++i];if(n(a[u],u,a)===!1)break}return t}}e.exports=n},function(e,t,n){function r(e,t,n){function r(){var t=this&&this!==a&&this instanceof r?u:e;return t.apply(s?n:this,arguments)}var s=t&o,u=i(e);return r}var i=n(21),a=n(2),o=1;e.exports=r},function(e,t,n){function r(e,t,n){function r(){for(var a=arguments.length,h=Array(a),_=a,f=u(r);_--;)h[_]=arguments[_];var m=a<3&&h[0]!==f&&h[a-1]!==f?[]:d(h,f);if(a-=m.length,a<n)return s(e,t,o,r.placeholder,void 0,h,m,void 0,void 0,n-a);var p=this&&this!==l&&this instanceof r?c:e;return i(p,this,h)}var c=a(e);return r}var i=n(36),a=n(21),o=n(72),s=n(73),u=n(79),d=n(47),l=n(2);e.exports=r},function(e,t,n){function r(e,t,n,r){function u(){for(var t=-1,a=arguments.length,s=-1,c=r.length,h=Array(c+a),_=this&&this!==o&&this instanceof u?l:e;++s<c;)h[s]=r[s];for(;a--;)h[s++]=arguments[++t];return i(_,d?n:this,h)}var d=t&s,l=a(e);return u}var i=n(36),a=n(21),o=n(2),s=1;e.exports=r},function(e,t,n){function r(e,t,n,r,i,k,x){switch(n){case L:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case b:return!(e.byteLength!=t.byteLength||!k(new a(e),new a(t)));case h:case _:case p:return o(+e,+t);case f:return e.name==t.name&&e.message==t.message;case g:case y:return e==t+"";case m:var w=u;case v:var D=r&l;if(w||(w=d),e.size!=t.size&&!D)return!1;var T=x.get(e);if(T)return T==t;r|=c,x.set(e,t);var S=s(w(e),w(t),r,i,k,x);return x.delete(e),S;case M:if(Y)return Y.call(e)==Y.call(t)}return!1}var i=n(10),a=n(53),o=n(15),s=n(75),u=n(84),d=n(90),l=1,c=2,h="[object Boolean]",_="[object Date]",f="[object Error]",m="[object Map]",p="[object Number]",g="[object RegExp]",v="[object Set]",y="[object String]",M="[object Symbol]",b="[object ArrayBuffer]",L="[object DataView]",k=i?i.prototype:void 0,Y=k?k.valueOf:void 0;e.exports=r},function(e,t,n){function r(e,t,n,r,o,u){var d=n&a,l=i(e),c=l.length,h=i(t),_=h.length;if(c!=_&&!d)return!1;for(var f=c;f--;){var m=l[f];if(!(d?m in t:s.call(t,m)))return!1}var p=u.get(e);if(p&&u.get(t))return p==t;var g=!0;u.set(e,t),u.set(t,e);for(var v=d;++f<c;){m=l[f];var y=e[m],M=t[m];if(r)var b=d?r(M,y,m,t,e,u):r(y,M,m,e,t,u);if(!(void 0===b?y===M||o(y,M,n,r,u):b)){g=!1;break}v||(v="constructor"==m)}if(g&&!v){var L=e.constructor,k=t.constructor;L!=k&&"constructor"in e&&"constructor"in t&&!("function"==typeof L&&L instanceof L&&"function"==typeof k&&k instanceof k)&&(g=!1)}return u.delete(e),u.delete(t),g}var i=n(77),a=1,o=Object.prototype,s=o.hasOwnProperty;e.exports=r},function(e,t,n){function r(e){return o(a(e,void 0,i),e+"")}var i=n(366),a=n(88),o=n(48);e.exports=r},function(e,t,n){function r(e){return i(e,o,a)}var i=n(63),a=n(80),o=n(31);e.exports=r},function(e,t,n){function r(e){for(var t=e.name+"",n=i[t],r=o.call(i,t)?n.length:0;r--;){var a=n[r],s=a.func;if(null==s||s==e)return a.name}return t}var i=n(350),a=Object.prototype,o=a.hasOwnProperty;e.exports=r},function(e,t,n){function r(e){for(var t=a(e),n=t.length;n--;){var r=t[n],o=e[r];t[n]=[r,o,i(o)]}return t}var i=n(83),a=n(30);e.exports=r},function(e,t,n){function r(e){var t=o.call(e,u),n=e[u];try{e[u]=void 0;var r=!0}catch(e){}var i=s.call(e);return r&&(t?e[u]=n:delete e[u]),i}var i=n(10),a=Object.prototype,o=a.hasOwnProperty,s=a.toString,u=i?i.toStringTag:void 0;e.exports=r},function(e,t){function n(e,t){return null==e?void 0:e[t]}e.exports=n},function(e,t){function n(e){var t=e.match(r);return t?t[1].split(i):[]}var r=/\{\n\/\* \[wrapped with (.+)\] \*/,i=/,? & /;e.exports=n},function(e,t,n){function r(e,t,n){t=i(t,e);for(var r=-1,l=t.length,c=!1;++r<l;){var h=d(t[r]);if(!(c=null!=e&&n(e,h)))break;e=e[h]}return c||++r!=l?c:(l=null==e?0:e.length,!!l&&u(l)&&s(h,l)&&(o(e)||a(e)))}var i=n(67),a=n(26),o=n(3),s=n(23),u=n(49),d=n(14);e.exports=r},function(e,t,n){function r(){this.__data__=i?i(null):{},this.size=0}var i=n(24);e.exports=r},function(e,t){function n(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}e.exports=n},function(e,t,n){function r(e){var t=this.__data__;if(i){var n=t[e];return n===a?void 0:n}return s.call(t,e)?t[e]:void 0}var i=n(24),a="__lodash_hash_undefined__",o=Object.prototype,s=o.hasOwnProperty;e.exports=r},function(e,t,n){function r(e){var t=this.__data__;return i?void 0!==t[e]:o.call(t,e)}var i=n(24),a=Object.prototype,o=a.hasOwnProperty;e.exports=r},function(e,t,n){function r(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=i&&void 0===t?a:t,this}var i=n(24),a="__lodash_hash_undefined__";e.exports=r},function(e,t){function n(e){var t=e.length,n=e.constructor(t);return t&&"string"==typeof e[0]&&i.call(e,"index")&&(n.index=e.index,n.input=e.input),n}var r=Object.prototype,i=r.hasOwnProperty;e.exports=n},function(e,t,n){function r(e,t,n,r){var j=e.constructor;switch(t){case y:return i(e);case c:case h:return new j(+e);case M:return a(e,r);case b:case L:case k:case Y:case x:case w:case D:case T:case S:return l(e,r);case _:return o(e,r,n);case f:case g:return new j(e);case m:return s(e);case p:return u(e,r,n);case v:return d(e)}}var i=n(41),a=n(297),o=n(298),s=n(299),u=n(300),d=n(301),l=n(69),c="[object Boolean]",h="[object Date]",_="[object Map]",f="[object Number]",m="[object RegExp]",p="[object Set]",g="[object String]",v="[object Symbol]",y="[object ArrayBuffer]",M="[object DataView]",b="[object Float32Array]",L="[object Float64Array]",k="[object Int8Array]",Y="[object Int16Array]",x="[object Int32Array]",w="[object Uint8Array]",D="[object Uint8ClampedArray]",T="[object Uint16Array]",S="[object Uint32Array]";e.exports=r},function(e,t){function n(e,t){var n=t.length;if(!n)return e;var i=n-1;return t[i]=(n>1?"& ":"")+t[i],t=t.join(n>2?", ":" "),e.replace(r,"{\n/* [wrapped with "+t+"] */\n")}var r=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;e.exports=n},function(e,t,n){function r(e){return o(e)||a(e)||!!(s&&e&&e[s])}var i=n(10),a=n(26),o=n(3),s=i?i.isConcatSpreadable:void 0;e.exports=r},function(e,t,n){function r(e,t,n){if(!s(n))return!1;var r=typeof t;return!!("number"==r?a(n)&&o(t,n.length):"string"==r&&t in n)&&i(n[t],e)}var i=n(15),a=n(27),o=n(23),s=n(4);e.exports=r},function(e,t){function n(e){var t=typeof e;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}e.exports=n},function(e,t,n){function r(e){var t=o(e),n=s[t];if("function"!=typeof n||!(t in i.prototype))return!1;if(e===n)return!0;var r=a(n);return!!r&&e===r[0]}var i=n(33),a=n(78),o=n(315),s=n(387);e.exports=r},function(e,t,n){function r(e){return!!a&&a in e}var i=n(304),a=function(){var e=/[^.]+$/.exec(i&&i.keys&&i.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}();e.exports=r},function(e,t){function n(){this.__data__=[],this.size=0}e.exports=n},function(e,t,n){function r(e){var t=this.__data__,n=i(t,e);if(n<0)return!1;var r=t.length-1;return n==r?t.pop():o.call(t,n,1),--this.size,!0}var i=n(19),a=Array.prototype,o=a.splice;e.exports=r},function(e,t,n){function r(e){var t=this.__data__,n=i(t,e);return n<0?void 0:t[n][1]}var i=n(19);e.exports=r},function(e,t,n){function r(e){return i(this.__data__,e)>-1}var i=n(19);e.exports=r},function(e,t,n){function r(e,t){var n=this.__data__,r=i(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this}var i=n(19);e.exports=r},function(e,t,n){function r(){this.size=0,this.__data__={hash:new i,map:new(o||a),string:new i}}var i=n(262),a=n(17),o=n(34);e.exports=r},function(e,t,n){function r(e){var t=i(this,e).delete(e);return this.size-=t?1:0,t}var i=n(22);e.exports=r},function(e,t,n){function r(e){return i(this,e).get(e)}var i=n(22);e.exports=r},function(e,t,n){function r(e){return i(this,e).has(e)}var i=n(22);e.exports=r},function(e,t,n){function r(e,t){var n=i(this,e),r=n.size;return n.set(e,t),this.size+=n.size==r?0:1,this}var i=n(22);e.exports=r},function(e,t,n){function r(e){var t=i(e,function(e){
return n.size===a&&n.clear(),e}),n=t.cache;return t}var i=n(377),a=500;e.exports=r},function(e,t,n){function r(e,t){var n=e[1],r=t[1],m=n|r,p=m<(u|d|h),g=r==h&&n==c||r==h&&n==_&&e[7].length<=t[8]||r==(h|_)&&t[7].length<=t[8]&&n==c;if(!p&&!g)return e;r&u&&(e[2]=t[2],m|=n&u?0:l);var v=t[3];if(v){var y=e[3];e[3]=y?i(y,v,t[4]):v,e[4]=y?o(e[3],s):t[4]}return v=t[5],v&&(y=e[5],e[5]=y?a(y,v,t[6]):v,e[6]=y?o(e[5],s):t[6]),v=t[7],v&&(e[7]=v),r&h&&(e[8]=null==e[8]?t[8]:f(e[8],t[8])),null==e[9]&&(e[9]=t[9]),e[0]=t[0],e[1]=m,e}var i=n(70),a=n(71),o=n(47),s="__lodash_placeholder__",u=1,d=2,l=4,c=8,h=128,_=256,f=Math.min;e.exports=r},function(e,t,n){var r=n(87),i=r(Object.keys,Object);e.exports=i},function(e,t){function n(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}e.exports=n},function(e,t,n){(function(e){var r=n(76),i="object"==typeof t&&t&&!t.nodeType&&t,a=i&&"object"==typeof e&&e&&!e.nodeType&&e,o=a&&a.exports===i,s=o&&r.process,u=function(){try{return s&&s.binding&&s.binding("util")}catch(e){}}();e.exports=u}).call(t,n(32)(e))},function(e,t){function n(e){return i.call(e)}var r=Object.prototype,i=r.toString;e.exports=n},function(e,t){var n={};e.exports=n},function(e,t,n){function r(e,t){for(var n=e.length,r=o(t.length,n),s=i(e);r--;){var u=t[r];e[r]=a(u,n)?s[u]:void 0}return e}var i=n(12),a=n(23),o=Math.min;e.exports=r},function(e,t){function n(e){return this.__data__.set(e,r),this}var r="__lodash_hash_undefined__";e.exports=n},function(e,t){function n(e){return this.__data__.has(e)}e.exports=n},function(e,t,n){function r(){this.__data__=new i,this.size=0}var i=n(17);e.exports=r},function(e,t){function n(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n}e.exports=n},function(e,t){function n(e){return this.__data__.get(e)}e.exports=n},function(e,t){function n(e){return this.__data__.has(e)}e.exports=n},function(e,t,n){function r(e,t){var n=this.__data__;if(n instanceof i){var r=n.__data__;if(!a||r.length<s-1)return r.push([e,t]),this.size=++n.size,this;n=this.__data__=new o(r)}return n.set(e,t),this.size=n.size,this}var i=n(17),a=n(34),o=n(35),s=200;e.exports=r},function(e,t){function n(e,t,n){for(var r=n-1,i=e.length;++r<i;)if(e[r]===t)return r;return-1}e.exports=n},function(e,t,n){function r(e,t){return i(m,function(n){var r="_."+n[0];t&n[1]&&!a(e,r)&&e.push(r)}),e.sort()}var i=n(37),a=n(269),o=1,s=2,u=8,d=16,l=32,c=64,h=128,_=256,f=512,m=[["ary",h],["bind",o],["bindKey",s],["curry",u],["curryRight",d],["flip",f],["partial",l],["partialRight",c],["rearg",_]];e.exports=r},function(e,t,n){function r(e){if(e instanceof i)return e.clone();var t=new a(e.__wrapped__,e.__chain__);return t.__actions__=o(e.__actions__),t.__index__=e.__index__,t.__values__=e.__values__,t}var i=n(33),a=n(52),o=n(12);e.exports=r},function(e,t,n){function r(e,t,n){return t=n?void 0:t,t=e&&null==t?e.length:t,i(e,a,void 0,void 0,void 0,void 0,t)}var i=n(42),a=128;e.exports=r},function(e,t,n){function r(e){return i(e,a)}var i=n(61),a=4;e.exports=r},function(e,t){function n(e){return function(){return e}}e.exports=n},function(e,t,n){function r(e,t,n){t=n?void 0:t;var o=i(e,a,void 0,void 0,void 0,void 0,void 0,t);return o.placeholder=r.placeholder,o}var i=n(42),a=8;r.placeholder={},e.exports=r},function(e,t,n){function r(e){var t=null==e?0:e.length;return t?i(e,1):[]}var i=n(273);e.exports=r},function(e,t,n){function r(e,t){return 2==t?function(t,n){return e.apply(void 0,arguments)}:function(t){return e.apply(void 0,arguments)}}function i(e,t){return 2==t?function(t,n){return e(t,n)}:function(t){return e(t)}}function a(e){for(var t=e?e.length:0,n=Array(t);t--;)n[t]=e[t];return n}function o(e){return function(t){return e({},t)}}function s(e,t){return function(){for(var n=arguments.length,r=n-1,i=Array(n);n--;)i[n]=arguments[n];var a=i[t],o=i.slice(0,t);return a&&h.apply(o,a),t!=r&&h.apply(o,i.slice(t+1)),e.apply(this,o)}}function u(e,t){return function(){var n=arguments.length;if(n){for(var r=Array(n);n--;)r[n]=arguments[n];var i=r[0]=t.apply(void 0,r);return e.apply(void 0,r),i}}}function d(e,t,n,h){function _(e,t){if(D.cap){var n=l.iterateeRearg[e];if(n)return b(t,n);var r=!x&&l.iterateeAry[e];if(r)return M(t,r)}return t}function f(e,t,n){return T||D.curry&&n>1?W(t,n):t}function m(e,t,n){if(D.fixed&&(S||!l.skipFixed[e])){var r=l.methodSpread[e],i=r&&r.start;return void 0===i?C(t,n):s(t,i)}return t}function p(e,t,n){return D.rearg&&n>1&&(j||!l.skipRearg[e])?N(t,l.methodRearg[e]||l.aryRearg[n]):t}function g(e,t){t=B(t);for(var n=-1,r=t.length,i=r-1,a=F(Object(e)),o=a;null!=o&&++n<r;){var s=t[n],u=o[s];null!=u&&(o[t[n]]=F(n==i?u:Object(u))),o=o[s]}return a}function v(e){return U.runInContext.convert(e)(void 0)}function y(e,t){var n=l.aliasToReal[e]||e,r=l.remap[n]||n,i=h;return function(e){var a=x?A:P,o=x?A[r]:t,s=O(O({},i),e);return d(a,n,o,s)}}function M(e,t){return L(e,function(e){return"function"==typeof e?i(e,t):e})}function b(e,t){return L(e,function(e){var n=t.length;return r(N(i(e,n),t),n)})}function L(e,t){return function(){var n=arguments.length;if(!n)return e();for(var r=Array(n);n--;)r[n]=arguments[n];var i=D.rearg?0:n-1;return r[i]=t(r[i]),e.apply(void 0,r)}}function k(e,t){var n,r=l.aliasToReal[e]||e,i=t,s=J[r];return s?i=s(t):D.immutable&&(l.mutate.array[r]?i=u(t,a):l.mutate.object[r]?i=u(t,o(t)):l.mutate.set[r]&&(i=u(t,g))),I($,function(e){return I(l.aryMethod[e],function(t){if(r==t){var a=l.methodSpread[r],o=a&&a.afterRearg;return n=o?m(r,p(r,i,e),e):p(r,m(r,i,e),e),n=_(r,n),n=f(r,n,e),!1}}),!n}),n||(n=i),n==t&&(n=T?W(n,1):function(){return t.apply(this,arguments)}),n.convert=y(r,t),l.placeholder[r]&&(Y=!0,n.placeholder=t.placeholder=H),n}var Y,x="function"==typeof t,w=t===Object(t);if(w&&(h=n,n=t,t=void 0),null==n)throw new TypeError;h||(h={});var D={cap:!("cap"in h)||h.cap,curry:!("curry"in h)||h.curry,fixed:!("fixed"in h)||h.fixed,immutable:!("immutable"in h)||h.immutable,rearg:!("rearg"in h)||h.rearg},T="curry"in h&&h.curry,S="fixed"in h&&h.fixed,j="rearg"in h&&h.rearg,H=x?n:c,A=x?n.runInContext():void 0,P=x?n:{ary:e.ary,assign:e.assign,clone:e.clone,curry:e.curry,forEach:e.forEach,isArray:e.isArray,isFunction:e.isFunction,iteratee:e.iteratee,keys:e.keys,rearg:e.rearg,toInteger:e.toInteger,toPath:e.toPath},C=P.ary,O=P.assign,F=P.clone,W=P.curry,I=P.forEach,E=P.isArray,z=P.isFunction,R=P.keys,N=P.rearg,V=P.toInteger,B=P.toPath,$=R(l.aryMethod),J={castArray:function(e){return function(){var t=arguments[0];return E(t)?e(a(t)):e.apply(void 0,arguments)}},iteratee:function(e){return function(){var t=arguments[0],n=arguments[1],r=e(t,n),a=r.length;return D.cap&&"number"==typeof n?(n=n>2?n-2:1,a&&a<=n?r:i(r,n)):r}},mixin:function(e){return function(t){var n=this;if(!z(n))return e(n,Object(t));var r=[];return I(R(t),function(e){z(t[e])&&r.push([e,n.prototype[e]])}),e(n,Object(t)),I(r,function(e){var t=e[1];z(t)?n.prototype[e[0]]=t:delete n.prototype[e[0]]}),n}},nthArg:function(e){return function(t){var n=t<0?1:V(t)+1;return W(e(t),n)}},rearg:function(e){return function(t,n){var r=n?n.length:0;return W(e(t,n),r)}},runInContext:function(t){return function(n){return d(e,t(n),h)}}};if(!w)return k(t,n);var U=n,q=[];return I($,function(e){I(l.aryMethod[e],function(e){var t=U[l.remap[e]||e];t&&q.push([e,k(e,t)])})}),I(R(U),function(e){var t=U[e];if("function"==typeof t){for(var n=q.length;n--;)if(q[n][0]==e)return;t.convert=y(e,t),q.push([e,t])}}),I(q,function(e){U[e[0]]=e[1]}),U.convert=v,Y&&(U.placeholder=H),I(R(U),function(e){I(l.realToAlias[e]||[],function(t){U[t]=U[e]})}),U}var l=n(368),c=n(95),h=Array.prototype.push;e.exports=d},function(e,t){t.aliasToReal={each:"forEach",eachRight:"forEachRight",entries:"toPairs",entriesIn:"toPairsIn",extend:"assignIn",extendAll:"assignInAll",extendAllWith:"assignInAllWith",extendWith:"assignInWith",first:"head",conforms:"conformsTo",matches:"isMatch",property:"get",__:"placeholder",F:"stubFalse",T:"stubTrue",all:"every",allPass:"overEvery",always:"constant",any:"some",anyPass:"overSome",apply:"spread",assoc:"set",assocPath:"set",complement:"negate",compose:"flowRight",contains:"includes",dissoc:"unset",dissocPath:"unset",dropLast:"dropRight",dropLastWhile:"dropRightWhile",equals:"isEqual",identical:"eq",indexBy:"keyBy",init:"initial",invertObj:"invert",juxt:"over",omitAll:"omit",nAry:"ary",path:"get",pathEq:"matchesProperty",pathOr:"getOr",paths:"at",pickAll:"pick",pipe:"flow",pluck:"map",prop:"get",propEq:"matchesProperty",propOr:"getOr",props:"at",symmetricDifference:"xor",symmetricDifferenceBy:"xorBy",symmetricDifferenceWith:"xorWith",takeLast:"takeRight",takeLastWhile:"takeRightWhile",unapply:"rest",unnest:"flatten",useWith:"overArgs",where:"conformsTo",whereEq:"isMatch",zipObj:"zipObject"},t.aryMethod={1:["assignAll","assignInAll","attempt","castArray","ceil","create","curry","curryRight","defaultsAll","defaultsDeepAll","floor","flow","flowRight","fromPairs","invert","iteratee","memoize","method","mergeAll","methodOf","mixin","nthArg","over","overEvery","overSome","rest","reverse","round","runInContext","spread","template","trim","trimEnd","trimStart","uniqueId","words","zipAll"],2:["add","after","ary","assign","assignAllWith","assignIn","assignInAllWith","at","before","bind","bindAll","bindKey","chunk","cloneDeepWith","cloneWith","concat","conformsTo","countBy","curryN","curryRightN","debounce","defaults","defaultsDeep","defaultTo","delay","difference","divide","drop","dropRight","dropRightWhile","dropWhile","endsWith","eq","every","filter","find","findIndex","findKey","findLast","findLastIndex","findLastKey","flatMap","flatMapDeep","flattenDepth","forEach","forEachRight","forIn","forInRight","forOwn","forOwnRight","get","groupBy","gt","gte","has","hasIn","includes","indexOf","intersection","invertBy","invoke","invokeMap","isEqual","isMatch","join","keyBy","lastIndexOf","lt","lte","map","mapKeys","mapValues","matchesProperty","maxBy","meanBy","merge","mergeAllWith","minBy","multiply","nth","omit","omitBy","overArgs","pad","padEnd","padStart","parseInt","partial","partialRight","partition","pick","pickBy","propertyOf","pull","pullAll","pullAt","random","range","rangeRight","rearg","reject","remove","repeat","restFrom","result","sampleSize","some","sortBy","sortedIndex","sortedIndexOf","sortedLastIndex","sortedLastIndexOf","sortedUniqBy","split","spreadFrom","startsWith","subtract","sumBy","take","takeRight","takeRightWhile","takeWhile","tap","throttle","thru","times","trimChars","trimCharsEnd","trimCharsStart","truncate","union","uniqBy","uniqWith","unset","unzipWith","without","wrap","xor","zip","zipObject","zipObjectDeep"],3:["assignInWith","assignWith","clamp","differenceBy","differenceWith","findFrom","findIndexFrom","findLastFrom","findLastIndexFrom","getOr","includesFrom","indexOfFrom","inRange","intersectionBy","intersectionWith","invokeArgs","invokeArgsMap","isEqualWith","isMatchWith","flatMapDepth","lastIndexOfFrom","mergeWith","orderBy","padChars","padCharsEnd","padCharsStart","pullAllBy","pullAllWith","rangeStep","rangeStepRight","reduce","reduceRight","replace","set","slice","sortedIndexBy","sortedLastIndexBy","transform","unionBy","unionWith","update","xorBy","xorWith","zipWith"],4:["fill","setWith","updateWith"]},t.aryRearg={2:[1,0],3:[2,0,1],4:[3,2,0,1]},t.iterateeAry={dropRightWhile:1,dropWhile:1,every:1,filter:1,find:1,findFrom:1,findIndex:1,findIndexFrom:1,findKey:1,findLast:1,findLastFrom:1,findLastIndex:1,findLastIndexFrom:1,findLastKey:1,flatMap:1,flatMapDeep:1,flatMapDepth:1,forEach:1,forEachRight:1,forIn:1,forInRight:1,forOwn:1,forOwnRight:1,map:1,mapKeys:1,mapValues:1,partition:1,reduce:2,reduceRight:2,reject:1,remove:1,some:1,takeRightWhile:1,takeWhile:1,times:1,transform:2},t.iterateeRearg={mapKeys:[1],reduceRight:[1,0]},t.methodRearg={assignInAllWith:[1,0],assignInWith:[1,2,0],assignAllWith:[1,0],assignWith:[1,2,0],differenceBy:[1,2,0],differenceWith:[1,2,0],getOr:[2,1,0],intersectionBy:[1,2,0],intersectionWith:[1,2,0],isEqualWith:[1,2,0],isMatchWith:[2,1,0],mergeAllWith:[1,0],mergeWith:[1,2,0],padChars:[2,1,0],padCharsEnd:[2,1,0],padCharsStart:[2,1,0],pullAllBy:[2,1,0],pullAllWith:[2,1,0],rangeStep:[1,2,0],rangeStepRight:[1,2,0],setWith:[3,1,2,0],sortedIndexBy:[2,1,0],sortedLastIndexBy:[2,1,0],unionBy:[1,2,0],unionWith:[1,2,0],updateWith:[3,1,2,0],xorBy:[1,2,0],xorWith:[1,2,0],zipWith:[1,2,0]},t.methodSpread={assignAll:{start:0},assignAllWith:{start:0},assignInAll:{start:0},assignInAllWith:{start:0},defaultsAll:{start:0},defaultsDeepAll:{start:0},invokeArgs:{start:2},invokeArgsMap:{start:2},mergeAll:{start:0},mergeAllWith:{start:0},partial:{start:1},partialRight:{start:1},without:{start:1},zipAll:{start:0}},t.mutate={array:{fill:!0,pull:!0,pullAll:!0,pullAllBy:!0,pullAllWith:!0,pullAt:!0,remove:!0,reverse:!0},object:{assign:!0,assignAll:!0,assignAllWith:!0,assignIn:!0,assignInAll:!0,assignInAllWith:!0,assignInWith:!0,assignWith:!0,defaults:!0,defaultsAll:!0,defaultsDeep:!0,defaultsDeepAll:!0,merge:!0,mergeAll:!0,mergeAllWith:!0,mergeWith:!0},set:{set:!0,setWith:!0,unset:!0,update:!0,updateWith:!0}},t.placeholder={bind:!0,bindKey:!0,curry:!0,curryRight:!0,partial:!0,partialRight:!0},t.realToAlias=function(){var e=Object.prototype.hasOwnProperty,n=t.aliasToReal,r={};for(var i in n){var a=n[i];e.call(r,a)?r[a].push(i):r[a]=[i]}return r}(),t.remap={assignAll:"assign",assignAllWith:"assignWith",assignInAll:"assignIn",assignInAllWith:"assignInWith",curryN:"curry",curryRightN:"curryRight",defaultsAll:"defaults",defaultsDeepAll:"defaultsDeep",findFrom:"find",findIndexFrom:"findIndex",findLastFrom:"findLast",findLastIndexFrom:"findLastIndex",getOr:"get",includesFrom:"includes",indexOfFrom:"indexOf",invokeArgs:"invoke",invokeArgsMap:"invokeMap",lastIndexOfFrom:"lastIndexOf",mergeAll:"merge",mergeAllWith:"mergeWith",padChars:"pad",padCharsEnd:"padEnd",padCharsStart:"padStart",propertyOf:"get",rangeStep:"range",rangeStepRight:"rangeRight",restFrom:"rest",spreadFrom:"spread",trimChars:"trim",trimCharsEnd:"trimEnd",trimCharsStart:"trimStart",zipAll:"zip"},t.skipFixed={castArray:!0,flow:!0,flowRight:!0,iteratee:!0,mixin:!0,rearg:!0,runInContext:!0},t.skipRearg={add:!0,assign:!0,assignIn:!0,bind:!0,bindKey:!0,concat:!0,difference:!0,divide:!0,eq:!0,gt:!0,gte:!0,isEqual:!0,lt:!0,lte:!0,matchesProperty:!0,merge:!0,multiply:!0,overArgs:!0,partial:!0,partialRight:!0,propertyOf:!0,random:!0,range:!0,rangeRight:!0,subtract:!0,zip:!0,zipObject:!0,zipObjectDeep:!0}},function(e,t,n){e.exports={ary:n(362),assign:n(60),clone:n(363),curry:n(365),forEach:n(37),isArray:n(3),isFunction:n(29),iteratee:n(376),keys:n(65),rearg:n(381),toInteger:n(97),toPath:n(385)}},function(e,t,n){function r(e,t,n){return i(a,e,t,n)}var i=n(367),a=n(369);e.exports=r},function(e,t,n){var r=n(370),i=r("merge",n(378));i.placeholder=n(95),e.exports=i},function(e,t,n){function r(e,t,n){var r=null==e?void 0:i(e,t);return void 0===r?n:r}var i=n(62);e.exports=r},function(e,t,n){function r(e,t){return null!=e&&a(e,t,i)}var i=n(275),a=n(320);e.exports=r},function(e,t,n){function r(e){return a(e)&&i(e)}var i=n(27),a=n(7);e.exports=r},function(e,t,n){function r(e){if(!o(e)||i(e)!=s)return!1;var t=a(e);if(null===t)return!0;var n=c.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&l.call(n)==h}var i=n(11),a=n(43),o=n(7),s="[object Object]",u=Function.prototype,d=Object.prototype,l=u.toString,c=d.hasOwnProperty,h=l.call(Object);e.exports=r},function(e,t,n){function r(e){return a("function"==typeof e?e:i(e,o))}var i=n(61),a=n(283),o=1;e.exports=r},function(e,t,n){function r(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new TypeError(a);var n=function(){var r=arguments,i=t?t.apply(this,r):r[0],a=n.cache;if(a.has(i))return a.get(i);var o=e.apply(this,r);return n.cache=a.set(i,o)||a,o};return n.cache=new(r.Cache||i),n}var i=n(35),a="Expected a function";r.Cache=i,e.exports=r},function(e,t,n){var r=n(287),i=n(306),a=i(function(e,t,n){r(e,t,n)});e.exports=a},function(e,t){function n(){}e.exports=n},function(e,t,n){function r(e){return o(e)?i(s(e)):a(e)}var i=n(289),a=n(290),o=n(45),s=n(14);e.exports=r},function(e,t,n){var r=n(42),i=n(313),a=256,o=i(function(e,t){return r(e,a,void 0,void 0,void 0,t)});e.exports=o},function(e,t){function n(){return!1}e.exports=n},function(e,t,n){function r(e){if(!e)return 0===e?e:0;if(e=i(e),e===a||e===-a){var t=e<0?-1:1;return t*o}return e===e?e:0}var i=n(384),a=1/0,o=1.7976931348623157e308;e.exports=r},function(e,t,n){function r(e){if("number"==typeof e)return e;if(a(e))return o;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(s,"");var n=d.test(e);return n||l.test(e)?c(e.slice(2),n?2:8):u.test(e)?o:+e}var i=n(4),a=n(16),o=NaN,s=/^\s+|\s+$/g,u=/^[-+]0x[0-9a-f]+$/i,d=/^0b[01]+$/i,l=/^0o[0-7]+$/i,c=parseInt;e.exports=r},function(e,t,n){function r(e){return o(e)?i(e,d):s(e)?[e]:a(u(l(e)))}var i=n(56),a=n(12),o=n(3),s=n(16),u=n(93),d=n(14),l=n(98);e.exports=r},function(e,t,n){function r(e){return i(e,a(e))}var i=n(13),a=n(31);e.exports=r},function(e,t,n){function r(e){if(u(e)&&!s(e)&&!(e instanceof i)){if(e instanceof a)return e;if(c.call(e,"__wrapped__"))return d(e)}return new a(e)}var i=n(33),a=n(52),o=n(40),s=n(3),u=n(7),d=n(361),l=Object.prototype,c=l.hasOwnProperty;r.prototype=o.prototype,r.prototype.constructor=r,e.exports=r},function(e,t,n){function r(e){return n(i(e))}function i(e){return a[e]||function(){throw new Error("Cannot find module '"+e+"'.")}()}var a={"./af":99,"./af.js":99,"./ar":105,"./ar-dz":100,"./ar-dz.js":100,"./ar-ly":101,"./ar-ly.js":101,"./ar-ma":102,"./ar-ma.js":102,"./ar-sa":103,"./ar-sa.js":103,"./ar-tn":104,"./ar-tn.js":104,"./ar.js":105,"./az":106,"./az.js":106,"./be":107,"./be.js":107,"./bg":108,"./bg.js":108,"./bn":109,"./bn.js":109,"./bo":110,"./bo.js":110,"./br":111,"./br.js":111,"./bs":112,"./bs.js":112,"./ca":113,"./ca.js":113,"./cs":114,"./cs.js":114,"./cv":115,"./cv.js":115,"./cy":116,"./cy.js":116,"./da":117,"./da.js":117,"./de":119,"./de-at":118,"./de-at.js":118,"./de.js":119,"./dv":120,"./dv.js":120,"./el":121,"./el.js":121,"./en-au":122,"./en-au.js":122,"./en-ca":123,"./en-ca.js":123,"./en-gb":124,"./en-gb.js":124,"./en-ie":125,"./en-ie.js":125,"./en-nz":126,"./en-nz.js":126,"./eo":127,"./eo.js":127,"./es":129,"./es-do":128,"./es-do.js":128,"./es.js":129,"./et":130,"./et.js":130,"./eu":131,"./eu.js":131,"./fa":132,"./fa.js":132,"./fi":133,"./fi.js":133,"./fo":134,"./fo.js":134,"./fr":137,"./fr-ca":135,"./fr-ca.js":135,"./fr-ch":136,"./fr-ch.js":136,"./fr.js":137,"./fy":138,"./fy.js":138,"./gd":139,"./gd.js":139,"./gl":140,"./gl.js":140,"./he":141,"./he.js":141,"./hi":142,"./hi.js":142,"./hr":143,"./hr.js":143,"./hu":144,"./hu.js":144,"./hy-am":145,"./hy-am.js":145,"./id":146,"./id.js":146,"./is":147,"./is.js":147,"./it":148,"./it.js":148,"./ja":149,"./ja.js":149,"./jv":150,"./jv.js":150,"./ka":151,"./ka.js":151,"./kk":152,"./kk.js":152,"./km":153,"./km.js":153,"./ko":154,"./ko.js":154,"./ky":155,"./ky.js":155,"./lb":156,"./lb.js":156,"./lo":157,"./lo.js":157,"./lt":158,"./lt.js":158,"./lv":159,"./lv.js":159,"./me":160,"./me.js":160,"./mi":161,"./mi.js":161,"./mk":162,"./mk.js":162,"./ml":163,"./ml.js":163,"./mr":164,"./mr.js":164,"./ms":166,"./ms-my":165,"./ms-my.js":165,"./ms.js":166,"./my":167,"./my.js":167,"./nb":168,"./nb.js":168,"./ne":169,"./ne.js":169,"./nl":171,"./nl-be":170,"./nl-be.js":170,"./nl.js":171,"./nn":172,"./nn.js":172,"./pa-in":173,"./pa-in.js":173,"./pl":174,"./pl.js":174,"./pt":176,"./pt-br":175,"./pt-br.js":175,"./pt.js":176,"./ro":177,"./ro.js":177,"./ru":178,"./ru.js":178,"./se":179,"./se.js":179,"./si":180,"./si.js":180,"./sk":181,"./sk.js":181,"./sl":182,"./sl.js":182,"./sq":183,"./sq.js":183,"./sr":185,"./sr-cyrl":184,"./sr-cyrl.js":184,"./sr.js":185,"./ss":186,"./ss.js":186,"./sv":187,"./sv.js":187,"./sw":188,"./sw.js":188,"./ta":189,"./ta.js":189,"./te":190,"./te.js":190,"./tet":191,"./tet.js":191,"./th":192,"./th.js":192,"./tl-ph":193,"./tl-ph.js":193,"./tlh":194,"./tlh.js":194,"./tr":195,"./tr.js":195,"./tzl":196,"./tzl.js":196,"./tzm":198,"./tzm-latn":197,"./tzm-latn.js":197,"./tzm.js":198,"./uk":199,"./uk.js":199,"./uz":200,"./uz.js":200,"./vi":201,"./vi.js":201,"./x-pseudo":202,"./x-pseudo.js":202,"./yo":203,"./yo.js":203,"./zh-cn":204,"./zh-cn.js":204,"./zh-hk":205,"./zh-hk.js":205,"./zh-tw":206,"./zh-tw.js":206};r.keys=function(){return Object.keys(a)},r.resolve=i,e.exports=r,r.id=388}])});

},{}],129:[function(require,module,exports){
var Vue // late bind
var map = Object.create(null)
var shimmed = false
var isBrowserify = false

/**
 * Determine compatibility and apply patch.
 *
 * @param {Function} vue
 * @param {Boolean} browserify
 */

exports.install = function (vue, browserify) {
  if (shimmed) return
  shimmed = true

  Vue = vue
  isBrowserify = browserify

  exports.compatible = !!Vue.internalDirectives
  if (!exports.compatible) {
    console.warn(
      '[HMR] vue-loader hot reload is only compatible with ' +
      'Vue.js 1.0.0+.'
    )
    return
  }

  // patch view directive
  patchView(Vue.internalDirectives.component)
  console.log('[HMR] Vue component hot reload shim applied.')
  // shim router-view if present
  var routerView = Vue.elementDirective('router-view')
  if (routerView) {
    patchView(routerView)
    console.log('[HMR] vue-router <router-view> hot reload shim applied.')
  }
}

/**
 * Shim the view directive (component or router-view).
 *
 * @param {Object} View
 */

function patchView (View) {
  var unbuild = View.unbuild
  View.unbuild = function (defer) {
    if (!this.hotUpdating) {
      var prevComponent = this.childVM && this.childVM.constructor
      removeView(prevComponent, this)
      // defer = true means we are transitioning to a new
      // Component. Register this new component to the list.
      if (defer) {
        addView(this.Component, this)
      }
    }
    // call original
    return unbuild.call(this, defer)
  }
}

/**
 * Add a component view to a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function addView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    if (!map[id]) {
      map[id] = {
        Component: Component,
        views: [],
        instances: []
      }
    }
    map[id].views.push(view)
  }
}

/**
 * Remove a component view from a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function removeView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    map[id].views.$remove(view)
  }
}

/**
 * Create a record for a hot module, which keeps track of its construcotr,
 * instnaces and views (component directives or router-views).
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if (typeof options === 'function') {
    options = options.options
  }
  if (typeof options.el !== 'string' && typeof options.data !== 'object') {
    makeOptionsHot(id, options)
    map[id] = {
      Component: null,
      views: [],
      instances: []
    }
  }
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot (id, options) {
  options.hotID = id
  injectHook(options, 'created', function () {
    var record = map[id]
    if (!record.Component) {
      record.Component = this.constructor
    }
    record.instances.push(this)
  })
  injectHook(options, 'beforeDestroy', function () {
    map[id].instances.$remove(this)
  })
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook (options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing)
      ? existing.concat(hook)
      : [existing, hook]
    : [hook]
}

/**
 * Update a hot component.
 *
 * @param {String} id
 * @param {Object|null} newOptions
 * @param {String|null} newTemplate
 */

exports.update = function (id, newOptions, newTemplate) {
  var record = map[id]
  // force full-reload if an instance of the component is active but is not
  // managed by a view
  if (!record || (record.instances.length && !record.views.length)) {
    console.log('[HMR] Root or manually-mounted instance modified. Full reload may be required.')
    if (!isBrowserify) {
      window.location.reload()
    } else {
      // browserify-hmr somehow sends incomplete bundle if we reload here
      return
    }
  }
  if (!isBrowserify) {
    // browserify-hmr already logs this
    console.log('[HMR] Updating component: ' + format(id))
  }
  var Component = record.Component
  // update constructor
  if (newOptions) {
    // in case the user exports a constructor
    Component = record.Component = typeof newOptions === 'function'
      ? newOptions
      : Vue.extend(newOptions)
    makeOptionsHot(id, Component.options)
  }
  if (newTemplate) {
    Component.options.template = newTemplate
  }
  // handle recursive lookup
  if (Component.options.name) {
    Component.options.components[Component.options.name] = Component
  }
  // reset constructor cached linker
  Component.linker = null
  // reload all views
  record.views.forEach(function (view) {
    updateView(view, Component)
  })
  // flush devtools
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('flush')
  }
}

/**
 * Update a component view instance
 *
 * @param {Directive} view
 * @param {Function} Component
 */

function updateView (view, Component) {
  if (!view._bound) {
    return
  }
  view.Component = Component
  view.hotUpdating = true
  // disable transitions
  view.vm._isCompiled = false
  // save state
  var state = extractState(view.childVM)
  // remount, make sure to disable keep-alive
  var keepAlive = view.keepAlive
  view.keepAlive = false
  view.mountComponent()
  view.keepAlive = keepAlive
  // restore state
  restoreState(view.childVM, state, true)
  // re-eanble transitions
  view.vm._isCompiled = true
  view.hotUpdating = false
}

/**
 * Extract state from a Vue instance.
 *
 * @param {Vue} vm
 * @return {Object}
 */

function extractState (vm) {
  return {
    cid: vm.constructor.cid,
    data: vm.$data,
    children: vm.$children.map(extractState)
  }
}

/**
 * Restore state to a reloaded Vue instance.
 *
 * @param {Vue} vm
 * @param {Object} state
 */

function restoreState (vm, state, isRoot) {
  var oldAsyncConfig
  if (isRoot) {
    // set Vue into sync mode during state rehydration
    oldAsyncConfig = Vue.config.async
    Vue.config.async = false
  }
  // actual restore
  if (isRoot || !vm._props) {
    vm.$data = state.data
  } else {
    Object.keys(state.data).forEach(function (key) {
      if (!vm._props[key]) {
        // for non-root, only restore non-props fields
        vm.$data[key] = state.data[key]
      }
    })
  }
  // verify child consistency
  var hasSameChildren = vm.$children.every(function (c, i) {
    return state.children[i] && state.children[i].cid === c.constructor.cid
  })
  if (hasSameChildren) {
    // rehydrate children
    vm.$children.forEach(function (c, i) {
      restoreState(c, state.children[i])
    })
  }
  if (isRoot) {
    Vue.config.async = oldAsyncConfig
  }
}

function format (id) {
  var match = id.match(/[^\/]+\.vue$/)
  return match ? match[0] : id
}

},{}],130:[function(require,module,exports){
/*!
 * vue-router v0.7.13
 * (c) 2016 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.VueRouter = factory();
}(this, function () { 'use strict';

  var babelHelpers = {};

  babelHelpers.classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  function Target(path, matcher, delegate) {
    this.path = path;
    this.matcher = matcher;
    this.delegate = delegate;
  }

  Target.prototype = {
    to: function to(target, callback) {
      var delegate = this.delegate;

      if (delegate && delegate.willAddRoute) {
        target = delegate.willAddRoute(this.matcher.target, target);
      }

      this.matcher.add(this.path, target);

      if (callback) {
        if (callback.length === 0) {
          throw new Error("You must have an argument in the function passed to `to`");
        }
        this.matcher.addChild(this.path, target, callback, this.delegate);
      }
      return this;
    }
  };

  function Matcher(target) {
    this.routes = {};
    this.children = {};
    this.target = target;
  }

  Matcher.prototype = {
    add: function add(path, handler) {
      this.routes[path] = handler;
    },

    addChild: function addChild(path, target, callback, delegate) {
      var matcher = new Matcher(target);
      this.children[path] = matcher;

      var match = generateMatch(path, matcher, delegate);

      if (delegate && delegate.contextEntered) {
        delegate.contextEntered(target, match);
      }

      callback(match);
    }
  };

  function generateMatch(startingPath, matcher, delegate) {
    return function (path, nestedCallback) {
      var fullPath = startingPath + path;

      if (nestedCallback) {
        nestedCallback(generateMatch(fullPath, matcher, delegate));
      } else {
        return new Target(startingPath + path, matcher, delegate);
      }
    };
  }

  function addRoute(routeArray, path, handler) {
    var len = 0;
    for (var i = 0, l = routeArray.length; i < l; i++) {
      len += routeArray[i].path.length;
    }

    path = path.substr(len);
    var route = { path: path, handler: handler };
    routeArray.push(route);
  }

  function eachRoute(baseRoute, matcher, callback, binding) {
    var routes = matcher.routes;

    for (var path in routes) {
      if (routes.hasOwnProperty(path)) {
        var routeArray = baseRoute.slice();
        addRoute(routeArray, path, routes[path]);

        if (matcher.children[path]) {
          eachRoute(routeArray, matcher.children[path], callback, binding);
        } else {
          callback.call(binding, routeArray);
        }
      }
    }
  }

  function map (callback, addRouteCallback) {
    var matcher = new Matcher();

    callback(generateMatch("", matcher, this.delegate));

    eachRoute([], matcher, function (route) {
      if (addRouteCallback) {
        addRouteCallback(this, route);
      } else {
        this.add(route);
      }
    }, this);
  }

  var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'];

  var escapeRegex = new RegExp('(\\' + specials.join('|\\') + ')', 'g');

  var noWarning = false;
  function warn(msg) {
    if (!noWarning && typeof console !== 'undefined') {
      console.error('[vue-router] ' + msg);
    }
  }

  function tryDecode(uri, asComponent) {
    try {
      return asComponent ? decodeURIComponent(uri) : decodeURI(uri);
    } catch (e) {
      warn('malformed URI' + (asComponent ? ' component: ' : ': ') + uri);
    }
  }

  function isArray(test) {
    return Object.prototype.toString.call(test) === "[object Array]";
  }

  // A Segment represents a segment in the original route description.
  // Each Segment type provides an `eachChar` and `regex` method.
  //
  // The `eachChar` method invokes the callback with one or more character
  // specifications. A character specification consumes one or more input
  // characters.
  //
  // The `regex` method returns a regex fragment for the segment. If the
  // segment is a dynamic of star segment, the regex fragment also includes
  // a capture.
  //
  // A character specification contains:
  //
  // * `validChars`: a String with a list of all valid characters, or
  // * `invalidChars`: a String with a list of all invalid characters
  // * `repeat`: true if the character specification can repeat

  function StaticSegment(string) {
    this.string = string;
  }
  StaticSegment.prototype = {
    eachChar: function eachChar(callback) {
      var string = this.string,
          ch;

      for (var i = 0, l = string.length; i < l; i++) {
        ch = string.charAt(i);
        callback({ validChars: ch });
      }
    },

    regex: function regex() {
      return this.string.replace(escapeRegex, '\\$1');
    },

    generate: function generate() {
      return this.string;
    }
  };

  function DynamicSegment(name) {
    this.name = name;
  }
  DynamicSegment.prototype = {
    eachChar: function eachChar(callback) {
      callback({ invalidChars: "/", repeat: true });
    },

    regex: function regex() {
      return "([^/]+)";
    },

    generate: function generate(params) {
      var val = params[this.name];
      return val == null ? ":" + this.name : val;
    }
  };

  function StarSegment(name) {
    this.name = name;
  }
  StarSegment.prototype = {
    eachChar: function eachChar(callback) {
      callback({ invalidChars: "", repeat: true });
    },

    regex: function regex() {
      return "(.+)";
    },

    generate: function generate(params) {
      var val = params[this.name];
      return val == null ? ":" + this.name : val;
    }
  };

  function EpsilonSegment() {}
  EpsilonSegment.prototype = {
    eachChar: function eachChar() {},
    regex: function regex() {
      return "";
    },
    generate: function generate() {
      return "";
    }
  };

  function parse(route, names, specificity) {
    // normalize route as not starting with a "/". Recognition will
    // also normalize.
    if (route.charAt(0) === "/") {
      route = route.substr(1);
    }

    var segments = route.split("/"),
        results = [];

    // A routes has specificity determined by the order that its different segments
    // appear in. This system mirrors how the magnitude of numbers written as strings
    // works.
    // Consider a number written as: "abc". An example would be "200". Any other number written
    // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
    // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
    // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
    // leading symbol, "1".
    // The rule is that symbols to the left carry more weight than symbols to the right
    // when a number is written out as a string. In the above strings, the leading digit
    // represents how many 100's are in the number, and it carries more weight than the middle
    // number which represents how many 10's are in the number.
    // This system of number magnitude works well for route specificity, too. A route written as
    // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
    // `x`, irrespective of the other parts.
    // Because of this similarity, we assign each type of segment a number value written as a
    // string. We can find the specificity of compound routes by concatenating these strings
    // together, from left to right. After we have looped through all of the segments,
    // we convert the string to a number.
    specificity.val = '';

    for (var i = 0, l = segments.length; i < l; i++) {
      var segment = segments[i],
          match;

      if (match = segment.match(/^:([^\/]+)$/)) {
        results.push(new DynamicSegment(match[1]));
        names.push(match[1]);
        specificity.val += '3';
      } else if (match = segment.match(/^\*([^\/]+)$/)) {
        results.push(new StarSegment(match[1]));
        specificity.val += '2';
        names.push(match[1]);
      } else if (segment === "") {
        results.push(new EpsilonSegment());
        specificity.val += '1';
      } else {
        results.push(new StaticSegment(segment));
        specificity.val += '4';
      }
    }

    specificity.val = +specificity.val;

    return results;
  }

  // A State has a character specification and (`charSpec`) and a list of possible
  // subsequent states (`nextStates`).
  //
  // If a State is an accepting state, it will also have several additional
  // properties:
  //
  // * `regex`: A regular expression that is used to extract parameters from paths
  //   that reached this accepting state.
  // * `handlers`: Information on how to convert the list of captures into calls
  //   to registered handlers with the specified parameters
  // * `types`: How many static, dynamic or star segments in this route. Used to
  //   decide which route to use if multiple registered routes match a path.
  //
  // Currently, State is implemented naively by looping over `nextStates` and
  // comparing a character specification against a character. A more efficient
  // implementation would use a hash of keys pointing at one or more next states.

  function State(charSpec) {
    this.charSpec = charSpec;
    this.nextStates = [];
  }

  State.prototype = {
    get: function get(charSpec) {
      var nextStates = this.nextStates;

      for (var i = 0, l = nextStates.length; i < l; i++) {
        var child = nextStates[i];

        var isEqual = child.charSpec.validChars === charSpec.validChars;
        isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;

        if (isEqual) {
          return child;
        }
      }
    },

    put: function put(charSpec) {
      var state;

      // If the character specification already exists in a child of the current
      // state, just return that state.
      if (state = this.get(charSpec)) {
        return state;
      }

      // Make a new state for the character spec
      state = new State(charSpec);

      // Insert the new state as a child of the current state
      this.nextStates.push(state);

      // If this character specification repeats, insert the new state as a child
      // of itself. Note that this will not trigger an infinite loop because each
      // transition during recognition consumes a character.
      if (charSpec.repeat) {
        state.nextStates.push(state);
      }

      // Return the new state
      return state;
    },

    // Find a list of child states matching the next character
    match: function match(ch) {
      // DEBUG "Processing `" + ch + "`:"
      var nextStates = this.nextStates,
          child,
          charSpec,
          chars;

      // DEBUG "  " + debugState(this)
      var returned = [];

      for (var i = 0, l = nextStates.length; i < l; i++) {
        child = nextStates[i];

        charSpec = child.charSpec;

        if (typeof (chars = charSpec.validChars) !== 'undefined') {
          if (chars.indexOf(ch) !== -1) {
            returned.push(child);
          }
        } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
          if (chars.indexOf(ch) === -1) {
            returned.push(child);
          }
        }
      }

      return returned;
    }

    /** IF DEBUG
    , debug: function() {
      var charSpec = this.charSpec,
          debug = "[",
          chars = charSpec.validChars || charSpec.invalidChars;
       if (charSpec.invalidChars) { debug += "^"; }
      debug += chars;
      debug += "]";
       if (charSpec.repeat) { debug += "+"; }
       return debug;
    }
    END IF **/
  };

  /** IF DEBUG
  function debug(log) {
    console.log(log);
  }

  function debugState(state) {
    return state.nextStates.map(function(n) {
      if (n.nextStates.length === 0) { return "( " + n.debug() + " [accepting] )"; }
      return "( " + n.debug() + " <then> " + n.nextStates.map(function(s) { return s.debug() }).join(" or ") + " )";
    }).join(", ")
  }
  END IF **/

  // Sort the routes by specificity
  function sortSolutions(states) {
    return states.sort(function (a, b) {
      return b.specificity.val - a.specificity.val;
    });
  }

  function recognizeChar(states, ch) {
    var nextStates = [];

    for (var i = 0, l = states.length; i < l; i++) {
      var state = states[i];

      nextStates = nextStates.concat(state.match(ch));
    }

    return nextStates;
  }

  var oCreate = Object.create || function (proto) {
    function F() {}
    F.prototype = proto;
    return new F();
  };

  function RecognizeResults(queryParams) {
    this.queryParams = queryParams || {};
  }
  RecognizeResults.prototype = oCreate({
    splice: Array.prototype.splice,
    slice: Array.prototype.slice,
    push: Array.prototype.push,
    length: 0,
    queryParams: null
  });

  function findHandler(state, path, queryParams) {
    var handlers = state.handlers,
        regex = state.regex;
    var captures = path.match(regex),
        currentCapture = 1;
    var result = new RecognizeResults(queryParams);

    for (var i = 0, l = handlers.length; i < l; i++) {
      var handler = handlers[i],
          names = handler.names,
          params = {};

      for (var j = 0, m = names.length; j < m; j++) {
        params[names[j]] = captures[currentCapture++];
      }

      result.push({ handler: handler.handler, params: params, isDynamic: !!names.length });
    }

    return result;
  }

  function addSegment(currentState, segment) {
    segment.eachChar(function (ch) {
      var state;

      currentState = currentState.put(ch);
    });

    return currentState;
  }

  function decodeQueryParamPart(part) {
    // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
    part = part.replace(/\+/gm, '%20');
    return tryDecode(part, true);
  }

  // The main interface

  var RouteRecognizer = function RouteRecognizer() {
    this.rootState = new State();
    this.names = {};
  };

  RouteRecognizer.prototype = {
    add: function add(routes, options) {
      var currentState = this.rootState,
          regex = "^",
          specificity = {},
          handlers = [],
          allSegments = [],
          name;

      var isEmpty = true;

      for (var i = 0, l = routes.length; i < l; i++) {
        var route = routes[i],
            names = [];

        var segments = parse(route.path, names, specificity);

        allSegments = allSegments.concat(segments);

        for (var j = 0, m = segments.length; j < m; j++) {
          var segment = segments[j];

          if (segment instanceof EpsilonSegment) {
            continue;
          }

          isEmpty = false;

          // Add a "/" for the new segment
          currentState = currentState.put({ validChars: "/" });
          regex += "/";

          // Add a representation of the segment to the NFA and regex
          currentState = addSegment(currentState, segment);
          regex += segment.regex();
        }

        var handler = { handler: route.handler, names: names };
        handlers.push(handler);
      }

      if (isEmpty) {
        currentState = currentState.put({ validChars: "/" });
        regex += "/";
      }

      currentState.handlers = handlers;
      currentState.regex = new RegExp(regex + "$");
      currentState.specificity = specificity;

      if (name = options && options.as) {
        this.names[name] = {
          segments: allSegments,
          handlers: handlers
        };
      }
    },

    handlersFor: function handlersFor(name) {
      var route = this.names[name],
          result = [];
      if (!route) {
        throw new Error("There is no route named " + name);
      }

      for (var i = 0, l = route.handlers.length; i < l; i++) {
        result.push(route.handlers[i]);
      }

      return result;
    },

    hasRoute: function hasRoute(name) {
      return !!this.names[name];
    },

    generate: function generate(name, params) {
      var route = this.names[name],
          output = "";
      if (!route) {
        throw new Error("There is no route named " + name);
      }

      var segments = route.segments;

      for (var i = 0, l = segments.length; i < l; i++) {
        var segment = segments[i];

        if (segment instanceof EpsilonSegment) {
          continue;
        }

        output += "/";
        output += segment.generate(params);
      }

      if (output.charAt(0) !== '/') {
        output = '/' + output;
      }

      if (params && params.queryParams) {
        output += this.generateQueryString(params.queryParams);
      }

      return output;
    },

    generateQueryString: function generateQueryString(params) {
      var pairs = [];
      var keys = [];
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
      keys.sort();
      for (var i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        var value = params[key];
        if (value == null) {
          continue;
        }
        var pair = encodeURIComponent(key);
        if (isArray(value)) {
          for (var j = 0, l = value.length; j < l; j++) {
            var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
            pairs.push(arrayPair);
          }
        } else {
          pair += "=" + encodeURIComponent(value);
          pairs.push(pair);
        }
      }

      if (pairs.length === 0) {
        return '';
      }

      return "?" + pairs.join("&");
    },

    parseQueryString: function parseQueryString(queryString) {
      var pairs = queryString.split("&"),
          queryParams = {};
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('='),
            key = decodeQueryParamPart(pair[0]),
            keyLength = key.length,
            isArray = false,
            value;
        if (pair.length === 1) {
          value = 'true';
        } else {
          //Handle arrays
          if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
            isArray = true;
            key = key.slice(0, keyLength - 2);
            if (!queryParams[key]) {
              queryParams[key] = [];
            }
          }
          value = pair[1] ? decodeQueryParamPart(pair[1]) : '';
        }
        if (isArray) {
          queryParams[key].push(value);
        } else {
          queryParams[key] = value;
        }
      }
      return queryParams;
    },

    recognize: function recognize(path, silent) {
      noWarning = silent;
      var states = [this.rootState],
          pathLen,
          i,
          l,
          queryStart,
          queryParams = {},
          isSlashDropped = false;

      queryStart = path.indexOf('?');
      if (queryStart !== -1) {
        var queryString = path.substr(queryStart + 1, path.length);
        path = path.substr(0, queryStart);
        if (queryString) {
          queryParams = this.parseQueryString(queryString);
        }
      }

      path = tryDecode(path);
      if (!path) return;

      // DEBUG GROUP path

      if (path.charAt(0) !== "/") {
        path = "/" + path;
      }

      pathLen = path.length;
      if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
        path = path.substr(0, pathLen - 1);
        isSlashDropped = true;
      }

      for (i = 0, l = path.length; i < l; i++) {
        states = recognizeChar(states, path.charAt(i));
        if (!states.length) {
          break;
        }
      }

      // END DEBUG GROUP

      var solutions = [];
      for (i = 0, l = states.length; i < l; i++) {
        if (states[i].handlers) {
          solutions.push(states[i]);
        }
      }

      states = sortSolutions(solutions);

      var state = solutions[0];

      if (state && state.handlers) {
        // if a trailing slash was dropped and a star segment is the last segment
        // specified, put the trailing slash back
        if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
          path = path + "/";
        }
        return findHandler(state, path, queryParams);
      }
    }
  };

  RouteRecognizer.prototype.map = map;

  var genQuery = RouteRecognizer.prototype.generateQueryString;

  // export default for holding the Vue reference
  var exports$1 = {};
  /**
   * Warn stuff.
   *
   * @param {String} msg
   */

  function warn$1(msg) {
    /* istanbul ignore next */
    if (typeof console !== 'undefined') {
      console.error('[vue-router] ' + msg);
    }
  }

  /**
   * Resolve a relative path.
   *
   * @param {String} base
   * @param {String} relative
   * @param {Boolean} append
   * @return {String}
   */

  function resolvePath(base, relative, append) {
    var query = base.match(/(\?.*)$/);
    if (query) {
      query = query[1];
      base = base.slice(0, -query.length);
    }
    // a query!
    if (relative.charAt(0) === '?') {
      return base + relative;
    }
    var stack = base.split('/');
    // remove trailing segment if:
    // - not appending
    // - appending to trailing slash (last segment is empty)
    if (!append || !stack[stack.length - 1]) {
      stack.pop();
    }
    // resolve relative path
    var segments = relative.replace(/^\//, '').split('/');
    for (var i = 0; i < segments.length; i++) {
      var segment = segments[i];
      if (segment === '.') {
        continue;
      } else if (segment === '..') {
        stack.pop();
      } else {
        stack.push(segment);
      }
    }
    // ensure leading slash
    if (stack[0] !== '') {
      stack.unshift('');
    }
    return stack.join('/');
  }

  /**
   * Forgiving check for a promise
   *
   * @param {Object} p
   * @return {Boolean}
   */

  function isPromise(p) {
    return p && typeof p.then === 'function';
  }

  /**
   * Retrive a route config field from a component instance
   * OR a component contructor.
   *
   * @param {Function|Vue} component
   * @param {String} name
   * @return {*}
   */

  function getRouteConfig(component, name) {
    var options = component && (component.$options || component.options);
    return options && options.route && options.route[name];
  }

  /**
   * Resolve an async component factory. Have to do a dirty
   * mock here because of Vue core's internal API depends on
   * an ID check.
   *
   * @param {Object} handler
   * @param {Function} cb
   */

  var resolver = undefined;

  function resolveAsyncComponent(handler, cb) {
    if (!resolver) {
      resolver = {
        resolve: exports$1.Vue.prototype._resolveComponent,
        $options: {
          components: {
            _: handler.component
          }
        }
      };
    } else {
      resolver.$options.components._ = handler.component;
    }
    resolver.resolve('_', function (Component) {
      handler.component = Component;
      cb(Component);
    });
  }

  /**
   * Map the dynamic segments in a path to params.
   *
   * @param {String} path
   * @param {Object} params
   * @param {Object} query
   */

  function mapParams(path, params, query) {
    if (params === undefined) params = {};

    path = path.replace(/:([^\/]+)/g, function (_, key) {
      var val = params[key];
      /* istanbul ignore if */
      if (!val) {
        warn$1('param "' + key + '" not found when generating ' + 'path for "' + path + '" with params ' + JSON.stringify(params));
      }
      return val || '';
    });
    if (query) {
      path += genQuery(query);
    }
    return path;
  }

  var hashRE = /#.*$/;

  var HTML5History = (function () {
    function HTML5History(_ref) {
      var root = _ref.root;
      var onChange = _ref.onChange;
      babelHelpers.classCallCheck(this, HTML5History);

      if (root && root !== '/') {
        // make sure there's the starting slash
        if (root.charAt(0) !== '/') {
          root = '/' + root;
        }
        // remove trailing slash
        this.root = root.replace(/\/$/, '');
        this.rootRE = new RegExp('^\\' + this.root);
      } else {
        this.root = null;
      }
      this.onChange = onChange;
      // check base tag
      var baseEl = document.querySelector('base');
      this.base = baseEl && baseEl.getAttribute('href');
    }

    HTML5History.prototype.start = function start() {
      var _this = this;

      this.listener = function (e) {
        var url = location.pathname + location.search;
        if (_this.root) {
          url = url.replace(_this.rootRE, '');
        }
        _this.onChange(url, e && e.state, location.hash);
      };
      window.addEventListener('popstate', this.listener);
      this.listener();
    };

    HTML5History.prototype.stop = function stop() {
      window.removeEventListener('popstate', this.listener);
    };

    HTML5History.prototype.go = function go(path, replace, append) {
      var url = this.formatPath(path, append);
      if (replace) {
        history.replaceState({}, '', url);
      } else {
        // record scroll position by replacing current state
        history.replaceState({
          pos: {
            x: window.pageXOffset,
            y: window.pageYOffset
          }
        }, '', location.href);
        // then push new state
        history.pushState({}, '', url);
      }
      var hashMatch = path.match(hashRE);
      var hash = hashMatch && hashMatch[0];
      path = url
      // strip hash so it doesn't mess up params
      .replace(hashRE, '')
      // remove root before matching
      .replace(this.rootRE, '');
      this.onChange(path, null, hash);
    };

    HTML5History.prototype.formatPath = function formatPath(path, append) {
      return path.charAt(0) === '/'
      // absolute path
      ? this.root ? this.root + '/' + path.replace(/^\//, '') : path : resolvePath(this.base || location.pathname, path, append);
    };

    return HTML5History;
  })();

  var HashHistory = (function () {
    function HashHistory(_ref) {
      var hashbang = _ref.hashbang;
      var onChange = _ref.onChange;
      babelHelpers.classCallCheck(this, HashHistory);

      this.hashbang = hashbang;
      this.onChange = onChange;
    }

    HashHistory.prototype.start = function start() {
      var self = this;
      this.listener = function () {
        var path = location.hash;
        var raw = path.replace(/^#!?/, '');
        // always
        if (raw.charAt(0) !== '/') {
          raw = '/' + raw;
        }
        var formattedPath = self.formatPath(raw);
        if (formattedPath !== path) {
          location.replace(formattedPath);
          return;
        }
        // determine query
        // note it's possible to have queries in both the actual URL
        // and the hash fragment itself.
        var query = location.search && path.indexOf('?') > -1 ? '&' + location.search.slice(1) : location.search;
        self.onChange(path.replace(/^#!?/, '') + query);
      };
      window.addEventListener('hashchange', this.listener);
      this.listener();
    };

    HashHistory.prototype.stop = function stop() {
      window.removeEventListener('hashchange', this.listener);
    };

    HashHistory.prototype.go = function go(path, replace, append) {
      path = this.formatPath(path, append);
      if (replace) {
        location.replace(path);
      } else {
        location.hash = path;
      }
    };

    HashHistory.prototype.formatPath = function formatPath(path, append) {
      var isAbsoloute = path.charAt(0) === '/';
      var prefix = '#' + (this.hashbang ? '!' : '');
      return isAbsoloute ? prefix + path : prefix + resolvePath(location.hash.replace(/^#!?/, ''), path, append);
    };

    return HashHistory;
  })();

  var AbstractHistory = (function () {
    function AbstractHistory(_ref) {
      var onChange = _ref.onChange;
      babelHelpers.classCallCheck(this, AbstractHistory);

      this.onChange = onChange;
      this.currentPath = '/';
    }

    AbstractHistory.prototype.start = function start() {
      this.onChange('/');
    };

    AbstractHistory.prototype.stop = function stop() {
      // noop
    };

    AbstractHistory.prototype.go = function go(path, replace, append) {
      path = this.currentPath = this.formatPath(path, append);
      this.onChange(path);
    };

    AbstractHistory.prototype.formatPath = function formatPath(path, append) {
      return path.charAt(0) === '/' ? path : resolvePath(this.currentPath, path, append);
    };

    return AbstractHistory;
  })();

  /**
   * Determine the reusability of an existing router view.
   *
   * @param {Directive} view
   * @param {Object} handler
   * @param {Transition} transition
   */

  function canReuse(view, handler, transition) {
    var component = view.childVM;
    if (!component || !handler) {
      return false;
    }
    // important: check view.Component here because it may
    // have been changed in activate hook
    if (view.Component !== handler.component) {
      return false;
    }
    var canReuseFn = getRouteConfig(component, 'canReuse');
    return typeof canReuseFn === 'boolean' ? canReuseFn : canReuseFn ? canReuseFn.call(component, {
      to: transition.to,
      from: transition.from
    }) : true; // defaults to true
  }

  /**
   * Check if a component can deactivate.
   *
   * @param {Directive} view
   * @param {Transition} transition
   * @param {Function} next
   */

  function canDeactivate(view, transition, next) {
    var fromComponent = view.childVM;
    var hook = getRouteConfig(fromComponent, 'canDeactivate');
    if (!hook) {
      next();
    } else {
      transition.callHook(hook, fromComponent, next, {
        expectBoolean: true
      });
    }
  }

  /**
   * Check if a component can activate.
   *
   * @param {Object} handler
   * @param {Transition} transition
   * @param {Function} next
   */

  function canActivate(handler, transition, next) {
    resolveAsyncComponent(handler, function (Component) {
      // have to check due to async-ness
      if (transition.aborted) {
        return;
      }
      // determine if this component can be activated
      var hook = getRouteConfig(Component, 'canActivate');
      if (!hook) {
        next();
      } else {
        transition.callHook(hook, null, next, {
          expectBoolean: true
        });
      }
    });
  }

  /**
   * Call deactivate hooks for existing router-views.
   *
   * @param {Directive} view
   * @param {Transition} transition
   * @param {Function} next
   */

  function deactivate(view, transition, next) {
    var component = view.childVM;
    var hook = getRouteConfig(component, 'deactivate');
    if (!hook) {
      next();
    } else {
      transition.callHooks(hook, component, next);
    }
  }

  /**
   * Activate / switch component for a router-view.
   *
   * @param {Directive} view
   * @param {Transition} transition
   * @param {Number} depth
   * @param {Function} [cb]
   */

  function activate(view, transition, depth, cb, reuse) {
    var handler = transition.activateQueue[depth];
    if (!handler) {
      saveChildView(view);
      if (view._bound) {
        view.setComponent(null);
      }
      cb && cb();
      return;
    }

    var Component = view.Component = handler.component;
    var activateHook = getRouteConfig(Component, 'activate');
    var dataHook = getRouteConfig(Component, 'data');
    var waitForData = getRouteConfig(Component, 'waitForData');

    view.depth = depth;
    view.activated = false;

    var component = undefined;
    var loading = !!(dataHook && !waitForData);

    // "reuse" is a flag passed down when the parent view is
    // either reused via keep-alive or as a child of a kept-alive view.
    // of course we can only reuse if the current kept-alive instance
    // is of the correct type.
    reuse = reuse && view.childVM && view.childVM.constructor === Component;

    if (reuse) {
      // just reuse
      component = view.childVM;
      component.$loadingRouteData = loading;
    } else {
      saveChildView(view);

      // unbuild current component. this step also destroys
      // and removes all nested child views.
      view.unbuild(true);

      // build the new component. this will also create the
      // direct child view of the current one. it will register
      // itself as view.childView.
      component = view.build({
        _meta: {
          $loadingRouteData: loading
        },
        created: function created() {
          this._routerView = view;
        }
      });

      // handle keep-alive.
      // when a kept-alive child vm is restored, we need to
      // add its cached child views into the router's view list,
      // and also properly update current view's child view.
      if (view.keepAlive) {
        component.$loadingRouteData = loading;
        var cachedChildView = component._keepAliveRouterView;
        if (cachedChildView) {
          view.childView = cachedChildView;
          component._keepAliveRouterView = null;
        }
      }
    }

    // cleanup the component in case the transition is aborted
    // before the component is ever inserted.
    var cleanup = function cleanup() {
      component.$destroy();
    };

    // actually insert the component and trigger transition
    var insert = function insert() {
      if (reuse) {
        cb && cb();
        return;
      }
      var router = transition.router;
      if (router._rendered || router._transitionOnLoad) {
        view.transition(component);
      } else {
        // no transition on first render, manual transition
        /* istanbul ignore if */
        if (view.setCurrent) {
          // 0.12 compat
          view.setCurrent(component);
        } else {
          // 1.0
          view.childVM = component;
        }
        component.$before(view.anchor, null, false);
      }
      cb && cb();
    };

    var afterData = function afterData() {
      // activate the child view
      if (view.childView) {
        activate(view.childView, transition, depth + 1, null, reuse || view.keepAlive);
      }
      insert();
    };

    // called after activation hook is resolved
    var afterActivate = function afterActivate() {
      view.activated = true;
      if (dataHook && waitForData) {
        // wait until data loaded to insert
        loadData(component, transition, dataHook, afterData, cleanup);
      } else {
        // load data and insert at the same time
        if (dataHook) {
          loadData(component, transition, dataHook);
        }
        afterData();
      }
    };

    if (activateHook) {
      transition.callHooks(activateHook, component, afterActivate, {
        cleanup: cleanup,
        postActivate: true
      });
    } else {
      afterActivate();
    }
  }

  /**
   * Reuse a view, just reload data if necessary.
   *
   * @param {Directive} view
   * @param {Transition} transition
   */

  function reuse(view, transition) {
    var component = view.childVM;
    var dataHook = getRouteConfig(component, 'data');
    if (dataHook) {
      loadData(component, transition, dataHook);
    }
  }

  /**
   * Asynchronously load and apply data to component.
   *
   * @param {Vue} component
   * @param {Transition} transition
   * @param {Function} hook
   * @param {Function} cb
   * @param {Function} cleanup
   */

  function loadData(component, transition, hook, cb, cleanup) {
    component.$loadingRouteData = true;
    transition.callHooks(hook, component, function () {
      component.$loadingRouteData = false;
      component.$emit('route-data-loaded', component);
      cb && cb();
    }, {
      cleanup: cleanup,
      postActivate: true,
      processData: function processData(data) {
        // handle promise sugar syntax
        var promises = [];
        if (isPlainObject(data)) {
          Object.keys(data).forEach(function (key) {
            var val = data[key];
            if (isPromise(val)) {
              promises.push(val.then(function (resolvedVal) {
                component.$set(key, resolvedVal);
              }));
            } else {
              component.$set(key, val);
            }
          });
        }
        if (promises.length) {
          return promises[0].constructor.all(promises);
        }
      }
    });
  }

  /**
   * Save the child view for a kept-alive view so that
   * we can restore it when it is switched back to.
   *
   * @param {Directive} view
   */

  function saveChildView(view) {
    if (view.keepAlive && view.childVM && view.childView) {
      view.childVM._keepAliveRouterView = view.childView;
    }
    view.childView = null;
  }

  /**
   * Check plain object.
   *
   * @param {*} val
   */

  function isPlainObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  }

  /**
   * A RouteTransition object manages the pipeline of a
   * router-view switching process. This is also the object
   * passed into user route hooks.
   *
   * @param {Router} router
   * @param {Route} to
   * @param {Route} from
   */

  var RouteTransition = (function () {
    function RouteTransition(router, to, from) {
      babelHelpers.classCallCheck(this, RouteTransition);

      this.router = router;
      this.to = to;
      this.from = from;
      this.next = null;
      this.aborted = false;
      this.done = false;
    }

    /**
     * Abort current transition and return to previous location.
     */

    RouteTransition.prototype.abort = function abort() {
      if (!this.aborted) {
        this.aborted = true;
        // if the root path throws an error during validation
        // on initial load, it gets caught in an infinite loop.
        var abortingOnLoad = !this.from.path && this.to.path === '/';
        if (!abortingOnLoad) {
          this.router.replace(this.from.path || '/');
        }
      }
    };

    /**
     * Abort current transition and redirect to a new location.
     *
     * @param {String} path
     */

    RouteTransition.prototype.redirect = function redirect(path) {
      if (!this.aborted) {
        this.aborted = true;
        if (typeof path === 'string') {
          path = mapParams(path, this.to.params, this.to.query);
        } else {
          path.params = path.params || this.to.params;
          path.query = path.query || this.to.query;
        }
        this.router.replace(path);
      }
    };

    /**
     * A router view transition's pipeline can be described as
     * follows, assuming we are transitioning from an existing
     * <router-view> chain [Component A, Component B] to a new
     * chain [Component A, Component C]:
     *
     *  A    A
     *  | => |
     *  B    C
     *
     * 1. Reusablity phase:
     *   -> canReuse(A, A)
     *   -> canReuse(B, C)
     *   -> determine new queues:
     *      - deactivation: [B]
     *      - activation: [C]
     *
     * 2. Validation phase:
     *   -> canDeactivate(B)
     *   -> canActivate(C)
     *
     * 3. Activation phase:
     *   -> deactivate(B)
     *   -> activate(C)
     *
     * Each of these steps can be asynchronous, and any
     * step can potentially abort the transition.
     *
     * @param {Function} cb
     */

    RouteTransition.prototype.start = function start(cb) {
      var transition = this;

      // determine the queue of views to deactivate
      var deactivateQueue = [];
      var view = this.router._rootView;
      while (view) {
        deactivateQueue.unshift(view);
        view = view.childView;
      }
      var reverseDeactivateQueue = deactivateQueue.slice().reverse();

      // determine the queue of route handlers to activate
      var activateQueue = this.activateQueue = toArray(this.to.matched).map(function (match) {
        return match.handler;
      });

      // 1. Reusability phase
      var i = undefined,
          reuseQueue = undefined;
      for (i = 0; i < reverseDeactivateQueue.length; i++) {
        if (!canReuse(reverseDeactivateQueue[i], activateQueue[i], transition)) {
          break;
        }
      }
      if (i > 0) {
        reuseQueue = reverseDeactivateQueue.slice(0, i);
        deactivateQueue = reverseDeactivateQueue.slice(i).reverse();
        activateQueue = activateQueue.slice(i);
      }

      // 2. Validation phase
      transition.runQueue(deactivateQueue, canDeactivate, function () {
        transition.runQueue(activateQueue, canActivate, function () {
          transition.runQueue(deactivateQueue, deactivate, function () {
            // 3. Activation phase

            // Update router current route
            transition.router._onTransitionValidated(transition);

            // trigger reuse for all reused views
            reuseQueue && reuseQueue.forEach(function (view) {
              return reuse(view, transition);
            });

            // the root of the chain that needs to be replaced
            // is the top-most non-reusable view.
            if (deactivateQueue.length) {
              var _view = deactivateQueue[deactivateQueue.length - 1];
              var depth = reuseQueue ? reuseQueue.length : 0;
              activate(_view, transition, depth, cb);
            } else {
              cb();
            }
          });
        });
      });
    };

    /**
     * Asynchronously and sequentially apply a function to a
     * queue.
     *
     * @param {Array} queue
     * @param {Function} fn
     * @param {Function} cb
     */

    RouteTransition.prototype.runQueue = function runQueue(queue, fn, cb) {
      var transition = this;
      step(0);
      function step(index) {
        if (index >= queue.length) {
          cb();
        } else {
          fn(queue[index], transition, function () {
            step(index + 1);
          });
        }
      }
    };

    /**
     * Call a user provided route transition hook and handle
     * the response (e.g. if the user returns a promise).
     *
     * If the user neither expects an argument nor returns a
     * promise, the hook is assumed to be synchronous.
     *
     * @param {Function} hook
     * @param {*} [context]
     * @param {Function} [cb]
     * @param {Object} [options]
     *                 - {Boolean} expectBoolean
     *                 - {Boolean} postActive
     *                 - {Function} processData
     *                 - {Function} cleanup
     */

    RouteTransition.prototype.callHook = function callHook(hook, context, cb) {
      var _ref = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];

      var _ref$expectBoolean = _ref.expectBoolean;
      var expectBoolean = _ref$expectBoolean === undefined ? false : _ref$expectBoolean;
      var _ref$postActivate = _ref.postActivate;
      var postActivate = _ref$postActivate === undefined ? false : _ref$postActivate;
      var processData = _ref.processData;
      var cleanup = _ref.cleanup;

      var transition = this;
      var nextCalled = false;

      // abort the transition
      var abort = function abort() {
        cleanup && cleanup();
        transition.abort();
      };

      // handle errors
      var onError = function onError(err) {
        postActivate ? next() : abort();
        if (err && !transition.router._suppress) {
          warn$1('Uncaught error during transition: ');
          throw err instanceof Error ? err : new Error(err);
        }
      };

      // since promise swallows errors, we have to
      // throw it in the next tick...
      var onPromiseError = function onPromiseError(err) {
        try {
          onError(err);
        } catch (e) {
          setTimeout(function () {
            throw e;
          }, 0);
        }
      };

      // advance the transition to the next step
      var next = function next() {
        if (nextCalled) {
          warn$1('transition.next() should be called only once.');
          return;
        }
        nextCalled = true;
        if (transition.aborted) {
          cleanup && cleanup();
          return;
        }
        cb && cb();
      };

      var nextWithBoolean = function nextWithBoolean(res) {
        if (typeof res === 'boolean') {
          res ? next() : abort();
        } else if (isPromise(res)) {
          res.then(function (ok) {
            ok ? next() : abort();
          }, onPromiseError);
        } else if (!hook.length) {
          next();
        }
      };

      var nextWithData = function nextWithData(data) {
        var res = undefined;
        try {
          res = processData(data);
        } catch (err) {
          return onError(err);
        }
        if (isPromise(res)) {
          res.then(next, onPromiseError);
        } else {
          next();
        }
      };

      // expose a clone of the transition object, so that each
      // hook gets a clean copy and prevent the user from
      // messing with the internals.
      var exposed = {
        to: transition.to,
        from: transition.from,
        abort: abort,
        next: processData ? nextWithData : next,
        redirect: function redirect() {
          transition.redirect.apply(transition, arguments);
        }
      };

      // actually call the hook
      var res = undefined;
      try {
        res = hook.call(context, exposed);
      } catch (err) {
        return onError(err);
      }

      if (expectBoolean) {
        // boolean hooks
        nextWithBoolean(res);
      } else if (isPromise(res)) {
        // promise
        if (processData) {
          res.then(nextWithData, onPromiseError);
        } else {
          res.then(next, onPromiseError);
        }
      } else if (processData && isPlainOjbect(res)) {
        // data promise sugar
        nextWithData(res);
      } else if (!hook.length) {
        next();
      }
    };

    /**
     * Call a single hook or an array of async hooks in series.
     *
     * @param {Array} hooks
     * @param {*} context
     * @param {Function} cb
     * @param {Object} [options]
     */

    RouteTransition.prototype.callHooks = function callHooks(hooks, context, cb, options) {
      var _this = this;

      if (Array.isArray(hooks)) {
        this.runQueue(hooks, function (hook, _, next) {
          if (!_this.aborted) {
            _this.callHook(hook, context, next, options);
          }
        }, cb);
      } else {
        this.callHook(hooks, context, cb, options);
      }
    };

    return RouteTransition;
  })();

  function isPlainOjbect(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  }

  function toArray(val) {
    return val ? Array.prototype.slice.call(val) : [];
  }

  var internalKeysRE = /^(component|subRoutes|fullPath)$/;

  /**
   * Route Context Object
   *
   * @param {String} path
   * @param {Router} router
   */

  var Route = function Route(path, router) {
    var _this = this;

    babelHelpers.classCallCheck(this, Route);

    var matched = router._recognizer.recognize(path);
    if (matched) {
      // copy all custom fields from route configs
      [].forEach.call(matched, function (match) {
        for (var key in match.handler) {
          if (!internalKeysRE.test(key)) {
            _this[key] = match.handler[key];
          }
        }
      });
      // set query and params
      this.query = matched.queryParams;
      this.params = [].reduce.call(matched, function (prev, cur) {
        if (cur.params) {
          for (var key in cur.params) {
            prev[key] = cur.params[key];
          }
        }
        return prev;
      }, {});
    }
    // expose path and router
    this.path = path;
    // for internal use
    this.matched = matched || router._notFoundHandler;
    // internal reference to router
    Object.defineProperty(this, 'router', {
      enumerable: false,
      value: router
    });
    // Important: freeze self to prevent observation
    Object.freeze(this);
  };

  function applyOverride (Vue) {
    var _Vue$util = Vue.util;
    var extend = _Vue$util.extend;
    var isArray = _Vue$util.isArray;
    var defineReactive = _Vue$util.defineReactive;

    // override Vue's init and destroy process to keep track of router instances
    var init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      options = options || {};
      var root = options._parent || options.parent || this;
      var router = root.$router;
      var route = root.$route;
      if (router) {
        // expose router
        this.$router = router;
        router._children.push(this);
        /* istanbul ignore if */
        if (this._defineMeta) {
          // 0.12
          this._defineMeta('$route', route);
        } else {
          // 1.0
          defineReactive(this, '$route', route);
        }
      }
      init.call(this, options);
    };

    var destroy = Vue.prototype._destroy;
    Vue.prototype._destroy = function () {
      if (!this._isBeingDestroyed && this.$router) {
        this.$router._children.$remove(this);
      }
      destroy.apply(this, arguments);
    };

    // 1.0 only: enable route mixins
    var strats = Vue.config.optionMergeStrategies;
    var hooksToMergeRE = /^(data|activate|deactivate)$/;

    if (strats) {
      strats.route = function (parentVal, childVal) {
        if (!childVal) return parentVal;
        if (!parentVal) return childVal;
        var ret = {};
        extend(ret, parentVal);
        for (var key in childVal) {
          var a = ret[key];
          var b = childVal[key];
          // for data, activate and deactivate, we need to merge them into
          // arrays similar to lifecycle hooks.
          if (a && hooksToMergeRE.test(key)) {
            ret[key] = (isArray(a) ? a : [a]).concat(b);
          } else {
            ret[key] = b;
          }
        }
        return ret;
      };
    }
  }

  function View (Vue) {

    var _ = Vue.util;
    var componentDef =
    // 0.12
    Vue.directive('_component') ||
    // 1.0
    Vue.internalDirectives.component;
    // <router-view> extends the internal component directive
    var viewDef = _.extend({}, componentDef);

    // with some overrides
    _.extend(viewDef, {

      _isRouterView: true,

      bind: function bind() {
        var route = this.vm.$route;
        /* istanbul ignore if */
        if (!route) {
          warn$1('<router-view> can only be used inside a ' + 'router-enabled app.');
          return;
        }
        // force dynamic directive so v-component doesn't
        // attempt to build right now
        this._isDynamicLiteral = true;
        // finally, init by delegating to v-component
        componentDef.bind.call(this);

        // locate the parent view
        var parentView = undefined;
        var parent = this.vm;
        while (parent) {
          if (parent._routerView) {
            parentView = parent._routerView;
            break;
          }
          parent = parent.$parent;
        }
        if (parentView) {
          // register self as a child of the parent view,
          // instead of activating now. This is so that the
          // child's activate hook is called after the
          // parent's has resolved.
          this.parentView = parentView;
          parentView.childView = this;
        } else {
          // this is the root view!
          var router = route.router;
          router._rootView = this;
        }

        // handle late-rendered view
        // two possibilities:
        // 1. root view rendered after transition has been
        //    validated;
        // 2. child view rendered after parent view has been
        //    activated.
        var transition = route.router._currentTransition;
        if (!parentView && transition.done || parentView && parentView.activated) {
          var depth = parentView ? parentView.depth + 1 : 0;
          activate(this, transition, depth);
        }
      },

      unbind: function unbind() {
        if (this.parentView) {
          this.parentView.childView = null;
        }
        componentDef.unbind.call(this);
      }
    });

    Vue.elementDirective('router-view', viewDef);
  }

  var trailingSlashRE = /\/$/;
  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
  var queryStringRE = /\?.*$/;

  // install v-link, which provides navigation support for
  // HTML5 history mode
  function Link (Vue) {
    var _Vue$util = Vue.util;
    var _bind = _Vue$util.bind;
    var isObject = _Vue$util.isObject;
    var addClass = _Vue$util.addClass;
    var removeClass = _Vue$util.removeClass;

    var onPriority = Vue.directive('on').priority;
    var LINK_UPDATE = '__vue-router-link-update__';

    var activeId = 0;

    Vue.directive('link-active', {
      priority: 9999,
      bind: function bind() {
        var _this = this;

        var id = String(activeId++);
        // collect v-links contained within this element.
        // we need do this here before the parent-child relationship
        // gets messed up by terminal directives (if, for, components)
        var childLinks = this.el.querySelectorAll('[v-link]');
        for (var i = 0, l = childLinks.length; i < l; i++) {
          var link = childLinks[i];
          var existingId = link.getAttribute(LINK_UPDATE);
          var value = existingId ? existingId + ',' + id : id;
          // leave a mark on the link element which can be persisted
          // through fragment clones.
          link.setAttribute(LINK_UPDATE, value);
        }
        this.vm.$on(LINK_UPDATE, this.cb = function (link, path) {
          if (link.activeIds.indexOf(id) > -1) {
            link.updateClasses(path, _this.el);
          }
        });
      },
      unbind: function unbind() {
        this.vm.$off(LINK_UPDATE, this.cb);
      }
    });

    Vue.directive('link', {
      priority: onPriority - 2,

      bind: function bind() {
        var vm = this.vm;
        /* istanbul ignore if */
        if (!vm.$route) {
          warn$1('v-link can only be used inside a router-enabled app.');
          return;
        }
        this.router = vm.$route.router;
        // update things when the route changes
        this.unwatch = vm.$watch('$route', _bind(this.onRouteUpdate, this));
        // check v-link-active ids
        var activeIds = this.el.getAttribute(LINK_UPDATE);
        if (activeIds) {
          this.el.removeAttribute(LINK_UPDATE);
          this.activeIds = activeIds.split(',');
        }
        // no need to handle click if link expects to be opened
        // in a new window/tab.
        /* istanbul ignore if */
        if (this.el.tagName === 'A' && this.el.getAttribute('target') === '_blank') {
          return;
        }
        // handle click
        this.handler = _bind(this.onClick, this);
        this.el.addEventListener('click', this.handler);
      },

      update: function update(target) {
        this.target = target;
        if (isObject(target)) {
          this.append = target.append;
          this.exact = target.exact;
          this.prevActiveClass = this.activeClass;
          this.activeClass = target.activeClass;
        }
        this.onRouteUpdate(this.vm.$route);
      },

      onClick: function onClick(e) {
        // don't redirect with control keys
        /* istanbul ignore if */
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        // don't redirect when preventDefault called
        /* istanbul ignore if */
        if (e.defaultPrevented) return;
        // don't redirect on right click
        /* istanbul ignore if */
        if (e.button !== 0) return;

        var target = this.target;
        if (target) {
          // v-link with expression, just go
          e.preventDefault();
          this.router.go(target);
        } else {
          // no expression, delegate for an <a> inside
          var el = e.target;
          while (el.tagName !== 'A' && el !== this.el) {
            el = el.parentNode;
          }
          if (el.tagName === 'A' && sameOrigin(el)) {
            e.preventDefault();
            var path = el.pathname;
            if (this.router.history.root) {
              path = path.replace(this.router.history.rootRE, '');
            }
            this.router.go({
              path: path,
              replace: target && target.replace,
              append: target && target.append
            });
          }
        }
      },

      onRouteUpdate: function onRouteUpdate(route) {
        // router.stringifyPath is dependent on current route
        // and needs to be called again whenver route changes.
        var newPath = this.router.stringifyPath(this.target);
        if (this.path !== newPath) {
          this.path = newPath;
          this.updateActiveMatch();
          this.updateHref();
        }
        if (this.activeIds) {
          this.vm.$emit(LINK_UPDATE, this, route.path);
        } else {
          this.updateClasses(route.path, this.el);
        }
      },

      updateActiveMatch: function updateActiveMatch() {
        this.activeRE = this.path && !this.exact ? new RegExp('^' + this.path.replace(/\/$/, '').replace(queryStringRE, '').replace(regexEscapeRE, '\\$&') + '(\\/|$)') : null;
      },

      updateHref: function updateHref() {
        if (this.el.tagName !== 'A') {
          return;
        }
        var path = this.path;
        var router = this.router;
        var isAbsolute = path.charAt(0) === '/';
        // do not format non-hash relative paths
        var href = path && (router.mode === 'hash' || isAbsolute) ? router.history.formatPath(path, this.append) : path;
        if (href) {
          this.el.href = href;
        } else {
          this.el.removeAttribute('href');
        }
      },

      updateClasses: function updateClasses(path, el) {
        var activeClass = this.activeClass || this.router._linkActiveClass;
        // clear old class
        if (this.prevActiveClass && this.prevActiveClass !== activeClass) {
          toggleClasses(el, this.prevActiveClass, removeClass);
        }
        // remove query string before matching
        var dest = this.path.replace(queryStringRE, '');
        path = path.replace(queryStringRE, '');
        // add new class
        if (this.exact) {
          if (dest === path ||
          // also allow additional trailing slash
          dest.charAt(dest.length - 1) !== '/' && dest === path.replace(trailingSlashRE, '')) {
            toggleClasses(el, activeClass, addClass);
          } else {
            toggleClasses(el, activeClass, removeClass);
          }
        } else {
          if (this.activeRE && this.activeRE.test(path)) {
            toggleClasses(el, activeClass, addClass);
          } else {
            toggleClasses(el, activeClass, removeClass);
          }
        }
      },

      unbind: function unbind() {
        this.el.removeEventListener('click', this.handler);
        this.unwatch && this.unwatch();
      }
    });

    function sameOrigin(link) {
      return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
    }

    // this function is copied from v-bind:class implementation until
    // we properly expose it...
    function toggleClasses(el, key, fn) {
      key = key.trim();
      if (key.indexOf(' ') === -1) {
        fn(el, key);
        return;
      }
      var keys = key.split(/\s+/);
      for (var i = 0, l = keys.length; i < l; i++) {
        fn(el, keys[i]);
      }
    }
  }

  var historyBackends = {
    abstract: AbstractHistory,
    hash: HashHistory,
    html5: HTML5History
  };

  // late bind during install
  var Vue = undefined;

  /**
   * Router constructor
   *
   * @param {Object} [options]
   */

  var Router = (function () {
    function Router() {
      var _this = this;

      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      var _ref$hashbang = _ref.hashbang;
      var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
      var _ref$abstract = _ref.abstract;
      var abstract = _ref$abstract === undefined ? false : _ref$abstract;
      var _ref$history = _ref.history;
      var history = _ref$history === undefined ? false : _ref$history;
      var _ref$saveScrollPosition = _ref.saveScrollPosition;
      var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
      var _ref$transitionOnLoad = _ref.transitionOnLoad;
      var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
      var _ref$suppressTransitionError = _ref.suppressTransitionError;
      var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
      var _ref$root = _ref.root;
      var root = _ref$root === undefined ? null : _ref$root;
      var _ref$linkActiveClass = _ref.linkActiveClass;
      var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;
      babelHelpers.classCallCheck(this, Router);

      /* istanbul ignore if */
      if (!Router.installed) {
        throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
      }

      // Vue instances
      this.app = null;
      this._children = [];

      // route recognizer
      this._recognizer = new RouteRecognizer();
      this._guardRecognizer = new RouteRecognizer();

      // state
      this._started = false;
      this._startCb = null;
      this._currentRoute = {};
      this._currentTransition = null;
      this._previousTransition = null;
      this._notFoundHandler = null;
      this._notFoundRedirect = null;
      this._beforeEachHooks = [];
      this._afterEachHooks = [];

      // trigger transition on initial render?
      this._rendered = false;
      this._transitionOnLoad = transitionOnLoad;

      // history mode
      this._root = root;
      this._abstract = abstract;
      this._hashbang = hashbang;

      // check if HTML5 history is available
      var hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;
      this._history = history && hasPushState;
      this._historyFallback = history && !hasPushState;

      // create history object
      var inBrowser = Vue.util.inBrowser;
      this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';

      var History = historyBackends[this.mode];
      this.history = new History({
        root: root,
        hashbang: this._hashbang,
        onChange: function onChange(path, state, anchor) {
          _this._match(path, state, anchor);
        }
      });

      // other options
      this._saveScrollPosition = saveScrollPosition;
      this._linkActiveClass = linkActiveClass;
      this._suppress = suppressTransitionError;
    }

    /**
     * Allow directly passing components to a route
     * definition.
     *
     * @param {String} path
     * @param {Object} handler
     */

    // API ===================================================

    /**
    * Register a map of top-level paths.
    *
    * @param {Object} map
    */

    Router.prototype.map = function map(_map) {
      for (var route in _map) {
        this.on(route, _map[route]);
      }
      return this;
    };

    /**
     * Register a single root-level path
     *
     * @param {String} rootPath
     * @param {Object} handler
     *                 - {String} component
     *                 - {Object} [subRoutes]
     *                 - {Boolean} [forceRefresh]
     *                 - {Function} [before]
     *                 - {Function} [after]
     */

    Router.prototype.on = function on(rootPath, handler) {
      if (rootPath === '*') {
        this._notFound(handler);
      } else {
        this._addRoute(rootPath, handler, []);
      }
      return this;
    };

    /**
     * Set redirects.
     *
     * @param {Object} map
     */

    Router.prototype.redirect = function redirect(map) {
      for (var path in map) {
        this._addRedirect(path, map[path]);
      }
      return this;
    };

    /**
     * Set aliases.
     *
     * @param {Object} map
     */

    Router.prototype.alias = function alias(map) {
      for (var path in map) {
        this._addAlias(path, map[path]);
      }
      return this;
    };

    /**
     * Set global before hook.
     *
     * @param {Function} fn
     */

    Router.prototype.beforeEach = function beforeEach(fn) {
      this._beforeEachHooks.push(fn);
      return this;
    };

    /**
     * Set global after hook.
     *
     * @param {Function} fn
     */

    Router.prototype.afterEach = function afterEach(fn) {
      this._afterEachHooks.push(fn);
      return this;
    };

    /**
     * Navigate to a given path.
     * The path can be an object describing a named path in
     * the format of { name: '...', params: {}, query: {}}
     * The path is assumed to be already decoded, and will
     * be resolved against root (if provided)
     *
     * @param {String|Object} path
     * @param {Boolean} [replace]
     */

    Router.prototype.go = function go(path) {
      var replace = false;
      var append = false;
      if (Vue.util.isObject(path)) {
        replace = path.replace;
        append = path.append;
      }
      path = this.stringifyPath(path);
      if (path) {
        this.history.go(path, replace, append);
      }
    };

    /**
     * Short hand for replacing current path
     *
     * @param {String} path
     */

    Router.prototype.replace = function replace(path) {
      if (typeof path === 'string') {
        path = { path: path };
      }
      path.replace = true;
      this.go(path);
    };

    /**
     * Start the router.
     *
     * @param {VueConstructor} App
     * @param {String|Element} container
     * @param {Function} [cb]
     */

    Router.prototype.start = function start(App, container, cb) {
      /* istanbul ignore if */
      if (this._started) {
        warn$1('already started.');
        return;
      }
      this._started = true;
      this._startCb = cb;
      if (!this.app) {
        /* istanbul ignore if */
        if (!App || !container) {
          throw new Error('Must start vue-router with a component and a ' + 'root container.');
        }
        /* istanbul ignore if */
        if (App instanceof Vue) {
          throw new Error('Must start vue-router with a component, not a ' + 'Vue instance.');
        }
        this._appContainer = container;
        var Ctor = this._appConstructor = typeof App === 'function' ? App : Vue.extend(App);
        // give it a name for better debugging
        Ctor.options.name = Ctor.options.name || 'RouterApp';
      }

      // handle history fallback in browsers that do not
      // support HTML5 history API
      if (this._historyFallback) {
        var _location = window.location;
        var _history = new HTML5History({ root: this._root });
        var path = _history.root ? _location.pathname.replace(_history.rootRE, '') : _location.pathname;
        if (path && path !== '/') {
          _location.assign((_history.root || '') + '/' + this.history.formatPath(path) + _location.search);
          return;
        }
      }

      this.history.start();
    };

    /**
     * Stop listening to route changes.
     */

    Router.prototype.stop = function stop() {
      this.history.stop();
      this._started = false;
    };

    /**
     * Normalize named route object / string paths into
     * a string.
     *
     * @param {Object|String|Number} path
     * @return {String}
     */

    Router.prototype.stringifyPath = function stringifyPath(path) {
      var generatedPath = '';
      if (path && typeof path === 'object') {
        if (path.name) {
          var extend = Vue.util.extend;
          var currentParams = this._currentTransition && this._currentTransition.to.params;
          var targetParams = path.params || {};
          var params = currentParams ? extend(extend({}, currentParams), targetParams) : targetParams;
          generatedPath = encodeURI(this._recognizer.generate(path.name, params));
        } else if (path.path) {
          generatedPath = encodeURI(path.path);
        }
        if (path.query) {
          // note: the generated query string is pre-URL-encoded by the recognizer
          var query = this._recognizer.generateQueryString(path.query);
          if (generatedPath.indexOf('?') > -1) {
            generatedPath += '&' + query.slice(1);
          } else {
            generatedPath += query;
          }
        }
      } else {
        generatedPath = encodeURI(path ? path + '' : '');
      }
      return generatedPath;
    };

    // Internal methods ======================================

    /**
    * Add a route containing a list of segments to the internal
    * route recognizer. Will be called recursively to add all
    * possible sub-routes.
    *
    * @param {String} path
    * @param {Object} handler
    * @param {Array} segments
    */

    Router.prototype._addRoute = function _addRoute(path, handler, segments) {
      guardComponent(path, handler);
      handler.path = path;
      handler.fullPath = (segments.reduce(function (path, segment) {
        return path + segment.path;
      }, '') + path).replace('//', '/');
      segments.push({
        path: path,
        handler: handler
      });
      this._recognizer.add(segments, {
        as: handler.name
      });
      // add sub routes
      if (handler.subRoutes) {
        for (var subPath in handler.subRoutes) {
          // recursively walk all sub routes
          this._addRoute(subPath, handler.subRoutes[subPath],
          // pass a copy in recursion to avoid mutating
          // across branches
          segments.slice());
        }
      }
    };

    /**
     * Set the notFound route handler.
     *
     * @param {Object} handler
     */

    Router.prototype._notFound = function _notFound(handler) {
      guardComponent('*', handler);
      this._notFoundHandler = [{ handler: handler }];
    };

    /**
     * Add a redirect record.
     *
     * @param {String} path
     * @param {String} redirectPath
     */

    Router.prototype._addRedirect = function _addRedirect(path, redirectPath) {
      if (path === '*') {
        this._notFoundRedirect = redirectPath;
      } else {
        this._addGuard(path, redirectPath, this.replace);
      }
    };

    /**
     * Add an alias record.
     *
     * @param {String} path
     * @param {String} aliasPath
     */

    Router.prototype._addAlias = function _addAlias(path, aliasPath) {
      this._addGuard(path, aliasPath, this._match);
    };

    /**
     * Add a path guard.
     *
     * @param {String} path
     * @param {String} mappedPath
     * @param {Function} handler
     */

    Router.prototype._addGuard = function _addGuard(path, mappedPath, _handler) {
      var _this2 = this;

      this._guardRecognizer.add([{
        path: path,
        handler: function handler(match, query) {
          var realPath = mapParams(mappedPath, match.params, query);
          _handler.call(_this2, realPath);
        }
      }]);
    };

    /**
     * Check if a path matches any redirect records.
     *
     * @param {String} path
     * @return {Boolean} - if true, will skip normal match.
     */

    Router.prototype._checkGuard = function _checkGuard(path) {
      var matched = this._guardRecognizer.recognize(path, true);
      if (matched) {
        matched[0].handler(matched[0], matched.queryParams);
        return true;
      } else if (this._notFoundRedirect) {
        matched = this._recognizer.recognize(path);
        if (!matched) {
          this.replace(this._notFoundRedirect);
          return true;
        }
      }
    };

    /**
     * Match a URL path and set the route context on vm,
     * triggering view updates.
     *
     * @param {String} path
     * @param {Object} [state]
     * @param {String} [anchor]
     */

    Router.prototype._match = function _match(path, state, anchor) {
      var _this3 = this;

      if (this._checkGuard(path)) {
        return;
      }

      var currentRoute = this._currentRoute;
      var currentTransition = this._currentTransition;

      if (currentTransition) {
        if (currentTransition.to.path === path) {
          // do nothing if we have an active transition going to the same path
          return;
        } else if (currentRoute.path === path) {
          // We are going to the same path, but we also have an ongoing but
          // not-yet-validated transition. Abort that transition and reset to
          // prev transition.
          currentTransition.aborted = true;
          this._currentTransition = this._prevTransition;
          return;
        } else {
          // going to a totally different path. abort ongoing transition.
          currentTransition.aborted = true;
        }
      }

      // construct new route and transition context
      var route = new Route(path, this);
      var transition = new RouteTransition(this, route, currentRoute);

      // current transition is updated right now.
      // however, current route will only be updated after the transition has
      // been validated.
      this._prevTransition = currentTransition;
      this._currentTransition = transition;

      if (!this.app) {
        (function () {
          // initial render
          var router = _this3;
          _this3.app = new _this3._appConstructor({
            el: _this3._appContainer,
            created: function created() {
              this.$router = router;
            },
            _meta: {
              $route: route
            }
          });
        })();
      }

      // check global before hook
      var beforeHooks = this._beforeEachHooks;
      var startTransition = function startTransition() {
        transition.start(function () {
          _this3._postTransition(route, state, anchor);
        });
      };

      if (beforeHooks.length) {
        transition.runQueue(beforeHooks, function (hook, _, next) {
          if (transition === _this3._currentTransition) {
            transition.callHook(hook, null, next, {
              expectBoolean: true
            });
          }
        }, startTransition);
      } else {
        startTransition();
      }

      if (!this._rendered && this._startCb) {
        this._startCb.call(null);
      }

      // HACK:
      // set rendered to true after the transition start, so
      // that components that are acitvated synchronously know
      // whether it is the initial render.
      this._rendered = true;
    };

    /**
     * Set current to the new transition.
     * This is called by the transition object when the
     * validation of a route has succeeded.
     *
     * @param {Transition} transition
     */

    Router.prototype._onTransitionValidated = function _onTransitionValidated(transition) {
      // set current route
      var route = this._currentRoute = transition.to;
      // update route context for all children
      if (this.app.$route !== route) {
        this.app.$route = route;
        this._children.forEach(function (child) {
          child.$route = route;
        });
      }
      // call global after hook
      if (this._afterEachHooks.length) {
        this._afterEachHooks.forEach(function (hook) {
          return hook.call(null, {
            to: transition.to,
            from: transition.from
          });
        });
      }
      this._currentTransition.done = true;
    };

    /**
     * Handle stuff after the transition.
     *
     * @param {Route} route
     * @param {Object} [state]
     * @param {String} [anchor]
     */

    Router.prototype._postTransition = function _postTransition(route, state, anchor) {
      // handle scroll positions
      // saved scroll positions take priority
      // then we check if the path has an anchor
      var pos = state && state.pos;
      if (pos && this._saveScrollPosition) {
        Vue.nextTick(function () {
          window.scrollTo(pos.x, pos.y);
        });
      } else if (anchor) {
        Vue.nextTick(function () {
          var el = document.getElementById(anchor.slice(1));
          if (el) {
            window.scrollTo(window.scrollX, el.offsetTop);
          }
        });
      }
    };

    return Router;
  })();

  function guardComponent(path, handler) {
    var comp = handler.component;
    if (Vue.util.isPlainObject(comp)) {
      comp = handler.component = Vue.extend(comp);
    }
    /* istanbul ignore if */
    if (typeof comp !== 'function') {
      handler.component = null;
      warn$1('invalid component for route "' + path + '".');
    }
  }

  /* Installation */

  Router.installed = false;

  /**
   * Installation interface.
   * Install the necessary directives.
   */

  Router.install = function (externalVue) {
    /* istanbul ignore if */
    if (Router.installed) {
      warn$1('already installed.');
      return;
    }
    Vue = externalVue;
    applyOverride(Vue);
    View(Vue);
    Link(Vue);
    exports$1.Vue = Vue;
    Router.installed = true;
  };

  // auto install
  /* istanbul ignore if */
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Router);
  }

  return Router;

}));
},{}],131:[function(require,module,exports){
"use strict";

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = require("babel-runtime/core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperties = require("babel-runtime/core-js/object/define-properties");

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _preventExtensions = require("babel-runtime/core-js/object/prevent-extensions");

var _preventExtensions2 = _interopRequireDefault(_preventExtensions);

var _isExtensible = require("babel-runtime/core-js/object/is-extensible");

var _isExtensible2 = _interopRequireDefault(_isExtensible);

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _getOwnPropertyNames = require("babel-runtime/core-js/object/get-own-property-names");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) && "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? exports.VueSelect = e() : t.VueSelect = e();
}(undefined, function () {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;var o = n[r] = { exports: {}, id: r, loaded: !1 };return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }var n = {};return e.m = t, e.c = n, e.p = "/", e(0);
  }([function (t, e, n) {
    "use strict";
    function r(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 }), e.mixins = e.VueSelect = void 0;var o = n(85),
        i = r(o),
        s = n(41),
        u = r(s);e["default"] = i["default"], e.VueSelect = i["default"], e.mixins = u["default"];
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    t.exports = !n(9)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e) {
    var n = {}.hasOwnProperty;t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(11),
        o = n(33),
        i = n(25),
        s = _defineProperty2.default;e.f = n(2) ? _defineProperty2.default : function (t, e, n) {
      if (r(t), e = i(e, !0), r(n), o) try {
        return s(t, e, n);
      } catch (u) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    var r = n(59),
        o = n(16);t.exports = function (t) {
      return r(o(t));
    };
  }, function (t, e) {
    var n = t.exports = { version: "2.4.0" };"number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(4),
        o = n(14);t.exports = n(2) ? function (t, e, n) {
      return r.f(t, e, o(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e, n) {
    var r = n(23)("wks"),
        o = n(15),
        i = n(1).Symbol,
        s = "function" == typeof i,
        u = t.exports = function (t) {
      return r[t] || (r[t] = s && i[t] || (s ? i : o)("Symbol." + t));
    };u.store = r;
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (e) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var r = n(38),
        o = n(17);t.exports = _keys2.default || function (t) {
      return r(t, o);
    };
  }, function (t, e, n) {
    var r = n(13);t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, e, n) {
    var r = n(1),
        o = n(6),
        i = n(56),
        s = n(7),
        u = "prototype",
        a = function a(t, e, n) {
      var c,
          l,
          f,
          p = t & a.F,
          d = t & a.G,
          h = t & a.S,
          v = t & a.P,
          y = t & a.B,
          b = t & a.W,
          g = d ? o : o[e] || (o[e] = {}),
          m = g[u],
          x = d ? r : h ? r[e] : (r[e] || {})[u];d && (n = e);for (c in n) {
        l = !p && x && void 0 !== x[c], l && c in g || (f = l ? x[c] : n[c], g[c] = d && "function" != typeof x[c] ? n[c] : y && l ? i(f, r) : b && x[c] == f ? function (t) {
          var e = function e(_e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {case 0:
                  return new t();case 1:
                  return new t(_e);case 2:
                  return new t(_e, n);}return new t(_e, n, r);
            }return t.apply(this, arguments);
          };return e[u] = t[u], e;
        }(f) : v && "function" == typeof f ? i(Function.call, f) : f, v && ((g.virtual || (g.virtual = {}))[c] = f, t & a.R && m && !m[c] && s(m, c, f)));
      }
    };a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) ? null !== t : "function" == typeof t;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    var r = n(4).f,
        o = n(3),
        i = n(8)("toStringTag");t.exports = function (t, e, n) {
      t && !o(t = n ? t : t.prototype, i) && r(t, i, { configurable: !0, value: e });
    };
  }, function (t, e, n) {
    var r = n(23)("keys"),
        o = n(15);t.exports = function (t) {
      return r[t] || (r[t] = o(t));
    };
  }, function (t, e, n) {
    var r = n(1),
        o = "__core-js_shared__",
        i = r[o] || (r[o] = {});t.exports = function (t) {
      return i[t] || (i[t] = {});
    };
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    var r = n(13);t.exports = function (t, e) {
      if (!r(t)) return t;var n, o;if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    var r = n(1),
        o = n(6),
        i = n(19),
        s = n(27),
        u = n(4).f;t.exports = function (t) {
      var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {});"_" == t.charAt(0) || t in e || u(e, t, { value: s.f(t) });
    };
  }, function (t, e, n) {
    e.f = n(8);
  }, function (t, e) {
    "use strict";
    t.exports = { props: { loading: { type: Boolean, "default": !1 }, onSearch: { type: Function, "default": !1 }, debounce: { type: Number, "default": 0 } }, watch: { search: function search() {
          this.search.length > 0 && this.onSearch && this.onSearch(this.search, this.toggleLoading);
        } }, methods: { toggleLoading: function toggleLoading() {
          var t = arguments.length <= 0 || void 0 === arguments[0] ? null : arguments[0];return null == t ? this.loading = !this.loading : this.loading = t;
        } } };
  }, function (t, e) {
    "use strict";
    t.exports = { watch: { typeAheadPointer: function typeAheadPointer() {
          this.maybeAdjustScroll();
        } }, methods: { maybeAdjustScroll: function maybeAdjustScroll() {
          var t = this.pixelsToPointerTop(),
              e = this.pixelsToPointerBottom();return t <= this.viewport().top ? this.scrollTo(t) : e >= this.viewport().bottom ? this.scrollTo(this.viewport().top + this.pointerHeight()) : void 0;
        }, pixelsToPointerTop: function n() {
          for (var n = 0, t = 0; t < this.typeAheadPointer; t++) {
            n += this.$els.dropdownMenu.children[t].offsetHeight;
          }return n;
        }, pixelsToPointerBottom: function pixelsToPointerBottom() {
          return this.pixelsToPointerTop() + this.pointerHeight();
        }, pointerHeight: function pointerHeight() {
          var t = this.$els.dropdownMenu.children[this.typeAheadPointer];return t ? t.offsetHeight : 0;
        }, viewport: function viewport() {
          return { top: this.$els.dropdownMenu.scrollTop, bottom: this.$els.dropdownMenu.offsetHeight + this.$els.dropdownMenu.scrollTop };
        }, scrollTo: function scrollTo(t) {
          return this.$els.dropdownMenu.scrollTop = t;
        } } };
  }, function (t, e) {
    "use strict";
    t.exports = { data: function data() {
        return { typeAheadPointer: -1 };
      }, watch: { filteredOptions: function filteredOptions() {
          this.typeAheadPointer = 0;
        } }, methods: { typeAheadUp: function typeAheadUp() {
          this.typeAheadPointer > 0 && (this.typeAheadPointer--, this.maybeAdjustScroll && this.maybeAdjustScroll());
        }, typeAheadDown: function typeAheadDown() {
          this.typeAheadPointer < this.filteredOptions.length - 1 && (this.typeAheadPointer++, this.maybeAdjustScroll && this.maybeAdjustScroll());
        }, typeAheadSelect: function typeAheadSelect() {
          this.filteredOptions[this.typeAheadPointer] ? this.select(this.filteredOptions[this.typeAheadPointer]) : this.taggable && this.search.length && this.select(this.search), this.clearSearchOnSelect && (this.search = "");
        } } };
  }, function (t, e) {
    var n = {}.toString;t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e, n) {
    var r = n(13),
        o = n(1).document,
        i = r(o) && r(o.createElement);t.exports = function (t) {
      return i ? o.createElement(t) : {};
    };
  }, function (t, e, n) {
    t.exports = !n(2) && !n(9)(function () {
      return 7 != Object.defineProperty(n(32)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e, n) {
    "use strict";
    var r = n(19),
        o = n(12),
        i = n(39),
        s = n(7),
        u = n(3),
        a = n(18),
        c = n(61),
        l = n(21),
        f = n(68),
        p = n(8)("iterator"),
        d = !([].keys && "next" in [].keys()),
        h = "@@iterator",
        v = "keys",
        y = "values",
        b = function b() {
      return this;
    };t.exports = function (t, e, n, g, m, x, w) {
      c(n, e, g);var S,
          O,
          _,
          j = function j(t) {
        if (!d && t in E) return E[t];switch (t) {case v:
            return function () {
              return new n(this, t);
            };case y:
            return function () {
              return new n(this, t);
            };}return function () {
          return new n(this, t);
        };
      },
          A = e + " Iterator",
          P = m == y,
          k = !1,
          E = t.prototype,
          M = E[p] || E[h] || m && E[m],
          T = M || j(m),
          C = m ? P ? j("entries") : T : void 0,
          $ = "Array" == e ? E.entries || M : M;if ($ && (_ = f($.call(new t())), _ !== Object.prototype && (l(_, A, !0), r || u(_, p) || s(_, p, b))), P && M && M.name !== y && (k = !0, T = function T() {
        return M.call(this);
      }), r && !w || !d && !k && E[p] || s(E, p, T), a[e] = T, a[A] = b, m) if (S = { values: P ? T : j(y), keys: x ? T : j(v), entries: C }, w) for (O in S) {
        O in E || i(E, O, S[O]);
      } else o(o.P + o.F * (d || k), e, S);return S;
    };
  }, function (t, e, n) {
    var r = n(11),
        o = n(65),
        i = n(17),
        s = n(22)("IE_PROTO"),
        u = function u() {},
        a = "prototype",
        _c = function c() {
      var t,
          e = n(32)("iframe"),
          r = i.length,
          o = ">";for (e.style.display = "none", n(58).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object</script" + o), t.close(), _c = t.F; r--;) {
        delete _c[a][i[r]];
      }return _c();
    };t.exports = _create2.default || function (t, e) {
      var n;return null !== t ? (u[a] = r(t), n = new u(), u[a] = null, n[s] = t) : n = _c(), void 0 === e ? n : o(n, e);
    };
  }, function (t, e, n) {
    var r = n(38),
        o = n(17).concat("length", "prototype");e.f = _getOwnPropertyNames2.default || function (t) {
      return r(t, o);
    };
  }, function (t, e) {
    e.f = _getOwnPropertySymbols2.default;
  }, function (t, e, n) {
    var r = n(3),
        o = n(5),
        i = n(55)(!1),
        s = n(22)("IE_PROTO");t.exports = function (t, e) {
      var n,
          u = o(t),
          a = 0,
          c = [];for (n in u) {
        n != s && r(u, n) && c.push(n);
      }for (; e.length > a;) {
        r(u, n = e[a++]) && (~i(c, n) || c.push(n));
      }return c;
    };
  }, function (t, e, n) {
    t.exports = n(7);
  }, function (t, e, n) {
    var r = n(16);t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = n(28),
        i = r(o),
        s = n(30),
        u = r(s),
        a = n(29),
        c = r(a);e["default"] = { ajax: i["default"], pointer: u["default"], pointerScroll: c["default"] };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      return t && t.__esModule ? t : { "default": t };
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = n(44),
        i = r(o),
        s = n(47),
        u = r(s),
        a = n(48),
        c = r(a),
        l = n(29),
        f = r(l),
        p = n(30),
        d = r(p),
        h = n(28),
        v = r(h);e["default"] = { mixins: [f["default"], d["default"], v["default"]], props: { value: { "default": null }, options: { type: Array, "default": function _default() {
            return [];
          } }, maxHeight: { type: String, "default": "400px" }, searchable: { type: Boolean, "default": !0 }, multiple: { type: Boolean, "default": !1 }, placeholder: { type: String, "default": "" }, transition: { type: String, "default": "expand" }, clearSearchOnSelect: { type: Boolean, "default": !0 }, label: { type: String, "default": "label" }, getOptionLabel: { type: Function, "default": function _default(t) {
            return "object" === ("undefined" == typeof t ? "undefined" : (0, c["default"])(t)) && this.label && t[this.label] ? t[this.label] : t;
          } }, onChange: Function, taggable: { type: Boolean, "default": !1 }, pushTags: { type: Boolean, "default": !1 }, createOption: { type: Function, "default": function _default(t) {
            return "object" === (0, c["default"])(this.options[0]) ? (0, u["default"])({}, this.label, t) : t;
          } }, resetOnOptionsChange: { type: Boolean, "default": !1 } }, data: function data() {
        return { search: "", open: !1 };
      }, watch: { value: function value(t, e) {
          this.multiple ? this.onChange ? this.onChange(t) : null : this.onChange && t !== e ? this.onChange(t) : null;
        }, options: function options() {
          !this.taggable && this.resetOnOptionsChange && this.$set("value", this.multiple ? [] : null);
        }, multiple: function multiple(t) {
          this.$set("value", t ? [] : null);
        } }, methods: { select: function select(t) {
          this.isOptionSelected(t) ? this.deselect(t) : (this.taggable && !this.optionExists(t) && (t = this.createOption(t), this.pushTags && this.options.push(t)), this.multiple ? this.value ? this.value.push(t) : this.$set("value", [t]) : this.value = t), this.onAfterSelect(t);
        }, deselect: function deselect(t) {
          var e = this;if (this.multiple) {
            var n = -1;this.value.forEach(function (r) {
              (r === t || "object" === ("undefined" == typeof r ? "undefined" : (0, c["default"])(r)) && r[e.label] === t[e.label]) && (n = r);
            }), this.value.$remove(n);
          } else this.value = null;
        }, onAfterSelect: function onAfterSelect(t) {
          this.multiple || (this.open = !this.open, this.$els.search.blur()), this.clearSearchOnSelect && (this.search = "");
        }, toggleDropdown: function toggleDropdown(t) {
          t.target !== this.$els.openIndicator && t.target !== this.$els.search && t.target !== this.$els.toggle && t.target !== this.$el || (this.open ? this.$els.search.blur() : (this.open = !0, this.$els.search.focus()));
        }, isOptionSelected: function isOptionSelected(t) {
          var e = this;if (this.multiple && this.value) {
            var n = !1;return this.value.forEach(function (r) {
              "object" === ("undefined" == typeof r ? "undefined" : (0, c["default"])(r)) && r[e.label] === t[e.label] ? n = !0 : r === t && (n = !0);
            }), n;
          }return this.value === t;
        }, onEscape: function onEscape() {
          this.search.length ? this.search = "" : this.$els.search.blur();
        }, maybeDeleteValue: function maybeDeleteValue() {
          if (!this.$els.search.value.length && this.value) return this.multiple ? this.value.pop() : this.$set("value", null);
        }, optionExists: function optionExists(t) {
          var e = this,
              n = !1;return this.options.forEach(function (r) {
            "object" === ("undefined" == typeof r ? "undefined" : (0, c["default"])(r)) && r[e.label] === t ? n = !0 : r === t && (n = !0);
          }), n;
        } }, computed: { dropdownClasses: function dropdownClasses() {
          return { open: this.open, searchable: this.searchable, loading: this.loading };
        }, searchPlaceholder: function searchPlaceholder() {
          if (this.isValueEmpty && this.placeholder) return this.placeholder;
        }, filteredOptions: function filteredOptions() {
          var t = this.$options.filters.filterBy(this.options, this.search);return this.taggable && this.search.length && !this.optionExists(this.search) && t.unshift(this.search), t;
        }, isValueEmpty: function isValueEmpty() {
          return !this.value || ("object" === (0, c["default"])(this.value) ? !(0, i["default"])(this.value).length : !this.value.length);
        }, valueAsArray: function valueAsArray() {
          return this.multiple ? this.value : this.value ? [this.value] : [];
        } } };
  }, function (t, e, n) {
    t.exports = { "default": n(49), __esModule: !0 };
  }, function (t, e, n) {
    t.exports = { "default": n(50), __esModule: !0 };
  }, function (t, e, n) {
    t.exports = { "default": n(51), __esModule: !0 };
  }, function (t, e, n) {
    t.exports = { "default": n(52), __esModule: !0 };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      return t && t.__esModule ? t : { "default": t };
    }e.__esModule = !0;var o = n(43),
        i = r(o);e["default"] = function (t, e, n) {
      return e in t ? (0, i["default"])(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      return t && t.__esModule ? t : { "default": t };
    }e.__esModule = !0;var o = n(46),
        i = r(o),
        s = n(45),
        u = r(s),
        a = "function" == typeof u["default"] && "symbol" == (0, _typeof3.default)(i["default"]) ? function (t) {
      return typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t);
    } : function (t) {
      return t && "function" == typeof u["default"] && t.constructor === u["default"] ? "symbol" : typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t);
    };e["default"] = "function" == typeof u["default"] && "symbol" === a(i["default"]) ? function (t) {
      return "undefined" == typeof t ? "undefined" : a(t);
    } : function (t) {
      return t && "function" == typeof u["default"] && t.constructor === u["default"] ? "symbol" : "undefined" == typeof t ? "undefined" : a(t);
    };
  }, function (t, e, n) {
    n(74);var r = n(6).Object;t.exports = function (t, e, n) {
      return r.defineProperty(t, e, n);
    };
  }, function (t, e, n) {
    n(75), t.exports = n(6).Object.keys;
  }, function (t, e, n) {
    n(78), n(76), n(79), n(80), t.exports = n(6).Symbol;
  }, function (t, e, n) {
    n(77), n(81), t.exports = n(27).f("iterator");
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e, n) {
    var r = n(5),
        o = n(72),
        i = n(71);t.exports = function (t) {
      return function (e, n, s) {
        var u,
            a = r(e),
            c = o(a.length),
            l = i(s, c);if (t && n != n) {
          for (; c > l;) {
            if (u = a[l++], u != u) return !0;
          }
        } else for (; c > l; l++) {
          if ((t || l in a) && a[l] === n) return t || l || 0;
        }return !t && -1;
      };
    };
  }, function (t, e, n) {
    var r = n(53);t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;switch (n) {case 1:
          return function (n) {
            return t.call(e, n);
          };case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };}return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(10),
        o = n(37),
        i = n(20);t.exports = function (t) {
      var e = r(t),
          n = o.f;if (n) for (var s, u = n(t), a = i.f, c = 0; u.length > c;) {
        a.call(t, s = u[c++]) && e.push(s);
      }return e;
    };
  }, function (t, e, n) {
    t.exports = n(1).document && document.documentElement;
  }, function (t, e, n) {
    var r = n(31);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e, n) {
    var r = n(31);t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(35),
        o = n(14),
        i = n(21),
        s = {};n(7)(s, n(8)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(s, { next: o(1, n) }), i(t, e + " Iterator");
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return { value: e, done: !!t };
    };
  }, function (t, e, n) {
    var r = n(10),
        o = n(5);t.exports = function (t, e) {
      for (var n, i = o(t), s = r(i), u = s.length, a = 0; u > a;) {
        if (i[n = s[a++]] === e) return n;
      }
    };
  }, function (t, e, n) {
    var r = n(15)("meta"),
        o = n(13),
        i = n(3),
        s = n(4).f,
        u = 0,
        a = _isExtensible2.default || function () {
      return !0;
    },
        c = !n(9)(function () {
      return a((0, _preventExtensions2.default)({}));
    }),
        l = function l(t) {
      s(t, r, { value: { i: "O" + ++u, w: {} } });
    },
        f = function f(t, e) {
      if (!o(t)) return "symbol" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) ? t : ("string" == typeof t ? "S" : "P") + t;if (!i(t, r)) {
        if (!a(t)) return "F";if (!e) return "E";l(t);
      }return t[r].i;
    },
        p = function p(t, e) {
      if (!i(t, r)) {
        if (!a(t)) return !0;if (!e) return !1;l(t);
      }return t[r].w;
    },
        d = function d(t) {
      return c && h.NEED && a(t) && !i(t, r) && l(t), t;
    },
        h = t.exports = { KEY: r, NEED: !1, fastKey: f, getWeak: p, onFreeze: d };
  }, function (t, e, n) {
    var r = n(4),
        o = n(11),
        i = n(10);t.exports = n(2) ? _defineProperties2.default : function (t, e) {
      o(t);for (var n, s = i(e), u = s.length, a = 0; u > a;) {
        r.f(t, n = s[a++], e[n]);
      }return t;
    };
  }, function (t, e, n) {
    var r = n(20),
        o = n(14),
        i = n(5),
        s = n(25),
        u = n(3),
        a = n(33),
        c = _getOwnPropertyDescriptor2.default;e.f = n(2) ? c : function (t, e) {
      if (t = i(t), e = s(e, !0), a) try {
        return c(t, e);
      } catch (n) {}if (u(t, e)) return o(!r.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var r = n(5),
        o = n(36).f,
        i = {}.toString,
        s = "object" == (typeof window === "undefined" ? "undefined" : (0, _typeof3.default)(window)) && window && _getOwnPropertyNames2.default ? (0, _getOwnPropertyNames2.default)(window) : [],
        u = function u(t) {
      try {
        return o(t);
      } catch (e) {
        return s.slice();
      }
    };t.exports.f = function (t) {
      return s && "[object Window]" == i.call(t) ? u(t) : o(r(t));
    };
  }, function (t, e, n) {
    var r = n(3),
        o = n(40),
        i = n(22)("IE_PROTO"),
        s = Object.prototype;t.exports = _getPrototypeOf2.default || function (t) {
      return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
    };
  }, function (t, e, n) {
    var r = n(12),
        o = n(6),
        i = n(9);t.exports = function (t, e) {
      var n = (o.Object || {})[t] || Object[t],
          s = {};s[t] = e(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", s);
    };
  }, function (t, e, n) {
    var r = n(24),
        o = n(16);t.exports = function (t) {
      return function (e, n) {
        var i,
            s,
            u = String(o(e)),
            a = r(n),
            c = u.length;return a < 0 || a >= c ? t ? "" : void 0 : (i = u.charCodeAt(a), i < 55296 || i > 56319 || a + 1 === c || (s = u.charCodeAt(a + 1)) < 56320 || s > 57343 ? t ? u.charAt(a) : i : t ? u.slice(a, a + 2) : (i - 55296 << 10) + (s - 56320) + 65536);
      };
    };
  }, function (t, e, n) {
    var r = n(24),
        o = Math.max,
        i = Math.min;t.exports = function (t, e) {
      return t = r(t), t < 0 ? o(t + e, 0) : i(t, e);
    };
  }, function (t, e, n) {
    var r = n(24),
        o = Math.min;t.exports = function (t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(54),
        o = n(62),
        i = n(18),
        s = n(5);t.exports = n(34)(Array, "Array", function (t, e) {
      this._t = s(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;return !t || n >= t.length ? (this._t = void 0, o(1)) : "keys" == e ? o(0, n) : "values" == e ? o(0, t[n]) : o(0, [n, t[n]]);
    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
  }, function (t, e, n) {
    var r = n(12);r(r.S + r.F * !n(2), "Object", { defineProperty: n(4).f });
  }, function (t, e, n) {
    var r = n(40),
        o = n(10);n(69)("keys", function () {
      return function (t) {
        return o(r(t));
      };
    });
  }, function (t, e) {}, function (t, e, n) {
    "use strict";
    var r = n(70)(!0);n(34)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          e = this._t,
          n = this._i;return n >= e.length ? { value: void 0, done: !0 } : (t = r(e, n), this._i += t.length, { value: t, done: !1 });
    });
  }, function (t, e, n) {
    "use strict";
    var r = n(1),
        o = n(3),
        i = n(2),
        s = n(12),
        u = n(39),
        a = n(64).KEY,
        c = n(9),
        l = n(23),
        f = n(21),
        p = n(15),
        d = n(8),
        h = n(27),
        v = n(26),
        y = n(63),
        b = n(57),
        g = n(60),
        m = n(11),
        x = n(5),
        w = n(25),
        S = n(14),
        O = n(35),
        _ = n(67),
        j = n(66),
        A = n(4),
        P = n(10),
        k = j.f,
        E = A.f,
        M = _.f,
        _T = r.Symbol,
        C = r.JSON,
        $ = C && C.stringify,
        F = "prototype",
        N = d("_hidden"),
        B = d("toPrimitive"),
        I = {}.propertyIsEnumerable,
        L = l("symbol-registry"),
        z = l("symbols"),
        D = l("op-symbols"),
        V = Object[F],
        R = "function" == typeof _T,
        H = r.QObject,
        U = !H || !H[F] || !H[F].findChild,
        W = i && c(function () {
      return 7 != O(E({}, "a", { get: function get() {
          return E(this, "a", { value: 7 }).a;
        } })).a;
    }) ? function (t, e, n) {
      var r = k(V, e);r && delete V[e], E(t, e, n), r && t !== V && E(V, e, r);
    } : E,
        J = function J(t) {
      var e = z[t] = O(_T[F]);return e._k = t, e;
    },
        G = R && "symbol" == (0, _typeof3.default)(_T.iterator) ? function (t) {
      return "symbol" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t));
    } : function (t) {
      return t instanceof _T;
    },
        K = function K(t, e, n) {
      return t === V && K(D, e, n), m(t), e = w(e, !0), m(n), o(z, e) ? (n.enumerable ? (o(t, N) && t[N][e] && (t[N][e] = !1), n = O(n, { enumerable: S(0, !1) })) : (o(t, N) || E(t, N, S(1, {})), t[N][e] = !0), W(t, e, n)) : E(t, e, n);
    },
        Y = function Y(t, e) {
      m(t);for (var n, r = b(e = x(e)), o = 0, i = r.length; i > o;) {
        K(t, n = r[o++], e[n]);
      }return t;
    },
        Z = function Z(t, e) {
      return void 0 === e ? O(t) : Y(O(t), e);
    },
        Q = function Q(t) {
      var e = I.call(this, t = w(t, !0));return !(this === V && o(z, t) && !o(D, t)) && (!(e || !o(this, t) || !o(z, t) || o(this, N) && this[N][t]) || e);
    },
        q = function q(t, e) {
      if (t = x(t), e = w(e, !0), t !== V || !o(z, e) || o(D, e)) {
        var n = k(t, e);return !n || !o(z, e) || o(t, N) && t[N][e] || (n.enumerable = !0), n;
      }
    },
        X = function X(t) {
      for (var e, n = M(x(t)), r = [], i = 0; n.length > i;) {
        o(z, e = n[i++]) || e == N || e == a || r.push(e);
      }return r;
    },
        tt = function tt(t) {
      for (var e, n = t === V, r = M(n ? D : x(t)), i = [], s = 0; r.length > s;) {
        !o(z, e = r[s++]) || n && !o(V, e) || i.push(z[e]);
      }return i;
    };R || (_T = function T() {
      if (this instanceof _T) throw TypeError("Symbol is not a constructor!");var t = p(arguments.length > 0 ? arguments[0] : void 0),
          e = function e(n) {
        this === V && e.call(D, n), o(this, N) && o(this[N], t) && (this[N][t] = !1), W(this, t, S(1, n));
      };return i && U && W(V, t, { configurable: !0, set: e }), J(t);
    }, u(_T[F], "toString", function () {
      return this._k;
    }), j.f = q, A.f = K, n(36).f = _.f = X, n(20).f = Q, n(37).f = tt, i && !n(19) && u(V, "propertyIsEnumerable", Q, !0), h.f = function (t) {
      return J(d(t));
    }), s(s.G + s.W + s.F * !R, { Symbol: _T });for (var et = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), nt = 0; et.length > nt;) {
      d(et[nt++]);
    }for (var et = P(d.store), nt = 0; et.length > nt;) {
      v(et[nt++]);
    }s(s.S + s.F * !R, "Symbol", { "for": function _for(t) {
        return o(L, t += "") ? L[t] : L[t] = _T(t);
      }, keyFor: function keyFor(t) {
        if (G(t)) return y(L, t);throw TypeError(t + " is not a symbol!");
      }, useSetter: function useSetter() {
        U = !0;
      }, useSimple: function useSimple() {
        U = !1;
      } }), s(s.S + s.F * !R, "Object", { create: Z, defineProperty: K, defineProperties: Y, getOwnPropertyDescriptor: q, getOwnPropertyNames: X, getOwnPropertySymbols: tt }), C && s(s.S + s.F * (!R || c(function () {
      var t = _T();return "[null]" != $([t]) || "{}" != $({ a: t }) || "{}" != $(Object(t));
    })), "JSON", { stringify: function stringify(t) {
        if (void 0 !== t && !G(t)) {
          for (var e, n, r = [t], o = 1; arguments.length > o;) {
            r.push(arguments[o++]);
          }return e = r[1], "function" == typeof e && (n = e), !n && g(e) || (e = function e(t, _e2) {
            if (n && (_e2 = n.call(this, t, _e2)), !G(_e2)) return _e2;
          }), r[1] = e, $.apply(C, r);
        }
      } }), _T[F][B] || n(7)(_T[F], B, _T[F].valueOf), f(_T, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
  }, function (t, e, n) {
    n(26)("asyncIterator");
  }, function (t, e, n) {
    n(26)("observable");
  }, function (t, e, n) {
    n(73);for (var r = n(1), o = n(7), i = n(18), s = n(8)("toStringTag"), u = ["NodeList", "DOMTokenList", "MediaList", "StyleSheetList", "CSSRuleList"], a = 0; a < 5; a++) {
      var c = u[a],
          l = r[c],
          f = l && l.prototype;f && !f[s] && o(f, s, c), i[c] = i.Array;
    }
  }, function (t, e, n) {
    e = t.exports = n(83)(), e.push([t.id, ".v-select{position:relative}.v-select .open-indicator{position:absolute;bottom:6px;right:10px;display:inline-block;cursor:pointer;pointer-events:all;-webkit-transition:all .15s cubic-bezier(1,-.115,.975,.855);transition:all .15s cubic-bezier(1,-.115,.975,.855);-webkit-transition-timing-function:cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855);opacity:1;-webkit-transition:opacity .1s;transition:opacity .1s}.v-select.loading .open-indicator{opacity:0}.v-select .open-indicator:before{border-color:rgba(60,60,60,.5);border-style:solid;border-width:.25em .25em 0 0;content:'';display:inline-block;height:10px;width:10px;vertical-align:top;-webkit-transform:rotate(133deg);transform:rotate(133deg);-webkit-transition:all .15s cubic-bezier(1,-.115,.975,.855);transition:all .15s cubic-bezier(1,-.115,.975,.855);-webkit-transition-timing-function:cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.v-select.open .open-indicator{bottom:1px}.v-select.open .open-indicator:before{-webkit-transform:rotate(315deg);transform:rotate(315deg)}.v-select .dropdown-toggle{display:block;padding:0;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.v-select.searchable .dropdown-toggle{cursor:text}.v-select.open .dropdown-toggle{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.v-select>.dropdown-menu{margin:0;width:100%;overflow-y:scroll;border-top:none;border-top-left-radius:0;border-top-right-radius:0}.v-select .selected-tag{color:#333;background-color:#f0f0f0;border:1px solid #ccc;border-radius:4px;height:26px;margin:4px 1px 0 3px;padding:0 .25em;float:left;line-height:1.7em}.v-select .selected-tag .close{float:none;margin-right:0;font-size:20px}.v-select input[type=search],.v-select input[type=search]:focus{display:inline-block;border:none;outline:none;margin:0;padding:0 .5em;width:10em;max-width:100%;background:none;position:relative;box-shadow:none;float:left;clear:none}.v-select input[type=search]:disabled,.v-select li a{cursor:pointer}.v-select .active a{background:rgba(50,50,50,.1);color:#333}.v-select .highlight a,.v-select li:hover>a{background:#f0f0f0;color:#333}.v-select .spinner{opacity:0;position:absolute;top:5px;right:10px;font-size:5px;text-indent:-9999em;overflow:hidden;border-top:.9em solid hsla(0,0%,39%,.1);border-right:.9em solid hsla(0,0%,39%,.1);border-bottom:.9em solid hsla(0,0%,39%,.1);border-left:.9em solid rgba(60,60,60,.45);-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s infinite linear;animation:vSelectSpinner 1.1s infinite linear;-webkit-transition:opacity .1s;transition:opacity .1s}.v-select.loading .spinner{opacity:1}.v-select .spinner,.v-select .spinner:after{border-radius:50%;width:5em;height:5em}@-webkit-keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
  }, function (t, e) {
    t.exports = function () {
      var t = [];return t.toString = function () {
        for (var t = [], e = 0; e < this.length; e++) {
          var n = this[e];n[2] ? t.push("@media " + n[2] + "{" + n[1] + "}") : t.push(n[1]);
        }return t.join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];"number" == typeof i && (r[i] = !0);
        }for (o = 0; o < e.length; o++) {
          var s = e[o];"number" == typeof s[0] && r[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), t.push(s));
        }
      }, t;
    };
  }, function (t, e) {
    t.exports = ' <div class="dropdown v-select" :class=dropdownClasses> <div v-el:toggle @mousedown.prevent=toggleDropdown class="dropdown-toggle clearfix" type=button> <span class=form-control v-if="!searchable && isValueEmpty"> {{ placeholder }} </span> <span class=selected-tag v-for="option in valueAsArray" track-by=$index> {{ getOptionLabel(option) }} <button v-if=multiple @click=select(option) type=button class=close> <span aria-hidden=true>&times;</span> </button> </span> <input v-el:search :debounce=debounce v-model=search v-show=searchable @keydown.delete=maybeDeleteValue @keyup.esc=onEscape @keydown.up.prevent=typeAheadUp @keydown.down.prevent=typeAheadDown @keyup.enter.prevent=typeAheadSelect @blur="open = false" @focus="open = true" type=search class=form-control :placeholder=searchPlaceholder :style="{ width: isValueEmpty ? \'100%\' : \'auto\' }"> <i v-el:open-indicator role=presentation class=open-indicator></i> <slot name=spinner> <div class=spinner v-show="onSearch && loading">Loading...</div> </slot> </div> <ul v-el:dropdown-menu v-show=open :transition=transition class=dropdown-menu :style="{ \'max-height\': maxHeight }"> <li v-for="option in filteredOptions" track-by=$index :class="{ active: isOptionSelected(option), highlight: $index === typeAheadPointer }" @mouseover="typeAheadPointer = $index"> <a @mousedown.prevent=select(option)> {{ getOptionLabel(option) }} </a> </li> <li transition=fade v-if=!filteredOptions.length class=divider></li> <li transition=fade v-if=!filteredOptions.length class=text-center> <slot name=no-options>Sorry, no matching options.</slot> </li> </ul> </div> ';
  }, function (t, e, n) {
    var r, o;n(87), r = n(42), o = n(84), t.exports = r || {}, t.exports.__esModule && (t.exports = t.exports["default"]), o && (("function" == typeof t.exports ? t.exports.options || (t.exports.options = {}) : t.exports).template = o);
  }, function (t, e, n) {
    function r(t, e) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
            o = f[r.id];if (o) {
          o.refs++;for (var i = 0; i < o.parts.length; i++) {
            o.parts[i](r.parts[i]);
          }for (; i < r.parts.length; i++) {
            o.parts.push(a(r.parts[i], e));
          }
        } else {
          for (var s = [], i = 0; i < r.parts.length; i++) {
            s.push(a(r.parts[i], e));
          }f[r.id] = { id: r.id, refs: 1, parts: s };
        }
      }
    }function o(t) {
      for (var e = [], n = {}, r = 0; r < t.length; r++) {
        var o = t[r],
            i = o[0],
            s = o[1],
            u = o[2],
            a = o[3],
            c = { css: s, media: u, sourceMap: a };n[i] ? n[i].parts.push(c) : e.push(n[i] = { id: i, parts: [c] });
      }return e;
    }function i(t, e) {
      var n = h(),
          r = b[b.length - 1];if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), b.push(e);else {
        if ("bottom" !== t.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e);
      }
    }function s(t) {
      t.parentNode.removeChild(t);var e = b.indexOf(t);e >= 0 && b.splice(e, 1);
    }function u(t) {
      var e = document.createElement("style");return e.type = "text/css", i(t, e), e;
    }function a(t, e) {
      var n, r, o;if (e.singleton) {
        var i = y++;n = v || (v = u(e)), r = c.bind(null, n, i, !1), o = c.bind(null, n, i, !0);
      } else n = u(e), r = l.bind(null, n), o = function o() {
        s(n);
      };return r(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;r(t = e);
        } else o();
      };
    }function c(t, e, n, r) {
      var o = n ? "" : r.css;if (t.styleSheet) t.styleSheet.cssText = g(e, o);else {
        var i = document.createTextNode(o),
            s = t.childNodes;s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(i, s[e]) : t.appendChild(i);
      }
    }function l(t, e) {
      var n = e.css,
          r = e.media,
          o = e.sourceMap;if (r && t.setAttribute("media", r), o && (n += "\n/*# sourceURL=" + o.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent((0, _stringify2.default)(o)))) + " */"), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }t.appendChild(document.createTextNode(n));
      }
    }var f = {},
        p = function p(t) {
      var e;return function () {
        return "undefined" == typeof e && (e = t.apply(this, arguments)), e;
      };
    },
        d = p(function () {
      return (/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
      );
    }),
        h = p(function () {
      return document.head || document.getElementsByTagName("head")[0];
    }),
        v = null,
        y = 0,
        b = [];t.exports = function (t, e) {
      e = e || {}, "undefined" == typeof e.singleton && (e.singleton = d()), "undefined" == typeof e.insertAt && (e.insertAt = "bottom");var n = o(t);return r(n, e), function (t) {
        for (var i = [], s = 0; s < n.length; s++) {
          var u = n[s],
              a = f[u.id];a.refs--, i.push(a);
        }if (t) {
          var c = o(t);r(c, e);
        }for (var s = 0; s < i.length; s++) {
          var a = i[s];if (0 === a.refs) {
            for (var l = 0; l < a.parts.length; l++) {
              a.parts[l]();
            }delete f[a.id];
          }
        }
      };
    };var g = function () {
      var t = [];return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();
  }, function (t, e, n) {
    var r = n(82);"string" == typeof r && (r = [[t.id, r, ""]]);n(86)(r, {});r.locals && (t.exports = r.locals);
  }]);
});

},{"babel-runtime/core-js/json/stringify":1,"babel-runtime/core-js/object/create":2,"babel-runtime/core-js/object/define-properties":3,"babel-runtime/core-js/object/define-property":4,"babel-runtime/core-js/object/get-own-property-descriptor":5,"babel-runtime/core-js/object/get-own-property-names":6,"babel-runtime/core-js/object/get-own-property-symbols":7,"babel-runtime/core-js/object/get-prototype-of":8,"babel-runtime/core-js/object/is-extensible":9,"babel-runtime/core-js/object/keys":10,"babel-runtime/core-js/object/prevent-extensions":11,"babel-runtime/helpers/typeof":16}],132:[function(require,module,exports){
(function (process){
/*!
 * Vue.js v1.0.28
 * (c) 2016 Evan You
 * Released under the MIT License.
 */
'use strict';

function set(obj, key, val) {
  if (hasOwn(obj, key)) {
    obj[key] = val;
    return;
  }
  if (obj._isVue) {
    set(obj._data, key, val);
    return;
  }
  var ob = obj.__ob__;
  if (!ob) {
    obj[key] = val;
    return;
  }
  ob.convert(key, val);
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._proxy(key);
      vm._digest();
    }
  }
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 *
 * @param {Object} obj
 * @param {String} key
 */

function del(obj, key) {
  if (!hasOwn(obj, key)) {
    return;
  }
  delete obj[key];
  var ob = obj.__ob__;
  if (!ob) {
    if (obj._isVue) {
      delete obj._data[key];
      obj._digest();
    }
    return;
  }
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._unproxy(key);
      vm._digest();
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check whether the object has the property.
 *
 * @param {Object} obj
 * @param {String} key
 * @return {Boolean}
 */

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Check if an expression is a literal value.
 *
 * @param {String} exp
 * @return {Boolean}
 */

var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;

function isLiteral(exp) {
  return literalValueRE.test(exp);
}

/**
 * Check if a string starts with $ or _
 *
 * @param {String} str
 * @return {Boolean}
 */

function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Guard text output, make sure undefined outputs
 * empty string
 *
 * @param {*} value
 * @return {String}
 */

function _toString(value) {
  return value == null ? '' : value.toString();
}

/**
 * Check and convert possible numeric strings to numbers
 * before setting back to data
 *
 * @param {*} value
 * @return {*|Number}
 */

function toNumber(value) {
  if (typeof value !== 'string') {
    return value;
  } else {
    var parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
  }
}

/**
 * Convert string boolean literals into real booleans.
 *
 * @param {*} value
 * @return {*|Boolean}
 */

function toBoolean(value) {
  return value === 'true' ? true : value === 'false' ? false : value;
}

/**
 * Strip quotes from a string
 *
 * @param {String} str
 * @return {String | false}
 */

function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}

/**
 * Camelize a hyphen-delimited string.
 *
 * @param {String} str
 * @return {String}
 */

var camelizeRE = /-(\w)/g;

function camelize(str) {
  return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
  return c ? c.toUpperCase() : '';
}

/**
 * Hyphenate a camelCase string.
 *
 * @param {String} str
 * @return {String}
 */

var hyphenateRE = /([^-])([A-Z])/g;

function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}

/**
 * Converts hyphen/underscore/slash delimitered names into
 * camelized classNames.
 *
 * e.g. my-component => MyComponent
 *      some_else    => SomeElse
 *      some/comp    => SomeComp
 *
 * @param {String} str
 * @return {String}
 */

var classifyRE = /(?:^|[-_\/])(\w)/g;

function classify(str) {
  return str.replace(classifyRE, toUpper);
}

/**
 * Simple bind, faster than native
 *
 * @param {Function} fn
 * @param {Object} ctx
 * @return {Function}
 */

function bind(fn, ctx) {
  return function (a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  };
}

/**
 * Convert an Array-like object to a real Array.
 *
 * @param {Array-like} list
 * @param {Number} [start] - start index
 * @return {Array}
 */

function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 *
 * @param {Object} to
 * @param {Object} from
 */

function extend(to, from) {
  var keys = Object.keys(from);
  var i = keys.length;
  while (i--) {
    to[keys[i]] = from[keys[i]];
  }
  return to;
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';

function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}

/**
 * Array type check.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var isArray = Array.isArray;

/**
 * Define a property.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 * @param {Boolean} [enumerable]
 */

function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Debounce a function so it only gets called after the
 * input stops arriving after the given wait period.
 *
 * @param {Function} func
 * @param {Number} wait
 * @return {Function} - the debounced function
 */

function _debounce(func, wait) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    }
  };
  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
}

/**
 * Manual indexOf because it's slightly faster than
 * native.
 *
 * @param {Array} arr
 * @param {*} obj
 */

function indexOf(arr, obj) {
  var i = arr.length;
  while (i--) {
    if (arr[i] === obj) return i;
  }
  return -1;
}

/**
 * Make a cancellable version of an async callback.
 *
 * @param {Function} fn
 * @return {Function}
 */

function cancellable(fn) {
  var cb = function cb() {
    if (!cb.cancelled) {
      return fn.apply(this, arguments);
    }
  };
  cb.cancel = function () {
    cb.cancelled = true;
  };
  return cb;
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 *
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 */

function looseEqual(a, b) {
  /* eslint-disable eqeqeq */
  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
  /* eslint-enable eqeqeq */
}

var hasProto = ('__proto__' in {});

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

// UA sniffing for working around browser-specific quirks
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && UA.indexOf('trident') > 0;
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

var transitionProp = undefined;
var transitionEndEvent = undefined;
var animationProp = undefined;
var animationEndEvent = undefined;

// Transition property/event sniffing
if (inBrowser && !isIE9) {
  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
}

/* istanbul ignore next */
function isNative(Ctor) {
  return (/native code/.test(Ctor.toString())
  );
}

/**
 * Defer a task to execute it asynchronously. Ideally this
 * should be executed as a microtask, so we leverage
 * MutationObserver if it's available, and fallback to
 * setTimeout(0).
 *
 * @param {Function} cb
 * @param {Object} ctx
 */

var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc = undefined;

  function nextTickHandler() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var noop = function noop() {};
    timerFunc = function () {
      p.then(nextTickHandler);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) setTimeout(noop);
    };
  } else if (typeof MutationObserver !== 'undefined') {
    // use MutationObserver where native Promise is not available,
    // e.g. IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = setTimeout;
  }

  return function (cb, ctx) {
    var func = ctx ? function () {
      cb.call(ctx);
    } : cb;
    callbacks.push(func);
    if (pending) return;
    pending = true;
    timerFunc(nextTickHandler, 0);
  };
})();

var _Set = undefined;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = function () {
    this.set = Object.create(null);
  };
  _Set.prototype.has = function (key) {
    return this.set[key] !== undefined;
  };
  _Set.prototype.add = function (key) {
    this.set[key] = 1;
  };
  _Set.prototype.clear = function () {
    this.set = Object.create(null);
  };
}

function Cache(limit) {
  this.size = 0;
  this.limit = limit;
  this.head = this.tail = undefined;
  this._keymap = Object.create(null);
}

var p = Cache.prototype;

/**
 * Put <value> into the cache associated with <key>.
 * Returns the entry which was removed to make room for
 * the new entry. Otherwise undefined is returned.
 * (i.e. if there was enough room already).
 *
 * @param {String} key
 * @param {*} value
 * @return {Entry|undefined}
 */

p.put = function (key, value) {
  var removed;

  var entry = this.get(key, true);
  if (!entry) {
    if (this.size === this.limit) {
      removed = this.shift();
    }
    entry = {
      key: key
    };
    this._keymap[key] = entry;
    if (this.tail) {
      this.tail.newer = entry;
      entry.older = this.tail;
    } else {
      this.head = entry;
    }
    this.tail = entry;
    this.size++;
  }
  entry.value = value;

  return removed;
};

/**
 * Purge the least recently used (oldest) entry from the
 * cache. Returns the removed entry or undefined if the
 * cache was empty.
 */

p.shift = function () {
  var entry = this.head;
  if (entry) {
    this.head = this.head.newer;
    this.head.older = undefined;
    entry.newer = entry.older = undefined;
    this._keymap[entry.key] = undefined;
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value
 * associated with <key> or undefined if not in cache.
 *
 * @param {String} key
 * @param {Boolean} returnEntry
 * @return {Entry|*}
 */

p.get = function (key, returnEntry) {
  var entry = this._keymap[key];
  if (entry === undefined) return;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.head) {
      this.head = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.tail; // D. --> E
  if (this.tail) {
    this.tail.newer = entry; // E. <-- D
  }
  this.tail = entry;
  return returnEntry ? entry : entry.value;
};

var cache$1 = new Cache(1000);
var reservedArgRE = /^in$|^-?\d+/;

/**
 * Parser state
 */

var str;
var dir;
var len;
var index;
var chr;
var state;
var startState = 0;
var filterState = 1;
var filterNameState = 2;
var filterArgState = 3;

var doubleChr = 0x22;
var singleChr = 0x27;
var pipeChr = 0x7C;
var escapeChr = 0x5C;
var spaceChr = 0x20;

var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };

function peek() {
  return str.charCodeAt(index + 1);
}

function next() {
  return str.charCodeAt(++index);
}

function eof() {
  return index >= len;
}

function eatSpace() {
  while (peek() === spaceChr) {
    next();
  }
}

function isStringStart(chr) {
  return chr === doubleChr || chr === singleChr;
}

function isExpStart(chr) {
  return expStartChr[chr];
}

function isExpEnd(start, chr) {
  return expChrPair[start] === chr;
}

function parseString() {
  var stringQuote = next();
  var chr;
  while (!eof()) {
    chr = next();
    // escape char
    if (chr === escapeChr) {
      next();
    } else if (chr === stringQuote) {
      break;
    }
  }
}

function parseSpecialExp(chr) {
  var inExp = 0;
  var startChr = chr;

  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
      continue;
    }

    if (startChr === chr) {
      inExp++;
    }
    if (isExpEnd(startChr, chr)) {
      inExp--;
    }

    next();

    if (inExp === 0) {
      break;
    }
  }
}

/**
 * syntax:
 * expression | filterName  [arg  arg [| filterName arg arg]]
 */

function parseExpression() {
  var start = index;
  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
    } else if (isExpStart(chr)) {
      parseSpecialExp(chr);
    } else if (chr === pipeChr) {
      next();
      chr = peek();
      if (chr === pipeChr) {
        next();
      } else {
        if (state === startState || state === filterArgState) {
          state = filterState;
        }
        break;
      }
    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
      eatSpace();
      break;
    } else {
      if (state === filterState) {
        state = filterNameState;
      }
      next();
    }
  }

  return str.slice(start + 1, index) || null;
}

function parseFilterList() {
  var filters = [];
  while (!eof()) {
    filters.push(parseFilter());
  }
  return filters;
}

function parseFilter() {
  var filter = {};
  var args;

  state = filterState;
  filter.name = parseExpression().trim();

  state = filterArgState;
  args = parseFilterArguments();

  if (args.length) {
    filter.args = args;
  }
  return filter;
}

function parseFilterArguments() {
  var args = [];
  while (!eof() && state !== filterState) {
    var arg = parseExpression();
    if (!arg) {
      break;
    }
    args.push(processFilterArg(arg));
  }

  return args;
}

/**
 * Check if an argument is dynamic and strip quotes.
 *
 * @param {String} arg
 * @return {Object}
 */

function processFilterArg(arg) {
  if (reservedArgRE.test(arg)) {
    return {
      value: toNumber(arg),
      dynamic: false
    };
  } else {
    var stripped = stripQuotes(arg);
    var dynamic = stripped === arg;
    return {
      value: dynamic ? arg : stripped,
      dynamic: dynamic
    };
  }
}

/**
 * Parse a directive value and extract the expression
 * and its filters into a descriptor.
 *
 * Example:
 *
 * "a + 1 | uppercase" will yield:
 * {
 *   expression: 'a + 1',
 *   filters: [
 *     { name: 'uppercase', args: null }
 *   ]
 * }
 *
 * @param {String} s
 * @return {Object}
 */

function parseDirective(s) {
  var hit = cache$1.get(s);
  if (hit) {
    return hit;
  }

  // reset parser state
  str = s;
  dir = {};
  len = str.length;
  index = -1;
  chr = '';
  state = startState;

  var filters;

  if (str.indexOf('|') < 0) {
    dir.expression = str.trim();
  } else {
    dir.expression = parseExpression().trim();
    filters = parseFilterList();
    if (filters.length) {
      dir.filters = filters;
    }
  }

  cache$1.put(s, dir);
  return dir;
}

var directive = Object.freeze({
  parseDirective: parseDirective
});

var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var cache = undefined;
var tagRE = undefined;
var htmlRE = undefined;
/**
 * Escape a string so it can be used in a RegExp
 * constructor.
 *
 * @param {String} str
 */

function escapeRegex(str) {
  return str.replace(regexEscapeRE, '\\$&');
}

function compileRegex() {
  var open = escapeRegex(config.delimiters[0]);
  var close = escapeRegex(config.delimiters[1]);
  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
  // reset cache
  cache = new Cache(1000);
}

/**
 * Parse a template text string into an array of tokens.
 *
 * @param {String} text
 * @return {Array<Object> | null}
 *               - {String} type
 *               - {String} value
 *               - {Boolean} [html]
 *               - {Boolean} [oneTime]
 */

function parseText(text) {
  if (!cache) {
    compileRegex();
  }
  var hit = cache.get(text);
  if (hit) {
    return hit;
  }
  if (!tagRE.test(text)) {
    return null;
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, html, value, first, oneTime;
  /* eslint-disable no-cond-assign */
  while (match = tagRE.exec(text)) {
    /* eslint-enable no-cond-assign */
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push({
        value: text.slice(lastIndex, index)
      });
    }
    // tag token
    html = htmlRE.test(match[0]);
    value = html ? match[1] : match[2];
    first = value.charCodeAt(0);
    oneTime = first === 42; // *
    value = oneTime ? value.slice(1) : value;
    tokens.push({
      tag: true,
      value: value.trim(),
      html: html,
      oneTime: oneTime
    });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push({
      value: text.slice(lastIndex)
    });
  }
  cache.put(text, tokens);
  return tokens;
}

/**
 * Format a list of tokens into an expression.
 * e.g. tokens parsed from 'a {{b}} c' can be serialized
 * into one single expression as '"a " + b + " c"'.
 *
 * @param {Array} tokens
 * @param {Vue} [vm]
 * @return {String}
 */

function tokensToExp(tokens, vm) {
  if (tokens.length > 1) {
    return tokens.map(function (token) {
      return formatToken(token, vm);
    }).join('+');
  } else {
    return formatToken(tokens[0], vm, true);
  }
}

/**
 * Format a single token.
 *
 * @param {Object} token
 * @param {Vue} [vm]
 * @param {Boolean} [single]
 * @return {String}
 */

function formatToken(token, vm, single) {
  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
}

/**
 * For an attribute with multiple interpolation tags,
 * e.g. attr="some-{{thing | filter}}", in order to combine
 * the whole thing into a single watchable expression, we
 * have to inline those filters. This function does exactly
 * that. This is a bit hacky but it avoids heavy changes
 * to directive parser and watcher mechanism.
 *
 * @param {String} exp
 * @param {Boolean} single
 * @return {String}
 */

var filterRE = /[^|]\|[^|]/;
function inlineFilters(exp, single) {
  if (!filterRE.test(exp)) {
    return single ? exp : '(' + exp + ')';
  } else {
    var dir = parseDirective(exp);
    if (!dir.filters) {
      return '(' + exp + ')';
    } else {
      return 'this._applyFilters(' + dir.expression + // value
      ',null,' + // oldValue (null for read)
      JSON.stringify(dir.filters) + // filter descriptors
      ',false)'; // write?
    }
  }
}

var text = Object.freeze({
  compileRegex: compileRegex,
  parseText: parseText,
  tokensToExp: tokensToExp
});

var delimiters = ['{{', '}}'];
var unsafeDelimiters = ['{{{', '}}}'];

var config = Object.defineProperties({

  /**
   * Whether to print debug messages.
   * Also enables stack trace for warnings.
   *
   * @type {Boolean}
   */

  debug: false,

  /**
   * Whether to suppress warnings.
   *
   * @type {Boolean}
   */

  silent: false,

  /**
   * Whether to use async rendering.
   */

  async: true,

  /**
   * Whether to warn against errors caught when evaluating
   * expressions.
   */

  warnExpressionErrors: true,

  /**
   * Whether to allow devtools inspection.
   * Disabled by default in production builds.
   */

  devtools: process.env.NODE_ENV !== 'production',

  /**
   * Internal flag to indicate the delimiters have been
   * changed.
   *
   * @type {Boolean}
   */

  _delimitersChanged: true,

  /**
   * List of asset types that a component can own.
   *
   * @type {Array}
   */

  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],

  /**
   * prop binding modes
   */

  _propBindingModes: {
    ONE_WAY: 0,
    TWO_WAY: 1,
    ONE_TIME: 2
  },

  /**
   * Max circular updates allowed in a batcher flush cycle.
   */

  _maxUpdateCount: 100

}, {
  delimiters: { /**
                 * Interpolation delimiters. Changing these would trigger
                 * the text parser to re-compile the regular expressions.
                 *
                 * @type {Array<String>}
                 */

    get: function get() {
      return delimiters;
    },
    set: function set(val) {
      delimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  },
  unsafeDelimiters: {
    get: function get() {
      return unsafeDelimiters;
    },
    set: function set(val) {
      unsafeDelimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  }
});

var warn = undefined;
var formatComponentName = undefined;

if (process.env.NODE_ENV !== 'production') {
  (function () {
    var hasConsole = typeof console !== 'undefined';

    warn = function (msg, vm) {
      if (hasConsole && !config.silent) {
        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
      }
    };

    formatComponentName = function (vm) {
      var name = vm._isVue ? vm.$options.name : vm.name;
      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
    };
  })();
}

/**
 * Append with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function appendWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    target.appendChild(el);
  }, vm, cb);
}

/**
 * InsertBefore with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function beforeWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    before(el, target);
  }, vm, cb);
}

/**
 * Remove with transition.
 *
 * @param {Element} el
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function removeWithTransition(el, vm, cb) {
  applyTransition(el, -1, function () {
    remove(el);
  }, vm, cb);
}

/**
 * Apply transitions with an operation callback.
 *
 * @param {Element} el
 * @param {Number} direction
 *                  1: enter
 *                 -1: leave
 * @param {Function} op - the actual DOM operation
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function applyTransition(el, direction, op, vm, cb) {
  var transition = el.__v_trans;
  if (!transition ||
  // skip if there are no js hooks and CSS transition is
  // not supported
  !transition.hooks && !transitionEndEvent ||
  // skip transitions for initial compile
  !vm._isCompiled ||
  // if the vm is being manipulated by a parent directive
  // during the parent's compilation phase, skip the
  // animation.
  vm.$parent && !vm.$parent._isCompiled) {
    op();
    if (cb) cb();
    return;
  }
  var action = direction > 0 ? 'enter' : 'leave';
  transition[action](op, cb);
}

var transition = Object.freeze({
  appendWithTransition: appendWithTransition,
  beforeWithTransition: beforeWithTransition,
  removeWithTransition: removeWithTransition,
  applyTransition: applyTransition
});

/**
 * Query an element selector if it's not an element already.
 *
 * @param {String|Element} el
 * @return {Element}
 */

function query(el) {
  if (typeof el === 'string') {
    var selector = el;
    el = document.querySelector(el);
    if (!el) {
      process.env.NODE_ENV !== 'production' && warn('Cannot find element: ' + selector);
    }
  }
  return el;
}

/**
 * Check if a node is in the document.
 * Note: document.documentElement.contains should work here
 * but always returns false for comment nodes in phantomjs,
 * making unit tests difficult. This is fixed by doing the
 * contains() check on the node's parentNode instead of
 * the node itself.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function inDoc(node) {
  if (!node) return false;
  var doc = node.ownerDocument.documentElement;
  var parent = node.parentNode;
  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
}

/**
 * Get and remove an attribute from a node.
 *
 * @param {Node} node
 * @param {String} _attr
 */

function getAttr(node, _attr) {
  var val = node.getAttribute(_attr);
  if (val !== null) {
    node.removeAttribute(_attr);
  }
  return val;
}

/**
 * Get an attribute with colon or v-bind: prefix.
 *
 * @param {Node} node
 * @param {String} name
 * @return {String|null}
 */

function getBindAttr(node, name) {
  var val = getAttr(node, ':' + name);
  if (val === null) {
    val = getAttr(node, 'v-bind:' + name);
  }
  return val;
}

/**
 * Check the presence of a bind attribute.
 *
 * @param {Node} node
 * @param {String} name
 * @return {Boolean}
 */

function hasBindAttr(node, name) {
  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
}

/**
 * Insert el before target
 *
 * @param {Element} el
 * @param {Element} target
 */

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

/**
 * Insert el after target
 *
 * @param {Element} el
 * @param {Element} target
 */

function after(el, target) {
  if (target.nextSibling) {
    before(el, target.nextSibling);
  } else {
    target.parentNode.appendChild(el);
  }
}

/**
 * Remove el from DOM
 *
 * @param {Element} el
 */

function remove(el) {
  el.parentNode.removeChild(el);
}

/**
 * Prepend el to target
 *
 * @param {Element} el
 * @param {Element} target
 */

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

/**
 * Replace target with el
 *
 * @param {Element} target
 * @param {Element} el
 */

function replace(target, el) {
  var parent = target.parentNode;
  if (parent) {
    parent.replaceChild(el, target);
  }
}

/**
 * Add event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 * @param {Boolean} [useCapture]
 */

function on(el, event, cb, useCapture) {
  el.addEventListener(event, cb, useCapture);
}

/**
 * Remove event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 */

function off(el, event, cb) {
  el.removeEventListener(event, cb);
}

/**
 * For IE9 compat: when both class and :class are present
 * getAttribute('class') returns wrong value...
 *
 * @param {Element} el
 * @return {String}
 */

function getClass(el) {
  var classname = el.className;
  if (typeof classname === 'object') {
    classname = classname.baseVal || '';
  }
  return classname;
}

/**
 * In IE9, setAttribute('class') will result in empty class
 * if the element also has the :class attribute; However in
 * PhantomJS, setting `className` does not work on SVG elements...
 * So we have to do a conditional check here.
 *
 * @param {Element} el
 * @param {String} cls
 */

function setClass(el, cls) {
  /* istanbul ignore if */
  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
    el.className = cls;
  } else {
    el.setAttribute('class', cls);
  }
}

/**
 * Add class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function addClass(el, cls) {
  if (el.classList) {
    el.classList.add(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      setClass(el, (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function removeClass(el, cls) {
  if (el.classList) {
    el.classList.remove(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    setClass(el, cur.trim());
  }
  if (!el.className) {
    el.removeAttribute('class');
  }
}

/**
 * Extract raw content inside an element into a temporary
 * container div
 *
 * @param {Element} el
 * @param {Boolean} asFragment
 * @return {Element|DocumentFragment}
 */

function extractContent(el, asFragment) {
  var child;
  var rawContent;
  /* istanbul ignore if */
  if (isTemplate(el) && isFragment(el.content)) {
    el = el.content;
  }
  if (el.hasChildNodes()) {
    trimNode(el);
    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
    /* eslint-disable no-cond-assign */
    while (child = el.firstChild) {
      /* eslint-enable no-cond-assign */
      rawContent.appendChild(child);
    }
  }
  return rawContent;
}

/**
 * Trim possible empty head/tail text and comment
 * nodes inside a parent.
 *
 * @param {Node} node
 */

function trimNode(node) {
  var child;
  /* eslint-disable no-sequences */
  while ((child = node.firstChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  while ((child = node.lastChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  /* eslint-enable no-sequences */
}

function isTrimmable(node) {
  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
}

/**
 * Check if an element is a template tag.
 * Note if the template appears inside an SVG its tagName
 * will be in lowercase.
 *
 * @param {Element} el
 */

function isTemplate(el) {
  return el.tagName && el.tagName.toLowerCase() === 'template';
}

/**
 * Create an "anchor" for performing dom insertion/removals.
 * This is used in a number of scenarios:
 * - fragment instance
 * - v-html
 * - v-if
 * - v-for
 * - component
 *
 * @param {String} content
 * @param {Boolean} persist - IE trashes empty textNodes on
 *                            cloneNode(true), so in certain
 *                            cases the anchor needs to be
 *                            non-empty to be persisted in
 *                            templates.
 * @return {Comment|Text}
 */

function createAnchor(content, persist) {
  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
  anchor.__v_anchor = true;
  return anchor;
}

/**
 * Find a component ref attribute that starts with $.
 *
 * @param {Element} node
 * @return {String|undefined}
 */

var refRE = /^v-ref:/;

function findRef(node) {
  if (node.hasAttributes()) {
    var attrs = node.attributes;
    for (var i = 0, l = attrs.length; i < l; i++) {
      var name = attrs[i].name;
      if (refRE.test(name)) {
        return camelize(name.replace(refRE, ''));
      }
    }
  }
}

/**
 * Map a function to a range of nodes .
 *
 * @param {Node} node
 * @param {Node} end
 * @param {Function} op
 */

function mapNodeRange(node, end, op) {
  var next;
  while (node !== end) {
    next = node.nextSibling;
    op(node);
    node = next;
  }
  op(end);
}

/**
 * Remove a range of nodes with transition, store
 * the nodes in a fragment with correct ordering,
 * and call callback when done.
 *
 * @param {Node} start
 * @param {Node} end
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Function} cb
 */

function removeNodeRange(start, end, vm, frag, cb) {
  var done = false;
  var removed = 0;
  var nodes = [];
  mapNodeRange(start, end, function (node) {
    if (node === end) done = true;
    nodes.push(node);
    removeWithTransition(node, vm, onRemoved);
  });
  function onRemoved() {
    removed++;
    if (done && removed >= nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        frag.appendChild(nodes[i]);
      }
      cb && cb();
    }
  }
}

/**
 * Check if a node is a DocumentFragment.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isFragment(node) {
  return node && node.nodeType === 11;
}

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 *
 * @param {Element} el
 * @return {String}
 */

function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
var reservedTagRE = /^(slot|partial|component)$/i;

var isUnknownElement = undefined;
if (process.env.NODE_ENV !== 'production') {
  isUnknownElement = function (el, tag) {
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return (/HTMLUnknownElement/.test(el.toString()) &&
        // Chrome returns unknown for several HTML5 elements.
        // https://code.google.com/p/chromium/issues/detail?id=540526
        // Firefox returns unknown for some "Interactive elements."
        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
      );
    }
  };
}

/**
 * Check if an element is a component, if yes return its
 * component id.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function checkComponentAttr(el, options) {
  var tag = el.tagName.toLowerCase();
  var hasAttrs = el.hasAttributes();
  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
    if (resolveAsset(options, 'components', tag)) {
      return { id: tag };
    } else {
      var is = hasAttrs && getIsBinding(el, options);
      if (is) {
        return is;
      } else if (process.env.NODE_ENV !== 'production') {
        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
        if (expectedTag) {
          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
        } else if (isUnknownElement(el, tag)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
        }
      }
    }
  } else if (hasAttrs) {
    return getIsBinding(el, options);
  }
}

/**
 * Get "is" binding from an element.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function getIsBinding(el, options) {
  // dynamic syntax
  var exp = el.getAttribute('is');
  if (exp != null) {
    if (resolveAsset(options, 'components', exp)) {
      el.removeAttribute('is');
      return { id: exp };
    }
  } else {
    exp = getBindAttr(el, 'is');
    if (exp != null) {
      return { id: exp, dynamic: true };
    }
  }
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 *
 * All strategy functions follow the same signature:
 *
 * @param {*} parentVal
 * @param {*} childVal
 * @param {Vue} [vm]
 */

var strats = config.optionMergeStrategies = Object.create(null);

/**
 * Helper that recursively merges two data objects together.
 */

function mergeData(to, from) {
  var key, toVal, fromVal;
  for (key in from) {
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isObject(toVal) && isObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (typeof childVal !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(childVal.call(this), parentVal.call(this));
    };
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
};

/**
 * El
 */

strats.el = function (parentVal, childVal, vm) {
  if (!vm && childVal && typeof childVal !== 'function') {
    process.env.NODE_ENV !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
    return;
  }
  var ret = childVal || parentVal;
  // invoke the element factory if this is instance merge
  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
};

/**
 * Hooks and param attributes are merged as arrays.
 */

strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
};

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */

function mergeAssets(parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
}

config._assetTypes.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Events & Watchers.
 *
 * Events & watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */

strats.watch = strats.events = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent ? parent.concat(child) : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */

strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret;
};

/**
 * Default strategy.
 */

var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Make sure component options get converted to actual
 * constructors.
 *
 * @param {Object} options
 */

function guardComponents(options) {
  if (options.components) {
    var components = options.components = guardArrayAssets(options.components);
    var ids = Object.keys(components);
    var def;
    if (process.env.NODE_ENV !== 'production') {
      var map = options._componentNameMap = {};
    }
    for (var i = 0, l = ids.length; i < l; i++) {
      var key = ids[i];
      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
        process.env.NODE_ENV !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
        continue;
      }
      // record a all lowercase <-> kebab-case mapping for
      // possible custom element case error warning
      if (process.env.NODE_ENV !== 'production') {
        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
      }
      def = components[key];
      if (isPlainObject(def)) {
        components[key] = Vue.extend(def);
      }
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 *
 * @param {Object} options
 */

function guardProps(options) {
  var props = options.props;
  var i, val;
  if (isArray(props)) {
    options.props = {};
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        options.props[val] = null;
      } else if (val.name) {
        options.props[val.name] = val;
      }
    }
  } else if (isPlainObject(props)) {
    var keys = Object.keys(props);
    i = keys.length;
    while (i--) {
      val = props[keys[i]];
      if (typeof val === 'function') {
        props[keys[i]] = { type: val };
      }
    }
  }
}

/**
 * Guard an Array-format assets option and converted it
 * into the key-value Object format.
 *
 * @param {Object|Array} assets
 * @return {Object}
 */

function guardArrayAssets(assets) {
  if (isArray(assets)) {
    var res = {};
    var i = assets.length;
    var asset;
    while (i--) {
      asset = assets[i];
      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
      if (!id) {
        process.env.NODE_ENV !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
      } else {
        res[id] = asset;
      }
    }
    return res;
  }
  return assets;
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 *
 * @param {Object} parent
 * @param {Object} child
 * @param {Vue} [vm] - if vm is present, indicates this is
 *                     an instantiation merge.
 */

function mergeOptions(parent, child, vm) {
  guardComponents(child);
  guardProps(child);
  if (process.env.NODE_ENV !== 'production') {
    if (child.propsData && !vm) {
      warn('propsData can only be used as an instantiation option.');
    }
  }
  var options = {};
  var key;
  if (child['extends']) {
    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      var mixin = child.mixins[i];
      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
      parent = mergeOptions(parent, mixinOptions, vm);
    }
  }
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 *
 * @param {Object} options
 * @param {String} type
 * @param {String} id
 * @param {Boolean} warnMissing
 * @return {Object|Function}
 */

function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  var camelizedId;
  var res = assets[id] ||
  // camelCase ID
  assets[camelizedId = camelize(id)] ||
  // Pascal Case ID
  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
  if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 *
 * @constructor
 */
function Dep() {
  this.id = uid$1++;
  this.subs = [];
}

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;

/**
 * Add a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.addSub = function (sub) {
  this.subs.push(sub);
};

/**
 * Remove a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.removeSub = function (sub) {
  this.subs.$remove(sub);
};

/**
 * Add self as a dependency to the target watcher.
 */

Dep.prototype.depend = function () {
  Dep.target.addDep(this);
};

/**
 * Notify all subscribers of a new value.
 */

Dep.prototype.notify = function () {
  // stablize the subscriber list first
  var subs = toArray(this.subs);
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto)

/**
 * Intercept mutating methods and emit events
 */

;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break;
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) ob.observeArray(inserted);
    // notify change
    ob.dep.notify();
    return result;
  });
});

/**
 * Swap the element at the given index with a new value
 * and emits corresponding event.
 *
 * @param {Number} index
 * @param {*} val
 * @return {*} - replaced element
 */

def(arrayProto, '$set', function $set(index, val) {
  if (index >= this.length) {
    this.length = Number(index) + 1;
  }
  return this.splice(index, 1, val)[0];
});

/**
 * Convenience method to remove the element at given index or target element reference.
 *
 * @param {*} item
 */

def(arrayProto, '$remove', function $remove(item) {
  /* istanbul ignore if */
  if (!this.length) return;
  var index = indexOf(this, item);
  if (index > -1) {
    return this.splice(index, 1);
  }
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However in certain cases, e.g.
 * v-for scope alias and props, we don't want to force conversion
 * because the value may be a nested value under a frozen data structure.
 *
 * So whenever we want to set a reactive property without forcing
 * conversion on the new value, we wrap that call inside this function.
 */

var shouldConvert = true;

function withoutConversion(fn) {
  shouldConvert = false;
  fn();
  shouldConvert = true;
}

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 *
 * @param {Array|Object} value
 * @constructor
 */

function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  def(value, '__ob__', this);
  if (isArray(value)) {
    var augment = hasProto ? protoAugment : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
}

// Instance methods

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 *
 * @param {Object} obj
 */

Observer.prototype.walk = function (obj) {
  var keys = Object.keys(obj);
  for (var i = 0, l = keys.length; i < l; i++) {
    this.convert(keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 *
 * @param {Array} items
 */

Observer.prototype.observeArray = function (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

/**
 * Convert a property into getter/setter so we can emit
 * the events when the property is accessed/changed.
 *
 * @param {String} key
 * @param {*} val
 */

Observer.prototype.convert = function (key, val) {
  defineReactive(this.value, key, val);
};

/**
 * Add an owner vm, so that when $set/$delete mutations
 * happen we can notify owner vms to proxy the keys and
 * digest the watchers. This is only called when the object
 * is observed as an instance's root $data.
 *
 * @param {Vue} vm
 */

Observer.prototype.addVm = function (vm) {
  (this.vms || (this.vms = [])).push(vm);
};

/**
 * Remove an owner vm. This is called when the object is
 * swapped out as an instance's $data object.
 *
 * @param {Vue} vm
 */

Observer.prototype.removeVm = function (vm) {
  this.vms.$remove(vm);
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 *
 * @param {Object|Array} target
 * @param {Object} src
 */

function protoAugment(target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 *
 * @param {Object|Array} target
 * @param {Object} proto
 */

function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 *
 * @param {*} value
 * @param {Vue} [vm]
 * @return {Observer|undefined}
 * @static
 */

function observe(value, vm) {
  if (!value || typeof value !== 'object') {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (ob && vm) {
    ob.addVm(vm);
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 */

function defineReactive(obj, key, val) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (isArray(value)) {
          for (var e, i = 0, l = value.length; i < l; i++) {
            e = value[i];
            e && e.__ob__ && e.__ob__.dep.depend();
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}



var util = Object.freeze({
	defineReactive: defineReactive,
	set: set,
	del: del,
	hasOwn: hasOwn,
	isLiteral: isLiteral,
	isReserved: isReserved,
	_toString: _toString,
	toNumber: toNumber,
	toBoolean: toBoolean,
	stripQuotes: stripQuotes,
	camelize: camelize,
	hyphenate: hyphenate,
	classify: classify,
	bind: bind,
	toArray: toArray,
	extend: extend,
	isObject: isObject,
	isPlainObject: isPlainObject,
	def: def,
	debounce: _debounce,
	indexOf: indexOf,
	cancellable: cancellable,
	looseEqual: looseEqual,
	isArray: isArray,
	hasProto: hasProto,
	inBrowser: inBrowser,
	devtools: devtools,
	isIE: isIE,
	isIE9: isIE9,
	isAndroid: isAndroid,
	isIOS: isIOS,
	get transitionProp () { return transitionProp; },
	get transitionEndEvent () { return transitionEndEvent; },
	get animationProp () { return animationProp; },
	get animationEndEvent () { return animationEndEvent; },
	nextTick: nextTick,
	get _Set () { return _Set; },
	query: query,
	inDoc: inDoc,
	getAttr: getAttr,
	getBindAttr: getBindAttr,
	hasBindAttr: hasBindAttr,
	before: before,
	after: after,
	remove: remove,
	prepend: prepend,
	replace: replace,
	on: on,
	off: off,
	setClass: setClass,
	addClass: addClass,
	removeClass: removeClass,
	extractContent: extractContent,
	trimNode: trimNode,
	isTemplate: isTemplate,
	createAnchor: createAnchor,
	findRef: findRef,
	mapNodeRange: mapNodeRange,
	removeNodeRange: removeNodeRange,
	isFragment: isFragment,
	getOuterHTML: getOuterHTML,
	mergeOptions: mergeOptions,
	resolveAsset: resolveAsset,
	checkComponentAttr: checkComponentAttr,
	commonTagRE: commonTagRE,
	reservedTagRE: reservedTagRE,
	get warn () { return warn; }
});

var uid = 0;

function initMixin (Vue) {
  /**
   * The main init sequence. This is called for every
   * instance, including ones that are created from extended
   * constructors.
   *
   * @param {Object} options - this options object should be
   *                           the result of merging class
   *                           options and the options passed
   *                           in to the constructor.
   */

  Vue.prototype._init = function (options) {
    options = options || {};

    this.$el = null;
    this.$parent = options.parent;
    this.$root = this.$parent ? this.$parent.$root : this;
    this.$children = [];
    this.$refs = {}; // child vm references
    this.$els = {}; // element references
    this._watchers = []; // all watchers as an array
    this._directives = []; // all directives

    // a uid
    this._uid = uid++;

    // a flag to avoid this being observed
    this._isVue = true;

    // events bookkeeping
    this._events = {}; // registered callbacks
    this._eventsCount = {}; // for $broadcast optimization

    // fragment instance properties
    this._isFragment = false;
    this._fragment = // @type {DocumentFragment}
    this._fragmentStart = // @type {Text|Comment}
    this._fragmentEnd = null; // @type {Text|Comment}

    // lifecycle state
    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
    this._unlinkFn = null;

    // context:
    // if this is a transcluded component, context
    // will be the common parent vm of this instance
    // and its host.
    this._context = options._context || this.$parent;

    // scope:
    // if this is inside an inline v-for, the scope
    // will be the intermediate scope created for this
    // repeat fragment. this is used for linking props
    // and container directives.
    this._scope = options._scope;

    // fragment:
    // if this instance is compiled inside a Fragment, it
    // needs to register itself as a child of that fragment
    // for attach/detach to work properly.
    this._frag = options._frag;
    if (this._frag) {
      this._frag.children.push(this);
    }

    // push self into parent / transclusion host
    if (this.$parent) {
      this.$parent.$children.push(this);
    }

    // merge options.
    options = this.$options = mergeOptions(this.constructor.options, options, this);

    // set ref
    this._updateRef();

    // initialize data as empty object.
    // it will be filled up in _initData().
    this._data = {};

    // call init hook
    this._callHook('init');

    // initialize data observation and scope inheritance.
    this._initState();

    // setup event system and option events.
    this._initEvents();

    // call created hook
    this._callHook('created');

    // if `el` option is passed, start compilation.
    if (options.el) {
      this.$mount(options.el);
    }
  };
}

var pathCache = new Cache(1000);

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Determine the type of a character in a keypath.
 *
 * @param {Char} ch
 * @return {String} type
 */

function getPathCharType(ch) {
  if (ch === undefined) {
    return 'eof';
  }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30:
      // 0
      return ch;

    case 0x5F: // _
    case 0x24:
      // $
      return 'ident';

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0: // No-break space
    case 0xFEFF: // Byte Order Mark
    case 0x2028: // Line Separator
    case 0x2029:
      // Paragraph Separator
      return 'ws';
  }

  // a-z, A-Z
  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
    return 'ident';
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) {
    return 'number';
  }

  return 'else';
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 *
 * @param {String} path
 * @return {String}
 */

function formatSubPath(path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
}

/**
 * Parse a string path into an array of segments
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parse(path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c, newChar, key, type, transition, action, typeMap;

  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote() {
    var nextChar = path[index + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true;
    }
  }

  while (mode != null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue;
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return; // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined ? c : newChar;
      if (action() === false) {
        return;
      }
    }

    if (mode === AFTER_PATH) {
      keys.raw = path;
      return keys;
    }
  }
}

/**
 * External parse that check for a cache hit first
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parsePath(path) {
  var hit = pathCache.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      pathCache.put(path, hit);
    }
  }
  return hit;
}

/**
 * Get from an object from a path string
 *
 * @param {Object} obj
 * @param {String} path
 */

function getPath(obj, path) {
  return parseExpression$1(path).get(obj);
}

/**
 * Warn against setting non-existent root path on a vm.
 */

var warnNonExistent;
if (process.env.NODE_ENV !== 'production') {
  warnNonExistent = function (path, vm) {
    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
  };
}

/**
 * Set on an object from a path
 *
 * @param {Object} obj
 * @param {String | Array} path
 * @param {*} val
 */

function setPath(obj, path, val) {
  var original = obj;
  if (typeof path === 'string') {
    path = parse(path);
  }
  if (!path || !isObject(obj)) {
    return false;
  }
  var last, key;
  for (var i = 0, l = path.length; i < l; i++) {
    last = obj;
    key = path[i];
    if (key.charAt(0) === '*') {
      key = parseExpression$1(key.slice(1)).get.call(original, original);
    }
    if (i < l - 1) {
      obj = obj[key];
      if (!isObject(obj)) {
        obj = {};
        if (process.env.NODE_ENV !== 'production' && last._isVue) {
          warnNonExistent(path, last);
        }
        set(last, key, obj);
      }
    } else {
      if (isArray(obj)) {
        obj.$set(key, val);
      } else if (key in obj) {
        obj[key] = val;
      } else {
        if (process.env.NODE_ENV !== 'production' && obj._isVue) {
          warnNonExistent(path, obj);
        }
        set(obj, key, val);
      }
    }
  }
  return true;
}

var path = Object.freeze({
  parsePath: parsePath,
  getPath: getPath,
  setPath: setPath
});

var expressionCache = new Cache(1000);

var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');

// keywords that don't make sense inside expressions
var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');

var wsRE = /\s/g;
var newlineRE = /\n/g;
var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
var restoreRE = /"(\d+)"/g;
var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;

function noop() {}

/**
 * Save / Rewrite / Restore
 *
 * When rewriting paths found in an expression, it is
 * possible for the same letter sequences to be found in
 * strings and Object literal property keys. Therefore we
 * remove and store these parts in a temporary array, and
 * restore them after the path rewrite.
 */

var saved = [];

/**
 * Save replacer
 *
 * The save regex can match two possible cases:
 * 1. An opening object literal
 * 2. A string
 * If matched as a plain string, we need to escape its
 * newlines, since the string needs to be preserved when
 * generating the function body.
 *
 * @param {String} str
 * @param {String} isString - str if matched as a string
 * @return {String} - placeholder with index
 */

function save(str, isString) {
  var i = saved.length;
  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
  return '"' + i + '"';
}

/**
 * Path rewrite replacer
 *
 * @param {String} raw
 * @return {String}
 */

function rewrite(raw) {
  var c = raw.charAt(0);
  var path = raw.slice(1);
  if (allowedKeywordsRE.test(path)) {
    return raw;
  } else {
    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
    return c + 'scope.' + path;
  }
}

/**
 * Restore replacer
 *
 * @param {String} str
 * @param {String} i - matched save index
 * @return {String}
 */

function restore(str, i) {
  return saved[i];
}

/**
 * Rewrite an expression, prefixing all path accessors with
 * `scope.` and generate getter/setter functions.
 *
 * @param {String} exp
 * @return {Function}
 */

function compileGetter(exp) {
  if (improperKeywordsRE.test(exp)) {
    process.env.NODE_ENV !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
  }
  // reset state
  saved.length = 0;
  // save strings and object literal keys
  var body = exp.replace(saveRE, save).replace(wsRE, '');
  // rewrite all paths
  // pad 1 space here because the regex matches 1 extra char
  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
  return makeGetterFn(body);
}

/**
 * Build a getter function. Requires eval.
 *
 * We isolate the try/catch so it doesn't affect the
 * optimization of the parse function when it is not called.
 *
 * @param {String} body
 * @return {Function|undefined}
 */

function makeGetterFn(body) {
  try {
    /* eslint-disable no-new-func */
    return new Function('scope', 'return ' + body + ';');
    /* eslint-enable no-new-func */
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      /* istanbul ignore if */
      if (e.toString().match(/unsafe-eval|CSP/)) {
        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
      } else {
        warn('Invalid expression. ' + 'Generated function body: ' + body);
      }
    }
    return noop;
  }
}

/**
 * Compile a setter function for the expression.
 *
 * @param {String} exp
 * @return {Function|undefined}
 */

function compileSetter(exp) {
  var path = parsePath(exp);
  if (path) {
    return function (scope, val) {
      setPath(scope, path, val);
    };
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid setter expression: ' + exp);
  }
}

/**
 * Parse an expression into re-written getter/setters.
 *
 * @param {String} exp
 * @param {Boolean} needSet
 * @return {Function}
 */

function parseExpression$1(exp, needSet) {
  exp = exp.trim();
  // try cache
  var hit = expressionCache.get(exp);
  if (hit) {
    if (needSet && !hit.set) {
      hit.set = compileSetter(hit.exp);
    }
    return hit;
  }
  var res = { exp: exp };
  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
  // optimized super simple getter
  ? makeGetterFn('scope.' + exp)
  // dynamic getter
  : compileGetter(exp);
  if (needSet) {
    res.set = compileSetter(exp);
  }
  expressionCache.put(exp, res);
  return res;
}

/**
 * Check if an expression is a simple path.
 *
 * @param {String} exp
 * @return {Boolean}
 */

function isSimplePath(exp) {
  return pathTestRE.test(exp) &&
  // don't treat literal values as paths
  !literalValueRE$1.test(exp) &&
  // Math constants e.g. Math.PI, Math.E etc.
  exp.slice(0, 5) !== 'Math.';
}

var expression = Object.freeze({
  parseExpression: parseExpression$1,
  isSimplePath: isSimplePath
});

// we have two separate queues: one for directive updates
// and one for user watcher registered via $watch().
// we want to guarantee directive updates to be called
// before user watchers so that when user watchers are
// triggered, the DOM would have already been in updated
// state.

var queue = [];
var userQueue = [];
var has = {};
var circular = {};
var waiting = false;

/**
 * Reset the batcher's state.
 */

function resetBatcherState() {
  queue.length = 0;
  userQueue.length = 0;
  has = {};
  circular = {};
  waiting = false;
}

/**
 * Flush both queues and run the watchers.
 */

function flushBatcherQueue() {
  var _again = true;

  _function: while (_again) {
    _again = false;

    runBatcherQueue(queue);
    runBatcherQueue(userQueue);
    // user watchers triggered more watchers,
    // keep flushing until it depletes
    if (queue.length) {
      _again = true;
      continue _function;
    }
    // dev tool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
    resetBatcherState();
  }
}

/**
 * Run the watchers in a single queue.
 *
 * @param {Array} queue
 */

function runBatcherQueue(queue) {
  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (var i = 0; i < queue.length; i++) {
    var watcher = queue[i];
    var id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (process.env.NODE_ENV !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > config._maxUpdateCount) {
        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
        break;
      }
    }
  }
  queue.length = 0;
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 *
 * @param {Watcher} watcher
 *   properties:
 *   - {Number} id
 *   - {Function} run
 */

function pushWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    // push watcher into appropriate queue
    var q = watcher.user ? userQueue : queue;
    has[id] = q.length;
    q.push(watcher);
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushBatcherQueue);
    }
  }
}

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 *
 * @param {Vue} vm
 * @param {String|Function} expOrFn
 * @param {Function} cb
 * @param {Object} options
 *                 - {Array} filters
 *                 - {Boolean} twoWay
 *                 - {Boolean} deep
 *                 - {Boolean} user
 *                 - {Boolean} sync
 *                 - {Boolean} lazy
 *                 - {Function} [preProcess]
 *                 - {Function} [postProcess]
 * @constructor
 */
function Watcher(vm, expOrFn, cb, options) {
  // mix in options
  if (options) {
    extend(this, options);
  }
  var isFn = typeof expOrFn === 'function';
  this.vm = vm;
  vm._watchers.push(this);
  this.expression = expOrFn;
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.prevError = null; // for async error stacks
  // parse expression for getter/setter
  if (isFn) {
    this.getter = expOrFn;
    this.setter = undefined;
  } else {
    var res = parseExpression$1(expOrFn, this.twoWay);
    this.getter = res.get;
    this.setter = res.set;
  }
  this.value = this.lazy ? undefined : this.get();
  // state for avoiding false triggers for deep and Array
  // watchers during vm._digest()
  this.queued = this.shallow = false;
}

/**
 * Evaluate the getter, and re-collect dependencies.
 */

Watcher.prototype.get = function () {
  this.beforeGet();
  var scope = this.scope || this.vm;
  var value;
  try {
    value = this.getter.call(scope, scope);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  if (this.preProcess) {
    value = this.preProcess(value);
  }
  if (this.filters) {
    value = scope._applyFilters(value, null, this.filters, false);
  }
  if (this.postProcess) {
    value = this.postProcess(value);
  }
  this.afterGet();
  return value;
};

/**
 * Set the corresponding value with the setter.
 *
 * @param {*} value
 */

Watcher.prototype.set = function (value) {
  var scope = this.scope || this.vm;
  if (this.filters) {
    value = scope._applyFilters(value, this.value, this.filters, true);
  }
  try {
    this.setter.call(scope, scope, value);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // two-way sync for v-for alias
  var forContext = scope.$forContext;
  if (forContext && forContext.alias === this.expression) {
    if (forContext.filters) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
      return;
    }
    forContext._withLock(function () {
      if (scope.$key) {
        // original is an object
        forContext.rawValue[scope.$key] = value;
      } else {
        forContext.rawValue.$set(scope.$index, value);
      }
    });
  }
};

/**
 * Prepare for dependency collection.
 */

Watcher.prototype.beforeGet = function () {
  Dep.target = this;
};

/**
 * Add a dependency to this directive.
 *
 * @param {Dep} dep
 */

Watcher.prototype.addDep = function (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */

Watcher.prototype.afterGet = function () {
  Dep.target = null;
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 *
 * @param {Boolean} shallow
 */

Watcher.prototype.update = function (shallow) {
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync || !config.async) {
    this.run();
  } else {
    // if queued, only overwrite shallow with non-shallow,
    // but not the other way around.
    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
    this.queued = true;
    // record before-push error stack in debug mode
    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config.debug) {
      this.prevError = new Error('[vue] async stack trace');
    }
    pushWatcher(this);
  }
};

/**
 * Batcher job interface.
 * Will be called by the batcher.
 */

Watcher.prototype.run = function () {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated; but only do so if this is a
    // non-shallow update (caused by a vm digest).
    (isObject(value) || this.deep) && !this.shallow) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      // in debug + async mode, when a watcher callbacks
      // throws, we also throw the saved before-push error
      // so the full cross-tick stack trace is available.
      var prevError = this.prevError;
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && config.debug && prevError) {
        this.prevError = null;
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          nextTick(function () {
            throw prevError;
          }, 0);
          throw e;
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
    this.queued = this.shallow = false;
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */

Watcher.prototype.evaluate = function () {
  // avoid overwriting another watcher that is being
  // collected.
  var current = Dep.target;
  this.value = this.get();
  this.dirty = false;
  Dep.target = current;
};

/**
 * Depend on all deps collected by this watcher.
 */

Watcher.prototype.depend = function () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subcriber list.
 */

Watcher.prototype.teardown = function () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed or is performing a v-for
    // re-render (the watcher list is then filtered by v-for).
    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
      this.vm._watchers.$remove(this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
    this.vm = this.cb = this.value = null;
  }
};

/**
 * Recrusively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 *
 * @param {*} val
 */

var seenObjects = new _Set();
function traverse(val, seen) {
  var i = undefined,
      keys = undefined;
  if (!seen) {
    seen = seenObjects;
    seen.clear();
  }
  var isA = isArray(val);
  var isO = isObject(val);
  if ((isA || isO) && Object.isExtensible(val)) {
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return;
      } else {
        seen.add(depId);
      }
    }
    if (isA) {
      i = val.length;
      while (i--) traverse(val[i], seen);
    } else if (isO) {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) traverse(val[keys[i]], seen);
    }
  }
}

var text$1 = {

  bind: function bind() {
    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
  },

  update: function update(value) {
    this.el[this.attr] = _toString(value);
  }
};

var templateCache = new Cache(1000);
var idSelectorCache = new Cache(1000);

var map = {
  efault: [0, '', ''],
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
};

map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];

map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];

/**
 * Check if a node is a supported template node with a
 * DocumentFragment content.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isRealTemplate(node) {
  return isTemplate(node) && isFragment(node.content);
}

var tagRE$1 = /<([\w:-]+)/;
var entityRE = /&#?\w+?;/;
var commentRE = /<!--/;

/**
 * Convert a string template to a DocumentFragment.
 * Determines correct wrapping by tag types. Wrapping
 * strategy found in jQuery & component/domify.
 *
 * @param {String} templateString
 * @param {Boolean} raw
 * @return {DocumentFragment}
 */

function stringToFragment(templateString, raw) {
  // try a cache hit first
  var cacheKey = raw ? templateString : templateString.trim();
  var hit = templateCache.get(cacheKey);
  if (hit) {
    return hit;
  }

  var frag = document.createDocumentFragment();
  var tagMatch = templateString.match(tagRE$1);
  var entityMatch = entityRE.test(templateString);
  var commentMatch = commentRE.test(templateString);

  if (!tagMatch && !entityMatch && !commentMatch) {
    // text only, return a single text node.
    frag.appendChild(document.createTextNode(templateString));
  } else {
    var tag = tagMatch && tagMatch[1];
    var wrap = map[tag] || map.efault;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var node = document.createElement('div');

    node.innerHTML = prefix + templateString + suffix;
    while (depth--) {
      node = node.lastChild;
    }

    var child;
    /* eslint-disable no-cond-assign */
    while (child = node.firstChild) {
      /* eslint-enable no-cond-assign */
      frag.appendChild(child);
    }
  }
  if (!raw) {
    trimNode(frag);
  }
  templateCache.put(cacheKey, frag);
  return frag;
}

/**
 * Convert a template node to a DocumentFragment.
 *
 * @param {Node} node
 * @return {DocumentFragment}
 */

function nodeToFragment(node) {
  // if its a template tag and the browser supports it,
  // its content is already a document fragment. However, iOS Safari has
  // bug when using directly cloned template content with touch
  // events and can cause crashes when the nodes are removed from DOM, so we
  // have to treat template elements as string templates. (#2805)
  /* istanbul ignore if */
  if (isRealTemplate(node)) {
    return stringToFragment(node.innerHTML);
  }
  // script template
  if (node.tagName === 'SCRIPT') {
    return stringToFragment(node.textContent);
  }
  // normal node, clone it to avoid mutating the original
  var clonedNode = cloneNode(node);
  var frag = document.createDocumentFragment();
  var child;
  /* eslint-disable no-cond-assign */
  while (child = clonedNode.firstChild) {
    /* eslint-enable no-cond-assign */
    frag.appendChild(child);
  }
  trimNode(frag);
  return frag;
}

// Test for the presence of the Safari template cloning bug
// https://bugs.webkit.org/showug.cgi?id=137755
var hasBrokenTemplate = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var a = document.createElement('div');
    a.innerHTML = '<template>1</template>';
    return !a.cloneNode(true).firstChild.innerHTML;
  } else {
    return false;
  }
})();

// Test for IE10/11 textarea placeholder clone bug
var hasTextareaCloneBug = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var t = document.createElement('textarea');
    t.placeholder = 't';
    return t.cloneNode(true).value === 't';
  } else {
    return false;
  }
})();

/**
 * 1. Deal with Safari cloning nested <template> bug by
 *    manually cloning all template instances.
 * 2. Deal with IE10/11 textarea placeholder bug by setting
 *    the correct value after cloning.
 *
 * @param {Element|DocumentFragment} node
 * @return {Element|DocumentFragment}
 */

function cloneNode(node) {
  /* istanbul ignore if */
  if (!node.querySelectorAll) {
    return node.cloneNode();
  }
  var res = node.cloneNode(true);
  var i, original, cloned;
  /* istanbul ignore if */
  if (hasBrokenTemplate) {
    var tempClone = res;
    if (isRealTemplate(node)) {
      node = node.content;
      tempClone = res.content;
    }
    original = node.querySelectorAll('template');
    if (original.length) {
      cloned = tempClone.querySelectorAll('template');
      i = cloned.length;
      while (i--) {
        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
      }
    }
  }
  /* istanbul ignore if */
  if (hasTextareaCloneBug) {
    if (node.tagName === 'TEXTAREA') {
      res.value = node.value;
    } else {
      original = node.querySelectorAll('textarea');
      if (original.length) {
        cloned = res.querySelectorAll('textarea');
        i = cloned.length;
        while (i--) {
          cloned[i].value = original[i].value;
        }
      }
    }
  }
  return res;
}

/**
 * Process the template option and normalizes it into a
 * a DocumentFragment that can be used as a partial or a
 * instance template.
 *
 * @param {*} template
 *        Possible values include:
 *        - DocumentFragment object
 *        - Node object of type Template
 *        - id selector: '#some-template-id'
 *        - template string: '<div><span>{{msg}}</span></div>'
 * @param {Boolean} shouldClone
 * @param {Boolean} raw
 *        inline HTML interpolation. Do not check for id
 *        selector and keep whitespace in the string.
 * @return {DocumentFragment|undefined}
 */

function parseTemplate(template, shouldClone, raw) {
  var node, frag;

  // if the template is already a document fragment,
  // do nothing
  if (isFragment(template)) {
    trimNode(template);
    return shouldClone ? cloneNode(template) : template;
  }

  if (typeof template === 'string') {
    // id selector
    if (!raw && template.charAt(0) === '#') {
      // id selector can be cached too
      frag = idSelectorCache.get(template);
      if (!frag) {
        node = document.getElementById(template.slice(1));
        if (node) {
          frag = nodeToFragment(node);
          // save selector to cache
          idSelectorCache.put(template, frag);
        }
      }
    } else {
      // normal string template
      frag = stringToFragment(template, raw);
    }
  } else if (template.nodeType) {
    // a direct node
    frag = nodeToFragment(template);
  }

  return frag && shouldClone ? cloneNode(frag) : frag;
}

var template = Object.freeze({
  cloneNode: cloneNode,
  parseTemplate: parseTemplate
});

var html = {

  bind: function bind() {
    // a comment node means this is a binding for
    // {{{ inline unescaped html }}}
    if (this.el.nodeType === 8) {
      // hold nodes
      this.nodes = [];
      // replace the placeholder with proper anchor
      this.anchor = createAnchor('v-html');
      replace(this.el, this.anchor);
    }
  },

  update: function update(value) {
    value = _toString(value);
    if (this.nodes) {
      this.swap(value);
    } else {
      this.el.innerHTML = value;
    }
  },

  swap: function swap(value) {
    // remove old nodes
    var i = this.nodes.length;
    while (i--) {
      remove(this.nodes[i]);
    }
    // convert new value to a fragment
    // do not attempt to retrieve from id selector
    var frag = parseTemplate(value, true, true);
    // save a reference to these nodes so we can remove later
    this.nodes = toArray(frag.childNodes);
    before(frag, this.anchor);
  }
};

/**
 * Abstraction for a partially-compiled fragment.
 * Can optionally compile content with a child scope.
 *
 * @param {Function} linker
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Vue} [host]
 * @param {Object} [scope]
 * @param {Fragment} [parentFrag]
 */
function Fragment(linker, vm, frag, host, scope, parentFrag) {
  this.children = [];
  this.childFrags = [];
  this.vm = vm;
  this.scope = scope;
  this.inserted = false;
  this.parentFrag = parentFrag;
  if (parentFrag) {
    parentFrag.childFrags.push(this);
  }
  this.unlink = linker(vm, frag, host, scope, this);
  var single = this.single = frag.childNodes.length === 1 &&
  // do not go single mode if the only node is an anchor
  !frag.childNodes[0].__v_anchor;
  if (single) {
    this.node = frag.childNodes[0];
    this.before = singleBefore;
    this.remove = singleRemove;
  } else {
    this.node = createAnchor('fragment-start');
    this.end = createAnchor('fragment-end');
    this.frag = frag;
    prepend(this.node, frag);
    frag.appendChild(this.end);
    this.before = multiBefore;
    this.remove = multiRemove;
  }
  this.node.__v_frag = this;
}

/**
 * Call attach/detach for all components contained within
 * this fragment. Also do so recursively for all child
 * fragments.
 *
 * @param {Function} hook
 */

Fragment.prototype.callHook = function (hook) {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    this.childFrags[i].callHook(hook);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    hook(this.children[i]);
  }
};

/**
 * Insert fragment before target, single node version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function singleBefore(target, withTransition) {
  this.inserted = true;
  var method = withTransition !== false ? beforeWithTransition : before;
  method(this.node, target, this.vm);
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, single node version
 */

function singleRemove() {
  this.inserted = false;
  var shouldCallRemove = inDoc(this.node);
  var self = this;
  this.beforeRemove();
  removeWithTransition(this.node, this.vm, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Insert fragment before target, multi-nodes version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function multiBefore(target, withTransition) {
  this.inserted = true;
  var vm = this.vm;
  var method = withTransition !== false ? beforeWithTransition : before;
  mapNodeRange(this.node, this.end, function (node) {
    method(node, target, vm);
  });
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, multi-nodes version
 */

function multiRemove() {
  this.inserted = false;
  var self = this;
  var shouldCallRemove = inDoc(this.node);
  this.beforeRemove();
  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Prepare the fragment for removal.
 */

Fragment.prototype.beforeRemove = function () {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    // call the same method recursively on child
    // fragments, depth-first
    this.childFrags[i].beforeRemove(false);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    // Call destroy for all contained instances,
    // with remove:false and defer:true.
    // Defer is necessary because we need to
    // keep the children to call detach hooks
    // on them.
    this.children[i].$destroy(false, true);
  }
  var dirs = this.unlink.dirs;
  for (i = 0, l = dirs.length; i < l; i++) {
    // disable the watchers on all the directives
    // so that the rendered content stays the same
    // during removal.
    dirs[i]._watcher && dirs[i]._watcher.teardown();
  }
};

/**
 * Destroy the fragment.
 */

Fragment.prototype.destroy = function () {
  if (this.parentFrag) {
    this.parentFrag.childFrags.$remove(this);
  }
  this.node.__v_frag = null;
  this.unlink();
};

/**
 * Call attach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function attach(child) {
  if (!child._isAttached && inDoc(child.$el)) {
    child._callHook('attached');
  }
}

/**
 * Call detach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function detach(child) {
  if (child._isAttached && !inDoc(child.$el)) {
    child._callHook('detached');
  }
}

var linkerCache = new Cache(5000);

/**
 * A factory that can be used to create instances of a
 * fragment. Caches the compiled linker if possible.
 *
 * @param {Vue} vm
 * @param {Element|String} el
 */
function FragmentFactory(vm, el) {
  this.vm = vm;
  var template;
  var isString = typeof el === 'string';
  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
    template = parseTemplate(el, true);
  } else {
    template = document.createDocumentFragment();
    template.appendChild(el);
  }
  this.template = template;
  // linker can be cached, but only for components
  var linker;
  var cid = vm.constructor.cid;
  if (cid > 0) {
    var cacheId = cid + (isString ? el : getOuterHTML(el));
    linker = linkerCache.get(cacheId);
    if (!linker) {
      linker = compile(template, vm.$options, true);
      linkerCache.put(cacheId, linker);
    }
  } else {
    linker = compile(template, vm.$options, true);
  }
  this.linker = linker;
}

/**
 * Create a fragment instance with given host and scope.
 *
 * @param {Vue} host
 * @param {Object} scope
 * @param {Fragment} parentFrag
 */

FragmentFactory.prototype.create = function (host, scope, parentFrag) {
  var frag = cloneNode(this.template);
  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
};

var ON = 700;
var MODEL = 800;
var BIND = 850;
var TRANSITION = 1100;
var EL = 1500;
var COMPONENT = 1500;
var PARTIAL = 1750;
var IF = 2100;
var FOR = 2200;
var SLOT = 2300;

var uid$3 = 0;

var vFor = {

  priority: FOR,
  terminal: true,

  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],

  bind: function bind() {
    if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('v-if')) {
      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
    }

    // support "item in/of items" syntax
    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
    if (inMatch) {
      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
      if (itMatch) {
        this.iterator = itMatch[1].trim();
        this.alias = itMatch[2].trim();
      } else {
        this.alias = inMatch[1].trim();
      }
      this.expression = inMatch[2];
    }

    if (!this.alias) {
      process.env.NODE_ENV !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
      return;
    }

    // uid as a cache identifier
    this.id = '__v-for__' + ++uid$3;

    // check if this is an option list,
    // so that we know if we need to update the <select>'s
    // v-model when the option list has changed.
    // because v-model has a lower priority than v-for,
    // the v-model is not bound here yet, so we have to
    // retrive it in the actual updateModel() function.
    var tag = this.el.tagName;
    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';

    // setup anchor nodes
    this.start = createAnchor('v-for-start');
    this.end = createAnchor('v-for-end');
    replace(this.el, this.end);
    before(this.start, this.end);

    // cache
    this.cache = Object.create(null);

    // fragment factory
    this.factory = new FragmentFactory(this.vm, this.el);
  },

  update: function update(data) {
    this.diff(data);
    this.updateRef();
    this.updateModel();
  },

  /**
   * Diff, based on new data and old data, determine the
   * minimum amount of DOM manipulations needed to make the
   * DOM reflect the new data Array.
   *
   * The algorithm diffs the new data Array by storing a
   * hidden reference to an owner vm instance on previously
   * seen data. This allows us to achieve O(n) which is
   * better than a levenshtein distance based algorithm,
   * which is O(m * n).
   *
   * @param {Array} data
   */

  diff: function diff(data) {
    // check if the Array was converted from an Object
    var item = data[0];
    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');

    var trackByKey = this.params.trackBy;
    var oldFrags = this.frags;
    var frags = this.frags = new Array(data.length);
    var alias = this.alias;
    var iterator = this.iterator;
    var start = this.start;
    var end = this.end;
    var inDocument = inDoc(start);
    var init = !oldFrags;
    var i, l, frag, key, value, primitive;

    // First pass, go through the new Array and fill up
    // the new frags array. If a piece of data has a cached
    // instance for it, we reuse it. Otherwise build a new
    // instance.
    for (i = 0, l = data.length; i < l; i++) {
      item = data[i];
      key = convertedFromObject ? item.$key : null;
      value = convertedFromObject ? item.$value : item;
      primitive = !isObject(value);
      frag = !init && this.getCachedFrag(value, i, key);
      if (frag) {
        // reusable fragment
        frag.reused = true;
        // update $index
        frag.scope.$index = i;
        // update $key
        if (key) {
          frag.scope.$key = key;
        }
        // update iterator
        if (iterator) {
          frag.scope[iterator] = key !== null ? key : i;
        }
        // update data for track-by, object repeat &
        // primitive values.
        if (trackByKey || convertedFromObject || primitive) {
          withoutConversion(function () {
            frag.scope[alias] = value;
          });
        }
      } else {
        // new instance
        frag = this.create(value, alias, i, key);
        frag.fresh = !init;
      }
      frags[i] = frag;
      if (init) {
        frag.before(end);
      }
    }

    // we're done for the initial render.
    if (init) {
      return;
    }

    // Second pass, go through the old fragments and
    // destroy those who are not reused (and remove them
    // from cache)
    var removalIndex = 0;
    var totalRemoved = oldFrags.length - frags.length;
    // when removing a large number of fragments, watcher removal
    // turns out to be a perf bottleneck, so we batch the watcher
    // removals into a single filter call!
    this.vm._vForRemoving = true;
    for (i = 0, l = oldFrags.length; i < l; i++) {
      frag = oldFrags[i];
      if (!frag.reused) {
        this.deleteCachedFrag(frag);
        this.remove(frag, removalIndex++, totalRemoved, inDocument);
      }
    }
    this.vm._vForRemoving = false;
    if (removalIndex) {
      this.vm._watchers = this.vm._watchers.filter(function (w) {
        return w.active;
      });
    }

    // Final pass, move/insert new fragments into the
    // right place.
    var targetPrev, prevEl, currentPrev;
    var insertionIndex = 0;
    for (i = 0, l = frags.length; i < l; i++) {
      frag = frags[i];
      // this is the frag that we should be after
      targetPrev = frags[i - 1];
      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
      if (frag.reused && !frag.staggerCb) {
        currentPrev = findPrevFrag(frag, start, this.id);
        if (currentPrev !== targetPrev && (!currentPrev ||
        // optimization for moving a single item.
        // thanks to suggestions by @livoras in #1807
        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
          this.move(frag, prevEl);
        }
      } else {
        // new instance, or still in stagger.
        // insert with updated stagger index.
        this.insert(frag, insertionIndex++, prevEl, inDocument);
      }
      frag.reused = frag.fresh = false;
    }
  },

  /**
   * Create a new fragment instance.
   *
   * @param {*} value
   * @param {String} alias
   * @param {Number} index
   * @param {String} [key]
   * @return {Fragment}
   */

  create: function create(value, alias, index, key) {
    var host = this._host;
    // create iteration scope
    var parentScope = this._scope || this.vm;
    var scope = Object.create(parentScope);
    // ref holder for the scope
    scope.$refs = Object.create(parentScope.$refs);
    scope.$els = Object.create(parentScope.$els);
    // make sure point $parent to parent scope
    scope.$parent = parentScope;
    // for two-way binding on alias
    scope.$forContext = this;
    // define scope properties
    // important: define the scope alias without forced conversion
    // so that frozen data structures remain non-reactive.
    withoutConversion(function () {
      defineReactive(scope, alias, value);
    });
    defineReactive(scope, '$index', index);
    if (key) {
      defineReactive(scope, '$key', key);
    } else if (scope.$key) {
      // avoid accidental fallback
      def(scope, '$key', null);
    }
    if (this.iterator) {
      defineReactive(scope, this.iterator, key !== null ? key : index);
    }
    var frag = this.factory.create(host, scope, this._frag);
    frag.forId = this.id;
    this.cacheFrag(value, frag, index, key);
    return frag;
  },

  /**
   * Update the v-ref on owner vm.
   */

  updateRef: function updateRef() {
    var ref = this.descriptor.ref;
    if (!ref) return;
    var hash = (this._scope || this.vm).$refs;
    var refs;
    if (!this.fromObject) {
      refs = this.frags.map(findVmFromFrag);
    } else {
      refs = {};
      this.frags.forEach(function (frag) {
        refs[frag.scope.$key] = findVmFromFrag(frag);
      });
    }
    hash[ref] = refs;
  },

  /**
   * For option lists, update the containing v-model on
   * parent <select>.
   */

  updateModel: function updateModel() {
    if (this.isOption) {
      var parent = this.start.parentNode;
      var model = parent && parent.__v_model;
      if (model) {
        model.forceUpdate();
      }
    }
  },

  /**
   * Insert a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Node} prevEl
   * @param {Boolean} inDocument
   */

  insert: function insert(frag, index, prevEl, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
    }
    var staggerAmount = this.getStagger(frag, index, null, 'enter');
    if (inDocument && staggerAmount) {
      // create an anchor and insert it synchronously,
      // so that we can resolve the correct order without
      // worrying about some elements not inserted yet
      var anchor = frag.staggerAnchor;
      if (!anchor) {
        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
        anchor.__v_frag = frag;
      }
      after(anchor, prevEl);
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.before(anchor);
        remove(anchor);
      });
      setTimeout(op, staggerAmount);
    } else {
      var target = prevEl.nextSibling;
      /* istanbul ignore if */
      if (!target) {
        // reset end anchor position in case the position was messed up
        // by an external drag-n-drop library.
        after(this.end, prevEl);
        target = this.end;
      }
      frag.before(target);
    }
  },

  /**
   * Remove a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {Boolean} inDocument
   */

  remove: function remove(frag, index, total, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
      // it's not possible for the same frag to be removed
      // twice, so if we have a pending stagger callback,
      // it means this frag is queued for enter but removed
      // before its transition started. Since it is already
      // destroyed, we can just leave it in detached state.
      return;
    }
    var staggerAmount = this.getStagger(frag, index, total, 'leave');
    if (inDocument && staggerAmount) {
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.remove();
      });
      setTimeout(op, staggerAmount);
    } else {
      frag.remove();
    }
  },

  /**
   * Move a fragment to a new position.
   * Force no transition.
   *
   * @param {Fragment} frag
   * @param {Node} prevEl
   */

  move: function move(frag, prevEl) {
    // fix a common issue with Sortable:
    // if prevEl doesn't have nextSibling, this means it's
    // been dragged after the end anchor. Just re-position
    // the end anchor to the end of the container.
    /* istanbul ignore if */
    if (!prevEl.nextSibling) {
      this.end.parentNode.appendChild(this.end);
    }
    frag.before(prevEl.nextSibling, false);
  },

  /**
   * Cache a fragment using track-by or the object key.
   *
   * @param {*} value
   * @param {Fragment} frag
   * @param {Number} index
   * @param {String} [key]
   */

  cacheFrag: function cacheFrag(value, frag, index, key) {
    var trackByKey = this.params.trackBy;
    var cache = this.cache;
    var primitive = !isObject(value);
    var id;
    if (key || trackByKey || primitive) {
      id = getTrackByKey(index, key, value, trackByKey);
      if (!cache[id]) {
        cache[id] = frag;
      } else if (trackByKey !== '$index') {
        process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
      }
    } else {
      id = this.id;
      if (hasOwn(value, id)) {
        if (value[id] === null) {
          value[id] = frag;
        } else {
          process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
        }
      } else if (Object.isExtensible(value)) {
        def(value, id, frag);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
      }
    }
    frag.raw = value;
  },

  /**
   * Get a cached fragment from the value/index/key
   *
   * @param {*} value
   * @param {Number} index
   * @param {String} key
   * @return {Fragment}
   */

  getCachedFrag: function getCachedFrag(value, index, key) {
    var trackByKey = this.params.trackBy;
    var primitive = !isObject(value);
    var frag;
    if (key || trackByKey || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      frag = this.cache[id];
    } else {
      frag = value[this.id];
    }
    if (frag && (frag.reused || frag.fresh)) {
      process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
    }
    return frag;
  },

  /**
   * Delete a fragment from cache.
   *
   * @param {Fragment} frag
   */

  deleteCachedFrag: function deleteCachedFrag(frag) {
    var value = frag.raw;
    var trackByKey = this.params.trackBy;
    var scope = frag.scope;
    var index = scope.$index;
    // fix #948: avoid accidentally fall through to
    // a parent repeater which happens to have $key.
    var key = hasOwn(scope, '$key') && scope.$key;
    var primitive = !isObject(value);
    if (trackByKey || key || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      this.cache[id] = null;
    } else {
      value[this.id] = null;
      frag.raw = null;
    }
  },

  /**
   * Get the stagger amount for an insertion/removal.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {String} type
   */

  getStagger: function getStagger(frag, index, total, type) {
    type = type + 'Stagger';
    var trans = frag.node.__v_trans;
    var hooks = trans && trans.hooks;
    var hook = hooks && (hooks[type] || hooks.stagger);
    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
  },

  /**
   * Pre-process the value before piping it through the
   * filters. This is passed to and called by the watcher.
   */

  _preProcess: function _preProcess(value) {
    // regardless of type, store the un-filtered raw value.
    this.rawValue = value;
    return value;
  },

  /**
   * Post-process the value after it has been piped through
   * the filters. This is passed to and called by the watcher.
   *
   * It is necessary for this to be called during the
   * watcher's dependency collection phase because we want
   * the v-for to update when the source Object is mutated.
   */

  _postProcess: function _postProcess(value) {
    if (isArray(value)) {
      return value;
    } else if (isPlainObject(value)) {
      // convert plain object to array.
      var keys = Object.keys(value);
      var i = keys.length;
      var res = new Array(i);
      var key;
      while (i--) {
        key = keys[i];
        res[i] = {
          $key: key,
          $value: value[key]
        };
      }
      return res;
    } else {
      if (typeof value === 'number' && !isNaN(value)) {
        value = range(value);
      }
      return value || [];
    }
  },

  unbind: function unbind() {
    if (this.descriptor.ref) {
      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
    }
    if (this.frags) {
      var i = this.frags.length;
      var frag;
      while (i--) {
        frag = this.frags[i];
        this.deleteCachedFrag(frag);
        frag.destroy();
      }
    }
  }
};

/**
 * Helper to find the previous element that is a fragment
 * anchor. This is necessary because a destroyed frag's
 * element could still be lingering in the DOM before its
 * leaving transition finishes, but its inserted flag
 * should have been set to false so we can skip them.
 *
 * If this is a block repeat, we want to make sure we only
 * return frag that is bound to this v-for. (see #929)
 *
 * @param {Fragment} frag
 * @param {Comment|Text} anchor
 * @param {String} id
 * @return {Fragment}
 */

function findPrevFrag(frag, anchor, id) {
  var el = frag.node.previousSibling;
  /* istanbul ignore if */
  if (!el) return;
  frag = el.__v_frag;
  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
    el = el.previousSibling;
    /* istanbul ignore if */
    if (!el) return;
    frag = el.__v_frag;
  }
  return frag;
}

/**
 * Create a range array from given number.
 *
 * @param {Number} n
 * @return {Array}
 */

function range(n) {
  var i = -1;
  var ret = new Array(Math.floor(n));
  while (++i < n) {
    ret[i] = i;
  }
  return ret;
}

/**
 * Get the track by key for an item.
 *
 * @param {Number} index
 * @param {String} key
 * @param {*} value
 * @param {String} [trackByKey]
 */

function getTrackByKey(index, key, value, trackByKey) {
  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
}

if (process.env.NODE_ENV !== 'production') {
  vFor.warnDuplicate = function (value) {
    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
  };
}

/**
 * Find a vm from a fragment.
 *
 * @param {Fragment} frag
 * @return {Vue|undefined}
 */

function findVmFromFrag(frag) {
  var node = frag.node;
  // handle multi-node frag
  if (frag.end) {
    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
      node = node.nextSibling;
    }
  }
  return node.__vue__;
}

var vIf = {

  priority: IF,
  terminal: true,

  bind: function bind() {
    var el = this.el;
    if (!el.__vue__) {
      // check else block
      var next = el.nextElementSibling;
      if (next && getAttr(next, 'v-else') !== null) {
        remove(next);
        this.elseEl = next;
      }
      // check main block
      this.anchor = createAnchor('v-if');
      replace(el, this.anchor);
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
      this.invalid = true;
    }
  },

  update: function update(value) {
    if (this.invalid) return;
    if (value) {
      if (!this.frag) {
        this.insert();
      }
    } else {
      this.remove();
    }
  },

  insert: function insert() {
    if (this.elseFrag) {
      this.elseFrag.remove();
      this.elseFrag = null;
    }
    // lazy init factory
    if (!this.factory) {
      this.factory = new FragmentFactory(this.vm, this.el);
    }
    this.frag = this.factory.create(this._host, this._scope, this._frag);
    this.frag.before(this.anchor);
  },

  remove: function remove() {
    if (this.frag) {
      this.frag.remove();
      this.frag = null;
    }
    if (this.elseEl && !this.elseFrag) {
      if (!this.elseFactory) {
        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
      }
      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
      this.elseFrag.before(this.anchor);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
    if (this.elseFrag) {
      this.elseFrag.destroy();
    }
  }
};

var show = {

  bind: function bind() {
    // check else block
    var next = this.el.nextElementSibling;
    if (next && getAttr(next, 'v-else') !== null) {
      this.elseEl = next;
    }
  },

  update: function update(value) {
    this.apply(this.el, value);
    if (this.elseEl) {
      this.apply(this.elseEl, !value);
    }
  },

  apply: function apply(el, value) {
    if (inDoc(el)) {
      applyTransition(el, value ? 1 : -1, toggle, this.vm);
    } else {
      toggle();
    }
    function toggle() {
      el.style.display = value ? '' : 'none';
    }
  }
};

var text$2 = {

  bind: function bind() {
    var self = this;
    var el = this.el;
    var isRange = el.type === 'range';
    var lazy = this.params.lazy;
    var number = this.params.number;
    var debounce = this.params.debounce;

    // handle composition events.
    //   http://blog.evanyou.me/2014/01/03/composition-event/
    // skip this for Android because it handles composition
    // events quite differently. Android doesn't trigger
    // composition events for language input methods e.g.
    // Chinese, but instead triggers them for spelling
    // suggestions... (see Discussion/#162)
    var composing = false;
    if (!isAndroid && !isRange) {
      this.on('compositionstart', function () {
        composing = true;
      });
      this.on('compositionend', function () {
        composing = false;
        // in IE11 the "compositionend" event fires AFTER
        // the "input" event, so the input handler is blocked
        // at the end... have to call it here.
        //
        // #1327: in lazy mode this is unecessary.
        if (!lazy) {
          self.listener();
        }
      });
    }

    // prevent messing with the input when user is typing,
    // and force update on blur.
    this.focused = false;
    if (!isRange && !lazy) {
      this.on('focus', function () {
        self.focused = true;
      });
      this.on('blur', function () {
        self.focused = false;
        // do not sync value after fragment removal (#2017)
        if (!self._frag || self._frag.inserted) {
          self.rawListener();
        }
      });
    }

    // Now attach the main listener
    this.listener = this.rawListener = function () {
      if (composing || !self._bound) {
        return;
      }
      var val = number || isRange ? toNumber(el.value) : el.value;
      self.set(val);
      // force update on next tick to avoid lock & same value
      // also only update when user is not typing
      nextTick(function () {
        if (self._bound && !self.focused) {
          self.update(self._watcher.value);
        }
      });
    };

    // apply debounce
    if (debounce) {
      this.listener = _debounce(this.listener, debounce);
    }

    // Support jQuery events, since jQuery.trigger() doesn't
    // trigger native events in some cases and some plugins
    // rely on $.trigger()
    //
    // We want to make sure if a listener is attached using
    // jQuery, it is also removed with jQuery, that's why
    // we do the check for each directive instance and
    // store that check result on itself. This also allows
    // easier test coverage control by unsetting the global
    // jQuery variable in tests.
    this.hasjQuery = typeof jQuery === 'function';
    if (this.hasjQuery) {
      var method = jQuery.fn.on ? 'on' : 'bind';
      jQuery(el)[method]('change', this.rawListener);
      if (!lazy) {
        jQuery(el)[method]('input', this.listener);
      }
    } else {
      this.on('change', this.rawListener);
      if (!lazy) {
        this.on('input', this.listener);
      }
    }

    // IE9 doesn't fire input event on backspace/del/cut
    if (!lazy && isIE9) {
      this.on('cut', function () {
        nextTick(self.listener);
      });
      this.on('keyup', function (e) {
        if (e.keyCode === 46 || e.keyCode === 8) {
          self.listener();
        }
      });
    }

    // set initial value if present
    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    // #3029 only update when the value changes. This prevent
    // browsers from overwriting values like selectionStart
    value = _toString(value);
    if (value !== this.el.value) this.el.value = value;
  },

  unbind: function unbind() {
    var el = this.el;
    if (this.hasjQuery) {
      var method = jQuery.fn.off ? 'off' : 'unbind';
      jQuery(el)[method]('change', this.listener);
      jQuery(el)[method]('input', this.listener);
    }
  }
};

var radio = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      // value overwrite via v-bind:value
      if (el.hasOwnProperty('_value')) {
        return el._value;
      }
      var val = el.value;
      if (self.params.number) {
        val = toNumber(val);
      }
      return val;
    };

    this.listener = function () {
      self.set(self.getValue());
    };
    this.on('change', this.listener);

    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    this.el.checked = looseEqual(value, this.getValue());
  }
};

var select = {

  bind: function bind() {
    var _this = this;

    var self = this;
    var el = this.el;

    // method to force update DOM using latest value.
    this.forceUpdate = function () {
      if (self._watcher) {
        self.update(self._watcher.get());
      }
    };

    // check if this is a multiple select
    var multiple = this.multiple = el.hasAttribute('multiple');

    // attach listener
    this.listener = function () {
      var value = getValue(el, multiple);
      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
      self.set(value);
    };
    this.on('change', this.listener);

    // if has initial value, set afterBind
    var initValue = getValue(el, multiple, true);
    if (multiple && initValue.length || !multiple && initValue !== null) {
      this.afterBind = this.listener;
    }

    // All major browsers except Firefox resets
    // selectedIndex with value -1 to 0 when the element
    // is appended to a new parent, therefore we have to
    // force a DOM update whenever that happens...
    this.vm.$on('hook:attached', function () {
      nextTick(_this.forceUpdate);
    });
    if (!inDoc(el)) {
      nextTick(this.forceUpdate);
    }
  },

  update: function update(value) {
    var el = this.el;
    el.selectedIndex = -1;
    var multi = this.multiple && isArray(value);
    var options = el.options;
    var i = options.length;
    var op, val;
    while (i--) {
      op = options[i];
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      /* eslint-disable eqeqeq */
      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
      /* eslint-enable eqeqeq */
    }
  },

  unbind: function unbind() {
    /* istanbul ignore next */
    this.vm.$off('hook:attached', this.forceUpdate);
  }
};

/**
 * Get select value
 *
 * @param {SelectElement} el
 * @param {Boolean} multi
 * @param {Boolean} init
 * @return {Array|*}
 */

function getValue(el, multi, init) {
  var res = multi ? [] : null;
  var op, val, selected;
  for (var i = 0, l = el.options.length; i < l; i++) {
    op = el.options[i];
    selected = init ? op.hasAttribute('selected') : op.selected;
    if (selected) {
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      if (multi) {
        res.push(val);
      } else {
        return val;
      }
    }
  }
  return res;
}

/**
 * Native Array.indexOf uses strict equal, but in this
 * case we need to match string/numbers with custom equal.
 *
 * @param {Array} arr
 * @param {*} val
 */

function indexOf$1(arr, val) {
  var i = arr.length;
  while (i--) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

var checkbox = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
    };

    function getBooleanValue() {
      var val = el.checked;
      if (val && el.hasOwnProperty('_trueValue')) {
        return el._trueValue;
      }
      if (!val && el.hasOwnProperty('_falseValue')) {
        return el._falseValue;
      }
      return val;
    }

    this.listener = function () {
      var model = self._watcher.get();
      if (isArray(model)) {
        var val = self.getValue();
        var i = indexOf(model, val);
        if (el.checked) {
          if (i < 0) {
            self.set(model.concat(val));
          }
        } else if (i > -1) {
          self.set(model.slice(0, i).concat(model.slice(i + 1)));
        }
      } else {
        self.set(getBooleanValue());
      }
    };

    this.on('change', this.listener);
    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    var el = this.el;
    if (isArray(value)) {
      el.checked = indexOf(value, this.getValue()) > -1;
    } else {
      if (el.hasOwnProperty('_trueValue')) {
        el.checked = looseEqual(value, el._trueValue);
      } else {
        el.checked = !!value;
      }
    }
  }
};

var handlers = {
  text: text$2,
  radio: radio,
  select: select,
  checkbox: checkbox
};

var model = {

  priority: MODEL,
  twoWay: true,
  handlers: handlers,
  params: ['lazy', 'number', 'debounce'],

  /**
   * Possible elements:
   *   <select>
   *   <textarea>
   *   <input type="*">
   *     - text
   *     - checkbox
   *     - radio
   *     - number
   */

  bind: function bind() {
    // friendly warning...
    this.checkFilters();
    if (this.hasRead && !this.hasWrite) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
    }
    var el = this.el;
    var tag = el.tagName;
    var handler;
    if (tag === 'INPUT') {
      handler = handlers[el.type] || handlers.text;
    } else if (tag === 'SELECT') {
      handler = handlers.select;
    } else if (tag === 'TEXTAREA') {
      handler = handlers.text;
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
      return;
    }
    el.__v_model = this;
    handler.bind.call(this);
    this.update = handler.update;
    this._unbind = handler.unbind;
  },

  /**
   * Check read/write filter stats.
   */

  checkFilters: function checkFilters() {
    var filters = this.filters;
    if (!filters) return;
    var i = filters.length;
    while (i--) {
      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
      if (typeof filter === 'function' || filter.read) {
        this.hasRead = true;
      }
      if (filter.write) {
        this.hasWrite = true;
      }
    }
  },

  unbind: function unbind() {
    this.el.__v_model = null;
    this._unbind && this._unbind();
  }
};

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  'delete': [8, 46],
  up: 38,
  left: 37,
  right: 39,
  down: 40
};

function keyFilter(handler, keys) {
  var codes = keys.map(function (key) {
    var charCode = key.charCodeAt(0);
    if (charCode > 47 && charCode < 58) {
      return parseInt(key, 10);
    }
    if (key.length === 1) {
      charCode = key.toUpperCase().charCodeAt(0);
      if (charCode > 64 && charCode < 91) {
        return charCode;
      }
    }
    return keyCodes[key];
  });
  codes = [].concat.apply([], codes);
  return function keyHandler(e) {
    if (codes.indexOf(e.keyCode) > -1) {
      return handler.call(this, e);
    }
  };
}

function stopFilter(handler) {
  return function stopHandler(e) {
    e.stopPropagation();
    return handler.call(this, e);
  };
}

function preventFilter(handler) {
  return function preventHandler(e) {
    e.preventDefault();
    return handler.call(this, e);
  };
}

function selfFilter(handler) {
  return function selfHandler(e) {
    if (e.target === e.currentTarget) {
      return handler.call(this, e);
    }
  };
}

var on$1 = {

  priority: ON,
  acceptStatement: true,
  keyCodes: keyCodes,

  bind: function bind() {
    // deal with iframes
    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
      var self = this;
      this.iframeBind = function () {
        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
      };
      this.on('load', this.iframeBind);
    }
  },

  update: function update(handler) {
    // stub a noop for v-on with no value,
    // e.g. @mousedown.prevent
    if (!this.descriptor.raw) {
      handler = function () {};
    }

    if (typeof handler !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
      return;
    }

    // apply modifiers
    if (this.modifiers.stop) {
      handler = stopFilter(handler);
    }
    if (this.modifiers.prevent) {
      handler = preventFilter(handler);
    }
    if (this.modifiers.self) {
      handler = selfFilter(handler);
    }
    // key filter
    var keys = Object.keys(this.modifiers).filter(function (key) {
      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
    });
    if (keys.length) {
      handler = keyFilter(handler, keys);
    }

    this.reset();
    this.handler = handler;

    if (this.iframeBind) {
      this.iframeBind();
    } else {
      on(this.el, this.arg, this.handler, this.modifiers.capture);
    }
  },

  reset: function reset() {
    var el = this.iframeBind ? this.el.contentWindow : this.el;
    if (this.handler) {
      off(el, this.arg, this.handler);
    }
  },

  unbind: function unbind() {
    this.reset();
  }
};

var prefixes = ['-webkit-', '-moz-', '-ms-'];
var camelPrefixes = ['Webkit', 'Moz', 'ms'];
var importantRE = /!important;?$/;
var propCache = Object.create(null);

var testEl = null;

var style = {

  deep: true,

  update: function update(value) {
    if (typeof value === 'string') {
      this.el.style.cssText = value;
    } else if (isArray(value)) {
      this.handleObject(value.reduce(extend, {}));
    } else {
      this.handleObject(value || {});
    }
  },

  handleObject: function handleObject(value) {
    // cache object styles so that only changed props
    // are actually updated.
    var cache = this.cache || (this.cache = {});
    var name, val;
    for (name in cache) {
      if (!(name in value)) {
        this.handleSingle(name, null);
        delete cache[name];
      }
    }
    for (name in value) {
      val = value[name];
      if (val !== cache[name]) {
        cache[name] = val;
        this.handleSingle(name, val);
      }
    }
  },

  handleSingle: function handleSingle(prop, value) {
    prop = normalize(prop);
    if (!prop) return; // unsupported prop
    // cast possible numbers/booleans into strings
    if (value != null) value += '';
    if (value) {
      var isImportant = importantRE.test(value) ? 'important' : '';
      if (isImportant) {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
        }
        value = value.replace(importantRE, '').trim();
        this.el.style.setProperty(prop.kebab, value, isImportant);
      } else {
        this.el.style[prop.camel] = value;
      }
    } else {
      this.el.style[prop.camel] = '';
    }
  }

};

/**
 * Normalize a CSS property name.
 * - cache result
 * - auto prefix
 * - camelCase -> dash-case
 *
 * @param {String} prop
 * @return {String}
 */

function normalize(prop) {
  if (propCache[prop]) {
    return propCache[prop];
  }
  var res = prefix(prop);
  propCache[prop] = propCache[res] = res;
  return res;
}

/**
 * Auto detect the appropriate prefix for a CSS property.
 * https://gist.github.com/paulirish/523692
 *
 * @param {String} prop
 * @return {String}
 */

function prefix(prop) {
  prop = hyphenate(prop);
  var camel = camelize(prop);
  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
  if (!testEl) {
    testEl = document.createElement('div');
  }
  var i = prefixes.length;
  var prefixed;
  if (camel !== 'filter' && camel in testEl.style) {
    return {
      kebab: prop,
      camel: camel
    };
  }
  while (i--) {
    prefixed = camelPrefixes[i] + upper;
    if (prefixed in testEl.style) {
      return {
        kebab: prefixes[i] + prop,
        camel: prefixed
      };
    }
  }
}

// xlink
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xlinkRE = /^xlink:/;

// check for attributes that prohibit interpolations
var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
// these attributes should also set their corresponding properties
// because they only affect the initial state of the element
var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
// these attributes expect enumrated values of "true" or "false"
// but are not boolean attributes
var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;

// these attributes should set a hidden property for
// binding v-model to object values
var modelProps = {
  value: '_value',
  'true-value': '_trueValue',
  'false-value': '_falseValue'
};

var bind$1 = {

  priority: BIND,

  bind: function bind() {
    var attr = this.arg;
    var tag = this.el.tagName;
    // should be deep watch on object mode
    if (!attr) {
      this.deep = true;
    }
    // handle interpolation bindings
    var descriptor = this.descriptor;
    var tokens = descriptor.interp;
    if (tokens) {
      // handle interpolations with one-time tokens
      if (descriptor.hasOneTime) {
        this.expression = tokensToExp(tokens, this._scope || this.vm);
      }

      // only allow binding on native attributes
      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
        process.env.NODE_ENV !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
        this.el.removeAttribute(attr);
        this.invalid = true;
      }

      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production') {
        var raw = attr + '="' + descriptor.raw + '": ';
        // warn src
        if (attr === 'src') {
          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
        }

        // warn style
        if (attr === 'style') {
          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
        }
      }
    }
  },

  update: function update(value) {
    if (this.invalid) {
      return;
    }
    var attr = this.arg;
    if (this.arg) {
      this.handleSingle(attr, value);
    } else {
      this.handleObject(value || {});
    }
  },

  // share object handler with v-bind:class
  handleObject: style.handleObject,

  handleSingle: function handleSingle(attr, value) {
    var el = this.el;
    var interp = this.descriptor.interp;
    if (this.modifiers.camel) {
      attr = camelize(attr);
    }
    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
      ? '' : value : value;

      if (el[attr] !== attrValue) {
        el[attr] = attrValue;
      }
    }
    // set model props
    var modelProp = modelProps[attr];
    if (!interp && modelProp) {
      el[modelProp] = value;
      // update v-model if present
      var model = el.__v_model;
      if (model) {
        model.listener();
      }
    }
    // do not set value attribute for textarea
    if (attr === 'value' && el.tagName === 'TEXTAREA') {
      el.removeAttribute(attr);
      return;
    }
    // update attribute
    if (enumeratedAttrRE.test(attr)) {
      el.setAttribute(attr, value ? 'true' : 'false');
    } else if (value != null && value !== false) {
      if (attr === 'class') {
        // handle edge case #1960:
        // class interpolation should not overwrite Vue transition class
        if (el.__v_trans) {
          value += ' ' + el.__v_trans.id + '-transition';
        }
        setClass(el, value);
      } else if (xlinkRE.test(attr)) {
        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
      } else {
        el.setAttribute(attr, value === true ? '' : value);
      }
    } else {
      el.removeAttribute(attr);
    }
  }
};

var el = {

  priority: EL,

  bind: function bind() {
    /* istanbul ignore if */
    if (!this.arg) {
      return;
    }
    var id = this.id = camelize(this.arg);
    var refs = (this._scope || this.vm).$els;
    if (hasOwn(refs, id)) {
      refs[id] = this.el;
    } else {
      defineReactive(refs, id, this.el);
    }
  },

  unbind: function unbind() {
    var refs = (this._scope || this.vm).$els;
    if (refs[this.id] === this.el) {
      refs[this.id] = null;
    }
  }
};

var ref = {
  bind: function bind() {
    process.env.NODE_ENV !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
  }
};

var cloak = {
  bind: function bind() {
    var el = this.el;
    this.vm.$once('pre-hook:compiled', function () {
      el.removeAttribute('v-cloak');
    });
  }
};

// logic control
// two-way binding
// event handling
// attributes
// ref & el
// cloak
// must export plain object
var directives = {
  text: text$1,
  html: html,
  'for': vFor,
  'if': vIf,
  show: show,
  model: model,
  on: on$1,
  bind: bind$1,
  el: el,
  ref: ref,
  cloak: cloak
};

var vClass = {

  deep: true,

  update: function update(value) {
    if (!value) {
      this.cleanup();
    } else if (typeof value === 'string') {
      this.setClass(value.trim().split(/\s+/));
    } else {
      this.setClass(normalize$1(value));
    }
  },

  setClass: function setClass(value) {
    this.cleanup(value);
    for (var i = 0, l = value.length; i < l; i++) {
      var val = value[i];
      if (val) {
        apply(this.el, val, addClass);
      }
    }
    this.prevKeys = value;
  },

  cleanup: function cleanup(value) {
    var prevKeys = this.prevKeys;
    if (!prevKeys) return;
    var i = prevKeys.length;
    while (i--) {
      var key = prevKeys[i];
      if (!value || value.indexOf(key) < 0) {
        apply(this.el, key, removeClass);
      }
    }
  }
};

/**
 * Normalize objects and arrays (potentially containing objects)
 * into array of strings.
 *
 * @param {Object|Array<String|Object>} value
 * @return {Array<String>}
 */

function normalize$1(value) {
  var res = [];
  if (isArray(value)) {
    for (var i = 0, l = value.length; i < l; i++) {
      var _key = value[i];
      if (_key) {
        if (typeof _key === 'string') {
          res.push(_key);
        } else {
          for (var k in _key) {
            if (_key[k]) res.push(k);
          }
        }
      }
    }
  } else if (isObject(value)) {
    for (var key in value) {
      if (value[key]) res.push(key);
    }
  }
  return res;
}

/**
 * Add or remove a class/classes on an element
 *
 * @param {Element} el
 * @param {String} key The class name. This may or may not
 *                     contain a space character, in such a
 *                     case we'll deal with multiple class
 *                     names at once.
 * @param {Function} fn
 */

function apply(el, key, fn) {
  key = key.trim();
  if (key.indexOf(' ') === -1) {
    fn(el, key);
    return;
  }
  // The key contains one or more space characters.
  // Since a class name doesn't accept such characters, we
  // treat it as multiple classes.
  var keys = key.split(/\s+/);
  for (var i = 0, l = keys.length; i < l; i++) {
    fn(el, keys[i]);
  }
}

var component = {

  priority: COMPONENT,

  params: ['keep-alive', 'transition-mode', 'inline-template'],

  /**
   * Setup. Two possible usages:
   *
   * - static:
   *   <comp> or <div v-component="comp">
   *
   * - dynamic:
   *   <component :is="view">
   */

  bind: function bind() {
    if (!this.el.__vue__) {
      // keep-alive cache
      this.keepAlive = this.params.keepAlive;
      if (this.keepAlive) {
        this.cache = {};
      }
      // check inline-template
      if (this.params.inlineTemplate) {
        // extract inline template as a DocumentFragment
        this.inlineTemplate = extractContent(this.el, true);
      }
      // component resolution related state
      this.pendingComponentCb = this.Component = null;
      // transition related state
      this.pendingRemovals = 0;
      this.pendingRemovalCb = null;
      // create a ref anchor
      this.anchor = createAnchor('v-component');
      replace(this.el, this.anchor);
      // remove is attribute.
      // this is removed during compilation, but because compilation is
      // cached, when the component is used elsewhere this attribute
      // will remain at link time.
      this.el.removeAttribute('is');
      this.el.removeAttribute(':is');
      // remove ref, same as above
      if (this.descriptor.ref) {
        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
      }
      // if static, build right now.
      if (this.literal) {
        this.setComponent(this.expression);
      }
    } else {
      process.env.NODE_ENV !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
    }
  },

  /**
   * Public update, called by the watcher in the dynamic
   * literal scenario, e.g. <component :is="view">
   */

  update: function update(value) {
    if (!this.literal) {
      this.setComponent(value);
    }
  },

  /**
   * Switch dynamic components. May resolve the component
   * asynchronously, and perform transition based on
   * specified transition mode. Accepts a few additional
   * arguments specifically for vue-router.
   *
   * The callback is called when the full transition is
   * finished.
   *
   * @param {String} value
   * @param {Function} [cb]
   */

  setComponent: function setComponent(value, cb) {
    this.invalidatePending();
    if (!value) {
      // just remove current
      this.unbuild(true);
      this.remove(this.childVM, cb);
      this.childVM = null;
    } else {
      var self = this;
      this.resolveComponent(value, function () {
        self.mountComponent(cb);
      });
    }
  },

  /**
   * Resolve the component constructor to use when creating
   * the child vm.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  resolveComponent: function resolveComponent(value, cb) {
    var self = this;
    this.pendingComponentCb = cancellable(function (Component) {
      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
      self.Component = Component;
      cb();
    });
    this.vm._resolveComponent(value, this.pendingComponentCb);
  },

  /**
   * Create a new instance using the current constructor and
   * replace the existing instance. This method doesn't care
   * whether the new component and the old one are actually
   * the same.
   *
   * @param {Function} [cb]
   */

  mountComponent: function mountComponent(cb) {
    // actual mount
    this.unbuild(true);
    var self = this;
    var activateHooks = this.Component.options.activate;
    var cached = this.getCached();
    var newComponent = this.build();
    if (activateHooks && !cached) {
      this.waitingFor = newComponent;
      callActivateHooks(activateHooks, newComponent, function () {
        if (self.waitingFor !== newComponent) {
          return;
        }
        self.waitingFor = null;
        self.transition(newComponent, cb);
      });
    } else {
      // update ref for kept-alive component
      if (cached) {
        newComponent._updateRef();
      }
      this.transition(newComponent, cb);
    }
  },

  /**
   * When the component changes or unbinds before an async
   * constructor is resolved, we need to invalidate its
   * pending callback.
   */

  invalidatePending: function invalidatePending() {
    if (this.pendingComponentCb) {
      this.pendingComponentCb.cancel();
      this.pendingComponentCb = null;
    }
  },

  /**
   * Instantiate/insert a new child vm.
   * If keep alive and has cached instance, insert that
   * instance; otherwise build a new one and cache it.
   *
   * @param {Object} [extraOptions]
   * @return {Vue} - the created instance
   */

  build: function build(extraOptions) {
    var cached = this.getCached();
    if (cached) {
      return cached;
    }
    if (this.Component) {
      // default options
      var options = {
        name: this.ComponentName,
        el: cloneNode(this.el),
        template: this.inlineTemplate,
        // make sure to add the child with correct parent
        // if this is a transcluded component, its parent
        // should be the transclusion host.
        parent: this._host || this.vm,
        // if no inline-template, then the compiled
        // linker can be cached for better performance.
        _linkerCachable: !this.inlineTemplate,
        _ref: this.descriptor.ref,
        _asComponent: true,
        _isRouterView: this._isRouterView,
        // if this is a transcluded component, context
        // will be the common parent vm of this instance
        // and its host.
        _context: this.vm,
        // if this is inside an inline v-for, the scope
        // will be the intermediate scope created for this
        // repeat fragment. this is used for linking props
        // and container directives.
        _scope: this._scope,
        // pass in the owner fragment of this component.
        // this is necessary so that the fragment can keep
        // track of its contained components in order to
        // call attach/detach hooks for them.
        _frag: this._frag
      };
      // extra options
      // in 1.0.0 this is used by vue-router only
      /* istanbul ignore if */
      if (extraOptions) {
        extend(options, extraOptions);
      }
      var child = new this.Component(options);
      if (this.keepAlive) {
        this.cache[this.Component.cid] = child;
      }
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('transition') && child._isFragment) {
        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
      }
      return child;
    }
  },

  /**
   * Try to get a cached instance of the current component.
   *
   * @return {Vue|undefined}
   */

  getCached: function getCached() {
    return this.keepAlive && this.cache[this.Component.cid];
  },

  /**
   * Teardown the current child, but defers cleanup so
   * that we can separate the destroy and removal steps.
   *
   * @param {Boolean} defer
   */

  unbuild: function unbuild(defer) {
    if (this.waitingFor) {
      if (!this.keepAlive) {
        this.waitingFor.$destroy();
      }
      this.waitingFor = null;
    }
    var child = this.childVM;
    if (!child || this.keepAlive) {
      if (child) {
        // remove ref
        child._inactive = true;
        child._updateRef(true);
      }
      return;
    }
    // the sole purpose of `deferCleanup` is so that we can
    // "deactivate" the vm right now and perform DOM removal
    // later.
    child.$destroy(false, defer);
  },

  /**
   * Remove current destroyed child and manually do
   * the cleanup after removal.
   *
   * @param {Function} cb
   */

  remove: function remove(child, cb) {
    var keepAlive = this.keepAlive;
    if (child) {
      // we may have a component switch when a previous
      // component is still being transitioned out.
      // we want to trigger only one lastest insertion cb
      // when the existing transition finishes. (#1119)
      this.pendingRemovals++;
      this.pendingRemovalCb = cb;
      var self = this;
      child.$remove(function () {
        self.pendingRemovals--;
        if (!keepAlive) child._cleanup();
        if (!self.pendingRemovals && self.pendingRemovalCb) {
          self.pendingRemovalCb();
          self.pendingRemovalCb = null;
        }
      });
    } else if (cb) {
      cb();
    }
  },

  /**
   * Actually swap the components, depending on the
   * transition mode. Defaults to simultaneous.
   *
   * @param {Vue} target
   * @param {Function} [cb]
   */

  transition: function transition(target, cb) {
    var self = this;
    var current = this.childVM;
    // for devtool inspection
    if (current) current._inactive = true;
    target._inactive = false;
    this.childVM = target;
    switch (self.params.transitionMode) {
      case 'in-out':
        target.$before(self.anchor, function () {
          self.remove(current, cb);
        });
        break;
      case 'out-in':
        self.remove(current, function () {
          target.$before(self.anchor, cb);
        });
        break;
      default:
        self.remove(current);
        target.$before(self.anchor, cb);
    }
  },

  /**
   * Unbind.
   */

  unbind: function unbind() {
    this.invalidatePending();
    // Do not defer cleanup when unbinding
    this.unbuild();
    // destroy all keep-alive cached instances
    if (this.cache) {
      for (var key in this.cache) {
        this.cache[key].$destroy();
      }
      this.cache = null;
    }
  }
};

/**
 * Call activate hooks in order (asynchronous)
 *
 * @param {Array} hooks
 * @param {Vue} vm
 * @param {Function} cb
 */

function callActivateHooks(hooks, vm, cb) {
  var total = hooks.length;
  var called = 0;
  hooks[0].call(vm, next);
  function next() {
    if (++called >= total) {
      cb();
    } else {
      hooks[called].call(vm, next);
    }
  }
}

var propBindingModes = config._propBindingModes;
var empty = {};

// regexes
var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;

/**
 * Compile props on a root element and return
 * a props link function.
 *
 * @param {Element|DocumentFragment} el
 * @param {Array} propOptions
 * @param {Vue} vm
 * @return {Function} propsLinkFn
 */

function compileProps(el, propOptions, vm) {
  var props = [];
  var propsData = vm.$options.propsData;
  var names = Object.keys(propOptions);
  var i = names.length;
  var options, name, attr, value, path, parsed, prop;
  while (i--) {
    name = names[i];
    options = propOptions[name] || empty;

    if (process.env.NODE_ENV !== 'production' && name === '$data') {
      warn('Do not use $data as prop.', vm);
      continue;
    }

    // props could contain dashes, which will be
    // interpreted as minus calculations by the parser
    // so we need to camelize the path here
    path = camelize(name);
    if (!identRE$1.test(path)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
      continue;
    }

    prop = {
      name: name,
      path: path,
      options: options,
      mode: propBindingModes.ONE_WAY,
      raw: null
    };

    attr = hyphenate(name);
    // first check dynamic version
    if ((value = getBindAttr(el, attr)) === null) {
      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
        prop.mode = propBindingModes.TWO_WAY;
      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
        prop.mode = propBindingModes.ONE_TIME;
      }
    }
    if (value !== null) {
      // has dynamic binding!
      prop.raw = value;
      parsed = parseDirective(value);
      value = parsed.expression;
      prop.filters = parsed.filters;
      // check binding type
      if (isLiteral(value) && !parsed.filters) {
        // for expressions containing literal numbers and
        // booleans, there's no need to setup a prop binding,
        // so we can optimize them as a one-time set.
        prop.optimizedLiteral = true;
      } else {
        prop.dynamic = true;
        // check non-settable path for two-way bindings
        if (process.env.NODE_ENV !== 'production' && prop.mode === propBindingModes.TWO_WAY && !settablePathRE.test(value)) {
          prop.mode = propBindingModes.ONE_WAY;
          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
        }
      }
      prop.parentPath = value;

      // warn required two-way
      if (process.env.NODE_ENV !== 'production' && options.twoWay && prop.mode !== propBindingModes.TWO_WAY) {
        warn('Prop "' + name + '" expects a two-way binding type.', vm);
      }
    } else if ((value = getAttr(el, attr)) !== null) {
      // has literal binding!
      prop.raw = value;
    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
      // has propsData
      prop.raw = value;
    } else if (process.env.NODE_ENV !== 'production') {
      // check possible camelCase prop usage
      var lowerCaseName = path.toLowerCase();
      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
      if (value) {
        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
        // warn missing required
        warn('Missing required prop: ' + name, vm);
      }
    }
    // push prop
    props.push(prop);
  }
  return makePropsLinkFn(props);
}

/**
 * Build a function that applies props to a vm.
 *
 * @param {Array} props
 * @return {Function} propsLinkFn
 */

function makePropsLinkFn(props) {
  return function propsLinkFn(vm, scope) {
    // store resolved props info
    vm._props = {};
    var inlineProps = vm.$options.propsData;
    var i = props.length;
    var prop, path, options, value, raw;
    while (i--) {
      prop = props[i];
      raw = prop.raw;
      path = prop.path;
      options = prop.options;
      vm._props[path] = prop;
      if (inlineProps && hasOwn(inlineProps, path)) {
        initProp(vm, prop, inlineProps[path]);
      }if (raw === null) {
        // initialize absent prop
        initProp(vm, prop, undefined);
      } else if (prop.dynamic) {
        // dynamic prop
        if (prop.mode === propBindingModes.ONE_TIME) {
          // one time binding
          value = (scope || vm._context || vm).$get(prop.parentPath);
          initProp(vm, prop, value);
        } else {
          if (vm._context) {
            // dynamic binding
            vm._bindDir({
              name: 'prop',
              def: propDef,
              prop: prop
            }, null, null, scope); // el, host, scope
          } else {
              // root instance
              initProp(vm, prop, vm.$get(prop.parentPath));
            }
        }
      } else if (prop.optimizedLiteral) {
        // optimized literal, cast it and just set once
        var stripped = stripQuotes(raw);
        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
        initProp(vm, prop, value);
      } else {
        // string literal, but we need to cater for
        // Boolean props with no value, or with same
        // literal value (e.g. disabled="disabled")
        // see https://github.com/vuejs/vue-loader/issues/182
        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
        initProp(vm, prop, value);
      }
    }
  };
}

/**
 * Process a prop with a rawValue, applying necessary coersions,
 * default values & assertions and call the given callback with
 * processed value.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} rawValue
 * @param {Function} fn
 */

function processPropValue(vm, prop, rawValue, fn) {
  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
  var value = rawValue;
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop);
  }
  value = coerceProp(prop, value, vm);
  var coerced = value !== rawValue;
  if (!assertProp(prop, value, vm)) {
    value = undefined;
  }
  if (isSimple && !coerced) {
    withoutConversion(function () {
      fn(value);
    });
  } else {
    fn(value);
  }
}

/**
 * Set a prop's initial value on a vm and its data object.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function initProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    defineReactive(vm, prop.path, value);
  });
}

/**
 * Update a prop's value on a vm.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function updateProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    vm[prop.path] = value;
  });
}

/**
 * Get the default value of a prop.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @return {*}
 */

function getPropDefaultValue(vm, prop) {
  // no default, return undefined
  var options = prop.options;
  if (!hasOwn(options, 'default')) {
    // absent boolean value defaults to false
    return options.type === Boolean ? false : undefined;
  }
  var def = options['default'];
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    process.env.NODE_ENV !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // call factory function for non-Function types
  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 *
 * @param {Object} prop
 * @param {*} value
 * @param {Vue} vm
 */

function assertProp(prop, value, vm) {
  if (!prop.options.required && ( // non-required
  prop.raw === null || // abscent
  value == null) // null or undefined
  ) {
      return true;
    }
  var options = prop.options;
  var type = options.type;
  var valid = !type;
  var expectedTypes = [];
  if (type) {
    if (!isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType);
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    if (process.env.NODE_ENV !== 'production') {
      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
    }
    return false;
  }
  var validator = options.validator;
  if (validator) {
    if (!validator(value)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
      return false;
    }
  }
  return true;
}

/**
 * Force parsing value with coerce option.
 *
 * @param {*} value
 * @param {Object} options
 * @return {*}
 */

function coerceProp(prop, value, vm) {
  var coerce = prop.options.coerce;
  if (!coerce) {
    return value;
  }
  if (typeof coerce === 'function') {
    return coerce(value);
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
    return value;
  }
}

/**
 * Assert the type of a value
 *
 * @param {*} value
 * @param {Function} type
 * @return {Object}
 */

function assertType(value, type) {
  var valid;
  var expectedType;
  if (type === String) {
    expectedType = 'string';
    valid = typeof value === expectedType;
  } else if (type === Number) {
    expectedType = 'number';
    valid = typeof value === expectedType;
  } else if (type === Boolean) {
    expectedType = 'boolean';
    valid = typeof value === expectedType;
  } else if (type === Function) {
    expectedType = 'function';
    valid = typeof value === expectedType;
  } else if (type === Object) {
    expectedType = 'object';
    valid = isPlainObject(value);
  } else if (type === Array) {
    expectedType = 'array';
    valid = isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

/**
 * Format type for output
 *
 * @param {String} type
 * @return {String}
 */

function formatType(type) {
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
}

/**
 * Format value
 *
 * @param {*} value
 * @return {String}
 */

function formatValue(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}

var bindingModes = config._propBindingModes;

var propDef = {

  bind: function bind() {
    var child = this.vm;
    var parent = child._context;
    // passed in from compiler directly
    var prop = this.descriptor.prop;
    var childKey = prop.path;
    var parentKey = prop.parentPath;
    var twoWay = prop.mode === bindingModes.TWO_WAY;

    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
      updateProp(child, prop, val);
    }, {
      twoWay: twoWay,
      filters: prop.filters,
      // important: props need to be observed on the
      // v-for scope if present
      scope: this._scope
    });

    // set the child initial value.
    initProp(child, prop, parentWatcher.value);

    // setup two-way binding
    if (twoWay) {
      // important: defer the child watcher creation until
      // the created hook (after data observation)
      var self = this;
      child.$once('pre-hook:created', function () {
        self.childWatcher = new Watcher(child, childKey, function (val) {
          parentWatcher.set(val);
        }, {
          // ensure sync upward before parent sync down.
          // this is necessary in cases e.g. the child
          // mutates a prop array, then replaces it. (#1683)
          sync: true
        });
      });
    }
  },

  unbind: function unbind() {
    this.parentWatcher.teardown();
    if (this.childWatcher) {
      this.childWatcher.teardown();
    }
  }
};

var queue$1 = [];
var queued = false;

/**
 * Push a job into the queue.
 *
 * @param {Function} job
 */

function pushJob(job) {
  queue$1.push(job);
  if (!queued) {
    queued = true;
    nextTick(flush);
  }
}

/**
 * Flush the queue, and do one forced reflow before
 * triggering transitions.
 */

function flush() {
  // Force layout
  var f = document.documentElement.offsetHeight;
  for (var i = 0; i < queue$1.length; i++) {
    queue$1[i]();
  }
  queue$1 = [];
  queued = false;
  // dummy return, so js linters don't complain about
  // unused variable f
  return f;
}

var TYPE_TRANSITION = 'transition';
var TYPE_ANIMATION = 'animation';
var transDurationProp = transitionProp + 'Duration';
var animDurationProp = animationProp + 'Duration';

/**
 * If a just-entered element is applied the
 * leave class while its enter transition hasn't started yet,
 * and the transitioned property has the same value for both
 * enter/leave, then the leave transition will be skipped and
 * the transitionend event never fires. This function ensures
 * its callback to be called after a transition has started
 * by waiting for double raf.
 *
 * It falls back to setTimeout on devices that support CSS
 * transitions but not raf (e.g. Android 4.2 browser) - since
 * these environments are usually slow, we are giving it a
 * relatively large timeout.
 */

var raf = inBrowser && window.requestAnimationFrame;
var waitForTransitionStart = raf
/* istanbul ignore next */
? function (fn) {
  raf(function () {
    raf(fn);
  });
} : function (fn) {
  setTimeout(fn, 50);
};

/**
 * A Transition object that encapsulates the state and logic
 * of the transition.
 *
 * @param {Element} el
 * @param {String} id
 * @param {Object} hooks
 * @param {Vue} vm
 */
function Transition(el, id, hooks, vm) {
  this.id = id;
  this.el = el;
  this.enterClass = hooks && hooks.enterClass || id + '-enter';
  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
  this.hooks = hooks;
  this.vm = vm;
  // async state
  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
  this.justEntered = false;
  this.entered = this.left = false;
  this.typeCache = {};
  // check css transition type
  this.type = hooks && hooks.type;
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production') {
    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
    }
  }
  // bind
  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
    self[m] = bind(self[m], self);
  });
}

var p$1 = Transition.prototype;

/**
 * Start an entering transition.
 *
 * 1. enter transition triggered
 * 2. call beforeEnter hook
 * 3. add enter class
 * 4. insert/show element
 * 5. call enter hook (with possible explicit js callback)
 * 6. reflow
 * 7. based on transition type:
 *    - transition:
 *        remove class now, wait for transitionend,
 *        then done if there's no explicit js callback.
 *    - animation:
 *        wait for animationend, remove class,
 *        then done if there's no explicit js callback.
 *    - no css transition:
 *        done now if there's no explicit js callback.
 * 8. wait for either done or js callback, then call
 *    afterEnter hook.
 *
 * @param {Function} op - insert/show the element
 * @param {Function} [cb]
 */

p$1.enter = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeEnter');
  this.cb = cb;
  addClass(this.el, this.enterClass);
  op();
  this.entered = false;
  this.callHookWithCb('enter');
  if (this.entered) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.enterCancelled;
  pushJob(this.enterNextTick);
};

/**
 * The "nextTick" phase of an entering transition, which is
 * to be pushed into a queue and executed after a reflow so
 * that removing the class can trigger a CSS transition.
 */

p$1.enterNextTick = function () {
  var _this = this;

  // prevent transition skipping
  this.justEntered = true;
  waitForTransitionStart(function () {
    _this.justEntered = false;
  });
  var enterDone = this.enterDone;
  var type = this.getCssTransitionType(this.enterClass);
  if (!this.pendingJsCb) {
    if (type === TYPE_TRANSITION) {
      // trigger transition by removing enter class now
      removeClass(this.el, this.enterClass);
      this.setupCssCb(transitionEndEvent, enterDone);
    } else if (type === TYPE_ANIMATION) {
      this.setupCssCb(animationEndEvent, enterDone);
    } else {
      enterDone();
    }
  } else if (type === TYPE_TRANSITION) {
    removeClass(this.el, this.enterClass);
  }
};

/**
 * The "cleanup" phase of an entering transition.
 */

p$1.enterDone = function () {
  this.entered = true;
  this.cancel = this.pendingJsCb = null;
  removeClass(this.el, this.enterClass);
  this.callHook('afterEnter');
  if (this.cb) this.cb();
};

/**
 * Start a leaving transition.
 *
 * 1. leave transition triggered.
 * 2. call beforeLeave hook
 * 3. add leave class (trigger css transition)
 * 4. call leave hook (with possible explicit js callback)
 * 5. reflow if no explicit js callback is provided
 * 6. based on transition type:
 *    - transition or animation:
 *        wait for end event, remove class, then done if
 *        there's no explicit js callback.
 *    - no css transition:
 *        done if there's no explicit js callback.
 * 7. wait for either done or js callback, then call
 *    afterLeave hook.
 *
 * @param {Function} op - remove/hide the element
 * @param {Function} [cb]
 */

p$1.leave = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeLeave');
  this.op = op;
  this.cb = cb;
  addClass(this.el, this.leaveClass);
  this.left = false;
  this.callHookWithCb('leave');
  if (this.left) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.leaveCancelled;
  // only need to handle leaveDone if
  // 1. the transition is already done (synchronously called
  //    by the user, which causes this.op set to null)
  // 2. there's no explicit js callback
  if (this.op && !this.pendingJsCb) {
    // if a CSS transition leaves immediately after enter,
    // the transitionend event never fires. therefore we
    // detect such cases and end the leave immediately.
    if (this.justEntered) {
      this.leaveDone();
    } else {
      pushJob(this.leaveNextTick);
    }
  }
};

/**
 * The "nextTick" phase of a leaving transition.
 */

p$1.leaveNextTick = function () {
  var type = this.getCssTransitionType(this.leaveClass);
  if (type) {
    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
    this.setupCssCb(event, this.leaveDone);
  } else {
    this.leaveDone();
  }
};

/**
 * The "cleanup" phase of a leaving transition.
 */

p$1.leaveDone = function () {
  this.left = true;
  this.cancel = this.pendingJsCb = null;
  this.op();
  removeClass(this.el, this.leaveClass);
  this.callHook('afterLeave');
  if (this.cb) this.cb();
  this.op = null;
};

/**
 * Cancel any pending callbacks from a previously running
 * but not finished transition.
 */

p$1.cancelPending = function () {
  this.op = this.cb = null;
  var hasPending = false;
  if (this.pendingCssCb) {
    hasPending = true;
    off(this.el, this.pendingCssEvent, this.pendingCssCb);
    this.pendingCssEvent = this.pendingCssCb = null;
  }
  if (this.pendingJsCb) {
    hasPending = true;
    this.pendingJsCb.cancel();
    this.pendingJsCb = null;
  }
  if (hasPending) {
    removeClass(this.el, this.enterClass);
    removeClass(this.el, this.leaveClass);
  }
  if (this.cancel) {
    this.cancel.call(this.vm, this.el);
    this.cancel = null;
  }
};

/**
 * Call a user-provided synchronous hook function.
 *
 * @param {String} type
 */

p$1.callHook = function (type) {
  if (this.hooks && this.hooks[type]) {
    this.hooks[type].call(this.vm, this.el);
  }
};

/**
 * Call a user-provided, potentially-async hook function.
 * We check for the length of arguments to see if the hook
 * expects a `done` callback. If true, the transition's end
 * will be determined by when the user calls that callback;
 * otherwise, the end is determined by the CSS transition or
 * animation.
 *
 * @param {String} type
 */

p$1.callHookWithCb = function (type) {
  var hook = this.hooks && this.hooks[type];
  if (hook) {
    if (hook.length > 1) {
      this.pendingJsCb = cancellable(this[type + 'Done']);
    }
    hook.call(this.vm, this.el, this.pendingJsCb);
  }
};

/**
 * Get an element's transition type based on the
 * calculated styles.
 *
 * @param {String} className
 * @return {Number}
 */

p$1.getCssTransitionType = function (className) {
  /* istanbul ignore if */
  if (!transitionEndEvent ||
  // skip CSS transitions if page is not visible -
  // this solves the issue of transitionend events not
  // firing until the page is visible again.
  // pageVisibility API is supported in IE10+, same as
  // CSS transitions.
  document.hidden ||
  // explicit js-only transition
  this.hooks && this.hooks.css === false ||
  // element is hidden
  isHidden(this.el)) {
    return;
  }
  var type = this.type || this.typeCache[className];
  if (type) return type;
  var inlineStyles = this.el.style;
  var computedStyles = window.getComputedStyle(this.el);
  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
  if (transDuration && transDuration !== '0s') {
    type = TYPE_TRANSITION;
  } else {
    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
    if (animDuration && animDuration !== '0s') {
      type = TYPE_ANIMATION;
    }
  }
  if (type) {
    this.typeCache[className] = type;
  }
  return type;
};

/**
 * Setup a CSS transitionend/animationend callback.
 *
 * @param {String} event
 * @param {Function} cb
 */

p$1.setupCssCb = function (event, cb) {
  this.pendingCssEvent = event;
  var self = this;
  var el = this.el;
  var onEnd = this.pendingCssCb = function (e) {
    if (e.target === el) {
      off(el, event, onEnd);
      self.pendingCssEvent = self.pendingCssCb = null;
      if (!self.pendingJsCb && cb) {
        cb();
      }
    }
  };
  on(el, event, onEnd);
};

/**
 * Check if an element is hidden - in that case we can just
 * skip the transition alltogether.
 *
 * @param {Element} el
 * @return {Boolean}
 */

function isHidden(el) {
  if (/svg$/.test(el.namespaceURI)) {
    // SVG elements do not have offset(Width|Height)
    // so we need to check the client rect
    var rect = el.getBoundingClientRect();
    return !(rect.width || rect.height);
  } else {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
}

var transition$1 = {

  priority: TRANSITION,

  update: function update(id, oldId) {
    var el = this.el;
    // resolve on owner vm
    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
    id = id || 'v';
    oldId = oldId || 'v';
    el.__v_trans = new Transition(el, id, hooks, this.vm);
    removeClass(el, oldId + '-transition');
    addClass(el, id + '-transition');
  }
};

var internalDirectives = {
  style: style,
  'class': vClass,
  component: component,
  prop: propDef,
  transition: transition$1
};

// special binding prefixes
var bindRE = /^v-bind:|^:/;
var onRE = /^v-on:|^@/;
var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
var modifierRE = /\.[^\.]+/g;
var transitionRE = /^(v-bind:|:)?transition$/;

// default directive priority
var DEFAULT_PRIORITY = 1000;
var DEFAULT_TERMINAL_PRIORITY = 2000;

/**
 * Compile a template and return a reusable composite link
 * function, which recursively contains more link functions
 * inside. This top level compile function would normally
 * be called on instance root nodes, but can also be used
 * for partial compilation if the partial argument is true.
 *
 * The returned composite link function, when called, will
 * return an unlink function that tearsdown all directives
 * created during the linking phase.
 *
 * @param {Element|DocumentFragment} el
 * @param {Object} options
 * @param {Boolean} partial
 * @return {Function}
 */

function compile(el, options, partial) {
  // link function for the node itself.
  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
  // link function for the childNodes
  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;

  /**
   * A composite linker function to be called on a already
   * compiled piece of DOM, which instantiates all directive
   * instances.
   *
   * @param {Vue} vm
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host] - host vm of transcluded content
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - link context fragment
   * @return {Function|undefined}
   */

  return function compositeLinkFn(vm, el, host, scope, frag) {
    // cache childNodes before linking parent, fix #657
    var childNodes = toArray(el.childNodes);
    // link
    var dirs = linkAndCapture(function compositeLinkCapturer() {
      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
    }, vm);
    return makeUnlinkFn(vm, dirs);
  };
}

/**
 * Apply a linker to a vm/element pair and capture the
 * directives created during the process.
 *
 * @param {Function} linker
 * @param {Vue} vm
 */

function linkAndCapture(linker, vm) {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'production') {
    // reset directives before every capture in production
    // mode, so that when unlinking we don't need to splice
    // them out (which turns out to be a perf hit).
    // they are kept in development mode because they are
    // useful for Vue's own tests.
    vm._directives = [];
  }
  var originalDirCount = vm._directives.length;
  linker();
  var dirs = vm._directives.slice(originalDirCount);
  sortDirectives(dirs);
  for (var i = 0, l = dirs.length; i < l; i++) {
    dirs[i]._bind();
  }
  return dirs;
}

/**
 * sort directives by priority (stable sort)
 *
 * @param {Array} dirs
 */
function sortDirectives(dirs) {
  if (dirs.length === 0) return;

  var groupedMap = {};
  var i, j, k, l;
  var index = 0;
  var priorities = [];
  for (i = 0, j = dirs.length; i < j; i++) {
    var dir = dirs[i];
    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
    var array = groupedMap[priority];
    if (!array) {
      array = groupedMap[priority] = [];
      priorities.push(priority);
    }
    array.push(dir);
  }

  priorities.sort(function (a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
  });
  for (i = 0, j = priorities.length; i < j; i++) {
    var group = groupedMap[priorities[i]];
    for (k = 0, l = group.length; k < l; k++) {
      dirs[index++] = group[k];
    }
  }
}

/**
 * Linker functions return an unlink function that
 * tearsdown all directives instances generated during
 * the process.
 *
 * We create unlink functions with only the necessary
 * information to avoid retaining additional closures.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Vue} [context]
 * @param {Array} [contextDirs]
 * @return {Function}
 */

function makeUnlinkFn(vm, dirs, context, contextDirs) {
  function unlink(destroying) {
    teardownDirs(vm, dirs, destroying);
    if (context && contextDirs) {
      teardownDirs(context, contextDirs);
    }
  }
  // expose linked directives
  unlink.dirs = dirs;
  return unlink;
}

/**
 * Teardown partial linked directives.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Boolean} destroying
 */

function teardownDirs(vm, dirs, destroying) {
  var i = dirs.length;
  while (i--) {
    dirs[i]._teardown();
    if (process.env.NODE_ENV !== 'production' && !destroying) {
      vm._directives.$remove(dirs[i]);
    }
  }
}

/**
 * Compile link props on an instance.
 *
 * @param {Vue} vm
 * @param {Element} el
 * @param {Object} props
 * @param {Object} [scope]
 * @return {Function}
 */

function compileAndLinkProps(vm, el, props, scope) {
  var propsLinkFn = compileProps(el, props, vm);
  var propDirs = linkAndCapture(function () {
    propsLinkFn(vm, scope);
  }, vm);
  return makeUnlinkFn(vm, propDirs);
}

/**
 * Compile the root element of an instance.
 *
 * 1. attrs on context container (context scope)
 * 2. attrs on the component template root node, if
 *    replace:true (child scope)
 *
 * If this is a fragment instance, we only need to compile 1.
 *
 * @param {Element} el
 * @param {Object} options
 * @param {Object} contextOptions
 * @return {Function}
 */

function compileRoot(el, options, contextOptions) {
  var containerAttrs = options._containerAttrs;
  var replacerAttrs = options._replacerAttrs;
  var contextLinkFn, replacerLinkFn;

  // only need to compile other attributes for
  // non-fragment instances
  if (el.nodeType !== 11) {
    // for components, container and replacer need to be
    // compiled separately and linked in different scopes.
    if (options._asComponent) {
      // 2. container attributes
      if (containerAttrs && contextOptions) {
        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
      }
      if (replacerAttrs) {
        // 3. replacer attributes
        replacerLinkFn = compileDirectives(replacerAttrs, options);
      }
    } else {
      // non-component, just compile as a normal element.
      replacerLinkFn = compileDirectives(el.attributes, options);
    }
  } else if (process.env.NODE_ENV !== 'production' && containerAttrs) {
    // warn container directives for fragment instances
    var names = containerAttrs.filter(function (attr) {
      // allow vue-loader/vueify scoped css attributes
      return attr.name.indexOf('_v-') < 0 &&
      // allow event listeners
      !onRE.test(attr.name) &&
      // allow slots
      attr.name !== 'slot';
    }).map(function (attr) {
      return '"' + attr.name + '"';
    });
    if (names.length) {
      var plural = names.length > 1;

      var componentName = options.el.tagName.toLowerCase();
      if (componentName === 'component' && options.name) {
        componentName += ':' + options.name;
      }

      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
    }
  }

  options._containerAttrs = options._replacerAttrs = null;
  return function rootLinkFn(vm, el, scope) {
    // link context scope dirs
    var context = vm._context;
    var contextDirs;
    if (context && contextLinkFn) {
      contextDirs = linkAndCapture(function () {
        contextLinkFn(context, el, null, scope);
      }, context);
    }

    // link self
    var selfDirs = linkAndCapture(function () {
      if (replacerLinkFn) replacerLinkFn(vm, el);
    }, vm);

    // return the unlink function that tearsdown context
    // container directives.
    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
  };
}

/**
 * Compile a node and return a nodeLinkFn based on the
 * node type.
 *
 * @param {Node} node
 * @param {Object} options
 * @return {Function|null}
 */

function compileNode(node, options) {
  var type = node.nodeType;
  if (type === 1 && !isScript(node)) {
    return compileElement(node, options);
  } else if (type === 3 && node.data.trim()) {
    return compileTextNode(node, options);
  } else {
    return null;
  }
}

/**
 * Compile an element and return a nodeLinkFn.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|null}
 */

function compileElement(el, options) {
  // preprocess textareas.
  // textarea treats its text content as the initial value.
  // just bind it as an attr directive for value.
  if (el.tagName === 'TEXTAREA') {
    // a textarea which has v-pre attr should skip complie.
    if (getAttr(el, 'v-pre') !== null) {
      return skip;
    }
    var tokens = parseText(el.value);
    if (tokens) {
      el.setAttribute(':value', tokensToExp(tokens));
      el.value = '';
    }
  }
  var linkFn;
  var hasAttrs = el.hasAttributes();
  var attrs = hasAttrs && toArray(el.attributes);
  // check terminal directives (for & if)
  if (hasAttrs) {
    linkFn = checkTerminalDirectives(el, attrs, options);
  }
  // check element directives
  if (!linkFn) {
    linkFn = checkElementDirectives(el, options);
  }
  // check component
  if (!linkFn) {
    linkFn = checkComponent(el, options);
  }
  // normal directives
  if (!linkFn && hasAttrs) {
    linkFn = compileDirectives(attrs, options);
  }
  return linkFn;
}

/**
 * Compile a textNode and return a nodeLinkFn.
 *
 * @param {TextNode} node
 * @param {Object} options
 * @return {Function|null} textNodeLinkFn
 */

function compileTextNode(node, options) {
  // skip marked text nodes
  if (node._skip) {
    return removeText;
  }

  var tokens = parseText(node.wholeText);
  if (!tokens) {
    return null;
  }

  // mark adjacent text nodes as skipped,
  // because we are using node.wholeText to compile
  // all adjacent text nodes together. This fixes
  // issues in IE where sometimes it splits up a single
  // text node into multiple ones.
  var next = node.nextSibling;
  while (next && next.nodeType === 3) {
    next._skip = true;
    next = next.nextSibling;
  }

  var frag = document.createDocumentFragment();
  var el, token;
  for (var i = 0, l = tokens.length; i < l; i++) {
    token = tokens[i];
    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
    frag.appendChild(el);
  }
  return makeTextNodeLinkFn(tokens, frag, options);
}

/**
 * Linker for an skipped text node.
 *
 * @param {Vue} vm
 * @param {Text} node
 */

function removeText(vm, node) {
  remove(node);
}

/**
 * Process a single text token.
 *
 * @param {Object} token
 * @param {Object} options
 * @return {Node}
 */

function processTextToken(token, options) {
  var el;
  if (token.oneTime) {
    el = document.createTextNode(token.value);
  } else {
    if (token.html) {
      el = document.createComment('v-html');
      setTokenType('html');
    } else {
      // IE will clean up empty textNodes during
      // frag.cloneNode(true), so we have to give it
      // something here...
      el = document.createTextNode(' ');
      setTokenType('text');
    }
  }
  function setTokenType(type) {
    if (token.descriptor) return;
    var parsed = parseDirective(token.value);
    token.descriptor = {
      name: type,
      def: directives[type],
      expression: parsed.expression,
      filters: parsed.filters
    };
  }
  return el;
}

/**
 * Build a function that processes a textNode.
 *
 * @param {Array<Object>} tokens
 * @param {DocumentFragment} frag
 */

function makeTextNodeLinkFn(tokens, frag) {
  return function textNodeLinkFn(vm, el, host, scope) {
    var fragClone = frag.cloneNode(true);
    var childNodes = toArray(fragClone.childNodes);
    var token, value, node;
    for (var i = 0, l = tokens.length; i < l; i++) {
      token = tokens[i];
      value = token.value;
      if (token.tag) {
        node = childNodes[i];
        if (token.oneTime) {
          value = (scope || vm).$eval(value);
          if (token.html) {
            replace(node, parseTemplate(value, true));
          } else {
            node.data = _toString(value);
          }
        } else {
          vm._bindDir(token.descriptor, node, host, scope);
        }
      }
    }
    replace(el, fragClone);
  };
}

/**
 * Compile a node list and return a childLinkFn.
 *
 * @param {NodeList} nodeList
 * @param {Object} options
 * @return {Function|undefined}
 */

function compileNodeList(nodeList, options) {
  var linkFns = [];
  var nodeLinkFn, childLinkFn, node;
  for (var i = 0, l = nodeList.length; i < l; i++) {
    node = nodeList[i];
    nodeLinkFn = compileNode(node, options);
    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
    linkFns.push(nodeLinkFn, childLinkFn);
  }
  return linkFns.length ? makeChildLinkFn(linkFns) : null;
}

/**
 * Make a child link function for a node's childNodes.
 *
 * @param {Array<Function>} linkFns
 * @return {Function} childLinkFn
 */

function makeChildLinkFn(linkFns) {
  return function childLinkFn(vm, nodes, host, scope, frag) {
    var node, nodeLinkFn, childrenLinkFn;
    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
      node = nodes[n];
      nodeLinkFn = linkFns[i++];
      childrenLinkFn = linkFns[i++];
      // cache childNodes before linking parent, fix #657
      var childNodes = toArray(node.childNodes);
      if (nodeLinkFn) {
        nodeLinkFn(vm, node, host, scope, frag);
      }
      if (childrenLinkFn) {
        childrenLinkFn(vm, childNodes, host, scope, frag);
      }
    }
  };
}

/**
 * Check for element directives (custom elements that should
 * be resovled as terminal directives).
 *
 * @param {Element} el
 * @param {Object} options
 */

function checkElementDirectives(el, options) {
  var tag = el.tagName.toLowerCase();
  if (commonTagRE.test(tag)) {
    return;
  }
  var def = resolveAsset(options, 'elementDirectives', tag);
  if (def) {
    return makeTerminalNodeLinkFn(el, tag, '', options, def);
  }
}

/**
 * Check if an element is a component. If yes, return
 * a component link function.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|undefined}
 */

function checkComponent(el, options) {
  var component = checkComponentAttr(el, options);
  if (component) {
    var ref = findRef(el);
    var descriptor = {
      name: 'component',
      ref: ref,
      expression: component.id,
      def: internalDirectives.component,
      modifiers: {
        literal: !component.dynamic
      }
    };
    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
      if (ref) {
        defineReactive((scope || vm).$refs, ref, null);
      }
      vm._bindDir(descriptor, el, host, scope, frag);
    };
    componentLinkFn.terminal = true;
    return componentLinkFn;
  }
}

/**
 * Check an element for terminal directives in fixed order.
 * If it finds one, return a terminal link function.
 *
 * @param {Element} el
 * @param {Array} attrs
 * @param {Object} options
 * @return {Function} terminalLinkFn
 */

function checkTerminalDirectives(el, attrs, options) {
  // skip v-pre
  if (getAttr(el, 'v-pre') !== null) {
    return skip;
  }
  // skip v-else block, but only if following v-if
  if (el.hasAttribute('v-else')) {
    var prev = el.previousElementSibling;
    if (prev && prev.hasAttribute('v-if')) {
      return skip;
    }
  }

  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
  for (var i = 0, j = attrs.length; i < j; i++) {
    attr = attrs[i];
    name = attr.name.replace(modifierRE, '');
    if (matched = name.match(dirAttrRE)) {
      def = resolveAsset(options, 'directives', matched[1]);
      if (def && def.terminal) {
        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
          termDef = def;
          rawName = attr.name;
          modifiers = parseModifiers(attr.name);
          value = attr.value;
          dirName = matched[1];
          arg = matched[2];
        }
      }
    }
  }

  if (termDef) {
    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
  }
}

function skip() {}
skip.terminal = true;

/**
 * Build a node link function for a terminal directive.
 * A terminal link function terminates the current
 * compilation recursion and handles compilation of the
 * subtree in the directive.
 *
 * @param {Element} el
 * @param {String} dirName
 * @param {String} value
 * @param {Object} options
 * @param {Object} def
 * @param {String} [rawName]
 * @param {String} [arg]
 * @param {Object} [modifiers]
 * @return {Function} terminalLinkFn
 */

function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
  var parsed = parseDirective(value);
  var descriptor = {
    name: dirName,
    arg: arg,
    expression: parsed.expression,
    filters: parsed.filters,
    raw: value,
    attr: rawName,
    modifiers: modifiers,
    def: def
  };
  // check ref for v-for, v-if and router-view
  if (dirName === 'for' || dirName === 'router-view') {
    descriptor.ref = findRef(el);
  }
  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
    if (descriptor.ref) {
      defineReactive((scope || vm).$refs, descriptor.ref, null);
    }
    vm._bindDir(descriptor, el, host, scope, frag);
  };
  fn.terminal = true;
  return fn;
}

/**
 * Compile the directives on an element and return a linker.
 *
 * @param {Array|NamedNodeMap} attrs
 * @param {Object} options
 * @return {Function}
 */

function compileDirectives(attrs, options) {
  var i = attrs.length;
  var dirs = [];
  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
  while (i--) {
    attr = attrs[i];
    name = rawName = attr.name;
    value = rawValue = attr.value;
    tokens = parseText(value);
    // reset arg
    arg = null;
    // check modifiers
    modifiers = parseModifiers(name);
    name = name.replace(modifierRE, '');

    // attribute interpolations
    if (tokens) {
      value = tokensToExp(tokens);
      arg = name;
      pushDir('bind', directives.bind, tokens);
      // warn against mixing mustaches with v-bind
      if (process.env.NODE_ENV !== 'production') {
        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
          return attr.name === ':class' || attr.name === 'v-bind:class';
        })) {
          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
        }
      }
    } else

      // special attribute: transition
      if (transitionRE.test(name)) {
        modifiers.literal = !bindRE.test(name);
        pushDir('transition', internalDirectives.transition);
      } else

        // event handlers
        if (onRE.test(name)) {
          arg = name.replace(onRE, '');
          pushDir('on', directives.on);
        } else

          // attribute bindings
          if (bindRE.test(name)) {
            dirName = name.replace(bindRE, '');
            if (dirName === 'style' || dirName === 'class') {
              pushDir(dirName, internalDirectives[dirName]);
            } else {
              arg = dirName;
              pushDir('bind', directives.bind);
            }
          } else

            // normal directives
            if (matched = name.match(dirAttrRE)) {
              dirName = matched[1];
              arg = matched[2];

              // skip v-else (when used with v-show)
              if (dirName === 'else') {
                continue;
              }

              dirDef = resolveAsset(options, 'directives', dirName, true);
              if (dirDef) {
                pushDir(dirName, dirDef);
              }
            }
  }

  /**
   * Push a directive.
   *
   * @param {String} dirName
   * @param {Object|Function} def
   * @param {Array} [interpTokens]
   */

  function pushDir(dirName, def, interpTokens) {
    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
    var parsed = !hasOneTimeToken && parseDirective(value);
    dirs.push({
      name: dirName,
      attr: rawName,
      raw: rawValue,
      def: def,
      arg: arg,
      modifiers: modifiers,
      // conversion from interpolation strings with one-time token
      // to expression is differed until directive bind time so that we
      // have access to the actual vm context for one-time bindings.
      expression: parsed && parsed.expression,
      filters: parsed && parsed.filters,
      interp: interpTokens,
      hasOneTime: hasOneTimeToken
    });
  }

  if (dirs.length) {
    return makeNodeLinkFn(dirs);
  }
}

/**
 * Parse modifiers from directive attribute name.
 *
 * @param {String} name
 * @return {Object}
 */

function parseModifiers(name) {
  var res = Object.create(null);
  var match = name.match(modifierRE);
  if (match) {
    var i = match.length;
    while (i--) {
      res[match[i].slice(1)] = true;
    }
  }
  return res;
}

/**
 * Build a link function for all directives on a single node.
 *
 * @param {Array} directives
 * @return {Function} directivesLinkFn
 */

function makeNodeLinkFn(directives) {
  return function nodeLinkFn(vm, el, host, scope, frag) {
    // reverse apply because it's sorted low to high
    var i = directives.length;
    while (i--) {
      vm._bindDir(directives[i], el, host, scope, frag);
    }
  };
}

/**
 * Check if an interpolation string contains one-time tokens.
 *
 * @param {Array} tokens
 * @return {Boolean}
 */

function hasOneTime(tokens) {
  var i = tokens.length;
  while (i--) {
    if (tokens[i].oneTime) return true;
  }
}

function isScript(el) {
  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
}

var specialCharRE = /[^\w\-:\.]/;

/**
 * Process an element or a DocumentFragment based on a
 * instance option object. This allows us to transclude
 * a template node/fragment before the instance is created,
 * so the processed fragment can then be cloned and reused
 * in v-for.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transclude(el, options) {
  // extract container attributes to pass them down
  // to compiler, because they need to be compiled in
  // parent scope. we are mutating the options object here
  // assuming the same object will be used for compile
  // right after this.
  if (options) {
    options._containerAttrs = extractAttrs(el);
  }
  // for template tags, what we want is its content as
  // a documentFragment (for fragment instances)
  if (isTemplate(el)) {
    el = parseTemplate(el);
  }
  if (options) {
    if (options._asComponent && !options.template) {
      options.template = '<slot></slot>';
    }
    if (options.template) {
      options._content = extractContent(el);
      el = transcludeTemplate(el, options);
    }
  }
  if (isFragment(el)) {
    // anchors for fragment instance
    // passing in `persist: true` to avoid them being
    // discarded by IE during template cloning
    prepend(createAnchor('v-start', true), el);
    el.appendChild(createAnchor('v-end', true));
  }
  return el;
}

/**
 * Process the template option.
 * If the replace option is true this will swap the $el.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transcludeTemplate(el, options) {
  var template = options.template;
  var frag = parseTemplate(template, true);
  if (frag) {
    var replacer = frag.firstChild;
    if (!replacer) {
      return frag;
    }
    var tag = replacer.tagName && replacer.tagName.toLowerCase();
    if (options.replace) {
      /* istanbul ignore if */
      if (el === document.body) {
        process.env.NODE_ENV !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
      }
      // there are many cases where the instance must
      // become a fragment instance: basically anything that
      // can create more than 1 root nodes.
      if (
      // multi-children template
      frag.childNodes.length > 1 ||
      // non-element template
      replacer.nodeType !== 1 ||
      // single nested component
      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
      // element directive
      resolveAsset(options, 'elementDirectives', tag) ||
      // for block
      replacer.hasAttribute('v-for') ||
      // if block
      replacer.hasAttribute('v-if')) {
        return frag;
      } else {
        options._replacerAttrs = extractAttrs(replacer);
        mergeAttrs(el, replacer);
        return replacer;
      }
    } else {
      el.appendChild(frag);
      return el;
    }
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid template option: ' + template);
  }
}

/**
 * Helper to extract a component container's attributes
 * into a plain object array.
 *
 * @param {Element} el
 * @return {Array}
 */

function extractAttrs(el) {
  if (el.nodeType === 1 && el.hasAttributes()) {
    return toArray(el.attributes);
  }
}

/**
 * Merge the attributes of two elements, and make sure
 * the class names are merged properly.
 *
 * @param {Element} from
 * @param {Element} to
 */

function mergeAttrs(from, to) {
  var attrs = from.attributes;
  var i = attrs.length;
  var name, value;
  while (i--) {
    name = attrs[i].name;
    value = attrs[i].value;
    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
      to.setAttribute(name, value);
    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
      value.split(/\s+/).forEach(function (cls) {
        addClass(to, cls);
      });
    }
  }
}

/**
 * Scan and determine slot content distribution.
 * We do this during transclusion instead at compile time so that
 * the distribution is decoupled from the compilation order of
 * the slots.
 *
 * @param {Element|DocumentFragment} template
 * @param {Element} content
 * @param {Vue} vm
 */

function resolveSlots(vm, content) {
  if (!content) {
    return;
  }
  var contents = vm._slotContents = Object.create(null);
  var el, name;
  for (var i = 0, l = content.children.length; i < l; i++) {
    el = content.children[i];
    /* eslint-disable no-cond-assign */
    if (name = el.getAttribute('slot')) {
      (contents[name] || (contents[name] = [])).push(el);
    }
    /* eslint-enable no-cond-assign */
    if (process.env.NODE_ENV !== 'production' && getBindAttr(el, 'slot')) {
      warn('The "slot" attribute must be static.', vm.$parent);
    }
  }
  for (name in contents) {
    contents[name] = extractFragment(contents[name], content);
  }
  if (content.hasChildNodes()) {
    var nodes = content.childNodes;
    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
      return;
    }
    contents['default'] = extractFragment(content.childNodes, content);
  }
}

/**
 * Extract qualified content nodes from a node list.
 *
 * @param {NodeList} nodes
 * @return {DocumentFragment}
 */

function extractFragment(nodes, parent) {
  var frag = document.createDocumentFragment();
  nodes = toArray(nodes);
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i];
    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
      parent.removeChild(node);
      node = parseTemplate(node, true);
    }
    frag.appendChild(node);
  }
  return frag;
}



var compiler = Object.freeze({
	compile: compile,
	compileAndLinkProps: compileAndLinkProps,
	compileRoot: compileRoot,
	transclude: transclude,
	resolveSlots: resolveSlots
});

function stateMixin (Vue) {
  /**
   * Accessor for `$data` property, since setting $data
   * requires observing the new object and updating
   * proxied properties.
   */

  Object.defineProperty(Vue.prototype, '$data', {
    get: function get() {
      return this._data;
    },
    set: function set(newData) {
      if (newData !== this._data) {
        this._setData(newData);
      }
    }
  });

  /**
   * Setup the scope of an instance, which contains:
   * - observed data
   * - computed properties
   * - user methods
   * - meta properties
   */

  Vue.prototype._initState = function () {
    this._initProps();
    this._initMeta();
    this._initMethods();
    this._initData();
    this._initComputed();
  };

  /**
   * Initialize props.
   */

  Vue.prototype._initProps = function () {
    var options = this.$options;
    var el = options.el;
    var props = options.props;
    if (props && !el) {
      process.env.NODE_ENV !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
    }
    // make sure to convert string selectors into element now
    el = options.el = query(el);
    this._propsUnlinkFn = el && el.nodeType === 1 && props
    // props must be linked in proper scope if inside v-for
    ? compileAndLinkProps(this, el, props, this._scope) : null;
  };

  /**
   * Initialize the data.
   */

  Vue.prototype._initData = function () {
    var dataFn = this.$options.data;
    var data = this._data = dataFn ? dataFn() : {};
    if (!isPlainObject(data)) {
      data = {};
      process.env.NODE_ENV !== 'production' && warn('data functions should return an object.', this);
    }
    var props = this._props;
    // proxy data on instance
    var keys = Object.keys(data);
    var i, key;
    i = keys.length;
    while (i--) {
      key = keys[i];
      // there are two scenarios where we can proxy a data key:
      // 1. it's not already defined as a prop
      // 2. it's provided via a instantiation option AND there are no
      //    template prop present
      if (!props || !hasOwn(props, key)) {
        this._proxy(key);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
      }
    }
    // observe data
    observe(data, this);
  };

  /**
   * Swap the instance's $data. Called in $data's setter.
   *
   * @param {Object} newData
   */

  Vue.prototype._setData = function (newData) {
    newData = newData || {};
    var oldData = this._data;
    this._data = newData;
    var keys, key, i;
    // unproxy keys not present in new data
    keys = Object.keys(oldData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!(key in newData)) {
        this._unproxy(key);
      }
    }
    // proxy keys not already proxied,
    // and trigger change for changed values
    keys = Object.keys(newData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!hasOwn(this, key)) {
        // new property
        this._proxy(key);
      }
    }
    oldData.__ob__.removeVm(this);
    observe(newData, this);
    this._digest();
  };

  /**
   * Proxy a property, so that
   * vm.prop === vm._data.prop
   *
   * @param {String} key
   */

  Vue.prototype._proxy = function (key) {
    if (!isReserved(key)) {
      // need to store ref to self here
      // because these getter/setters might
      // be called by child scopes via
      // prototype inheritance.
      var self = this;
      Object.defineProperty(self, key, {
        configurable: true,
        enumerable: true,
        get: function proxyGetter() {
          return self._data[key];
        },
        set: function proxySetter(val) {
          self._data[key] = val;
        }
      });
    }
  };

  /**
   * Unproxy a property.
   *
   * @param {String} key
   */

  Vue.prototype._unproxy = function (key) {
    if (!isReserved(key)) {
      delete this[key];
    }
  };

  /**
   * Force update on every watcher in scope.
   */

  Vue.prototype._digest = function () {
    for (var i = 0, l = this._watchers.length; i < l; i++) {
      this._watchers[i].update(true); // shallow updates
    }
  };

  /**
   * Setup computed properties. They are essentially
   * special getter/setters
   */

  function noop() {}
  Vue.prototype._initComputed = function () {
    var computed = this.$options.computed;
    if (computed) {
      for (var key in computed) {
        var userDef = computed[key];
        var def = {
          enumerable: true,
          configurable: true
        };
        if (typeof userDef === 'function') {
          def.get = makeComputedGetter(userDef, this);
          def.set = noop;
        } else {
          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
          def.set = userDef.set ? bind(userDef.set, this) : noop;
        }
        Object.defineProperty(this, key, def);
      }
    }
  };

  function makeComputedGetter(getter, owner) {
    var watcher = new Watcher(owner, getter, null, {
      lazy: true
    });
    return function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
  }

  /**
   * Setup instance methods. Methods must be bound to the
   * instance since they might be passed down as a prop to
   * child components.
   */

  Vue.prototype._initMethods = function () {
    var methods = this.$options.methods;
    if (methods) {
      for (var key in methods) {
        this[key] = bind(methods[key], this);
      }
    }
  };

  /**
   * Initialize meta information like $index, $key & $value.
   */

  Vue.prototype._initMeta = function () {
    var metas = this.$options._meta;
    if (metas) {
      for (var key in metas) {
        defineReactive(this, key, metas[key]);
      }
    }
  };
}

var eventRE = /^v-on:|^@/;

function eventsMixin (Vue) {
  /**
   * Setup the instance's option events & watchers.
   * If the value is a string, we pull it from the
   * instance's methods by name.
   */

  Vue.prototype._initEvents = function () {
    var options = this.$options;
    if (options._asComponent) {
      registerComponentEvents(this, options.el);
    }
    registerCallbacks(this, '$on', options.events);
    registerCallbacks(this, '$watch', options.watch);
  };

  /**
   * Register v-on events on a child component
   *
   * @param {Vue} vm
   * @param {Element} el
   */

  function registerComponentEvents(vm, el) {
    var attrs = el.attributes;
    var name, value, handler;
    for (var i = 0, l = attrs.length; i < l; i++) {
      name = attrs[i].name;
      if (eventRE.test(name)) {
        name = name.replace(eventRE, '');
        // force the expression into a statement so that
        // it always dynamically resolves the method to call (#2670)
        // kinda ugly hack, but does the job.
        value = attrs[i].value;
        if (isSimplePath(value)) {
          value += '.apply(this, $arguments)';
        }
        handler = (vm._scope || vm._context).$eval(value, true);
        handler._fromParent = true;
        vm.$on(name.replace(eventRE), handler);
      }
    }
  }

  /**
   * Register callbacks for option events and watchers.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {Object} hash
   */

  function registerCallbacks(vm, action, hash) {
    if (!hash) return;
    var handlers, key, i, j;
    for (key in hash) {
      handlers = hash[key];
      if (isArray(handlers)) {
        for (i = 0, j = handlers.length; i < j; i++) {
          register(vm, action, key, handlers[i]);
        }
      } else {
        register(vm, action, key, handlers);
      }
    }
  }

  /**
   * Helper to register an event/watch callback.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {String} key
   * @param {Function|String|Object} handler
   * @param {Object} [options]
   */

  function register(vm, action, key, handler, options) {
    var type = typeof handler;
    if (type === 'function') {
      vm[action](key, handler, options);
    } else if (type === 'string') {
      var methods = vm.$options.methods;
      var method = methods && methods[handler];
      if (method) {
        vm[action](key, method, options);
      } else {
        process.env.NODE_ENV !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
      }
    } else if (handler && type === 'object') {
      register(vm, action, key, handler.handler, handler);
    }
  }

  /**
   * Setup recursive attached/detached calls
   */

  Vue.prototype._initDOMHooks = function () {
    this.$on('hook:attached', onAttached);
    this.$on('hook:detached', onDetached);
  };

  /**
   * Callback to recursively call attached hook on children
   */

  function onAttached() {
    if (!this._isAttached) {
      this._isAttached = true;
      this.$children.forEach(callAttach);
    }
  }

  /**
   * Iterator to call attached hook
   *
   * @param {Vue} child
   */

  function callAttach(child) {
    if (!child._isAttached && inDoc(child.$el)) {
      child._callHook('attached');
    }
  }

  /**
   * Callback to recursively call detached hook on children
   */

  function onDetached() {
    if (this._isAttached) {
      this._isAttached = false;
      this.$children.forEach(callDetach);
    }
  }

  /**
   * Iterator to call detached hook
   *
   * @param {Vue} child
   */

  function callDetach(child) {
    if (child._isAttached && !inDoc(child.$el)) {
      child._callHook('detached');
    }
  }

  /**
   * Trigger all handlers for a hook
   *
   * @param {String} hook
   */

  Vue.prototype._callHook = function (hook) {
    this.$emit('pre-hook:' + hook);
    var handlers = this.$options[hook];
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        handlers[i].call(this);
      }
    }
    this.$emit('hook:' + hook);
  };
}

function noop$1() {}

/**
 * A directive links a DOM element with a piece of data,
 * which is the result of evaluating an expression.
 * It registers a watcher with the expression and calls
 * the DOM update function when a change is triggered.
 *
 * @param {Object} descriptor
 *                 - {String} name
 *                 - {Object} def
 *                 - {String} expression
 *                 - {Array<Object>} [filters]
 *                 - {Object} [modifiers]
 *                 - {Boolean} literal
 *                 - {String} attr
 *                 - {String} arg
 *                 - {String} raw
 *                 - {String} [ref]
 *                 - {Array<Object>} [interp]
 *                 - {Boolean} [hasOneTime]
 * @param {Vue} vm
 * @param {Node} el
 * @param {Vue} [host] - transclusion host component
 * @param {Object} [scope] - v-for scope
 * @param {Fragment} [frag] - owner fragment
 * @constructor
 */
function Directive(descriptor, vm, el, host, scope, frag) {
  this.vm = vm;
  this.el = el;
  // copy descriptor properties
  this.descriptor = descriptor;
  this.name = descriptor.name;
  this.expression = descriptor.expression;
  this.arg = descriptor.arg;
  this.modifiers = descriptor.modifiers;
  this.filters = descriptor.filters;
  this.literal = this.modifiers && this.modifiers.literal;
  // private
  this._locked = false;
  this._bound = false;
  this._listeners = null;
  // link context
  this._host = host;
  this._scope = scope;
  this._frag = frag;
  // store directives on node in dev mode
  if (process.env.NODE_ENV !== 'production' && this.el) {
    this.el._vue_directives = this.el._vue_directives || [];
    this.el._vue_directives.push(this);
  }
}

/**
 * Initialize the directive, mixin definition properties,
 * setup the watcher, call definition bind() and update()
 * if present.
 */

Directive.prototype._bind = function () {
  var name = this.name;
  var descriptor = this.descriptor;

  // remove attribute
  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
    var attr = descriptor.attr || 'v-' + name;
    this.el.removeAttribute(attr);
  }

  // copy def properties
  var def = descriptor.def;
  if (typeof def === 'function') {
    this.update = def;
  } else {
    extend(this, def);
  }

  // setup directive params
  this._setupParams();

  // initial bind
  if (this.bind) {
    this.bind();
  }
  this._bound = true;

  if (this.literal) {
    this.update && this.update(descriptor.raw);
  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
    // wrapped updater for context
    var dir = this;
    if (this.update) {
      this._update = function (val, oldVal) {
        if (!dir._locked) {
          dir.update(val, oldVal);
        }
      };
    } else {
      this._update = noop$1;
    }
    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
    {
      filters: this.filters,
      twoWay: this.twoWay,
      deep: this.deep,
      preProcess: preProcess,
      postProcess: postProcess,
      scope: this._scope
    });
    // v-model with inital inline value need to sync back to
    // model instead of update to DOM on init. They would
    // set the afterBind hook to indicate that.
    if (this.afterBind) {
      this.afterBind();
    } else if (this.update) {
      this.update(watcher.value);
    }
  }
};

/**
 * Setup all param attributes, e.g. track-by,
 * transition-mode, etc...
 */

Directive.prototype._setupParams = function () {
  if (!this.params) {
    return;
  }
  var params = this.params;
  // swap the params array with a fresh object.
  this.params = Object.create(null);
  var i = params.length;
  var key, val, mappedKey;
  while (i--) {
    key = hyphenate(params[i]);
    mappedKey = camelize(key);
    val = getBindAttr(this.el, key);
    if (val != null) {
      // dynamic
      this._setupParamWatcher(mappedKey, val);
    } else {
      // static
      val = getAttr(this.el, key);
      if (val != null) {
        this.params[mappedKey] = val === '' ? true : val;
      }
    }
  }
};

/**
 * Setup a watcher for a dynamic param.
 *
 * @param {String} key
 * @param {String} expression
 */

Directive.prototype._setupParamWatcher = function (key, expression) {
  var self = this;
  var called = false;
  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
    self.params[key] = val;
    // since we are in immediate mode,
    // only call the param change callbacks if this is not the first update.
    if (called) {
      var cb = self.paramWatchers && self.paramWatchers[key];
      if (cb) {
        cb.call(self, val, oldVal);
      }
    } else {
      called = true;
    }
  }, {
    immediate: true,
    user: false
  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
};

/**
 * Check if the directive is a function caller
 * and if the expression is a callable one. If both true,
 * we wrap up the expression and use it as the event
 * handler.
 *
 * e.g. on-click="a++"
 *
 * @return {Boolean}
 */

Directive.prototype._checkStatement = function () {
  var expression = this.expression;
  if (expression && this.acceptStatement && !isSimplePath(expression)) {
    var fn = parseExpression$1(expression).get;
    var scope = this._scope || this.vm;
    var handler = function handler(e) {
      scope.$event = e;
      fn.call(scope, scope);
      scope.$event = null;
    };
    if (this.filters) {
      handler = scope._applyFilters(handler, null, this.filters);
    }
    this.update(handler);
    return true;
  }
};

/**
 * Set the corresponding value with the setter.
 * This should only be used in two-way directives
 * e.g. v-model.
 *
 * @param {*} value
 * @public
 */

Directive.prototype.set = function (value) {
  /* istanbul ignore else */
  if (this.twoWay) {
    this._withLock(function () {
      this._watcher.set(value);
    });
  } else if (process.env.NODE_ENV !== 'production') {
    warn('Directive.set() can only be used inside twoWay' + 'directives.');
  }
};

/**
 * Execute a function while preventing that function from
 * triggering updates on this directive instance.
 *
 * @param {Function} fn
 */

Directive.prototype._withLock = function (fn) {
  var self = this;
  self._locked = true;
  fn.call(self);
  nextTick(function () {
    self._locked = false;
  });
};

/**
 * Convenience method that attaches a DOM event listener
 * to the directive element and autometically tears it down
 * during unbind.
 *
 * @param {String} event
 * @param {Function} handler
 * @param {Boolean} [useCapture]
 */

Directive.prototype.on = function (event, handler, useCapture) {
  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
};

/**
 * Teardown the watcher and call unbind.
 */

Directive.prototype._teardown = function () {
  if (this._bound) {
    this._bound = false;
    if (this.unbind) {
      this.unbind();
    }
    if (this._watcher) {
      this._watcher.teardown();
    }
    var listeners = this._listeners;
    var i;
    if (listeners) {
      i = listeners.length;
      while (i--) {
        off(this.el, listeners[i][0], listeners[i][1]);
      }
    }
    var unwatchFns = this._paramUnwatchFns;
    if (unwatchFns) {
      i = unwatchFns.length;
      while (i--) {
        unwatchFns[i]();
      }
    }
    if (process.env.NODE_ENV !== 'production' && this.el) {
      this.el._vue_directives.$remove(this);
    }
    this.vm = this.el = this._watcher = this._listeners = null;
  }
};

function lifecycleMixin (Vue) {
  /**
   * Update v-ref for component.
   *
   * @param {Boolean} remove
   */

  Vue.prototype._updateRef = function (remove) {
    var ref = this.$options._ref;
    if (ref) {
      var refs = (this._scope || this._context).$refs;
      if (remove) {
        if (refs[ref] === this) {
          refs[ref] = null;
        }
      } else {
        refs[ref] = this;
      }
    }
  };

  /**
   * Transclude, compile and link element.
   *
   * If a pre-compiled linker is available, that means the
   * passed in element will be pre-transcluded and compiled
   * as well - all we need to do is to call the linker.
   *
   * Otherwise we need to call transclude/compile/link here.
   *
   * @param {Element} el
   */

  Vue.prototype._compile = function (el) {
    var options = this.$options;

    // transclude and init element
    // transclude can potentially replace original
    // so we need to keep reference; this step also injects
    // the template and caches the original attributes
    // on the container node and replacer node.
    var original = el;
    el = transclude(el, options);
    this._initElement(el);

    // handle v-pre on root node (#2026)
    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
      return;
    }

    // root is always compiled per-instance, because
    // container attrs and props can be different every time.
    var contextOptions = this._context && this._context.$options;
    var rootLinker = compileRoot(el, options, contextOptions);

    // resolve slot distribution
    resolveSlots(this, options._content);

    // compile and link the rest
    var contentLinkFn;
    var ctor = this.constructor;
    // component compilation can be cached
    // as long as it's not using inline-template
    if (options._linkerCachable) {
      contentLinkFn = ctor.linker;
      if (!contentLinkFn) {
        contentLinkFn = ctor.linker = compile(el, options);
      }
    }

    // link phase
    // make sure to link root with prop scope!
    var rootUnlinkFn = rootLinker(this, el, this._scope);
    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);

    // register composite unlink function
    // to be called during instance destruction
    this._unlinkFn = function () {
      rootUnlinkFn();
      // passing destroying: true to avoid searching and
      // splicing the directives
      contentUnlinkFn(true);
    };

    // finally replace original
    if (options.replace) {
      replace(original, el);
    }

    this._isCompiled = true;
    this._callHook('compiled');
  };

  /**
   * Initialize instance element. Called in the public
   * $mount() method.
   *
   * @param {Element} el
   */

  Vue.prototype._initElement = function (el) {
    if (isFragment(el)) {
      this._isFragment = true;
      this.$el = this._fragmentStart = el.firstChild;
      this._fragmentEnd = el.lastChild;
      // set persisted text anchors to empty
      if (this._fragmentStart.nodeType === 3) {
        this._fragmentStart.data = this._fragmentEnd.data = '';
      }
      this._fragment = el;
    } else {
      this.$el = el;
    }
    this.$el.__vue__ = this;
    this._callHook('beforeCompile');
  };

  /**
   * Create and bind a directive to an element.
   *
   * @param {Object} descriptor - parsed directive descriptor
   * @param {Node} node   - target node
   * @param {Vue} [host] - transclusion host component
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - owner fragment
   */

  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
  };

  /**
   * Teardown an instance, unobserves the data, unbind all the
   * directives, turn off all the event listeners, etc.
   *
   * @param {Boolean} remove - whether to remove the DOM node.
   * @param {Boolean} deferCleanup - if true, defer cleanup to
   *                                 be called later
   */

  Vue.prototype._destroy = function (remove, deferCleanup) {
    if (this._isBeingDestroyed) {
      if (!deferCleanup) {
        this._cleanup();
      }
      return;
    }

    var destroyReady;
    var pendingRemoval;

    var self = this;
    // Cleanup should be called either synchronously or asynchronoysly as
    // callback of this.$remove(), or if remove and deferCleanup are false.
    // In any case it should be called after all other removing, unbinding and
    // turning of is done
    var cleanupIfPossible = function cleanupIfPossible() {
      if (destroyReady && !pendingRemoval && !deferCleanup) {
        self._cleanup();
      }
    };

    // remove DOM element
    if (remove && this.$el) {
      pendingRemoval = true;
      this.$remove(function () {
        pendingRemoval = false;
        cleanupIfPossible();
      });
    }

    this._callHook('beforeDestroy');
    this._isBeingDestroyed = true;
    var i;
    // remove self from parent. only necessary
    // if parent is not being destroyed as well.
    var parent = this.$parent;
    if (parent && !parent._isBeingDestroyed) {
      parent.$children.$remove(this);
      // unregister ref (remove: true)
      this._updateRef(true);
    }
    // destroy all children.
    i = this.$children.length;
    while (i--) {
      this.$children[i].$destroy();
    }
    // teardown props
    if (this._propsUnlinkFn) {
      this._propsUnlinkFn();
    }
    // teardown all directives. this also tearsdown all
    // directive-owned watchers.
    if (this._unlinkFn) {
      this._unlinkFn();
    }
    i = this._watchers.length;
    while (i--) {
      this._watchers[i].teardown();
    }
    // remove reference to self on $el
    if (this.$el) {
      this.$el.__vue__ = null;
    }

    destroyReady = true;
    cleanupIfPossible();
  };

  /**
   * Clean up to ensure garbage collection.
   * This is called after the leave transition if there
   * is any.
   */

  Vue.prototype._cleanup = function () {
    if (this._isDestroyed) {
      return;
    }
    // remove self from owner fragment
    // do it in cleanup so that we can call $destroy with
    // defer right when a fragment is about to be removed.
    if (this._frag) {
      this._frag.children.$remove(this);
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (this._data && this._data.__ob__) {
      this._data.__ob__.removeVm(this);
    }
    // Clean up references to private properties and other
    // instances. preserve reference to _data so that proxy
    // accessors still work. The only potential side effect
    // here is that mutating the instance after it's destroyed
    // may affect the state of other components that are still
    // observing the same object, but that seems to be a
    // reasonable responsibility for the user rather than
    // always throwing an error on them.
    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
    // call the last hook...
    this._isDestroyed = true;
    this._callHook('destroyed');
    // turn off all instance listeners.
    this.$off();
  };
}

function miscMixin (Vue) {
  /**
   * Apply a list of filter (descriptors) to a value.
   * Using plain for loops here because this will be called in
   * the getter of any watcher with filters so it is very
   * performance sensitive.
   *
   * @param {*} value
   * @param {*} [oldValue]
   * @param {Array} filters
   * @param {Boolean} write
   * @return {*}
   */

  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
    var filter, fn, args, arg, offset, i, l, j, k;
    for (i = 0, l = filters.length; i < l; i++) {
      filter = filters[write ? l - i - 1 : i];
      fn = resolveAsset(this.$options, 'filters', filter.name, true);
      if (!fn) continue;
      fn = write ? fn.write : fn.read || fn;
      if (typeof fn !== 'function') continue;
      args = write ? [value, oldValue] : [value];
      offset = write ? 2 : 1;
      if (filter.args) {
        for (j = 0, k = filter.args.length; j < k; j++) {
          arg = filter.args[j];
          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
        }
      }
      value = fn.apply(this, args);
    }
    return value;
  };

  /**
   * Resolve a component, depending on whether the component
   * is defined normally or using an async factory function.
   * Resolves synchronously if already resolved, otherwise
   * resolves asynchronously and caches the resolved
   * constructor on the factory.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  Vue.prototype._resolveComponent = function (value, cb) {
    var factory;
    if (typeof value === 'function') {
      factory = value;
    } else {
      factory = resolveAsset(this.$options, 'components', value, true);
    }
    /* istanbul ignore if */
    if (!factory) {
      return;
    }
    // async component factory
    if (!factory.options) {
      if (factory.resolved) {
        // cached
        cb(factory.resolved);
      } else if (factory.requested) {
        // pool callbacks
        factory.pendingCallbacks.push(cb);
      } else {
        factory.requested = true;
        var cbs = factory.pendingCallbacks = [cb];
        factory.call(this, function resolve(res) {
          if (isPlainObject(res)) {
            res = Vue.extend(res);
          }
          // cache resolved
          factory.resolved = res;
          // invoke callbacks
          for (var i = 0, l = cbs.length; i < l; i++) {
            cbs[i](res);
          }
        }, function reject(reason) {
          process.env.NODE_ENV !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
        });
      }
    } else {
      // normal component
      cb(factory);
    }
  };
}

var filterRE$1 = /[^|]\|[^|]/;

function dataAPI (Vue) {
  /**
   * Get the value from an expression on this vm.
   *
   * @param {String} exp
   * @param {Boolean} [asStatement]
   * @return {*}
   */

  Vue.prototype.$get = function (exp, asStatement) {
    var res = parseExpression$1(exp);
    if (res) {
      if (asStatement) {
        var self = this;
        return function statementHandler() {
          self.$arguments = toArray(arguments);
          var result = res.get.call(self, self);
          self.$arguments = null;
          return result;
        };
      } else {
        try {
          return res.get.call(this, this);
        } catch (e) {}
      }
    }
  };

  /**
   * Set the value from an expression on this vm.
   * The expression must be a valid left-hand
   * expression in an assignment.
   *
   * @param {String} exp
   * @param {*} val
   */

  Vue.prototype.$set = function (exp, val) {
    var res = parseExpression$1(exp, true);
    if (res && res.set) {
      res.set.call(this, this, val);
    }
  };

  /**
   * Delete a property on the VM
   *
   * @param {String} key
   */

  Vue.prototype.$delete = function (key) {
    del(this._data, key);
  };

  /**
   * Watch an expression, trigger callback when its
   * value changes.
   *
   * @param {String|Function} expOrFn
   * @param {Function} cb
   * @param {Object} [options]
   *                 - {Boolean} deep
   *                 - {Boolean} immediate
   * @return {Function} - unwatchFn
   */

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    var parsed;
    if (typeof expOrFn === 'string') {
      parsed = parseDirective(expOrFn);
      expOrFn = parsed.expression;
    }
    var watcher = new Watcher(vm, expOrFn, cb, {
      deep: options && options.deep,
      sync: options && options.sync,
      filters: parsed && parsed.filters,
      user: !options || options.user !== false
    });
    if (options && options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };

  /**
   * Evaluate a text directive, including filters.
   *
   * @param {String} text
   * @param {Boolean} [asStatement]
   * @return {String}
   */

  Vue.prototype.$eval = function (text, asStatement) {
    // check for filters.
    if (filterRE$1.test(text)) {
      var dir = parseDirective(text);
      // the filter regex check might give false positive
      // for pipes inside strings, so it's possible that
      // we don't get any filters here
      var val = this.$get(dir.expression, asStatement);
      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
    } else {
      // no filter
      return this.$get(text, asStatement);
    }
  };

  /**
   * Interpolate a piece of template text.
   *
   * @param {String} text
   * @return {String}
   */

  Vue.prototype.$interpolate = function (text) {
    var tokens = parseText(text);
    var vm = this;
    if (tokens) {
      if (tokens.length === 1) {
        return vm.$eval(tokens[0].value) + '';
      } else {
        return tokens.map(function (token) {
          return token.tag ? vm.$eval(token.value) : token.value;
        }).join('');
      }
    } else {
      return text;
    }
  };

  /**
   * Log instance data as a plain JS object
   * so that it is easier to inspect in console.
   * This method assumes console is available.
   *
   * @param {String} [path]
   */

  Vue.prototype.$log = function (path) {
    var data = path ? getPath(this._data, path) : this._data;
    if (data) {
      data = clean(data);
    }
    // include computed fields
    if (!path) {
      var key;
      for (key in this.$options.computed) {
        data[key] = clean(this[key]);
      }
      if (this._props) {
        for (key in this._props) {
          data[key] = clean(this[key]);
        }
      }
    }
    console.log(data);
  };

  /**
   * "clean" a getter/setter converted object into a plain
   * object copy.
   *
   * @param {Object} - obj
   * @return {Object}
   */

  function clean(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

function domAPI (Vue) {
  /**
   * Convenience on-instance nextTick. The callback is
   * auto-bound to the instance, and this avoids component
   * modules having to rely on the global Vue.
   *
   * @param {Function} fn
   */

  Vue.prototype.$nextTick = function (fn) {
    nextTick(fn, this);
  };

  /**
   * Append instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$appendTo = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, append, appendWithTransition);
  };

  /**
   * Prepend instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$prependTo = function (target, cb, withTransition) {
    target = query(target);
    if (target.hasChildNodes()) {
      this.$before(target.firstChild, cb, withTransition);
    } else {
      this.$appendTo(target, cb, withTransition);
    }
    return this;
  };

  /**
   * Insert instance before target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$before = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
  };

  /**
   * Insert instance after target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$after = function (target, cb, withTransition) {
    target = query(target);
    if (target.nextSibling) {
      this.$before(target.nextSibling, cb, withTransition);
    } else {
      this.$appendTo(target.parentNode, cb, withTransition);
    }
    return this;
  };

  /**
   * Remove instance from DOM
   *
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$remove = function (cb, withTransition) {
    if (!this.$el.parentNode) {
      return cb && cb();
    }
    var inDocument = this._isAttached && inDoc(this.$el);
    // if we are not in document, no need to check
    // for transitions
    if (!inDocument) withTransition = false;
    var self = this;
    var realCb = function realCb() {
      if (inDocument) self._callHook('detached');
      if (cb) cb();
    };
    if (this._isFragment) {
      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
    } else {
      var op = withTransition === false ? removeWithCb : removeWithTransition;
      op(this.$el, this, realCb);
    }
    return this;
  };

  /**
   * Shared DOM insertion function.
   *
   * @param {Vue} vm
   * @param {Element} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition]
   * @param {Function} op1 - op for non-transition insert
   * @param {Function} op2 - op for transition insert
   * @return vm
   */

  function insert(vm, target, cb, withTransition, op1, op2) {
    target = query(target);
    var targetIsDetached = !inDoc(target);
    var op = withTransition === false || targetIsDetached ? op1 : op2;
    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
    if (vm._isFragment) {
      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
        op(node, target, vm);
      });
      cb && cb();
    } else {
      op(vm.$el, target, vm, cb);
    }
    if (shouldCallHook) {
      vm._callHook('attached');
    }
    return vm;
  }

  /**
   * Check for selectors
   *
   * @param {String|Element} el
   */

  function query(el) {
    return typeof el === 'string' ? document.querySelector(el) : el;
  }

  /**
   * Append operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function append(el, target, vm, cb) {
    target.appendChild(el);
    if (cb) cb();
  }

  /**
   * InsertBefore operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function beforeWithCb(el, target, vm, cb) {
    before(el, target);
    if (cb) cb();
  }

  /**
   * Remove operation that takes a callback.
   *
   * @param {Node} el
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function removeWithCb(el, vm, cb) {
    remove(el);
    if (cb) cb();
  }
}

function eventsAPI (Vue) {
  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$on = function (event, fn) {
    (this._events[event] || (this._events[event] = [])).push(fn);
    modifyListenerCount(this, event, 1);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$once = function (event, fn) {
    var self = this;
    function on() {
      self.$off(event, on);
      fn.apply(this, arguments);
    }
    on.fn = fn;
    this.$on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$off = function (event, fn) {
    var cbs;
    // all
    if (!arguments.length) {
      if (this.$parent) {
        for (event in this._events) {
          cbs = this._events[event];
          if (cbs) {
            modifyListenerCount(this, event, -cbs.length);
          }
        }
      }
      this._events = {};
      return this;
    }
    // specific event
    cbs = this._events[event];
    if (!cbs) {
      return this;
    }
    if (arguments.length === 1) {
      modifyListenerCount(this, event, -cbs.length);
      this._events[event] = null;
      return this;
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        modifyListenerCount(this, event, -1);
        cbs.splice(i, 1);
        break;
      }
    }
    return this;
  };

  /**
   * Trigger an event on self.
   *
   * @param {String|Object} event
   * @return {Boolean} shouldPropagate
   */

  Vue.prototype.$emit = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    var cbs = this._events[event];
    var shouldPropagate = isSource || !cbs;
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      // this is a somewhat hacky solution to the question raised
      // in #2102: for an inline component listener like <comp @test="doThis">,
      // the propagation handling is somewhat broken. Therefore we
      // need to treat these inline callbacks differently.
      var hasParentCbs = isSource && cbs.some(function (cb) {
        return cb._fromParent;
      });
      if (hasParentCbs) {
        shouldPropagate = false;
      }
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        var cb = cbs[i];
        var res = cb.apply(this, args);
        if (res === true && (!hasParentCbs || cb._fromParent)) {
          shouldPropagate = true;
        }
      }
    }
    return shouldPropagate;
  };

  /**
   * Recursively broadcast an event to all children instances.
   *
   * @param {String|Object} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$broadcast = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    // if no child has registered for this event,
    // then there's no need to broadcast.
    if (!this._eventsCount[event]) return;
    var children = this.$children;
    var args = toArray(arguments);
    if (isSource) {
      // use object event to indicate non-source emit
      // on children
      args[0] = { name: event, source: this };
    }
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var shouldPropagate = child.$emit.apply(child, args);
      if (shouldPropagate) {
        child.$broadcast.apply(child, args);
      }
    }
    return this;
  };

  /**
   * Recursively propagate an event up the parent chain.
   *
   * @param {String} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$dispatch = function (event) {
    var shouldPropagate = this.$emit.apply(this, arguments);
    if (!shouldPropagate) return;
    var parent = this.$parent;
    var args = toArray(arguments);
    // use object event to indicate non-source emit
    // on parents
    args[0] = { name: event, source: this };
    while (parent) {
      shouldPropagate = parent.$emit.apply(parent, args);
      parent = shouldPropagate ? parent.$parent : null;
    }
    return this;
  };

  /**
   * Modify the listener counts on all parents.
   * This bookkeeping allows $broadcast to return early when
   * no child has listened to a certain event.
   *
   * @param {Vue} vm
   * @param {String} event
   * @param {Number} count
   */

  var hookRE = /^hook:/;
  function modifyListenerCount(vm, event, count) {
    var parent = vm.$parent;
    // hooks do not get broadcasted so no need
    // to do bookkeeping for them
    if (!parent || !count || hookRE.test(event)) return;
    while (parent) {
      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
      parent = parent.$parent;
    }
  }
}

function lifecycleAPI (Vue) {
  /**
   * Set instance target element and kick off the compilation
   * process. The passed in `el` can be a selector string, an
   * existing Element, or a DocumentFragment (for block
   * instances).
   *
   * @param {Element|DocumentFragment|string} el
   * @public
   */

  Vue.prototype.$mount = function (el) {
    if (this._isCompiled) {
      process.env.NODE_ENV !== 'production' && warn('$mount() should be called only once.', this);
      return;
    }
    el = query(el);
    if (!el) {
      el = document.createElement('div');
    }
    this._compile(el);
    this._initDOMHooks();
    if (inDoc(this.$el)) {
      this._callHook('attached');
      ready.call(this);
    } else {
      this.$once('hook:attached', ready);
    }
    return this;
  };

  /**
   * Mark an instance as ready.
   */

  function ready() {
    this._isAttached = true;
    this._isReady = true;
    this._callHook('ready');
  }

  /**
   * Teardown the instance, simply delegate to the internal
   * _destroy.
   *
   * @param {Boolean} remove
   * @param {Boolean} deferCleanup
   */

  Vue.prototype.$destroy = function (remove, deferCleanup) {
    this._destroy(remove, deferCleanup);
  };

  /**
   * Partially compile a piece of DOM and return a
   * decompile function.
   *
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host]
   * @param {Object} [scope]
   * @param {Fragment} [frag]
   * @return {Function}
   */

  Vue.prototype.$compile = function (el, host, scope, frag) {
    return compile(el, this.$options, true)(this, el, host, scope, frag);
  };
}

/**
 * The exposed Vue constructor.
 *
 * API conventions:
 * - public API methods/properties are prefixed with `$`
 * - internal methods/properties are prefixed with `_`
 * - non-prefixed properties are assumed to be proxied user
 *   data.
 *
 * @constructor
 * @param {Object} [options]
 * @public
 */

function Vue(options) {
  this._init(options);
}

// install internals
initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
miscMixin(Vue);

// install instance APIs
dataAPI(Vue);
domAPI(Vue);
eventsAPI(Vue);
lifecycleAPI(Vue);

var slot = {

  priority: SLOT,
  params: ['name'],

  bind: function bind() {
    // this was resolved during component transclusion
    var name = this.params.name || 'default';
    var content = this.vm._slotContents && this.vm._slotContents[name];
    if (!content || !content.hasChildNodes()) {
      this.fallback();
    } else {
      this.compile(content.cloneNode(true), this.vm._context, this.vm);
    }
  },

  compile: function compile(content, context, host) {
    if (content && context) {
      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
        // if the inserted slot has v-if
        // inject fallback content as the v-else
        var elseBlock = document.createElement('template');
        elseBlock.setAttribute('v-else', '');
        elseBlock.innerHTML = this.el.innerHTML;
        // the else block should be compiled in child scope
        elseBlock._context = this.vm;
        content.appendChild(elseBlock);
      }
      var scope = host ? host._scope : this._scope;
      this.unlink = context.$compile(content, host, scope, this._frag);
    }
    if (content) {
      replace(this.el, content);
    } else {
      remove(this.el);
    }
  },

  fallback: function fallback() {
    this.compile(extractContent(this.el, true), this.vm);
  },

  unbind: function unbind() {
    if (this.unlink) {
      this.unlink();
    }
  }
};

var partial = {

  priority: PARTIAL,

  params: ['name'],

  // watch changes to name for dynamic partials
  paramWatchers: {
    name: function name(value) {
      vIf.remove.call(this);
      if (value) {
        this.insert(value);
      }
    }
  },

  bind: function bind() {
    this.anchor = createAnchor('v-partial');
    replace(this.el, this.anchor);
    this.insert(this.params.name);
  },

  insert: function insert(id) {
    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
    if (partial) {
      this.factory = new FragmentFactory(this.vm, partial);
      vIf.insert.call(this);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
  }
};

var elementDirectives = {
  slot: slot,
  partial: partial
};

var convertArray = vFor._postProcess;

/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
  offset = offset ? parseInt(offset, 10) : 0;
  n = toNumber(n);
  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/**
 * Filter filter for arrays
 *
 * @param {String} search
 * @param {String} [delimiter]
 * @param {String} ...dataKeys
 */

function filterBy(arr, search, delimiter) {
  arr = convertArray(arr);
  if (search == null) {
    return arr;
  }
  if (typeof search === 'function') {
    return arr.filter(search);
  }
  // cast to lowercase string
  search = ('' + search).toLowerCase();
  // allow optional `in` delimiter
  // because why not
  var n = delimiter === 'in' ? 3 : 2;
  // extract and flatten keys
  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
  var res = [];
  var item, key, val, j;
  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i];
    val = item && item.$value || item;
    j = keys.length;
    if (j) {
      while (j--) {
        key = keys[j];
        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
          res.push(item);
          break;
        }
      }
    } else if (contains(item, search)) {
      res.push(item);
    }
  }
  return res;
}

/**
 * Order filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy(arr) {
  var comparator = null;
  var sortKeys = undefined;
  arr = convertArray(arr);

  // determine order (last argument)
  var args = toArray(arguments, 1);
  var order = args[args.length - 1];
  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1;
    args = args.length > 1 ? args.slice(0, -1) : args;
  } else {
    order = 1;
  }

  // determine sortKeys & comparator
  var firstArg = args[0];
  if (!firstArg) {
    return arr;
  } else if (typeof firstArg === 'function') {
    // custom comparator
    comparator = function (a, b) {
      return firstArg(a, b) * order;
    };
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args);
    comparator = function (a, b, i) {
      i = i || 0;
      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
    };
  }

  function baseCompare(a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex];
    if (sortKey) {
      if (sortKey !== '$key') {
        if (isObject(a) && '$value' in a) a = a.$value;
        if (isObject(b) && '$value' in b) b = b.$value;
      }
      a = isObject(a) ? getPath(a, sortKey) : a;
      b = isObject(b) ? getPath(b, sortKey) : b;
    }
    return a === b ? 0 : a > b ? order : -order;
  }

  // sort on a copy to avoid mutating original array
  return arr.slice().sort(comparator);
}

/**
 * String contain helper
 *
 * @param {*} val
 * @param {String} search
 */

function contains(val, search) {
  var i;
  if (isPlainObject(val)) {
    var keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true;
      }
    }
  } else if (isArray(val)) {
    i = val.length;
    while (i--) {
      if (contains(val[i], search)) {
        return true;
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1;
  }
}

var digitsRE = /(\d{3})(?=\d)/g;

// asset collections must be a plain object.
var filters = {

  orderBy: orderBy,
  filterBy: filterBy,
  limitBy: limitBy,

  /**
   * Stringify value.
   *
   * @param {Number} indent
   */

  json: {
    read: function read(value, indent) {
      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
    },
    write: function write(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  },

  /**
   * 'abc' => 'Abc'
   */

  capitalize: function capitalize(value) {
    if (!value && value !== 0) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  /**
   * 'abc' => 'ABC'
   */

  uppercase: function uppercase(value) {
    return value || value === 0 ? value.toString().toUpperCase() : '';
  },

  /**
   * 'AbC' => 'abc'
   */

  lowercase: function lowercase(value) {
    return value || value === 0 ? value.toString().toLowerCase() : '';
  },

  /**
   * 12345 => $12,345.00
   *
   * @param {String} sign
   * @param {Number} decimals Decimal places
   */

  currency: function currency(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
  },

  /**
   * 'item' => 'items'
   *
   * @params
   *  an array of strings corresponding to
   *  the single, double, triple ... forms of the word to
   *  be pluralized. When the number to be pluralized
   *  exceeds the length of the args, it will use the last
   *  entry in the array.
   *
   *  e.g. ['single', 'double', 'triple', 'multiple']
   */

  pluralize: function pluralize(value) {
    var args = toArray(arguments, 1);
    var length = args.length;
    if (length > 1) {
      var index = value % 10 - 1;
      return index in args ? args[index] : args[length - 1];
    } else {
      return args[0] + (value === 1 ? '' : 's');
    }
  },

  /**
   * Debounce a handler function.
   *
   * @param {Function} handler
   * @param {Number} delay = 300
   * @return {Function}
   */

  debounce: function debounce(handler, delay) {
    if (!handler) return;
    if (!delay) {
      delay = 300;
    }
    return _debounce(handler, delay);
  }
};

function installGlobalAPI (Vue) {
  /**
   * Vue and every constructor that extends Vue has an
   * associated options object, which can be accessed during
   * compilation steps as `this.constructor.options`.
   *
   * These can be seen as the default options of every
   * Vue instance.
   */

  Vue.options = {
    directives: directives,
    elementDirectives: elementDirectives,
    filters: filters,
    transitions: {},
    components: {},
    partials: {},
    replace: true
  };

  /**
   * Expose useful internals
   */

  Vue.util = util;
  Vue.config = config;
  Vue.set = set;
  Vue['delete'] = del;
  Vue.nextTick = nextTick;

  /**
   * The following are exposed for advanced usage / plugins
   */

  Vue.compiler = compiler;
  Vue.FragmentFactory = FragmentFactory;
  Vue.internalDirectives = internalDirectives;
  Vue.parsers = {
    path: path,
    text: text,
    template: template,
    directive: directive,
    expression: expression
  };

  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */

  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   *
   * @param {Object} extendOptions
   */

  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var isFirstExtend = Super.cid === 0;
    if (isFirstExtend && extendOptions._Ctor) {
      return extendOptions._Ctor;
    }
    var name = extendOptions.name || Super.options.name;
    if (process.env.NODE_ENV !== 'production') {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
        name = null;
      }
    }
    var Sub = createClass(name || 'VueComponent');
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;
    // allow further extension
    Sub.extend = Super.extend;
    // create asset registers, so extended classes
    // can have their private assets too.
    config._assetTypes.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }
    // cache constructor
    if (isFirstExtend) {
      extendOptions._Ctor = Sub;
    }
    return Sub;
  };

  /**
   * A function that returns a sub-class constructor with the
   * given name. This gives us much nicer output when
   * logging instances in the console.
   *
   * @param {String} name
   * @return {Function}
   */

  function createClass(name) {
    /* eslint-disable no-new-func */
    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
    /* eslint-enable no-new-func */
  }

  /**
   * Plugin system
   *
   * @param {Object} plugin
   */

  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return;
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this;
  };

  /**
   * Apply a global mixin by merging it into the default
   * options.
   */

  Vue.mixin = function (mixin) {
    Vue.options = mergeOptions(Vue.options, mixin);
  };

  /**
   * Create asset registration methods with the following
   * signature:
   *
   * @param {String} id
   * @param {*} definition
   */

  config._assetTypes.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          if (!definition.name) {
            definition.name = id;
          }
          definition = Vue.extend(definition);
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });

  // expose internal transition API
  extend(Vue.transition, transition);
}

installGlobalAPI(Vue);

Vue.version = '1.0.28';

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue);
    } else if (process.env.NODE_ENV !== 'production' && inBrowser && /Chrome\/\d+/.test(window.navigator.userAgent)) {
      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
    }
  }
}, 0);

module.exports = Vue;
}).call(this,require('_process'))
},{"_process":124}],133:[function(require,module,exports){
var inserted = exports.cache = {}

exports.insert = function (css) {
  if (inserted[css]) return
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return elem
}

},{}],134:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.vuetable th.sortable:hover {\n  color: #2185d0;\n  cursor: pointer;\n}\n.vuetable-actions {\n  width: 15%;\n  padding: 12px 0px;\n  text-align: center;\n}\n.vuetable-pagination {\n  background: #f9fafb !important;\n}\n.vuetable-pagination-info {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        wrapperClass: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        historyMode: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        htmlTitle: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        tableWrapper: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        tableClass: {
            type: String,
            default: function _default() {
                return 'ui blue striped selectable celled stackable attached table';
            }
        },
        loadingClass: {
            type: String,
            default: function _default() {
                return 'loading';
            }
        },
        dataPath: {
            type: String,
            default: function _default() {
                return 'data';
            }
        },
        paginationPath: {
            type: String,
            default: function _default() {
                return 'links.pagination';
            }
        },
        fields: {
            type: Array,
            required: true
        },
        apiUrl: {
            type: String,
            required: true
        },
        sortOrder: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        multiSort: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        /*
         * physical key that will trigger multi-sort option
         * possible values: 'alt', 'ctrl', 'meta', 'shift'
         * 'ctrl' might not work as expected on Mac
         */
        multiSortKey: {
            type: String,
            default: 'alt'
        },
        perPage: {
            type: Number,
            coerce: function coerce(val) {
                return parseInt(val);
            },
            default: function _default() {
                return 10;
            }
        },
        ascendingIcon: {
            type: String,
            default: function _default() {
                return 'blue chevron up icon';
            }
        },
        descendingIcon: {
            type: String,
            default: function _default() {
                return 'blue chevron down icon';
            }
        },
        appendParams: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        showPagination: {
            type: Boolean,
            default: function _default() {
                return true;
            }
        },
        paginationComponent: {
            type: String,
            default: function _default() {
                return 'vuetable-pagination';
            }
        },
        paginationInfoTemplate: {
            type: String,
            default: function _default() {
                return "Displaying {from} to {to} of {total} items";
            }
        },
        paginationInfoNoDataTemplate: {
            type: String,
            default: function _default() {
                return 'No relevant data';
            }
        },
        paginationClass: {
            type: String,
            default: function _default() {
                return 'ui bottom attached segment grid';
            }
        },
        paginationInfoClass: {
            type: String,
            default: function _default() {
                return 'left floated left aligned six wide column';
            }
        },
        paginationComponentClass: {
            type: String,
            default: function _default() {
                return 'right floated right aligned six wide column';
            }
        },
        paginationConfig: {
            type: String,
            default: function _default() {
                return 'paginationConfig';
            }
        },
        paginationConfigCallback: {
            type: String,
            default: function _default() {
                return 'paginationConfig';
            }
        },
        itemActions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        queryParams: {
            type: Object,
            default: function _default() {
                return {
                    sort: 'sort',
                    page: 'page',
                    perPage: 'per_page'
                };
            }
        },
        loadOnStart: {
            type: Boolean,
            default: function _default() {
                return true;
            }
        },
        selectedTo: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        httpOptions: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        detailRow: {
            type: String,
            default: ''
        },
        detailRowCallback: {
            type: String,
            default: ''
        },
        detailRowId: {
            type: String,
            default: 'id'
        },
        detailRowTransition: {
            type: String,
            default: ''
        },
        detailRowClass: {
            type: String,
            default: 'vuetable-detail-row'
        },
        detailRowComponent: {
            type: String,
            default: ''
        },
        rowClassCallback: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            eventPrefix: 'vuetable:',
            tableData: null,
            tablePagination: null,
            currentPage: 1,
            visibleDetailRows: []
        };
    },
    directives: {
        'attr': {
            update: function update(value) {
                for (var i in value) {
                    this.el.setAttribute(i, value[i]);
                }
            }
        }
    },
    computed: {
        paginationInfo: function paginationInfo() {
            if (this.tablePagination == null || this.tablePagination.total == 0) {
                return this.paginationInfoNoDataTemplate;
            }

            return this.paginationInfoTemplate.replace('{from}', this.tablePagination.from || 0).replace('{to}', this.tablePagination.to || 0).replace('{total}', this.tablePagination.total || 0);
        },
        useDetailRow: function useDetailRow() {
            if (this.tableData && typeof this.tableData[0][this.detailRowId] === 'undefined') {
                console.warn('You need to define "detail-row-id" in order for detail-row feature to work!');
                return false;
            }

            return this.detailRowCallback.trim() !== '' || this.detailRowComponent !== '';
        },
        useDetailRowComponent: function useDetailRowComponent() {
            return this.detailRowComponent !== '';
        },
        countVisibleFields: function countVisibleFields() {
            return this.fields.filter(function (field) {
                return field.visible;
            }).length;
        }
    },
    methods: {
        normalizeFields: function normalizeFields() {
            var self = this;
            var obj;
            this.fields.forEach(function (field, i) {
                if (typeof field === 'string') {
                    obj = {
                        name: field,
                        title: self.setTitle(field),
                        titleClass: '',
                        dataClass: '',
                        callback: null,
                        visible: true
                    };
                } else {
                    obj = {
                        name: field.name,
                        title: field.title === undefined ? self.setTitle(field.name) : field.title,
                        sortField: field.sortField,
                        titleClass: field.titleClass === undefined ? '' : field.titleClass,
                        dataClass: field.dataClass === undefined ? '' : field.dataClass,
                        callback: field.callback === undefined ? '' : field.callback,
                        visible: field.visible === undefined ? true : field.visible
                    };
                }
                self.fields.$set(i, obj);
            });
        },
        setTitle: function setTitle(str) {
            if (this.isSpecialField(str)) {
                return '';
            }

            return this.titleCase(str);
        },
        titleCase: function titleCase(str) {
            return str.replace(/\w+/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        notIn: function notIn(str, arr) {
            return arr.indexOf(str) === -1;
        },
        loadData: function loadData() {
            var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            console.log(initial);
            var self = this;

            var wrapper = document.querySelector(this.tableWrapper);
            this.showLoadingAnimation(wrapper);

            if (this.historyMode == true && initial != true) {
                window.history.pushState({}, "Tenants", '?' + this.getAllQueryParams());
            }

            if (initial && window.location.search != '') {
                var url = this.apiUrl + window.location.search;
            } else {
                var url = this.apiUrl + '?' + this.getAllQueryParams();
            }

            this.$http.get(url, this.httpOptions).then(function (response) {
                var body = this.transform(response.body);
                self.tableData = self.getObjectValue(body, self.dataPath, null);
                self.tablePagination = self.getObjectValue(body, self.paginationPath, null);
                if (self.tablePagination === null) {
                    console.warn('vuetable: pagination-path "' + self.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + 'or you may have set it incorrectly.');
                }

                self.$nextTick(function () {
                    self.dispatchEvent('load-success', response);
                    self.broadcastEvent('load-success', self.tablePagination);

                    self.hideLoadingAnimation(wrapper);
                });
            }, function (response) {
                self.dispatchEvent('load-error', response);
                self.broadcastEvent('load-error', response);

                self.hideLoadingAnimation(wrapper);
            });
        },
        getAllQueryParams: function getAllQueryParams() {
            var params = [this.queryParams.sort + '=' + this.getSortParam(), this.queryParams.page + '=' + this.currentPage, this.queryParams.perPage + '=' + this.perPage].join('&');

            if (this.appendParams.length > 0) {
                params += '&' + this.appendParams.join('&');
            }

            return params;
        },
        showLoadingAnimation: function showLoadingAnimation(wrapper) {
            if (wrapper !== null) {
                this.addClass(wrapper, this.loadingClass);
            }
            this.dispatchEvent('loading');
        },
        hideLoadingAnimation: function hideLoadingAnimation(wrapper) {
            if (wrapper !== null) {
                this.removeClass(wrapper, this.loadingClass);
            }
            this.dispatchEvent('loaded');
        },
        transform: function transform(data) {
            var func = 'transform';

            if (this.parentFunctionExists(func)) {
                return this.$parent[func].call(this.$parent, data);
            }

            return data;
        },
        parentFunctionExists: function parentFunctionExists(func) {
            return func !== '' && typeof this.$parent[func] === 'function';
        },
        getTitle: function getTitle(field) {
            if (typeof field.title === 'undefined') {
                return field.name.replace('.', ' ');
            }
            return field.title;
        },
        getSortParam: function getSortParam() {
            if (!this.sortOrder || this.sortOrder.field == '') {
                return '';
            }

            if (typeof this.$parent['getSortParam'] == 'function') {
                return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
            }

            return this.getDefaultSortParam();
        },
        getDefaultSortParam: function getDefaultSortParam() {
            var result = '';

            for (var i = 0; i < this.sortOrder.length; i++) {
                var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

                result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
            }

            return result;
        },
        addClass: function addClass(el, className) {
            if (el.classList) el.classList.add(className);else el.className += ' ' + className;
        },
        removeClass: function removeClass(el, className) {
            if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        dispatchEvent: function dispatchEvent(eventName, args) {
            this.$dispatch(this.eventPrefix + eventName, args);
        },
        broadcastEvent: function broadcastEvent(eventName, args) {
            this.$broadcast(this.eventPrefix + eventName, args);
        },
        orderBy: function orderBy(field, event) {
            if (!this.isSortable(field)) {
                return;
            }

            var key = this.multiSortKey.toLowerCase() + 'Key';

            if (this.multiSort && event[key]) {
                //adding column to multisort
                var i = this.currentSortOrder(field);

                if (i === false) {
                    //this field is not in the sort array yet
                    this.sortOrder.push({
                        field: field.sortField,
                        direction: 'asc'
                    });
                } else {
                    //this field is in the sort array, now we change its state
                    if (this.sortOrder[i].direction == 'asc') {
                        // switch direction
                        this.sortOrder[i].direction = 'desc';
                    } else {
                        //remove sort condition
                        this.sortOrder.splice(i, 1);
                    }
                }
            } else {
                //no multisort, or resetting sort
                if (this.sortOrder.length == 0) {
                    this.sortOrder.push({
                        field: '',
                        direction: 'asc'
                    });
                }

                this.sortOrder.splice(1); //removes additional columns

                if (this.sortOrder[0].field == field.sortField) {
                    // change sort direction
                    this.sortOrder[0].direction = this.sortOrder[0].direction == 'asc' ? 'desc' : 'asc';
                } else {
                    // reset sort direction
                    this.sortOrder[0].direction = 'asc';
                }
                this.sortOrder[0].field = field.sortField;
            }

            this.currentPage = 1; // reset page index
            this.loadData();
        },
        isSortable: function isSortable(field) {
            return !(typeof field.sortField == 'undefined');
        },
        isCurrentSortField: function isCurrentSortField(field) {
            return this.currentSortOrder(field) !== false;
        },
        currentSortOrder: function currentSortOrder(field) {
            if (!this.isSortable(field)) {
                return false;
            }

            for (var i = 0; i < this.sortOrder.length; i++) {
                if (this.sortOrder[i].field == field.sortField) {
                    return i;
                }
            }

            return false;
        },
        sortIcon: function sortIcon(field) {
            var i = this.currentSortOrder(field);
            if (i !== false) {
                return this.sortOrder[i].direction == 'asc' ? this.ascendingIcon : this.descendingIcon;
            } else {
                return '';
            }
        },
        sortIconOpacity: function sortIconOpacity(field) {
            //fields with stronger precedence have darker color

            //if there are few fields, we go down by 0.3
            //ex. 2 fields are selected: 1.0, 0.7

            //if there are more we go down evenly on the given spectrum
            //ex. 6 fields are selected: 1.0, 0.86, 0.72, 0.58, 0.44, 0.3

            var max = 1.0;
            var min = 0.3;
            var step = 0.3;

            var count = this.sortOrder.length;
            var current = this.currentSortOrder(field);

            if (max - count * step < min) {
                step = (max - min) / (count - 1);
            }

            var opacity = max - current * step;

            return opacity;
        },
        gotoPreviousPage: function gotoPreviousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.loadData();
            }
        },
        gotoNextPage: function gotoNextPage() {
            if (this.currentPage < this.tablePagination.last_page) {
                this.currentPage++;
                this.loadData();
            }
        },
        gotoPage: function gotoPage(page) {
            if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
                this.currentPage = page;
                this.loadData();
            }
        },
        isSpecialField: function isSpecialField(fieldName) {
            // return fieldName.startsWith('__')
            return fieldName.slice(0, 2) === '__';
        },
        hasCallback: function hasCallback(item) {
            return item.callback ? true : false;
        },
        callCallback: function callCallback(field, item) {
            if (!this.hasCallback(field)) return;

            var args = field.callback.split('|');
            var func = args.shift();

            if (typeof this.$parent[func] == 'function') {
                return args.length > 0 ? this.$parent[func].apply(this.$parent, [this.getObjectValue(item, field.name)].concat(args)) : this.$parent[func].call(this.$parent, this.getObjectValue(item, field.name));
            }

            return null;
        },
        getObjectValue: function getObjectValue(object, path, defaultValue) {
            defaultValue = typeof defaultValue == 'undefined' ? null : defaultValue;

            var obj = object;
            if (path.trim() != '') {
                var keys = path.split('.');
                keys.forEach(function (key) {
                    if (obj !== null && typeof obj[key] != 'undefined' && obj[key] !== null) {
                        obj = obj[key];
                    } else {
                        obj = defaultValue;
                        return;
                    }
                });
            }
            return obj;
        },
        callAction: function callAction(action, data) {
            this.$dispatch(this.eventPrefix + 'action', action, data);
        },
        addParam: function addParam(param) {
            this.appendParams.push(param);
        },
        toggleCheckbox: function toggleCheckbox(isChecked, dataItem, fieldName) {
            var idColumn = this.extractArgs(fieldName);
            if (idColumn === undefined) {
                console.warn('You did not provide reference id column with "__checkbox:<column_name>" field!');
                return;
            }

            var key = dataItem[idColumn];
            if (isChecked) {
                this.selectId(key);
            } else {
                this.unselectId(key);
            }
        },
        toggleAllCheckboxes: function toggleAllCheckboxes(isChecked, fieldName) {
            var self = this;
            var idColumn = this.extractArgs(fieldName);

            if (isChecked) {
                this.tableData.forEach(function (dataItem) {
                    self.selectId(dataItem[idColumn]);
                });
            } else {
                this.tableData.forEach(function (dataItem) {
                    self.unselectId(dataItem[idColumn]);
                });
            }
        },
        selectId: function selectId(key) {
            if (!this.isSelectedRow(key)) {
                this.selectedTo.push(key);
            }
        },
        unselectId: function unselectId(key) {
            this.selectedTo.$remove(key);
            // this.selectedTo = this.selectedTo.filter(function(item) {
            //     return item !== key
            // })
        },
        isSelectedRow: function isSelectedRow(key) {
            return this.selectedTo.indexOf(key) >= 0;
        },
        rowSelected: function rowSelected(dataItem, fieldName) {
            var idColumn = this.extractArgs(fieldName);
            // var key = dataItem[idColumn]

            return this.isSelectedRow(dataItem[idColumn]);
        },
        checkCheckboxesState: function checkCheckboxesState(fieldName) {
            var self = this;
            var idColumn = this.extractArgs(fieldName);
            var selector = 'th.checkbox_' + idColumn + ' input[type=checkbox]';
            var els = document.querySelectorAll(selector);

            // count how many checkbox row in the current page has been checked
            var selected = this.tableData.filter(function (item) {
                return self.selectedTo.indexOf(item[idColumn]) >= 0;
            });

            // count == 0, clear the checkbox
            if (selected.length <= 0) {
                els.forEach(function (el) {
                    el.indeterminate = false;
                });
                return false;
            }
            // count > 0 and count < perPage, set checkbox state to 'indeterminate'
            else if (selected.length < this.perPage) {
                    els.forEach(function (el) {
                        el.indeterminate = true;
                    });
                    return true;
                }
                // count == perPage, set checkbox state to 'checked'
                else {
                        els.forEach(function (el) {
                            el.indeterminate = false;
                        });
                        return true;
                    }
        },
        extractName: function extractName(string) {
            return string.split(':')[0].trim();
        },
        extractArgs: function extractArgs(string) {
            return string.split(':')[1];
        },
        callDetailRowCallback: function callDetailRowCallback(item) {
            var func = this.detailRowCallback.trim();
            if (func === '') {
                return '';
            }

            if (typeof this.$parent[func] == 'function') {
                return this.$parent[func].call(this.$parent, item);
            } else {
                console.error('Function "' + func + '()" does not exist!');
            }
        },
        isVisibleDetailRow: function isVisibleDetailRow(rowId) {
            return this.visibleDetailRows.indexOf(rowId) >= 0;
        },
        showDetailRow: function showDetailRow(rowId) {
            if (!this.isVisibleDetailRow(rowId)) {
                this.visibleDetailRows.push(rowId);
            }
        },
        hideDetailRow: function hideDetailRow(rowId) {
            if (this.isVisibleDetailRow(rowId)) {
                this.visibleDetailRows.$remove(rowId);
            }
        },
        toggleDetailRow: function toggleDetailRow(rowId) {
            if (this.isVisibleDetailRow(rowId)) {
                this.hideDetailRow(rowId);
            } else {
                this.showDetailRow(rowId);
            }
        },
        onRowClass: function onRowClass(dataItem, index) {
            var func = this.rowClassCallback.trim();

            if (func !== '' && typeof this.$parent[func] === 'function') {
                return this.$parent[func].call(this.$parent, dataItem, index);
            }
            return '';
        },
        onRowChanged: function onRowChanged(dataItem) {
            this.dispatchEvent('row-changed', dataItem);
            return true;
        },
        onRowClicked: function onRowClicked(dataItem, event) {
            this.$dispatch(this.eventPrefix + 'row-clicked', dataItem, event);
            return true;
        },
        onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
            this.$dispatch(this.eventPrefix + 'row-dblclicked', dataItem, event);
        },
        onCellClicked: function onCellClicked(dataItem, field, event) {
            this.$dispatch(this.eventPrefix + 'cell-clicked', dataItem, field, event);
        },
        onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
            this.$dispatch(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
        },
        onDetailRowClick: function onDetailRowClick(dataItem, event) {
            this.$dispatch(this.eventPrefix + 'detail-row-clicked', dataItem, event);
        },
        callPaginationConfig: function callPaginationConfig() {
            if (typeof this.$parent[this.paginationConfigCallback] === 'function') {
                this.$parent[this.paginationConfigCallback].call(this.$parent, this.$refs.pagination.$options.name);
            }
        },
        logDeprecatedMessage: function logDeprecatedMessage(name, replacer) {
            var msg = '"{name}" prop is being deprecated and will be removed in the future. Please use "{replacer}" instead.';
            console.warn(msg.replace('{name}', name).replace('{replacer}', replacer));
        },
        checkForDeprecatedProps: function checkForDeprecatedProps() {
            if (this.paginationConfig !== 'paginationConfig') {
                this.logDeprecatedMessage('paginationConfig', 'paginationConfigCallback');
            }
            if (this.detailRow !== '') {
                this.logDeprecatedMessage('detail-row', 'detail-row-callback');
            }
            if (this.detailRowCallback !== '') {
                this.logDeprecatedMessage('detail-row-callback', 'detail-row-component');
            }
        }
    },
    watch: {
        'multiSort': function multiSort(newVal, oldVal) {
            if (newVal === false && this.sortOrder.length > 1) {
                this.sortOrder.splice(1);
                this.loadData();
            }
        }
    },
    events: {
        'vuetable-pagination:change-page': function vuetablePaginationChangePage(page) {
            if (page == 'prev') {
                this.gotoPreviousPage();
            } else if (page == 'next') {
                this.gotoNextPage();
            } else {
                this.gotoPage(page);
            }
        },
        'vuetable:reload': function vuetableReload() {
            this.loadData();
        },
        'vuetable:refresh': function vuetableRefresh() {
            this.currentPage = 1;
            this.loadData();
        },
        'vuetable:goto-page': function vuetableGotoPage(page) {
            this.$emit('vuetable-pagination:change-page', page);
        },
        'vuetable:set-options': function vuetableSetOptions(options) {
            for (var n in options) {
                this.$set(n, options[n]);
            }
        },
        'vuetable:toggle-detail': function vuetableToggleDetail(dataItem) {
            this.toggleDetailRow(dataItem);
        },
        'vuetable:show-detail': function vuetableShowDetail(dataItem) {
            this.showDetailRow(dataItem);
        },
        'vuetable:hide-detail': function vuetableHideDetail(dataItem) {
            this.hideDetailRow(dataItem);
        },
        'vuetable:normalize-fields': function vuetableNormalizeFields() {
            this.normalizeFields();
        }
    },
    created: function created() {
        this.checkForDeprecatedProps();
        this.normalizeFields();
        if (this.loadOnStart) {
            this.loadData(true);
        }
        this.$nextTick(function () {
            this.callPaginationConfig();
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"{{wrapperClass}}\">\n    <table class=\"vuetable {{tableClass}}\">\n        <thead>\n            <tr>\n                <template v-for=\"field in fields\">\n                    <template v-if=\"field.visible\">\n                        <template v-if=\"isSpecialField(field.name)\">\n                            <th v-if=\"extractName(field.name) == '__checkbox'\" :class=\"[field.titleClass, 'checkbox_'+extractArgs(field.name)]\">\n                                <input type=\"checkbox\" @change=\"toggleAllCheckboxes($event.target.checked, field.name)\" :checked=\"checkCheckboxesState(field.name)\">\n                            </th>\n                            <th v-if=\"extractName(field.name) == '__component'\" @click=\"orderBy(field, $event)\" class=\"{{field.titleClass || ''}} {{isSortable(field) ? 'sortable' : ''}}\">\n                                {{field.title || ''}}\n                                <i v-if=\"isCurrentSortField(field) &amp;&amp; field.title\" class=\"{{ sortIcon(field) }}\" :style=\"{opacity: sortIconOpacity(field)}\"></i>\n                            </th>\n                            <th v-if=\"notIn(extractName(field.name), ['__checkbox', '__component'])\" id=\"{{field.name}}\" class=\"{{field.titleClass || ''}}\">\n                                {{field.title || ''}}\n                            </th>\n                        </template>\n                        <template v-else=\"\">\n                            <th v-if=\"!htmlTitle\" @click=\"orderBy(field, $event)\" id=\"_{{field.name}}\" class=\"{{field.titleClass || ''}} {{isSortable(field) ? 'sortable' : ''}}\">\n                                {{getTitle(field) | capitalize}}&nbsp;\n                                <i v-if=\"isCurrentSortField(field)\" class=\"{{ sortIcon(field) }}\" :style=\"{opacity: sortIconOpacity(field)}\"></i>\n                            </th>\n                            <th v-else=\"\" @click=\"orderBy(field, $event)\" id=\"_{{field.name}}\" class=\"{{field.titleClass || ''}} {{isSortable(field) ? 'sortable' : ''}}\">\n                                <span v-html=\"getTitle(field)\"></span>&nbsp;\n                                <i v-if=\"isCurrentSortField(field)\" class=\"{{ sortIcon(field) }}\" :style=\"{opacity: sortIconOpacity(field)}\"></i>\n                            </th>\n                        </template>\n                    </template>\n                </template>\n            </tr>\n        </thead>\n        <tbody v-cloak=\"\">\n            <template v-for=\"(itemNumber, item) in tableData\">\n                <tr @dblclick=\"onRowDoubleClicked(item, $event)\" @click=\"onRowClicked(item, $event)\" :render=\"onRowChanged(item)\" :class=\"onRowClass(item, itemNumber)\">\n                    <template v-for=\"field in fields\">\n                        <template v-if=\"field.visible\">\n                            <template v-if=\"isSpecialField(field.name)\">\n                                <td v-if=\"extractName(field.name) == '__sequence'\" class=\"vuetable-sequence {{field.dataClass}}\" v-html=\"tablePagination.from + itemNumber\">\n                                </td>\n                                <td v-if=\"extractName(field.name) == '__checkbox'\" class=\"vuetable-checkboxes {{field.dataClass}}\">\n                                    <input type=\"checkbox\" @change=\"toggleCheckbox($event.target.checked, item, field.name)\" :checked=\"rowSelected(item, field.name)\">\n                                </td>\n                                <td v-if=\"field.name == '__actions'\" class=\"vuetable-actions {{field.dataClass}}\">\n                                    <template v-for=\"action in itemActions\">\n                                        <button class=\"{{ action.class }}\" @click=\"callAction(action.name, item)\" v-attr=\"action.extra\">\n                                            <i class=\"{{ action.icon }}\"></i> {{ action.label }}\n                                        </button>\n                                    </template>\n                                </td>\n                                <td v-if=\"extractName(field.name) == '__component'\" class=\"{{field.dataClass}}\">\n                                    <component :is=\"extractArgs(field.name)\" :row-data=\"item\" :row-index=\"itemNumber\"></component>\n                                </td>\n                            </template>\n                            <template v-else=\"\">\n                                <td v-if=\"hasCallback(field)\" class=\"{{field.dataClass}}\" @click=\"onCellClicked(item, field, $event)\" @dblclick=\"onCellDoubleClicked(item, field, $event)\">\n                                    {{{ callCallback(field, item) }}}\n                                </td>\n                                <td v-else=\"\" class=\"{{field.dataClass}}\" @click=\"onCellClicked(item, field, $event)\" @dblclick=\"onCellDoubleClicked(item, field, $event)\">\n                                    {{{ getObjectValue(item, field.name, \"\") }}}\n                                </td>\n                            </template>\n                        </template>\n                    </template>\n                </tr>\n                <template v-if=\"useDetailRow\">\n                  <template v-if=\"useDetailRowComponent\">\n                    <tr v-if=\"isVisibleDetailRow(item[detailRowId])\" @click=\"onDetailRowClick(item, $event)\" :transition=\"detailRowTransition\" :class=\"[detailRowClass]\">\n                      <td :colspan=\"countVisibleFields\">\n                        <component :is=\"detailRowComponent\" :row-data=\"item\" :row-index=\"itemNumber\"></component>\n                      </td>\n                    </tr>\n                  </template>\n                  <template v-else=\"\">\n                    <tr v-if=\"isVisibleDetailRow(item[detailRowId])\" v-html=\"callDetailRowCallback(item)\" @click=\"onDetailRowClick(item, $event)\" :transition=\"detailRowTransition\" :class=\"[detailRowClass]\"></tr>\n                  </template>\n                </template>\n            </template>\n        </tbody>\n    </table>\n    <div v-if=\"showPagination\" class=\"vuetable-pagination {{paginationClass}}\">\n        <div class=\"vuetable-pagination-info {{paginationInfoClass}}\" v-html=\"paginationInfo\">\n        </div>\n        <div v-show=\"tablePagination &amp;&amp; tablePagination.last_page > 1\" class=\"vuetable-pagination-component {{paginationComponentClass}}\">\n            <component v-ref:pagination=\"\" :is=\"paginationComponent\"></component>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.vuetable th.sortable:hover {\n  color: #2185d0;\n  cursor: pointer;\n}\n.vuetable-actions {\n  width: 15%;\n  padding: 12px 0px;\n  text-align: center;\n}\n.vuetable-pagination {\n  background: #f9fafb !important;\n}\n.vuetable-pagination-info {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3166e0da", module.exports)
  } else {
    hotAPI.update("_v-3166e0da", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],135:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VuetablePaginationMixin = require('./VuetablePaginationMixin.vue');

var _VuetablePaginationMixin2 = _interopRequireDefault(_VuetablePaginationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_VuetablePaginationMixin2.default]
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"{{wrapperClass}}\">\n    <a @click=\"loadPage(1)\" class=\"btn-nav {{linkClass}} {{isOnFirstPage ? disabledClass : ''}}\">\n            <i v-if=\"icons.first != ''\" class=\"{{icons.first}}\"></i>\n            <span v-else=\"\">«</span>\n    </a>\n    <a @click=\"loadPage('prev')\" class=\"btn-nav {{linkClass}} {{isOnFirstPage ? disabledClass : ''}}\">\n            <i v-if=\"icons.next != ''\" class=\"{{icons.prev}}\"></i>\n            <span v-else=\"\">&nbsp;‹</span>\n    </a>\n    <template v-if=\"notEnoughPages\">\n        <template v-for=\"n in totalPage\">\n            <a @click=\"loadPage(n+1)\" class=\"{{pageClass}} {{isCurrentPage(n+1) ? activeClass : ''}}\">\n                    {{ n+1 }}\n            </a>\n        </template>\n    </template>\n    <template v-else=\"\">\n       <template v-for=\"n in windowSize\">\n           <a @click=\"loadPage(windowStart+n)\" class=\"{{pageClass}} {{isCurrentPage(windowStart+n) ? activeClass : ''}}\">\n                {{ windowStart+n }}\n           </a>\n       </template>\n    </template>\n    <a @click=\"loadPage('next')\" class=\"btn-nav {{linkClass}} {{isOnLastPage ? disabledClass : ''}}\">\n        <i v-if=\"icons.next != ''\" class=\"{{icons.next}}\"></i>\n        <span v-else=\"\">›&nbsp;</span>\n    </a>\n    <a @click=\"loadPage(totalPage)\" class=\"btn-nav {{linkClass}} {{isOnLastPage ? disabledClass : ''}}\">\n        <i v-if=\"icons.last != ''\" class=\"{{icons.last}}\"></i>\n        <span v-else=\"\">»</span>\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7b8b788d", module.exports)
  } else {
    hotAPI.update("_v-7b8b788d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./VuetablePaginationMixin.vue":137,"vue":132,"vue-hot-reload-api":129}],136:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _VuetablePaginationMixin = require('./VuetablePaginationMixin.vue');

var _VuetablePaginationMixin2 = _interopRequireDefault(_VuetablePaginationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_VuetablePaginationMixin2.default],
    props: {
        'dropdownClass': {
            type: String,
            default: function _default() {
                return 'ui search dropdown';
            }
        },
        'pageText': {
            type: String,
            default: function _default() {
                return 'Page';
            }
        }
    },
    methods: {
        loadPage: function loadPage(page) {
            // update dropdown value
            if (page == 'prev' && !this.isOnFirstPage) {
                this.setDropdownToPage(this.tablePagination.current_page - 1);
            } else if (page == 'next' && !this.isOnLastPage) {
                this.setDropdownToPage(this.tablePagination.current_page + 1);
            }

            this.$dispatch('vuetable-pagination:change-page', page);
        },
        setDropdownToPage: function setDropdownToPage(page) {
            this.$nextTick(function () {
                document.getElementById('vuetable-pagination-dropdown').value = page;
            });
        },
        selectPage: function selectPage(event) {
            this.$dispatch('vuetable-pagination:change-page', event.target.selectedIndex + 1);
        }
    },
    events: {
        'vuetable:load-success': function vuetableLoadSuccess(tablePagination) {
            this.tablePagination = tablePagination;
            this.setDropdownToPage(tablePagination.current_page);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"{{wrapperClass}}\">\n    <a @click=\"loadPage('prev')\" class=\"{{linkClass}} {{isOnFirstPage ? disabledClass : ''}}\">\n        <i :class=\"icons.prev\"></i>\n    </a>\n    <select id=\"vuetable-pagination-dropdown\" class=\"{{dropdownClass}}\" @change=\"selectPage($event)\">\n        <template v-for=\"n in totalPage\">\n            <option class=\"{{pageClass}}\" value=\"{{n+1}}\">\n                {{pageText}} {{n+1}}\n            </option>\n        </template>\n    </select>\n    <a @click=\"loadPage('next')\" class=\"{{linkClass}} {{isOnLastPage ? disabledClass : ''}}\">\n        <i :class=\"icons.next\"></i>\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-63a64984", module.exports)
  } else {
    hotAPI.update("_v-63a64984", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./VuetablePaginationMixin.vue":137,"vue":132,"vue-hot-reload-api":129}],137:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        'wrapperClass': {
            type: String,
            default: function _default() {
                return 'ui right floated pagination menu';
            }
        },
        'activeClass': {
            type: String,
            default: function _default() {
                return 'active large';
            }
        },
        'disabledClass': {
            type: String,
            default: function _default() {
                return 'disabled';
            }
        },
        'pageClass': {
            type: String,
            default: function _default() {
                return 'item';
            }
        },
        'linkClass': {
            type: String,
            default: function _default() {
                return 'icon item';
            }
        },
        'icons': {
            type: Object,
            default: function _default() {
                return {
                    first: 'angle double left icon',
                    prev: 'left chevron icon',
                    next: 'right chevron icon',
                    last: 'angle double right icon'
                };
            }
        },
        'onEachSide': {
            type: Number,
            coerce: function coerce(value) {
                return parseInt(value);
            },
            default: function _default() {
                return 2;
            }
        }
    },
    data: function data() {
        return {
            tablePagination: null
        };
    },
    computed: {
        totalPage: function totalPage() {
            return this.tablePagination == null ? 0 : this.tablePagination.last_page;
        },
        isOnFirstPage: function isOnFirstPage() {
            return this.tablePagination == null ? false : this.tablePagination.current_page == 1;
        },
        isOnLastPage: function isOnLastPage() {
            return this.tablePagination == null ? false : this.tablePagination.current_page == this.tablePagination.last_page;
        },
        notEnoughPages: function notEnoughPages() {
            return this.totalPage < this.onEachSide * 2 + 4;
        },
        windowSize: function windowSize() {
            return this.onEachSide * 2 + 1;
        },
        windowStart: function windowStart() {
            if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
                return 1;
            } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
                return this.totalPage - this.onEachSide * 2;
            }

            return this.tablePagination.current_page - this.onEachSide;
        }
    },
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        },
        isCurrentPage: function isCurrentPage(page) {
            return page == this.tablePagination.current_page;
        }
    },
    events: {
        'vuetable:load-success': function vuetableLoadSuccess(tablePagination) {
            this.tablePagination = tablePagination;
        },
        'vuetable-pagination:set-options': function vuetablePaginationSetOptions(options) {
            for (var n in options) {
                this.$set(n, options[n]);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-12ffe1a4", module.exports)
  } else {
    hotAPI.update("_v-12ffe1a4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],138:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ObjectToFormdata = require("../vue/utils/helpers/ObjectToFormdata.js");

var _ObjectToFormdata2 = _interopRequireDefault(_ObjectToFormdata);

var _ToFD = require("../vue/utils/helpers/ToFD.js");

var _ToFD2 = _interopRequireDefault(_ToFD);

var _Vuetable = require("vuetable/src/components/Vuetable.vue");

var _Vuetable2 = _interopRequireDefault(_Vuetable);

var _VuetablePagination = require("vuetable/src/components/VuetablePagination.vue");

var _VuetablePagination2 = _interopRequireDefault(_VuetablePagination);

var _VuetablePaginationDropdown = require("vuetable/src/components/VuetablePaginationDropdown.vue");

var _VuetablePaginationDropdown2 = _interopRequireDefault(_VuetablePaginationDropdown);

var _DeviceHelper = require("../vue/vueify/components/ui/vuetable/DeviceHelper.vue");

var _DeviceHelper2 = _interopRequireDefault(_DeviceHelper);

var _DateFields = require("../vue/vueify/components/ui/DateFields.vue");

var _DateFields2 = _interopRequireDefault(_DateFields);

var _FileSelector = require("../vue/vueify/components/ui/FileSelector.vue");

var _FileSelector2 = _interopRequireDefault(_FileSelector);

var _FileUpload = require("../vue/vueify/components/ui/FileUpload.vue");

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _VueGoogleAutocomplete = require("../vue/vueify/components/ui/VueGoogleAutocomplete.vue");

var _VueGoogleAutocomplete2 = _interopRequireDefault(_VueGoogleAutocomplete);

var _vueChartjs = require("vue-chartjs");

var _vueChartjs2 = _interopRequireDefault(_vueChartjs);

var _vueRouter = require("vue-router");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueSelect = require("vue-select");

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _Portfolios = require("../vue/gateguard/Portfolios.vue");

var _Portfolios2 = _interopRequireDefault(_Portfolios);

var _Announcements = require("../vue/gateguard/Announcements.vue");

var _Announcements2 = _interopRequireDefault(_Announcements);

var _Visitors = require("../vue/gateguard/Visitors.vue");

var _Visitors2 = _interopRequireDefault(_Visitors);

var _TenantsPage = require("../vue/gateguard/TenantsPage.vue");

var _TenantsPage2 = _interopRequireDefault(_TenantsPage);

var _Buildings = require("../vue/gateguard/Buildings.vue");

var _Buildings2 = _interopRequireDefault(_Buildings);

var _Calls = require("../vue/gateguard/Calls.vue");

var _Calls2 = _interopRequireDefault(_Calls);

var _AddPortfolioModal = require("../vue/gateguard/AddPortfolioModal.vue");

var _AddPortfolioModal2 = _interopRequireDefault(_AddPortfolioModal);

var _AddBuildingModal = require("../vue/gateguard/AddBuildingModal.vue");

var _AddBuildingModal2 = _interopRequireDefault(_AddBuildingModal);

var _AssignBuildingModal = require("../vue/gateguard/AssignBuildingModal.vue");

var _AssignBuildingModal2 = _interopRequireDefault(_AssignBuildingModal);

var _AddAnnounceModal = require("../vue/gateguard/AddAnnounceModal.vue");

var _AddAnnounceModal2 = _interopRequireDefault(_AddAnnounceModal);

var _AddVisitorModal = require("../vue/gateguard/AddVisitorModal.vue");

var _AddVisitorModal2 = _interopRequireDefault(_AddVisitorModal);

var _AddTenantModal = require("../vue/gateguard/AddTenantModal.vue");

var _AddTenantModal2 = _interopRequireDefault(_AddTenantModal);

var _DeviceSettings = require("../vue/gateguard/DeviceSettings.vue");

var _DeviceSettings2 = _interopRequireDefault(_DeviceSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

$(document).ready(function () {
  //body & comps-section__comps--outer section scroll
  $(".comps-section__comps--outer").niceScroll({
    cursorcolor: "#dff4ff",
    cursoropacitymax: 1,
    cursorwidth: 7,
    cursorborder: 0,
    autohidemode: false
  });
  $('#ascrail2000').show();
  //END body & comps-section__comps--outer section scroll

  //header search and pageview mobile on click
  $(document).on('click', function (e) {
    if ($(e.target).closest(".titlebar__pageview--mobile").length > 0) {
      $('.menu li:not(:last-child)').fadeOut('fast', 'linear', function () {
        $('.titlebar__pageview--mobile').hide();
        $('.titlebar__search').hide();
        $('.titlebar__pageview').fadeIn();
        $('.titlebar__search--mobile').fadeIn();
      });
    } else if ($(e.target).closest(".titlebar__pageview").length > 0) {
      return false;
    } else if ($(e.target).closest(".titlebar__search--mobile").length > 0) {
      $('.menu li:not(:last-child)').fadeOut('fast', 'linear', function () {
        $('.titlebar__pageview').hide();
        $('.titlebar__search--mobile').hide();
        $('.titlebar__search').fadeIn();
        $('.titlebar__pageview--mobile').fadeIn();
      });
    } else if ($(e.target).closest(".titlebar__search").length > 0) {
      return false;
    } else if ($(e.target).closest("#comps__row--share--popup").length > 0) {
      $('.comps__row--share--popup').hide();
      $(e.target).siblings('.comps__row--share--popup').toggle();
    } else if ($(e.target).closest(".comps__row--share--popup").length > 0) {
      return false;
    } else {
      $('.comps__row--share--popup').hide();
      if ($(window).width() < 1120) {
        $('.titlebar__pageview').hide();
        $('.titlebar__search').hide();
        $('.menu li').fadeIn();
        $('.titlebar__pageview--mobile').fadeIn();
        $('.titlebar__search--mobile').fadeIn();
      } else {
        $('.titlebar__pageview').show();
        $('.titlebar__search').show();
        $('.menu li').show();
        $('.titlebar__pageview--mobile').hide();
        $('.titlebar__search--mobile').hide();
      }
    }
  });
  //END header search and pageview mobile on click

  //comps-section first td height calculation
  var styleCalculationHandler = function styleCalculationHandler() {
    if ($(window).width() > 768) {
      $('.comps-section .comps__row > td:nth-child(1) div').css({
        height: 'auto',
        'padding-top': 'auto'
      });
      var compsRowHeight = $('.comps-section .comps__row > td:nth-child(2)').height(),
          compsRowHalf = parseInt(compsRowHeight) / 2,
          compsRowDivHeight = $('.comps-section .comps__row > td:nth-child(1) > div').height(),
          compsRowDivHalf = parseInt(compsRowDivHeight) / 2,
          paddingdiv = parseInt(compsRowHalf) - parseInt(compsRowDivHalf);
      $('.comps-section .comps__row > td:nth-child(1) > div').css({
        height: compsRowHeight,
        'margin-top': '3px',
        'padding-top': paddingdiv
      });
    } else {
      $('.comps-section .comps__row > td:nth-child(1) div').css({
        height: 'auto',
        'padding-top': 'auto'
      });
    }
  };
  $(window).on("resize", _.debounce(styleCalculationHandler, 300));
  styleCalculationHandler();
  //END comps-section first td height calculation
});

$(document).ready(function () {
  //    profile-connect-nav
  $('.profile__header .bootstrap_btn_mobile .navbar-toggle').on('click', function () {
    if (!$(this).find('#close-sign').hasClass('show')) {
      $('.profile__header .bootstrap_btn_mobile a').show();
      $('.profile__header .bootstrap_btn_mobile #close-sign').addClass('show');
    } else {
      $('.profile__header .bootstrap_btn_mobile a').hide();
      $('.profile__header .bootstrap_btn_mobile #close-sign').removeClass('show');
    }
  });
  //    profile-connect-nav-ends
  //    timeline-nav
  $('.timeline__nav--top .bootstrap_btn_mobile .navbar-toggle').on('click', function () {
    if ($('.timeline__nav--top .bootstrap_btn_mobile  ul').css('display') === 'none') {
      $('.timeline__nav--top .bootstrap_btn_mobile  ul').slideDown();
    } else {
      $('.timeline__nav--top .bootstrap_btn_mobile  ul').slideUp();
    }
  });
  //  timeline-nav-ends
});
$(document).ready(function () {
  //    profile-connect-nav
  $('.profile__header .bootstrap_btn_mobile .navbar-toggle').on('click', function () {
    if (!$(this).find('#close-sign').hasClass('show')) {
      $('.profile__header .bootstrap_btn_mobile a').show();
      $('.profile__header .bootstrap_btn_mobile #close-sign').addClass('show');
    } else {
      $('.profile__header .bootstrap_btn_mobile a').hide();
      $('.profile__header .bootstrap_btn_mobile #close-sign').removeClass('show');
    }
  });
  //    profile-connect-nav-ends

  //    open tab links 
  $('.tab__links--skyblue a').on('click', function (e) {
    $('.tab__links--skyblue a').removeClass('active');
    $(this).addClass('active');
    e.preventDefault();
    if ($(this).is('#about-link')) {
      $('#div_link_1').removeClass('hide');
      $('#div_link_2').addClass('hide');
    } else if ($(this).is('#performance-link')) {
      $('#div_link_1').addClass('hide');
      $('#div_link_2').removeClass('hide');
    }
  });
  //    open tab links 

  //data tables
  $('.table__data--custom').DataTable();
  //hide show entries row
  $('.dataTables_wrapper .row:nth-child(1)').hide();
  //hide pagination row
  $('.dataTables_wrapper .row:nth-child(3) .dataTables_info').hide();
  //data tables end

  $('.submenu-list').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('arrow-down');
    $('.treeview-submenu', this).slideToggle();
  });

  $('#about-link .fa').on('click', function () {
    var $this = $(this);
    if ($this.hasClass('fa-plus') == true) {
      $('.about-all-list').slideDown();
      $this.removeClass('fa-plus').addClass('fa-minus');
    } else {
      $('.about-all-list').slideUp();
      $this.removeClass('fa-minus').addClass('fa-plus');
    }
  });

  $(window).resize(function () {
    if ($(window).width() < 768) {
      $('.about-all-list').hide();
    } else {
      $('.about-all-list').show();
    }
  });
});
Vue.directive('chat-sidebar-toggle', {
  params: [],
  bind: function bind() {
    var el = $(this.el);
    el.click(function () {
      var sidebar = $(".sidebar.left");
      if (sidebar.css('left') != '0px') {
        sidebar.sidebar().trigger("sidebar:open");
      } else {
        sidebar.sidebar().trigger("sidebar:close");
      }
    });
  }
});
Vue.directive('drop-down', {
  params: [],
  bind: function bind() {
    var self = this,
        el = this.el,
        $el = jQuery(el);

    $el.on('mouseover', function () {
      console.log('2');
      var $menuItem = $(this),
          $submenuWrapper = $('> .dd-wrapper', $menuItem);
      var menuItemPos = $menuItem.position();
      $submenuWrapper.css({
        top: menuItemPos.top,
        left: menuItemPos.left + Math.round($menuItem.outerWidth())
      });
    });
  }
});

var VueElementQuery = function () {
  /**
   * Constructor for the class
   * @param  {VueComponent} component
   */
  function VueElementQuery(ResizeSensor, element, params) {
    _classCallCheck(this, VueElementQuery);

    this.ResizeSensor = ResizeSensor;
    this.breakpoints = {
      'min-width': params.minWidth ? params.minWidth.split(',') : [],
      'max-width': params.maxWidth ? params.maxWidth.split(',') : []
    };
    this.init(element);
  }

  /**
   * Initialize ElementQuery by crawling stylesheets for breakpoints,
   * setting a resize watcher on the element, and firing the initial resize
   * event.
   * @param  {HTMLElement}  element
   * @return {void}
   */


  _createClass(VueElementQuery, [{
    key: "init",
    value: function init(element) {
      this.setBreakpoints(element);
      this.watchElement(element);
      this.setInitialResize(element);
    }

    /**
     * Fire the initial resize event
     * @param {HTMLElement} element
     */

  }, {
    key: "setInitialResize",
    value: function setInitialResize(element) {
      element.resizedAttached.call();
    }

    /**
     * Create a watcher on the element width
     * @param {HTMLElement} element
     * @return {void}
     */

  }, {
    key: "watchElement",
    value: function watchElement(element) {
      var _this = this;

      new this.ResizeSensor(element, function () {
        element.setAttribute('min-width', _this.setMinWidth(element.clientWidth));
        element.setAttribute('max-width', _this.setMaxWidth(element.clientWidth));
      });
    }

    /**
     * Crawl the document stylesheets and capture all breakpoints for
     * this element
     * @param {HTMLElement} element
     */

  }, {
    key: "setBreakpoints",
    value: function setBreakpoints(element) {}
    // TODO: catch breakpoints via params


    /**
     * Set the string for the min-width attribute that will be used for element
     * queries. Example result: "500px 600px 900px"
     * @param {Number} elementWidth
     */

  }, {
    key: "setMinWidth",
    value: function setMinWidth(elementWidth) {
      return this.breakpoints['min-width'].reduce(function (string, key) {
        return elementWidth >= key ? string + key + 'px ' : string;
      }, '').slice(0, -1);
    }

    /**
     * Set the string for the max-width attribute that will be used for element
     * queries. Example result: "500px 600px 900px"
     * @param {Number} elementWidth
     */

  }, {
    key: "setMaxWidth",
    value: function setMaxWidth(elementWidth) {
      return this.breakpoints['max-width'].reduce(function (string, key) {
        return elementWidth <= key ? string + key + 'px ' : string;
      }, '').slice(0, -1);
    }
  }]);

  return VueElementQuery;
}();

Vue.directive('el-query', {
  params: ['min-width', 'max-width'],
  bind: function bind() {
    var self = this;
    _.defer(function () {
      new VueElementQuery(ResizeSensor, self.el, self.params);
    });
  },
  unbind: function unbind() {
    ResizeSensor.detach(this.el);
  }
});

Vue.directive('gg-sidebar-toggle', {
  bind: function bind() {
    var el = $(this.el);
    el.click(function (e) {
      e.preventDefault();
      var sidebar = $("#gg-siderbar");
      if (sidebar.css('left') != '0px') {
        sidebar.sidebar().trigger("sidebar:open");
      } else {
        sidebar.sidebar().trigger("sidebar:close");
      }
    });
  }
});
Vue.directive('import-modal-open', {
  twoWay: true,
  bind: function bind() {
    //$('#import-modal').modal('show');
  }
});
Vue.directive('inputprefix', {
  params: ['prefix'],
  bind: function bind() {
    var self = this,
        el = this.el,
        $el = jQuery(el);

    if ($el.val().indexOf(this.params.prefix) !== 0) {
      $el.val(this.params.prefix);
    }

    $el.keydown(function (e) {
      var oldvalue = $(this).val();
      var field = this;
      setTimeout(function () {
        if (field.value.indexOf(self.params.prefix) !== 0) {
          $(field).val(oldvalue);
        }
      }, 1);
    }).trigger('keydown');
  },
  update: function update(newValue, oldValue) {
    var self = this,
        el = this.el,
        $el = jQuery(el);

    if ($el.val().indexOf(this.params.prefix) !== 0) {
      $el.val(this.params.prefix);
    }
  }
});

Vue.directive('masked-input', {
  params: ['format'],
  bind: function bind() {
    var self = this,
        el = this.el,
        $el = jQuery(el);

    $el.inputmask(this.params.format);
  }
});

Vue.directive('nicescroll', {
  params: ['horizrailenabled'],
  bind: function bind() {
    var self = this;

    var scrollSettings = {
      cursorcolor: "#dff4ff",
      cursoropacitymax: 1,
      cursorwidth: 7,
      cursorborder: 0,
      autohidemode: false,
      horizrailenabled: false
    };

    scrollSettings = _.defaults(this.params || {}, scrollSettings);

    $(this.el).niceScroll(scrollSettings);
  },
  unbind: function unbind() {
    var niceScroll = $(this.el).getNiceScroll();
    niceScroll && niceScroll.remove();
  }
});

Vue.directive('datepicker', {
  twoWay: true,
  bind: function bind() {
    var el = this.el;
    var self = this;
    var $el = jQuery(el);
    $el.datepicker({
      autoclose: true,
      format: "yyyy-mm-dd"

    }).on('changeDate', function (e) {
      self.set($el.val());
      self.vm.$dispatch('onSearch');
    });
  }
});
Vue.directive('fileinput', {
  bind: function bind() {
    var self = this;

    var $input = $(this.el),
        $label = $input.next('label'),
        labelVal = $label.html();

    $input.on('change', function (e) {
      var fileName = '';

      if (this.files && this.files.length > 1) fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);else if (e.target.value) fileName = e.target.value.split('\\').pop();

      if (fileName) $label.find('span').html(fileName);else $label.html(labelVal);
    });

    // Firefox bug fix
    $input.on('focus', function () {
      $input.addClass('has-focus');
    }).on('blur', function () {
      $input.removeClass('has-focus');
    });
  },
  unbind: function unbind() {
    $(this.el).off();
  }
});

Vue.directive('multiselect', {
  twoWay: true,
  bind: function bind() {
    var el = this.el;
    var self = this;
    var $el = jQuery(el);
    $el.multiselect({
      onDropdownHide: function onDropdownHide(event) {
        self.set($el.val());
        self.vm.$dispatch('onSearch');
      }
    });
  }
});

Vue.directive('users-multiselect', {
  twoWay: true,
  bind: function bind() {
    var el = this.el;
    var self = this;
    var $el = jQuery(el);
    $el.select2({
      ajax: {
        url: "/dashboard/chat/search",
        dataType: 'json',
        delay: 250,
        data: function data(params) {
          return {
            q: params.term
          };
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results
          };
        },
        cache: true
      },
      escapeMarkup: function escapeMarkup(markup) {
        return markup;
      },
      minimumInputLength: 1,
      templateResult: function templateResult(user) {
        if (user.disabled) {
          return "<div class='select-avatar pull-left'>Searching...</div><div class='clearfix'></div>";
        } else {
          return "<div class='select-avatar pull-left'><img src='" + user.avatar_str + "'/></div><div class='pull-left select-name'>" + user.first_name + ' ' + user.last_name + "</div><div class='clearfix'></div>";
        }
      },
      templateSelection: function templateSelection(user) {
        return user.first_name + ' ' + user.last_name;
      }
    });
  }
});
Vue.directive('select', {
  twoWay: true,
  priority: 1000,
  params: ['options'],
  bind: function bind() {
    var self = this;
    $(this.el).select2({
      data: this.params.options
    }).on('change', function () {
      self.set($(self.el).val());
      self.vm.$dispatch('onSearch');
    });
  },
  update: function update(value) {
    var self = this;
    $(this.el).val(value).trigger('change');
  },
  unbind: function unbind() {
    $(this.el).off().select2('destroy');
  }
});

Vue.directive('company-autocomplete', {
  params: ['format'],
  bind: function bind() {
    var el = this.el;
    var self = this;
    $('document').ready(function () {
      new autoComplete({
        selector: 'input[name="' + $(el).attr('name') + '"]',
        minChars: 1,
        source: function source(term, response) {
          $.getJSON('https://autocomplete.clearbit.com/v1/companies/suggest', { query: term }, function (data) {
            response(data);
          });
        },
        renderItem: function renderItem(item, search) {
          default_logo = 'https://s3.amazonaws.com/clearbit-blog/images/company_autocomplete_api/unknown.gif';

          if (item.logo == null) {
            logo = default_logo;
          } else {
            logo = item.logo + '?size=25x25';
          }

          container = '<div class="autocomplete-suggestion" data-name="' + item.name + '" data-val="' + search + '">';
          container += '<span class="icon"><img align="center" src="' + logo + '" onerror="this.src=\'' + default_logo + '\'"></span> ';
          container += item.name + '<span class="domain">' + item.domain + '</span></div>';
          return container;
        },
        onSelect: function onSelect(e, term, item) {
          $(el).val($(item).data('name'));
        }
      });
    });
  }
});
Vue.filter('dateFormat', function (text, length, clamp) {
  var currentDate = moment().format("YYYY-MM-DD");
  var createdDateArr = text.split(" ");
  if (currentDate == createdDateArr[0]) {
    return "Today";
  } else {
    return moment(text).format("MMM DD h:mm a");
  }
});

emojione.ascii = true;

Vue.filter('emoji', function (value) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toImage';

  return emojione[method](value);
});

Vue.filter('format-owner-address', function (text, length, clamp) {
  var array = text.split('|');

  if (text != '|||||') {
    return array[4] + ' ' + array[1] + ', ' + array[0] + ', ' + array[2] + ', ' + array[3];
  } else {
    return 'Address hidden';
  }
});

Vue.filter('format-period', function (text, length, clamp) {
  var array = text.split('/');
  var dateStart = moment(array[0], 'YYYY-MM-DD');
  var dateEnd = moment(array[1], 'YYYY-MM-DD');
  return dateStart.format('MMMM D, YYYY') + ' - ' + dateEnd.format('MMMM D, YYYY');
});

Vue.filter('inputPrefix', {
  read: function read(val) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '@';

    if (!val || val < prefix) return prefix;
    return val && val.indexOf(prefix) == 0 ? val : prefix + val;
  }
  // write: function(val, oldVal, prefix) {
  //   return val
  // }
});

Vue.filter('linkify', {
  read: function read(val) {
    return linkifyHtml(val);
  }
});

(function ($) {

  // Matches trailing non-space characters.
  var chop = /(\s*\S+|\s)$/;

  // Matches the first word in the string.
  var start = /^(\S*)/;

  // Return a truncated html string.  Delegates to $.fn.truncate.
  $.truncate = function (html, options) {
    return $('<div></div>').append(html).truncate(options).html();
  };

  // Truncate the contents of an element in place.
  $.fn.truncate = function (options) {
    if ($.isNumeric(options)) options = { length: options };
    var o = $.extend({}, $.truncate.defaults, options);

    return this.each(function () {
      var self = $(this);

      if (o.noBreaks) self.find('br').replaceWith(' ');

      var text = self.text();
      var excess = text.length - o.length;

      if (o.stripTags) self.text(text);

      // Chop off any partial words if appropriate.
      if (o.words && excess > 0) {
        var truncated = text.slice(0, o.length).replace(chop, '').length;

        if (o.keepFirstWord && truncated === 0) {
          excess = text.length - start.exec(text)[0].length - 1;
        } else {
          excess = text.length - truncated - 1;
        }
      }

      if (excess < 0 || !excess && !o.truncated) return;

      // Iterate over each child node in reverse, removing excess text.
      $.each(self.contents().get().reverse(), function (i, el) {
        var $el = $(el);
        var text = $el.text();
        var length = text.length;

        // If the text is longer than the excess, remove the node and continue.
        if (length <= excess) {
          o.truncated = true;
          excess -= length;
          $el.remove();
          return;
        }

        // Remove the excess text and append the ellipsis.
        if (el.nodeType === 3) {
          $(el.splitText(length - excess - 1)).replaceWith(o.ellipsis);
          return false;
        }

        // Recursively truncate child nodes.
        $el.truncate($.extend(o, { length: length - excess }));
        return false;
      });
    });
  };

  $.truncate.defaults = {

    // Strip all html elements, leaving only plain text.
    stripTags: false,

    // Only truncate at word boundaries.
    words: false,

    // When 'words' is active, keeps the first word in the string
    // even if it's longer than a target length.
    keepFirstWord: false,

    // Replace instances of <br> with a single space.
    noBreaks: false,

    // The maximum length of the truncated html.
    length: Infinity,

    // The character to use as the ellipsis.  The word joiner (U+2060) can be
    // used to prevent a hanging ellipsis, but displays incorrectly in Chrome
    // on Windows 7.
    // http://code.google.com/p/chromium/issues/detail?id=68323
    ellipsis: "\u2026" // '\u2060\u2026'

  };
})(jQuery);

Vue.filter('truncate', function (text, length, clamp) {
  return jQuery.truncate(text, {
    length: length || 220,
    words: true
  });
});

var AddChat = Vue.extend({
  components: {
    typeahead: VueStrap.typeahead
  },
  data: function data() {
    return {
      users: [],
      chatName: '',
      asyncTemplate: '<img width="18px" height="18px" style="margin-right:10px;" :src="item.avatar_str">' + '<span>{{item.first_name}} {{item.last_name}} ({{item.email}})</span>'
    };
  },

  ready: function ready() {},
  methods: {
    removeUser: function removeUser(user) {
      this.users.$remove(user);
    },
    seacrhCallback: function seacrhCallback(item) {
      var result = $.grep(this.users, function (e) {
        return e.id == item.id;
      });
      if (result.length == 0) {
        this.users.push(item);
      }
      $('#search-add-chat div').removeClass('open');
      $('#search-add-chat input').val('');
    }
  }
});
Vue.component('add-chat', AddChat);

var AddProperty = Vue.extend({
  props: ['existed', 'tutor', 'lim'],
  components: {
    typeahead: VueStrap.typeahead,
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      showModal: false,
      items: [],
      chatName: '',
      existed: null,
      loading: false,
      one: false,
      properties: [],
      form: { properties: null },
      addedProperties: null,
      addPropertySearchTemplate: '{{item}}'
    };
  },

  ready: function ready() {},
  methods: {
    getProperties: function getProperties(search, loading) {
      var _this2 = this;

      loading(true);
      this.$http.get('/api/search?type=bbl&query=' + search).then(function (resp) {
        _this2.properties = resp.data;
        loading(false);
      });
    },

    select: function select(index) {
      var ctx = this;
      var item = ctx.items[index];
      var relations = $('input[name="property-relationship-' + item.id + '[]"]:checked').map(function () {
        return $(this).val();
      }).get();

      ctx.items[index].relations = relations;
    },
    removeItem: function removeItem(item) {
      this.items.$remove(item);
      this.existed = this.existed - 1;
    },
    submit: function submit() {
      var ctx = this;
      ctx.loading = true;
      console.log(this.items);
      $.post('/add-property', {
        items: ctx.items
      }, function (data) {
        ctx.loading = false;
        ctx.items = [];

        if (!ctx.tutor) {
          window.location.reload();
        }

        ctx.$dispatch('render-complains-dashboard');

        ctx.addedProperties = data;
        $('#added-properties').show();
      });
    },
    addPropertySearchCallback: function addPropertySearchCallback(item) {

      var result = $.grep(this.items, function (e) {
        return e.id == item.id;
      });
      if (result.length == 0) {
        this.items.push(item);
        this.existed = this.existed + 1;
      }
      $('.add-property-search').removeClass('open');
      $('.add-property-search input').val('');
      this.form.properties = null;
    }
  },
  events: {
    'open-add-pr-modal': function openAddPrModal(data) {
      var ctx = this;
      ctx.itmes = [];

      $('#added-properties').hide();
      this.showModal = true;
      if (data.length != 0) {
        this.itmes = [data];
        this.$data.items = [data];
        this.one = true;
      }
    }
  }
});
Vue.component('add-property', AddProperty);

var AddTenant = Vue.extend({
  components: {
    typeahead: VueStrap.typeahead,
    datefields: _DateFields2.default,
    VueGoogleAutocomplete: _VueGoogleAutocomplete2.default,
    FileSelector: _FileSelector2.default,
    FileUpload: _FileUpload2.default
  },
  data: function data() {
    return {
      ggApiUrl: "/api/v2/gate-guard/users/",
      rawData: null,
      devices: [],
      is_active: false,

      form: {
        sms_unlock: 0,
        call_to_unlock: 0,
        title: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix: '',
        date_of_birth: '',
        login_id: '',
        unit: '',

        email: null,
        mobile_phone: null,

        emails: {
          email1: null,
          email2: null,
          email3: null
        },
        phones: {
          phone1: null,
          phone2: null,
          phone3: null
        },
        primary_email: 'email1',
        primary_phone: 'phone1',

        contacts: {
          facebook: null,
          twitter: null,
          instagram: null,
          prev_address: null,
          prev_unit: null
        },

        access: {
          building_id: '',
          device_id: ''
        },

        emergency: {
          name: null,
          relationship: null,
          mobile_phone: null,
          day_phone: null
        },

        photos: [],
        photo_ids: [],

        documents: [{
          type: null,
          file1: null,
          file2: null,
          file3: null,
          photos: null
        }],
        document_ids: {
          social_security_id: null,
          drivers_license_id: null,
          passport_id: null,
          nyc_card_id: null
        },
        co_tenants: {
          adults: [],
          childrens: []
        },
        notes: null,
        note: null,
        lease: {
          begin_date: null,
          end_date: null,
          rent_amount: null,
          type: null,
          signed_lease: null,
          riders: null,

          signed_lease_current: null
        },
        gg_settings: {
          app: {
            allow_amenities: true
          },
          alert_settings: {
            'nonprimary': {
              deactivated: false,
              appear_after: null,
              recipients: [{
                name: 'Me',
                alert_type: 1
              }, {
                name: 'Building Super',
                alert_type: 2
              }, {
                name: 'Building Manager',
                alert_type: 1
              }]
            },
            'too_many_guests': {
              deactivated: false,
              guests_count: null,
              hours_count: null,
              recipients: [{
                name: 'Me',
                alert_type: 1
              }, {
                name: 'Building Super',
                alert_type: 2
              }, {
                name: 'Building Manager',
                alert_type: 1
              }]
            },
            'after_hours_guests': {
              deactivated: false,
              guests_count: null,
              start_time: null,
              end_time: null,
              recipients: [{
                name: 'Me',
                alert_type: 1
              }, {
                name: 'Building Super',
                alert_type: 2
              }, {
                name: 'Building Manager',
                alert_type: 1
              }]
            }
          }
        },
        ss_settings: {
          get_alerts: true,
          alert_settings: {
            recipients: [{
              name: 'Me',
              alert_type: 1
            }]
          }
        }
      },
      createGateguardProfile: true,
      numberOfAdults: null,
      numberOfChildrens: null,
      recipientsList: [{ label: 'Dude 1', value: '1' }, { label: 'Dude 2', value: '2' }, { label: 'Dude 3', value: '3' }],
      serverErrors: null,
      loading: false,

      tenantPhotosCurrent: [],
      tenantPhotos: [],
      upload: {},
      auto: true
    };
  },

  props: ['userId', 'mode', 'id', 'tenantsBaseUrl'],
  ready: function ready() {
    if (this.mode == 'edit' && this.id) {
      this.fetchData();
    }
    this.formInit();
  },
  computed: {
    mainEmail: function mainEmail() {
      var emails = this.form.emails;
      var key = this.form.primary_email;
      var out = emails.hasOwnProperty(key) ? emails[key] : '';

      this.form.email = out;
      return out;
    },
    mainPhone: function mainPhone() {
      var phones = this.form.phones;
      var key = this.form.primary_phone;
      var out = phones.hasOwnProperty(key) ? phones[key] : '';

      this.form.mobile_phone = out;
      return out;
    },
    tenantPhotosComputed: function tenantPhotosComputed() {
      //
    }
  },
  watch: {
    'numberOfAdults': function numberOfAdults(val, oldVal) {
      var self = this,
          oldObj = this.form.co_tenants.adults,
          newObj = [];

      if (oldObj.length > val) {
        var amount = oldObj.length - val;
        oldObj.splice(-amount, amount);
      }
      if (oldObj.length < val) {
        for (var i = oldObj.length; i < val; i++) {
          oldObj.push({
            first_name: '',
            last_name: '',
            email: '',
            mobile_phone: ''
          });
        }
      }
    },
    'numberOfChildrens': function numberOfChildrens(val, oldVal) {
      var self = this,
          oldObj = this.form.co_tenants.childrens,
          newObj = [];

      if (oldObj.length > val) {
        var amount = oldObj.length - val;
        oldObj.splice(-amount, amount);
      }
      if (oldObj.length < val) {
        for (var i = oldObj.length; i < val; i++) {
          oldObj.push({
            first_name: '',
            last_name: '',
            email: '',
            mobile_phone: ''
          });
        }
      }
    },
    tenantPhotosCurrent: function tenantPhotosCurrent(val, oldVal) {
      this.updatePhotos();
    },
    tenantPhotos: function tenantPhotos(val, oldVal) {
      this.updatePhotos();
    }
  },
  methods: {
    fetchDevices: function fetchDevices() {
      var _this3 = this;

      this.$http.get("/dashboard/tenants/devices-by-building/" + this.form.access.building_id).then(function (response) {
        var o = response.data;
        var data = o.data;
        console.log(o);
        _this3.devices = o;
      }, function (response) {});
    },
    randomLogin: function randomLogin() {
      this.form.login_id = _.random(100, 999) + '555' + _.random(1000, 9999);
    },
    phoneLogin: function phoneLogin() {
      var key = this.form.primary_phone;
      this.form.login_id = _.replace(this.form.phones[key], new RegExp("[+-]", "g"), "");
    },
    formInit: function formInit() {
      this.numberOfAdults = 0;
      this.numberOfChildrens = 0;
    },
    fetchData: function fetchData() {
      var _this4 = this;

      this.loading = true;
      this.$http.get("" + this.ggApiUrl + this.id).then(function (response) {
        var o = response.data;
        var data = o.data;

        _this4.is_active = data.is_active;

        for (var key in data) {
          if (_this4.form.hasOwnProperty(key)) {
            _this4.form[key] = data[key];
          }
        }

        _this4.loading = false;
      }, function (response) {
        _this4.loading = false;
      });
    },

    addAdult: function addAdult() {
      this.adults.push(this.adults.length + 1);
    },
    removeAdult: function removeAdult(adult) {
      this.adults.$remove(adult);
    },
    addChild: function addChild() {
      this.childrens.push(this.childrens.length + 1);
    },
    removeChild: function removeChild(child) {
      this.childrens.$remove(child);
    },
    addDocument: function addDocument() {
      this.form.documents.push({
        type: null,
        file1: null,
        file2: null,
        file3: null,
        photos: null
      });
    },
    addRecipientToGG: function addRecipientToGG(alert_type) {
      var settings = this.form.gg_settings.alert_settings[alert_type];
      if (!settings) return false;

      settings.recipients.push({
        select: true,
        alert_type: null
      });
    },
    addRecipientToSS: function addRecipientToSS() {
      var settings = this.form.ss_settings.alert_settings;
      if (!settings) return false;

      settings.recipients.push({
        select: true,
        alert_type: null
      });
    },
    updatePhotos: function updatePhotos() {
      var tenantPhotosCurrent = this.tenantPhotosCurrent;
      var tenantPhotos = this.tenantPhotos;
      this.form.photos = tenantPhotos.concat(tenantPhotosCurrent);
      this.form.photo_ids = _.compact(_.map(this.form.photos, function (o) {
        if (o.file_name) {
          return o.id;
        } else {
          var id = null;
          if (o.data && o.data.data) id = o.data.data.id;
          return id;
        }
      }));
    },
    saveFormTrigger: function saveFormTrigger(e) {
      var _this5 = this;

      this.$validate(true, function () {
        console.log('VALIDD', _this5.$addTenantFormValidator, _this5.$addTenantFormValidator.email);
        if (_this5.$addTenantFormValidator.invalid) {
          _this5.scrollToFirstError();
          e.preventDefault();
        } else {
          _this5.saveForm();
        }
      });
    },
    scrollToFirstError: function scrollToFirstError() {
      _.defer(function () {
        var el = $('.has-error, .has-error-group');
        if (el.length) {
          var firstEl = el.first(),
              firstElTop = firstEl.get(0).offsetTop;
          firstElTop -= 30;
          $('.content-wrapper').animate({ scrollTop: firstElTop }, 250, function () {
            firstEl.find('input').focus();
          });
        }
      });
    },
    saveForm: function saveForm() {
      var _this6 = this;

      var formData = (0, _ToFD2.default)(this.form);
      this.loading = true;
      this.serverErrors = null;

      // That's why we should do so: https://github.com/laravel/framework/issues/13457
      if (this.mode == 'edit' && this.id) {
        formData.append('_method', 'PUT');
      }

      var requestPromise = this.mode == 'edit' && this.id ? this.$http.post("" + this.ggApiUrl + this.id, formData) : this.$http.post(this.ggApiUrl + "/tenants", formData);

      requestPromise.then(function (response) {
        _this6.loading = false;
        //window.location.href = this.tenantsBaseUrl
        toastr["success"]('Tenant saved!');
      }, function (response) {
        _this6.loading = false;
        var errors = null;
        var o = response.data;

        if (_.isPlainObject(o) && !o.hasOwnProperty('error')) {
          errors = _.map(o, function (v, k) {
            return {
              field: k,
              messages: v
            };
          });
        } else {
          errors = [{
            field: 'error',
            messages: [o.error.message || 'Unknown error occurred']
          }];
        }

        _this6.serverErrors = errors;
        _this6.$setValidationErrors(errors);
      });
    },
    getAddressData: function getAddressData(addressData, placeResultData) {
      this.form.contacts.prev_address = $(this.$refs.googleAddressAc.$el).val();
    },
    remove: function remove(file) {
      if (file.progress) this.$refs.upload.files.$remove(file);else this.tenantPhotosCurrent.$remove(file);
    },
    toggleTenantActivationStatus: function toggleTenantActivationStatus() {
      var self = this;
      self.loading = true;
      this.$http.patch('/dashboard/gateguard/tenant/' + this.id + '/activation').then(function (response) {
        self.is_active = response.data.new_status;
        self.loading = false;
      }, function (fresponse) {
        console.log(fresponse);
        self.loading = false;
      });
    }
  },
  events: {
    addFileUpload: function addFileUpload(file, component) {
      console.log('addFileUpload', file, component);
      if (this.auto) {
        component.active = true;
      }
    },
    fileUploadProgress: function fileUploadProgress(file, component) {
      console.log('fileUploadProgress ' + file.progress);
    },
    afterFileUpload: function afterFileUpload(file, component) {
      console.log('afterFileUpload', file, component);
      this.updatePhotos();
    }
  },
  compiled: function compiled() {
    this.upload = this.$refs.upload;
    this.tenantPhotos = this.$refs.upload.files;
  }
});
Vue.component('add-tenant', AddTenant);

var AlertsMessages = Vue.extend({
  props: ['notifications', 'loaded'],
  data: function data() {
    return {
      notifications: [],
      loaded: false
    };
  },
  ready: function ready() {
    var ctx = this;
    ctx.reload();

    if (typeof socket !== 'undefined') {
      socket.on('connect', function (data) {
        socket.emit('subscribe', { channel: 'chat.room' });
      });
      socket.emit('join', { room: 'notifications-' + currentUser });

      socket.on('private-notifications', function (data) {
        /*console.log(data)
        ctx.notifications.unshift(data.data);
        ctx.notifications.$remove(ctx.notifications[9]);*/
        ctx.reload();
      });
    }
  },
  methods: {
    reload: function reload() {
      var ctx = this;
      ctx.loaded = false;
      if (typeof socket !== 'undefined') {
        $.get('/notifications?limit=15', function (data) {
          ctx.notifications = data.notifications;
          ctx.loaded = true;
        });
      }
    }
  }
});
Vue.component('alerts-messages', AlertsMessages);

var CardPaymentForm = Vue.extend({
  props: ['actionUrl', 'successRedirectUrl', 'formId'],
  data: function data() {
    return {
      response: false,
      error: false,
      loading: false,
      card: false,
      availableYears: [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035],
      paymentInfo: {
        card_number: '',
        expiration_date: '',
        csv: '',
        exp_month: null,
        exp_year: null
      }
    };
  },
  ready: function ready() {
    this.initCardForm();
  },

  methods: {
    initCardForm: function initCardForm() {
      this.card = new Card({
        form: 'form#' + this.formId,
        container: '.card-wrapper',

        formSelectors: {
          nameInput: 'input[name="name"]' // optional - defaults input[name="name"]
        }
      });
    },
    submit: function submit(event) {
      var _this7 = this;

      event.preventDefault();
      this.loading = true;
      this.$http.post(this.actionUrl, {
        card_number: this.paymentInfo.card_number.replace(/\s/g, ''),
        expiration_date: this.expirationDate,
        csv: this.paymentInfo.csv,
        card_type: this.card.cardType
      }).then(function (response) {
        window.location.href = _this7.successRedirectUrl;
      }, function (response) {
        _this7.response = response.data;
        _this7.error = true;
        _this7.loading = false;
      });
    }
  },
  computed: {
    expirationDate: function expirationDate() {
      return this.exp_month + '/' + this.exp_year;
    }
  }
});
Vue.component('card-payment-form', CardPaymentForm);
var ChatBox = Vue.extend({
  data: function data() {
    return {
      chats: [],
      currentUser: null,
      loading: false
    };
  },
  created: function created() {
    $('#chat-window-boxes-wrapper').removeClass('hidden');
    this.currentUser = currentUser;
  },
  ready: function ready() {
    $('#chat-window-boxes-wrapper').removeClass('hidden');
  },
  compiled: function compiled() {
    $('#chat-window-boxes-wrapper').removeClass('hidden');
  },
  methods: {
    sendMsg: function sendMsg(event) {
      var ctx = this;
      var form = $(event.target);
      var index = form.find('input[name="index"]').val();

      event.preventDefault();

      if (form.find('input[name="message"]').val().length == 0) {
        return false;
      }

      $.post('/dashboard/chat/send-message', {
        _token: $('meta[name="csrf-token"]').attr('content'),
        text: form.find('input[name="message"]').val(),
        chat_id: form.find('input[name="chat_id"]').val()
      }, function (data) {
        ctx.$dispatch('push-msg-to-chats', data);
        form.find('input[name="message"]').val('');
        ctx.scrollToEnd();
      }, 'json');
    },
    minimize: function minimize(index) {
      this.chats[index].min = !this.chats[index].min;
    },
    remove: function remove(chat) {
      var chats = Cookies.getJSON('dialogs');
      this.chats.$remove(chat);

      var index = chats.indexOf(chat.id);
      if (index > -1) {
        chats.splice(index, 1);
      }
      Cookies.set('dialogs', chats);
    },
    scrollToEnd: function scrollToEnd() {
      setTimeout(function () {
        $.each($('.direct-chat-messages'), function (key, value) {
          value.scrollTop = value.scrollHeight + 300;
        });
      }, 10);
    }
  },
  events: {
    'push-new_msg': function pushNew_msg(data) {
      var ctx = this;

      var index = parseInt($.map(ctx.chats, function (e) {
        if (e.id == data.chat_id) {
          return ctx.chats.indexOf(e);
        }
      }));

      if (!isNaN(index)) {
        ctx.chats[index].messages.push(data);
        ctx.scrollToEnd();
      }
    },
    'push-minimize-dialog': function pushMinimizeDialog(chat) {
      var ctx = this;

      var result = $.grep(this.chats, function (e) {
        return e.id == chat.id;
      });

      if (result.length == 0) {
        if (this.chats.length == 3) {
          this.remove(this.chats[0]);
        }
        ctx.loading = true;

        $.get('/dashboard/chat/messages-for-chat/' + chat.hash, function (data) {
          Vue.set(chat, 'messages', data);
          Vue.set(chat, 'min', false);

          ctx.loading = false;
          ctx.chats.push(chat);
          ctx.scrollToEnd();

          ctx.$dispatch('set-current-dialog', chat.id);
        }, 'json');
      }
    }
  }
});
Vue.component('chat-box', ChatBox);

var ChatRecipientsList = Vue.extend({
  components: {
    dropdown: VueStrap.dropdown,
    modal: VueStrap.modal
  },
  props: ['recipients', 'active', 'addPrivateChat'],
  data: function data() {
    return {
      recipients: null,
      addPrivateChat: false,
      addPublicChat: false,
      users: []
    };
  },
  created: function created() {
    this.fetchData();

    if (this.active) {
      this.openDialogWindow(this.active);
    }
  },
  ready: function ready() {
    var ctx = this;
    setTimeout(function () {
      if (_typeof(ctx.active) == 'object') {
        ctx.openDialogWindow(ctx.active);
      }
    }, 1);
  },
  methods: {
    addChatPublic: function addChatPublic() {
      var chatName = $('.modal-body input[name="chat_name"]:visible').val();

      if (chatName) {
        $.post('/dashboard/chat/add-public-chat', {
          chat_name: chatName
        }, function (data) {
          window.location = '/dashboard/messages/' + data.hash;
        });
      } else {
        swal({
          title: 'Oops...',
          text: "Chat name is required!",
          type: "error",
          confirmButtonText: "Got It!"
        });
      }
    },
    addChat: function addChat() {
      var users = $('select[name="users"]:visible').val();

      if (users) {
        $.post('/dashboard/chat/add-chat', {
          users: users
        }, function (data) {
          window.location = '/dashboard/messages/' + data.hash;
        });
      } else {
        swal({
          title: 'Oops...',
          text: "Add one or more users!",
          type: "error",
          confirmButtonText: "Got It!"
        });
      }
    },
    openDialogWindow: function openDialogWindow(chat) {
      this.$dispatch('open-dialog', chat);
    },
    fetchData: function fetchData() {
      var ctx = this;
      $.get('/dashboard/chat/recipients-list', function (data) {
        ctx.recipients = data;
        console.log(ctx.active);
        if (ctx.recipients.length && _typeof(ctx.active) != 'object') {
          ctx.openDialogWindow(ctx.recipients[0]);
        }
      }, 'json');
    }
  }
});
Vue.component('chat-recipients-list', ChatRecipientsList);

var ChatSidebar = Vue.extend({
  components: {
    dropdown: VueStrap.dropdown,
    modal: VueStrap.modal
  },
  props: ['recipients', 'active', 'addPrivateChat'],
  data: function data() {
    return {
      recipients: null,
      addPrivateChat: false,
      addPublicChat: false,
      users: []
    };
  },
  created: function created() {
    this.fetchData();
  },
  ready: function ready() {},
  methods: {
    addChatPublic: function addChatPublic() {
      var chatName = $('.modal-body input[name="chat_name"]:visible').val();

      if (chatName) {
        $.post('/dashboard/chat/add-public-chat', {
          chat_name: chatName
        }, function (data) {
          window.location = '/dashboard/messages/' + data.hash;
        });
      } else {
        swal({
          title: 'Oops...',
          text: "Chat name is required!",
          type: "error",
          confirmButtonText: "Got It!"
        });
      }
    },
    addChat: function addChat() {
      var users = $('select[name="users"]:visible').val();

      if (users) {
        $.post('/dashboard/chat/add-chat', {
          users: users
        }, function (data) {
          window.location = '/dashboard/messages/' + data.hash;
        });
      } else {
        swal({
          title: 'Oops...',
          text: "Add one or more users!",
          type: "error",
          confirmButtonText: "Got It!"
        });
      }
    },
    openDialogWindow: function openDialogWindow(chat) {
      this.$dispatch('open-dialog', chat);
    },
    fetchData: function fetchData() {
      var ctx = this;
      $.get('/dashboard/chat/recipients-list', function (data) {
        ctx.recipients = data;
      }, 'json');
    }
  }
});
Vue.component('chat-sidebar', ChatSidebar);

var ChatWindow = Vue.extend({
  components: {
    modal: VueStrap.modal,
    popover: VueStrap.popover
  },
  data: function data() {
    return {
      usersListOpen: false,
      opponent: null,
      messages: [],
      msg: '',
      currentUser: null,
      currentChat: null,
      editMode: false,
      chatName: '',
      addUsers: false
    };
  },
  compiled: function compiled() {
    $('#chat-window-container').removeClass('hidden');
    $('#chat-window-container-preload').addClass('hidden');
  },
  created: function created() {
    this.currentUser = currentUser;
  },
  methods: {
    addUsersToChat: function addUsersToChat() {
      var users = $('#add-users-container select[name="users"]').val();
      var ctx = this;

      if (users) {
        $.post('/dashboard/chat/add-users-to-chat', {
          users: users,
          chat_id: ctx.currentChat.hash
        }, function (data) {
          window.location = '/dashboard/messages/' + data.hash;
        });
      } else {
        swal({
          title: 'Oops...',
          text: "Add one or more users!",
          type: "error",
          confirmButtonText: "Got It!"
        });
      }
    },
    setEditMode: function setEditMode(value) {
      this.editMode = value;
    },
    saveChatName: function saveChatName() {
      var ctx = this;
      $.post('/dashboard/chat/change-chat-name', {
        chat_id: ctx.currentChat.id,
        name: ctx.chatName
      }, function (data) {
        ctx.chatName = data.chat_name;
        ctx.currentChat.chat_name = data.chat_name;
        ctx.editMode = false;
        $('.chat-name-' + data.id).text(data.chat_name);
      });
    },
    openUsersModal: function openUsersModal() {
      this.usersListOpen = true;
    },
    minimize: function minimize() {
      this.$dispatch('push-minimize-dialog', this.currentChat);
    },
    removeChat: function removeChat() {
      var ctx = this;

      swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      }, function () {
        $.post('/dashboard/chat/remove-chat', {
          chat_id: ctx.currentChat.id
        }, function (data) {
          window.location = "/dashboard/messages";
        });
      });
    },
    removeUser: function removeUser(user) {
      var ctx = this;

      swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      }, function () {
        $.post('/dashboard/chat/remove-user-from-chat', {
          chat_id: ctx.currentChat.id,
          user_id: user.id
        }, function (data) {
          ctx.currentChat.users.$remove(user);
          swal.close();
        });
      });
    },
    openDialogWindow: function openDialogWindow(userId) {},
    fetchMessages: function fetchMessages(chatId) {
      var ctx = this;
      $.get('/dashboard/chat/load-messages/' + chatId, function (data) {
        ctx.messages = data;
        $('#chat-window-spin').hide();
        ctx.scrollToEnd();
      }, 'json');
    },
    sendMsg: function sendMsg(event) {
      var ctx = this;

      event.preventDefault();

      if (this.msg.length == 0) {
        return false;
      }

      $.post('/dashboard/chat/send-message', {
        _token: $('meta[name="csrf-token"]').attr('content'),
        text: this.msg,
        chat_id: ctx.currentChat.id
      }, function (data) {
        ctx.$dispatch('push-msg-to-chats', data);
        ctx.msg = '';

        ctx.scrollToEnd();
      }, 'json');
    },
    scrollToEnd: function scrollToEnd() {
      setTimeout(function () {
        var block = $('#messages')[0];
        block.scrollTop = block.scrollHeight + 300;
      }, 10);
    }

  },
  events: {
    'push-new_msg': function pushNew_msg(data) {
      if (data.chat_id == this.currentChat.id) {
        this.messages.push(data);
        this.scrollToEnd();
      }
    },
    'open-dialog': function openDialog(chat) {
      console.log(chat);
      this.$dispatch('set-current-dialog', chat.id);
      this.currentChat = chat;
      this.chatName = chat.chat_name;
      this.msg = '';
      this.fetchMessages(chat.id);
    }
  }
});
Vue.component('chat-window', ChatWindow);

var СomplainsDashboard = Vue.extend({
  components: {
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      rows: [],
      loading: true
    };
  },

  ready: function ready() {},
  created: function created() {
    this.renderTable();
  },
  methods: {
    renderTable: function renderTable() {
      var ctx = this;
      $('#dashboard-table').DataTable().destroy();

      $('#dashboard-table, #dashboard-table-head').hide();
      ctx.loading = true;

      $.get('/dashboard/monitoring-properties', function (data) {
        ctx.rows = data;
        $('#dashboard-table, #dashboard-table-head').show();
        ctx.loading = false;

        setTimeout(function () {
          $('#dashboard-table').DataTable({
            "paging": true,
            "lengthChange": false,
            "searching": false,
            "ordering": true,
            "autoWidth": false,
            "bDestroy": true
          });
        }, 500);
      });
    }
  },
  filters: {
    currency: function currency(val, format) {
      val = isNaN(val) ? 0 : Number(val);
      format = format.split('.');
      return format[0] + val.toFixed(format[1]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    round: function round(val, count) {
      val = isNaN(val) ? 0 : Number(val);
      count = Math.pow(10, count);
      return Math.round(val * count) / count;
    }
  },
  events: {
    'open-join-us-modal': function openJoinUsModal(data) {
      this.showModal = true;
    },
    'render-complains-dashboard': function renderComplainsDashboard(data) {
      this.renderTable();
    }
  }
});
Vue.component('complains-dashboard', СomplainsDashboard);

var re = /([^&=]+)=?([^&]*)/g;
var decode = function decode(str) {
  return decodeURIComponent(str.replace(/\+/g, ' '));
};
var parseParams = function parseParams(query) {

  // recursive function to construct the result object
  function createElement(params, key, value) {
    key = key + '';

    // if the key is a property
    if (key.indexOf('.') !== -1) {
      // extract the first part with the name of the object
      var list = key.split('.');

      // the rest of the key
      var new_key = key.split(/\.(.+)?/)[1];

      // create the object if it doesnt exist
      if (!params[list[0]]) params[list[0]] = {};

      // if the key is not empty, create it in the object
      if (new_key !== '') {
        createElement(params[list[0]], new_key, value);
      } else console.warn('parseParams :: empty property in key "' + key + '"');
    } else
      // if the key is an array
      if (key.indexOf('[') !== -1) {
        // extract the array name
        var list = key.split('[');
        key = list[0];

        // extract the index of the array
        var list = list[1].split(']');
        var index = list[0];

        // if index is empty, just push the value at the end of the array
        if (index == '') {
          if (!params) params = {};
          if (!params[key] || !$.isArray(params[key])) params[key] = [];
          params[key].push(value);
        } else
          // add the value at the index (must be an integer)
          {
            if (!params) params = {};
            if (!params[key] || !$.isArray(params[key])) params[key] = [];
            params[key][parseInt(index)] = value;
          }
      } else
        // just normal key
        {
          if (!params) params = {};
          params[key] = value;
        }
  }

  // be sure the query is a string
  query = query + '';

  if (query === '') query = window.location + '';

  var params = {},
      e;
  if (query) {
    // remove # from end of query
    if (query.indexOf('#') !== -1) {
      query = query.substr(0, query.indexOf('#'));
    }

    // remove ? at the begining of the query
    if (query.indexOf('?') !== -1) {
      query = query.substr(query.indexOf('?') + 1, query.length);
    } else return {};

    // empty parameters
    if (query == '') return {};

    // execute a createElement on every key and value
    while (e = re.exec(query)) {
      var key = decode(e[1]);
      var value = decode(e[2]);
      createElement(params, key, value);
    }
  }
  return params;
};

var getQueryStringAsObject = function getQueryStringAsObject() {
  var b,
      cv,
      e,
      k,
      ma,
      sk,
      v,
      r = {},
      d = function d(v) {
    return decodeURIComponent(v).replace(/\+/g, " ");
  },
      //# d(ecode) the v(alue)
  q = window.location.search.substring(1),
      s = /([^&;=]+)=?([^&;]*)/g //# original regex that does not allow for ; as a delimiter:   /([^&=]+)=?([^&]*)/g
  ;

  //# ma(make array) out of the v(alue)
  ma = function ma(v) {
    //# If the passed v(alue) hasn't been setup as an object
    if ((typeof v === "undefined" ? "undefined" : _typeof(v)) != "object") {
      //# Grab the cv(current value) then setup the v(alue) as an object
      cv = v;
      v = {};
      v.length = 0;

      //# If there was a cv(current value), .push it into the new v(alue)'s array
      //#     NOTE: This may or may not be 100% logical to do... but it's better than loosing the original value
      if (cv) {
        Array.prototype.push.call(v, cv);
      }
    }
    return v;
  };

  //# While we still have key-value e(ntries) from the q(uerystring) via the s(earch regex)...
  while (e = s.exec(q)) {
    //# while((e = s.exec(q)) !== null) {
    //# Collect the open b(racket) location (if any) then set the d(ecoded) v(alue) from the above split key-value e(ntry)
    b = e[1].indexOf("[");
    v = d(e[2]);

    //# As long as this is NOT a hash[]-style key-value e(ntry)
    if (b < 0) {
      //# b == "-1"
      //# d(ecode) the simple k(ey)
      k = d(e[1]);

      //# If the k(ey) already exists
      if (r[k]) {
        //# ma(make array) out of the k(ey) then .push the v(alue) into the k(ey)'s array in the r(eturn value)
        r[k] = ma(r[k]);
        Array.prototype.push.call(r[k], v);
      }
      //# Else this is a new k(ey), so just add the k(ey)/v(alue) into the r(eturn value)
      else {
          r[k] = v;
        }
    }
    //# Else we've got ourselves a hash[]-style key-value e(ntry)
    else {
        //# Collect the d(ecoded) k(ey) and the d(ecoded) sk(sub-key) based on the b(racket) locations
        k = d(e[1].slice(0, b));
        sk = d(e[1].slice(b + 1, e[1].indexOf("]", b)));

        //# ma(make array) out of the k(ey)
        r[k] = ma(r[k]);

        //# If we have a sk(sub-key), plug the v(alue) into it
        if (sk) {
          r[k][sk] = v;
        }
        //# Else .push the v(alue) into the k(ey)'s array
        else {
            Array.prototype.push.call(r[k], v);
          }
      }
  }

  //# Return the r(eturn value)
  return r;
};

var tbody = Vue.extend({
  props: ['row'],
  methods: {
    expandParent: function expandParent(parent) {
      parent.expandChild = !parent.expandChild;
    },
    shareCompliance: function shareCompliance(base_url, unique_id) {
      var compliance_url = base_url + '/' + unique_id;
      swal({
        title: 'Share URL',
        text: '<input type="text" value="' + compliance_url + '" style="display: block;">',
        html: true
      });
    }
  },
  filters: {
    statusClass: function statusClass(status) {
      if (status) {
        return status.replace(new RegExp(' ', 'g'), '').toLowerCase();
      }
    },
    formatDate: function formatDate(datetime, format) {
      if (moment(datetime).isValid() && format) {
        return moment(datetime).format(format);
      } else {
        return '-';
      }
    },
    currency: function currency(val, format) {
      val = isNaN(val) ? 0 : Number(val);
      format = format.split('.');
      return format[0] + val.toFixed(format[1]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

  }
});

var hpd_complaints = tbody.extend({
  template: '#hpd-complaints'
});

var hpd_violations = tbody.extend({
  template: '#hpd-violations'
});

var hpd_charges = tbody.extend({
  template: '#hpd-charges'
});

var hpd_litigation = tbody.extend({
  template: '#hpd-litigation'
});

var dot_violations = tbody.extend({
  template: '#dot-violations'
});

var complaints = tbody.extend({
  template: '#complaints'
});

var fdny_violations = tbody.extend({
  template: '#fdny-violations'
});

var fdny_violation_orders = tbody.extend({
  template: '#fdny-violation-orders'
});

var fdny_cof = tbody.extend({
  template: '<tbody><tr class="expand-parent" @click="expandParent(row)"><td class="collapsible" ><i class="fa" v-bind:class="{ \'fa-minus-square-o\': row.expandChild, \'fa-plus-square-o\': row.expandChild == false }"></i></td><td class="star"><a data-id="" class="star fa fa-star-o"></a></td><td class="order">{{ row.fdny_cof_num }}</td> <td class="order">{{ row.fdny_cof_holder_name }}</td> <td class="order">{{ row.fdny_cof_type }}</td> <td class="date">{{ row.fdny_cof_expires_on | formatDate "M/D/YYYY" }}</td> <td><div class="status {{ row.fdny_cof_status | statusClass }}" title="{{ row.fdny_cof_status }}">{{ row.fdny_cof_status }}</div></td></tr> <tr class="expand-child" style="display: table-row;" v-show="row.expandChild"> <td colspan="2" class="sub"></td> <td colspan="100%"> <fieldset><legend>Certificates of Fitness Details</legend> <div class="half left"> <div class="title">Cert #:</div><div class="data">{{ row.child.fdny_cof_num }}</div> </div> <div class="half"> <div class="title">COF Holder:</div><div class="data">{{ row.child.fdny_cof_holder_name }}</div> </div> <div class="half left"> <div class="title">Category:</div><div class="data">{{ row.child.fdny_cof_type }}</div> </div> <div class="half"> <div class="title">Expiration Date:</div><div class="data">{{ row.fdny_cof_expires_on | formatDate "M/D/YYYY" }}</div> </div> <div class="half left"> <div class="title">Status:</div><div class="status {{ row.child.fdny_cof_status | statusClass }}">{{ row.child.fdny_cof_status }}</div> </div> </fieldset> </td> </tr> </tbody>'
});

var fdny_summonses = tbody.extend({
  template: '<tbody><tr class="expand-parent" @click="expandParent(row)"><td class="collapsible" ><i class="fa" v-bind:class="{ \'fa-minus-square-o\': row.expandChild, \'fa-plus-square-o\': row.expandChild == false }"></i> </td> <td class="star"><a data-id="" class="star fa fa-star-o"></a></td> <td class="order">{{ row.fdnyvo_intermediate }}</td> <td class="date">{{ row.issue_date | formatDate "M/D/YYYY" }}</td> <td>{{ row.fdnyvo_sum_name }}</td> <td class="type"><span>{{ row.vo_rule_label }}</span></td> <td class="date">{{ row.fdnyvo_hearing_dt | formatDate "M/D/YYYY" }}</td></tr> <tr class="expand-child" style="display: table-row;" v-show="row.expandChild"> <td colspan="2" class="sub"></td> <td colspan="100%"> <fieldset><legend>Summons Details</legend> <div class="full"> <div class="title">Infractions:</div><div class="data"> <div v-for="item in row.child.infrac"> <p><span class="label label-sm bg-grey-cascade">{{ item.vo_rule_key }}</span> {{ item.vo_rule_description }}</p> </div></div> <div class="title">Account #:</div> <div class="data">{{ row.child.fdnyvo_account_no }}</div> </div> </fieldset> <fieldset><legend>District Office Details</legend> <div class="title">District Office:</div> <div class="data">{{ row.child.fdnydo_description }}</div> <div class="title">Number:</div> <div class="data">{{ row.child.fdnyvo_district_office }}</div> <div class="title">Phone Number:</div><div class="data">{{ row.child.fdnydo_phone_number }}</div> <div class="title">Unit Number:</div><div class="data">{{ row.child.fdnyvo_unit_num }}</div> </fieldset> </td> </tr> </tbody>'
});

var dsny_violations = tbody.extend({
  template: '#dsny-violations'
});

var dep_violations = tbody.extend({
  template: '#dep-violations'
});

var dep_benchmarking = tbody.extend({
  template: '<tbody><tr class="expand-parent"> <td class="collapsible" > </td> <td class="star"><a data-id="" class="star fa fa-star-o"></a></td> <td>{{ row.boro }}</td> <td>{{ row.block }}</td> <td>{{ row.lot }}</td> <td>{{ row.floors }}</td> <td>{{ row.area }}</td> <td><span class="fa-stack fa-lg" v-if="row.amr == 1"><i class="fa fa-circle fa-stack-2x font-blue"></i><i class="fa fa-stack-1x fa-inverse fa-tint"></i></span></td> <td><div class="status {{ row.subject | statusClass }}" title="{{ row.subject }}">{{ row.subject }}</div></td></tr> <tr class="expand-child" style="display: table-row;" v-show="row.expandChild"> <td colspan="2" class="sub"></td> <td colspan="100%"> </td> </tr> </tbody>'
});

var dep_audit = tbody.extend({
  template: '<tbody><tr class="expand-parent"><td class="collapsible" ></td> <td class="star"><a data-id="" class="star fa fa-star-o"></a></td> <td>{{ row.boro }}</td> <td>{{ row.block }}</td> <td>{{ row.lot }}</td> <td>{{ row.floors }}</td> <td>{{ row.area }}</td> <td>{{ row.audit_year }}</td> <td><div class="status {{ row.subject | statusClass }}" title="{{ row.subject }}">{{ row.subject }}</div></td></tr> <tr class="expand-child" style="display: table-row;" v-show="row.expandChild"> <td colspan="2" class="sub"></td> <td colspan="100%"> </td> </tr> </tbody>'
});

var doh_violations = tbody.extend({
  template: '#doh-violations'
});

var dob_complaints = tbody.extend({
  template: '#dob-complaints'
});

var dob_jobs = tbody.extend({
  template: '#dob-jobs'
});

var dob_permits = tbody.extend({
  template: '#dob-permits'
});

var dob_electrical = tbody.extend({
  template: '#dob-electrical'
});

var dob_elevator = tbody.extend({
  template: '#dob-elevator'
});

var dob_elevator_inspections = tbody.extend({
  template: '#dob-elevator-inspections'
});

var dob_boiler = tbody.extend({
  template: '#dob-boiler'
});

var dob_boilers_dep = tbody.extend({
  template: '#dob-boilers-dep'
});

var dob_aralaajobs = tbody.extend({
  template: '#dob-aralaajobs'
});

var dob_ahvpermits = tbody.extend({
  template: '#dob-ahvpermits'
});

var dob_facades = tbody.extend({
  template: '#dob-facades'
});

var dob_violations = tbody.extend({
  template: '#dob-violations'
});

var dob_ecb_violations = tbody.extend({
  template: '#dob-ecb-violations'
});

var dof_values = tbody.extend({
  template: '#dof-values'
});

var dof_charges = tbody.extend({
  template: '#dof-charges'
});
var dof_statements = tbody.extend({
  template: '#dof-statements'
});
var dof_exemptions = tbody.extend({
  template: '#dof-exemptions'
});
var dof_penalties = tbody.extend({
  template: '#dof-penalties'
});

var dof_payments = tbody.extend({
  template: '#dof-payments'
});

var dob_cofo = tbody.extend({
  template: '#dob-cofo'
});

var dec_storage = tbody.extend({
  template: '#dec-storage'
});

var DataTable = Vue.extend({
  components: {
    complaints: complaints,
    hpd_violations: hpd_violations,
    hpd_complaints: hpd_complaints,
    hpd_charges: hpd_charges,
    hpd_litigation: hpd_litigation,
    dot_violations: dot_violations,
    fdny_violations: fdny_violations,
    fdny_violation_orders: fdny_violation_orders,
    fdny_cof: fdny_cof,
    fdny_summonses: fdny_summonses,
    dsny_violations: dsny_violations,
    dep_violations: dep_violations,
    dep_benchmarking: dep_benchmarking,
    dep_audit: dep_audit,
    doh_violations: doh_violations,
    dob_complaints: dob_complaints,
    dob_jobs: dob_jobs,
    dob_permits: dob_permits,
    dob_electrical: dob_electrical,
    dob_elevator: dob_elevator,
    dob_elevator_inspections: dob_elevator_inspections,
    dob_boiler: dob_boiler,
    dob_boilers_dep: dob_boilers_dep,
    dob_aralaajobs: dob_aralaajobs,
    dob_ahvpermits: dob_ahvpermits,
    dob_facades: dob_facades,
    dob_violations: dob_violations,
    dob_ecb_violations: dob_ecb_violations,
    dof_values: dof_values,
    dof_charges: dof_charges,
    dof_statements: dof_statements,
    dof_exemptions: dof_exemptions,
    dof_penalties: dof_penalties,
    dof_payments: dof_payments,
    dob_cofo: dob_cofo,
    dec_storage: dec_storage
  },
  props: ['source', 'agency', 'type', 'hash'],
  data: function data() {
    return {
      parrent_menu: {
        par_menu: "Agencies",
        sub_selected_menu: "",
        sub_sub_selected_menu: ""
      },
      pagination: {
        total: 0, // total number of elements or items
        per_page: 12, // items per page
        current_page: 1, // current page (it will be automatically updated when users clicks on some page number).
        total_pages: 0 // total pages in record
      },
      loading: false,
      haveNoData: false,
      columns: {
        "vio_num": "VIO #",
        "vio_issue": "Issued",
        "vio_nov": "NOV #",
        "vio_apt": "Apt",
        "vio_hazard": "Class",
        "vio_order": "Order #",
        "vio_cert": "Cert Due",
        "vio_stat": "Status"
      },
      columns_count: 8,
      form_categories: [],
      rows: {},
      paginator: {},
      template: '',
      filter: {
        field: '',
        dir: 'desc'
      },
      currentMenu: ''
    };
  },

  methods: {
    uc_str: function uc_str(str) {
      return str.substr(0, 1).toUpperCase() + str.substr(1);
    },
    displayForms: function displayForms(type) {
      this.currentMenu = type;
      this.getForms(type);
    },
    violationAgency: function violationAgency(type) {
      this.currentMenu = type;
      this.columns = this.getHeadColumns(type);
      this.columns_count = Object.keys(this.columns).length;
      // this.pagination.current_page = 1;
      this.filter = {};
      if (window.innerWidth < 768) {
        var items = this.currentMenu.split("_");
        this.parrent_menu.sub_selected_menu = items[0].toUpperCase();
        this.parrent_menu.sub_sub_selected_menu = this.uc_str(items[1]);
        var elem = document.getElementsByClassName("agencies-menu__agency__sub-menu")[0].style.display = "none";
      }

      this.pagination = {
        total: 0,
        per_page: 12,
        current_page: 1,
        total_pages: 0
      };
      this.getData();
    },
    updateUrlAgency: function updateUrlAgency(agency, type) {

      history.pushState(null, null, this.source + '/' + agency + '/' + type);
    },
    getHeadColumns: function getHeadColumns(type) {
      switch (type) {
        case "hpd_complaints":
          this.template = 'hpd_complaints';
          this.url = '/api/data/hpd/complaints/' + this.hash;
          this.updateUrlAgency('hpd', 'complaints');
          return {
            comp_number: "Comp #",
            comp_date: "Date",
            comp_apt: "Apt",
            comp_condition: "Condition",
            comp_detail: "Details",
            comp_location: "Location",
            comp_status: "Status"
          };
          break;
        case "hpd_violations":
          this.template = 'hpd_violations';
          this.url = '/api/data/hpd/violations/' + this.hash;
          this.updateUrlAgency('hpd', 'violations');
          return {
            "vio_num": "VIO #",
            "vio_issue": "Issued",
            "vio_nov": "NOV #",
            "vio_apt": "Apt",
            "vio_hazard": "Class",
            "vio_order": "Order #",
            "vio_cert": "Cert Due",
            "vio_stat": "Status"
          };
          break;
        case "hpd_charges":
          this.template = 'hpd_charges';
          this.url = '/api/data/hpd/charges/' + this.hash;
          this.updateUrlAgency('hpd', 'charges');
          return {
            num: "OMO #",
            charge_issued: "Issued",
            type: "Type",
            job: "Job",
            charge: "Charge",
            phrase: "Status"
          };
          break;
        case "hpd_litigation":
          this.template = 'hpd_litigation';
          this.url = '/api/data/hpd/litigation/' + this.hash;
          this.updateUrlAgency('hpd', 'litigation');
          return {
            opened: "Opened",
            type: "Type",
            outst: "Outstanding",
            status: "Status"
          };
          break;
        case "dot_violations":
          this.template = 'dot_violations';
          this.url = '/api/data/dot/violations/' + this.hash;
          this.updateUrlAgency('dot', 'violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status"
          };
          break;
        case "dot_complaints":
          this.template = 'complaints';
          this.url = '/api/data/dot/complaints/' + this.hash;
          this.updateUrlAgency('dot', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;
        case "nypd_complaints":
          this.template = 'complaints';
          this.url = '/api/data/nypd/complaints/' + this.hash;
          this.updateUrlAgency('nypd', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;
        case "dsny_violations":
          this.template = 'dsny_violations';
          this.url = '/api/data/dsny/violations/' + this.hash;
          this.updateUrlAgency('dsny', 'violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status"
          };
          break;
        case "dsny_complaints":
          this.template = 'complaints';
          this.url = '/api/data/dsny/complaints/' + this.hash;
          this.updateUrlAgency('dsny', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;

        case "fdny_violations":
          this.template = 'fdny_violations';
          this.url = '/api/data/fdny/violations/' + this.hash;
          this.updateUrlAgency('fdny', 'violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status",
            comp_status: "Compliance Status"
          };
          break;

        case "fdny_violation_orders":
          this.template = 'fdny_violation_orders';
          this.url = '/api/data/fdny/violation_orders/' + this.hash;
          this.updateUrlAgency('fdny', 'violation_orders');
          return {
            fdny_violation_no: "Violation #",
            issue_date: "Issue Date",
            vo_rule_label: "Type",
            fdnydo_label: "District Office",
            fdnyvo_account_owner: "Account Owner",
            comp_status: "Compliance Status"
          };
          break;

        case "fdny_summonses":
          this.template = 'fdny_summonses';
          this.url = '/api/data/fdny/summonses/' + this.hash;
          this.updateUrlAgency('fdny', 'summonses');
          return {
            fdnyvo_intermediate: "Summons Number",
            issue_date: "Issue Date",
            fdnyvo_sum_name: "Summons Name",
            vo_rule_label: "Type",
            fdnyvo_hearing_dt: "Hearing Date"
          };
          break;

        case "fdny_complaints":
          this.template = 'complaints';
          this.url = '/api/data/fdny/complaints/' + this.hash;
          this.updateUrlAgency('fdny', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;
        case "fdny_cof":
          this.template = 'fdny_cof';
          this.url = '/api/data/fdny/cof/' + this.hash;
          this.updateUrlAgency('fdny', 'cof');
          return {
            fdny_cof_num: "Cert #",
            fdny_cof_holder_name: "COF Holder",
            fdny_cof_type: "Category",
            fdny_cof_expires_on: "Expiration Date",
            fdny_cof_status: "Status"
          };
          break;
        case "dep_violations":
          this.template = 'dep_violations';
          this.url = '/api/data/dep/violations/' + this.hash;
          this.updateUrlAgency('dep', 'violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status"
          };
          break;
        case "dep_complaints":
          this.template = 'complaints';
          this.url = '/api/data/dep/complaints/' + this.hash;
          this.updateUrlAgency('dep', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;
        case "dep_benchmarking":
          this.template = 'dep_benchmarking';
          this.url = '/api/data/dep/benchmarking/' + this.hash;
          this.updateUrlAgency('dep', 'benchmarking');
          return {
            boro: "Borough",
            block: "Block",
            lot: "Lot",
            floors: "Floors",
            area: "Building Area",
            amr: "AMR",
            subject: "Subject"
          };
          break;

        case "dep_audit":
          this.template = 'dep_audit';
          this.url = '/api/data/dep/audit/' + this.hash;
          this.updateUrlAgency('dep', 'audit');
          return {
            boro: "Borough",
            block: "Block",
            lot: "Lot",
            floors: "Floors",
            area: "Building Area",
            audit: "Audit Year",
            subject: "Subject"
          };
          break;
        case "doh_violations":
          this.template = 'doh_violations';
          this.url = '/api/data/doh/violations/' + this.hash;
          this.updateUrlAgency('doh', 'violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status"
          };
          break;
        case "doh_complaints":
          this.template = 'complaints';
          this.url = '/api/data/doh/complaints/' + this.hash;
          this.updateUrlAgency('doh', 'complaints');
          return {
            rel: "Complaint #",
            created_date: "Created",
            comp_type_name: "Type",
            closed_date: "Closed",
            status_name: "Status"
          };
          break;

        case "dob_jobs":
          this.template = 'dob_jobs';
          this.url = '/api/data/dob/jobs/' + this.hash;
          this.updateUrlAgency('dob', 'jobs');
          return {
            num: "Job Num",
            job_file_date: "Filed",
            job_doc_number: "Doc #",
            job_type_name: "Job Type",
            job_status_date: "Status Date",
            job_status_short: "Status"
          };
          break;

        case "dob_permits":
          this.template = 'dob_permits';
          this.url = '/api/data/dob/permits/' + this.hash;
          this.updateUrlAgency('dob', 'permits');
          return {
            p_num: "Permit Num",
            issue_date: "Issued",
            type_short: "Permit Type",
            expire_date: "Expires",
            p_status: "Status"
          };
          break;

        case 'dob_electrical':
          this.template = 'dob_electrical';
          this.url = '/api/data/dob/electrical/' + this.hash;
          this.updateUrlAgency('dob', 'electrical');
          return {
            app_number: "App Num",
            app_enter_date: "Entered",
            app_type_request: "Request Type",
            app_job_end: "Job End",
            app_status_word: "Status"
          };
          break;

        case 'dob_elevator_inspections':
          this.template = 'dob_elevator_inspections';
          this.url = '/api/data/dob/elevator_inspections/' + this.hash;
          this.updateUrlAgency('dob', 'elevator_inspections');
          return {
            insp_date: "Date",
            device_num: "Device",
            insp_type: "Insp Type",
            insp_badge: "Inspected By",
            insp_disp: "Disposition"
          };
          break;

        case 'dob_boiler':
          this.template = 'dob_boiler';
          this.url = '/api/data/dob/boiler/' + this.hash;
          this.updateUrlAgency('dob', 'boiler');
          return {
            insp_date: "Date",
            num: "Device #/ Serial",
            insp_name: "Inspected by",
            result: "Result"
          };
          break;
        case 'dob_boilers_dep':
          this.template = 'dob_boilers_dep';
          this.url = '/api/data/dob/boilers_dep/' + this.hash;
          this.updateUrlAgency('dob', 'boilers_dep');
          return {
            num: "DEP Num",
            decision_date: "Decision Date",
            dep_t: "Request Type",
            model: "Make/Model",
            expDate: "Expires",
            status: "Status"
          };
          break;
        case 'dob_aralaajobs':
          this.template = 'dob_aralaajobs';
          this.url = '/api/data/dob/aralaajobs/' + this.hash;
          this.updateUrlAgency('dob', 'aralaajobs');
          return {
            alj_file_date: "File Date",
            alj_job_number: "Job Num",
            alj_job_status: "Status",
            alj_applicant: "Applicant"
          };
          break;
        case 'dob_ahvpermits':
          this.template = 'dob_ahvpermits';
          this.url = '/api/data/dob/ahvpermits/' + this.hash;
          this.updateUrlAgency('dob', 'ahvpermits');
          return {
            ahv_ref_number: "Reference Num",
            ahv_job_number: "Job Num",
            ahv_start_date: "Start Date",
            ahv_end_date: "End Date",
            ahv_status: "Status"
          };
          break;
        case 'dob_facades':
          this.template = 'dob_facades';
          this.url = '/api/data/dob/facades/' + this.hash;
          this.updateUrlAgency('dob', 'facades');
          return {
            control_no: 'Control #',
            cycle: 'Cycle',
            sequence_no: 'Sequence #',
            submitted_on: 'Submitted On',
            applicant: 'Applicant',
            current_status: 'Current Status'
          };
          break;
        case 'dob_complaints':
          this.template = 'dob_complaints';
          this.url = '/api/data/dob/complaints/' + this.hash;
          this.updateUrlAgency('dob', 'complaints');
          return {
            comp_dob_number: "Comp #",
            comp_received_datetime: "Received",
            comp_cat_code: "Category",
            comp_priority: "Priority",
            comp_disp_code: "Disposition",
            comp_status: "Status"
          };
          break;
        case 'dob_violations':
          this.template = 'dob_violations';
          this.url = '/api/data/dob/violations/' + this.hash;
          this.updateUrlAgency('dob', 'violations');
          return {
            vio_number: "Violation",
            vio_issue_date: "Issued",
            vio_type_word: "Type",
            vio_cat_word: "Category",
            vio_disp_date: "Dismissed",
            vio_disp_word: "Status"
          };
          break;
        case 'dob_ecb_violations':
          this.template = 'dob_ecb_violations';
          this.url = '/api/data/dob/ecb_violations/' + this.hash;
          this.updateUrlAgency('dob', 'ecb_violations');
          return {
            ecb_number: "Violation #",
            vio_date: "Offense",
            vio_total_due: "Total Due",
            vio_hearing_date: "Hearing",
            vio_status: "Status"
            /*
            num: "Vio #",
            ecb_issue_date: "Issued",
            ecb_type_word: "Type",
            ecb_severity: "Severity",
            ecb_hearing_date: "Hearing",
            ecb_balance: "Balance",
            ecb_status_word: "Cert Status"
            */
          };
          break;
        case 'dob_cofo':
          this.template = 'dob_cofo';
          this.url = '/api/data/dob/cofo/' + this.hash;
          this.updateUrlAgency('dob', 'cofo');
          return {
            effective_date: "Effective",
            app_number: "App Number",
            expire_date: "Expires",
            doc_type: "Type",
            doc_name: "Document Number"
          };
          break;
        case 'dof_values':
          this.template = 'dof_values';
          this.url = '/api/data/dof/values/' + this.hash;
          this.updateUrlAgency('dof', 'values');
          return {
            market: "Market Value",
            totals: "Assessed Value",
            land: "Land Value",
            tax: "Tax Base",
            bbl: "NPV"
          };
          break;
        case 'dof_charges':
          this.template = 'dof_charges';
          this.url = '/api/data/dof/charges/' + this.hash;
          this.updateUrlAgency('dof', 'charges');
          return {
            period: "Period",
            agency: "Agency",
            acc: "Payment Account",
            acc_number: "Account",
            due: "Due",
            charge: "Total",
            ch_status: "Status"
          };
          break;
        case 'dof_statements':
          this.template = 'dof_statements';
          this.url = '/api/data/dof/statements/' + this.hash;
          this.updateUrlAgency('dof', 'statements');
          return {
            stmt_date: "Date",
            statement: "Statement",
            payment_due: "Payment Due"
          };
          break;

        case 'dof_exemptions':
          this.template = 'dof_exemptions';
          this.url = '/api/data/dof/exemptions/' + this.hash;
          this.updateUrlAgency('dof', 'exemptions');
          return {
            application_number: "Application Number",
            type: "Type",
            credit_or_debit_approved: "Approved Date",
            monthly_legal_rent: "Monthly Legal Rent",
            credit_or_debit: "Credit or (Debit)",
            benefit_status: "Benefit Status"
          };
          break;
        case 'dof_penalties':
          this.template = 'dof_penalties';
          this.url = '/api/data/dof/penalties/' + this.hash;
          this.updateUrlAgency('dof', 'penalties');
          return {
            vio_date: "Issue Date",
            agency: "Agency",
            ecb_number: "Violation #",
            vio_hearing_date: "Hearing Date",
            imposed: "Imposed",
            paid: "Payments",
            vio_total_due: "Balance",
            vio_status: "Status"
          };
          break;
        case 'dof_payments':
          this.template = 'dof_payments';
          this.url = '/api/data/dof/payments/' + this.hash;
          this.updateUrlAgency('dof', 'payments');
          return {
            p_date: "Date",
            acc_dept: "Agency",
            acc_type: "Payment Account",
            acc_num: "Account",
            trans_type: "Trans Type",
            amount: "Payment"
          };
          break;

        case 'dec_storage':
          this.template = 'dec_storage';
          this.url = '/api/data/dec/storage/' + this.hash;
          this.updateUrlAgency('dec', 'storage');
          return {
            siteID: "Site #",
            height: "Site Name",
            width: "Program",
            ann_fee: "Expiration",
            bill_interval: "Status"
          };
          break;
      }
    },
    sortable: function sortable(column) {
      var self = this;
      if (this.filter.dir == undefined) {
        this.filter.dir = 'asc';
      }
      if (column == this.filter.field) {
        this.filter.dir = this.filter.dir == 'desc' ? 'asc' : 'desc';
      }
      this.filter.field = column;
      this.getData();
    },
    getForms: function getForms(type) {
      switch (type) {
        case 'dob_forms':
          this.url = '/api/data/dob/forms/' + this.hash;
          this.updateUrlAgency('dob', 'forms');
          break;
        case 'hpd_forms':
          this.url = '/api/data/hpd/forms/' + this.hash;
          this.updateUrlAgency('hpd', 'forms');
          break;
      }

      this.loading = true;
      this.form_categories = [];

      var self = this;
      $.ajax({
        url: self.url,
        method: 'GET',
        success: function success(resp) {
          self.form_categories = resp.data;
          self.loading = false;
        },
        error: function error(_error) {
          self.loading = false;
        }
      });
    },
    getData: function getData() {

      var self = this;
      self.filter.page = self.pagination.current_page;
      self.loading = true;
      self.rows = {};

      $.ajax({
        url: self.url,
        method: "GET",
        data: self.filter,
        success: function success(resp) {
          if (!resp.data) {
            self.haveNoData = true;
          } else {
            self.haveNoData = false;
            self.rows = resp.data;

            if (resp.paginator != null) {
              self.pagination.total = resp.paginator.total_items;
              self.pagination.total_pages = resp.paginator.total_pages;
            } else {
              self.pagination.total = self.rows.length;
            }
          }

          self.loading = false;

          var string = $.param(self.filter);
          history.pushState({}, '', location.href.split('?')[0] + (string ? '?' + string : ''));
        },
        error: function error(_error2) {
          self.loading = false;
        }
      });
    }

  },
  beforeCompile: function beforeCompile() {
    if (this.agency != '' && this.type != '') {
      var type = this.agency + '_' + this.type;
      if (window.innerWidth < 768) {
        this.parrent_menu.sub_selected_menu = this.agency.toUpperCase();
        this.parrent_menu.sub_sub_selected_menu = this.uc_str(this.type);
      }

      this.filter = parseParams(window.location.href);

      this.currentMenu = type;
      if (type == 'dob_forms' || type == 'hpd_forms') {
        this.getForms(type);
      } else {
        this.columns = this.getHeadColumns(type);
        this.columns_count = Object.keys(this.columns).length;

        if (this.filter.page != '') {
          this.pagination.current_page = this.filter.page;
        }

        if (this.filter.page == '') {
          delete this.filter.page;
        }

        if (this.filter.field == '') {
          delete this.filter.field;
          delete this.filter.dir;
        }

        var string = $.param(this.filter);
        history.pushState({}, '', location.href.split('?')[0] + (string ? '?' + string : ''));

        this.getData();
      }
    }
  },
  compiled: function compiled() {}

});

Vue.component('data-table', DataTable);

var Help = Vue.extend({
  components: {
    panel: VueStrap.panel,
    accordion: VueStrap.accordion
  },
  data: function data() {
    return {
      //
    };
  },
  methods: {
    openSupportChat: function openSupportChat() {
      console.log('open chat with Ari');
    }
  }
});
Vue.component('help', Help);

var JoinUsModal = Vue.extend({
  components: {
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      showModal: false
    };
  },

  ready: function ready() {},
  methods: {},
  events: {
    'open-join-us-modal': function openJoinUsModal(data) {
      this.showModal = true;
    }
  }
});
Vue.component('join-us-modal', JoinUsModal);

var NeighborhoodsItem = Vue.extend({
  name: 'neighborhoods-item',
  props: ['items'],
  data: {
    isSelectedAll: '',
    list: {}
  },
  template: '<ul class="neighborhoods-tree">' + '<li class="neighborhoods-tree__element" v-for="item in items | orderBy \' title \'">' + '<div class="neighborhoods-tree__element-group">' + '<input type="checkbox" @click="toggleItem(item)" id="neighborhoods-tree-{{ item.id }}" v-model="item.checked" :value="item.id">' + '<label for="neighborhoods-tree-{{ item.id }}" class="neighborhoods-tree__title">{{item.title}}</label>' + '</div>' + '<neighborhoods-item v-if="item.children" :items="item.children"></neighborhoods-item>' + '</li>' + '</ul>',
  methods: {
    toggleCheckItem: function toggleCheckItem(items, checked) {
      var self = this;
      items.forEach(function (item) {
        item.checked = checked;
        if (item.children) {
          self.toggleCheckItem(item.children, checked);
        }
      });
    },
    toggleItem: function toggleItem(item) {
      var self = this;
      var checked = !item.checked;
      self.isSelectedAll = checked;
      self.$dispatch('toggleItem', {
        isSelectedAll: checked
      });
      if (item.children) {
        self.toggleCheckItem(item.children, checked);
      }
    }

  },
  events: {
    selectAll: function selectAll(data) {
      this.toggleCheckItem(data.parent.children, data.parent.checked);
    }
  }

});
Vue.component('neighborhoods-item', NeighborhoodsItem);

var News = Vue.extend({
  components: {},
  data: function data() {
    return {
      articles: [],
      publications: [],
      selectedPublication: null,
      currentPage: 1,
      descriptionSize: 500,
      loading: false,
      isMobile: false,
      pagination: 10
    };
  },
  props: ['selectedPublicationProp'],
  ready: function ready() {
    this.selectedPublication = this.selectedPublicationProp;
    this.loading = true;
    this.fetchData();
    this.getPublications();
  },
  beforeCompile: function beforeCompile() {
    this.loading = false;
    if (screen.width < 420) {
      this.descriptionSize = 120;
    }
  },

  methods: {
    nextPage: function nextPage() {
      this.loading = true;
      var nexpage = this.currentPage + 1;
      this.currentPage = nexpage;
      if (this.selectedPublication) {
        this.getArticles('/dashboard/articles/' + this.pagination + '?page=' + nexpage + '&publication_slug=' + this.selectedPublication);
      } else {
        this.getArticles('/dashboard/articles/' + this.pagination + '?page=' + nexpage);
      }
    },
    previousPage: function previousPage() {
      if (this.currentPage != 1) {
        this.loading = true;
        var previous = this.currentPage - 1;
        this.currentPage = previous;
        if (this.selectedPublication) {
          this.getArticles('/dashboard/articles/' + this.pagination + '?page=' + previous + '&publication_slug=' + this.selectedPublication);
        } else {
          this.getArticles('/dashboard/articles/' + this.pagination + '?page=' + previous);
        }
      }
    },

    fetchData: function fetchData() {
      if (this.selectedPublication != null) {
        this.getArticles('/dashboard/articles/' + this.pagination + '?publication_slug=' + this.selectedPublication);
      } else {
        this.getArticles('/dashboard/articles/' + this.pagination + '');
      }
    },
    getArticles: function getArticles(action) {
      var ctx = this;

      $.get(action, function (data) {
        ctx.loading = false;
        ctx.articles = data;
      });
    },
    getPublications: function getPublications() {
      var ctx = this;
      $.get('/dashboard/publications', function (data) {
        ctx.loading = false;
        ctx.publications = data;
        console.log(ctx.publications);
      });
    },
    filterByPublication: function filterByPublication(slug) {
      this.loading = true;
      this.selectedPublication = slug;
      this.getArticles('/dashboard/articles/' + this.pagination + '?publication_slug=' + slug);
    }
  }

});
Vue.component('news', News);

var Notifications = Vue.extend({
  data: function data() {
    return {
      loading: false,
      isPushEnabled: false,
      pushButtonDisabled: true
    };
  },
  ready: function ready() {
    this.registerServiceWorker();
  },


  methods: {
    /**
     * Register the service worker.
     */
    registerServiceWorker: function registerServiceWorker() {
      var _this8 = this;

      if (!('serviceWorker' in navigator)) {
        console.log('Service workers aren\'t supported in this browser.');
        return;
      }

      navigator.serviceWorker.register('/sw.js').then(function () {
        return _this8.initialise();
      });
    },
    initialise: function initialise() {
      var _this9 = this;

      if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
        console.log('Notifications aren\'t supported.');
        return;
      }

      if (Notification.permission === 'denied') {
        console.log('The user has blocked notifications.');
        return;
      }

      if (!('PushManager' in window)) {
        console.log('Push messaging isn\'t supported.');
        return;
      }

      navigator.serviceWorker.ready.then(function (registration) {
        registration.pushManager.getSubscription().then(function (subscription) {
          _this9.pushButtonDisabled = false;

          if (!subscription) {
            return;
          }

          _this9.updateSubscription(subscription);

          _this9.isPushEnabled = true;
        }).catch(function (err) {
          console.log('Error during getSubscription()', err);
        });
      });
    },


    /**
     * Subscribe for push notifications.
     */
    subscribe: function subscribe() {
      var _this10 = this;

      navigator.serviceWorker.ready.then(function (registration) {
        registration.pushManager.subscribe({ userVisibleOnly: true }).then(function (subscription) {
          _this10.isPushEnabled = true;
          _this10.pushButtonDisabled = false;

          _this10.updateSubscription(subscription);
        }).catch(function (e) {
          if (Notification.permission === 'denied') {
            console.log('Permission for Notifications was denied');
            _this10.pushButtonDisabled = true;
          } else {
            console.log('Unable to subscribe to push.', e);
            _this10.pushButtonDisabled = false;
          }
        });
      });
    },


    /**
     * Unsubscribe from push notifications.
     */
    unsubscribe: function unsubscribe() {
      var _this11 = this;

      navigator.serviceWorker.ready.then(function (registration) {
        registration.pushManager.getSubscription().then(function (subscription) {
          if (!subscription) {
            _this11.isPushEnabled = false;
            _this11.pushButtonDisabled = false;
            return;
          }

          subscription.unsubscribe().then(function () {
            _this11.deleteSubscription(subscription);

            _this11.isPushEnabled = false;
            _this11.pushButtonDisabled = false;
          }).catch(function (e) {
            console.log('Unsubscription error: ', e);
            _this11.pushButtonDisabled = false;
          });
        }).catch(function (e) {
          console.log('Error thrown while unsubscribing.', e);
        });
      });
    },


    /**
     * Toggle push notifications subscription.
     */
    togglePush: function togglePush() {
      if (this.isPushEnabled) {
        this.unsubscribe();
      } else {
        this.subscribe();
      }
    },


    /**
     * Send a request to the server to update user's subscription.
     *
     * @param {PushSubscription} subscription
     */
    updateSubscription: function updateSubscription(subscription) {
      var _this12 = this;

      var key = subscription.getKey('p256dh');
      var token = subscription.getKey('auth');

      var data = {
        endpoint: subscription.endpoint,
        key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
        token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
      };

      this.loading = true;

      this.$http.post('/subscriptions', data).then(function () {
        return _this12.loading = false;
      });
    },


    /**
     * Send a requst to the server to delete user's subscription.
     *
     * @param {PushSubscription} subscription
     */
    deleteSubscription: function deleteSubscription(subscription) {
      var _this13 = this;

      this.loading = true;

      this.$http.post('/subscriptions/delete', { endpoint: subscription.endpoint }).then(function () {
        return _this13.loading = false;
      });
    },


    /**
     * Send a request to the server for a push notification.
     */
    sendNotification: function sendNotification() {
      var _this14 = this;

      this.loading = true;

      this.$http.post('/notifications').catch(function (response) {
        return console.log(response);
      }).then(function () {
        return _this14.loading = false;
      });
    }
  }
});
Vue.component('notifications', Notifications);

var Pagination = Vue.extend({
  template: '<nav class=" {{navClass}} " v-show="visible">' + '<ul class="pagination {{size}} " >' + '<li v-if="pagination.current_page > 1">' + '<a href="#" aria-label="Previous" @click.prevent="changePage(1)">' + '<span aria-hidden="true">First</span>' + '</a>' + '</li>' + '<li v-if="pagination.current_page > 1">' + '<a href="#" aria-label="Previous" @click.prevent="changePage(pagination.current_page - 1)">' + '<span aria-hidden="true">&laquo;</span>' + '</a>' + '</li>' + '<li v-if="pagination.current_page > 1">' + '<a href="#" aria-label="Next" @click.prevent="changePage(from)">' + '<span aria-hidden="true">...</span>' + '</a>' + '</li>' + '<li v-for="num in data" :class="{\'active\': num == pagination.current_page}">' + '<a href="#" @click.prevent="changePage(num)">{{ num }}</a>' + '</li>' + '<li v-if="pagination.current_page < pagination.total_pages">' + '<a href="#" aria-label="Next" @click.prevent="changePage(to)">' + '<span aria-hidden="true">...</span>' + '</a>' + '</li>' + '<li v-if="pagination.current_page < pagination.total_pages">' + '<a href="#" aria-label="Next" @click.prevent="changePage(pagination.current_page + 1)">' + '<span aria-hidden="true">&raquo;</span>' + '</a>' + '</li>' + '<li v-if="pagination.current_page < pagination.total_pages">' + '<a href="#" aria-label="Next" @click.prevent="changePage(pagination.total_pages)">' + '<span aria-hidden="true">Last</span>' + '</a>' + '</li>' + '</ul>' + '</nav>',

  props: {
    pagination: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      required: true
    },
    size: {
      type: String,
      default: ""
    },
    navClass: {
      type: String,
      default: ""
    },
    offset: {
      type: Number,
      default: 4
    },
    visible: {
      type: Number,
      default: 1
    }
  },

  computed: {
    data: function data() {

      this.visible = 1;

      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }

      var to = from + this.offset * 2;
      if (to >= this.pagination.total_pages) {
        to = this.pagination.total_pages;
      }
      this.from = from;
      this.to = to;

      var arr = [];
      while (from <= to) {
        arr.push(from);
        from++;
      }

      if (arr.length == 1) this.visible = 0;

      return arr;
    }
  },

  watch: {
    'pagination.per_page': function paginationPer_page() {
      this.callback();
    }
  },

  methods: {
    changePage: function changePage(page) {
      this.$set('pagination.current_page', page);
      this.callback();
    }
  }

});

Vue.component('pagination', Pagination);
var PastJobs = Vue.extend({
  props: ['isCurrent', 'theyShouldPay'],
  data: function data() {
    return {
      isCurrent: 1,
      theyShouldPay: 0
    };
  },
  ready: function ready() {},
  methods: {}
});
Vue.component('past-jobs', PastJobs);
var PhoneVerification = Vue.extend({
  props: ['phone', 'loading', 'error', 'editMode', 'code', 'verified', 'sent', 'showError'],
  ready: function ready() {
    if (!this.sent) {
      this.sendCode();
    }
    if (this.showError) {
      swal({
        title: '<h2 style="text-align: left; margin: -28px 0px -10px 0px; font-size: 23px; color: grey; font-weight: 400;">Please verify your phone</h2>',
        text: "" + "<span style='font-size: 16px; line-height: 21px; margin-bottom: 1px; display: block;'>To prevent spam & fake accounts, we need users to verify their mobile numbers.</span></br>" + "<span style='font-size: 16px; line-height: 21px; margin-bottom: 1px; display: block;'>Once you enter the verification code we sent you, all links, search, and other features will work.</span>",
        html: true

      });
    }
  },
  methods: {
    editPhone: function editPhone() {
      this.editMode = true;
    },
    backFromEditPhone: function backFromEditPhone() {
      this.editMode = false;
    },
    checkCode: function checkCode() {
      var ctx = this;

      $.post('/dashboard/check-code', {
        code: ctx.code,
        _token: $('meta[name="csrf-token"]').attr('content')
      }, function (data) {
        if (data.error) {
          ctx.error = data.error;
        } else {
          ctx.verified = true;
        }
        ctx.loading = false;
      });
    },
    sendCode: function sendCode() {
      var ctx = this;

      ctx.loading = true;
      ctx.error = false;
      ctx.editMode = false;

      $.post('/dashboard/send-verification-code', {
        phone: ctx.phone,
        _token: $('meta[name="csrf-token"]').attr('content')
      }, function (data) {
        if (data.error) {
          ctx.error = data.error;
        }
        ctx.loading = false;
      });
    }
  }
});
Vue.component('phone-verification', PhoneVerification);
var PromoCodeApply = Vue.extend({
  props: [],
  data: function data() {
    var _ref;

    return _ref = {
      code: null,
      loading: false,
      codeIsFine: false,
      codeIsWrong: false
    }, _defineProperty(_ref, "code", null), _defineProperty(_ref, "codeObject", {
      "code": "",
      "amount": 0
    }), _ref;
  },
  ready: function ready() {},
  methods: {
    resetData: function resetData() {
      this.codeIsFine = false;
      this.codeIsWrong = false;
      this.codeObject = {
        "code": "",
        "amount": 0
      };
    },
    checkCode: function checkCode() {
      if (this.loading) {
        return;
      }

      var ctx = this;
      ctx.loading = true;
      ctx.resetData();

      $.get('/check-promo-code?code=' + this.code, function (data) {
        if (data.code) {
          ctx.codeObject = data;
          ctx.codeIsFine = true;
        } else {
          ctx.codeIsWrong = true;
        }
        ctx.loading = false;
      });
    }
  }
});
Vue.component('promo-code-apply', PromoCodeApply);
var PropertyOwners = Vue.extend({
  props: ['owners', 'loaded'],
  data: function data() {
    return {
      owners: [],
      ownersPeriods: [],
      individuals: [],
      companies: [],
      loaded: false
    };
  },
  ready: function ready() {
    var ctx = this;
    var periods = {};
    this.owners.forEach(function (item) {
      var periodName = item.registration_start_date + '/' + item.registration_end_date;
      if (typeof periods[periodName] == 'undefined') {
        periods[periodName] = [];
      }
      periods[periodName].push(item);
      if (item.company_id) {
        ctx.companies.push(item.company_id);
      } else {
        ctx.individuals.push(item.individual_id);
      }
    });
    this.ownersPeriods = periods;

    $.post('/property/owners-info', {
      individualsIds: ctx.individuals,
      corpIds: this.companies
    }, function (data) {
      $.each(ctx.ownersPeriods, function (period, value) {
        value.forEach(function (owner, index, array) {
          if (owner.company_id) {
            ctx.ownersPeriods[period][index].color = 'pink';
            var tempCorp = ctx.getItemById(data.corps, owner.company_id);
            if (!ctx.isExist(ctx.ownersPeriods[period], tempCorp, 'corp')) {
              ctx.ownersPeriods[period][index].company = tempCorp;
            }
          } else {
            ctx.ownersPeriods[period][index].color = 'blue';
            var tempIndividual = ctx.getItemById(data.individual, owner.individual_id);
            if (!ctx.isExist(ctx.ownersPeriods[period], tempIndividual, 'individual')) {
              ctx.ownersPeriods[period][index].individual = tempIndividual;
            }
          }
        });
      });
      console.log(ctx.ownersPeriods);
      ctx.loaded = true;
    });
  },
  methods: {
    isExist: function isExist(data, item, type) {
      var isExist = false;
      data.forEach(function (value, index, array) {
        if (type == 'individual') {
          if (typeof value.individual != 'undefined' && value.individual.first_name == item.first_name && value.individual.last_name == item.last_name) {
            isExist = true;
          }
        } else {
          if (typeof value.company != 'undefined' && value.company.name == item.name) {
            isExist = true;
          }
        }
      });
      return isExist;
    },
    getItemById: function getItemById(data, id) {
      var item;
      data.forEach(function (value, index, array) {
        if (value.id == id) {
          item = value;
        }
      });
      return item;
    }
  }
});
Vue.component('property-owners', PropertyOwners);

var PropertySearch = Vue.extend({
  components: {
    alert: VueStrap.alert,
    modal: VueStrap.modal,
    typeahead: VueStrap.typeahead
  },
  data: function data() {
    return this.initializeData();
  },
  methods: {
    initializeData: function initializeData() {
      var data = {
        ownerSearchTemplate: '<div>{{ item.name }}</div>',
        properties: {},
        paginator: {
          currentPage: 1
        },

        search: {},
        loading: false,
        alertWarning: false,
        totalSelected: 0,
        totalNeighborhoodsText: '',
        currentNeighborhood: '',
        selectedNeighborhood: [],
        neighborhoodsParent: '',
        childrendNeighborhoods: '',
        allNeighborhoods: '',
        mobileNeighborhoods: {},
        isSelectedAll: false,

        saveSearchModal: false,
        neighborhoodsModal: false,

        xhr: null,
        bounds_map: { "south": 49.214863755856875, "west": 3.2169477894531155, "north": 49.66136382782872, "east": 3.6742536976562405 },
        center: {
          lat: 48.8538302,
          lng: 2.2982161
        },
        isCompact: false,
        isMobile: false,
        map_search: null
      };

      var is_compact = Cookies.get('property-search-compact');
      if (typeof is_compact !== 'undefined') {
        if (is_compact == 'false') {
          data['isCompact'] = false;
        } else {
          data['isCompact'] = true;
        }
      }
      if (screen.width <= 768) {
        data['isMobile'] = true;
      }

      return data;
    },
    toggleViewPresentation: function toggleViewPresentation() {
      this.isCompact = !this.isCompact;
      Cookies.set('property-search-compact', this.isCompact.toString());
    },
    addProperty: function addProperty(data) {
      this.$dispatch('open-add-pr-modal', data);
    },
    ownerSearchCallback: function ownerSearchCallback(items, targetVM) {
      var that = targetVM;
      that.reset();
      this.search.owner = items;
      this.filterSearch();
      that.query = items.owner_name;
    },
    filterSearch: function filterSearch() {
      var self = this;
      self.paginator.currentPage = 1;
      self.search.page = 1;
      self.onSearch();
    },
    onSearch: function onSearch() {
      var self = this;

      if (self.xhr != null) {
        self.xhr.abort();
        self.xhr = null;
      }
      self.loading = true;
      self.xhr = $.ajax({
        method: "POST",
        url: "/api/search/properties",
        data: self.search
      }).success(function (resp) {
        self.alertWarning = false;
        self.loading = false;
        self.properties = resp.data;
        self.paginator = resp.paginator;
      }).error(function (resp) {
        self.loading = false;
        if (resp.status == 429) {
          self.alertWarning = true;
          console.log('Too Many Attempts.');
        }
      });
    },
    openSaveSearchModal: function openSaveSearchModal() {
      this.saveSearchModal = true;
    },
    openNeighborhoodsModal: function openNeighborhoodsModal() {
      this.neighborhoodsModal = true;
    },
    selectAll: function selectAll(item) {
      item.checked = !item.checked;
      this.$broadcast('selectAll', {
        isSelectedAll: item.checked,
        parent: item
      });
    },
    saveSelected: function saveSelected() {
      this.selectedNeighborhood = [];
      this.totalSelected = 0;
      this.countChecked(this.allNeighborhoods);
      this.totalNeighborhoodsText = this.totalSelected + ' Neighborhoods';
      this.neighborhoodsModal = false;
      this.search.neighborhoods = this.selectedNeighborhood;
      this.onSearch();
    },
    countChecked: function countChecked(items) {
      var self = this;
      items.forEach(function (item) {
        if (item.checked == true) {
          self.totalSelected++;
          self.selectedNeighborhood.push(item.id);
        }
        if (item.children) {
          self.countChecked(item.children);
        }
      });
    },
    selectNeighborhood: function selectNeighborhood(object) {
      var self = this;
      this.currentNeighborhood = object;
      this.currentNeighborhood.title = this.currentNeighborhood.title.replace('The', '');
      self.isSelectedAll = false;
      self.childrendNeighborhoods = '';
      this.allNeighborhoods.forEach(function (item) {
        item.checked = false;
        if (item.id == object.id) {
          self.childrendNeighborhoods = item.children;
          self.reset(self.childrendNeighborhoods);
          return false;
        }
      });
    },
    reset: function reset(items) {
      var self = this;
      items.forEach(function (item) {
        item.checked = false;
        if (item.children) {
          self.reset(item.children);
        }
      });
    },
    paginationPrev: function paginationPrev() {
      var self = this;
      self.paginator.CurrentPage--;
      self.search.page = self.paginator.CurrentPage;
      self.search.total = self.paginator.Total;
      self.search.per_page = self.paginator.PerPage;
      self.onSearch();
    },
    paginationNext: function paginationNext() {
      var self = this;
      self.paginator.CurrentPage++;
      self.search.page = self.paginator.CurrentPage;
      self.search.total = self.paginator.Total;
      self.search.per_page = self.paginator.PerPage;
      self.onSearch();
    }
  },
  events: {
    toggleItem: function toggleItem(data) {
      this.isSelectedAll = false;
    },
    onSearch: function onSearch() {
      this.filterSearch();
    }
  },
  beforeCompile: function beforeCompile() {
    var self = this;
    $.ajax({
      url: '/api/neighborhood',
      method: 'GET',
      success: function success(resp) {
        self.neighborhoodsParent = resp.data.neighborhoodsParent;
        self.currentNeighborhood = self.neighborhoodsParent[0];

        self.allNeighborhoods = resp.data.childrendNeighborhoods;
        self.mobileNeighborhoods = resp.data.neighborhoods;
        self.childrendNeighborhoods = resp.data.childrendNeighborhoods[0].children;
      },
      error: function error(_error3) {}
    });
  }
});

Vue.component('property-search', PropertySearch);

var RequestAcall = Vue.extend({
  components: {
    modal: VueStrap.modal
  },
  compiled: function compiled() {},
  props: ['showRequestModal'],
  data: function data() {
    return {
      loading: false,
      success: false,
      error: false,
      response: null,
      showModal: false,
      formData: {
        email: "",
        first_name: '',
        last_name: '',
        company_name: '',
        phone: '',
        phone_ext: '',
        role: ''
      }
    };
  },
  methods: {
    requestacall: function requestacall(event) {
      event.preventDefault();
      this.request(this, this.formData);
    },
    request: function request(context, formData) {
      var ctx = this;
      ctx.loading = true;
      $.post('/request_a_call', {
        company_name: formData.company_name,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        phone_ext: formData.phone_ext,
        role: formData.role
      }, function (data) {
        ctx.success = true;
        ctx.loading = false;
      }).fail(function (data) {
        ctx.response = data.responseJSON;
        ctx.loading = false;
        ctx.error = true;
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    }
  },
  events: {
    'set-request-call-modal': function setRequestCallModal(data) {
      this.showModal = data;
    }
  },
  watch: {
    'showRequestModal': function showRequestModal(val, oldVal) {
      this.showModal = true;
    }
  }
});
Vue.component('requestacall', RequestAcall);
var RightSidebar = Vue.extend({
  template: "#rightSidebar",
  data: function data() {
    return {
      showSidebar: true,
      articles: [],
      loading: false
    };
  },
  props: ['active'],
  created: function created() {
    this.showSidebar = this.active;
  },
  ready: function ready() {},
  beforeCompile: function beforeCompile() {
    var self = this;
    self.loading = true, $.ajax({
      url: '/dashboard/articles/8',
      method: 'GET',
      success: function success(resp) {
        self.loading = false, self.articles = resp;
      },
      error: function error(_error4) {}
    });
  },
  watch: {
    'active': function active(val, oldval) {
      this.showSidebar = val;
      if (val == true) {
        $('body').addClass('control-sidebar-open');

        /*    document.getElementById('rightSudebarAside').style.marginRight = '100px';
            document.getElementById('rightSudebarAside').style.transition = '4s all';*/
        // if($('.search-result-box').length>0){
        //     var search_result_box_width = $('.search-result-box').width();
        //     $('.search-result-box').removeClass('extra-narrow');
        //     $('.search-result-box').removeClass('like-mobile');
        //     $('.search-result-box').removeClass('narrow');
        //     $('.search-result-box').removeClass('w-300');
        //     $('.search-result-box').removeClass('w-480');
        //     if($(window).width() > 767){
        //         if(search_result_box_width<300){
        //             $('.search-result-box').addClass('w-300');
        //         } else if(search_result_box_width<480){
        //             $('.search-result-box').addClass('w-480');
        //         }
        //         if(search_result_box_width<500){
        //             $('.search-result-box').addClass('like-mobile');
        //         } else if(search_result_box_width<600){
        //             $('.search-result-box').addClass('extra-narrow');
        //         } else if(search_result_box_width<800){
        //             $('.search-result-box').addClass('narrow');
        //         }
        //     }
        // }
        // console.log($('.content-wrapper').length);
        //
        // if($('.content-wrapper').length>0){
        //     var $wrapper = $('.content-wrapper');
        //     if($wrapper.hasClass('property-wrapper')){
        //         var content_wrapper_width = $wrapper.children('.property').width();
        //     } else {
        //         var content_wrapper_width = $wrapper.width();
        //     }
        //     $wrapper.removeClass('w-less-850');
        //     $wrapper.removeClass('w-less-800');
        //     $wrapper.removeClass('w-less-700');
        //     $wrapper.removeClass('w-less-600');
        //     $wrapper.removeClass('w-less-500');
        //     $wrapper.removeClass('w-less-400');
        //     $wrapper.removeClass('w-less-300');
        //     if($(window).width() > 767){
        //         if(content_wrapper_width<300){
        //             $wrapper.addClass('w-less-300');
        //         }
        //         if(content_wrapper_width<400){
        //             $wrapper.addClass('w-less-400');
        //         }
        //         if(content_wrapper_width<500){
        //             $wrapper.addClass('w-less-500');
        //         }
        //         if(content_wrapper_width<600){
        //             $wrapper.addClass('w-less-600');
        //         }
        //         if(content_wrapper_width<700){
        //             $wrapper.addClass('w-less-700');
        //         }
        //         if(content_wrapper_width<800){
        //             $wrapper.addClass('w-less-800');
        //         }
        //         if(content_wrapper_width<850){
        //             $wrapper.addClass('w-less-850');
        //         }
        //     }
        // }

      } else {
        $('body').removeClass('control-sidebar-open');

        /* document.getElementById('rightSudebarAside').style.marginRight = '-623px';
         document.getElementById('rightSudebarAside').style.transition = '4s all';*/
      }
    }
  }

});
Vue.component("right-sidebar", RightSidebar);

var SignUp = Vue.extend({
  components: {
    modal: VueStrap.modal
  },
  props: ['showModalParam', 'show', 'reqStage'],
  data: function data() {
    return {
      card: false,
      stage: 'registration',
      success: false,
      error: false,
      loading: false,
      response: [],
      user: {
        first_name: '',
        email: '',
        password: '',
        last_name: '',
        phone_number: ''
      },
      showModal: false
    };
  },
  watch: {
    'showModalParam': function showModalParam(val, oldval) {
      this.showModal = val;
    }
  },
  ready: function ready() {
    this.stage = this.reqStage;
    if (this.show) {
      this.openModal();
    }
  },
  methods: {
    openModal: function openModal() {
      this.showModal = !this.showModal;
    },
    register: function register(event) {
      event.preventDefault();
      var context = this;
      context.loading = true;
      this.$http.post('/registration/store-info', {
        first_name: context.user.first_name,
        last_name: context.user.last_name,
        phone_number: context.user.phone_number,
        email: context.user.email,
        password: context.user.password
      }).then(function (response) {
        context.loading = false;
        context.stage = 'subscription';
      }, function (response) {
        context.response = response.data;
        context.error = true;
        context.loading = false;
      });
    },
    closeModal: function closeModal() {
      this.showModal = false;
    }
  },
  events: {
    'set-signup-modal': function setSignupModal(data) {
      this.showModal = data;
    }
  }
});

Vue.component('signup', SignUp);
var SignUpRoles = Vue.extend({
  components: {},
  data: function data() {
    return {
      'agentBroker': false,
      'financer': false,
      'propManager': false,
      'analystResearch': false,
      'investor': false,
      'owner': false,
      'attorney': false,
      'insurance': false,
      'vendor': false
    };
  },

  ready: function ready() {
    this.agentBroker = Cookies.get('agentBroker') === 'true';
    this.financer = Cookies.get('financer') === 'true';
    this.propManager = Cookies.get('propManager') === 'true';
    this.analystResearch = Cookies.get('analystResearch') === 'true';
    this.investor = Cookies.get('investor') === 'true';
    this.owner = Cookies.get('owner') === 'true';
    this.attorney = Cookies.get('attorney') === 'true';
    this.insurance = Cookies.get('insurance') === 'true';
    this.vendor = Cookies.get('vendor') === 'true';
  },
  methods: {},
  watch: {
    agentBroker: function agentBroker() {
      Cookies.set('agentBroker', this.agentBroker);
    },
    financer: function financer() {
      Cookies.set('financer', this.financer);
    },
    propManager: function propManager() {
      Cookies.set('propManager', this.propManager);
    },
    analystResearch: function analystResearch() {
      Cookies.set('analystResearch', this.analystResearch);
    },
    investor: function investor() {
      Cookies.set('investor', this.investor);
    },
    owner: function owner() {
      Cookies.set('owner', this.owner);
    },
    attorney: function attorney() {
      Cookies.set('attorney', this.attorney);
    },
    insurance: function insurance() {
      Cookies.set('insurance', this.insurance);
    },
    vendor: function vendor() {
      Cookies.set('vendor', this.vendor);
    }
  }
});
Vue.component('sign-up-roles', SignUpRoles);

var SingleArticle = Vue.extend({
  components: {},
  data: function data() {
    return {
      articleBody: "",
      showMoreBool: true
    };
  },
  ready: function ready() {
    this.articleBody = $(".article_content_hide").text();
  },
  methods: {
    showMore: function showMore() {
      $(".article_content").html(this.articleBody);
      this.showMoreBool = false;
    }
  }

});

Vue.component('single-article', SingleArticle);
var Slick = Vue.extend({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  ready: function ready() {
    var $slick = $(this.$el);

    $slick.on('afterChange', this.afterChange);
    $slick.on('beforeChange', this.beforeChange);

    $slick.slick(this.options);
  },
  methods: {
    goTo: function goTo(index, dontAnimate) {
      $(this.$el).slick('slickGoTo', index, dontAnimate);
    },

    // Events
    afterChange: function afterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },
    beforeChange: function beforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    }
  }
});
Vue.component('slick', Slick);

var BarChart = _vueChartjs2.default.Bar.extend({
  ready: function ready() {
    this.render({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [{
        // label: 'Label',
        backgroundColor: '#DD1B16',
        data: [3, 5, 1, 4, 4, null, null, null, null, null, null, null]
      }]
    }, {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          ticks: {
            stepSize: 1
          }
        }],
        xAxes: [{
          barPercentage: 0.8
        }]
      }
    });
  }
});

var PieChart = _vueChartjs2.default.Pie.extend({
  ready: function ready() {
    this.render({
      labels: ['Full Apartments', 'Partial / Rooms', 'Duplicate Listings'],
      datasets: [{
        backgroundColor: ['#DD1B16', '#00D8FF', '#999999'],
        data: [40, 20, 80]
      }]
    }, {
      legend: {
        display: true,
        position: 'bottom'
      }
    });
  }
});

var Subletspy = Vue.extend({
  components: {
    vuetable: _Vuetable2.default,
    modal: VueStrap.modal,
    barchart: BarChart,
    piechart: PieChart
  },
  data: function data() {
    return {
      lastMonthStatUrl: '/api/subletspy/last_month',
      lastYearStatUrl: '/api/subletspy/last_year',
      columns: [{
        name: 'address',
        title: 'Address',
        sortField: 'address'
      }, {
        name: 'count_by_zip',
        title: 'New by zip',
        sortField: 'count_by_zip'
      }, {
        name: 'count_by_radius',
        title: 'New by radius',
        sortField: 'count_by_radius'
      },
      // {
      //     name: 'middle_name',
      //     title: '% increase',
      //     sortField: 'middle_name'
      // },
      {
        name: 'count_reviewed',
        title: 'Reviewed',
        sortField: 'count_reviewed'
      }, {
        name: 'count_possible_match',
        title: 'Possible',
        sortField: 'count_possible_match'
      }, {
        name: 'count_match',
        title: 'Match',
        sortField: 'count_match'
      }, {
        name: 'count_rs_match',
        title: 'RS Match',
        sortField: 'count_rs_match'
      }],
      sortOrder: [{
        field: 'address',
        direction: 'asc'
      }]
    };
  },
  props: [
    //
  ],
  ready: function ready() {
    _.delay(this.fetchDevices, 500);
  },
  methods: {
    fetchDevices: function fetchDevices() {
      //
    }
  },
  events: {
    'vuetable:action': function vuetableAction(action, data) {
      console.log('vuetable:action', action, data);
    },
    'vuetable:load-error': function vuetableLoadError(response) {
      console.log('Load Error: ', response);
    }
  }
});
Vue.component('subletspy', Subletspy);

Vue.component('device-helper', _DeviceHelper2.default);

var Tenants = Vue.extend({
  components: {
    vuetable: _Vuetable2.default,
    modal: VueStrap.modal,
    FileSelector: _FileSelector2.default
  },
  data: function data() {
    return {
      devices: null,
      buildings: null,
      tenants: null,
      loading: false,
      addDeviceModal: false,
      addBuildingModal: false,
      deviceForm: {
        bbl: ''
      },
      buildingForm: {
        name: ''
      },
      assignDeviceModal: false,
      assignDeviceForm: {
        tenantId: null,
        currentIds: [],
        deviceIds: [],
        devicePins: []
      },
      devicePinsForm: null,
      importTenantsModal: false,
      importTenantsForm: {
        file: null
      },

      ggApiUrl: PPDATA.gateguardApiUrl + "/users/" + PPDATA.currentUserData.id,
      tenantsApiUrl: PPDATA.gateguardApiUrl + "/users/" + PPDATA.currentUserData.id + "/tenants",
      tenantsApiUrlParams: ["email=" + PPDATA.currentUserData.email],

      tenantsColumns: [{
        name: 'id',
        title: 'ID',
        sortField: 'id'
      }, {
        name: 'first_name',
        title: 'First name',
        sortField: 'first_name'
      }, {
        name: 'middle_name',
        title: 'Middle name',
        sortField: 'middle_name'
      }, {
        name: 'last_name',
        title: 'Last name',
        sortField: 'last_name'
      }, {
        name: 'login_id',
        title: 'Login ID',
        sortField: 'login_id'
      }, {
        name: '__component:device-helper',
        title: 'Devices'
      }, '__actions'],
      sortOrder: [{
        field: 'id',
        direction: 'asc'
      }],
      tenantsItemActions: [{ name: 'delete-tenant', title: 'Delete tenant', icon: 'fa fa-times', class: 'e-tbl-btn' }, { name: 'edit-tenant', title: 'Edit tenant', icon: 'fa fa-wrench', class: 'e-tbl-btn' }, { name: 'settings-tenant', title: 'Setting for this tenant', icon: 'fa fa-cog', class: 'e-tbl-btn' }]
    };
  },
  props: ['userId', 'tenantsBaseUrl'],
  ready: function ready() {
    _.delay(this.fetchDevices, 500);
    //_.delay(this.fetchBuildings, 500)
  },
  computed: {
    devicePinsObserver: function devicePinsObserver() {
      var _this15 = this;

      var tenantId = this.assignDeviceForm.tenantId;
      var devices = this.devices;

      if (tenantId && devices) {
        devices.forEach(function (o) {
          var item = _.find(_this15.assignDeviceForm.pinCodes, { device_id: o.id });
          if (item) {
            _this15.devicePinsForm[+o.id]['pin'] = _.clone(item.value);
          } else {
            _this15.devicePinsForm[+o.id]['pin'] = null;
          }
        });
      }

      return Date.now();
    }
  },
  watch: {
    'devicePinsObserver': function devicePinsObserver(val, old) {
      //
    }
  },
  methods: {
    // fetchData() {
    //     let ppUserId = this.userId;
    //     this.loading = true;
    //     this.$http.get(`${this.ggApiUrl}/tenants`, {params: {email: PPDATA.currentUserData.email}})
    //         .then(response => {
    //             let o = response.json()
    //             this.tenants = o.data
    //             this.loading = false
    //         }, response => {
    //             this.loading = false
    //         });
    // },
    generatePIN: function generatePIN(deviceId) {
      var pin = '';
      for (var i = 0; i < 4; i++) {
        pin += Math.floor(Math.random() * 9 + 1);
      }
      this.devicePinsForm[deviceId].pin = pin;
    },
    fetchDevices: function fetchDevices() {
      var _this16 = this;

      this.$http.get(this.ggApiUrl + "/owned-devices").then(function (response) {
        var o = response.data;
        _this16.devices = o.data;
        _this16.devicePinsForm = _.chain(o.data).keyBy('id').mapValues(function (o) {
          return { pin: null };
        }).value();
      }, function (response) {
        //
      });
    },
    fetchBuildings: function fetchBuildings() {
      var _this17 = this;

      this.$http.get('/dashboard/tenants/buildings').then(function (response) {
        var o = response.data;
        _this17.buildings = o;
      }, function (response) {
        //
      });
    },
    saveDeviceTrigger: function saveDeviceTrigger(e) {
      var _this18 = this;

      this.$validate(true, function () {
        if (_this18.$deviceFormValidator.invalid) {
          e.preventDefault();
        } else {
          _this18.saveDevice();
        }
      });
    },
    saveBuildingTrigger: function saveBuildingTrigger(e) {
      var _this19 = this;

      this.$validate(true, function () {
        if (_this19.$buildingFormValidator.invalid) {
          e.preventDefault();
        } else {
          _this19.saveBuilding();
        }
      });
    },
    saveBuilding: function saveBuilding() {
      var _this20 = this;

      this.$http.post('/dashboard/tenants/add-building', this.buildingForm).then(function (response) {
        _this20.fetchBuildings();
        _this20.addBuildingModal = false;
      }, function (response) {
        //
      });
    },
    saveDevice: function saveDevice() {
      var _this21 = this;

      this.$http.post(this.ggApiUrl + "/devices", this.deviceForm).then(function (response) {
        _this21.fetchDevices();
        _this21.addDeviceModal = false;
      }, function (response) {
        //
      });
    },
    removeDevice: function removeDevice(id) {
      var _this22 = this;

      swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      }, function () {
        _this22.$http.delete(_this22.ggApiUrl + "/devices/" + id).then(function (response) {
          swal("Deleted!", null, "success");
          _this22.fetchDevices();
        }, function (response) {
          //
        });
      });
    },
    assignDeviceTrigger: function assignDeviceTrigger(e) {
      this.assignDevice();
    },
    assignDevice: function assignDevice() {
      var _this23 = this;

      var tenantId = this.assignDeviceForm.tenantId;
      var currentIds = this.assignDeviceForm.currentIds;
      var deviceIds = this.assignDeviceForm.deviceIds;
      var data = {
        devices: deviceIds,
        pincodes: this.devicePinsForm
      };

      this.$http.post(this.ggApiUrl + "/tenants/" + tenantId + "/roles/tenant", data).then(function (response) {
        _this23.$broadcast('vuetable:refresh');
        _this23.assignDeviceModal = false;
      }, function (response) {
        //
      });
    },

    formatDate: function formatDate(value, fmt) {
      if (value == null) return '';
      fmt = typeof fmt == 'undefined' ? 'D MMM YYYY' : fmt;
      return moment(value, 'YYYY-MM-DD').format(fmt);
    },
    makeDevicesSpot: function makeDevicesSpot(data, a, s, d) {
      var output = [];
      console.log('OPANA', data, a, s, d);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          output.push('<span class="label label-info e-label"><strong>ID' + item.id + '</strong> - ' + item.hash + '</span>');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return output.length ? output.join('<br>') : '<span class="text-muted">&mdash;</span>';
    },
    editTenant: function editTenant(id) {
      window.location.href = this.tenantsBaseUrl + "/edit/" + id;
    },
    deleteTenant: function deleteTenant(id) {
      var _this24 = this;

      swal({
        title: "Are you sure?",
        // text: "Your will not be able to recover this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      }, function () {
        _this24.loading = true;
        _this24.$http.delete(_this24.ggApiUrl + "/tenants/" + id).then(function (response) {
          swal("Deleted!", null, "success");
          _this24.$broadcast('vuetable:refresh');
          _this24.loading = false;
        }, function (response) {
          _this24.loading = false;
        });
      });
    },
    importTrigger: function importTrigger() {
      var _this25 = this;

      console.log('import', this.importTenantsForm);
      var formData = (0, _ToFD2.default)(this.importTenantsForm);
      this.$http.post(this.ggApiUrl + "/import", formData).then(function (response) {
        var data = response.data;
        var insertedCount = data.data.insertedCount;

        _this25.importTenantsModal = false;
        _this25.$broadcast('vuetable:refresh');
        _this25.fetchDevices();
        if (insertedCount) {
          swal("Tenants was imported successfully (" + insertedCount + " rows)", null, 'success');
        } else {
          swal('No one tenant was imported', null, 'warning');
        }
      }, function (response) {
        _this25.importTenantsModal = false;
        swal('Some error occurred!', null, 'error');
      });
    }
  },
  events: {
    'vuetable:action': function vuetableAction(action, data) {
      console.log('vuetable:action', action, data);
      if (action == 'edit-tenant') {
        this.editTenant(data.id);
      } else if (action == 'delete-tenant') {
        this.deleteTenant(data.id);
      } else if (action == 'settings-tenant') {
        this.assignDeviceForm.tenantId = data.id;
        this.assignDeviceForm.currentIds = _.map(data.devices, 'id');
        this.assignDeviceForm.deviceIds = _.map(data.devices, 'id');
        this.assignDeviceForm.pinCodes = data.pins;

        this.assignDeviceModal = true;
      }
    },
    'vuetable:load-error': function vuetableLoadError(response) {
      console.log('Load Error: ', response);
    }
  }
});
Vue.component('tenants', Tenants);

/* eslint-disable */

var TenantsLog = Vue.extend({
  components: {
    vuetable: _Vuetable2.default
  },
  data: function data() {
    return {
      from: '',
      to: '',
      buildingId: '',
      unit: '',
      userId: '',
      actions: {},
      users: {},
      units: [],
      filterShow: false
    };
  },
  props: ['from', 'to', 'buildingId', 'actions', 'unit', 'userId'],
  ready: function ready() {
    var ctx = this;
    this.setPageTitle('GateGuard Logs');
    window.datatable = $('#logs').DataTable({
      stateSave: false,
      dom: '<"toolbar">frtip',
      processing: true,
      serverSide: true,
      autoWidth: false,
      pageLength: 50,
      order: [[15, "desc"]],
      ajax: '/dashboard/gateguard/logs' + (location.search != '' ? location.search : ''),
      columns: [{ data: 'check', name: 'check', orderable: false, searchable: false }, { data: 'session_id', name: 'session_id', orderable: true, searchable: true }, { data: 'share', name: 'share', orderable: false, searchable: false }, { data: 'building_name', name: 'building_name', orderable: true, searchable: true }, { data: 'unit', name: 'unit', orderable: true, searchable: true }, { data: 'user_first_name', name: 'user_first_name', orderable: true, searchable: true }, { data: 'user_last_name', name: 'user_last_name', orderable: true, searchable: true }, { data: 'user_stats', name: 'user_stats', orderable: false, searchable: false }, { data: 'activity_type', name: 'activity_type', orderable: true, searchable: true }, { data: 'activity_sub_type', name: 'activity_sub_type', orderable: true, searchable: true }, { data: 'visitor_name', name: 'visitor_name', orderable: true, searchable: true }, { data: 'timestamp_nyc', name: 'timestamp_nyc', orderData: 15 }, { data: 'status', name: 'status', orderable: true, searchable: true }, { data: 'not_tenant', name: 'not_tenant', orderable: false, searchable: false }, { data: 'photo', name: 'photo', orderable: true, searchable: true }, { data: 'timestamp', name: 'timestamp', visible: false }, { data: 'input', name: 'input', visible: true, searchable: true }],
      "drawCallback": function drawCallback(settings) {
        var currentSessionId = null;
        var currentClass = 'even';
        $.each($('#logs tbody').find('tr'), function (key, val) {
          var sessionId = $(val).find('.hl').eq(0).data('session-id');
          console.log(sessionId);
          $(val).removeClass('odd even');

          if (sessionId == 'server_log') {
            $(val).removeClass('odd even');
            $(val).css("background", 'rgba(0, 0, 0, 0.05)');
          } else if (currentSessionId != sessionId) {
            $(val).addClass(currentClass == 'even' ? 'odd' : 'even');
            currentClass = currentClass == 'even' ? 'odd' : 'even';
          } else {
            $(val).addClass(currentClass);
          }
          if (sessionId != 'server_log') {
            currentSessionId = sessionId;
          }
        });
      }
    });
    //$("div.toolbar").html('<button class="btn btn-info">GeneratePDF</button> <button class="btn btn-info">Output CSV</button>');

    $("div.toolbar").html('');

    $('#logs').on("click", ".mgf", function (e) {
      e.preventDefault();
      $(this).magnificPopup({
        type: 'image'
      }).magnificPopup('open');
    });
    $('#logs').on("click", ".hl", function (e) {
      e.preventDefault();
      var sId = $(this).data('session-id');
      $("tr:contains('" + sId + "')").css("background", '#' + ('000000' + Math.floor(Math.random() * 16777215).toString(16)).slice(-6) + '26');
    });

    $('#building_id_select').select2().on('change', function () {
      ctx.buildingId = $(this).val();
      ctx.changeBuilding();
    });

    $('#logs').on('click', '.report-btn', function (e) {
      e.preventDefault();
      var rowId = $(this).attr('data-row-id');
      $(this).text('Processing...');
      ctx.reportNonTenant(rowId);
    });

    $('#logs').on('click', '.filter-by-user', function (e) {
      e.preventDefault();
      var userId = $(this).attr('data-user-id');
      ctx.userId = userId;
      ctx.showOnlyUser();
    });

    if (window.location.href.indexOf("robust") > -1) {
      $('#robust-mode').prop('checked', true);
    }

    this.fetchUsers();
  },
  computed: {},
  watch: {},
  methods: {
    toggleFilter: function toggleFilter() {
      var ctx = this;
      this.filterShow = !this.filterShow;
      this.$nextTick(function () {
        $('#building_id_select').off();
        $('#building_id_select').select2().on('change', function () {
          ctx.buildingId = $(this).val();
          ctx.changeBuilding();
        });
      });
    },
    getPdf: function getPdf() {
      swal("Processing... \n I will notify you soon.");

      this.$http.post("/dashboard/gateguard/logs/request-pdf-log", {
        from: this.from,
        to: this.to,
        building_id: this.buildingId,
        unit: this.unit,
        user_id: this.userId,
        actions: this.actions
      }).then(function (response) {}, function (response) {});
    },
    pushFilterState: function pushFilterState() {
      var baseUrl = '/dashboard/gateguard/logs';
      window.history.pushState({}, "Logs", '?' + $('#filter').serialize());
      window.datatable.ajax.url(baseUrl + (location.search != '' ? location.search : '')).load();
    },
    changeFilterItem: function changeFilterItem() {
      this.pushFilterState();
    },
    showOnlyUser: function showOnlyUser() {
      var baseUrl = '/dashboard/gateguard/logs';
      window.history.pushState({}, "Logs", '?' + $('#filter').serialize() + '&user_id=' + this.userId);
      window.datatable.ajax.url(baseUrl + (location.search != '' ? location.search : '')).load();
    },
    changeBuilding: function changeBuilding() {
      var ctx = this;
      this.unit = '-';
      this.userId = '-';

      setTimeout(function () {
        ctx.pushFilterState();
        ctx.fetchUsers();
      }, 500);
    },
    fetchUsers: function fetchUsers() {
      var _this26 = this;

      var ctx = this;

      this.users = [];
      this.units = [];
      this.$http.get("/dashboard/gateguard/logs/tenants-by-building/" + this.buildingId).then(function (response) {
        var o = response.data;
        var data = o.data;
        _this26.users = o.users;
        _this26.units = o.units;

        $('#user_id_select').select2().on('change', function () {
          ctx.userId = $(self.el).val();
          ctx.changeFilterItem();
        });
      }, function (response) {});
    },
    setPageTitle: function setPageTitle(prepend_text) {
      document.title = prepend_text + '|' + window.PPDATA.globalPageTitle;
    },
    reportNonTenant: function reportNonTenant(entry_id) {
      this.$http.post("/dashboard/gateguard/logs/report/" + entry_id, {
        issue: 'not_tenant'
      }).then(function (response) {
        window.datatable.ajax.reload();
      }, function (response) {});
    }
  },
  events: {
    onSearch: function onSearch() {
      this.from = $('#from_select').val();
      this.to = $('#to_select').val();
      this.changeFilterItem();
    }
  }
});
Vue.component('tenants-log', TenantsLog);
var Welcome = Vue.extend({
  data: function data() {
    return {
      landingSliderOptions: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'cubic-bezier(.65, 0, .15, 1)',
        autoplay: true,
        autoplaySpeed: 6000
      },
      currentSlide: 0
    };
  },
  ready: function ready() {
    var _this27 = this;

    this.$refs['landingSlider'] && this.$refs['landingSlider'].$on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      _this27.currentSlide = nextSlide || 0;
    });
  },
  methods: {
    showSignUpModalFn: function showSignUpModalFn() {
      if ($('body').attr('id').trim() == 'auth') {
        window.location = '/login';
      } else {
        this.$broadcast('set-signup-modal', true);
      }
    },
    showRequestCallModalFn: function showRequestCallModalFn() {
      this.$broadcast('set-request-call-modal', true);
    },
    ppSumm: function ppSumm(buildings, users) {
      return 9.99 * users * 12;
    },
    reonomySumm: function reonomySumm(buildings, users) {
      return 7188 * users;
    },
    propertySharkSumm: function propertySharkSumm(buildings, users) {
      return 959 * users;
    },
    SiteCompliSumm: function SiteCompliSumm(buildings, users) {
      return 60 * 12 * buildings;
    },
    getYouSave: function getYouSave(buildings, users) {
      return this.reonomySumm(buildings, users) + this.propertySharkSumm(buildings, users) + this.SiteCompliSumm(buildings, users) - this.ppSumm(buildings, users);
    },
    setSlide: function setSlide(slideId) {
      var slider = this.$refs['landingSlider'];
      slider.goTo(slideId || 0);
    },
    isCurrentSlide: function isCurrentSlide(slideId) {
      return this.currentSlide == slideId;
    }
  }
});
Vue.component('welcome', Welcome);
//import Vuetable from '../vue/vueify/components/ui/vuetable/Vuetable.vue';


// GateGuard Components

//import Logs from '../vue/gateguard/Logs.vue';


Vue.component('v-select', _vueSelect2.default);
Vue.component('vuetable', _Vuetable2.default);
Vue.component('vuetable-pagination', _VuetablePagination2.default);
Vue.component('vuetable-pagination-dropdown', _VuetablePaginationDropdown2.default);

Vue.use(_vueRouter2.default);

Vue.mixin({
  methods: {
    setPageTitle: function setPageTitle(prepend_text) {
      document.title = prepend_text + '|' + window.PPDATA.globalPageTitle;
    }
  }
});

var router = new _vueRouter2.default({
  history: true,
  root: '/dashboard/gateguard'
});

router.map({
  '/portfolios': {
    component: _Portfolios2.default
  },
  '/tenants': {
    component: _TenantsPage2.default
  },
  '/buildings': {
    component: _Buildings2.default
  },
  '/visitors': {
    component: _Visitors2.default
  },
  '/announcements': {
    component: _Announcements2.default
  },
  '/calls': {
    component: _Calls2.default
  }
  /* '/logs': {
     component: Logs
   },*/
});

// Register email validator function.
Vue.validator('email', function (val) {
  if (!val) return true;
  return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
  );
});

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  }
  return size.toString() + ' B';
});

Object.defineProperty(Vue.prototype, "$bus", {
  get: function get() {
    return this.$root.bus;
  }
});

var App = Vue.extend({

  components: {
    AddTenantModal: _AddTenantModal2.default,
    AddVisitorModal: _AddVisitorModal2.default,
    AddAnnounceModal: _AddAnnounceModal2.default,
    AssignBuildingModal: _AssignBuildingModal2.default,
    AddPortfolioModal: _AddPortfolioModal2.default,
    AddBuildingModal: _AddBuildingModal2.default,
    DeviceSettings: _DeviceSettings2.default,
    typeahead: VueStrap.typeahead,
    ButtonGroup: VueStrap.buttonGroup,
    avatar: Avatar.Avatar
  },
  data: function data() {
    return {
      bus: new Vue({}),
      currentDialogs: [],
      ShowRightSidebar: false,
      sidebarPermanentShows: ['/dashboard']
    };
  },
  ready: function ready() {
    if (typeof socket !== 'undefined') {
      this.initializeTypeahead();
    }

    if (!/Mobi/.test(navigator.userAgent) && this.sidebarPermanentShows.indexOf(window.location.pathname) != -1) {
      this.ShowRightSidebar = true;
    } else {
      this.ShowRightSidebar = false;
    }
  },
  created: function created() {
    var ctx = this;
    if (typeof socket !== 'undefined') {
      socket.on('connect', function (data) {
        socket.emit('subscribe', { channel: 'chat.room' });
      });
      socket.emit('join', { room: 'inbox-' + currentUser });

      socket.on('chat.room', function (data) {

        var result = $.grep(ctx.currentDialogs, function (e) {
          return e == data.chat_id;
        });

        if (result.length) {
          ctx.$broadcast('push-new_msg', data);
        } else {
          toastr.options.onclick = function () {
            window.location = "/dashboard/messages/" + data.chat_hash;
          };
          toastr["info"](data.sender.first_name + ' ' + data.sender.last_name + ' sent you message!');
        }
      });
    }
  },
  compiled: function compiled() {
    var ctx = this;
    var chatIds = Cookies.getJSON('dialogs');

    if (typeof chatIds !== 'undefined' && chatIds.length) {
      $.get('/dashboard/chat/load-chats/' + chatIds.join(), function (data) {
        $.each(data, function (key, value) {
          ctx.$broadcast('push-minimize-dialog', value);
        });
      });
    }
  },
  methods: {
    goToTenantsPage: function goToTenantsPage() {
      if (window.location.pathname == '/dashboard/gateguard/tenants') {
        this.$router.go('/tenants');
        this.$bus.$emit('reset-tenants-table', true);
      }
    },
    showRightSideBarFn: function showRightSideBarFn() {
      this.ShowRightSidebar = !this.ShowRightSidebar;
    },
    showJoinUs: function showJoinUs() {
      this.$broadcast('open-join-us-modal');
    },
    addProperty: function addProperty(data) {
      this.$broadcast('open-add-pr-modal', data);
    },
    addTenant: function addTenant() {
      this.$bus.$emit('add-tenant-modal-set-state', true, {});
    },
    initializeTypeahead: function initializeTypeahead() {
      $(document).ready(function () {

        function number_format(number, decimals, decPoint, thousandsSep) {
          number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
          var n = !isFinite(+number) ? 0 : +number;
          var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
          var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
          var dec = typeof decPoint === 'undefined' ? '.' : decPoint;

          var s = '';

          var toFixedFix = function toFixedFix(n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k).toFixed(prec);
          };

          s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
          if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
          }

          if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
          }

          return s.join(dec);
        }

        function getBloodhoundSettings(type) {

          var remote = {
            url: '/api/search',
            prepare: function prepare(query, settings) {
              settings.type = 'GET';
              settings.contentType = 'application/json; charset=UTF-8';
              settings.data = {
                'query': query,
                'type': type
              };

              return settings;
            }
          };

          var settings = {
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            identify: function identify(datum) {
              return datum.id;
            },

            sufficient: 1
          };

          if (type == 'search') {

            settings.datumTokenizer = Bloodhound.tokenizers.obj.whitespace('query');
            settings.prefetch = {
              url: '/api/recent-searches',
              cache: false,
              cacheKey: 'recentsearches',
              prepare: function prepare(settings) {
                settings.type = 'GET';
                settings.contentType = 'application/json; charset=UTF-8';

                return settings;
              }
            };

            return localforage.getItem('recent_search_query').then(function (recent_search_query) {
              if (recent_search_query) {
                settings.prefetch.prepare = function (settings) {
                  settings.type = 'GET';
                  settings.contentType = 'application/json; charset=UTF-8';
                  settings.data = {
                    'new_query': recent_search_query
                  };

                  return settings;
                };

                localforage.removeItem('recent_search_query').then(function () {}).catch(function (err) {});
              }

              return settings;
            }).catch(function (err) {
              console.log(err);
            });
          } else {
            settings.remote = remote;
          }

          return settings;
        }

        var searchBHSettings = getBloodhoundSettings('search');
        var isPromise = typeof searchBHSettings.then == 'function';
        if (isPromise) {
          searchBHSettings.then(function (searchConfig) {
            createTypeahead(searchConfig);
          });
        } else {
          createTypeahead(searchBHSettings);
        }

        function createTypeahead(searchBHSettings) {
          var search = new Bloodhound(searchBHSettings);

          var individualsBHSettings = getBloodhoundSettings('individuals');
          var individuals = new Bloodhound(individualsBHSettings);

          var organizationsBHSettings = getBloodhoundSettings('organizations');
          var organizations = new Bloodhound(organizationsBHSettings);

          var bblBHSettings = getBloodhoundSettings('bbl');
          var bbl = new Bloodhound(bblBHSettings);

          function searchWithDefaults(query, syncCallback, asyncCallback) {
            if (query === '') {
              var allPrefetch = search.all();
              console.log(allPrefetch);
              if (allPrefetch.length > 0) {
                if (allPrefetch.length > 3) {
                  allPrefetch = allPrefetch.slice(0, 3);
                }

                var ids = [];
                for (var i in allPrefetch) {
                  ids.push(allPrefetch[i].id);
                }

                syncCallback(search.get(ids));
              }
            } else {
              search.search(query, syncCallback, asyncCallback);
            }
          }

          var original_query = '';
          var typeaheadInput = $('header input[type=search]').typeahead({
            hint: true,
            highlight: true,
            minLength: 0
          }, {
            name: 'search',
            source: searchWithDefaults,
            limit: 3,
            templates: {
              header: '<h4 class="suggestion-header clearfix">Recent Searches</h4>',
              suggestion: function suggestion(datum) {
                if (datum) {
                  return '<div id="popular-search-id-' + datum.id + '" class="clearfix"><span><span class="popular-search-icon glyphicon glyphicon-search"></span> ' + datum.query + '<span class="meta-info"></span></span></div>';
                }
              }
            },
            display: function display(suggestion) {
              return suggestion.query;
            }
          }, {
            name: 'search-bbl',
            source: bbl,
            limit: 3,
            templates: {
              header: '<h4 class="suggestion-header clearfix">Properties</h4>',
              suggestion: function suggestion(datum) {
                console.log(datum);
                return '<div id="property-search-id-' + datum.id + '" class="clearfix"><span>' + datum.address + '<br>' + '<span class="meta-info"><a href="' + datum.url + '/ownership">Ownership</a> | <a href="' + datum.url + '/violations">Compliance</a> | <a href="' + datum.url + '/debt">Debt</a></span></span></div>';
              }
            },
            display: function display(suggestion) {
              return suggestion.address;
            } /*, {
                 name: 'search-individuals',
                 source: individuals,
                 limit: 3,
                 templates: {
                     header: '<h4 class="suggestion-header clearfix">Individuals</h4>',
                     suggestion: function(datum) {
                         var img = '';
                         if (datum.image) {
                             img = '<img class="meta-img" src="' + datum.image + '">';
                         }
                          var description = '';
                         if (datum.organization) {
                             description = datum.organization;
                         }
                          return '<div id="individual-search-id-' + datum.id + '" class="clearfix"><span>' + img + datum.name + '<br><span class="meta-info">' + description + '</span></span></div>';
                     }
                 },
                 display: function(suggestion) {
                     return suggestion.name;
                 }
              }, {
                 name: 'search-organizations',
                 source: organizations,
                 limit: 3,
                 templates: {
                     header: '<h4 class="suggestion-header clearfix">Organizations</h4>',
                     suggestion: function(datum) {
                         var img = '<span class="popular-search-icon glyphicon glyphicon-briefcase"></span>';
                          var description = '';
                         if (datum.address) {
                             description = datum.address;
                         }
                          return '<div id="organization-search-id-' + datum.id + '" class="clearfix"><span>' + img + datum.name + '<br><span class="meta-info">' + description + '</span></span></div>';
                     }
                 },
                 display: function(suggestion) {
                     return suggestion.name;
                 }
              }*/ }).bind('keydown', function (event) {
            setTimeout(function () {
              original_query = $(event.target).val();
            }, 100);
          }).bind('focus', function () {
            typeaheadInput.typeahead('open');
          }).bind('typeahead:select', function (event, suggestion) {
            localforage.setItem('recent_search_query', original_query).then(function (value) {}).catch(function (err) {});
            if (typeof suggestion.url !== 'undefined') {
              location.href = suggestion.url;
            } else if (typeof suggestion.query !== 'undefined') {
              typeaheadInput.blur();
              setTimeout(function () {
                typeaheadInput.focus();
              }, 0);
              typeaheadInput.typeahead('val', suggestion.query);
            }
          });
        }
      });
    }
  },
  events: {
    'render-complains-dashboard': function renderComplainsDashboard(data) {
      this.$broadcast('render-complains-dashboard', data);
    },
    'open-add-pr-modal': function openAddPrModal(data) {
      this.addProperty(data);
    },
    'push-msg-to-chats': function pushMsgToChats(data) {
      this.$broadcast('push-new_msg', data);
    },
    'open-dialog': function openDialog(chat) {
      this.$broadcast('open-dialog', chat);
    },
    'set-current-dialog': function setCurrentDialog(dialog) {
      this.currentDialogs.push(dialog);
    },
    'push-minimize-dialog': function pushMinimizeDialog(chat) {
      var chats = typeof Cookies.getJSON('dialogs') != 'undefined' ? Cookies.getJSON('dialogs') : [];

      var result = $.grep(chats, function (e) {
        return e == chat;
      });

      if (result.length == 0) {
        chats.push(chat.id);
        Cookies.set('dialogs', chats);
      }

      this.$broadcast('push-minimize-dialog', chat);
    }
  }
});

router.start(App, 'body');



},{"../vue/gateguard/AddAnnounceModal.vue":139,"../vue/gateguard/AddBuildingModal.vue":140,"../vue/gateguard/AddPortfolioModal.vue":141,"../vue/gateguard/AddTenantModal.vue":142,"../vue/gateguard/AddVisitorModal.vue":143,"../vue/gateguard/Announcements.vue":144,"../vue/gateguard/AssignBuildingModal.vue":145,"../vue/gateguard/Buildings.vue":146,"../vue/gateguard/Calls.vue":147,"../vue/gateguard/DeviceSettings.vue":148,"../vue/gateguard/Portfolios.vue":150,"../vue/gateguard/TenantsPage.vue":151,"../vue/gateguard/Visitors.vue":163,"../vue/utils/helpers/ObjectToFormdata.js":164,"../vue/utils/helpers/ToFD.js":165,"../vue/vueify/components/ui/DateFields.vue":166,"../vue/vueify/components/ui/FileSelector.vue":167,"../vue/vueify/components/ui/FileUpload.vue":168,"../vue/vueify/components/ui/VueGoogleAutocomplete.vue":169,"../vue/vueify/components/ui/vuetable/DeviceHelper.vue":170,"vue-chartjs":128,"vue-router":130,"vue-select":131,"vuetable/src/components/Vuetable.vue":134,"vuetable/src/components/VuetablePagination.vue":135,"vuetable/src/components/VuetablePaginationDropdown.vue":136}],139:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-c8234794] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      show: false,
      submiting: false,
      form: {
        text: '',
        portfolios: [],
        properties: [],
        buildings: []
      }
    };
  },
  created: function created() {
    var ctx = this;
    ctx.reset();
    this.$bus.$on("add-announce-modal-set-state", function (data, aims) {
      ctx.show = data;
      if (typeof aims.building_id != 'undefined') {
        ctx.form.buildings = [];
        ctx.form.buildings.push(aims.building_id);
      }
      if (typeof aims.portfolio_id != 'undefined') {
        ctx.form.portfolios = [];
        ctx.form.portfolios.push(aims.portfolio_id);
      }
      if (typeof aims.property_id != 'undefined') {
        ctx.form.properties = [];
        ctx.form.properties.push(aims.property_id);
      }
    });
  },

  methods: {
    saveFormTrigger: function saveFormTrigger(e) {
      var _this = this;

      this.$validate(true, function () {
        if (_this.$addAnnounceFormValidator.invalid) {
          e.preventDefault();
        } else {
          _this.saveForm();
        }
      });
    },
    saveForm: function saveForm() {
      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/announce', this.form).then(function (response) {
        toastr["success"]('New announce added! And will be sent soon...');
        ctx.show = false;
        ctx.submiting = false;

        ctx.reset();
      }, function (response) {});
    },
    reset: function reset() {
      this.form = {
        text: '',
        portfolios: [],
        properties: [],
        buildings: []
      };
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-c8234794=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-c8234794=\"\">\n    <h4 class=\"modal-title\" _v-c8234794=\"\">Add Announce</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-c8234794=\"\">\n    <validator name=\"addAnnounceFormValidator\" _v-c8234794=\"\">\n      <form novalidate=\"\" @submit=\"saveFormTrigger\" _v-c8234794=\"\">\n        <div class=\"form-group\" :class=\"{ 'has-error': $addAnnounceFormValidator.text.invalid }\" _v-c8234794=\"\">\n          <label for=\"name\" _v-c8234794=\"\">Announce text</label>\n          <textarea class=\"form-control\" v-model=\"form.text\" placeholder=\"Announce text\" initial=\"off\" v-validate:text=\"{ required: true }\" _v-c8234794=\"\">            \n          </textarea>\n   \n          <span class=\"help-block\" v-if=\"$addAnnounceFormValidator.text.required\" _v-c8234794=\"\">\n          Field is required.\n          </span>\n        </div>\n      </form>\n    </validator>\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-c8234794=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-c8234794=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" @click=\"saveFormTrigger\" _v-c8234794=\"\">Add</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-c8234794=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-c8234794] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c8234794", module.exports)
  } else {
    hotAPI.update("_v-c8234794", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],140:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-01edc24b] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    typeahead: VueStrap.typeahead,
    tooltip: VueStrap.tooltip,
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      devicesCount: 1,
      properties: null,
      googleTemplate: '{{ item.formatted_address }}',
      searchProperty: '{{item.id}}',
      newProperty: false,
      portfolioPreselected: false,
      intercomPricing: false,
      camerasPricing: false,
      show: false,
      submiting: false,
      portfolios: {},
      form: {
        other_to_pay: {
          'email': '',
          'first_name': '',
          'last_name': ''
        },
        who_will_pay: 'you',
        devices: [],
        property_name: '',
        new_property: false,
        portfolio: '',
        property: '',
        bbl: '',
        address: '',
        intercom: false,
        cameras: false
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.reset();
    this.fetchPortfolios();

    this.$bus.$on("add-building-modal-set-state", function (data, portfolio) {
      ctx.reset();
      ctx.show = data;
      if (portfolio) {
        ctx.form.portfolio = portfolio;
        ctx.portfolioPreselected = true;
      }
    }), this.$bus.$on("share-portfolios", function (data) {
      ctx.portfolios = data;
    });
  },

  methods: {
    getProperties: function getProperties(search, loading) {
      var _this = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/property/search?q=' + search).then(function (resp) {
        _this.properties = resp.data;
        loading(false);
      });
    },
    fetchPortfolios: function fetchPortfolios() {
      var ctx = this;

      this.$http.get('/dashboard/gateguard/portfolio').then(function (response) {
        ctx.portfolios = response.data;
      }, function (response) {});
    },
    googleCallback: function googleCallback(items, targetVM) {
      var that = targetVM;
      that.reset();
      that.value = items.formatted_address;
      this.form.address = items.formatted_address;
    },

    addPropertySearchCallback: function addPropertySearchCallback(items, targetVM) {
      var that = targetVM;
      that.reset();
      that.value = items.name;
      this.form.property = items.id;
    },
    saveFormTrigger: function saveFormTrigger(e) {
      e.preventDefault();
      this.saveForm();
    },
    addProperty: function addProperty(portfolio) {
      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/property', {
        name: this.form.property_name
      }).then(function (response) {
        console.log(response.data);
        toastr["success"]('New property added!');
        ctx.submiting = false;
        ctx.form.property_name = '';
        ctx.form.new_property = false;

        //ctx.$bus.$emit('update-portfolios', true)
      }, function (response) {});

      return false;
    },
    reset: function reset() {
      this.portfolioPreselected = false;
      this.form = {
        who_will_pay: 'you',
        other_to_pay: {
          'email': '',
          'first_name': '',
          'last_name': ''
          // 'company' => 'RogaKopyta LLC',
          // 'office_phone' => '123456789',
          // 'address' => '123 Sample street',
          // 'city' => 'New York',
          // 'state' => 'NY',
          // 'country' => 'USA',
          // 'zip' => '10001'
        },
        devices: [],
        property_name: '',
        new_property: false,
        portfolio: '',
        property: '',
        bbl: '',
        address: '',
        intercom: false,
        cameras: false
      };
    },
    saveForm: function saveForm() {
      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/order-devices', this.form).then(function (response) {
        toastr["success"]('New building added!');
        ctx.show = false;
        ctx.submiting = false;

        ctx.form = {
          property_name: '',
          new_property: false,
          portfolio: '',
          property: '',
          bbl: '',
          address: '',
          intercom: false,
          cameras: false
        };

        ctx.$bus.$emit('update-buildings-table', true);
        ctx.$bus.$emit('update-portfolios', true);
      }, function (response) {});
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-01edc24b=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-01edc24b=\"\">\n    <h4 class=\"modal-title\" _v-01edc24b=\"\">Add building</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-01edc24b=\"\">\n  \n    <form @submit=\"saveFormTrigger\" _v-01edc24b=\"\">\n      <div class=\"form-group\" _v-01edc24b=\"\">\n        <label for=\"name\" _v-01edc24b=\"\">For how many buildings do you need devices?</label>\n        <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"devicesCount\" _v-01edc24b=\"\">\n      </div>\n      <div class=\"form-group\" _v-01edc24b=\"\">\n        <label for=\"name\" _v-01edc24b=\"\">Who will pay?</label>\n        <select class=\"form-control\" v-model=\"form.who_will_pay\" required=\"\" _v-01edc24b=\"\">\n          <option value=\"you\" _v-01edc24b=\"\">You</option>\n          <option value=\"other\" _v-01edc24b=\"\">Other</option>\n        </select>\n      </div>\n      <div v-if=\"form.who_will_pay == 'other'\" _v-01edc24b=\"\">\n        <div class=\"form-group\" _v-01edc24b=\"\">\n          <label for=\"name\" _v-01edc24b=\"\">First name of payer</label>\n          <input type=\"text\" class=\"form-control\" v-model=\"form.other_to_pay.first_name\" required=\"\" _v-01edc24b=\"\">\n        </div>\n        <div class=\"form-group\" _v-01edc24b=\"\">\n          <label for=\"name\" _v-01edc24b=\"\">Last name of payer</label>\n          <input type=\"text\" class=\"form-control\" v-model=\"form.other_to_pay.last_name\" required=\"\" _v-01edc24b=\"\">\n        </div>\n        <div class=\"form-group\" _v-01edc24b=\"\">\n          <label for=\"name\" _v-01edc24b=\"\">Email of payer</label>\n          <input type=\"text\" class=\"form-control\" v-model=\"form.other_to_pay.email\" required=\"\" _v-01edc24b=\"\">\n        </div>\n      </div>\n\n      <hr _v-01edc24b=\"\">\n      <div v-for=\"d in parseInt(devicesCount)\" _v-01edc24b=\"\">\n      <div class=\"form-group\" _v-01edc24b=\"\">\n        <label for=\"name\" _v-01edc24b=\"\">Portfolio</label>\n        <select class=\"form-control\" v-model=\"form.devices[d].portfolio\" required=\"\" _v-01edc24b=\"\">\n          <option v-for=\"item in portfolios\" value=\"{{item.id}}\" _v-01edc24b=\"\">{{item.name}}</option>\n        </select>\n      </div>\n      <div class=\"form-group\" _v-01edc24b=\"\">\n        <label for=\"name\" _v-01edc24b=\"\">Property (<a href=\"#\" @click=\"form.new_property = true\" _v-01edc24b=\"\">add new</a>)</label>\n        <v-select :value.sync=\"form.devices[d].property\" :debounce=\"250\" :on-search=\"getProperties\" :options=\"properties\" placeholder=\"Search property\" label=\"name\" required=\"\" _v-01edc24b=\"\">\n        </v-select>\n\n       \n      </div>\n      <div v-if=\"form.new_property\" _v-01edc24b=\"\">\n        <div class=\"panel panel-default\" _v-01edc24b=\"\">\n          <div class=\"panel-heading\" style=\"min-height: unset;\" _v-01edc24b=\"\">New Property (<a href=\"#\" @click=\"form.new_property = false\" _v-01edc24b=\"\">Hide</a>)</div>\n          <div class=\"panel-body\" _v-01edc24b=\"\">\n            <div class=\"row\" _v-01edc24b=\"\">\n              <div class=\"col-md-10\" _v-01edc24b=\"\">\n                <input type=\"text\" name=\"name\" class=\"form-control\" v-model=\"form.property_name\" placeholder=\"New Property name\" _v-01edc24b=\"\">\n              </div>\n              <div class=\"col-md-2\" _v-01edc24b=\"\">\n                <button v-if=\"!submiting\" class=\"btn btn-primary btn-block\" type=\"button\" @click=\"addProperty(item)\" :disabled=\"!form.property_name.length\" _v-01edc24b=\"\">ADD</button>\n                <button v-if=\"submiting\" class=\"btn btn-primary btn-block\" type=\"button\" disabled=\"disabled\" _v-01edc24b=\"\">Adding...</button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\" _v-01edc24b=\"\">\n        <label for=\"name\" _v-01edc24b=\"\">Address</label>\n        <input type=\"text\" name=\"name\" required=\"\" class=\"form-control\" v-model=\"form.devices[d].bbl\" placeholder=\"Address\" _v-01edc24b=\"\">\n      </div>\n      <hr _v-01edc24b=\"\">\n      </div>\n\n        <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-01edc24b=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"submit\" class=\"btn btn-success\" _v-01edc24b=\"\">Order</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-01edc24b=\"\">Submiting...</button>\n    </form>\n\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-01edc24b=\"\">\n    \n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-01edc24b] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-01edc24b", module.exports)
  } else {
    hotAPI.update("_v-01edc24b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],141:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-108739c3] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      show: false,
      submiting: false,
      form: {
        name: ''
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.$bus.$on("add-portfolio-modal-set-state", function (data) {
      ctx.show = data;
    });
  },

  methods: {
    saveFormTrigger: function saveFormTrigger(e) {
      var _this = this;

      this.$validate(true, function () {
        if (_this.$addProtfolioFormValidator.invalid) {
          e.preventDefault();
        } else {
          _this.saveForm();
        }
      });
    },
    saveForm: function saveForm() {
      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/portfolio', this.form).then(function (response) {
        toastr["success"]('New portfolio added!');
        ctx.show = false;
        ctx.submiting = false;
        ctx.form.name = '';

        ctx.$bus.$emit('update-portfolios', true);
      }, function (response) {});
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-108739c3=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-108739c3=\"\">\n    <h4 class=\"modal-title\" _v-108739c3=\"\">Add portfolio</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-108739c3=\"\">\n    <validator name=\"addProtfolioFormValidator\" _v-108739c3=\"\">\n      <form novalidate=\"\" @submit=\"saveFormTrigger\" _v-108739c3=\"\">\n        <div class=\"form-group\" :class=\"{ 'has-error': $addProtfolioFormValidator.name.invalid }\" _v-108739c3=\"\">\n          <label for=\"name\" _v-108739c3=\"\">Portfolio name</label>\n          <input type=\"text\" name=\"name\" class=\"form-control\" v-model=\"form.name\" placeholder=\"Portfolio name\" initial=\"off\" v-validate:name=\"{ required: true }\" _v-108739c3=\"\">\n          <span class=\"help-block\" v-if=\"$addProtfolioFormValidator.name.required\" _v-108739c3=\"\">\n          Field is required.\n          </span>\n        </div>\n      </form>\n    </validator>\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-108739c3=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-108739c3=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" @click=\"saveFormTrigger\" _v-108739c3=\"\">Add</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-108739c3=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-108739c3] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-108739c3", module.exports)
  } else {
    hotAPI.update("_v-108739c3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],142:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-4ac320d6] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal,
    datepicker: VueStrap.datepicker,
    ButtonGroup: VueStrap.buttonGroup
  },
  data: function data() {
    return {

      tenant_id: null,
      edit: false,
      buildingsLoading: false,
      properties: null,
      buildings: [],
      show: false,
      submiting: false,
      form: {
        send_instructions: true,
        properties: null,
        buildings: [],
        unit: '',
        email: '',
        mobile_phone: '',
        first_name: '',
        last_name: '',
        name: ''
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.$bus.$on("add-tenant-modal-set-state", function (data, aims) {
      ctx.reset();
      ctx.show = data;

      if (typeof aims.property != 'undefined') {
        ctx.form.properties = aims.property;
        ctx.properties = aims.property;
      }
      if (typeof aims.building != 'undefined') {
        ctx.form.buildings.push(aims.building);
        ctx.buildings.push(aims.building);
      }
    });
  },

  watch: {
    'form.properties': function formProperties(val) {
      var _this = this;

      var ctx = this;
      ctx.buildingsLoading = true;
      this.$http.get('/dashboard/gateguard/building/search', {
        params: {
          q: '',
          properties: [val]
        }
      }).then(function (resp) {
        _this.buildings = resp.data;
        ctx.buildingsLoading = false;
      });
    }
  },
  methods: {
    reset: function reset() {
      this.edit = false;
      this.tenant_id = null;
      this.properties = null;
      this.buildings = [];

      this.form = {
        properties: null,
        send_instructions: true,
        buildings: [],
        unit: '',
        email: '',
        mobile_phone: '',
        first_name: '',
        last_name: '',
        name: ''
      };
    },
    getBuildings: function getBuildings(search, loading) {
      var _this2 = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/building/search', {
        params: {
          q: search,
          properties: this.properties
        }
      }).then(function (resp) {
        _this2.buildings = resp.data;
        loading(false);
      });
    },
    getProperties: function getProperties(search, loading) {
      var _this3 = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/property/search?q=' + search).then(function (resp) {
        _this3.properties = resp.data;
        loading(false);
      });
    },
    saveFormTrigger: function saveFormTrigger(e) {
      var _this4 = this;

      this.$validate(true, function () {
        if (_this4.$addVisitorFormValidator.invalid) {
          e.preventDefault();
        } else {
          if (_this4.tenant_id && _this4.edit) {
            //his.updateForm()
          } else {
            _this4.saveForm(_this4._saveFormCallback);
          }
        }
      });
    },
    saveFormAndMoreTrigger: function saveFormAndMoreTrigger(e) {
      var _this5 = this;

      this.$validate(true, function () {
        if (_this5.$addVisitorFormValidator.invalid) {
          e.preventDefault();
        } else {
          if (_this5.tenant_id && _this5.edit) {
            //his.updateForm()
          } else {
            _this5.saveForm(_this5._saveFormAndMoreCallback);
          }
        }
      });
    },

    /*
     updateForm() {
     var ctx = this;
     ctx.submiting = true;
     this.$http.put('/dashboard/gateguard/visitor/' + this.tenant_id, this.form)
     .then(response => {
     toastr["success"]('Visitor updated!')
     ctx.show = false;
     ctx.submiting = false;
     this.$bus.$emit('update-visitors-table', true)
     }, response => { })
     },
     */
    saveForm: function saveForm(callback) {
      var ctx = this;
      ctx.submiting = true;
      this.form.login_id = this.form.mobile_phone;

      this.$http.post('/dashboard/gateguard/tenant', this.form).then(function (response) {
        toastr["success"]('New tenant added!');
        callback(ctx);

        ctx.$bus.$emit('update-buildings-table', true);
        ctx.$bus.$emit('update-tenant-table', true);
      }, function (response) {
        $.each(response.data, function (key, value) {
          toastr["error"](value);
        });
        ctx.submiting = false;
      });
    },
    _saveFormCallback: function _saveFormCallback(target) {
      target.show = false;
      target.submiting = false;
    },
    _saveFormAndMoreCallback: function _saveFormAndMoreCallback(target) {
      target.$addVisitorFormValidator.unit.invalid = false;
      target.submiting = false;
      target.form.unit = '';
      target.form.email = '';
      target.form.mobile_phone = '';
      target.form.first_name = '';
      target.form.last_name = '';
      target.form.name = '';
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-4ac320d6=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-4ac320d6=\"\">\n    <h4 class=\"modal-title\" v-if=\"!edit\" _v-4ac320d6=\"\">Add Tenant</h4>\n    <h4 class=\"modal-title\" v-if=\"edit\" _v-4ac320d6=\"\">Edit Tenant</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-4ac320d6=\"\">\n    <validator name=\"addVisitorFormValidator\" _v-4ac320d6=\"\">\n      <form novalidate=\"\" @submit=\"saveFormTrigger\" _v-4ac320d6=\"\">\n        <div class=\"form-group\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Property</label>\n          <v-select :value.sync=\"form.properties\" :debounce=\"250\" :on-search=\"getProperties\" :options=\"properties\" placeholder=\"Search property\" label=\"name\" _v-4ac320d6=\"\">\n          </v-select>\n        </div>\n        <div class=\"form-group\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Buildings \n            <span v-if=\"!buildingsLoading\" style=\"color:red;\" _v-4ac320d6=\"\">(required to fill)</span>\n            <span v-if=\"buildingsLoading\" style=\"color:red;\" _v-4ac320d6=\"\">(Loading...)</span>\n          </label>\n          <v-select :value.sync=\"form.buildings\" multiple=\"\" :debounce=\"250\" :on-search=\"getBuildings\" :options=\"buildings\" placeholder=\"Search buildings\" label=\"full_name\" _v-4ac320d6=\"\">\n          </v-select>\n        </div>\n\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.unit.invalid }\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Unit</label>\n          <input type=\"text\" name=\"unit\" class=\"form-control\" v-model=\"form.unit\" placeholder=\"Unit\" initial=\"off\" @valid=\"true\" v-validate:unit=\"{ required: true }\" _v-4ac320d6=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.unit.required\" _v-4ac320d6=\"\">\n          Field is required.\n          </span>\n        </div>\n\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.first_name.invalid }\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">First name</label>\n          <input type=\"text\" name=\"first_name\" class=\"form-control\" v-model=\"form.first_name\" placeholder=\"First name\" initial=\"off\" v-validate:first_name=\"{ required: true }\" _v-4ac320d6=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.first_name.required\" _v-4ac320d6=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.last_name.invalid }\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Last name</label>\n          <input type=\"text\" name=\"last_name\" class=\"form-control\" v-model=\"form.last_name\" placeholder=\"Last name\" initial=\"off\" v-validate:last_name=\"{ required: true }\" _v-4ac320d6=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.last_name.required\" _v-4ac320d6=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.mobile_phone.invalid }\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Mobile phone</label>\n          <input v-masked-input=\"\" format=\"9999999999\" type=\"text\" name=\"mobile_phone\" class=\"form-control\" v-model=\"form.mobile_phone\" placeholder=\"Mobile phone\" initial=\"off\" v-validate:mobile_phone=\"{ required: true }\" _v-4ac320d6=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.mobile_phone.required\" _v-4ac320d6=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.email.invalid }\" _v-4ac320d6=\"\">\n          <label for=\"name\" _v-4ac320d6=\"\">Email</label>\n          <input type=\"text\" name=\"email\" class=\"form-control\" v-model=\"form.email\" placeholder=\"Email\" initial=\"off\" v-validate:email=\"{ required: true }\" _v-4ac320d6=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.email.required\" _v-4ac320d6=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"checkbox\" _v-4ac320d6=\"\">\n          <label _v-4ac320d6=\"\">\n            <input :checked=\"form.send_instructions\" type=\"checkbox\" v-model=\"form.send_instructions\" _v-4ac320d6=\"\"> Send instructions to tenant after creation  \n          </label>\n        </div>\n      </form>\n    </validator>\n  </div>\n \n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-4ac320d6=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-4ac320d6=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" :disabled=\"!form.buildings.length\" @click=\"saveFormTrigger\" _v-4ac320d6=\"\">\n      Add\n    </button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" :disabled=\"!form.buildings.length\" @click=\"saveFormAndMoreTrigger\" _v-4ac320d6=\"\">\n      Save and add more\n    </button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-4ac320d6=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-4ac320d6] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4ac320d6", module.exports)
  } else {
    hotAPI.update("_v-4ac320d6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],143:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-6a4a56dd] {\n  margin-bottom: 20px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal,
    datepicker: VueStrap.datepicker,
    ButtonGroup: VueStrap.buttonGroup
  },
  data: function data() {
    return {
      guest_id: null,
      edit: false,
      buildingsLoading: false,
      days: [{ value: "0", label: "Sunday" }, { value: "1", label: "Monday" }, { value: "2", label: "Tuesday" }, { value: "3", label: "Wednesday" }, { value: "4", label: "Thursday" }, { value: "5", label: "Friday" }, { value: "6", label: "Saturday" }],

      properties: [],
      buildings: [],
      show: false,
      submiting: false,
      form: {
        start_date: '',
        end_date: '',
        days: [],
        email: '',
        mobile_phone: '',
        first_name: '',
        last_name: '',
        type: 9,
        name: '',
        properties: [],
        buildings: []
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.$bus.$on("add-visitor-modal-set-state", function (data, aims) {
      ctx.show = data;
      ctx.reset();

      console.log(aims);

      if (typeof aims.edit != 'undefined') {
        ctx.buildings = aims.edit.buildings;
        ctx.edit = true;
        ctx.guest_id = aims.edit.guest_unique_id;

        ctx.form = {
          start_date: aims.edit.restrictions.date_start,
          end_date: aims.edit.restrictions.date_end,
          days: aims.edit.restrictions.days,
          email: aims.edit.guest_data.email,
          mobile_phone: aims.edit.guest_data.mobile_phone,
          first_name: aims.edit.guest_data.first_name,
          last_name: aims.edit.guest_data.last_name,
          type: aims.edit.restrictions.type,
          name: '',
          properties: [],
          buildings: aims.edit.buildings
        };
      }

      if (typeof aims.property != 'undefined') {
        ctx.form.properties.push(aims.property);
        ctx.properties.push(aims.property);
      }
      if (typeof aims.building != 'undefined') {
        ctx.form.buildings.push(aims.building);
        ctx.buildings.push(aims.building);
      }
    });
  },

  watch: {
    'form.properties': function formProperties(val) {
      var _this = this;

      var ctx = this;
      ctx.buildingsLoading = true;
      this.$http.get('/dashboard/gateguard/building/search', {
        params: {
          q: '',
          properties: val
        }
      }).then(function (resp) {
        _this.buildings = resp.data;
        ctx.buildingsLoading = false;
      });
    }
  },
  methods: {
    reset: function reset() {
      this.edit = false;
      this.guest_id = null;
      this.properties = [];
      this.buildings = [];

      this.form = {
        start_date: '',
        end_date: '',
        days: [],
        email: '',
        mobile_phone: '',
        first_name: '',
        last_name: '',
        type: 9,
        name: '',
        properties: [],
        buildings: []
      };
    },
    getBuildings: function getBuildings(search, loading) {
      var _this2 = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/building/search', {
        params: {
          q: search,
          properties: this.properties
        }
      }).then(function (resp) {
        _this2.buildings = resp.data;
        loading(false);
      });
    },
    getProperties: function getProperties(search, loading) {
      var _this3 = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/property/search?q=' + search).then(function (resp) {
        _this3.properties = resp.data;
        loading(false);
      });
    },
    saveFormTrigger: function saveFormTrigger(e) {
      var _this4 = this;

      this.$validate(true, function () {
        if (_this4.$addVisitorFormValidator.invalid) {
          e.preventDefault();
        } else {
          if (_this4.guest_id && _this4.edit) {
            _this4.updateForm();
          } else {
            _this4.saveForm();
          }
        }
      });
    },
    updateForm: function updateForm() {
      var _this5 = this;

      var ctx = this;
      ctx.submiting = true;
      this.$http.put('/dashboard/gateguard/visitor/' + this.guest_id, this.form).then(function (response) {
        toastr["success"]('Visitor updated!');
        ctx.show = false;
        ctx.submiting = false;
        _this5.$bus.$emit('update-visitors-table', true);
      }, function (response) {});
    },
    saveForm: function saveForm() {
      var _this6 = this;

      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/visitor', this.form).then(function (response) {
        toastr["success"]('New visitor added!');
        ctx.show = false;
        ctx.submiting = false;
        _this6.$bus.$emit('update-visitors-table', true);
      }, function (response) {});
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-6a4a56dd=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-6a4a56dd=\"\">\n    <h4 class=\"modal-title\" v-if=\"!edit\" _v-6a4a56dd=\"\">Add Visitor</h4>\n    <h4 class=\"modal-title\" v-if=\"edit\" _v-6a4a56dd=\"\">Edit Visitor</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-6a4a56dd=\"\">\n    <validator name=\"addVisitorFormValidator\" _v-6a4a56dd=\"\">\n      <form novalidate=\"\" @submit=\"saveFormTrigger\" _v-6a4a56dd=\"\">\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Properties</label>\n          <v-select :value.sync=\"form.properties\" multiple=\"\" :debounce=\"250\" :on-search=\"getProperties\" :options=\"properties\" placeholder=\"Search property\" label=\"name\" _v-6a4a56dd=\"\">\n          </v-select>\n        </div>\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Buildings \n            <span v-if=\"!buildingsLoading\" style=\"color:red;\" _v-6a4a56dd=\"\">(required to fill)</span>\n            <span v-if=\"buildingsLoading\" style=\"color:red;\" _v-6a4a56dd=\"\">(Loading...)</span>\n          </label>\n          <v-select :value.sync=\"form.buildings\" multiple=\"\" :debounce=\"250\" :on-search=\"getBuildings\" :options=\"buildings\" placeholder=\"Search buildings\" label=\"full_name\" _v-6a4a56dd=\"\">\n          </v-select>\n        </div>\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Role</label>\n          <select class=\"form-control\" v-model=\"form.type\" _v-6a4a56dd=\"\">\n            <option value=\"1\" _v-6a4a56dd=\"\">Friend</option>\n            <option value=\"2\" _v-6a4a56dd=\"\">Family</option>\n            <option value=\"3\" _v-6a4a56dd=\"\">Сleaning Service </option>\n            <option value=\"4\" _v-6a4a56dd=\"\">Delivery</option>\n            <option value=\"5\" _v-6a4a56dd=\"\">Babysitter</option>\n            <option value=\"6\" _v-6a4a56dd=\"\">Health</option>\n            <option value=\"7\" _v-6a4a56dd=\"\">Repairs</option>\n            <option value=\"8\" _v-6a4a56dd=\"\">Sublet</option>\n            <option value=\"9\" _v-6a4a56dd=\"\">Other</option>\n            <option value=\"10\" _v-6a4a56dd=\"\">Prefer to not say</option>\n          </select>\n        </div>\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.first_name.invalid }\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">First name</label>\n          <input type=\"text\" name=\"first_name\" class=\"form-control\" v-model=\"form.first_name\" placeholder=\"First name\" initial=\"off\" v-validate:first_name=\"{ required: true }\" _v-6a4a56dd=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.first_name.required\" _v-6a4a56dd=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"form-group\" :class=\"{ 'has-error': $addVisitorFormValidator.last_name.invalid }\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Last name</label>\n          <input type=\"text\" name=\"last_name\" class=\"form-control\" v-model=\"form.last_name\" placeholder=\"Last name\" initial=\"off\" v-validate:last_name=\"{ required: true }\" _v-6a4a56dd=\"\">\n          <span class=\"help-block\" v-if=\"$addVisitorFormValidator.last_name.required\" _v-6a4a56dd=\"\">\n          Field is required.\n          </span>\n        </div>\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Mobile phone</label>\n          <input type=\"text\" name=\"mobile_phone\" class=\"form-control\" v-model=\"form.mobile_phone\" placeholder=\"Mobile phone\" _v-6a4a56dd=\"\">\n        </div>\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Email</label>\n          <input type=\"text\" name=\"email\" class=\"form-control\" v-model=\"form.email\" placeholder=\"Email\" _v-6a4a56dd=\"\">\n        </div>\n        <hr _v-6a4a56dd=\"\">\n        <b _v-6a4a56dd=\"\">When should this code be active?</b><br _v-6a4a56dd=\"\">\n        <b _v-6a4a56dd=\"\">You can limit the period and days of week a code works.</b>\n        <br _v-6a4a56dd=\"\"><br _v-6a4a56dd=\"\">\n        <div class=\"row\" _v-6a4a56dd=\"\">\n          <div class=\"col-md-6\" _v-6a4a56dd=\"\">\n            <div class=\"form-group\" _v-6a4a56dd=\"\">\n              <label for=\"name\" _v-6a4a56dd=\"\">From date</label>\n              <div id=\"vue-datepicker\" _v-6a4a56dd=\"\">\n                <datepicker :value.sync=\"form.start_date\" placeholder=\"From date\" width=\"100%\" _v-6a4a56dd=\"\"></datepicker>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-md-6\" _v-6a4a56dd=\"\">\n            <div class=\"form-group\" _v-6a4a56dd=\"\">\n              <label for=\"name\" _v-6a4a56dd=\"\">To date</label>\n              <div id=\"vue-datepicker\" _v-6a4a56dd=\"\">\n                <datepicker :value.sync=\"form.end_date\" placeholder=\"To date\" width=\"100%\" _v-6a4a56dd=\"\"></datepicker>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\" _v-6a4a56dd=\"\">\n          <label for=\"name\" _v-6a4a56dd=\"\">Days of week</label>\n          <v-select multiple=\"\" :options=\"days\" :value.sync=\"form.days\" _v-6a4a56dd=\"\"></v-select>\n        </div>\n      </form>\n    </validator>\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-6a4a56dd=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-6a4a56dd=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" :disabled=\"!form.buildings.length\" @click=\"saveFormTrigger\" _v-6a4a56dd=\"\">Add</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-6a4a56dd=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-6a4a56dd] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6a4a56dd", module.exports)
  } else {
    hotAPI.update("_v-6a4a56dd", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],144:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-03d3d409] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {},
  data: function data() {
    return {
      columns: [{
        name: 'text',
        title: 'Text',
        sortField: 'text'
      }, {
        name: 'status',
        title: 'Status',
        sortField: 'status'
      }, {
        name: 'created_at',
        title: 'Created at',
        sortField: 'created_at'
      }]
    };
  },
  created: function created() {
    this.setPageTitle('GateGuard Announcements');
  },

  methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1 _v-03d3d409=\"\">Announcements</h1>\n<div class=\"vuetable-custom\" _v-03d3d409=\"\">\n  <vuetable api-url=\"/dashboard/gateguard/announce\" :fields=\"columns\" table-class=\"table table-bordered\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :per-page=\"10\" _v-03d3d409=\"\"></vuetable>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-03d3d409] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-03d3d409", module.exports)
  } else {
    hotAPI.update("_v-03d3d409", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],145:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-2eb9e632] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal,
    typeahead: VueStrap.typeahead
  },
  data: function data() {
    return {
      searchBuilding: '{{item.bbl}} {{item.address}}',
      show: false,
      submiting: false,
      portfolio: null,
      properties: [],
      items: [],
      form: {
        name: ''
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.$bus.$on("assign-building-modal-set-state", function (data, portfolio) {
      ctx.show = data;
      ctx.items = [];
      ctx.portfolio = portfolio;
    });
  },

  methods: {
    addBuildingSearchCallback: function addBuildingSearchCallback(items, targetVM) {
      var that = targetVM;
      that.reset();
      this.items.push(items);
    },
    saveFormTrigger: function saveFormTrigger(e) {
      if (this.items.length) {
        this.saveForm();
      }
    },
    getProperties: function getProperties(search, loading) {
      var _this = this;

      loading(true);
      this.$http.get('/dashboard/gateguard/building/search?q=' + search).then(function (resp) {
        _this.properties = resp.data;
        loading(false);
      });
    },
    saveForm: function saveForm() {
      var ctx = this;
      ctx.submiting = true;
      this.$http.post('/dashboard/gateguard/portfolio/' + this.portfolio + '/building', { devices: this.items }).then(function (response) {
        toastr["success"]('New buildings assigned!');
        ctx.show = false;
        ctx.submiting = false;
        ctx.form.name = '';

        ctx.$bus.$emit('update-portfolios', true);
      }, function (response) {});
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" _v-2eb9e632=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-2eb9e632=\"\">\n    <h4 class=\"modal-title\" _v-2eb9e632=\"\">Assign building</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-2eb9e632=\"\">\n    <div _v-2eb9e632=\"\">\n         <v-select multiple=\"\" :value.sync=\"items\" :debounce=\"250\" :on-search=\"getProperties\" :options=\"properties\" placeholder=\"Search my property...\" label=\"bbl\" _v-2eb9e632=\"\">\n          </v-select>\n    </div>\n    <div _v-2eb9e632=\"\">\n      <ul style=\"padding: 20px;\" _v-2eb9e632=\"\">\n        <li v-for=\"item in items\" _v-2eb9e632=\"\">{{item.bbl}} {{item.address}}</li>\n      </ul>\n    </div>\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-2eb9e632=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-2eb9e632=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" :disabled=\"!items.length\" @click=\"saveFormTrigger\" _v-2eb9e632=\"\">Add</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-2eb9e632=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-2eb9e632] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2eb9e632", module.exports)
  } else {
    hotAPI.update("_v-2eb9e632", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],146:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-1dc4e53c] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('instruction_action_buildings', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="generatePDF" v-if="!is_generating"><i class="fa fa-refresh" aria-hidden="true" ></i></button>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" v-if="is_generating"><i class="fa fa-refresh fa-spin" aria-hidden="true"></i></button>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="showPDF" v-if="is_ready"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      is_generating: false,
      is_ready: false
    };
  },
  ready: function ready() {
    this.is_generating = this.rowData.building.tenant_instruction && this.rowData.building.tenant_instruction.status == 'processing', this.is_ready = this.rowData.building.tenant_instruction && this.rowData.building.tenant_instruction.status == 'generated';
  },

  methods: {
    generatePDF: function generatePDF() {
      var _this = this;

      console.log(this.rowData);
      this.$http.get('/dashboard/gateguard/building/all-tenants-instructions/' + this.rowData.building_id).then(function (response) {
        _this.is_generating = true;
      });
    },
    showPDF: function showPDF() {
      window.open(this.rowData.building.tenant_instruction.file_path, '_blank');
    }
  }
});

Vue.component('logs_action_buildings', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      window.open('/dashboard/tenants/log?f=&building_id=' + data.building_id + '&from=&to=&unit=&user_id=', '_blank');
    }
  }
});

Vue.component('calls_action_buildings', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      console.log(data);
      console.log('custom-action: ' + action, data.name);
    }
  }
});

Vue.component('work_orders_action_buildings', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      console.log(data);
      console.log('custom-action: ' + action, data.name);
    }
  }
});

Vue.component('announce_action_buildings', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddAnnounceModal(rowData)"><i class="fa fa-bullhorn" aria-hidden="true"></i> Announce</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddAnnounceModal: function showAddAnnounceModal(data) {
      this.$bus.$emit('add-announce-modal-set-state', true, {
        building_id: data.id
      });
    }
  }
});

Vue.component('add_visitor_action_buildings', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddVisitorModal(rowData)">+ Add visitor</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddVisitorModal: function showAddVisitorModal(data) {
      this.$bus.$emit('add-visitor-modal-set-state', true, {
        building: {
          id: data.id,
          full_name: data.full_name.trim()
        }
      });
    }
  }
});

Vue.component('device_settings_action', {
  template: ['<div>', '<a href="/dashboard/gateguard/buildings/{{rowData.id}}/settings"><button class="btn btn-default btn-sm"><i class="fa fa-cog" aria-hidden="true"></i></button></a>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showDeviceSettingsModal: function showDeviceSettingsModal(data) {
      this.$bus.$emit('open-device-settings', true, {
        deviceId: data.id
      });
    }
  }
});

Vue.component('add_tenant_action_buildings', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddTenantModal(rowData)">+ Add tenant</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddTenantModal: function showAddTenantModal(data) {
      this.$bus.$emit('add-tenant-modal-set-state', true, {
        building: {
          id: data.id,
          full_name: data.full_name.trim()
        }
      });
    }
  }
});

Vue.component('tenant_count', {
  template: ['<a target="_blank" href="/dashboard/gateguard/tenants?device={{rowData.id}}">{{rowData.tenants.length}}</a>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {}
});

Vue.component('reboot_action_builinds', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="rebootDevice(rowData)">', '<i class="fa fa-refresh" aria-hidden="true" style="margin-right: 3px;"></i>', 'Reboot', '</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      is_rebooting: false
    };
  },

  methods: {
    rebootDevice: function rebootDevice(rowData) {
      var self = this;
      swal({
        title: "Are you sure want to reboot " + self.rowData.full_name + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, reboot",
        cancelButtonText: "Cancel",
        closeOnConfirm: false
      }, function () {
        swal({
          title: "Rebooting the device " + self.rowData.full_name,
          type: "warning",
          showCancelButton: false,
          showConfirmButton: false,
          cancelButtonText: "Close"
        });
        self.$http.post('/dashboard/gateguard/building/reboot-device', { hash: self.rowData.hash }).then(function (response) {
          swal({
            title: "Device rebooted",
            // text: fresponse.data.message ? fresponse.data.message : '',
            type: "success",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Close"
          });
        }, function (fresponse) {
          swal({
            title: "Something went wrong...",
            // text: fresponse.data.error ? fresponse.data.error : '',
            type: "error",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Close"
          });
        });
      });
    }
  }
});

exports.default = {
  components: {},
  data: function data() {
    return {
      search: '',
      items: [],
      moreParams: [],
      selected: 'All',
      columns: [{
        name: 'property_name',
        title: 'Property name',
        sortField: 'property_name'
      }, {
        name: 'bbl',
        title: 'Address',
        sortField: 'bbl'
      },
      // {
      //   name: 'bbl',
      //   title: 'BBL',
      //   sortField: 'bbl'
      // },
      (0, _defineProperty3.default)({
        name: 'tenants',
        title: 'Tenants (ALL)'
      }, 'name', '__component:tenant_count'), {
        name: 'fm',
        title: 'FM',
        sortField: 'fm'
      }, {
        name: 'rs',
        title: 'RS/other',
        sortField: 'rs'
      }, {
        name: 'vacant',
        title: 'Vacant',
        sortField: 'vacant'
      }, {
        name: '__component:instruction_action_buildings',
        title: 'Instructions'
      }, {
        name: '__component:logs_action_buildings',
        title: 'Logs'
      }, {
        name: '__component:calls_action_buildings',
        title: 'Calls'
      }, {
        name: '__component:device_settings_action',
        title: 'Settings'
      }, {
        name: '__component:add_visitor_action_buildings',
        title: 'Add visitor'
      }, {
        name: '__component:add_tenant_action_buildings',
        title: 'Add tenant'
      }, {
        name: '__component:reboot_action_builinds',
        title: 'Reboot Device',
        dataClass: 'text-center'
      }]
    };
  },

  computed: {
    url: function url() {
      return '/dashboard/gateguard/building';
    }
  },
  created: function created() {
    console.log(this);
    var ctx = this;
    this.update();
    this.fetchPortfolios();
    this.$bus.$on("update-buildings-table", function (data) {
      ctx.update();
    });
    this.setPageTitle('GateGuard Buildings');
  },

  methods: {
    tenantsCount: function tenantsCount(value, e) {
      console.log(value);
      console.log(e);
      return '<a href="">' + value.length + '</a>';
    },
    update: function update() {
      this.moreParams = ['q=' + this.search, 'portfolio=' + this.selected];

      this.$nextTick(function () {
        this.$broadcast('vuetable:refresh');
      });
    },
    showAddBuildingModal: function showAddBuildingModal() {
      this.$bus.$emit('add-building-modal-set-state', true);
    },
    fetchPortfolios: function fetchPortfolios() {
      var ctx = this;

      this.$http.get('/dashboard/gateguard/portfolio').then(function (response) {
        ctx.items = response.data;

        ctx.$bus.$emit('share-portfolios', response.data);
      }, function (response) {});
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1 _v-1dc4e53c=\"\">Buildings <button class=\"btn btn btn-primary\" @click=\"showAddBuildingModal\" _v-1dc4e53c=\"\">+ ADD BUILDING</button></h1>\n<div class=\"row\" _v-1dc4e53c=\"\">\n    <div class=\"col-md-2\" _v-1dc4e53c=\"\">\n      <select v-model=\"selected\" class=\"form-control\" style=\"margin-bottom: 25px;\" @change=\"update\" _v-1dc4e53c=\"\">\n        <option value=\"All\" _v-1dc4e53c=\"\">All</option>\n        <option v-for=\"item in items\" value=\"{{item.id}}\" _v-1dc4e53c=\"\">{{item.name}}</option>\n      </select>\n    </div>\n    <div class=\"col-md-8\" _v-1dc4e53c=\"\">\n    </div>\n    <div class=\"col-md-2\" _v-1dc4e53c=\"\">\n      <div class=\"input-group\" _v-1dc4e53c=\"\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search for...\" v-model=\"search\" _v-1dc4e53c=\"\">\n        <span class=\"input-group-btn\" _v-1dc4e53c=\"\">\n          <button class=\"btn btn-default\" type=\"button\" @click=\"update\" _v-1dc4e53c=\"\"><i class=\"fa fa-search\" aria-hidden=\"true\" _v-1dc4e53c=\"\"></i></button>\n        </span>\n      </div>\n    </div>\n</div>\n<div class=\"vuetable-custom table-responsive\" _v-1dc4e53c=\"\">\n  <vuetable :api-url=\"url\" :fields=\"columns\" table-class=\"table table-bordered\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :append-params=\"moreParams\" :per-page=\"10\" _v-1dc4e53c=\"\"></vuetable>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-1dc4e53c] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1dc4e53c", module.exports)
  } else {
    hotAPI.update("_v-1dc4e53c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":15,"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],147:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileApps = require('./TenantsPage/MobileApps.vue');

var _MobileApps2 = _interopRequireDefault(_MobileApps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryString = require('query-string');

Vue.component('tenant-mobile-apps', _MobileApps2.default);

exports.default = {
  data: function data() {
    return {
      selectedDevice: 'All',
      selectedUser: 'All',
      search: '',
      devices: [],
      users: [],
      moreParams: [],
      columns: [{
        name: 'id',
        title: 'ID',
        sortField: 'id'
      }, {
        name: 'device',
        title: 'Device',
        sortField: 'device'
      }, {
        name: 'user',
        title: 'User',
        sortField: 'user'
      }, {
        name: '__component:tenant-mobile-apps',
        title: 'Mobile App',
        sortField: 'mobile_app',
        callback: 'mobileAppRow'
      }, {
        name: 'mobile_app_last_login',
        title: 'App last login',
        sortField: 'mobile_app_last_login',
        callback: 'mobileAppLastLoginRow'
      }, {
        name: 'door_status',
        title: 'Result',
        sortField: 'door_status',
        callback: 'resultRow'
      }, {
        name: 'missed_sms_alert',
        title: 'Sms Alert Status',
        sortField: 'missed_sms_alert',
        callback: 'smsAlertRow'
      }, {
        name: 'photo',
        title: 'Photo',
        sortField: 'photo',
        callback: 'photoRow'
      }, {
        name: 'created_at',
        title: 'Created At',
        sortField: 'created_at'
      }]
    };
  },
  created: function created() {
    var params = queryString.parse(location.search);

    this.search = typeof params.q != 'undefined' ? params.q : '';
    this.selectedDevice = typeof params.device != 'undefined' ? params.device : 'All';
    this.selectedUser = typeof params.user != 'undefined' ? params.user : 'All';

    this.fetchDevices();

    this.setPageTitle('GateGuard Calls');
  },

  computed: {
    url: function url() {
      return '/dashboard/gateguard/call';
    },
    moreParams: function moreParams() {
      return ['q=' + this.search, 'device=' + this.selectedDevice, 'user=' + this.selectedUser];
    }
  },
  events: {
    'vuetable:load-success': function vuetableLoadSuccess() {
      $('.image-link').magnificPopup({ type: 'image' });
    }
  },
  watch: {
    'selectedDevice': function selectedDevice(val) {
      var ctx = this;
      this.$http.get('/dashboard/gateguard/call/users', {
        params: {
          device: ctx.selectedDevice
        }
      }).then(function (resp) {
        ctx.users = resp.data;
      });
    }
  },
  methods: {
    update: function update() {
      this.$nextTick(function () {
        this.$broadcast('vuetable:refresh');
      });
    },
    fetchDevices: function fetchDevices() {
      var _this = this;

      this.$http.get('/dashboard/gateguard/call/devices').then(function (response) {
        _this.devices = response.data;
      });
    },
    resultRow: function resultRow(value) {
      switch (value) {
        case 'open':
          return '<span class="label label-success">Door opened</span>';
          break;
        case 'closed':
          return '<span class="label label-danger">Call missed</span>';
          break;
        case 'accepted_by_tenant':
          return '<span class="label label-warning">Call accepted, door not opened</span>';
          break;
        case 'rejected_by_tenant':
          return '<span class="label label-warning">Rejected by tenant</span>';
          break;
        default:
          return value;
          break;
      }
    },
    smsAlertRow: function smsAlertRow(value) {
      if (value == 'old') {
        return value;
      } else if (value == null) {
        return 'None';
      } else {
        var text = '';
        var messages = JSON.parse(value);
        _.each(messages, function (result) {
          text += result.status.success ? '<span class="label label-success">' + result.phone + '</span>' : '<span class="label label-danger">' + result.phone + '</span>';
          text += '<br />';
          return true;
        });
        return text;
      }
    },
    photoRow: function photoRow(value) {
      var url = value.replace('public/call_device/', PPDATA.gateguardDeviceStorageUrl + '/call_device/');

      return '<a class="image-link" href="' + url + '"><img src="' + url + '" class="img-responsive" style="max-width: 100px"></a>';
    },
    mobileAppRow: function mobileAppRow(value) {
      return value ? '<span class="label label-success">YES</span>' : '<span class="label label-danger">NO</span>';
    },
    mobileAppLastLoginRow: function mobileAppLastLoginRow(value) {
      if (value == '0000-00-00') {
        return '<span class="label label-danger">NEVER</span>';
      } else {
        return value;
      }
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1>Calls</h1>\n<div class=\"row\">\n  <div class=\"col-xs-6 col-sm-2\">\n    <select v-model=\"selectedDevice\" class=\"form-control\" style=\"margin-bottom: 25px;\" @change=\"update\">\n        <option value=\"All\">All devices</option>\n        <option v-for=\"device in devices\" value=\"{{ device.id }}\">{{ device.bbl }}</option>\n      </select>\n  </div>\n  <div class=\"col-xs-6 col-sm-2\">\n    <select v-model=\"selectedUser\" class=\"form-control\" style=\"margin-bottom: 25px;\" @change=\"update\">\n        <option value=\"All\">All users</option>\n        <option v-for=\"user in users\" value=\"{{ user.id }}\">{{ user.first_name }} {{ user.last_name }}</option>\n      </select>\n  </div>\n  <div class=\"col-md-6\"></div>\n  <div class=\"col-md-2\">\n    <div class=\"input-group\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"Search for...\" v-model=\"search\">\n      <span class=\"input-group-btn\">\n        <button class=\"btn btn-default\" type=\"button\" @click=\"update\">\n          <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n        </button>\n      </span>\n    </div>\n  </div>\n</div>\n<div class=\"vuetable-custom table-responsive\">\n  <vuetable v-ref:calltable=\"\" :api-url=\"url\" :fields=\"columns\" :html-title=\"true\" table-class=\"table table-bordered\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :append-params=\"moreParams\" :per-page=\"25\" :history-mode=\"true\" :load-success=\"dtLoaded\" :sort-order=\"[{ field: 'created_at', direction: 'desc' }]\"></vuetable>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-781d1b5c", module.exports)
  } else {
    hotAPI.update("_v-781d1b5c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./TenantsPage/MobileApps.vue":160,"query-string":125,"vue":132,"vue-hot-reload-api":129}],148:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-28eb07ec] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {
    modal: VueStrap.modal,
    datepicker: VueStrap.datepicker,
    ButtonGroup: VueStrap.buttonGroup
  },
  data: function data() {
    return {
      deviceId: null,
      show: false,
      submiting: false,
      loading: true,
      form: {
        pin_delay_timer: null,
        pin_enabled: null,
        manager_number: null,
        company_name: null
      }
    };
  },
  created: function created() {
    var ctx = this;
    this.$bus.$on("open-device-settings", function (data, aims) {
      ctx.reset();
      ctx.show = data;
      ctx.deviceId = aims.deviceId;
      ctx.load().then(function (success) {
        ctx.loading = false;
      });
      ctx.show = true;
    });
  },


  methods: {
    reset: function reset() {
      this.edit = false;
      this.deviceId = null;
      this.loading = true;

      this.form = {
        pin_delay_timer: null,
        pin_enabled: null,
        manager_number: null,
        company_name: null
      };
    },
    load: function load() {
      var _this = this;

      var ctx = this;
      this.$http.get('/dashboard/gateguard/building/' + ctx.deviceId + '/settings').then(function (resp) {
        console.log(resp);
        _this.form = resp.data;
        _this.loading = false;
      });
    },
    saveFormTrigger: function saveFormTrigger(e) {
      var _this2 = this;

      this.$validate(true, function () {
        if (_this2.$deviceSettingsFormValidator.invalid) {
          e.preventDefault();
        } else {
          _this2.saveForm();
        }
      });
    },
    saveForm: function saveForm() {
      var ctx = this;
      ctx.submiting = true;

      this.$http.post('/dashboard/gateguard/building/' + ctx.deviceId + '/settings', this.form).then(function (response) {
        toastr["success"]('Settings updated!');

        ctx.submiting = false;
      }, function (response) {
        console.log(response);
        $.each(response.data, function (key, value) {
          toastr["error"](value);
        });
        ctx.submiting = false;
      });
    }
  },
  events: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-28eb07ec=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-28eb07ec=\"\">\n    <h4 class=\"modal-title\" _v-28eb07ec=\"\">Device settings</h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-28eb07ec=\"\">\n    <div v-if=\"loading\" class=\"overlay text-center\" _v-28eb07ec=\"\">\n      <i class=\"fa fa-refresh fa-spin\" _v-28eb07ec=\"\"></i>\n    </div>\n    <validator name=\"deviceSettingsFormValidator\" _v-28eb07ec=\"\">\n      <form novalidate=\"\" @submit=\"saveFormTrigger\" v-if=\"!loading\" _v-28eb07ec=\"\">\n\n\n\n        <div class=\"form-group\" :class=\"{ 'has-error': $deviceSettingsFormValidator.pin_delay_timer.invalid }\" _v-28eb07ec=\"\">\n          <label for=\"name\" _v-28eb07ec=\"\">Pin delay timer</label>\n          <input type=\"number\" name=\"pin_delay_timer\" class=\"form-control\" v-model=\"form.pin_delay_timer\" placeholder=\"Pin delay timer\" initial=\"off\" v-validate:pin_delay_timer=\"{ required: true }\" _v-28eb07ec=\"\">\n          <span class=\"help-block\" v-if=\"$deviceSettingsFormValidator.pin_delay_timer.required\" _v-28eb07ec=\"\">\n          Field is required.\n          </span>\n        </div>\n\n        \n\n        <div class=\"form-group\" _v-28eb07ec=\"\">\n          <label for=\"name\" _v-28eb07ec=\"\">Pin enabled</label>\n           <select class=\"form-control\" v-model=\"form.pin_enabled\" _v-28eb07ec=\"\">\n            <option value=\"1\" _v-28eb07ec=\"\">Yes</option>\n            <option value=\"0\" _v-28eb07ec=\"\">No</option>\n          </select>\n        </div>\n\n        <div class=\"form-group\" :class=\"{ 'has-error': $deviceSettingsFormValidator.manager_number.invalid }\" _v-28eb07ec=\"\">\n          <label for=\"name\" _v-28eb07ec=\"\">Manager number</label>\n          <input type=\"text\" name=\"manager_number\" class=\"form-control\" v-model=\"form.manager_number\" placeholder=\"Manager number\" initial=\"off\" v-validate:manager_number=\"{ required: true }\" _v-28eb07ec=\"\">\n          <span class=\"help-block\" v-if=\"$deviceSettingsFormValidator.manager_number.required\" _v-28eb07ec=\"\">\n          Field is required.\n          </span>\n        </div>\n\n        <div class=\"form-group\" :class=\"{ 'has-error': $deviceSettingsFormValidator.company_name.invalid }\" _v-28eb07ec=\"\">\n          <label for=\"name\" _v-28eb07ec=\"\">Company Name</label>\n          <input type=\"text\" name=\"company_name\" class=\"form-control\" v-model=\"form.company_name\" placeholder=\"Manager number\" initial=\"off\" v-validate:company_name=\"{ required: true }\" _v-28eb07ec=\"\">\n          <span class=\"help-block\" v-if=\"$deviceSettingsFormValidator.company_name.required\" _v-28eb07ec=\"\">\n          Field is required.\n          </span>\n        </div>\n\n      </form>\n    </validator>\n  </div>\n\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-28eb07ec=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-28eb07ec=\"\">Close</button>\n    <button v-if=\"!submiting\" type=\"button\" class=\"btn btn-success\" @click=\"saveFormTrigger\" _v-28eb07ec=\"\">Save</button>\n    <button v-if=\"submiting\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-28eb07ec=\"\">Submiting...</button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-28eb07ec] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-28eb07ec", module.exports)
  } else {
    hotAPI.update("_v-28eb07ec", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],149:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


Vue.component('logs_action', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      window.open('/dashboard/tenants/log?f=&building_id=' + data.building_id + '&from=&to=&unit=&user_id=', '_blank');
    }
  }
});

Vue.component('calls_action', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      console.log(data);
      console.log('custom-action: ' + action, data.name);
    }
  }
});

Vue.component('work_orders_action', {
  template: ['<div>', '<button style="margin-right: 10px;" class="btn btn-default btn-sm" @click="itemAction(\'view-item\', rowData)"><i class="fa fa-eye" aria-hidden="true"></i></button>', '<button class="btn btn-default btn-sm" @click="itemAction(\'edit-item\', rowData)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      console.log(data);
      console.log('custom-action: ' + action, data.name);
    }
  }
});

Vue.component('announce_action', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddAnnounceModal(rowData)"><i class="fa fa-bullhorn" aria-hidden="true"></i> Announce</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddAnnounceModal: function showAddAnnounceModal(data) {
      this.$bus.$emit('add-announce-modal-set-state', true, {
        property_id: data.building_id
      });
    }
  }
});

Vue.component('remove', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="remove(rowData)">Remove</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    remove: function remove(data) {

      $(this.$el).closest('tr').remove();
      this.$http.post('/dashboard/gateguard/portfolio/' + data.portfolio_id + '/remove-building', { building_id: data.building_id });
    }
  }
});

Vue.component('add_visitor_action', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddVisitorModal(rowData)">+ Add visitor</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddVisitorModal: function showAddVisitorModal(data) {

      this.$bus.$emit('add-visitor-modal-set-state', true, {
        property: { id: data.building_id, name: data.building_name }
      });
    }
  }
});

Vue.component('add_tenant_action', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="showAddTenantModal(rowData)">+ Add tenant</button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    showAddTenantModal: function showAddTenantModal(data) {
      console.log(data);
      this.$bus.$emit('add-tenant-modal-set-state', true, {
        property: { id: data.building_id, name: data.building_name }
      }).then(function () {
        console.log('oooooooo');
      });
    }
  }
});

exports.default = {
  props: ['portfolio'],
  data: function data() {
    return {
      loading: true,
      portfolio: null,
      columns: [{
        name: 'building_name',
        title: 'Property name',
        sortField: 'building_name'
      }, {
        name: 'devices_count',
        title: 'Buildings',
        sortField: 'devices_count'
      }, {
        name: 'tenants_count',
        title: 'Tenants (ALL)',
        sortField: 'tenants_count'
      }, {
        name: 'fm',
        title: 'FM',
        sortField: 'fm'
      }, {
        name: 'rs',
        title: 'RS/other',
        sortField: 'rs'
      }, {
        name: 'vacant',
        title: 'Vacant',
        sortField: 'vacant'
      }, {
        name: '__component:logs_action',
        title: 'Logs'
      }, {
        name: '__component:calls_action',
        title: 'Calls'
      }, {
        name: '__component:work_orders_action',
        title: 'Work orders'
      }, {
        name: '__component:add_visitor_action',
        title: 'Add visitor'
      }, {
        name: '__component:add_tenant_action',
        title: 'Add tenant'
      }, {
        name: '__component:remove',
        title: 'Remove'
      }]
    };
  },
  created: function created() {},

  computed: {
    url: function url() {
      return "/dashboard/gateguard/portfolio/" + this.portfolio;
    }
  },
  methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"vuetable-custom table-responsive\"> \n  <vuetable :api-url=\"url\" :fields=\"columns\" table-class=\"table table-bordered\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :per-page=\"10\"></vuetable>\n</div> \n<!-- <div v-if=\"loading\" class=\"overlay\" id=\"chat-window-container-preload\"><i class=\"fa fa-refresh fa-spin\"></i></div> -->\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-31c0b78e", module.exports)
  } else {
    hotAPI.update("_v-31c0b78e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],150:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-435adffe] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PortfolioTable = require('./PortfolioTable.vue');

var _PortfolioTable2 = _interopRequireDefault(_PortfolioTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    PortfolioTable: _PortfolioTable2.default
  },
  data: function data() {
    return {
      items: {},
      loading: true,
      selected: 'All'
    };
  },
  created: function created() {
    var ctx = this;
    this.fetchPortfolios();
    this.$bus.$on("update-portfolios", function (data) {
      ctx.fetchPortfolios();
    });
    this.setPageTitle('GateGuard Portfolios');
  },

  methods: {
    showAssignBuildingModal: function showAssignBuildingModal(portfolio) {
      this.$bus.$emit('assign-building-modal-set-state', true, portfolio);
    },
    showAddPortfolioModal: function showAddPortfolioModal() {
      this.$bus.$emit('add-portfolio-modal-set-state', true);
    },
    showAddBuildingModal: function showAddBuildingModal(portfolio) {
      this.$bus.$emit('add-building-modal-set-state', true, portfolio);
    },
    fetchPortfolios: function fetchPortfolios() {
      var ctx = this;
      this.loading = true;
      this.$http.get('/dashboard/gateguard/portfolio').then(function (response) {
        ctx.items = response.data;
        ctx.loading = false;

        ctx.$bus.$emit('share-portfolios', response.data);
      }, function (response) {});
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1 _v-435adffe=\"\">PORTFOLIOS <button class=\"btn btn btn-primary\" @click=\"showAddPortfolioModal\" _v-435adffe=\"\">+ ADD PORTFOLIO</button></h1>\n<div v-if=\"!loading\" _v-435adffe=\"\">\n  <div class=\"row\" _v-435adffe=\"\">\n    <div class=\"col-md-2\" _v-435adffe=\"\">\n      <select v-model=\"selected\" class=\"form-control\" style=\"margin-bottom: 25px;\" _v-435adffe=\"\">\n        <option value=\"All\" _v-435adffe=\"\">All</option>\n        <option v-for=\"item in items\" value=\"{{item.id}}\" _v-435adffe=\"\">{{item.name}}</option>\n      </select>\n    </div>\n    <div class=\"col-md-10\" _v-435adffe=\"\">\n    </div>\n  </div>\n  <div style=\"margin-bottom: 25px;\" class=\"row\" v-for=\"item in items\" v-show=\"(selected == 'All') || (item.id == selected)\" _v-435adffe=\"\">\n    <div class=\"col-md-4\" _v-435adffe=\"\">\n      <h2 style=\"margin-top: 0px;\" _v-435adffe=\"\">{{item.name}}</h2>\n    </div>\n    <div class=\"col-md-8\" style=\"text-align: right;\" _v-435adffe=\"\">\n      <button style=\"margin-right: 10px;\" class=\"btn btn btn-primary\" @click=\"showAssignBuildingModal(item.id)\" _v-435adffe=\"\">ASSIGN BUILDING</button>\n      \n    </div>\n    <div class=\"col-md-12\" _v-435adffe=\"\">\n      <portfolio-table :portfolio=\"item.id\" _v-435adffe=\"\"></portfolio-table>\n    </div>\n  </div>\n</div>\n<div v-if=\"loading\" class=\"overlay\" id=\"chat-window-container-preload\" _v-435adffe=\"\"><i class=\"fa fa-refresh fa-spin\" _v-435adffe=\"\"></i></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-435adffe] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-435adffe", module.exports)
  } else {
    hotAPI.update("_v-435adffe", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./PortfolioTable.vue":149,"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],151:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-60562316] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetailsRow = require('./TenantsPage/DetailsRow.vue');

var _DetailsRow2 = _interopRequireDefault(_DetailsRow);

var _DetailsToggler = require('./TenantsPage/DetailsToggler.vue');

var _DetailsToggler2 = _interopRequireDefault(_DetailsToggler);

var _InstructionsButtons = require('./TenantsPage/InstructionsButtons.vue');

var _InstructionsButtons2 = _interopRequireDefault(_InstructionsButtons);

var _InstructionsModal = require('./TenantsPage/InstructionsModal.vue');

var _InstructionsModal2 = _interopRequireDefault(_InstructionsModal);

var _EditButton = require('./TenantsPage/EditButton.vue');

var _EditButton2 = _interopRequireDefault(_EditButton);

var _MobileAppNoCache = require('./TenantsPage/MobileAppNoCache.vue');

var _MobileAppNoCache2 = _interopRequireDefault(_MobileAppNoCache);

var _ViewLogs = require('./TenantsPage/ViewLogs.vue');

var _ViewLogs2 = _interopRequireDefault(_ViewLogs);

var _PropertyBuilding = require('./TenantsPage/PropertyBuilding.vue');

var _PropertyBuilding2 = _interopRequireDefault(_PropertyBuilding);

var _Enrollment = require('./TenantsPage/Enrollment.vue');

var _Enrollment2 = _interopRequireDefault(_Enrollment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryString = require('query-string');

Vue.component('tenant-details-row', _DetailsRow2.default);
Vue.component('tenant-details-toggler', _DetailsToggler2.default);
Vue.component('tenant-instructions-buttons', _InstructionsButtons2.default);
Vue.component('tenant-instructions-modal', _InstructionsModal2.default);
Vue.component('tenant-edit-button', _EditButton2.default);
Vue.component('tenant-mobile-apps-no_cache', _MobileAppNoCache2.default);
Vue.component('tenant-view-logs', _ViewLogs2.default);
Vue.component('tenant-property-building', _PropertyBuilding2.default);
Vue.component('tenant-enrollment', _Enrollment2.default);

exports.default = {
  components: {},
  data: function data() {
    return {
      search: '',
      items: [],
      devices: [],
      moreParams: [],
      selected: 'All',
      selectedDevice: 'All',
      activeFilter: 1,
      selectedEntity: { id: 'All', name: 'Loading...' },
      selectedDeviceEntity: { id: 'All', full_name: 'Loading...', address: 'All', bbl: 'All' }
    };
  },

  computed: {
    url: function url() {
      return '/dashboard/gateguard/tenant';
    },
    columns: function columns() {
      return [{
        name: '__component:tenant-details-toggler',
        title: 'View details',
        visible: true
      }, {
        name: '__component:tenant-property-building',
        title: 'Property, Building',
        sortField: 'bbl',
        visible: this.selectedDevice == 'All'
      }, {
        name: 'unit',
        title: 'Unit',
        sortField: 'unit',
        visible: true
      }, {
        name: 'first_name',
        title: 'First <br /> name',
        sortField: 'first_name',
        visible: true
      }, {
        name: 'last_name',
        title: 'Last <br /> name',
        sortField: 'last_name',
        visible: true
      }, {
        name: '__component:tenant-mobile-apps-no_cache',
        title: 'Mobile app',
        sortField: 'mobile_app',
        visible: true
      }, {
        name: 'mobile_app_last_login',
        title: 'Mobile <br /> app <br /> last <br /> login',
        sortField: 'mobile_app_last_login',
        visible: true
      }, {
        name: '__component:tenant-enrollment',
        title: 'Enrolled',
        sortField: 'enrolled',
        visible: true
      }, {
        name: 'last_entry',
        title: 'Last <br /> entry',
        sortField: 'last_entry',
        visible: true
      }, {
        name: 'last_buzz',
        title: 'Last <br /> Buzz',
        sortField: 'last_buzz',
        visible: true
      }, {
        name: 'last_guest',
        title: 'Last <br /> Buzz <br /> Unlock',
        sortField: 'last_guest',
        visible: true
      }, {
        name: 'ttl_guests',
        title: "TTL <br /> guests",
        sortField: 'ttl_guests',
        visible: true
      }, {
        name: 'ttl_guests_30days',
        title: "TTL <br /> guests <br /> 30 days",
        sortField: 'ttl_guests_30days',
        visible: true
      }, {
        name: 'last_delivery',
        title: 'Last <br /> delivery',
        sortField: 'last_delivery',
        visible: true
      }, {
        name: 'ttl_delivery_30days',
        title: 'TTL <br /> delivery <br /> 30 days',
        sortField: 'ttl_delivery_30days',
        visible: true
      }, {
        name: 'ttl_work_orders',
        title: 'TTL <br /> work <br /> orders',
        sortField: 'ttl_work_orders',
        visible: true
      }, {
        name: 'ttl_work_orders_open',
        title: 'TTL <br /> work <br /> orders <br /> open',
        sortField: 'ttl_work_orders_open',
        visible: true
      }, {
        name: 'rent_amount',
        title: 'Rent <br /> amount',
        sortField: 'rent_amount',
        visible: true
      }, {
        name: 'rent_due',
        title: 'Rent <br /> due',
        sortField: 'rent_due',
        visible: true
      }, {
        name: 'fr',
        title: 'Financially <br /> responsible',
        sortField: 'fr',
        visible: true
      }, {
        name: '__component:tenant-edit-button',
        title: 'Edit',
        visible: true
      }, {
        name: '__component:tenant-view-logs',
        title: 'View logs',
        visible: true
      }, {
        name: '__component:tenant-instructions-buttons',
        title: 'Send Instru ctions',
        visible: true
      }];
    }
  },
  created: function created() {
    var ctx = this;
    this.$http.get('/dashboard/gateguard/building/search', {
      params: {
        portfolio: ctx.selected
      }
    }).then(function (resp) {
      ctx.devices = resp.data;
    });

    var params = queryString.parse(location.search);

    this.search = typeof params.q != 'undefined' ? params.q : '';
    this.selected = typeof params.portfolio != 'undefined' ? params.portfolio : 'All';
    this.selectedDevice = typeof params.device != 'undefined' ? params.device : 'All';
    this.activeFilter = typeof params.act_status != 'undefined' ? params.act_status : 'all';

    var ctx = this;
    this.update();
    this.fetchPortfolios();
    this.$bus.$on("update-buildings-table", function (data) {
      ctx.update();
    });
    this.$bus.$on("reset-tenants-table", function (data) {
      ctx.reset();
    });
    this.$bus.$on("expand-row", function (data) {
      ctx.$broadcast('vuetable:toggle-detail', data);
    });
    this.setPageTitle('GateGuard Tenants');
  },

  watch: {
    'selected': function selected(val) {
      var ctx = this;
      this.$http.get('/dashboard/gateguard/building/search', {
        params: {
          portfolio: ctx.selected
        }
      }).then(function (resp) {
        ctx.devices = resp.data;
      });
    }
  },
  methods: {
    fetchOptions: function fetchOptions(value) {
      if (value && value.id) {
        this.selected = value.id;
      } else {
        this.reset();
      }
      this.update();
    },
    selectedItem: function selectedItem() {
      var ctx = this;
      this.selectedEntity = ctx.items.find(function (item) {
        return item.id == ctx.selected;
      });
    },
    selectedDeviceItem: function selectedDeviceItem() {
      var ctx = this;
      this.selectedDeviceEntity = ctx.devices.find(function (item) {
        return item.id == ctx.selectedDevice;
      });
    },
    fetchDeviceOptions: function fetchDeviceOptions(value) {
      if (value && value.id) {
        this.selectedDevice = value.id;
      } else {
        this.selectedDevice = 'All';
      }
      this.update();
    },
    rowClass: function rowClass(rowData) {
      if (!rowData.is_active) {
        return "deactivated";
      } else {
        return "";
      }
    },
    boolValue: function boolValue(value) {
      return value ? '<span class="label label-success">YES</span>' : '<span class="label label-danger">NO</span>';
    },
    tenantsCount: function tenantsCount(value) {
      return value.length;
    },
    reset: function reset() {
      this.search = '';
      this.selected = 'All';
      this.selectedDevice = 'All';
      this.activeFilter = 'all';

      this.update();
    },
    update: function update() {
      this.moreParams = ['q=' + this.search, 'portfolio=' + this.selected, 'device=' + this.selectedDevice, 'act_status=' + this.activeFilter];

      this.$nextTick(function () {
        this.$broadcast('vuetable:refresh');
      });
    },
    showAddTenantModal: function showAddTenantModal() {
      this.$bus.$emit('add-tenant-modal-set-state', true, {});
    },
    fetchPortfolios: function fetchPortfolios() {
      var ctx = this;

      this.$http.get('/dashboard/gateguard/portfolio').then(function (response) {
        ctx.items = response.data;
        ctx.$bus.$emit('share-portfolios', response.data);
        ctx.selectedItem();
        ctx.selectedDeviceItem();
      }, function (response) {});
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1 _v-60562316=\"\">Tenants\n  <button class=\"btn btn btn-primary\" @click=\"showAddTenantModal\" _v-60562316=\"\">+ ADD TENANT</button>\n  <a href=\"/dashboard/gateguard/tenants/import\" _v-60562316=\"\">\n    <button class=\"btn btn btn-primary\" _v-60562316=\"\">+ IMPORT TENANTS</button>\n  </a>\n  <a href=\"/dashboard/gateguard/tenants/prospective/\" _v-60562316=\"\">\n    <button class=\"btn btn btn-warning\" _v-60562316=\"\">PENDING TENANTS</button>\n  </a>\n  </h1>\n  <div class=\"row\" _v-60562316=\"\">\n      <div class=\"col-md-3\" _v-60562316=\"\">\n          <v-select :options=\"items\" clearable=\"true\" :multiple=\"false\" :index=\"id\" :value=\"selectedEntity\" :on-change=\"fetchOptions\" label=\"name\" _v-60562316=\"\">\n          </v-select>\n      </div>\n      <div class=\"col-md-4\" _v-60562316=\"\">\n          <v-select :options=\"devices\" :multiple=\"false\" :index=\"id\" :value=\"selectedDeviceEntity\" :on-change=\"fetchDeviceOptions\" label=\"full_name\" _v-60562316=\"\">\n          </v-select>\n      </div>\n      <div class=\"col-md-1\" _v-60562316=\"\">\n          <select v-model=\"activeFilter\" class=\"form-control\" style=\"margin-bottom: 25px;\" @change=\"update\" _v-60562316=\"\">\n              <option value=\"1\" _v-60562316=\"\">Active only</option>\n              <option value=\"0\" _v-60562316=\"\">Deactivated only</option>\n              <option value=\"all\" _v-60562316=\"\">All</option>\n          </select>\n      </div>\n      <div class=\"col-md-2\" _v-60562316=\"\"></div>\n      <div class=\"col-md-2\" _v-60562316=\"\">\n          <div class=\"input-group\" _v-60562316=\"\">\n              <input type=\"text\" class=\"form-control\" placeholder=\"Search for...\" v-model=\"search\" _v-60562316=\"\">\n              <span class=\"input-group-btn\" _v-60562316=\"\">\n          <button class=\"btn btn-default\" type=\"button\" @click=\"update\" _v-60562316=\"\">\n            <i class=\"fa fa-search\" aria-hidden=\"true\" _v-60562316=\"\"></i>\n          </button>\n        </span>\n          </div>\n      </div>\n  </div>\n<div class=\"vuetable-custom table-responsive\" _v-60562316=\"\">\n  <vuetable v-ref:tenanttable=\"\" :api-url=\"url\" :fields=\"columns\" :html-title=\"true\" table-class=\"table table-bordered tenants-table\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :append-params=\"moreParams\" :per-page=\"25\" :history-mode=\"true\" detail-row-component=\"tenant-details-row\" detail-row-id=\"id\" detail-row-transition=\"expand\" row-class-callback=\"rowClass\" _v-60562316=\"\"></vuetable>\n</div>\n<tenant-instructions-modal _v-60562316=\"\"></tenant-instructions-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-60562316] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-60562316", module.exports)
  } else {
    hotAPI.update("_v-60562316", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./TenantsPage/DetailsRow.vue":153,"./TenantsPage/DetailsToggler.vue":154,"./TenantsPage/EditButton.vue":155,"./TenantsPage/Enrollment.vue":156,"./TenantsPage/InstructionsButtons.vue":157,"./TenantsPage/InstructionsModal.vue":158,"./TenantsPage/MobileAppNoCache.vue":159,"./TenantsPage/PropertyBuilding.vue":161,"./TenantsPage/ViewLogs.vue":162,"query-string":125,"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],152:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['userId'],
  data: function data() {
    return {
      processing: false
    };
  },

  methods: {
    changePinCode: function changePinCode() {
      var _this = this;

      this.processing = true;
      this.$http.get('/dashboard/gateguard/tenant/' + this.userId + '/reset-pin').then(function (response) {
        _this.$emit('update-complete');
        _this.processing = false;
        var swalText = '';
        if (response.data.results) {
          if (response.data.results.success && response.data.results.success.length) {
            swalText += 'SMS notifications sent to \n';
            response.data.results.success.forEach(function (phone) {
              swalText += phone + '\n';
            });
          }
          if (response.data.results.fail && response.data.results.fail.length) {
            swalText += 'SMS notifications failed for \n';
            response.data.results.fail.forEach(function (phone) {
              swalText += phone + '\n';
            });
          }
        }
        swal({
          title: "Pin code changed",
          text: swalText,
          type: "success"
        });
      }, function (response) {
        _this.processing = false;
        swal({
          title: "Something went wrong, sorry",
          type: "error"
        });
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<button class=\"btn btn-default btn-sm\" @click=\"changePinCode\">\n  <i class=\"fa fa-refresh\" style=\"margin-right: 5px;\"></i>\n  <span v-if=\"processing\">Processing.....</span>\n  <span v-if=\"!processing\">Change pin</span>\n</button>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ebb630c6", module.exports)
  } else {
    hotAPI.update("_v-ebb630c6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],153:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChangePinButton = require('./ChangePinButton.vue');

var _ChangePinButton2 = _interopRequireDefault(_ChangePinButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      pin: 'loading...',
      visitors: '',
      loadingVisitors: false
    };
  },
  created: function created() {
    this.fetchData();
  },

  components: {
    'change-pin-button': _ChangePinButton2.default
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var ctx = this;
      ctx.loading = true;
      this.$http.get('/dashboard/gateguard/tenant/access/' + this.rowData.id + '/' + this.rowData.device_id, {}).then(function (resp) {
        _this.pin = resp.data.value;
        ctx.loading = false;
      });
    },
    getVisitors: function getVisitors() {
      var _this2 = this;

      var ctx = this;
      ctx.loadingVisitors = true;
      this.$http.get('/dashboard/gateguard/tenant/' + this.rowData.id + '/visitors', {}).then(function (resp) {
        console.log(resp);
        _this2.visitors = resp.data;
        ctx.loadingVisitors = false;
      }).catch(function (err) {
        ctx.loadingVisitors = false;
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\">\n  <div class=\"col-xs-2\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td><label>Email</label></td>\n        <td>{{ rowData.email }}</td>\n      </tr>\n      <tr>\n        <td><label>Phone</label></td>\n        <td>{{ rowData.mobile_phone }}</td>\n      </tr>\n    </tbody></table>\n  </div>\n  <div class=\"col-xs-2\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td><label>Title</label></td>\n        <td>{{ rowData.title }}</td>\n      </tr><tr>\n      </tr><tr>\n        <td><label>Date of birth</label></td>\n        <td>{{ rowData.date_of_birth }}</td>\n      </tr><tr>\n    </tr></tbody></table>\n  </div>\n  <div class=\"col-xs-2\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td><label>Is active</label></td>\n        <td>\n          <span class=\"label label-success\" v-if=\"rowData.is_active\">YES</span>\n          <span class=\"label label-danger\" v-else=\"\">NO</span>\n        </td>\n      </tr><tr>\n      </tr><tr>\n        <td><label>Is online</label></td>\n        <td>\n          <span class=\"label label-success\" v-if=\"rowData.is_online\">YES</span>\n          <span class=\"label label-danger\" v-else=\"\">NO</span>\n        </td>\n      </tr><tr>\n    </tr></tbody></table>\n  </div>\n  <div class=\"col-xs-2\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td><label>Is child</label></td>\n        <td>\n          <span class=\"label label-success\" v-if=\"rowData.is_child\">YES</span>\n          <span class=\"label label-danger\" v-else=\"\">NO</span>\n        </td>\n      </tr><tr>\n    </tr></tbody></table>\n  </div>\n  <div class=\"col-xs-2\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td><label>Login Id</label></td>\n        <td>\n          {{ rowData.login_id }}\n        </td>\n      </tr><tr>\n      </tr><tr>\n        <td><label>Pin</label></td>\n        <td>\n          <change-pin-button :user-id=\"rowData.id\" @update-complete=\"fetchData\"></change-pin-button>\n        </td>\n        <td>\n          {{ pin }}\n        </td>\n      </tr><tr>\n    </tr></tbody></table>\n  </div>\n  <div class=\"col-xs-8\">\n    <table class=\"table table-stripped\">\n      <tbody><tr>\n        <td>\n          <button class=\"btn btn-default\" @click=\"getVisitors\">\n            <p v-if=\"!loadingVisitors\">Show visitors</p>\n            <p v-if=\"loadingVisitors\">Loading...</p>\n          </button>\n        </td>\n        <td v-for=\"visitor in visitors\">\n          Code : {{ visitor.value }}<br>\n          Status : {{ visitor.active ? 'active' : 'inactive' }}\n        </td>\n      </tr><tr>\n    </tr></tbody></table>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e12463c", module.exports)
  } else {
    hotAPI.update("_v-7e12463c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./ChangePinButton.vue":152,"vue":132,"vue-hot-reload-api":129}],154:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemAction: function itemAction(action, data) {
      this.$bus.$emit('expand-row', data.id);
    }
  },
  computed: {
    icon: function icon() {
      return this.$parent.$parent.$refs.tenanttable.isVisibleDetailRow(this.rowData.id) ? '<i class="fa fa-compress" aria-hidden="true"></i>' : '<i class="fa fa-expand" aria-hidden="true"></i>';
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <button class=\"btn btn-default btn-sm\" @click=\"itemAction('toggle-details', rowData)\" v-html=\"icon\">\n  </button>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-59c118a6", module.exports)
  } else {
    hotAPI.update("_v-59c118a6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],155:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    itemAction: function itemAction(action, data) {
      window.open('/dashboard/tenants/edit/' + data.id, '_blank');
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <button class=\"btn btn-default btn-sm\" @click=\"itemAction('edit-item', rowData)\">\n    <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4c52a6f4", module.exports)
  } else {
    hotAPI.update("_v-4c52a6f4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],156:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span class=\"label label-success\" v-if=\"rowData.enrolled\">YES</span>\n<span class=\"label label-danger\" v-if=\"!rowData.enrolled\">NO</span>\n<span class=\"label\" style=\"background-color: #000080\" v-if=\"!rowData.is_active\">DEACTIVATED</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-735ae9ae", module.exports)
  } else {
    hotAPI.update("_v-735ae9ae", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],157:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    sendInstructions: function sendInstructions() {
      this.$bus.$emit("tenant-instructions-modal-set-state", this.rowData);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"btn-group-vertical\">\n  <button class=\"btn btn-default btn-sm\" title=\"Send instructions\" @click=\"sendInstructions()\">\n    <i class=\"fa fa-send\" aria-hidden=\"true\"></i>\n  </button>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-086c00e2", module.exports)
  } else {
    hotAPI.update("_v-086c00e2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],158:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.checkbox h4[_v-acc9f764] {\n  margin-top: 0px; }\n\n/* line 7, stdin */\n.checkbox input[type=\"checkbox\"][_v-acc9f764] {\n  margin-top: 1px; }\n\n/* line 12, stdin */\n.overlay[_v-acc9f764] {\n  min-height: 300px;\n  padding-top: 25%; }\n  /* line 15, stdin */\n  .overlay i[_v-acc9f764] {\n    font-size: 30px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    modal: VueStrap.modal
  },
  data: function data() {
    return {
      loading: true,
      result: false,
      userData: false,
      show: false,
      submiting: false,
      userPin: 'loading...',
      needSms: true,
      needEmail: true,
      emailPreview: false,
      smsPreview: false,
      form: {
        available_emails: [],
        custom_email: null,
        customAddress: false,
        available_phone_numbers: [],
        custom_phone_number: null,
        customNumber: false,
        selected_emails: [],
        selected_phones: []
      }
    };
  },
  created: function created() {
    var ctx = this;

    this.$bus.$on("tenant-instructions-modal-set-state", function (userData) {
      ctx.reset();
      ctx.userData = userData;
      ctx.getUserPin();

      ctx.loading = false;
      ctx.show = true;
    });
  },

  methods: {
    reset: function reset() {
      this.loading = true;
      this.result = false;
      this.userData = false;
      this.show = false;
      this.submiting = false;
      this.userPin = 'loading...';
      this.needSms = true;
      this.needEmail = true;
      this.emailPreview = false;
      this.smsPreview = false;
      this.form = {
        available_emails: [],
        custom_email: null,
        customAddress: false,
        available_phone_numbers: [],
        custom_phone_number: null,
        customNumber: false,
        selected_emails: [],
        selected_phones: []
      };
    },
    getUserPin: function getUserPin() {
      var _this = this;

      this.$http.get('/dashboard/gateguard/tenant/access/' + this.userData.id + '/' + this.userData.device_id).then(function (resp) {
        _this.userPin = resp.data.value;
      });
    },
    getUserContacts: function getUserContacts() {
      var ctx = this;
      return new _promise2.default(function (resolve, reject) {
        ctx.$http.get('/dashboard/gateguard/tenant/' + ctx.userData.id + '/contact-info').then(function (response) {
          ctx.form.available_emails = response.data.emails;
          ctx.form.available_phone_numbers = response.data.phones;
          resolve();
        }, function (fresponse) {
          reject();
        });
      });
    },
    send: function send() {
      var _this2 = this;

      this.submiting = true;
      this.$http.post('/dashboard/gateguard/tenant/instructions/' + this.userData.id + '/' + this.userData.device_id, this.postContacts).then(function (response) {
        _this2.result = response.data;
      });
    }
  },
  computed: {
    emailsToSend: function emailsToSend() {
      return this.form.customAddress ? this.form.selected_emails.concat([this.form.custom_email]) : this.form.selected_emails;
    },
    phonesToSend: function phonesToSend() {
      return this.form.customNumber ? this.form.selected_phones.concat([this.form.custom_phone_number]) : this.form.selected_phones;
    },
    postContacts: function postContacts() {
      var data = {};
      if (this.needSms) {
        data.phones = this.phonesToSend;
      }
      if (this.needEmail) {
        data.emails = this.emailsToSend;
      }

      return data;
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<modal :show.sync=\"show\" effect=\"zoom\" backdrop=\"false\" _v-acc9f764=\"\">\n  <div slot=\"modal-header\" class=\"modal-header\" _v-acc9f764=\"\">\n    <h4 class=\"modal-title\" _v-acc9f764=\"\">\n      Send instructions to tenant\n    </h4>\n  </div>\n  <div slot=\"modal-body\" class=\"modal-body\" _v-acc9f764=\"\">\n    <div v-if=\"!loading &amp;&amp; !result\" _v-acc9f764=\"\">\n      <a :href=\"'/dashboard/gateguard/tenant/pdf/' + userData.id + '/' + userData.device_id\" class=\"btn btn-default\" _v-acc9f764=\"\">\n        <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\" _v-acc9f764=\"\"></i>\n        Dowload PDF\n      </a>\n      <hr _v-acc9f764=\"\">\n\n  \n\n    </div>\n    <div v-if=\"!loading &amp;&amp; result\" _v-acc9f764=\"\">\n       <h4 _v-acc9f764=\"\">\n          Instructions sucessfully sent\n        </h4>\n\n    \n     \n\n    </div>\n    <div v-if=\"loading\" class=\"overlay text-center\" _v-acc9f764=\"\">\n      <i class=\"fa fa-refresh fa-spin\" _v-acc9f764=\"\"></i>\n    </div>\n  </div>\n  <div slot=\"modal-footer\" class=\"modal-footer\" _v-acc9f764=\"\">\n    <button type=\"button\" class=\"btn btn-default\" @click=\"show = false\" _v-acc9f764=\"\">\n      Close\n    </button>\n    <button v-if=\"!submiting &amp;&amp; !result\" type=\"button\" class=\"btn btn-success\" :disabled=\"false\" @click=\"send\" _v-acc9f764=\"\">\n      Send\n    </button>\n    <button v-if=\"submiting &amp;&amp; !result\" disabled=\"disabled\" type=\"button\" class=\"btn btn-success\" _v-acc9f764=\"\">\n      Sending...\n    </button>\n  </div>\n</modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.checkbox h4[_v-acc9f764] {\n  margin-top: 0px; }\n\n/* line 7, stdin */\n.checkbox input[type=\"checkbox\"][_v-acc9f764] {\n  margin-top: 1px; }\n\n/* line 12, stdin */\n.overlay[_v-acc9f764] {\n  min-height: 300px;\n  padding-top: 25%; }\n  /* line 15, stdin */\n  .overlay i[_v-acc9f764] {\n    font-size: 30px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-acc9f764", module.exports)
  } else {
    hotAPI.update("_v-acc9f764", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/promise":12,"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],159:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      showRemindButton: false,
      remindButtonText: "Remind"
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  created: function created() {
    console.log(this.rowData);
  },

  computed: {
    platformUnknown: function platformUnknown() {
      console.log(this.rowData);
      return this.rowData.last_token && !this.rowData.last_token.platform;
    },
    platformKnown: function platformKnown() {
      return this.rowData.last_token.platform;
    }
  },
  methods: {
    mouseOver: function mouseOver() {
      if (!this.rowData.last_token) {
        this.showRemindButton = true;
      }
    },
    mouseLeave: function mouseLeave() {
      if (!this.rowData.last_token && this.remindButtonText == "Remind") {
        this.showRemindButton = false;
      }
    },
    remind: function remind() {
      var self = this;
      self.remindButtonText = "Sending..", self.$http.get('/dashboard/gateguard/tenant/' + self.rowData.id + '/reminder/' + self.rowData.device_id).then(function (response) {
        self.remindButtonText = "Reminded.";
        var text = '';
        $.each(response.data.message, function (index, value) {
          text += index + ': ' + value.msg + ' ';
        });
        swal({
          title: "SMS reminders sent.",
          text: text,
          type: "success",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        });
      }, function (fresponse) {
        self.remindButtonText = "Remind";
        swal({
          title: "Something went wrong...",
          // text: fresponse.data.error ? fresponse.data.error : '',
          type: "error",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        });
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"noc\">\n  <div v-on:mouseover=\"mouseOver\" v-on:mouseleave=\"mouseLeave\" class=\"noc\">\n    <span class=\"label label-danger\" v-if=\"!rowData.last_token &amp;&amp; !showRemindButton\">NO</span>\n    <a class=\"label label-primary\" style=\"margin-right: -5px;\" v-if=\"!rowData.last_token &amp;&amp; showRemindButton\" v-on:click=\"remind\">\n      {{ remindButtonText }}\n    </a>\n    <span class=\"label label-success\" v-if=\"platformUnknown\">YES</span>\n\n    <span class=\"label label-success\" v-if=\"platformKnown\">\n    v.{{ rowData.last_token.app_version }}\n    \n    <i class=\"fa fa-android\" aria-hidden=\"true\" v-if=\"rowData.last_token.platform.toLowerCase() == 'android'\"></i>\n    <i class=\"fa fa-apple\" aria-hidden=\"true\" v-if=\"rowData.last_token.platform.toLowerCase() == 'ios'\"></i>\n    {{ rowData.last_token.version }}\n    </span>\n    <div>unlock -{{rowData.type_unlock}}</div>\n  </div>\n  </div>\n  \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0095454c", module.exports)
  } else {
    hotAPI.update("_v-0095454c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],160:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      showRemindButton: false,
      remindButtonText: "Remind"
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  created: function created() {
    console.log(this.rowData);
  },

  computed: {
    platformUnknown: function platformUnknown() {
      return this.rowData.mobile_app && !this.rowData.platform;
    },
    platformKnown: function platformKnown() {
      return this.rowData.platform;
    }
  },
  methods: {
    mouseOver: function mouseOver() {
      if (!this.rowData.mobile_app) {
        this.showRemindButton = true;
      }
    },
    mouseLeave: function mouseLeave() {
      if (!this.rowData.mobile_app && this.remindButtonText == "Remind") {
        this.showRemindButton = false;
      }
    },
    remind: function remind() {
      var self = this;
      self.remindButtonText = "Sending..", self.$http.get('/dashboard/gateguard/tenant/' + self.rowData.id + '/reminder/' + self.rowData.device_id).then(function (response) {
        self.remindButtonText = "Reminded.";
        var text = '';
        $.each(response.data.message, function (index, value) {
          text += index + ': ' + value.msg + ' ';
        });
        swal({
          title: "SMS reminders sent.",
          text: text,
          type: "success",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        });
      }, function (fresponse) {
        self.remindButtonText = "Remind";
        swal({
          title: "Something went wrong...",
          // text: fresponse.data.error ? fresponse.data.error : '',
          type: "error",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        });
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <div v-on:mouseover=\"mouseOver\" v-on:mouseleave=\"mouseLeave\">\n    <span class=\"label label-danger\" v-if=\"!rowData.mobile_app &amp;&amp; !showRemindButton\">NO</span>\n    <a class=\"label label-primary\" style=\"margin-right: -5px;\" v-if=\"!rowData.mobile_app &amp;&amp; showRemindButton\" v-on:click=\"remind\">\n      {{ remindButtonText }}\n    </a>\n    <span class=\"label label-success\" v-if=\"platformUnknown\">YES</span>\n\n    <span class=\"label label-success\" v-if=\"platformKnown\">\n    v.{{ rowData.app_version }}\n    \n    <i class=\"fa fa-android\" aria-hidden=\"true\" v-if=\"rowData.platform.toLowerCase() == 'android'\"></i>\n    <i class=\"fa fa-apple\" aria-hidden=\"true\" v-if=\"rowData.platform.toLowerCase() == 'ios'\"></i>\n    {{ rowData.version }}\n    </span>\n    <div>unlock -{{rowData.type_unlock}}</div>\n  </div>\n  </div>\n  \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4df9c644", module.exports)
  } else {
    hotAPI.update("_v-4df9c644", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],161:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n   {{ rowData.bbl }}\n   <br>\n   {{ rowData.address }}\n</div> \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2df7f35a", module.exports)
  } else {
    hotAPI.update("_v-2df7f35a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],162:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    itemAction: function itemAction(action, data) {
      window.open('/dashboard/gateguard/logs-v2?building_id=' + data.building_id, '_blank');
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <button class=\"btn btn-default btn-sm\" @click=\"itemAction('view-logs', rowData)\">\n    <i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-11a8851e", module.exports)
  } else {
    hotAPI.update("_v-11a8851e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],163:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh1[_v-183fab58] {\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


Vue.component('remove_action', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="remove(rowData)"><i class="fa fa-times" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    remove: function remove(data) {
      var _this = this;

      var ctx = this;
      this.$http.delete('/dashboard/gateguard/visitor/' + data.guest_unique_id).then(function (response) {
        toastr["success"]('Visitor removed!');
        _this.$bus.$emit('update-visitors-table', true);
      }, function (response) {});
    }
  }
});

Vue.component('edit_action', {
  template: ['<div>', '<button class="btn btn-default btn-sm" @click="edit(rowData)"><i class="fa fa-pencil" aria-hidden="true"></i></button>', '</div>'].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    edit: function edit(data) {
      this.$bus.$emit('add-visitor-modal-set-state', true, {
        edit: data
      });
    }
  }
});
exports.default = {
  components: {},
  data: function data() {
    return {
      moreParams: [],
      columns: [{
        name: 'buildings',
        title: 'Access',

        callback: 'buildingsCount'
      }, {
        name: 'value',
        title: 'Value'
      }, {
        name: 'guest_data.first_name',
        title: 'First name'
      }, {
        name: 'guest_data.last_name',
        title: 'Last name'
      }, {
        name: 'guest_data.email',
        title: 'Email'
      }, {
        name: 'guest_data.mobile_phone',
        title: 'Mobile phone'
      }, {
        name: 'created_at',
        title: 'Created At',
        sortField: 'created_at'
      }, {
        name: '__component:edit_action',
        title: 'Edit'
      }, {
        name: '__component:remove_action',
        title: 'Remove'
      }]
    };
  },

  computed: {
    url: function url() {
      return '/dashboard/gateguard/visitor';
    }
  },
  created: function created() {
    // console.log(this)
    var ctx = this;
    this.update();
    this.$bus.$on("update-visitors-table", function (data) {
      ctx.update();
    });
    this.setPageTitle('GateGuard Visitors');
  },

  methods: {
    update: function update() {
      this.$nextTick(function () {
        this.$router.app.$broadcast('vuetable:refresh');
      });
    },
    showAddVisitorModal: function showAddVisitorModal() {
      this.$bus.$emit('add-visitor-modal-set-state', true, {});
    },
    buildingsCount: function buildingsCount(value) {
      return _.map(value, 'full_name').join('<br />');
      if (value.length > 1) {
        return value.length + ' Buildings';
      } else {
        return value.length + ' Building';
      }
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<h1 _v-183fab58=\"\">Visitors <button class=\"btn btn btn-primary\" @click=\"showAddVisitorModal\" _v-183fab58=\"\">+ ADD VISITOR</button></h1>\n<div class=\"vuetable-custom table-responsive\" _v-183fab58=\"\">\n  <vuetable :api-url=\"url\" :fields=\"columns\" table-class=\"table table-bordered\" ascending-icon=\"glyphicon glyphicon-chevron-up\" descending-icon=\"glyphicon glyphicon-chevron-down\" pagination-path=\"\" pagination-class=\"\" pagination-info-class=\"\" pagination-component-class=\"\" pagination-component=\"vuetable-pagination\" wrapper-class=\"vuetable-wrapper\" table-wrapper=\".vuetable-wrapper\" loading-class=\"vue-loading\" :append-params=\"moreParams\" :per-page=\"10\" _v-183fab58=\"\"></vuetable>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh1[_v-183fab58] {\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-183fab58", module.exports)
  } else {
    hotAPI.update("_v-183fab58", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],164:[function(require,module,exports){
'use strict';

function isObject(value) {
  return value === Object(value);
}

function isArray(value) {
  return Array.isArray(value);
}

function isFile(value) {
  return value instanceof File;
}

function makeArrayKey(key) {
  if (key.length > 2 && key.lastIndexOf('[]') === key.length - 2) {
    return key;
  } else {
    return key + '[]';
  }
}

function objectToFormData(obj, fd, pre) {
  fd = fd || new FormData();

  Object.keys(obj).forEach(function (prop) {
    var key = pre ? pre + '[' + prop + ']' : prop;

    if (isObject(obj[prop]) && !isArray(obj[prop]) && !isFile(obj[prop])) {
      objectToFormData(obj[prop], fd, key);
    } else if (isArray(obj[prop])) {
      obj[prop].forEach(function (value) {
        var arrayKey = makeArrayKey(key);

        if (isObject(value) && !isFile(value)) {
          objectToFormData(value, fd, arrayKey);
        } else {
          fd.append(arrayKey, value);
        }
      });
    } else {
      fd.append(key, obj[prop]);
    }
  });

  return fd;
}

module.exports = objectToFormData;

},{}],165:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function toFD(object, options) {
  options = $.extend(true, {
    maxDepth: 100,
    skipArrayKeys: true
  }, options || {});
  var getType = function getType(any) {
    return Object.prototype.toString.call(any).slice(8, -1);
  };
  var toName = function toName(path) {
    var ar = Array.prototype.map.call(path, function (value) {
      return "[" + value + "]";
    });
    ar[0] = path[0];
    return ar.join("");
  };
  var appendToForm = function appendToForm(form, path, value, filename) {
    var name = toName(path);
    if (value === null) value = '';
    if (typeof filename === "undefined") {
      form.append(name, value);
    } else {
      form.append(name, value, filename);
    }
  };
  var formData = new FormData();
  var run = function run(obj, path, depth) {
    if (depth > options.maxDepth) return;
    var type = getType(obj);
    if (type == "Object" && obj !== null) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          run(obj[key], path.concat(key), depth + 1);
        }
      }
    } else if (type == "Array" || type == "FileList") {
      for (var i = 0; i < obj.length; i++) {
        run(obj[i], path.concat(options.skipArrayKeys ? "" : i), depth + 1);
      }
    } else if (type == "Blob") {
      appendToForm(formData, path, obj, obj.name);
    } else {
      appendToForm(formData, path, obj);
    }
  };
  run(object, [], 0);
  return formData;
}

// https://gist.github.com/ghinda/8442a57f22099bdb2e34#gistcomment-1965514
function toFormData(obj, form, namespace) {
  var fd = form || new FormData();
  var formKey = void 0;

  for (var property in obj) {
    // if(obj.hasOwnProperty(property) && obj[property]) {
    if (obj.hasOwnProperty(property) && obj[property] !== null && obj[property] !== undefined) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (_typeof(obj[property]) === 'object' && !(obj[property] instanceof File)) {
        toFormData(obj[property], fd, formKey);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}

module.exports = toFormData;

},{}],166:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var config = {
  dobYearsRange: {
    start: new Date().getFullYear() - 75,
    stop: new Date().getFullYear() - 16
  },
  generalYearsRange: {
    start: new Date().getFullYear() - 75,
    stop: new Date().getFullYear()
  },
  months: "January February March April May June July August September October November December".split(/ /)
};

exports.default = {
  data: function data() {
    return {
      monthOptions: config.months,
      yearOptions: _.range(config.generalYearsRange['stop'], config.generalYearsRange['start'], -1),
      dayOptions: _.range(1, 32),
      day: null,
      month: null,
      year: null
    };
  },

  props: ['date', 'type'],
  beforeCompile: function beforeCompile() {
    if (this.type == 'dob') {
      this.yearOptions = _.range(config.dobYearsRange['stop'], config.dobYearsRange['start'], -1);
    }
    this.setFromDateStr(this.date);
  },
  computed: {
    dateChangeDetector: function dateChangeDetector() {
      return this.day, this.month, this.year, Date.now();
    }
  },
  watch: {
    date: function date(val, oldVal) {
      this.setFromDateStr(val);
    },
    dateChangeDetector: function dateChangeDetector() {
      var day = this.day;
      var month = this.month;
      var year = this.year;

      if (day && month && year) {
        this.date = moment(new Date(+year, month - 1, +day)).format("YYYY-MM-DD");
      }
    }
  },
  methods: {
    setFromDateStr: function setFromDateStr(dateStr) {
      if (!dateStr) return;
      var date = moment(new Date(dateStr));

      this.day = date.get('date');
      this.month = date.get('month') + 1;
      this.year = date.get('year');
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\">\n  <div class=\"col-sm-4\">\n    <select class=\"form-control\" v-model=\"month\">\n      <option :value=\"null\" selecte=\"\" disabled=\"\">Month</option>\n      <option v-for=\"option in monthOptions\" v-bind:value=\"$index+1\">\n        {{ option }}\n      </option>\n    </select>\n  </div>\n  <div class=\"col-sm-4\">\n    <select class=\"form-control\" v-model=\"day\">\n      <option :value=\"null\" selecte=\"\" disabled=\"\">Day</option>\n      <option v-for=\"option in dayOptions\" v-bind:value=\"$index+1\">\n        {{ option }}\n      </option>\n    </select>\n  </div>\n  <div class=\"col-sm-4\">\n    <select class=\"form-control\" v-model=\"year\">\n      <option :value=\"null\" selecte=\"\" disabled=\"\">Year</option>\n      <option v-for=\"option in yearOptions\" v-bind:value=\"option\">\n        {{ option }}\n      </option>\n    </select>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-df200e98", module.exports)
  } else {
    hotAPI.update("_v-df200e98", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],167:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    id: {
      type: String,
      default: 'file_selector_' + Date.now()
    },
    multiple: {
      type: Boolean,
      default: false
    },
    oldValue: {},
    value: {},
    label: {
      type: String
    },
    class: {
      type: String
    }
  },
  data: function data() {
    return {
      filesData: null,
      labelText: null
    };
  },

  methods: {
    handleFileChange: function handleFileChange(e) {
      console.log('op', e);
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.labelText = null;
        return;
      }
      if (files.length == 1) {
        this.filesData = files[0];
        console.log('1112', files, this.filesData);
        this.labelText = e.target.value.split('\\').pop();
      }
      if (files.length > 1) {
        this.filesData = files;
        this.labelText = '{count} files selected'.replace('{count}', files.length);
      }

      this.$emit('input', this.filesData);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-inline-b\">\n  <input type=\"file\" class=\"e-inputfile -general\" v-bind:class=\"class\" v-bind:id=\"id\" v-bind:multiple=\"multiple\" @change=\"handleFileChange\">\n  <label v-bind:for=\"id\">\n    <span>{{labelText || (label||(oldValue?'Renew':'Upload'))}}</span>\n  </label>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b8da8230", module.exports)
  } else {
    hotAPI.update("_v-b8da8230", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],168:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.file-uploads {\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n}\n.file-uploads span{\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n}\n.file-uploads input{\n    z-index: 1;\n    opacity: 0;\n    font-size: 20em;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\n.file-uploads.file-uploads-html5 input{\n    float: left;\n    width: 1px !important;\n    height: 1px !important;\n    top:-1px !important;\n    left:-1px !important;\n    right:auto !important;\n    bottom:auto !important;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    title: {
      type: String,
      default: 'Upload file'
    },
    name: {
      type: String,
      default: 'file'
    },
    drop: {
      default: false
    },
    extensions: {
      default: function _default() {
        return [];
      }
    },
    postAction: {
      type: String
    },
    putAction: {
      type: String
    },
    accept: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    timeout: {
      type: Number,
      default: 0
    },
    size: {
      type: Number
    },
    events: {
      type: Object,
      default: function _default() {}
    }
  },

  components: {
    inputFile: {
      template: '<input type="file" :name="$parent.name" :id="$parent.id||$parent.name" :accept="$parent.accept" @change="change" :multiple="$parent.multiple && $parent.$mode == \'html5\'">',
      methods: {
        change: function change(e) {
          this.$parent._addFileUploads(e.target);
          this.$destroy();
        }
      }
    }
  },

  data: function data() {
    return {
      files: [],
      active: false,
      uploaded: true,
      dropActive: false,
      dropElement: false,
      request: {
        data: {},
        headers: {}
      }
    };
  },
  ready: function ready() {
    this._drop(this.drop);
  },
  init: function init() {
    var input = document.createElement('input');
    input.type = 'file';
    if (window.FormData && input.files) {
      this.$mode = 'html5';
    } else {
      this.$mode = 'html4';
    }
    this._index = 0;
    this._dropActive = 0;
    this._files = {};
  },
  beforeDestroy: function beforeDestroy() {
    this.active = false;
    this.files = [];
  },


  watch: {
    drop: function drop(value) {
      this._drop(value);
    },
    files: function files(_files) {
      var ids = [];
      for (var i = 0; i < _files.length; i++) {
        var file = _files[i];
        if (!file.errno && !file.success) {
          this.uploaded = false;
        }
        ids.push(file.id);
      }
      for (var id in this._files) {
        if (ids.indexOf(id) != -1) {
          continue;
        }

        var file = this._files[id]._file;

        file.removed = true;
        var xhr = this._files[id].xhr;
        if (xhr) {
          try {
            xhr.abort();
            xhr.timeout = 1;
          } catch (e) {}
        }
        var iframe = this._files[id].iframe;
        if (iframe) {
          iframe.onabort({ type: 'abort' });
        }
        delete this._files[id];
        this._uploadEvents('removeFileUpload', file);
      }
      this._index = 0;
    },
    active: function active(newValue, oldValue) {
      if (newValue && !oldValue) {
        this._fileUploads();
      }
    },
    uploaded: function uploaded(_uploaded) {
      if (_uploaded) {
        this.active = false;
      }
    }
  },

  methods: {
    clear: function clear() {
      if (this.files.length) {
        this.files.splice(0, this.files.length);
      }
    },
    _uploadEvents: function _uploadEvents(name, file) {
      this.$dispatch && this.$dispatch(name, file, this);
      this[name] && this[name](file);
      this.events && this.events[name] && this.events[name](file, this);
    },
    _drop: function _drop(value) {
      if (this.dropElement && this.$mode === 'html5') {
        try {
          window.document.removeEventListener('dragenter', this._onDragenter, false);
          window.document.removeEventListener('dragleave', this._onDragleave, false);
          this.dropElement.removeEventListener('dragover', this._onDragover, false);
          this.dropElement.removeEventListener('drop', this._onDrop, false);
        } catch (e) {}
      }

      if (!value) {
        this.dropElement = false;
        return;
      }

      if (typeof value == 'string') {
        this.dropElement = document.querySelector(value) || this.$root.$el.querySelector(value);
      } else if (typeof value == 'boolean') {
        this.dropElement = this.$parent.$el;
      } else {
        this.dropElement = this.drop;
      }
      if (this.dropElement && this.$mode === 'html5') {
        window.document.addEventListener('dragenter', this._onDragenter, false);
        window.document.addEventListener('dragleave', this._onDragleave, false);
        this.dropElement.addEventListener('dragover', this._onDragover, false);
        this.dropElement.addEventListener('drop', this._onDrop, false);
      }
    },
    _onDragenter: function _onDragenter(e) {
      this._dropActive++;
      this.dropActive = !!this._dropActive;
      e.preventDefault();
    },
    _onDragleave: function _onDragleave(e) {
      e.preventDefault();
      this._dropActive--;
      if (e.target.nodeName == 'HTML' || e.screenX == 0 && e.screenY == 0) {
        this.dropActive = !!this._dropActive;
      }
    },
    _onDragover: function _onDragover(e) {
      e.preventDefault();
    },
    _addFileUpload: function _addFileUpload(hiddenData, file) {
      var defaultFile = {
        size: -1,
        name: 'Filename',
        progress: '0.00',
        speed: 0,
        active: false,
        error: '',
        errno: '',
        success: false,
        data: {},
        request: {
          headers: {},
          data: {}
        }
      };

      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(hiddenData.file);
      }

      for (var key in defaultFile) {
        if (typeof file[key] == 'undefined') {
          file[key] = defaultFile[key];
        }
      }
      if (!file.id) {
        file.id = Math.random().toString(36).substr(2);
      }

      if (!this.multiple) {
        this.clear();
      }

      this._files[file.id] = hiddenData;
      file = this.files[this.files.push(file) - 1];
      this._files[file.id]._file = file;
      this._uploadEvents('addFileUpload', file);
    },
    _onDrop: function _onDrop(e) {
      this._dropActive = 0;
      this.dropActive = false;
      e.preventDefault();
      if (e.dataTransfer.files.length) {
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          var file = e.dataTransfer.files[i];
          this._addFileUpload({ file: file }, { size: file.size, name: file.name, type: file.type });
          if (!this.multiple) {
            break;
          }
        }
      }
    },
    _addFileUploads: function _addFileUploads(el) {
      var Component = this.$options.components.inputFile;
      new Component({
        parent: this,
        el: el
      });
      this.uploaded = false;

      if (el.files) {
        for (var i = 0; i < el.files.length; i++) {
          var file = el.files[i];
          this._addFileUpload({ file: file, el: el }, { size: file.size, name: file.name, type: file.type });
        }
      } else {
        this._addFileUpload({ el: el }, { size: -1, name: el.value.replace(/^.*?([^\/\\\r\n]+)$/, '$1') });
      }
    },
    _fileUploads: function _fileUploads() {
      if (!this.active) {
        return;
      }
      for (; this._index < this.files.length; this._index++) {
        var file = this.files[this._index];
        if (file.active || file.success || file.errno) {
          continue;
        }
        if (this.size && this.size > 0 && file.size >= 0 && file.size > this.size) {
          file.error = 'Size';
          file.errno = 'size';
          continue;
        }

        if (this.extensions && (this.extensions.length || typeof this.extensions.length == 'undefined')) {
          var extensions = this.extensions;
          if ((typeof extensions === 'undefined' ? 'undefined' : (0, _typeof3.default)(extensions)) == 'object' && extensions instanceof RegExp) {} else {
            if (typeof extensions == 'string') {
              extensions = extensions.split(',').map(function (value) {
                return value.trim();
              }).filter(function (value) {
                return value;
              });
            }
            extensions = new RegExp('\\.(' + extensions.join('|').replace(/\./g, '\\.') + ')$', 'i');
          }

          if (file.name.search(extensions) == -1) {
            file.error = 'Extension';
            file.errno = 'extension';
            continue;
          }
        }

        if (this.$mode == 'html5') {
          if (this.putAction || file.putAction) {
            this._fileUploadPut(file);
          } else if (this.postAction || file.postAction) {
            this._fileUploadHtml5(file);
          } else {
            file.error = 'Not Support';
            file.errno = 'not_support';
            continue;
          }
        } else {
          if (this.postAction || file.postAction) {
            this._fileUploadHtml4(file);
          } else {
            file.error = 'Not Support';
            file.errno = 'not_support';
            continue;
          }
        }
        return;
      }
      this.active = false;
      this.uploaded = true;
    },
    _fileUploadXhr: function _fileUploadXhr(xhr, file, data) {
      var _self = this;
      var hiddenData = this._files[file.id];
      var fileUploads = false;
      var speedTime = 0;
      var speedLoaded = 0;
      xhr.upload.onprogress = function (e) {
        if (file.removed) {
          xhr.abort();
          return;
        }
        if (!_self.active || !file.active) {
          xhr.abort();
          return;
        }
        if (e.lengthComputable) {
          file.progress = (e.loaded / e.total * 100).toFixed(2);
          var speedTime2 = Math.round(Date.now() / 1000);
          if (speedTime2 != speedTime) {
            file.speed = e.loaded - speedLoaded;
            speedLoaded = e.loaded;
            speedTime = speedTime2;
          }
        }
        _self._uploadEvents('fileUploadProgress', file);
      };

      var callback = function callback(e) {
        switch (e.type) {
          case 'timeout':
            file.errno = 'timeout';
            file.error = 'Timeout';
            break;
          case 'abort':
            file.errno = 'abort';
            file.error = 'Abort';
            break;
          case 'error':
            if (!xhr.status) {
              file.errno = 'network';
              file.error = 'Network';
            } else if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            }
            break;
          default:
            if (xhr.status >= 500) {
              file.errno = 'server';
              file.error = 'Server';
            } else if (xhr.status >= 400) {
              file.errno = 'denied';
              file.error = 'Denied';
            } else {
              file.progress = '100.00';
              file.success = true;
            }
        }
        file.active = false;
        if (xhr.responseText) {
          var contentType = xhr.getResponseHeader('Content-Type');
          if (contentType && contentType.indexOf('/json') != -1) {
            file.data = JSON.parse(xhr.responseText);
          } else {
            file.data = xhr.responseText;
          }
        }
        if (!fileUploads) {
          fileUploads = true;
          if (!file.removed) {
            _self._uploadEvents('afterFileUpload', file);
          }
          setTimeout(function () {
            _self._fileUploads();
          }, 50);
        }
      };

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      xhr.onload = callback;
      xhr.onerror = callback;
      xhr.onabort = callback;
      xhr.ontimeout = callback;

      if (this.timeout) {
        xhr.timeout = this.timeout;
      }

      // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      for (var key in this.request.headers) {
        xhr.setRequestHeader(key, this.request.headers[key]);
      }
      for (var key in file.request.headers) {
        xhr.setRequestHeader(key, file.request.headers[key]);
      }

      xhr.send(data);
      file.active = true;
      hiddenData.xhr = xhr;
      var interval = setInterval(function () {
        if (!_self.active || !file.active || file.success || file.errno) {
          clearInterval(interval);
          if (!file.success && !file.errno) {
            xhr.abort();
          }
        }
      }, 100);
      this._uploadEvents('beforeFileUpload', file);
    },
    _fileUploadPut: function _fileUploadPut(file) {
      var _self = this;

      var querys = {};
      for (var key in this.request.data) {
        querys[key] = this.request.data[key];
      }
      for (var _key in file.request.data) {
        querys[_key] = file.request.data[_key];
      }
      var queryArray = [];
      for (var _key2 in querys) {
        if (querys[_key2] !== null && typeof querys[_key2] !== 'undefined') {
          queryArray.push(encodeURIComponent(_key2) + '=' + encodeURIComponent(querys[_key2]));
        }
      }
      var queryString = queryArray.length ? '?' + queryArray.join('&') : '';

      var xhr = new XMLHttpRequest();
      xhr.open('PUT', (file.putAction || this.putAction) + queryString);
      this._fileUploadXhr(xhr, file, this._files[file.id].file);
    },
    _fileUploadHtml5: function _fileUploadHtml5(file) {
      var form = new window.FormData();
      form.append(this.name, this._files[file.id].file);
      for (var key in this.request.data) {
        form.append(key, this.request.data[key]);
      }

      for (var key in file.request.data) {
        form.append(key, file.request.data[key]);
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', file.postAction || this.postAction);
      this._fileUploadXhr(xhr, file, form);
    },
    _fileUploadHtml4: function _fileUploadHtml4(file) {
      var _self = this;
      var hiddenData = this._files[file.id];

      var fileUploads = false;

      var keydown = function keydown(e) {
        if (e.keyCode == 27) {
          e.preventDefault();
        }
      };

      var iframe = document.createElement('iframe');
      iframe.id = 'upload-iframe-' + file.id;
      iframe.name = 'upload-iframe-' + file.id;
      iframe.src = 'about:blank';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.top = '-9999px';
      iframe.style.left = '-9999px';
      iframe.style.position = 'absolute';
      iframe.style.marginTop = '-9999em';

      var form = document.createElement('form');
      form.action = file.postAction || this.postAction;
      form.name = 'upload-form-' + file.id;
      form.setAttribute('method', 'POST');
      form.setAttribute('target', 'upload-iframe-' + file.id);
      form.setAttribute('enctype', 'multipart/form-data');
      form.appendChild(hiddenData.el);
      for (var key in this.request.data) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = this.request.data[key];
        form.appendChild(input);
      }

      for (var key in file.request.data) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = file.request.data[key];
        form.appendChild(input);
      }

      var getDocumentData = function getDocumentData() {
        var doc;
        try {
          if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
          }
        } catch (err) {}
        if (!doc) {
          try {
            doc = iframe.contentDocument ? iframe.contentDocument : iframe.document;
          } catch (err) {
            doc = iframe.document;
          }
        }
        if (doc && doc.body) {
          return doc.body.innerHTML;
        }
        return null;
      };

      var callback = function callback(e) {
        switch (e.type) {
          case 'abort':
            file.errno = 'abort';
            file.error = 'Abort';
            break;
          case 'error':
            var data = getDocumentData();
            if (file.errno) {} else if (data === null) {
              file.errno = 'network';
              file.error = 'Network';
            } else {
              file.errno = 'denied';
              file.error = 'Denied';
            }
            break;
          default:
            var data = getDocumentData();
            if (file.errno) {} else if (data === null) {
              file.errno = 'network';
              file.error = 'Network';
            } else {
              file.progress = '100.00';
              file.success = true;
            }
        }

        file.active = false;
        if (typeof data != "undefined") {
          if (data && data.substr(0, 1) == '{' && data.substr(data.length - 1, 1) == '}') {
            try {
              data = JSON.parse(data);
            } catch (err) {}
          }
          file.data = data;
        }
        if (!fileUploads) {
          document.body.removeEventListener('keydown', keydown);
          document.body.removeEventListener('keydown', keydown);
          fileUploads = true;
          iframe.parentNode && iframe.parentNode.removeChild(iframe);
          if (!file.removed) {
            _self._uploadEvents('afterFileUpload', file);
          }
          setTimeout(function () {
            _self._fileUploads();
          }, 50);
        }
      };

      setTimeout(function () {
        document.body.appendChild(iframe).appendChild(form).submit();
        iframe.onload = callback;
        iframe.onerror = callback;
        iframe.onabort = callback;

        file.active = true;

        hiddenData.iframe = iframe;

        document.body.addEventListener('keydown', keydown);
        var interval = setInterval(function () {
          if (!_self.active || !file.active || file.success || file.errno) {
            clearInterval(interval);
            if (!file.success && !file.errno) {
              iframe.onabort({ type: 'abort' });
            }
          }
        }, 50);
        _self._uploadEvents('beforeFileUpload', file);
      }, 10);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<label :class=\"{'file-uploads': true, 'file-uploads-html5': $mode == 'html5', 'file-uploads-html4': $mode == 'html4'}\">\n    <span>{{{title}}}</span>\n    <input-file></input-file>\n</label>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.file-uploads {\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n}\n.file-uploads span{\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n}\n.file-uploads input{\n    z-index: 1;\n    opacity: 0;\n    font-size: 20em;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\n.file-uploads.file-uploads-html5 input{\n    float: left;\n    width: 1px !important;\n    height: 1px !important;\n    top:-1px !important;\n    left:-1px !important;\n    right:auto !important;\n    bottom:auto !important;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-58cc404a", module.exports)
  } else {
    hotAPI.update("_v-58cc404a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/typeof":16,"vue":132,"vue-hot-reload-api":129,"vueify/lib/insert-css":133}],169:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'VueGoogleAutocomplete',

  props: {
    id: {
      type: String,
      required: true
    },

    value: {
      type: String
    },

    classname: String,

    placeholder: {
      type: String,
      default: 'Start typing'
    },

    types: {
      type: String,
      default: 'address'
    },

    country: {
      type: String,
      default: null
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      /**
       * The Autocomplete object.
       *
       * @type {Autocomplete}
       * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
       */
      autocomplete: null,

      /**
       * Autocomplete input text
       * @type {String}
       */
      autocompleteText: ''
    };
  },

  watch: {
    'value': function value(val, oldVal) {
      if (val && !this.autocompleteText) this.autocompleteText = val;
    }
  },

  ready: function ready() {
    var _this = this;

    var options = {
      types: [this.types]
    };

    console.log('777', this.value);

    this.autocompleteText = this.value;

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

    this.autocomplete.addListener('place_changed', function () {

      var place = _this.autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        _this.$emit('no-results-found', place);
        return;
      }

      var addressComponents = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };

      var returnData = {};

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData['latitude'] = place.geometry.location.lat();
        returnData['longitude'] = place.geometry.location.lng();

        // return returnData object and PlaceResult object
        _this.$emit('placechanged', returnData, place);
      }
    });
  },

  methods: {
    /**
     * When the input gets focus
     */
    onFocus: function onFocus() {
      this.geolocate();
      this.$emit('focus');
    },


    /**
     * When the input loses focus
     */
    onBlur: function onBlur() {
      this.$emit('blur');
    },


    /**
     * When the input got changed
     */
    onChange: function onChange() {
      this.$emit('change', this.autocompleteText);
    },


    /**
     * When a key gets pressed
     * @param  {Event} event A keypress event
     */
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },


    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate: function geolocate() {
      var _this2 = this;

      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            _this2.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<input :class=\"classname\" :id=\"id\" :placeholder=\"placeholder\" v-model=\"autocompleteText\" @focus=\"onFocus()\" @blur=\"onBlur()\" @change=\"onChange\" @keypress=\"onKeyPress\">\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-437ecb4a", module.exports)
  } else {
    hotAPI.update("_v-437ecb4a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}],170:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        rowData: {
            type: Object,
            required: true
        }
    },
    computed: {
        items: function items() {
            var _rowData = this.rowData,
                devices = _rowData.devices,
                pins = _rowData.pins;

            return devices.map(function (o, k) {
                var pinCodeItem = _.find(pins, { 'device_id': o.id });
                return {
                    id: o.id,
                    hash: o.hash,
                    pin: pinCodeItem ? pinCodeItem.value : null
                };
            });
        }
    },
    methods: {
        //
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"items.length\">\n    <div v-for=\"item in items\">\n        <span class=\"label label-info e-label\">\n            <strong>ID:</strong> {{ item.id }}\n        \n            | <strong>PIN:</strong> {{ item.pin || 'not difined' }}\n        </span>\n        <br>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e2522ee", module.exports)
  } else {
    hotAPI.update("_v-7e2522ee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":132,"vue-hot-reload-api":129}]},{},[138]);
